var _objectDestructuringEmpty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectDestructuringEmpty.js").default;

var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _classCallCheck2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createClass.js").default;

var _assertThisInitialized = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;

var _inherits = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createSuper.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _slicedToArray2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _excluded = ["borderRadius"],
    _excluded2 = ["contentJustification", "orientation"],
    _excluded3 = ["className", "onResizeStart", "onResize", "onResizeStop"],
    _excluded4 = ["url", "providerNameSlug", "type"],
    _excluded5 = ["children"],
    _excluded6 = ["isHidden", "captionFocused", "onFocusCaption", "className", "value", "placeholder", "tagName", "captionRef"],
    _excluded7 = ["isHidden"],
    _excluded8 = ["align"],
    _excluded9 = ["isSelected", "isStackedOnMobile"],
    _excluded10 = ["nofollow"],
    _excluded11 = ["navigationMenuId"],
    _excluded12 = ["itemsJustification", "orientation"],
    _excluded13 = ["className", "mainColor", "customMainColor", "customTextColor"],
    _excluded14 = ["className", "figureStyle", "mainColor", "customMainColor", "customTextColor"],
    _excluded15 = ["className", "mainColor", "customMainColor", "customTextColor"],
    _excluded16 = ["value", "citation"],
    _excluded17 = ["value", "citation"],
    _excluded18 = ["name"],
    _excluded19 = ["icon", "size"];

/*! For license information please see wp-blockLibrary.js.LICENSE.txt */
!function webpackUniversalModuleDefinition(l, s) {
  "object" == typeof exports && "object" == typeof module ? module.exports = s() : "function" == typeof define && define.amd ? define([], s) : "object" == typeof exports ? exports["@wordpress/block-library"] = s() : (l.wp = l.wp || {}, l.wp.blockLibrary = s());
}(self, function () {
  return function () {
    var l = {
      5221: function _(l) {
        function _extends() {
          return l.exports = _extends = Object.assign || function (l) {
            for (var s = 1; s < arguments.length; s++) {
              var c = arguments[s];

              for (var m in c) {
                Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
              }
            }

            return l;
          }, l.exports.__esModule = !0, l.exports.default = l.exports, _extends.apply(this, arguments);
        }

        l.exports = _extends, l.exports.__esModule = !0, l.exports.default = l.exports;
      },
      8424: function _(l) {
        l.exports = function _interopRequireDefault(l) {
          return l && l.__esModule ? l : {
            default: l
          };
        }, l.exports.__esModule = !0, l.exports.default = l.exports;
      },
      2190: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ArchivesEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var m = s.showPostCounts,
              w = s.displayAsDropdown;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(_.PanelBody, {
            title: (0, y.__)("Archives settings")
          }, (0, v.createElement)(_.ToggleControl, {
            label: (0, y.__)("Display as dropdown"),
            checked: w,
            onChange: function onChange() {
              return c({
                displayAsDropdown: !w
              });
            }
          }), (0, v.createElement)(_.ToggleControl, {
            label: (0, y.__)("Show post counts"),
            checked: m,
            onChange: function onChange() {
              return c({
                showPostCounts: !m
              });
            }
          }))), (0, v.createElement)("div", (0, k.useBlockProps)(), (0, v.createElement)(_.Disabled, null, (0, v.createElement)(E.default, {
            block: "core/archives",
            attributes: s
          }))));
        };

        var v = c(1753),
            _ = c(4892),
            y = c(6756),
            k = c(1326),
            E = m(c(2643));
      },
      8230: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(2190));

        var y = {
          apiVersion: 2,
          name: "core/archives",
          title: "Archives",
          category: "widgets",
          description: "Display a monthly archive of your posts.",
          textdomain: "default",
          attributes: {
            displayAsDropdown: {
              type: "boolean",
              default: !1
            },
            showPostCounts: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-archives-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.archive,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      5436: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(1753),
            v = c(1326),
            _ = [{
          attributes: {
            src: {
              type: "string",
              source: "attribute",
              selector: "audio",
              attribute: "src"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            id: {
              type: "number"
            },
            autoplay: {
              type: "boolean",
              source: "attribute",
              selector: "audio",
              attribute: "autoplay"
            },
            loop: {
              type: "boolean",
              source: "attribute",
              selector: "audio",
              attribute: "loop"
            },
            preload: {
              type: "string",
              source: "attribute",
              selector: "audio",
              attribute: "preload"
            }
          },
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.autoplay,
                _ = s.caption,
                y = s.loop,
                k = s.preload,
                E = s.src;
            return (0, m.createElement)("figure", null, (0, m.createElement)("audio", {
              controls: "controls",
              src: E,
              autoPlay: c,
              loop: y,
              preload: k
            }), !v.RichText.isEmpty(_) && (0, m.createElement)(v.RichText.Content, {
              tagName: "figcaption",
              value: _
            }));
          }
        }];
        s.default = _;
      },
      500: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(9388),
            _ = c(4892),
            y = c(1326),
            k = c(6756),
            E = c(8467),
            w = c(5303),
            C = c(6700),
            S = c(4e3);

        var P = ["audio"];
        var T = (0, _.withNotices)(function AudioEdit(l) {
          var s = l.attributes,
              c = l.noticeOperations,
              T = l.setAttributes,
              B = l.onReplace,
              z = l.isSelected,
              L = l.noticeUI,
              V = l.insertBlocksAfter;
          var A = s.id,
              R = s.autoplay,
              O = s.caption,
              D = s.loop,
              F = s.preload,
              G = s.src,
              q = (0, y.useBlockProps)(),
              W = (0, E.useSelect)(function (l) {
            var _l2 = l(y.store),
                s = _l2.getSettings;

            return s().mediaUpload;
          }, []);

          function toggleAttribute(l) {
            return function (s) {
              T(_defineProperty({}, l, s));
            };
          }

          function onSelectURL(l) {
            if (l !== G) {
              var _s = (0, S.createUpgradedEmbedBlock)({
                attributes: {
                  url: l
                }
              });

              if (void 0 !== _s) return void B(_s);
              T({
                src: l,
                id: void 0
              });
            }
          }

          function onUploadError(l) {
            c.removeAllNotices(), c.createErrorNotice(l);
          }

          function onSelectAudio(l) {
            l && l.url ? T({
              src: l.url,
              id: l.id
            }) : T({
              src: void 0,
              id: void 0
            });
          }

          return (0, m.useEffect)(function () {
            if (!A && (0, v.isBlobURL)(G)) {
              var _l3 = (0, v.getBlobByURL)(G);

              _l3 && W({
                filesList: [_l3],
                onFileChange: function onFileChange(l) {
                  var _l4 = _slicedToArray2(l, 1),
                      _l4$ = _l4[0],
                      s = _l4$.id,
                      c = _l4$.url;

                  T({
                    id: s,
                    src: c
                  });
                },
                onError: function onError(l) {
                  T({
                    src: void 0,
                    id: void 0
                  }), c.createErrorNotice(l);
                },
                allowedTypes: P
              });
            }
          }, []), G ? (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.BlockControls, {
            group: "other"
          }, (0, m.createElement)(y.MediaReplaceFlow, {
            mediaId: A,
            mediaURL: G,
            allowedTypes: P,
            accept: "audio/*",
            onSelect: onSelectAudio,
            onSelectURL: onSelectURL,
            onError: onUploadError
          })), (0, m.createElement)(y.InspectorControls, null, (0, m.createElement)(_.PanelBody, {
            title: (0, k.__)("Audio settings")
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, k.__)("Autoplay"),
            onChange: toggleAttribute("autoplay"),
            checked: R,
            help: function getAutoplayHelp(l) {
              return l ? (0, k.__)("Autoplay may cause usability issues for some users.") : null;
            }
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, k.__)("Loop"),
            onChange: toggleAttribute("loop"),
            checked: D
          }), (0, m.createElement)(_.SelectControl, {
            label: (0, k._x)("Preload", "noun; Audio block parameter"),
            value: F || "",
            onChange: function onChange(l) {
              return T({
                preload: l || void 0
              });
            },
            options: [{
              value: "",
              label: (0, k.__)("Browser default")
            }, {
              value: "auto",
              label: (0, k.__)("Auto")
            }, {
              value: "metadata",
              label: (0, k.__)("Metadata")
            }, {
              value: "none",
              label: (0, k._x)("None", '"Preload" value')
            }]
          }))), (0, m.createElement)("figure", q, (0, m.createElement)(_.Disabled, {
            isDisabled: !z
          }, (0, m.createElement)("audio", {
            controls: "controls",
            src: G
          })), (!y.RichText.isEmpty(O) || z) && (0, m.createElement)(y.RichText, {
            tagName: "figcaption",
            "aria-label": (0, k.__)("Audio caption text"),
            placeholder: (0, k.__)("Add caption"),
            value: O,
            onChange: function onChange(l) {
              return T({
                caption: l
              });
            },
            inlineToolbar: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return V((0, C.createBlock)("core/paragraph"));
            }
          }))) : (0, m.createElement)("div", q, (0, m.createElement)(y.MediaPlaceholder, {
            icon: (0, m.createElement)(y.BlockIcon, {
              icon: w.audio
            }),
            onSelect: onSelectAudio,
            onSelectURL: onSelectURL,
            accept: "audio/*",
            allowedTypes: P,
            value: s,
            notices: L,
            onError: onUploadError
          }));
        });
        s.default = T;
      },
      2939: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(5436)),
            y = m(c(500)),
            k = m(c(652)),
            E = m(c(8077));

        var w = {
          apiVersion: 2,
          name: "core/audio",
          title: "Audio",
          category: "media",
          description: "Embed a simple audio player.",
          keywords: ["music", "sound", "podcast", "recording"],
          textdomain: "default",
          attributes: {
            src: {
              type: "string",
              source: "attribute",
              selector: "audio",
              attribute: "src"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            id: {
              type: "number"
            },
            autoplay: {
              type: "boolean",
              source: "attribute",
              selector: "audio",
              attribute: "autoplay"
            },
            loop: {
              type: "boolean",
              source: "attribute",
              selector: "audio",
              attribute: "loop"
            },
            preload: {
              type: "string",
              source: "attribute",
              selector: "audio",
              attribute: "preload"
            }
          },
          supports: {
            anchor: !0,
            align: !0
          },
          editorStyle: "wp-block-audio-editor",
          style: "wp-block-audio"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: v.audio,
          example: {
            attributes: {
              src: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Armstrong_Small_Step.ogg"
            }
          },
          transforms: E.default,
          deprecated: _.default,
          edit: y.default,
          save: k.default
        };
        s.settings = S;
      },
      652: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.autoplay,
              _ = s.caption,
              y = s.loop,
              k = s.preload,
              E = s.src;
          return E && (0, m.createElement)("figure", v.useBlockProps.save(), (0, m.createElement)("audio", {
            controls: "controls",
            src: E,
            autoPlay: c,
            loop: y,
            preload: k
          }), !v.RichText.isEmpty(_) && (0, m.createElement)(v.RichText.Content, {
            tagName: "figcaption",
            value: _
          }));
        };
        var m = c(1753),
            v = c(1326);
      },
      8077: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(9388),
            v = c(6700);
        var _ = {
          from: [{
            type: "files",
            isMatch: function isMatch(l) {
              return 1 === l.length && 0 === l[0].type.indexOf("audio/");
            },
            transform: function transform(l) {
              var s = l[0];
              return (0, v.createBlock)("core/audio", {
                src: (0, m.createBlobURL)(s)
              });
            }
          }, {
            type: "shortcode",
            tag: "audio",
            attributes: {
              src: {
                type: "string",
                shortcode: function shortcode(l) {
                  var _l$named = l.named,
                      s = _l$named.src,
                      c = _l$named.mp3,
                      m = _l$named.m4a,
                      v = _l$named.ogg,
                      _ = _l$named.wav,
                      y = _l$named.wma;
                  return s || c || m || v || _ || y;
                }
              },
              loop: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.loop;
                  return s;
                }
              },
              autoplay: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.autoplay;
                  return s;
                }
              },
              preload: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.preload;
                  return s;
                }
              }
            }
          }]
        };
        s.default = _;
      },
      7306: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ReusableBlockEdit(l) {
          var s = l.attributes.ref,
              c = l.clientId;

          var _ref = (0, E.__experimentalUseNoRecursiveRenders)(s),
              _ref2 = _slicedToArray2(_ref, 2),
              S = _ref2[0],
              P = _ref2[1],
              _ref3 = (0, v.useSelect)(function (l) {
            var c = l(_.store).getEntityRecord("postType", "wp_block", s),
                m = l(_.store).hasFinishedResolution("getEntityRecord", ["postType", "wp_block", s]);
            return {
              hasResolved: m,
              isMissing: m && !c
            };
          }, [s, c]),
              T = _ref3.isMissing,
              B = _ref3.hasResolved,
              _ref4 = (0, v.useDispatch)(w.store),
              z = _ref4.__experimentalConvertBlockToStatic,
              _ref5 = (0, _.useEntityBlockEditor)("postType", "wp_block", {
            id: s
          }),
              _ref6 = _slicedToArray2(_ref5, 3),
              L = _ref6[0],
              V = _ref6[1],
              A = _ref6[2],
              _ref7 = (0, _.useEntityProp)("postType", "wp_block", "title", s),
              _ref8 = _slicedToArray2(_ref7, 2),
              R = _ref8[0],
              O = _ref8[1],
              D = (0, E.useBlockProps)(),
              F = (0, E.useInnerBlocksProps)({}, {
            value: L,
            onInput: V,
            onChange: A,
            renderAppender: null != L && L.length ? void 0 : E.InnerBlocks.ButtonBlockAppender
          });

          if (S) return (0, m.createElement)("div", D, (0, m.createElement)(E.Warning, null, (0, k.__)("Block cannot be rendered inside itself.")));
          if (T) return (0, m.createElement)("div", D, (0, m.createElement)(E.Warning, null, (0, k.__)("Block has been deleted or is unavailable.")));
          if (!B) return (0, m.createElement)("div", D, (0, m.createElement)(y.Placeholder, null, (0, m.createElement)(y.Spinner, null)));
          return (0, m.createElement)(P, null, (0, m.createElement)("div", D, (0, m.createElement)(E.BlockControls, null, (0, m.createElement)(y.ToolbarGroup, null, (0, m.createElement)(y.ToolbarButton, {
            onClick: function onClick() {
              return z(c);
            },
            label: (0, k.__)("Convert to regular blocks"),
            icon: C.ungroup,
            showTooltip: !0
          }))), (0, m.createElement)(E.InspectorControls, null, (0, m.createElement)(y.PanelBody, null, (0, m.createElement)(y.TextControl, {
            label: (0, k.__)("Name"),
            value: R,
            onChange: O
          }))), (0, m.createElement)(E.__experimentalBlockContentOverlay, {
            clientId: c,
            wrapperProps: F,
            className: "block-library-block__reusable-block-container"
          })));
        };

        var m = c(1753),
            v = c(8467),
            _ = c(1295),
            y = c(4892),
            k = c(6756),
            E = c(1326),
            w = c(1019),
            C = c(5303);
      },
      600: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(7306));

        var y = {
          apiVersion: 2,
          name: "core/block",
          title: "Reusable block",
          category: "reusable",
          description: "Create and save content to reuse across your site. Update the block, and the changes apply everywhere it’s used.",
          textdomain: "default",
          attributes: {
            ref: {
              type: "number"
            }
          },
          supports: {
            customClassName: !1,
            html: !1,
            inserter: !1
          },
          editorStyle: "wp-block-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          edit: _.default,
          icon: v.symbol
        };
        s.settings = E;
      },
      6143: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = m(c(2703)),
            k = c(1326),
            E = c(3200),
            w = m(c(5935));

        var migrateBorderRadius = function migrateBorderRadius(l) {
          var s, c, m;

          var v = l.borderRadius,
              _ = _objectWithoutProperties(l, _excluded),
              y = [v, null === (s = _.style) || void 0 === s || null === (c = s.border) || void 0 === c ? void 0 : c.radius].find(function (l) {
            return "number" == typeof l && 0 !== l;
          });

          return y ? _objectSpread(_objectSpread({}, _), {}, {
            style: _objectSpread(_objectSpread({}, _.style), {}, {
              border: _objectSpread(_objectSpread({}, null === (m = _.style) || void 0 === m ? void 0 : m.border), {}, {
                radius: "".concat(y, "px")
              })
            })
          }) : _;
        },
            migrateCustomColorsAndGradients = function migrateCustomColorsAndGradients(l) {
          if (!l.customTextColor && !l.customBackgroundColor && !l.customGradient) return l;
          var s = {
            color: {}
          };
          return l.customTextColor && (s.color.text = l.customTextColor), l.customBackgroundColor && (s.color.background = l.customBackgroundColor), l.customGradient && (s.color.gradient = l.customGradient), _objectSpread(_objectSpread({}, (0, _.omit)(l, ["customTextColor", "customBackgroundColor", "customGradient"])), {}, {
            style: s
          });
        },
            oldColorsMigration = function oldColorsMigration(l) {
          return migrateCustomColorsAndGradients((0, _.omit)(_objectSpread(_objectSpread({}, l), {}, {
            customTextColor: l.textColor && "#" === l.textColor[0] ? l.textColor : void 0,
            customBackgroundColor: l.color && "#" === l.color[0] ? l.color : void 0
          }), ["color", "textColor"]));
        },
            C = {
          url: {
            type: "string",
            source: "attribute",
            selector: "a",
            attribute: "href"
          },
          title: {
            type: "string",
            source: "attribute",
            selector: "a",
            attribute: "title"
          },
          text: {
            type: "string",
            source: "html",
            selector: "a"
          }
        };

        var S = [{
          attributes: {
            url: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "href"
            },
            title: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "title"
            },
            text: {
              type: "string",
              source: "html",
              selector: "a"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            width: {
              type: "number"
            }
          },
          supports: {
            anchor: !0,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalSkipSerialization: !0,
              gradients: !0
            },
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0
            },
            reusable: !1,
            spacing: {
              __experimentalSkipSerialization: !0,
              padding: ["horizontal", "vertical"],
              __experimentalDefaultControls: {
                padding: !0
              }
            },
            __experimentalBorder: {
              radius: !0,
              __experimentalSkipSerialization: !0
            },
            __experimentalSelector: ".wp-block-button__link"
          },
          save: function save(l) {
            var _ref9;

            var s, c;
            var m = l.attributes,
                _ = l.className;
            var E = m.fontSize,
                w = m.linkTarget,
                C = m.rel,
                S = m.style,
                P = m.text,
                T = m.title,
                B = m.url,
                z = m.width;
            if (!P) return null;

            var L = (0, k.__experimentalGetBorderClassesAndStyles)(m),
                V = (0, k.__experimentalGetColorClassesAndStyles)(m),
                A = (0, k.__experimentalGetSpacingClassesAndStyles)(m),
                R = (0, y.default)("wp-block-button__link", V.className, L.className, {
              "no-border-radius": 0 === (null == S || null === (s = S.border) || void 0 === s ? void 0 : s.radius)
            }),
                O = _objectSpread(_objectSpread(_objectSpread({}, L.style), V.style), A.style),
                D = (0, y.default)(_, (_ref9 = {}, _defineProperty(_ref9, "has-custom-width wp-block-button__width-".concat(z), z), _defineProperty(_ref9, "has-custom-font-size", E || (null == S || null === (c = S.typography) || void 0 === c ? void 0 : c.fontSize)), _ref9));

            return (0, v.createElement)("div", k.useBlockProps.save({
              className: D
            }), (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: R,
              href: B,
              title: T,
              style: O,
              value: P,
              target: w,
              rel: C
            }));
          },
          migrate: w.default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }, {
          supports: {
            anchor: !0,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalSkipSerialization: !0,
              gradients: !0
            },
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0
            },
            reusable: !1,
            __experimentalSelector: ".wp-block-button__link"
          },
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            width: {
              type: "number"
            }
          }),
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return "number" == typeof (null == c || null === (s = c.border) || void 0 === s ? void 0 : s.radius);
          },
          save: function save(l) {
            var _ref10;

            var s, c, m;
            var _ = l.attributes,
                E = l.className;
            var w = _.fontSize,
                C = _.linkTarget,
                S = _.rel,
                P = _.style,
                T = _.text,
                B = _.title,
                z = _.url,
                L = _.width;
            if (!T) return null;

            var V = null == P || null === (s = P.border) || void 0 === s ? void 0 : s.radius,
                A = (0, k.__experimentalGetColorClassesAndStyles)(_),
                R = (0, y.default)("wp-block-button__link", A.className, {
              "no-border-radius": 0 === (null == P || null === (c = P.border) || void 0 === c ? void 0 : c.radius)
            }),
                O = _objectSpread({
              borderRadius: V || void 0
            }, A.style),
                D = (0, y.default)(E, (_ref10 = {}, _defineProperty(_ref10, "has-custom-width wp-block-button__width-".concat(L), L), _defineProperty(_ref10, "has-custom-font-size", w || (null == P || null === (m = P.typography) || void 0 === m ? void 0 : m.fontSize)), _ref10));

            return (0, v.createElement)("div", k.useBlockProps.save({
              className: D
            }), (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: R,
              href: z,
              title: B,
              style: O,
              value: T,
              target: C,
              rel: S
            }));
          },
          migrate: (0, E.compose)(w.default, migrateBorderRadius)
        }, {
          supports: {
            anchor: !0,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalSkipSerialization: !0
            },
            reusable: !1,
            __experimentalSelector: ".wp-block-button__link"
          },
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            borderRadius: {
              type: "number"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            style: {
              type: "object"
            },
            width: {
              type: "number"
            }
          }),
          save: function save(l) {
            var s = l.attributes,
                c = l.className;

            var m = s.borderRadius,
                _ = s.linkTarget,
                E = s.rel,
                w = s.text,
                C = s.title,
                S = s.url,
                P = s.width,
                T = (0, k.__experimentalGetColorClassesAndStyles)(s),
                B = (0, y.default)("wp-block-button__link", T.className, {
              "no-border-radius": 0 === m
            }),
                z = _objectSpread({
              borderRadius: m ? m + "px" : void 0
            }, T.style),
                L = (0, y.default)(c, _defineProperty({}, "has-custom-width wp-block-button__width-".concat(P), P));

            return (0, v.createElement)("div", k.useBlockProps.save({
              className: L
            }), (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: B,
              href: S,
              title: C,
              style: z,
              value: w,
              target: _,
              rel: E
            }));
          },
          migrate: (0, E.compose)(w.default, migrateBorderRadius)
        }, {
          supports: {
            anchor: !0,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalSkipSerialization: !0
            },
            reusable: !1,
            __experimentalSelector: ".wp-block-button__link"
          },
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            borderRadius: {
              type: "number"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            style: {
              type: "object"
            },
            width: {
              type: "number"
            }
          }),
          save: function save(l) {
            var s = l.attributes,
                c = l.className;

            var m = s.borderRadius,
                _ = s.linkTarget,
                E = s.rel,
                w = s.text,
                C = s.title,
                S = s.url,
                P = s.width,
                T = (0, k.__experimentalGetColorClassesAndStyles)(s),
                B = (0, y.default)("wp-block-button__link", T.className, {
              "no-border-radius": 0 === m
            }),
                z = _objectSpread({
              borderRadius: m ? m + "px" : void 0
            }, T.style),
                L = (0, y.default)(c, _defineProperty({}, "has-custom-width wp-block-button__width-".concat(P), P));

            return (0, v.createElement)("div", k.useBlockProps.save({
              className: L
            }), (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: B,
              href: S,
              title: C,
              style: z,
              value: w,
              target: _,
              rel: E
            }));
          },
          migrate: (0, E.compose)(w.default, migrateBorderRadius)
        }, {
          supports: {
            align: !0,
            alignWide: !1,
            color: {
              gradients: !0
            }
          },
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            borderRadius: {
              type: "number"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            style: {
              type: "object"
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            var c = s.borderRadius,
                m = s.linkTarget,
                _ = s.rel,
                E = s.text,
                w = s.title,
                C = s.url,
                S = (0, y.default)("wp-block-button__link", {
              "no-border-radius": 0 === c
            }),
                P = {
              borderRadius: c ? c + "px" : void 0
            };
            return (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: S,
              href: C,
              title: w,
              style: P,
              value: E,
              target: m,
              rel: _
            });
          },
          migrate: migrateBorderRadius
        }, {
          supports: {
            align: !0,
            alignWide: !1
          },
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            borderRadius: {
              type: "number"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            customGradient: {
              type: "string"
            },
            gradient: {
              type: "string"
            }
          }),
          isEligible: function isEligible(l) {
            return !!l.customTextColor || !!l.customBackgroundColor || !!l.customGradient;
          },
          migrate: (0, E.compose)(migrateBorderRadius, migrateCustomColorsAndGradients),
          save: function save(l) {
            var _ref13;

            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.borderRadius,
                _ = s.customBackgroundColor,
                E = s.customTextColor,
                w = s.customGradient,
                C = s.linkTarget,
                S = s.gradient,
                P = s.rel,
                T = s.text,
                B = s.textColor,
                z = s.title,
                L = s.url,
                V = (0, k.getColorClassName)("color", B),
                A = !w && (0, k.getColorClassName)("background-color", c),
                R = (0, k.__experimentalGetGradientClass)(S),
                O = (0, y.default)("wp-block-button__link", (_ref13 = {
              "has-text-color": B || E
            }, _defineProperty(_ref13, V, V), _defineProperty(_ref13, "has-background", c || _ || w || S), _defineProperty(_ref13, A, A), _defineProperty(_ref13, "no-border-radius", 0 === m), _defineProperty(_ref13, R, R), _ref13)),
                D = {
              background: w || void 0,
              backgroundColor: A || w || S ? void 0 : _,
              color: V ? void 0 : E,
              borderRadius: m ? m + "px" : void 0
            };
            return (0, v.createElement)("div", null, (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: O,
              href: L,
              title: z,
              style: D,
              value: T,
              target: C,
              rel: P
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            align: {
              type: "string",
              default: "none"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            }
          }),
          isEligible: function isEligible(l) {
            return l.className && l.className.includes("is-style-squared");
          },
          migrate: function migrate(l) {
            var s = l.className;
            return s && (s = s.replace(/is-style-squared[\s]?/, "").trim()), migrateBorderRadius(migrateCustomColorsAndGradients(_objectSpread(_objectSpread({}, l), {}, {
              className: s || void 0,
              borderRadius: 0
            })));
          },
          save: function save(l) {
            var _ref14;

            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                _ = s.customTextColor,
                E = s.linkTarget,
                w = s.rel,
                C = s.text,
                S = s.textColor,
                P = s.title,
                T = s.url,
                B = (0, k.getColorClassName)("color", S),
                z = (0, k.getColorClassName)("background-color", c),
                L = (0, y.default)("wp-block-button__link", (_ref14 = {
              "has-text-color": S || _
            }, _defineProperty(_ref14, B, B), _defineProperty(_ref14, "has-background", c || m), _defineProperty(_ref14, z, z), _ref14)),
                V = {
              backgroundColor: z ? void 0 : m,
              color: B ? void 0 : _
            };
            return (0, v.createElement)("div", null, (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: L,
              href: T,
              title: P,
              style: V,
              value: C,
              target: E,
              rel: w
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            align: {
              type: "string",
              default: "none"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            }
          }),
          migrate: oldColorsMigration,
          save: function save(l) {
            var _ref15;

            var s = l.attributes;
            var c = s.url,
                m = s.text,
                _ = s.title,
                E = s.backgroundColor,
                w = s.textColor,
                C = s.customBackgroundColor,
                S = s.customTextColor,
                P = (0, k.getColorClassName)("color", w),
                T = (0, k.getColorClassName)("background-color", E),
                B = (0, y.default)("wp-block-button__link", (_ref15 = {
              "has-text-color": w || S
            }, _defineProperty(_ref15, P, P), _defineProperty(_ref15, "has-background", E || C), _defineProperty(_ref15, T, T), _ref15)),
                z = {
              backgroundColor: T ? void 0 : C,
              color: P ? void 0 : S
            };
            return (0, v.createElement)("div", null, (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: B,
              href: c,
              title: _,
              style: z,
              value: m
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            color: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            align: {
              type: "string",
              default: "none"
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.text,
                _ = s.title,
                y = s.align,
                E = s.color,
                w = s.textColor,
                C = {
              backgroundColor: E,
              color: w
            };
            return (0, v.createElement)("div", {
              className: "align".concat(y)
            }, (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              className: "wp-block-button__link",
              href: c,
              title: _,
              style: C,
              value: m
            }));
          },
          migrate: oldColorsMigration
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            color: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            align: {
              type: "string",
              default: "none"
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.text,
                _ = s.title,
                y = s.align,
                E = s.color,
                w = s.textColor;
            return (0, v.createElement)("div", {
              className: "align".concat(y),
              style: {
                backgroundColor: E
              }
            }, (0, v.createElement)(k.RichText.Content, {
              tagName: "a",
              href: c,
              title: _,
              style: {
                color: w
              },
              value: m
            }));
          },
          migrate: oldColorsMigration
        }];
        s.default = S;
      },
      1548: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(6756),
            E = c(4892),
            w = c(1326),
            C = c(9880),
            S = c(5303),
            P = c(6700);

        var T = "noreferrer noopener";

        function WidthPanel(l) {
          var s = l.selectedWidth,
              c = l.setAttributes;
          return (0, v.createElement)(E.PanelBody, {
            title: (0, k.__)("Width settings")
          }, (0, v.createElement)(E.ButtonGroup, {
            "aria-label": (0, k.__)("Button width")
          }, [25, 50, 75, 100].map(function (l) {
            return (0, v.createElement)(E.Button, {
              key: l,
              isSmall: !0,
              variant: l === s ? "primary" : void 0,
              onClick: function onClick() {
                return function handleChange(l) {
                  c({
                    width: s === l ? void 0 : l
                  });
                }(l);
              }
            }, l, "%");
          })));
        }

        var B = function ButtonEdit(l) {
          var _ref18;

          var s;

          var c = l.attributes,
              m = l.setAttributes,
              B = l.className,
              z = l.isSelected,
              L = l.onReplace,
              V = l.mergeBlocks,
              A = c.linkTarget,
              R = c.placeholder,
              O = c.rel,
              D = c.style,
              F = c.text,
              G = c.url,
              q = c.width,
              W = (0, v.useCallback)(function (l) {
            m({
              rel: l
            });
          }, [m]),
              U = (0, w.__experimentalUseBorderProps)(c),
              $ = (0, w.__experimentalUseColorProps)(c),
              Z = (0, w.__experimentalGetSpacingClassesAndStyles)(c),
              K = (0, v.useRef)(),
              Q = (0, v.useRef)(),
              Y = (0, w.useBlockProps)({
            ref: K,
            onKeyDown: function onKeyDown(l) {
              if (C.isKeyboardEvent.primary(l, "k")) startEditing(l);else if (C.isKeyboardEvent.primaryShift(l, "k")) {
                var s;
                unlink(), null === (s = Q.current) || void 0 === s || s.focus();
              }
            }
          }),
              _ref16 = (0, v.useState)(!1),
              _ref17 = _slicedToArray2(_ref16, 2),
              X = _ref17[0],
              J = _ref17[1],
              ee = !!G,
              te = "_blank" === A;

          function startEditing(l) {
            l.preventDefault(), J(!0);
          }

          function unlink() {
            m({
              url: void 0,
              linkTarget: void 0,
              rel: void 0
            }), J(!1);
          }

          return (0, v.useEffect)(function () {
            z || J(!1);
          }, [z]), (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", (0, _.default)({}, Y, {
            className: (0, y.default)(Y.className, (_ref18 = {}, _defineProperty(_ref18, "has-custom-width wp-block-button__width-".concat(q), q), _defineProperty(_ref18, "has-custom-font-size", Y.style.fontSize), _ref18))
          }), (0, v.createElement)(w.RichText, {
            ref: Q,
            "aria-label": (0, k.__)("Button text"),
            placeholder: R || (0, k.__)("Add text…"),
            value: F,
            onChange: function onChange(l) {
              return function setButtonText(l) {
                m({
                  text: l.replace(/<\/?a[^>]*>/g, "")
                });
              }(l);
            },
            withoutInteractiveFormatting: !0,
            className: (0, y.default)(B, "wp-block-button__link", $.className, U.className, {
              "no-border-radius": 0 === (null == D || null === (s = D.border) || void 0 === s ? void 0 : s.radius)
            }),
            style: _objectSpread(_objectSpread(_objectSpread({}, U.style), $.style), Z.style),
            onSplit: function onSplit(l) {
              return (0, P.createBlock)("core/button", _objectSpread(_objectSpread({}, c), {}, {
                text: l
              }));
            },
            onReplace: L,
            onMerge: V,
            identifier: "text"
          })), (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, !ee && (0, v.createElement)(E.ToolbarButton, {
            name: "link",
            icon: S.link,
            title: (0, k.__)("Link"),
            shortcut: C.displayShortcut.primary("k"),
            onClick: startEditing
          }), ee && (0, v.createElement)(E.ToolbarButton, {
            name: "link",
            icon: S.linkOff,
            title: (0, k.__)("Unlink"),
            shortcut: C.displayShortcut.primaryShift("k"),
            onClick: unlink,
            isActive: !0
          })), z && (X || ee) && (0, v.createElement)(E.Popover, {
            position: "bottom center",
            onClose: function onClose() {
              var l;
              J(!1), null === (l = Q.current) || void 0 === l || l.focus();
            },
            anchorRef: null == K ? void 0 : K.current,
            focusOnMount: !!X && "firstElement"
          }, (0, v.createElement)(w.__experimentalLinkControl, {
            className: "wp-block-navigation-link__inline-link-input",
            value: {
              url: G,
              opensInNewTab: te
            },
            onChange: function onChange(l) {
              var _l$url = l.url,
                  s = _l$url === void 0 ? "" : _l$url,
                  c = l.opensInNewTab;
              m({
                url: s
              }), te !== c && function onToggleOpenInNewTab(l) {
                var s = l ? "_blank" : void 0;
                var c = O;
                s && !O ? c = T : s || O !== T || (c = void 0), m({
                  linkTarget: s,
                  rel: c
                });
              }(c);
            },
            onRemove: function onRemove() {
              var l;
              unlink(), null === (l = Q.current) || void 0 === l || l.focus();
            },
            forceIsEditingLink: X
          })), (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(WidthPanel, {
            selectedWidth: q,
            setAttributes: m
          })), (0, v.createElement)(w.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, v.createElement)(E.TextControl, {
            label: (0, k.__)("Link rel"),
            value: O || "",
            onChange: W
          })));
        };

        s.default = B;
      },
      9601: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(6143)),
            k = m(c(1548)),
            E = m(c(6761));

        var w = {
          apiVersion: 2,
          name: "core/button",
          title: "Button",
          category: "design",
          parent: ["core/buttons"],
          description: "Prompt visitors to take action with a button-style link.",
          keywords: ["link"],
          textdomain: "default",
          attributes: {
            url: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "href"
            },
            title: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "title"
            },
            text: {
              type: "string",
              source: "html",
              selector: "a"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "target"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "a",
              attribute: "rel"
            },
            placeholder: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            width: {
              type: "number"
            }
          },
          supports: {
            anchor: !0,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalSkipSerialization: !0,
              gradients: !0
            },
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            reusable: !1,
            spacing: {
              __experimentalSkipSerialization: !0,
              padding: ["horizontal", "vertical"],
              __experimentalDefaultControls: {
                padding: !0
              }
            },
            __experimentalBorder: {
              radius: !0,
              __experimentalSkipSerialization: !0
            },
            __experimentalSelector: ".wp-block-button__link"
          },
          styles: [{
            name: "fill",
            label: "Fill",
            isDefault: !0
          }, {
            name: "outline",
            label: "Outline"
          }],
          editorStyle: "wp-block-button-editor",
          style: "wp-block-button"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.button,
          example: {
            attributes: {
              className: "is-style-fill",
              text: (0, v.__)("Call to Action")
            }
          },
          edit: k.default,
          save: E.default,
          deprecated: y.default,
          merge: function merge(l, s) {
            var _s$text = s.text,
                c = _s$text === void 0 ? "" : _s$text;
            return _objectSpread(_objectSpread({}, l), {}, {
              text: (l.text || "") + c
            });
          }
        };
        s.settings = S;
      },
      6761: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _ref19;

          var s, c;
          var m = l.attributes,
              k = l.className;
          var E = m.fontSize,
              w = m.linkTarget,
              C = m.rel,
              S = m.style,
              P = m.text,
              T = m.title,
              B = m.url,
              z = m.width;
          if (!P) return null;

          var L = (0, y.__experimentalGetBorderClassesAndStyles)(m),
              V = (0, y.__experimentalGetColorClassesAndStyles)(m),
              A = (0, y.__experimentalGetSpacingClassesAndStyles)(m),
              R = (0, _.default)("wp-block-button__link", V.className, L.className, {
            "no-border-radius": 0 === (null == S || null === (s = S.border) || void 0 === s ? void 0 : s.radius)
          }),
              O = _objectSpread(_objectSpread(_objectSpread({}, L.style), V.style), A.style),
              D = (0, _.default)(k, (_ref19 = {}, _defineProperty(_ref19, "has-custom-width wp-block-button__width-".concat(z), z), _defineProperty(_ref19, "has-custom-font-size", E || (null == S || null === (c = S.typography) || void 0 === c ? void 0 : c.fontSize)), _ref19));

          return (0, v.createElement)("div", y.useBlockProps.save({
            className: D
          }), (0, v.createElement)(y.RichText.Content, {
            tagName: "a",
            className: R,
            href: B,
            title: T,
            style: O,
            value: P,
            target: w,
            rel: C
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      4498: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var migrateWithLayout = function migrateWithLayout(l) {
          if (l.layout) return l;

          var s = l.contentJustification,
              c = l.orientation,
              m = _objectWithoutProperties(l, _excluded2);

          return (s || c) && Object.assign(m, {
            layout: _objectSpread(_objectSpread({
              type: "flex"
            }, s && {
              justifyContent: s
            }), c && {
              orientation: c
            })
          }), m;
        };

        var k = [{
          attributes: {
            contentJustification: {
              type: "string"
            },
            orientation: {
              type: "string",
              default: "horizontal"
            }
          },
          supports: {
            anchor: !0,
            align: ["wide", "full"],
            __experimentalExposeControlsToChildren: !0,
            spacing: {
              blockGap: !0,
              margin: ["top", "bottom"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            }
          },
          isEligible: function isEligible(l) {
            var s = l.contentJustification,
                c = l.orientation;
            return !!s || !!c;
          },
          migrate: migrateWithLayout,
          save: function save(l) {
            var _ref20;

            var _l$attributes = l.attributes,
                s = _l$attributes.contentJustification,
                c = _l$attributes.orientation;
            return (0, v.createElement)("div", y.useBlockProps.save({
              className: (0, _.default)((_ref20 = {}, _defineProperty(_ref20, "is-content-justification-".concat(s), s), _defineProperty(_ref20, "is-vertical", "vertical" === c), _ref20))
            }), (0, v.createElement)(y.InnerBlocks.Content, null));
          }
        }, {
          supports: {
            align: ["center", "left", "right"],
            anchor: !0
          },
          save: function save() {
            return (0, v.createElement)("div", null, (0, v.createElement)(y.InnerBlocks.Content, null));
          },
          isEligible: function isEligible(l) {
            var s = l.align;
            return s && ["center", "left", "right"].includes(s);
          },
          migrate: function migrate(l) {
            return migrateWithLayout(_objectSpread(_objectSpread({}, l), {}, {
              align: void 0,
              contentJustification: l.align
            }));
          }
        }];
        s.default = k;
      },
      9600: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(1326),
            _ = c(8467),
            y = c(9601);

        var k = [y.name];

        var E = function ButtonsEdit(l) {
          var _l$attributes$layout = l.attributes.layout,
              s = _l$attributes$layout === void 0 ? {} : _l$attributes$layout;
          var c = (0, v.useBlockProps)(),
              E = (0, _.useSelect)(function (l) {
            var s;

            var c = l(v.store).getSettings().__experimentalPreferredStyleVariations;

            return null == c || null === (s = c.value) || void 0 === s ? void 0 : s[y.name];
          }, []),
              w = (0, v.useInnerBlocksProps)(c, {
            allowedBlocks: k,
            template: [[y.name, {
              className: E && "is-style-".concat(E)
            }]],
            __experimentalLayout: s,
            templateInsertUpdatesSelection: !0
          });
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)("div", w));
        };

        s.default = E;
      },
      990: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(4498)),
            k = m(c(6539)),
            E = m(c(9600)),
            w = m(c(5231));

        var C = {
          apiVersion: 2,
          name: "core/buttons",
          title: "Buttons",
          category: "design",
          description: "Prompt visitors to take action with a group of button-style links.",
          keywords: ["link"],
          textdomain: "default",
          supports: {
            anchor: !0,
            align: ["wide", "full"],
            __experimentalExposeControlsToChildren: !0,
            spacing: {
              blockGap: !0,
              margin: ["top", "bottom"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            },
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            }
          },
          editorStyle: "wp-block-buttons-editor",
          style: "wp-block-buttons"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.buttons,
          example: {
            innerBlocks: [{
              name: "core/button",
              attributes: {
                text: (0, v.__)("Find out more")
              }
            }, {
              name: "core/button",
              attributes: {
                text: (0, v.__)("Contact us")
              }
            }]
          },
          deprecated: y.default,
          transforms: k.default,
          edit: E.default,
          save: w.default
        };
        s.settings = P;
      },
      5231: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          var l = v.useInnerBlocksProps.save(v.useBlockProps.save());
          return (0, m.createElement)("div", l);
        };
        var m = c(1753),
            v = c(1326);
      },
      6539: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(7060);
        var _apiVersion$name$titl = {
          apiVersion: 2,
          name: "core/buttons",
          title: "Buttons",
          category: "design",
          description: "Prompt visitors to take action with a group of button-style links.",
          keywords: ["link"],
          textdomain: "default",
          supports: {
            anchor: !0,
            align: ["wide", "full"],
            __experimentalExposeControlsToChildren: !0,
            spacing: {
              blockGap: !0,
              margin: ["top", "bottom"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            },
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            }
          },
          editorStyle: "wp-block-buttons-editor",
          style: "wp-block-buttons"
        },
            _ = _apiVersion$name$titl.name;
        var y = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/button"],
            transform: function transform(l) {
              return (0, m.createBlock)(_, {}, l.map(function (l) {
                return (0, m.createBlock)("core/button", l);
              }));
            }
          }, {
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)(_, {}, l.map(function (l) {
                var s = (0, v.__unstableCreateElement)(document, l.content),
                    c = s.innerText || "",
                    _ = s.querySelector("a"),
                    y = null == _ ? void 0 : _.getAttribute("href");

                return (0, m.createBlock)("core/button", {
                  text: c,
                  url: y
                });
              }));
            },
            isMatch: function isMatch(l) {
              return l.every(function (l) {
                var s = (0, v.__unstableCreateElement)(document, l.content),
                    c = s.innerText || "",
                    m = s.querySelectorAll("a");
                return c.length <= 30 && m.length <= 1;
              });
            }
          }]
        };
        s.default = y;
      },
      9667: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CalendarEdit(l) {
          var s = l.attributes;

          var c = (0, S.useBlockProps)(),
              _ref21 = (0, w.useSelect)(function (l) {
            var _l5 = l(P.store),
                s = _l5.getEntityRecords,
                c = _l5.hasFinishedResolution,
                m = {
              status: "publish",
              per_page: 1
            },
                v = s("postType", "post", m),
                _ = c("getEntityRecords", ["postType", "post", m]);

            var y;
            var k = l("core/editor");

            if (k) {
              "post" === k.getEditedPostAttribute("type") && (y = k.getEditedPostAttribute("date"));
            }

            return {
              date: y,
              hasPostsResolved: _,
              hasPosts: _ && 1 === (null == v ? void 0 : v.length)
            };
          }, []),
              m = _ref21.date,
              _ = _ref21.hasPosts,
              y = _ref21.hasPostsResolved;

          if (!_) return (0, v.createElement)("div", c, (0, v.createElement)(E.Placeholder, {
            icon: k.calendar,
            label: (0, T.__)("Calendar")
          }, y ? (0, T.__)("No published posts found.") : (0, v.createElement)(E.Spinner, null)));
          return (0, v.createElement)("div", c, (0, v.createElement)(E.Disabled, null, (0, v.createElement)(C.default, {
            block: "core/calendar",
            attributes: _objectSpread(_objectSpread({}, s), B(m))
          })));
        };

        var v = c(1753),
            _ = m(c(605)),
            y = m(c(1593)),
            k = c(5303),
            E = c(4892),
            w = c(8467),
            C = m(c(2643)),
            S = c(1326),
            P = c(1295),
            T = c(6756);

        var B = (0, y.default)(function (l) {
          if (!l) return {};
          var s = (0, _.default)(l);
          return {
            year: s.year(),
            month: s.month() + 1
          };
        });
      },
      8468: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(9667));

        var y = {
          apiVersion: 2,
          name: "core/calendar",
          title: "Calendar",
          category: "widgets",
          description: "A calendar of your site’s posts.",
          keywords: ["posts", "archive"],
          textdomain: "default",
          attributes: {
            month: {
              type: "integer"
            },
            year: {
              type: "integer"
            }
          },
          supports: {
            align: !0
          },
          style: "wp-block-calendar"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.calendar,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      7759: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CategoriesEdit(l) {
          var _l$attributes2 = l.attributes,
              s = _l$attributes2.displayAsDropdown,
              c = _l$attributes2.showHierarchy,
              P = _l$attributes2.showPostCounts,
              T = _l$attributes2.showOnlyTopLevel,
              B = l.setAttributes;

          var z = (0, y.useInstanceId)(CategoriesEdit, "blocks-category-select"),
              _ref22 = (0, k.useSelect)(function (l) {
            var _l6 = l(S.store),
                s = _l6.getEntityRecords,
                c = _l6.isResolving,
                m = {
              per_page: -1,
              hide_empty: !0,
              context: "view"
            };

            return T && (m.parent = 0), {
              categories: s("taxonomy", "category", m),
              isRequesting: c("getEntityRecords", ["taxonomy", "category", m])
            };
          }, [T]),
              L = _ref22.categories,
              V = _ref22.isRequesting,
              getCategoriesList = function getCategoriesList(l) {
            return null != L && L.length ? null === l ? L : L.filter(function (s) {
              var c = s.parent;
              return c === l;
            }) : [];
          },
              getCategoryListClassName = function getCategoryListClassName(l) {
            return "wp-block-categories__list wp-block-categories__list-level-".concat(l);
          },
              toggleAttribute = function toggleAttribute(l) {
            return function (s) {
              return B(_defineProperty({}, l, s));
            };
          },
              renderCategoryName = function renderCategoryName(l) {
            return l ? (0, v.unescape)(l).trim() : (0, w.__)("(Untitled)");
          },
              renderCategoryListItem = function renderCategoryListItem(l, s) {
            var v = getCategoriesList(l.id),
                _ = l.id,
                y = l.link,
                k = l.count,
                E = l.name;
            return (0, m.createElement)("li", {
              key: _
            }, (0, m.createElement)("a", {
              href: y,
              target: "_blank",
              rel: "noreferrer noopener"
            }, renderCategoryName(E)), P && (0, m.createElement)("span", {
              className: "wp-block-categories__post-count"
            }, " (".concat(k, ")")), c && !!v.length && (0, m.createElement)("ul", {
              className: getCategoryListClassName(s + 1)
            }, v.map(function (l) {
              return renderCategoryListItem(l, s + 1);
            })));
          },
              renderCategoryDropdownItem = function renderCategoryDropdownItem(l, s) {
            var _ = l.id,
                y = l.count,
                k = l.name,
                E = getCategoriesList(_);
            return [(0, m.createElement)("option", {
              key: _
            }, (0, v.times)(3 * s, function () {
              return " ";
            }), renderCategoryName(k), P && " (".concat(y, ")")), c && !!E.length && E.map(function (l) {
              return renderCategoryDropdownItem(l, s + 1);
            })];
          };

          return (0, m.createElement)("div", (0, E.useBlockProps)(), (0, m.createElement)(E.InspectorControls, null, (0, m.createElement)(_.PanelBody, {
            title: (0, w.__)("Categories settings")
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, w.__)("Display as dropdown"),
            checked: s,
            onChange: toggleAttribute("displayAsDropdown")
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, w.__)("Show post counts"),
            checked: P,
            onChange: toggleAttribute("showPostCounts")
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, w.__)("Show only top level categories"),
            checked: T,
            onChange: toggleAttribute("showOnlyTopLevel")
          }), !T && (0, m.createElement)(_.ToggleControl, {
            label: (0, w.__)("Show hierarchy"),
            checked: c,
            onChange: toggleAttribute("showHierarchy")
          }))), V && (0, m.createElement)(_.Placeholder, {
            icon: C.pin,
            label: (0, w.__)("Categories")
          }, (0, m.createElement)(_.Spinner, null)), !V && 0 === (null == L ? void 0 : L.length) && (0, m.createElement)("p", null, (0, w.__)("Your site does not have any posts, so there is nothing to display here at the moment.")), !V && (null == L ? void 0 : L.length) > 0 && (s ? function () {
            var l = getCategoriesList(c ? 0 : null);
            return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.VisuallyHidden, {
              as: "label",
              htmlFor: z
            }, (0, w.__)("Categories")), (0, m.createElement)("select", {
              id: z,
              className: "wp-block-categories__dropdown"
            }, l.map(function (l) {
              return renderCategoryDropdownItem(l, 0);
            })));
          }() : function () {
            var l = getCategoriesList(c ? 0 : null);
            return (0, m.createElement)("ul", {
              className: getCategoryListClassName(0)
            }, l.map(function (l) {
              return renderCategoryListItem(l, 0);
            }));
          }()));
        };

        var m = c(1753),
            v = c(4793),
            _ = c(4892),
            y = c(3200),
            k = c(8467),
            E = c(1326),
            w = c(6756),
            C = c(5303),
            S = c(1295);
      },
      3977: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(7759));

        var y = {
          apiVersion: 2,
          name: "core/categories",
          title: "Categories",
          category: "widgets",
          description: "Display a list of all categories.",
          textdomain: "default",
          attributes: {
            displayAsDropdown: {
              type: "boolean",
              default: !1
            },
            showHierarchy: {
              type: "boolean",
              default: !1
            },
            showPostCounts: {
              type: "boolean",
              default: !1
            },
            showOnlyTopLevel: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-categories-editor",
          style: "wp-block-categories"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.category,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      4020: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CodeEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              y = l.onRemove;
          var k = (0, _.useBlockProps)();
          return (0, m.createElement)("pre", k, (0, m.createElement)(_.RichText, {
            tagName: "code",
            value: s.content,
            onChange: function onChange(l) {
              return c({
                content: l
              });
            },
            onRemove: y,
            placeholder: (0, v.__)("Write code…"),
            "aria-label": (0, v.__)("Code"),
            preserveWhiteSpace: !0,
            __unstablePastePlainText: !0
          }));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(1326);
      },
      2733: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(4020)),
            k = m(c(2729)),
            E = m(c(3631));

        var w = {
          apiVersion: 2,
          name: "core/code",
          title: "Code",
          category: "text",
          description: "Display code snippets that respect your spacing and tabs.",
          textdomain: "default",
          attributes: {
            content: {
              type: "string",
              source: "html",
              selector: "code"
            }
          },
          supports: {
            anchor: !0,
            __experimentalSelector: ".wp-block-code > code",
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            spacing: {
              margin: ["top", "bottom"],
              padding: !0
            },
            __experimentalBorder: {
              radius: !0,
              color: !0,
              width: !0,
              style: !0
            },
            color: {
              text: !0,
              background: !0,
              gradients: !0
            }
          },
          style: "wp-block-code"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.code,
          example: {
            attributes: {
              content: (0, v.__)('// A "block" is the abstract term used\n// to describe units of markup that\n// when composed together, form the\n// content or layout of a page.\nregisterBlockType( name, settings );')
            }
          },
          transforms: E.default,
          edit: y.default,
          save: k.default
        };
        s.settings = S;
      },
      2729: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          return (0, m.createElement)("pre", v.useBlockProps.save(), (0, m.createElement)(v.RichText.Content, {
            tagName: "code",
            value: (0, _.escape)(s.content)
          }));
        };

        var m = c(1753),
            v = c(1326),
            _ = c(4644);
      },
      3631: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "enter",
            regExp: /^```$/,
            transform: function transform() {
              return (0, m.createBlock)("core/code");
            }
          }, {
            type: "block",
            blocks: ["core/html"],
            transform: function transform(l) {
              var s = l.content;
              return (0, m.createBlock)("core/code", {
                content: s
              });
            }
          }, {
            type: "raw",
            isMatch: function isMatch(l) {
              return "PRE" === l.nodeName && 1 === l.children.length && "CODE" === l.firstChild.nodeName;
            },
            schema: {
              pre: {
                children: {
                  code: {
                    children: {
                      "#text": {}
                    }
                  }
                }
              }
            }
          }]
        };
        s.default = v;
      },
      4644: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.escape = function escape(l) {
          return (0, m.flow)(escapeOpeningSquareBrackets, escapeProtocolInIsolatedUrls)(l || "");
        };
        var m = c(4793);

        function escapeOpeningSquareBrackets(l) {
          return l.replace(/\[/g, "&#91;");
        }

        function escapeProtocolInIsolatedUrls(l) {
          return l.replace(/^(\s*https?:)\/\/([^\s<>"]+\s*)$/m, "$1&#47;&#47;$2");
        }
      },
      8138: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var k = [{
          attributes: {
            verticalAlignment: {
              type: "string"
            },
            width: {
              type: "number",
              min: 0,
              max: 100
            }
          },
          isEligible: function isEligible(l) {
            var s = l.width;
            return isFinite(s);
          },
          migrate: function migrate(l) {
            return _objectSpread(_objectSpread({}, l), {}, {
              width: "".concat(l.width, "%")
            });
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.verticalAlignment,
                m = s.width,
                k = (0, _.default)(_defineProperty({}, "is-vertically-aligned-".concat(c), c)),
                E = {
              flexBasis: m + "%"
            };
            return (0, v.createElement)("div", {
              className: k,
              style: E
            }, (0, v.createElement)(y.InnerBlocks.Content, null));
          }
        }];
        s.default = k;
      },
      4905: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(4892),
            E = c(8467),
            w = c(6756);

        var C = function ColumnEdit(l) {
          var _l$attributes3 = l.attributes,
              s = _l$attributes3.verticalAlignment,
              c = _l$attributes3.width,
              _l$attributes3$templa = _l$attributes3.templateLock,
              m = _l$attributes3$templa === void 0 ? !1 : _l$attributes3$templa,
              C = _l$attributes3.allowedBlocks,
              S = l.setAttributes,
              P = l.clientId;

          var T = (0, _.default)("block-core-columns", _defineProperty({}, "is-vertically-aligned-".concat(s), s)),
              B = (0, k.__experimentalUseCustomUnits)({
            availableUnits: (0, y.useSetting)("spacing.units") || ["%", "px", "em", "rem", "vw"]
          }),
              _ref24 = (0, E.useSelect)(function (l) {
            var _l7 = l(y.store),
                s = _l7.getBlockOrder,
                c = _l7.getBlockRootClientId,
                m = c(P);

            return {
              hasChildBlocks: s(P).length > 0,
              rootClientId: m,
              columnsIds: s(m)
            };
          }, [P]),
              z = _ref24.columnsIds,
              L = _ref24.hasChildBlocks,
              V = _ref24.rootClientId,
              _ref25 = (0, E.useDispatch)(y.store),
              A = _ref25.updateBlockAttributes,
              R = Number.isFinite(c) ? c + "%" : c,
              O = (0, y.useBlockProps)({
            className: T,
            style: R ? {
              flexBasis: R
            } : void 0
          }),
              D = z.length,
              F = z.indexOf(P) + 1,
              G = (0, w.sprintf)((0, w.__)("%1$s (%2$d of %3$d)"), O["aria-label"], F, D),
              q = (0, y.useInnerBlocksProps)(_objectSpread(_objectSpread({}, O), {}, {
            "aria-label": G
          }), {
            templateLock: m,
            allowedBlocks: C,
            renderAppender: L ? void 0 : y.InnerBlocks.ButtonBlockAppender
          });

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, null, (0, v.createElement)(y.BlockVerticalAlignmentToolbar, {
            onChange: function onChange(l) {
              S({
                verticalAlignment: l
              }), A(V, {
                verticalAlignment: null
              });
            },
            value: s
          })), (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, w.__)("Column settings")
          }, (0, v.createElement)(k.__experimentalUnitControl, {
            label: (0, w.__)("Width"),
            labelPosition: "edge",
            __unstableInputWidth: "80px",
            value: c || "",
            onChange: function onChange(l) {
              l = 0 > parseFloat(l) ? "0" : l, S({
                width: l
              });
            },
            units: B
          }))), (0, v.createElement)("div", q));
        };

        s.default = C;
      },
      8705: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8138)),
            y = m(c(4905)),
            k = m(c(6347));

        var E = {
          apiVersion: 2,
          name: "core/column",
          title: "Column",
          category: "text",
          parent: ["core/columns"],
          description: "A single column within a columns block.",
          textdomain: "default",
          attributes: {
            verticalAlignment: {
              type: "string"
            },
            width: {
              type: "string"
            },
            allowedBlocks: {
              type: "array"
            },
            templateLock: {
              type: ["string", "boolean"],
              enum: ["all", "insert", !1]
            }
          },
          supports: {
            anchor: !0,
            reusable: !1,
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              padding: !0,
              __experimentalDefaultControls: {
                padding: !0
              }
            }
          }
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.column,
          edit: y.default,
          save: k.default,
          deprecated: _.default
        };
        s.settings = C;
      },
      6347: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.verticalAlignment,
              m = s.width,
              k = (0, _.default)(_defineProperty({}, "is-vertically-aligned-".concat(c), c));
          var E;

          if (m && /\d/.test(m)) {
            var _l8 = Number.isFinite(m) ? m + "%" : m;

            if (!Number.isFinite(m) && null != m && m.endsWith("%")) {
              var _s2 = 1e12;
              _l8 = Math.round(Number.parseFloat(m) * _s2) / _s2 + "%";
            }

            E = {
              flexBasis: _l8
            };
          }

          var w = y.useBlockProps.save({
            className: k,
            style: E
          }),
              C = y.useInnerBlocksProps.save(w);
          return (0, v.createElement)("div", C);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      1793: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = m(c(2703)),
            k = c(6700),
            E = c(1326);

        function getDeprecatedLayoutColumn(l) {
          var s,
              c = getDeprecatedLayoutColumn.doc;
          c || (c = document.implementation.createHTMLDocument(""), getDeprecatedLayoutColumn.doc = c), c.body.innerHTML = l;

          var _iterator = _createForOfIteratorHelper(c.body.firstChild.classList),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _l9 = _step.value;
              if (s = _l9.match(/^layout-column-(\d+)$/)) return Number(s[1]) - 1;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        var w = [{
          attributes: {
            verticalAlignment: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            }
          },
          migrate: function migrate(l) {
            if (!l.customTextColor && !l.customBackgroundColor) return l;
            var s = {
              color: {}
            };
            return l.customTextColor && (s.color.text = l.customTextColor), l.customBackgroundColor && (s.color.background = l.customBackgroundColor), _objectSpread(_objectSpread({}, (0, _.omit)(l, ["customTextColor", "customBackgroundColor"])), {}, {
              style: s,
              isStackedOnMobile: !0
            });
          },
          save: function save(l) {
            var _ref28;

            var s = l.attributes;
            var c = s.verticalAlignment,
                m = s.backgroundColor,
                _ = s.customBackgroundColor,
                k = s.textColor,
                w = s.customTextColor,
                C = (0, E.getColorClassName)("background-color", m),
                S = (0, E.getColorClassName)("color", k),
                P = (0, y.default)((_ref28 = {
              "has-background": m || _,
              "has-text-color": k || w
            }, _defineProperty(_ref28, C, C), _defineProperty(_ref28, S, S), _defineProperty(_ref28, "are-vertically-aligned-".concat(c), c), _ref28)),
                T = {
              backgroundColor: C ? void 0 : _,
              color: S ? void 0 : w
            };
            return (0, v.createElement)("div", {
              className: P || void 0,
              style: T
            }, (0, v.createElement)(E.InnerBlocks.Content, null));
          }
        }, {
          attributes: {
            columns: {
              type: "number",
              default: 2
            }
          },
          isEligible: function isEligible(l, s) {
            return !!s.some(function (l) {
              return /layout-column-\d+/.test(l.originalContent);
            }) && s.some(function (l) {
              return void 0 !== getDeprecatedLayoutColumn(l.originalContent);
            });
          },
          migrate: function migrate(l, s) {
            var c = s.reduce(function (l, s) {
              var c = s.originalContent;
              var m = getDeprecatedLayoutColumn(c);
              return void 0 === m && (m = 0), l[m] || (l[m] = []), l[m].push(s), l;
            }, []).map(function (l) {
              return (0, k.createBlock)("core/column", {}, l);
            });
            return [_objectSpread(_objectSpread({}, (0, _.omit)(l, ["columns"])), {}, {
              isStackedOnMobile: !0
            }), c];
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.columns;
            return (0, v.createElement)("div", {
              className: "has-".concat(c, "-columns")
            }, (0, v.createElement)(E.InnerBlocks.Content, null));
          }
        }, {
          attributes: {
            columns: {
              type: "number",
              default: 2
            }
          },
          migrate: function migrate(l, s) {
            return [l = _objectSpread(_objectSpread({}, (0, _.omit)(l, ["columns"])), {}, {
              isStackedOnMobile: !0
            }), s];
          },
          save: function save(l) {
            var s = l.attributes;

            var c = s.verticalAlignment,
                m = s.columns,
                _ = (0, y.default)("has-".concat(m, "-columns"), _defineProperty({}, "are-vertically-aligned-".concat(c), c));

            return (0, v.createElement)("div", {
              className: _
            }, (0, v.createElement)(E.InnerBlocks.Content, null));
          }
        }];
        s.default = w;
      },
      2325: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(6756),
            E = c(4892),
            w = c(1326),
            C = c(8467),
            S = c(6700),
            P = c(5629);

        var T = ["core/column"];
        var B = (0, C.withDispatch)(function (l, s, c) {
          return {
            updateAlignment: function updateAlignment(m) {
              var v = s.clientId,
                  _ = s.setAttributes,
                  _l10 = l(w.store),
                  y = _l10.updateBlockAttributes,
                  _c$select = c.select(w.store),
                  k = _c$select.getBlockOrder;

              _({
                verticalAlignment: m
              });

              k(v).forEach(function (l) {
                y(l, {
                  verticalAlignment: m
                });
              });
            },
            updateColumns: function updateColumns(m, v) {
              var _ = s.clientId,
                  _l11 = l(w.store),
                  k = _l11.replaceInnerBlocks,
                  _c$select2 = c.select(w.store),
                  E = _c$select2.getBlocks;

              var C = E(_);
              var T = (0, P.hasExplicitPercentColumnWidths)(C),
                  B = v > m;

              if (B && T) {
                var _l12 = (0, P.toWidthPrecision)(100 / v),
                    _s3 = (0, P.getRedistributedColumnWidths)(C, 100 - _l12);

                C = [].concat(_toConsumableArray((0, P.getMappedColumnWidths)(C, _s3)), _toConsumableArray((0, y.times)(v - m, function () {
                  return (0, S.createBlock)("core/column", {
                    width: "".concat(_l12, "%")
                  });
                })));
              } else if (B) C = [].concat(_toConsumableArray(C), _toConsumableArray((0, y.times)(v - m, function () {
                return (0, S.createBlock)("core/column");
              })));else if (C = (0, y.dropRight)(C, m - v), T) {
                var _l13 = (0, P.getRedistributedColumnWidths)(C, 100);

                C = (0, P.getMappedColumnWidths)(C, _l13);
              }

              k(_, C);
            }
          };
        })(function ColumnsEditContainer(l) {
          var _ref31;

          var s = l.attributes,
              c = l.setAttributes,
              m = l.updateAlignment,
              y = l.updateColumns,
              S = l.clientId;

          var P = s.isStackedOnMobile,
              B = s.verticalAlignment,
              _ref30 = (0, C.useSelect)(function (l) {
            return {
              count: l(w.store).getBlockCount(S)
            };
          }, [S]),
              z = _ref30.count,
              L = (0, _.default)((_ref31 = {}, _defineProperty(_ref31, "are-vertically-aligned-".concat(B), B), _defineProperty(_ref31, "is-not-stacked-on-mobile", !P), _ref31)),
              V = (0, w.useBlockProps)({
            className: L
          }),
              A = (0, w.useInnerBlocksProps)(V, {
            allowedBlocks: T,
            orientation: "horizontal",
            renderAppender: !1
          });

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.BlockControls, null, (0, v.createElement)(w.BlockVerticalAlignmentToolbar, {
            onChange: m,
            value: B
          })), (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(E.PanelBody, null, (0, v.createElement)(E.RangeControl, {
            label: (0, k.__)("Columns"),
            value: z,
            onChange: function onChange(l) {
              return y(z, l);
            },
            min: 1,
            max: Math.max(6, z)
          }), z > 6 && (0, v.createElement)(E.Notice, {
            status: "warning",
            isDismissible: !1
          }, (0, k.__)("This column count exceeds the recommended amount and may cause visual breakage.")), (0, v.createElement)(E.ToggleControl, {
            label: (0, k.__)("Stack on mobile"),
            checked: P,
            onChange: function onChange() {
              return c({
                isStackedOnMobile: !P
              });
            }
          }))), (0, v.createElement)("div", A));
        });

        function Placeholder(l) {
          var s = l.clientId,
              c = l.name,
              m = l.setAttributes;

          var _ref32 = (0, C.useSelect)(function (l) {
            var _l14 = l(S.store),
                s = _l14.getBlockVariations,
                m = _l14.getBlockType,
                v = _l14.getDefaultBlockVariation;

            return {
              blockType: m(c),
              defaultVariation: v(c, "block"),
              variations: s(c, "block")
            };
          }, [c]),
              _ = _ref32.blockType,
              k = _ref32.defaultVariation,
              E = _ref32.variations,
              _ref33 = (0, C.useDispatch)(w.store),
              P = _ref33.replaceInnerBlocks,
              T = (0, w.useBlockProps)();

          return (0, v.createElement)("div", T, (0, v.createElement)(w.__experimentalBlockVariationPicker, {
            icon: (0, y.get)(_, ["icon", "src"]),
            label: (0, y.get)(_, ["title"]),
            variations: E,
            onSelect: function onSelect() {
              var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : k;
              l.attributes && m(l.attributes), l.innerBlocks && P(s, (0, S.createBlocksFromInnerBlocksTemplate)(l.innerBlocks), !0);
            },
            allowSkip: !0
          }));
        }

        var _default = function _default(l) {
          var s = l.clientId,
              c = (0, C.useSelect)(function (l) {
            return l(w.store).getBlocks(s).length > 0;
          }, [s]) ? B : Placeholder;
          return (0, v.createElement)(c, l);
        };

        s.default = _default;
      },
      1567: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(1793)),
            k = m(c(2325)),
            E = m(c(1392)),
            w = m(c(7931)),
            C = m(c(4589));

        var S = {
          apiVersion: 2,
          name: "core/columns",
          title: "Columns",
          category: "design",
          description: "Display content in multiple columns, with blocks added to each column.",
          textdomain: "default",
          attributes: {
            verticalAlignment: {
              type: "string"
            },
            isStackedOnMobile: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            anchor: !0,
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              margin: ["top", "bottom"],
              padding: !0,
              __experimentalDefaultControls: {
                padding: !0
              }
            }
          },
          editorStyle: "wp-block-columns-editor",
          style: "wp-block-columns"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: _.columns,
          variations: w.default,
          example: {
            viewportWidth: 600,
            innerBlocks: [{
              name: "core/column",
              innerBlocks: [{
                name: "core/paragraph",
                attributes: {
                  content: (0, v.__)("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent et eros eu felis.")
                }
              }, {
                name: "core/image",
                attributes: {
                  url: "https://s.w.org/images/core/5.3/Windbuchencom.jpg"
                }
              }, {
                name: "core/paragraph",
                attributes: {
                  content: (0, v.__)("Suspendisse commodo neque lacus, a dictum orci interdum et.")
                }
              }]
            }, {
              name: "core/column",
              innerBlocks: [{
                name: "core/paragraph",
                attributes: {
                  content: (0, v.__)("Etiam et egestas lorem. Vivamus sagittis sit amet dolor quis lobortis. Integer sed fermentum arcu, id vulputate lacus. Etiam fermentum sem eu quam hendrerit.")
                }
              }, {
                name: "core/paragraph",
                attributes: {
                  content: (0, v.__)("Nam risus massa, ullamcorper consectetur eros fermentum, porta aliquet ligula. Sed vel mauris nec enim.")
                }
              }]
            }]
          },
          deprecated: y.default,
          edit: k.default,
          save: E.default,
          transforms: C.default
        };
        s.settings = T;
      },
      1392: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _ref34;

          var s = l.attributes;
          var c = s.isStackedOnMobile,
              m = s.verticalAlignment,
              k = (0, _.default)((_ref34 = {}, _defineProperty(_ref34, "are-vertically-aligned-".concat(m), m), _defineProperty(_ref34, "is-not-stacked-on-mobile", !c), _ref34)),
              E = y.useBlockProps.save({
            className: k
          }),
              w = y.useInnerBlocksProps.save(E);
          return (0, v.createElement)("div", w);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      4589: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["*"],
            __experimentalConvert: function __experimentalConvert(l) {
              var s = +(100 / l.length).toFixed(2),
                  c = l.map(function (l) {
                var c = l.name,
                    m = l.attributes,
                    v = l.innerBlocks;
                return ["core/column", {
                  width: "".concat(s, "%")
                }, [[c, _objectSpread({}, m), v]]];
              });
              return (0, m.createBlock)("core/columns", {}, (0, m.createBlocksFromInnerBlocksTemplate)(c));
            },
            isMatch: function isMatch(l) {
              var s = l.length;
              return s && s <= 6;
            }
          }, {
            type: "block",
            blocks: ["core/media-text"],
            priority: 1,
            transform: function transform(l, s) {
              var c = l.align,
                  v = l.backgroundColor,
                  _ = l.textColor,
                  y = l.style,
                  k = l.mediaAlt,
                  E = l.mediaId,
                  w = l.mediaPosition,
                  C = l.mediaSizeSlug,
                  S = l.mediaType,
                  P = l.mediaUrl,
                  T = l.mediaWidth,
                  B = l.verticalAlignment;
              var z;
              if ("image" !== S && S) z = ["core/video", {
                id: E,
                src: P
              }];else {
                z = ["core/image", _objectSpread(_objectSpread({}, {
                  id: E,
                  alt: k,
                  url: P,
                  sizeSlug: C
                }), {
                  href: l.href,
                  linkClass: l.linkClass,
                  linkDestination: l.linkDestination,
                  linkTarget: l.linkTarget,
                  rel: l.rel
                })];
              }
              var L = [["core/column", {
                width: "".concat(T, "%")
              }, [z]], ["core/column", {
                width: 100 - T + "%"
              }, s]];
              return "right" === w && L.reverse(), (0, m.createBlock)("core/columns", {
                align: c,
                backgroundColor: v,
                textColor: _,
                style: y,
                verticalAlignment: B
              }, (0, m.createBlocksFromInnerBlocksTemplate)(L));
            }
          }]
        };
        s.default = v;
      },
      5629: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getColumnWidths = getColumnWidths, s.getEffectiveColumnWidth = getEffectiveColumnWidth, s.getMappedColumnWidths = function getMappedColumnWidths(l, s) {
          return l.map(function (l) {
            return (0, m.merge)({}, l, {
              attributes: {
                width: "".concat(s[l.clientId], "%")
              }
            });
          });
        }, s.getRedistributedColumnWidths = function getRedistributedColumnWidths(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l.length;
          var v = getTotalColumnsWidth(l, c);
          return (0, m.mapValues)(getColumnWidths(l, c), function (l) {
            return toWidthPrecision(s * l / v);
          });
        }, s.getTotalColumnsWidth = getTotalColumnsWidth, s.getWidthWithUnit = function getWidthWithUnit(l, s) {
          l = 0 > parseFloat(l) ? "0" : l, isPercentageUnit(s) && (l = Math.min(l, 100));
          return "".concat(l).concat(s);
        }, s.getWidths = function getWidths(l) {
          var s = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          return l.map(function (c) {
            var m = c.attributes.width || 100 / l.length;
            return s ? parseFloat(m) : m;
          });
        }, s.hasExplicitPercentColumnWidths = function hasExplicitPercentColumnWidths(l) {
          return l.every(function (l) {
            var s;
            var c = l.attributes.width;
            return Number.isFinite(null != c && null !== (s = c.endsWith) && void 0 !== s && s.call(c, "%") ? parseFloat(c) : c);
          });
        }, s.isPercentageUnit = isPercentageUnit, s.toWidthPrecision = void 0;
        var m = c(4793);

        var toWidthPrecision = function toWidthPrecision(l) {
          var s = parseFloat(l);
          return Number.isFinite(s) ? parseFloat(s.toFixed(2)) : void 0;
        };

        function getEffectiveColumnWidth(l, s) {
          var _l$attributes$width = l.attributes.width,
              c = _l$attributes$width === void 0 ? 100 / s : _l$attributes$width;
          return toWidthPrecision(c);
        }

        function getTotalColumnsWidth(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.length;
          return (0, m.sumBy)(l, function (l) {
            return getEffectiveColumnWidth(l, s);
          });
        }

        function getColumnWidths(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.length;
          return l.reduce(function (l, c) {
            var m = getEffectiveColumnWidth(c, s);
            return Object.assign(l, _defineProperty({}, c.clientId, m));
          }, {});
        }

        function isPercentageUnit(l) {
          return "%" === l;
        }

        s.toWidthPrecision = toWidthPrecision;
      },
      7931: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756);

        var y = [{
          name: "one-column-full",
          title: (0, _.__)("100"),
          description: (0, _.__)("One column"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m39.0625 14h-30.0625v20.0938h30.0625zm-30.0625-2c-1.10457 0-2 .8954-2 2v20.0938c0 1.1045.89543 2 2 2h30.0625c1.1046 0 2-.8955 2-2v-20.0938c0-1.1046-.8954-2-2-2z"
          })),
          innerBlocks: [["core/column"]],
          scope: ["block"]
        }, {
          name: "two-columns-equal",
          title: (0, _.__)("50 / 50"),
          description: (0, _.__)("Two columns; equal split"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H25V34H39ZM23 34H9V14H23V34Z"
          })),
          isDefault: !0,
          innerBlocks: [["core/column"], ["core/column"]],
          scope: ["block"]
        }, {
          name: "two-columns-one-third-two-thirds",
          title: (0, _.__)("30 / 70"),
          description: (0, _.__)("Two columns; one-third, two-thirds split"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H20V34H39ZM18 34H9V14H18V34Z"
          })),
          innerBlocks: [["core/column", {
            width: "33.33%"
          }], ["core/column", {
            width: "66.66%"
          }]],
          scope: ["block"]
        }, {
          name: "two-columns-two-thirds-one-third",
          title: (0, _.__)("70 / 30"),
          description: (0, _.__)("Two columns; two-thirds, one-third split"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H30V34H39ZM28 34H9V14H28V34Z"
          })),
          innerBlocks: [["core/column", {
            width: "66.66%"
          }], ["core/column", {
            width: "33.33%"
          }]],
          scope: ["block"]
        }, {
          name: "three-columns-equal",
          title: (0, _.__)("33 / 33 / 33"),
          description: (0, _.__)("Three columns; equal split"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            d: "M41 14a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14zM28.5 34h-9V14h9v20zm2 0V14H39v20h-8.5zm-13 0H9V14h8.5v20z"
          })),
          innerBlocks: [["core/column"], ["core/column"], ["core/column"]],
          scope: ["block"]
        }, {
          name: "three-columns-wider-center",
          title: (0, _.__)("25 / 50 / 25"),
          description: (0, _.__)("Three columns; wide center column"),
          icon: (0, m.createElement)(v.SVG, {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            fillRule: "evenodd",
            d: "M41 14a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14zM31 34H17V14h14v20zm2 0V14h6v20h-6zm-18 0H9V14h6v20z"
          })),
          innerBlocks: [["core/column", {
            width: "25%"
          }], ["core/column", {
            width: "50%"
          }], ["core/column", {
            width: "25%"
          }]],
          scope: ["block"]
        }];
        s.default = y;
      },
      9004: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var s = l.attributes,
              c = l.context.commentId,
              m = l.setAttributes;

          var C = s.height,
              S = s.width,
              _ref35 = (0, E.useEntityProp)("root", "comment", "author_avatar_urls", c),
              _ref36 = _slicedToArray2(_ref35, 1),
              P = _ref36[0],
              _ref37 = (0, E.useEntityProp)("root", "comment", "author_name", c),
              _ref38 = _slicedToArray2(_ref37, 1),
              T = _ref38[0],
              B = P ? Object.values(P) : null,
              z = P ? Object.keys(P) : null,
              L = z ? z[0] : 24,
              V = z ? z[z.length - 1] : 96,
              A = (0, y.useBlockProps)(),
              R = Math.floor(2.5 * V),
              O = (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, w.__)("Avatar Settings")
          }, (0, v.createElement)(k.RangeControl, {
            label: (0, w.__)("Image size"),
            onChange: function onChange(l) {
              return m({
                width: l,
                height: l
              });
            },
            min: L,
            max: R,
            initialPosition: S,
            value: S
          }))),
              D = B ? (0, v.createElement)(k.ResizableBox, {
            size: {
              width: S,
              height: C
            },
            onResizeStop: function onResizeStop(l, s, c, v) {
              m({
                height: parseInt(C + v.height, 10),
                width: parseInt(S + v.width, 10)
              });
            },
            lockAspectRatio: !0,
            enable: {
              top: !1,
              right: !(0, w.isRTL)(),
              bottom: !0,
              left: (0, w.isRTL)()
            },
            minWidth: L,
            maxWidth: R
          }, (0, v.createElement)("img", (0, _.default)({
            src: B[B.length - 1],
            alt: "".concat(T, " ").concat((0, w.__)("Avatar"))
          }, A))) : (0, v.createElement)("p", A, (0, w._x)("Comment Author Avatar", "block title"));

          return (0, v.createElement)(v.Fragment, null, O, (0, v.createElement)("div", null, D));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(1326),
            k = c(4892),
            E = c(1295),
            w = c(6756);
      },
      236: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(9004));

        var y = {
          apiVersion: 2,
          name: "core/comment-author-avatar",
          title: "Comment Author Avatar",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Add the avatar of this comment's author.",
          textdomain: "default",
          attributes: {
            width: {
              type: "number",
              default: 96
            },
            height: {
              type: "number",
              default: 96
            }
          },
          usesContext: ["commentId"],
          supports: {
            html: !1,
            __experimentalBorder: {
              radius: !0,
              width: !0,
              color: !0,
              style: !0
            },
            color: {
              background: !0,
              text: !1,
              links: !1
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.commentAuthorAvatar,
          edit: _.default
        };
        s.settings = E;
      },
      8049: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            isLink: {
              type: "boolean",
              default: !1
            },
            linkTarget: {
              type: "string",
              default: "_self"
            }
          },
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      8027: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var _l$attributes4 = l.attributes,
              s = _l$attributes4.isLink,
              c = _l$attributes4.linkTarget,
              m = _l$attributes4.textAlign,
              S = l.context.commentId,
              P = l.setAttributes;
          var T = (0, E.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(m), m))
          }),
              B = (0, k.useSelect)(function (l) {
            var _l15 = l(w.store),
                s = _l15.getEntityRecord,
                c = s("root", "comment", S),
                m = null == c ? void 0 : c.author_name;

            if (c && !m) {
              var v;

              var _l16 = s("root", "user", c.author);

              return null !== (v = null == _l16 ? void 0 : _l16.name) && void 0 !== v ? v : (0, y.__)("Anonymous");
            }

            return null != m ? m : "";
          }, [S]),
              z = (0, v.createElement)(E.BlockControls, {
            group: "block"
          }, (0, v.createElement)(E.AlignmentControl, {
            value: m,
            onChange: function onChange(l) {
              return P({
                textAlign: l
              });
            }
          })),
              L = (0, v.createElement)(E.InspectorControls, null, (0, v.createElement)(C.PanelBody, {
            title: (0, y.__)("Link settings")
          }, (0, v.createElement)(C.ToggleControl, {
            label: (0, y.__)("Link to authors URL"),
            onChange: function onChange() {
              return P({
                isLink: !s
              });
            },
            checked: s
          }), s && (0, v.createElement)(C.ToggleControl, {
            label: (0, y.__)("Open in new tab"),
            onChange: function onChange(l) {
              return P({
                linkTarget: l ? "_blank" : "_self"
              });
            },
            checked: "_blank" === c
          })));
          if (!S || !B) return (0, v.createElement)(v.Fragment, null, L, z, (0, v.createElement)("div", T, (0, v.createElement)("p", null, (0, y._x)("Comment Author", "block title"))));
          var V = s ? (0, v.createElement)("a", {
            href: "#comment-author-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, B) : (0, v.createElement)("p", null, B);
          return (0, v.createElement)(v.Fragment, null, L, z, (0, v.createElement)("div", T, V));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(8467),
            E = c(1326),
            w = c(1295),
            C = c(4892);
      },
      5513: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8027)),
            y = m(c(8049));

        var k = {
          apiVersion: 2,
          name: "core/comment-author-name",
          title: "Comment Author Name",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Add the author name of this comment.",
          textdomain: "default",
          attributes: {
            isLink: {
              type: "boolean",
              default: !1
            },
            linkTarget: {
              type: "string",
              default: "_self"
            },
            textAlign: {
              type: "string"
            }
          },
          usesContext: ["commentId"],
          supports: {
            html: !1,
            spacing: {
              margin: !0,
              padding: !0
            },
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            }
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.commentAuthorName,
          edit: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      8002: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var s = l.setAttributes,
              c = l.attributes.textAlign,
              m = l.context.commentId;

          var C = (0, w.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c))
          }),
              _ref40 = (0, E.useEntityProp)("root", "comment", "content", m),
              _ref41 = _slicedToArray2(_ref40, 1),
              S = _ref41[0],
              P = (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, (0, v.createElement)(w.AlignmentControl, {
            value: c,
            onChange: function onChange(l) {
              return s({
                textAlign: l
              });
            }
          }));

          if (!m || !S) return (0, v.createElement)(v.Fragment, null, P, (0, v.createElement)("div", C, (0, v.createElement)("p", null, (0, y._x)("Comment Content", "block title"))));
          return (0, v.createElement)(v.Fragment, null, P, (0, v.createElement)("div", C, (0, v.createElement)(k.Disabled, null, (0, v.createElement)(v.RawHTML, {
            key: "html"
          }, S.rendered))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(4892),
            E = c(1295),
            w = c(1326);
      },
      4040: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8002));

        var y = {
          apiVersion: 2,
          name: "core/comment-content",
          title: "Comment Content",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Displays the contents of a comment.",
          textdomain: "default",
          usesContext: ["commentId"],
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            },
            spacing: {
              padding: ["horizontal", "vertical"],
              __experimentalDefaultControls: {
                padding: !0
              }
            },
            html: !1
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.commentContent,
          edit: _.default
        };
        s.settings = E;
      },
      9494: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            format: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      8753: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var _l$attributes5 = l.attributes,
              s = _l$attributes5.format,
              c = _l$attributes5.isLink,
              w = l.context.commentId,
              C = l.setAttributes;

          var S = (0, y.useBlockProps)(),
              _ref43 = (0, v.useEntityProp)("root", "comment", "date", w),
              _ref44 = _slicedToArray2(_ref43, 1),
              P = _ref44[0],
              _ref45 = (0, v.useEntityProp)("root", "site", "date_format"),
              _ref46 = _slicedToArray2(_ref45, 1),
              T = _ref46[0],
              B = (0, _.__experimentalGetSettings)(),
              z = Object.values(B.formats).map(function (l) {
            return {
              key: l,
              name: (0, _.dateI18n)(l, P || new Date())
            };
          }),
              L = s || T || B.formats.date,
              V = (0, m.createElement)(y.InspectorControls, null, (0, m.createElement)(k.PanelBody, {
            title: (0, E.__)("Format settings")
          }, (0, m.createElement)(k.CustomSelectControl, {
            hideLabelFromVision: !0,
            label: (0, E.__)("Date Format"),
            options: z,
            onChange: function onChange(l) {
              var s = l.selectedItem;
              return C({
                format: s.key
              });
            },
            value: z.find(function (l) {
              return l.key === L;
            })
          })), (0, m.createElement)(k.PanelBody, {
            title: (0, E.__)("Link settings")
          }, (0, m.createElement)(k.ToggleControl, {
            label: (0, E.__)("Link to comment"),
            onChange: function onChange() {
              return C({
                isLink: !c
              });
            },
            checked: c
          })));

          if (!w || !P) return (0, m.createElement)(m.Fragment, null, V, (0, m.createElement)("div", S, (0, m.createElement)("p", null, (0, E._x)("Comment Date", "block title"))));
          var A = (0, m.createElement)("time", {
            dateTime: (0, _.dateI18n)("c", P)
          }, (0, _.dateI18n)(L, P));
          c && (A = (0, m.createElement)("a", {
            href: "#comment-date-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, A));
          return (0, m.createElement)(m.Fragment, null, V, (0, m.createElement)("div", S, A));
        };

        var m = c(1753),
            v = c(1295),
            _ = c(7126),
            y = c(1326),
            k = c(4892),
            E = c(6756);
      },
      9150: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8753)),
            y = m(c(9494));

        var k = {
          apiVersion: 2,
          name: "core/comment-date",
          title: "Comment Date",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Add the date of this comment.",
          textdomain: "default",
          attributes: {
            format: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !1
            }
          },
          usesContext: ["commentId"],
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.postDate,
          edit: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      249: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var _l$attributes6 = l.attributes,
              s = _l$attributes6.linkTarget,
              c = _l$attributes6.textAlign,
              m = l.setAttributes;
          var w = (0, y.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c))
          }),
              C = (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(y.AlignmentControl, {
            value: c,
            onChange: function onChange(l) {
              return m({
                textAlign: l
              });
            }
          })),
              S = (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, E.__)("Link settings")
          }, (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Open in new tab"),
            onChange: function onChange(l) {
              return m({
                linkTarget: l ? "_blank" : "_self"
              });
            },
            checked: "_blank" === s
          })));
          return (0, v.createElement)(v.Fragment, null, C, S, (0, v.createElement)("div", w, (0, v.createElement)("a", {
            href: "#edit-comment-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, E.__)("Edit"))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(4892),
            E = c(6756);
      },
      9261: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(249));

        var y = {
          apiVersion: 2,
          name: "core/comment-edit-link",
          title: "Comment Edit Link",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Displays a link to edit the comment in the WordPress Dashboard. This link is only visible to users with the edit comment capability.",
          textdomain: "default",
          usesContext: ["commentId"],
          attributes: {
            linkTarget: {
              type: "string",
              default: "_self"
            },
            textAlign: {
              type: "string"
            }
          },
          supports: {
            html: !1,
            color: {
              link: !0,
              gradients: !0,
              text: !1
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.edit,
          edit: _.default
        };
        s.settings = E;
      },
      1397: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(1326);

        var E = function Edit(l) {
          var s = l.setAttributes,
              c = l.attributes.textAlign;
          var m = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c))
          }),
              E = (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: c,
            onChange: function onChange(l) {
              return s({
                textAlign: l
              });
            }
          }));
          return (0, v.createElement)(v.Fragment, null, E, (0, v.createElement)("div", m, (0, v.createElement)("a", {
            href: "#comment-reply-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, y.__)("Reply"))));
        };

        s.default = E;
      },
      6899: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(1397));

        var y = {
          apiVersion: 2,
          name: "core/comment-reply-link",
          title: "Comment Reply Link",
          category: "theme",
          parent: ["core/comment-template"],
          description: "Displays a link to reply to a comment.",
          textdomain: "default",
          usesContext: ["commentId"],
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            color: {
              gradients: !0,
              link: !0,
              text: !1
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            },
            html: !1
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          edit: _.default,
          icon: v.commentReplyLink
        };
        s.settings = E;
      },
      7065: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CommentTemplateEdit(l) {
          var s = l.clientId,
              _l$context = l.context,
              c = _l$context.postId,
              w = _l$context.queryPerPage;

          var C = (0, y.useBlockProps)(),
              _ref49 = (0, m.useState)(),
              _ref50 = _slicedToArray2(_ref49, 2),
              S = _ref50[0],
              P = _ref50[1],
              _ref51 = (0, v.useSelect)(function (l) {
            var _l17 = l(E.store),
                m = _l17.getEntityRecords,
                _l18 = l(y.store),
                v = _l18.getBlocks;

            return {
              comments: m("root", "comment", {
                post: c,
                status: "approve",
                per_page: w,
                order: "asc"
              }),
              blocks: v(s)
            };
          }, [w, c, s]),
              T = _ref51.comments,
              B = _ref51.blocks,
              z = (0, m.useMemo)(function () {
            return null == T ? void 0 : T.map(function (l) {
              return {
                commentId: l.id
              };
            });
          }, [T]);

          if (!T) return (0, m.createElement)("p", C, (0, m.createElement)(k.Spinner, null));
          if (!T.length) return (0, m.createElement)("p", C, " ", (0, _.__)("No results found."));
          return (0, m.createElement)("ul", C, z && z.map(function (l) {
            return (0, m.createElement)(y.BlockContextProvider, {
              key: l.commentId,
              value: l
            }, l === (S || z[0]) ? (0, m.createElement)(CommentTemplateInnerBlocks, null) : (0, m.createElement)("li", null, (0, m.createElement)(y.BlockPreview, {
              blocks: B,
              __experimentalLive: !0,
              __experimentalOnClick: function __experimentalOnClick() {
                return P(l);
              }
            })));
          }));
        };

        var m = c(1753),
            v = c(8467),
            _ = c(6756),
            y = c(1326),
            k = c(4892),
            E = c(1295);

        var w = [["core/comment-author-avatar"], ["core/comment-author-name"], ["core/comment-date"], ["core/comment-content"], ["core/comment-reply-link"], ["core/comment-edit-link"]];

        function CommentTemplateInnerBlocks() {
          var l = (0, y.useInnerBlocksProps)({}, {
            template: w
          });
          return (0, m.createElement)("li", l);
        }
      },
      9060: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(7065)),
            y = m(c(3573));

        var k = {
          apiVersion: 2,
          name: "core/comment-template",
          title: "Comment Template",
          category: "design",
          parent: ["core/comments-query-loop"],
          description: "Contains the block elements used to render a comment, like the title, date, author, avatar and more.",
          textdomain: "default",
          usesContext: ["queryId", "queryPerPage", "postId"],
          supports: {
            reusable: !1,
            html: !1,
            align: !0
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.layout,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      3573: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CommentTemplateSave() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      2343: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CommentsQueryLoopEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var m = s.queryPerPage,
              C = s.tagName,
              S = (0, _.useBlockProps)(),
              P = (0, _.useInnerBlocksProps)(S, {
            template: w
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(_.BlockControls, null, (0, v.createElement)(E.default, {
            queryPerPage: m,
            setQuery: c
          })), (0, v.createElement)(_.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, v.createElement)(y.SelectControl, {
            label: (0, k.__)("HTML element"),
            options: [{
              label: (0, k.__)("Default (<div>)"),
              value: "div"
            }, {
              label: "<section>",
              value: "section"
            }, {
              label: "<aside>",
              value: "aside"
            }],
            value: C,
            onChange: function onChange(l) {
              return c({
                tagName: l
              });
            }
          })), (0, v.createElement)(C, P));
        };

        var v = c(1753),
            _ = c(1326),
            y = c(4892),
            k = c(6756),
            E = m(c(4224));

        var w = [["core/comment-template"]];
      },
      4073: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(2343)),
            y = m(c(4402));

        var k = {
          apiVersion: 2,
          name: "core/comments-query-loop",
          title: "Comments Query Loop",
          category: "theme",
          description: "An advanced block that allows displaying post comments based on different query parameters and visual configurations.",
          textdomain: "default",
          attributes: {
            queryId: {
              type: "number"
            },
            queryPerPage: {
              type: "number",
              default: 4
            },
            tagName: {
              type: "string",
              default: "div"
            }
          },
          providesContext: {
            queryId: "queryId",
            queryPerPage: "queryPerPage"
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            }
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.postComments,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      4402: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CommentsQueryLoopSave(l) {
          var s = l.attributes.tagName;
          return (0, m.createElement)(s, v.useBlockProps.save(), (0, m.createElement)(v.InnerBlocks.Content, null));
        };
        var m = c(1753),
            v = c(1326);
      },
      4224: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function CommentsQueryLoopToolbar(l) {
          var s = l.queryPerPage,
              c = l.setQuery;
          return (0, m.createElement)(v.ToolbarGroup, null, (0, m.createElement)(v.Dropdown, {
            renderToggle: function renderToggle(l) {
              var s = l.onToggle;
              return (0, m.createElement)(v.ToolbarButton, {
                icon: y.settings,
                label: (0, _.__)("Display settings"),
                onClick: s
              });
            },
            renderContent: function renderContent() {
              return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(v.BaseControl, null, (0, m.createElement)(v.__experimentalNumberControl, {
                __unstableInputWidth: "60px",
                label: (0, _.__)("Items per Page"),
                labelPosition: "edge",
                min: 1,
                max: 100,
                onChange: function onChange(l) {
                  var s = parseInt(l, 10);
                  isNaN(s) || s < 1 || s > 100 || c({
                    queryPerPage: s
                  });
                },
                step: "1",
                value: s,
                isDragEnabled: !1
              })));
            }
          }));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            y = c(5303);
      },
      9433: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = m(c(2703)),
            k = c(6700),
            E = c(1326),
            w = c(6756),
            C = c(3946);

        function dimRatioToClassV1(l) {
          return 0 !== l && 50 !== l && l ? "has-background-dim-" + 10 * Math.round(l / 10) : null;
        }

        function migrateDimRatio(l) {
          return _objectSpread(_objectSpread({}, l), {}, {
            dimRatio: l.url ? l.dimRatio : 100
          });
        }

        var S = {
          url: {
            type: "string"
          },
          id: {
            type: "number"
          },
          hasParallax: {
            type: "boolean",
            default: !1
          },
          dimRatio: {
            type: "number",
            default: 50
          },
          overlayColor: {
            type: "string"
          },
          customOverlayColor: {
            type: "string"
          },
          backgroundType: {
            type: "string",
            default: "image"
          },
          focalPoint: {
            type: "object"
          }
        };
        var P = [{
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            isRepeated: {
              type: "boolean",
              default: !1
            },
            minHeight: {
              type: "number"
            },
            minHeightUnit: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            customGradient: {
              type: "string"
            },
            contentPosition: {
              type: "string"
            },
            alt: {
              type: "string",
              source: "attribute",
              selector: "img",
              attribute: "alt",
              default: ""
            }
          }),
          supports: {
            anchor: !0,
            align: !0,
            html: !1,
            spacing: {
              padding: !0,
              __experimentalDefaultControls: {
                padding: !0
              }
            },
            color: {
              __experimentalDuotone: "> .wp-block-cover__image-background, > .wp-block-cover__video-background",
              text: !1,
              background: !1
            }
          },
          save: function save(l) {
            var _ref52;

            var s = l.attributes;

            var c = s.backgroundType,
                m = s.gradient,
                _ = s.contentPosition,
                k = s.customGradient,
                w = s.customOverlayColor,
                S = s.dimRatio,
                P = s.focalPoint,
                T = s.hasParallax,
                B = s.isRepeated,
                z = s.overlayColor,
                L = s.url,
                V = s.alt,
                A = s.id,
                R = s.minHeight,
                O = s.minHeightUnit,
                D = (0, E.getColorClassName)("background-color", z),
                F = (0, E.__experimentalGetGradientClass)(m),
                G = O ? "".concat(R).concat(O) : R,
                q = C.IMAGE_BACKGROUND_TYPE === c,
                W = C.VIDEO_BACKGROUND_TYPE === c,
                U = !(T || B),
                $ = _objectSpread(_objectSpread({}, q && !U ? (0, C.backgroundImageStyles)(L) : {}), {}, {
              backgroundColor: D ? void 0 : w,
              background: k && !L ? k : void 0,
              minHeight: G || void 0
            }),
                Z = P && U ? "".concat(Math.round(100 * P.x), "% ").concat(Math.round(100 * P.y), "%") : void 0,
                K = (0, y.default)(dimRatioToClassV1(S), D, (_ref52 = {
              "has-background-dim": 0 !== S,
              "has-parallax": T,
              "is-repeated": B,
              "has-background-gradient": m || k
            }, _defineProperty(_ref52, F, !L && F), _defineProperty(_ref52, "has-custom-content-position", !(0, C.isContentPositionCenter)(_)), _ref52), (0, C.getPositionClassName)(_));

            return (0, v.createElement)("div", E.useBlockProps.save({
              className: K,
              style: $
            }), L && (m || k) && 0 !== S && (0, v.createElement)("span", {
              "aria-hidden": "true",
              className: (0, y.default)("wp-block-cover__gradient-background", F),
              style: k ? {
                background: k
              } : void 0
            }), q && U && L && (0, v.createElement)("img", {
              className: (0, y.default)("wp-block-cover__image-background", A ? "wp-image-".concat(A) : null),
              alt: V,
              src: L,
              style: {
                objectPosition: Z
              },
              "data-object-fit": "cover",
              "data-object-position": Z
            }), W && L && (0, v.createElement)("video", {
              className: (0, y.default)("wp-block-cover__video-background", "intrinsic-ignore"),
              autoPlay: !0,
              muted: !0,
              loop: !0,
              playsInline: !0,
              src: L,
              style: {
                objectPosition: Z
              },
              "data-object-fit": "cover",
              "data-object-position": Z
            }), (0, v.createElement)("div", {
              className: "wp-block-cover__inner-container"
            }, (0, v.createElement)(E.InnerBlocks.Content, null)));
          },
          migrate: migrateDimRatio
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            isRepeated: {
              type: "boolean",
              default: !1
            },
            minHeight: {
              type: "number"
            },
            minHeightUnit: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            customGradient: {
              type: "string"
            },
            contentPosition: {
              type: "string"
            }
          }),
          supports: {
            align: !0
          },
          save: function save(l) {
            var _ref53;

            var s = l.attributes;
            var c = s.backgroundType,
                m = s.gradient,
                _ = s.contentPosition,
                k = s.customGradient,
                w = s.customOverlayColor,
                S = s.dimRatio,
                P = s.focalPoint,
                T = s.hasParallax,
                B = s.isRepeated,
                z = s.overlayColor,
                L = s.url,
                V = s.minHeight,
                A = s.minHeightUnit,
                R = (0, E.getColorClassName)("background-color", z),
                O = (0, E.__experimentalGetGradientClass)(m),
                D = A ? "".concat(V).concat(A) : V,
                F = C.IMAGE_BACKGROUND_TYPE === c,
                G = C.VIDEO_BACKGROUND_TYPE === c,
                q = F ? (0, C.backgroundImageStyles)(L) : {},
                W = {};
            var U;
            R || (q.backgroundColor = w), k && !L && (q.background = k), q.minHeight = D || void 0, P && (U = "".concat(Math.round(100 * P.x), "% ").concat(Math.round(100 * P.y), "%"), F && !T && (q.backgroundPosition = U), G && (W.objectPosition = U));
            var $ = (0, y.default)(dimRatioToClassV1(S), R, (_ref53 = {
              "has-background-dim": 0 !== S,
              "has-parallax": T,
              "is-repeated": B,
              "has-background-gradient": m || k
            }, _defineProperty(_ref53, O, !L && O), _defineProperty(_ref53, "has-custom-content-position", !(0, C.isContentPositionCenter)(_)), _ref53), (0, C.getPositionClassName)(_));
            return (0, v.createElement)("div", E.useBlockProps.save({
              className: $,
              style: q
            }), L && (m || k) && 0 !== S && (0, v.createElement)("span", {
              "aria-hidden": "true",
              className: (0, y.default)("wp-block-cover__gradient-background", O),
              style: k ? {
                background: k
              } : void 0
            }), G && L && (0, v.createElement)("video", {
              className: "wp-block-cover__video-background",
              autoPlay: !0,
              muted: !0,
              loop: !0,
              playsInline: !0,
              src: L,
              style: W
            }), (0, v.createElement)("div", {
              className: "wp-block-cover__inner-container"
            }, (0, v.createElement)(E.InnerBlocks.Content, null)));
          },
          migrate: migrateDimRatio
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            minHeight: {
              type: "number"
            },
            gradient: {
              type: "string"
            },
            customGradient: {
              type: "string"
            }
          }),
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundType,
                m = s.gradient,
                _ = s.customGradient,
                k = s.customOverlayColor,
                w = s.dimRatio,
                S = s.focalPoint,
                P = s.hasParallax,
                T = s.overlayColor,
                B = s.url,
                z = s.minHeight,
                L = (0, E.getColorClassName)("background-color", T),
                V = (0, E.__experimentalGetGradientClass)(m),
                A = c === C.IMAGE_BACKGROUND_TYPE ? (0, C.backgroundImageStyles)(B) : {};
            L || (A.backgroundColor = k), S && !P && (A.backgroundPosition = "".concat(Math.round(100 * S.x), "% ").concat(Math.round(100 * S.y), "%")), _ && !B && (A.background = _), A.minHeight = z || void 0;
            var R = (0, y.default)(dimRatioToClassV1(w), L, _defineProperty({
              "has-background-dim": 0 !== w,
              "has-parallax": P,
              "has-background-gradient": _
            }, V, !B && V));
            return (0, v.createElement)("div", {
              className: R,
              style: A
            }, B && (m || _) && 0 !== w && (0, v.createElement)("span", {
              "aria-hidden": "true",
              className: (0, y.default)("wp-block-cover__gradient-background", V),
              style: _ ? {
                background: _
              } : void 0
            }), C.VIDEO_BACKGROUND_TYPE === c && B && (0, v.createElement)("video", {
              className: "wp-block-cover__video-background",
              autoPlay: !0,
              muted: !0,
              loop: !0,
              src: B
            }), (0, v.createElement)("div", {
              className: "wp-block-cover__inner-container"
            }, (0, v.createElement)(E.InnerBlocks.Content, null)));
          },
          migrate: migrateDimRatio
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            minHeight: {
              type: "number"
            },
            gradient: {
              type: "string"
            },
            customGradient: {
              type: "string"
            }
          }),
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundType,
                m = s.gradient,
                _ = s.customGradient,
                k = s.customOverlayColor,
                w = s.dimRatio,
                S = s.focalPoint,
                P = s.hasParallax,
                T = s.overlayColor,
                B = s.url,
                z = s.minHeight,
                L = (0, E.getColorClassName)("background-color", T),
                V = (0, E.__experimentalGetGradientClass)(m),
                A = c === C.IMAGE_BACKGROUND_TYPE ? (0, C.backgroundImageStyles)(B) : {};
            L || (A.backgroundColor = k), S && !P && (A.backgroundPosition = "".concat(100 * S.x, "% ").concat(100 * S.y, "%")), _ && !B && (A.background = _), A.minHeight = z || void 0;
            var R = (0, y.default)(dimRatioToClassV1(w), L, _defineProperty({
              "has-background-dim": 0 !== w,
              "has-parallax": P,
              "has-background-gradient": _
            }, V, !B && V));
            return (0, v.createElement)("div", {
              className: R,
              style: A
            }, B && (m || _) && 0 !== w && (0, v.createElement)("span", {
              "aria-hidden": "true",
              className: (0, y.default)("wp-block-cover__gradient-background", V),
              style: _ ? {
                background: _
              } : void 0
            }), C.VIDEO_BACKGROUND_TYPE === c && B && (0, v.createElement)("video", {
              className: "wp-block-cover__video-background",
              autoPlay: !0,
              muted: !0,
              loop: !0,
              src: B
            }), (0, v.createElement)("div", {
              className: "wp-block-cover__inner-container"
            }, (0, v.createElement)(E.InnerBlocks.Content, null)));
          },
          migrate: migrateDimRatio
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            title: {
              type: "string",
              source: "html",
              selector: "p"
            },
            contentAlign: {
              type: "string",
              default: "center"
            }
          }),
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundType,
                m = s.contentAlign,
                _ = s.customOverlayColor,
                k = s.dimRatio,
                w = s.focalPoint,
                S = s.hasParallax,
                P = s.overlayColor,
                T = s.title,
                B = s.url,
                z = (0, E.getColorClassName)("background-color", P),
                L = c === C.IMAGE_BACKGROUND_TYPE ? (0, C.backgroundImageStyles)(B) : {};
            z || (L.backgroundColor = _), w && !S && (L.backgroundPosition = "".concat(100 * w.x, "% ").concat(100 * w.y, "%"));
            var V = (0, y.default)(dimRatioToClassV1(k), z, _defineProperty({
              "has-background-dim": 0 !== k,
              "has-parallax": S
            }, "has-".concat(m, "-content"), "center" !== m));
            return (0, v.createElement)("div", {
              className: V,
              style: L
            }, C.VIDEO_BACKGROUND_TYPE === c && B && (0, v.createElement)("video", {
              className: "wp-block-cover__video-background",
              autoPlay: !0,
              muted: !0,
              loop: !0,
              src: B
            }), !E.RichText.isEmpty(T) && (0, v.createElement)(E.RichText.Content, {
              tagName: "p",
              className: "wp-block-cover-text",
              value: T
            }));
          },
          migrate: function migrate(l) {
            var s = _objectSpread(_objectSpread({}, l), {}, {
              dimRatio: l.url ? l.dimRatio : 100
            });

            return [(0, _.omit)(s, ["title", "contentAlign"]), [(0, k.createBlock)("core/paragraph", {
              content: l.title,
              align: l.contentAlign,
              fontSize: "large",
              placeholder: (0, w.__)("Write title…")
            })]];
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            title: {
              type: "string",
              source: "html",
              selector: "p"
            },
            contentAlign: {
              type: "string",
              default: "center"
            },
            align: {
              type: "string"
            }
          }),
          supports: {
            className: !1
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.title,
                _ = s.hasParallax,
                k = s.dimRatio,
                w = s.align,
                S = s.contentAlign,
                P = s.overlayColor,
                T = s.customOverlayColor,
                B = (0, E.getColorClassName)("background-color", P),
                z = (0, C.backgroundImageStyles)(c);
            B || (z.backgroundColor = T);
            var L = (0, y.default)("wp-block-cover-image", dimRatioToClassV1(k), B, _defineProperty({
              "has-background-dim": 0 !== k,
              "has-parallax": _
            }, "has-".concat(S, "-content"), "center" !== S), w ? "align".concat(w) : null);
            return (0, v.createElement)("div", {
              className: L,
              style: z
            }, !E.RichText.isEmpty(m) && (0, v.createElement)(E.RichText.Content, {
              tagName: "p",
              className: "wp-block-cover-image-text",
              value: m
            }));
          },
          migrate: function migrate(l) {
            var s = _objectSpread(_objectSpread({}, l), {}, {
              dimRatio: l.url ? l.dimRatio : 100
            });

            return [(0, _.omit)(s, ["title", "contentAlign", "align"]), [(0, k.createBlock)("core/paragraph", {
              content: l.title,
              align: l.contentAlign,
              fontSize: "large",
              placeholder: (0, w.__)("Write title…")
            })]];
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, S), {}, {
            title: {
              type: "string",
              source: "html",
              selector: "h2"
            },
            align: {
              type: "string"
            },
            contentAlign: {
              type: "string",
              default: "center"
            }
          }),
          supports: {
            className: !1
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.title,
                _ = s.hasParallax,
                k = s.dimRatio,
                w = s.align,
                S = (0, C.backgroundImageStyles)(c),
                P = (0, y.default)("wp-block-cover-image", dimRatioToClassV1(k), {
              "has-background-dim": 0 !== k,
              "has-parallax": _
            }, w ? "align".concat(w) : null);
            return (0, v.createElement)("section", {
              className: P,
              style: S
            }, (0, v.createElement)(E.RichText.Content, {
              tagName: "h2",
              value: m
            }));
          },
          migrate: function migrate(l) {
            var s = _objectSpread(_objectSpread({}, l), {}, {
              dimRatio: l.url ? l.dimRatio : 100
            });

            return [(0, _.omit)(s, ["title", "contentAlign", "align"]), [(0, k.createBlock)("core/paragraph", {
              content: l.title,
              align: l.contentAlign,
              fontSize: "large",
              placeholder: (0, w.__)("Write title…")
            })]];
          }
        }];
        s.default = P;
      },
      26: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = m(c(2689)),
            E = c(7270),
            w = m(c(9785)),
            C = c(4892),
            S = c(3200),
            P = c(1326),
            T = c(6756),
            B = c(8467),
            z = c(5303),
            L = c(9388),
            V = c(3946);

        (0, E.extend)([w.default]);
        var A = C.__experimentalBoxControl.__Visualizer;

        function retrieveFastAverageColor() {
          return retrieveFastAverageColor.fastAverageColor || (retrieveFastAverageColor.fastAverageColor = new k.default()), retrieveFastAverageColor.fastAverageColor;
        }

        function CoverHeightInput(l) {
          var s = l.onChange,
              c = l.onUnitChange,
              _l$unit = l.unit,
              m = _l$unit === void 0 ? "px" : _l$unit,
              _l$value = l.value,
              _ = _l$value === void 0 ? "" : _l$value;

          var _ref58 = (0, v.useState)(null),
              _ref59 = _slicedToArray2(_ref58, 2),
              y = _ref59[0],
              k = _ref59[1],
              E = "block-cover-height-input-".concat((0, S.useInstanceId)(P.__experimentalUnitControl)),
              w = "px" === m,
              B = (0, C.__experimentalUseCustomUnits)({
            availableUnits: (0, P.useSetting)("spacing.units") || ["px", "em", "rem", "vw", "vh"],
            defaultValues: {
              px: "430",
              em: "20",
              rem: "20",
              vw: "20",
              vh: "50"
            }
          }),
              z = null !== y ? y : _,
              L = w ? V.COVER_MIN_HEIGHT : 0;

          return (0, v.createElement)(C.BaseControl, {
            label: (0, T.__)("Minimum height of cover"),
            id: E
          }, (0, v.createElement)(P.__experimentalUnitControl, {
            id: E,
            isResetValueOnUnitChange: !0,
            min: L,
            onBlur: function onBlur() {
              null !== y && k(null);
            },
            onChange: function onChange(l) {
              var m = "" !== l ? parseFloat(l) : void 0;
              isNaN(m) && void 0 !== m ? k(l) : (k(null), s(m), void 0 === m && c());
            },
            onUnitChange: c,
            style: {
              maxWidth: 80
            },
            unit: m,
            units: B,
            value: z
          }));
        }

        var R = {
          top: !1,
          right: !1,
          bottom: !0,
          left: !1,
          topRight: !1,
          bottomRight: !1,
          bottomLeft: !1,
          topLeft: !1
        };

        function ResizableCover(l) {
          var s = l.className,
              c = l.onResizeStart,
              m = l.onResize,
              k = l.onResizeStop,
              E = _objectWithoutProperties(l, _excluded3);

          var _ref60 = (0, v.useState)(!1),
              _ref61 = _slicedToArray2(_ref60, 2),
              w = _ref61[0],
              S = _ref61[1];

          return (0, v.createElement)(C.ResizableBox, (0, _.default)({
            className: (0, y.default)(s, {
              "is-resizing": w
            }),
            enable: R,
            onResizeStart: function onResizeStart(l, s, v) {
              c(v.clientHeight), m(v.clientHeight);
            },
            onResize: function onResize(l, s, c) {
              m(c.clientHeight), w || S(!0);
            },
            onResizeStop: function onResizeStop(l, s, c) {
              k(c.clientHeight), S(!1);
            }
          }, E));
        }

        function mediaPosition(l) {
          var s = l.x,
              c = l.y;
          return "".concat(Math.round(100 * s), "% ").concat(Math.round(100 * c), "%");
        }

        function CoverPlaceholder(l) {
          var _l$disableMediaButton = l.disableMediaButtons,
              s = _l$disableMediaButton === void 0 ? !1 : _l$disableMediaButton,
              c = l.children,
              m = l.noticeUI,
              _ = l.noticeOperations,
              y = l.onSelectMedia,
              k = l.style;
          var E = _.removeAllNotices,
              w = _.createErrorNotice;
          return (0, v.createElement)(P.MediaPlaceholder, {
            icon: (0, v.createElement)(P.BlockIcon, {
              icon: z.cover
            }),
            labels: {
              title: (0, T.__)("Cover"),
              instructions: (0, T.__)("Drag and drop onto this block, upload, or select existing media from your library.")
            },
            onSelect: y,
            accept: "image/*,video/*",
            allowedTypes: V.ALLOWED_MEDIA_TYPES,
            notices: m,
            disableMediaButtons: s,
            onError: function onError(l) {
              E(), w(l);
            },
            style: k
          }, c);
        }

        var O = (0, S.compose)([(0, B.withDispatch)(function (l) {
          var _l19 = l(P.store),
              s = _l19.toggleSelection,
              c = _l19.__unstableMarkNextChangeAsNotPersistent;

          return {
            toggleSelection: s,
            markNextChangeAsNotPersistent: c
          };
        }), (0, P.withColors)({
          overlayColor: "background-color"
        }), C.withNotices, S.withInstanceId])(function CoverEdit(l) {
          var s, c, m;
          var k = l.attributes,
              w = l.clientId,
              S = l.isSelected,
              z = l.noticeUI,
              R = l.noticeOperations,
              O = l.overlayColor,
              D = l.setAttributes,
              F = l.setOverlayColor,
              G = l.toggleSelection,
              q = l.markNextChangeAsNotPersistent;

          var W = k.contentPosition,
              U = k.id,
              $ = k.backgroundType,
              Z = k.dimRatio,
              K = k.focalPoint,
              Q = k.hasParallax,
              Y = k.isDark,
              X = k.isRepeated,
              J = k.minHeight,
              ee = k.minHeightUnit,
              te = k.style,
              re = k.url,
              ae = k.alt,
              oe = k.allowedBlocks,
              ne = k.templateLock,
              _ref62 = (0, P.__experimentalUseGradient)(),
              le = _ref62.gradientClass,
              ie = _ref62.gradientValue,
              se = _ref62.setGradient,
              ce = (0, V.attributesFromMedia)(D, Z),
              ue = function (l, s) {
            return !l && (0, L.isBlobURL)(s);
          }(U, re),
              _ref63 = (0, v.useState)(J),
              _ref64 = _slicedToArray2(_ref63, 2),
              de = _ref64[0],
              me = _ref64[1],
              _ref65 = (0, v.useState)(ee),
              _ref66 = _slicedToArray2(_ref65, 2),
              pe = _ref66[0],
              ge = _ref66[1],
              ve = "vh" === ee && 100 === J,
              he = (0, v.useRef)(),
              be = function useCoverIsDark(l) {
            var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50,
                c = arguments.length > 2 ? arguments[2] : void 0,
                m = arguments.length > 3 ? arguments[3] : void 0;

            var _ref67 = (0, v.useState)(!1),
                _ref68 = _slicedToArray2(_ref67, 2),
                _ = _ref68[0],
                y = _ref68[1];

            return (0, v.useEffect)(function () {
              l && s <= 50 && m.current && retrieveFastAverageColor().getColorAsync(m.current, function (l) {
                y(l.isDark);
              });
            }, [l, l && s <= 50 && m.current, y]), (0, v.useEffect)(function () {
              if (s > 50 || !l) {
                if (!c) return void y(!0);
                y((0, E.colord)(c).isDark());
              }
            }, [c, s > 50 || !l, y]), (0, v.useEffect)(function () {
              l || c || y(!1);
            }, [!l && !c, y]), _;
          }(re, Z, O.color, he);

          (0, v.useEffect)(function () {
            q(), D({
              isDark: be
            });
          }, [be]);

          var _e = V.IMAGE_BACKGROUND_TYPE === $,
              fe = V.VIDEO_BACKGROUND_TYPE === $,
              _ref69 = (0, v.useState)(null),
              _ref70 = _slicedToArray2(_ref69, 2),
              ye = _ref70[0],
              ke = _ref70[1],
              Ee = ee ? "".concat(J).concat(ee) : J,
              we = !(Q || X),
              Ce = _objectSpread(_objectSpread({}, _e && !we ? (0, V.backgroundImageStyles)(re) : void 0), {}, {
            minHeight: ye || Ee || void 0
          }),
              xe = {
            backgroundColor: O.color
          },
              Se = {
            objectPosition: K && we ? mediaPosition(K) : void 0
          },
              Pe = !!(re || O.color || ie),
              Te = fe || _e && (!Q || X),
              imperativeFocalPointPreview = function imperativeFocalPointPreview(l) {
            var _ref71 = he.current ? [he.current.style, "objectPosition"] : [Ie.current.style, "backgroundPosition"],
                _ref72 = _slicedToArray2(_ref71, 2),
                s = _ref72[0],
                c = _ref72[1];

            s[c] = mediaPosition(l);
          },
              Me = (0, B.useSelect)(function (l) {
            return l(P.store).getBlock(w).innerBlocks.length > 0;
          }, [w]),
              Be = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(P.BlockControls, {
            group: "block"
          }, (0, v.createElement)(P.__experimentalBlockAlignmentMatrixControl, {
            label: (0, T.__)("Change content position"),
            value: W,
            onChange: function onChange(l) {
              return D({
                contentPosition: l
              });
            },
            isDisabled: !Me
          }), (0, v.createElement)(P.__experimentalBlockFullHeightAligmentControl, {
            isActive: ve,
            onToggle: function onToggle() {
              return ve ? D("vh" === pe && 100 === de ? {
                minHeight: void 0,
                minHeightUnit: void 0
              } : {
                minHeight: de,
                minHeightUnit: pe
              }) : (me(J), ge(ee), D({
                minHeight: 100,
                minHeightUnit: "vh"
              }));
            },
            isDisabled: !Me
          })), (0, v.createElement)(P.BlockControls, {
            group: "other"
          }, (0, v.createElement)(P.MediaReplaceFlow, {
            mediaId: U,
            mediaURL: re,
            allowedTypes: V.ALLOWED_MEDIA_TYPES,
            accept: "image/*,video/*",
            onSelect: ce,
            name: re ? (0, T.__)("Replace") : (0, T.__)("Add Media")
          })), (0, v.createElement)(P.InspectorControls, null, !!re && (0, v.createElement)(C.PanelBody, {
            title: (0, T.__)("Media settings")
          }, _e && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.ToggleControl, {
            label: (0, T.__)("Fixed background"),
            checked: Q,
            onChange: function onChange() {
              D(_objectSpread({
                hasParallax: !Q
              }, Q ? {} : {
                focalPoint: void 0
              }));
            }
          }), (0, v.createElement)(C.ToggleControl, {
            label: (0, T.__)("Repeated background"),
            checked: X,
            onChange: function onChange() {
              D({
                isRepeated: !X
              });
            }
          })), Te && (0, v.createElement)(C.FocalPointPicker, {
            label: (0, T.__)("Focal point picker"),
            url: re,
            value: K,
            onDragStart: imperativeFocalPointPreview,
            onDrag: imperativeFocalPointPreview,
            onChange: function onChange(l) {
              return D({
                focalPoint: l
              });
            }
          }), re && _e && we && (0, v.createElement)(C.TextareaControl, {
            label: (0, T.__)("Alt text (alternative text)"),
            value: ae,
            onChange: function onChange(l) {
              return D({
                alt: l
              });
            },
            help: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.ExternalLink, {
              href: "https://www.w3.org/WAI/tutorials/images/decision-tree"
            }, (0, T.__)("Describe the purpose of the image")), (0, T.__)("Leave empty if the image is purely decorative."))
          }), (0, v.createElement)(C.PanelRow, null, (0, v.createElement)(C.Button, {
            variant: "secondary",
            isSmall: !0,
            className: "block-library-cover__reset-button",
            onClick: function onClick() {
              return D({
                url: void 0,
                id: void 0,
                backgroundType: void 0,
                focalPoint: void 0,
                hasParallax: void 0,
                isRepeated: void 0
              });
            }
          }, (0, T.__)("Clear Media")))), (0, v.createElement)(P.__experimentalPanelColorGradientSettings, {
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0,
            title: (0, T.__)("Overlay"),
            initialOpen: !0,
            settings: [{
              colorValue: O.color,
              gradientValue: ie,
              onColorChange: F,
              onGradientChange: se,
              label: (0, T.__)("Color")
            }]
          }, (0, v.createElement)(C.RangeControl, {
            label: (0, T.__)("Opacity"),
            value: Z,
            onChange: function onChange(l) {
              return D({
                dimRatio: l
              });
            },
            min: 0,
            max: 100,
            step: 10,
            required: !0
          }))), (0, v.createElement)(P.InspectorControls, {
            __experimentalGroup: "dimensions"
          }, (0, v.createElement)(C.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return !!J;
            },
            label: (0, T.__)("Minimum height"),
            onDeselect: function onDeselect() {
              return D({
                minHeight: void 0,
                minHeightUnit: void 0
              });
            },
            resetAllFilter: function resetAllFilter() {
              return {
                minHeight: void 0,
                minHeightUnit: void 0
              };
            },
            isShownByDefault: !0,
            panelId: w
          }, (0, v.createElement)(CoverHeightInput, {
            value: ye || J,
            unit: ee,
            onChange: function onChange(l) {
              return D({
                minHeight: l
              });
            },
            onUnitChange: function onUnitChange(l) {
              return D({
                minHeightUnit: l
              });
            }
          })))),
              Ie = (0, v.useRef)(),
              Ne = (0, P.useBlockProps)({
            ref: Ie
          }),
              ze = function getInnerBlocksTemplate(l) {
            return [["core/paragraph", _objectSpread({
              align: "center",
              placeholder: (0, T.__)("Write title…")
            }, l)]];
          }({
            fontSize: !(null === (s = (0, P.useSetting)("typography.fontSizes")) || void 0 === s || !s.length) ? "large" : void 0
          }),
              Le = (0, P.useInnerBlocksProps)({
            className: "wp-block-cover__inner-container"
          }, {
            template: ze,
            templateInsertUpdatesSelection: !0,
            allowedBlocks: oe,
            templateLock: ne
          });

          if (!Me && !Pe) return (0, v.createElement)(v.Fragment, null, Be, (0, v.createElement)("div", (0, _.default)({}, Ne, {
            className: (0, y.default)("is-placeholder", Ne.className)
          }), (0, v.createElement)(CoverPlaceholder, {
            noticeUI: z,
            onSelectMedia: ce,
            noticeOperations: R,
            style: {
              minHeight: ye || Ee || void 0
            }
          }, (0, v.createElement)("div", {
            className: "wp-block-cover__placeholder-background-options"
          }, (0, v.createElement)(P.ColorPalette, {
            disableCustomColors: !0,
            value: O.color,
            onChange: F,
            clearable: !1
          }))), (0, v.createElement)(ResizableCover, {
            className: "block-library-cover__resize-container",
            onResizeStart: function onResizeStart() {
              D({
                minHeightUnit: "px"
              }), G(!1);
            },
            onResize: ke,
            onResizeStop: function onResizeStop(l) {
              G(!0), D({
                minHeight: l
              }), ke(null);
            },
            showHandle: S
          })));
          var Ve = (0, y.default)({
            "is-dark-theme": Y,
            "is-light": !Y,
            "is-transient": ue,
            "has-parallax": Q,
            "is-repeated": X,
            "has-custom-content-position": !(0, V.isContentPositionCenter)(W)
          }, (0, V.getPositionClassName)(W));
          return (0, v.createElement)(v.Fragment, null, Be, (0, v.createElement)("div", (0, _.default)({}, Ne, {
            className: (0, y.default)(Ve, Ne.className),
            style: _objectSpread(_objectSpread({}, Ce), Ne.style),
            "data-url": re
          }), (0, v.createElement)(A, {
            values: null == te || null === (c = te.spacing) || void 0 === c ? void 0 : c.padding,
            showValues: null == te || null === (m = te.visualizers) || void 0 === m ? void 0 : m.padding
          }), (0, v.createElement)(ResizableCover, {
            className: "block-library-cover__resize-container",
            onResizeStart: function onResizeStart() {
              D({
                minHeightUnit: "px"
              }), G(!1);
            },
            onResize: ke,
            onResizeStop: function onResizeStop(l) {
              G(!0), D({
                minHeight: l
              }), ke(null);
            },
            showHandle: S
          }), (0, v.createElement)("span", {
            "aria-hidden": "true",
            className: (0, y.default)((0, V.dimRatioToClass)(Z), _defineProperty({}, O.class, O.class), "wp-block-cover__gradient-background", le, _defineProperty({
              "has-background-dim": void 0 !== Z,
              "has-background-gradient": ie
            }, le, !re && le)),
            style: _objectSpread({
              backgroundImage: ie
            }, xe)
          }), re && _e && we && (0, v.createElement)("img", {
            ref: he,
            className: "wp-block-cover__image-background",
            alt: ae,
            src: re,
            style: Se
          }), re && fe && (0, v.createElement)("video", {
            ref: he,
            className: "wp-block-cover__video-background",
            autoPlay: !0,
            muted: !0,
            loop: !0,
            src: re,
            style: Se
          }), ue && (0, v.createElement)(C.Spinner, null), (0, v.createElement)(CoverPlaceholder, {
            disableMediaButtons: !0,
            noticeUI: z,
            onSelectMedia: ce,
            noticeOperations: R
          }), (0, v.createElement)("div", Le)));
        });
        s.default = O;
      },
      7260: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(9433)),
            k = m(c(26)),
            E = m(c(9607)),
            w = m(c(2271));

        var C = {
          apiVersion: 2,
          name: "core/cover",
          title: "Cover",
          category: "media",
          description: "Add an image or video with a text overlay — great for headers.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            id: {
              type: "number"
            },
            alt: {
              type: "string",
              source: "attribute",
              selector: "img",
              attribute: "alt",
              default: ""
            },
            hasParallax: {
              type: "boolean",
              default: !1
            },
            isRepeated: {
              type: "boolean",
              default: !1
            },
            dimRatio: {
              type: "number",
              default: 100
            },
            overlayColor: {
              type: "string"
            },
            customOverlayColor: {
              type: "string"
            },
            backgroundType: {
              type: "string",
              default: "image"
            },
            focalPoint: {
              type: "object"
            },
            minHeight: {
              type: "number"
            },
            minHeightUnit: {
              type: "string"
            },
            gradient: {
              type: "string"
            },
            customGradient: {
              type: "string"
            },
            contentPosition: {
              type: "string"
            },
            isDark: {
              type: "boolean",
              default: !0
            },
            allowedBlocks: {
              type: "array"
            },
            templateLock: {
              type: ["string", "boolean"],
              enum: ["all", "insert", !1]
            }
          },
          supports: {
            anchor: !0,
            align: !0,
            html: !1,
            spacing: {
              padding: !0,
              __experimentalDefaultControls: {
                padding: !0
              }
            },
            color: {
              __experimentalDuotone: "> .wp-block-cover__image-background, > .wp-block-cover__video-background",
              text: !1,
              background: !1
            }
          },
          editorStyle: "wp-block-cover-editor",
          style: "wp-block-cover"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.cover,
          example: {
            attributes: {
              customOverlayColor: "#065174",
              dimRatio: 40,
              url: "https://s.w.org/images/core/5.3/Windbuchencom.jpg"
            },
            innerBlocks: [{
              name: "core/paragraph",
              attributes: {
                customFontSize: 48,
                content: (0, v.__)("<strong>Snow Patrol</strong>"),
                align: "center"
              }
            }]
          },
          transforms: w.default,
          save: E.default,
          edit: k.default,
          deprecated: y.default
        };
        s.settings = P;
      },
      9607: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;

          var c = s.backgroundType,
              m = s.gradient,
              E = s.contentPosition,
              w = s.customGradient,
              C = s.customOverlayColor,
              S = s.dimRatio,
              P = s.focalPoint,
              T = s.hasParallax,
              B = s.isDark,
              z = s.isRepeated,
              L = s.overlayColor,
              V = s.url,
              A = s.alt,
              R = s.id,
              O = s.minHeight,
              D = s.minHeightUnit,
              F = (0, y.getColorClassName)("background-color", L),
              G = (0, y.__experimentalGetGradientClass)(m),
              q = D ? "".concat(O).concat(D) : O,
              W = k.IMAGE_BACKGROUND_TYPE === c,
              U = k.VIDEO_BACKGROUND_TYPE === c,
              $ = !(T || z),
              Z = _objectSpread(_objectSpread({}, W && !$ ? (0, k.backgroundImageStyles)(V) : {}), {}, {
            minHeight: q || void 0
          }),
              K = {
            backgroundColor: F ? void 0 : C,
            background: w || void 0
          },
              Q = P && $ ? "".concat(Math.round(100 * P.x), "% ").concat(Math.round(100 * P.y), "%") : void 0,
              Y = (0, _.default)({
            "is-light": !B,
            "has-parallax": T,
            "is-repeated": z,
            "has-custom-content-position": !(0, k.isContentPositionCenter)(E)
          }, (0, k.getPositionClassName)(E));

          return (0, v.createElement)("div", y.useBlockProps.save({
            className: Y,
            style: Z
          }), (0, v.createElement)("span", {
            "aria-hidden": "true",
            className: (0, _.default)(F, (0, k.dimRatioToClass)(S), "wp-block-cover__gradient-background", G, _defineProperty({
              "has-background-dim": void 0 !== S,
              "has-background-gradient": m || w
            }, G, !V && G)),
            style: K
          }), W && $ && V && (0, v.createElement)("img", {
            className: (0, _.default)("wp-block-cover__image-background", R ? "wp-image-".concat(R) : null),
            alt: A,
            src: V,
            style: {
              objectPosition: Q
            },
            "data-object-fit": "cover",
            "data-object-position": Q
          }), U && V && (0, v.createElement)("video", {
            className: (0, _.default)("wp-block-cover__video-background", "intrinsic-ignore"),
            autoPlay: !0,
            muted: !0,
            loop: !0,
            playsInline: !0,
            src: V,
            style: {
              objectPosition: Q
            },
            "data-object-fit": "cover",
            "data-object-position": Q
          }), (0, v.createElement)("div", y.useInnerBlocksProps.save({
            className: "wp-block-cover__inner-container"
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(3946);
      },
      3946: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.VIDEO_BACKGROUND_TYPE = s.IMAGE_BACKGROUND_TYPE = s.COVER_MIN_HEIGHT = s.COVER_MAX_HEIGHT = s.COVER_DEFAULT_HEIGHT = s.ALLOWED_MEDIA_TYPES = void 0, s.attributesFromMedia = function attributesFromMedia(l, s) {
          return function (c) {
            if (!c || !c.url) return void l({
              url: void 0,
              id: void 0
            });
            var v;
            if ((0, m.isBlobURL)(c.url) && (c.type = (0, m.getBlobTypeByURL)(c.url)), c.media_type) v = c.media_type === _ ? _ : y;else {
              if (c.type !== _ && c.type !== y) return;
              v = c.type;
            }
            l(_objectSpread({
              dimRatio: 100 === s ? 50 : s,
              url: c.url,
              id: c.id,
              alt: null == c ? void 0 : c.alt,
              backgroundType: v
            }, v === y ? {
              focalPoint: void 0,
              hasParallax: void 0
            } : {}));
          };
        }, s.backgroundImageStyles = function backgroundImageStyles(l) {
          return l ? {
            backgroundImage: "url(".concat(l, ")")
          } : {};
        }, s.dimRatioToClass = function dimRatioToClass(l) {
          return 50 === l || void 0 === !l ? null : "has-background-dim-" + 10 * Math.round(l / 10);
        }, s.getPositionClassName = function getPositionClassName(l) {
          return isContentPositionCenter(l) ? "" : v[l];
        }, s.isContentPositionCenter = isContentPositionCenter;
        var m = c(9388);
        var v = {
          "top left": "is-position-top-left",
          "top center": "is-position-top-center",
          "top right": "is-position-top-right",
          "center left": "is-position-center-left",
          "center center": "is-position-center-center",
          center: "is-position-center-center",
          "center right": "is-position-center-right",
          "bottom left": "is-position-bottom-left",
          "bottom center": "is-position-bottom-center",
          "bottom right": "is-position-bottom-right"
        },
            _ = "image";
        s.IMAGE_BACKGROUND_TYPE = _;
        var y = "video";
        s.VIDEO_BACKGROUND_TYPE = y;
        s.COVER_MIN_HEIGHT = 50;
        s.COVER_MAX_HEIGHT = 1e3;
        s.COVER_DEFAULT_HEIGHT = 300;

        function isContentPositionCenter(l) {
          return !l || "center center" === l || "center" === l;
        }

        s.ALLOWED_MEDIA_TYPES = ["image", "video"];
      },
      2271: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(3946);
        var _ = {
          from: [{
            type: "block",
            blocks: ["core/image"],
            transform: function transform(l) {
              var s;
              var c = l.caption,
                  v = l.url,
                  _ = l.alt,
                  y = l.align,
                  k = l.id,
                  E = l.anchor,
                  w = l.style;
              return (0, m.createBlock)("core/cover", {
                dimRatio: 50,
                url: v,
                alt: _,
                align: y,
                id: k,
                anchor: E,
                style: {
                  color: {
                    duotone: null == w || null === (s = w.color) || void 0 === s ? void 0 : s.duotone
                  }
                }
              }, [(0, m.createBlock)("core/paragraph", {
                content: c,
                fontSize: "large"
              })]);
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            transform: function transform(l) {
              var s = l.caption,
                  c = l.src,
                  _ = l.align,
                  y = l.id,
                  k = l.anchor;
              return (0, m.createBlock)("core/cover", {
                dimRatio: 50,
                url: c,
                align: _,
                id: y,
                backgroundType: v.VIDEO_BACKGROUND_TYPE,
                anchor: k
              }, [(0, m.createBlock)("core/paragraph", {
                content: s,
                fontSize: "large"
              })]);
            }
          }, {
            type: "block",
            blocks: ["core/group"],
            isMatch: function isMatch(l) {
              var s, c;
              var m = l.backgroundColor,
                  v = l.gradient,
                  _ = l.style;
              return m || (null == _ || null === (s = _.color) || void 0 === s ? void 0 : s.background) || (null == _ || null === (c = _.color) || void 0 === c ? void 0 : c.gradient) || v;
            },
            transform: function transform(l, s) {
              var c, v;
              var _ = l.align,
                  y = l.anchor,
                  k = l.backgroundColor,
                  E = l.gradient,
                  w = l.style;
              return (0, m.createBlock)("core/cover", {
                align: _,
                anchor: y,
                overlayColor: k,
                customOverlayColor: null == w || null === (c = w.color) || void 0 === c ? void 0 : c.background,
                gradient: E,
                customGradient: null == w || null === (v = w.color) || void 0 === v ? void 0 : v.gradient
              }, s);
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/image"],
            isMatch: function isMatch(l) {
              var s = l.backgroundType,
                  c = l.url,
                  m = l.overlayColor,
                  _ = l.customOverlayColor,
                  y = l.gradient,
                  k = l.customGradient;
              return c ? s === v.IMAGE_BACKGROUND_TYPE : !(m || _ || y || k);
            },
            transform: function transform(l) {
              var s;
              var c = l.title,
                  v = l.url,
                  _ = l.alt,
                  y = l.align,
                  k = l.id,
                  E = l.anchor,
                  w = l.style;
              return (0, m.createBlock)("core/image", {
                caption: c,
                url: v,
                alt: _,
                align: y,
                id: k,
                anchor: E,
                style: {
                  color: {
                    duotone: null == w || null === (s = w.color) || void 0 === s ? void 0 : s.duotone
                  }
                }
              });
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            isMatch: function isMatch(l) {
              var s = l.backgroundType,
                  c = l.url,
                  m = l.overlayColor,
                  _ = l.customOverlayColor,
                  y = l.gradient,
                  k = l.customGradient;
              return c ? s === v.VIDEO_BACKGROUND_TYPE : !(m || _ || y || k);
            },
            transform: function transform(l) {
              var s = l.title,
                  c = l.url,
                  v = l.align,
                  _ = l.id,
                  y = l.anchor;
              return (0, m.createBlock)("core/video", {
                caption: s,
                src: c,
                id: _,
                align: v,
                anchor: y
              });
            }
          }]
        };
        s.default = _;
      },
      3611: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.WP_EMBED_TYPE = s.ASPECT_RATIOS = void 0;
        s.ASPECT_RATIOS = [{
          ratio: "2.33",
          className: "wp-embed-aspect-21-9"
        }, {
          ratio: "2.00",
          className: "wp-embed-aspect-18-9"
        }, {
          ratio: "1.78",
          className: "wp-embed-aspect-16-9"
        }, {
          ratio: "1.33",
          className: "wp-embed-aspect-4-3"
        }, {
          ratio: "1.00",
          className: "wp-embed-aspect-1-1"
        }, {
          ratio: "0.56",
          className: "wp-embed-aspect-9-16"
        }, {
          ratio: "0.50",
          className: "wp-embed-aspect-1-2"
        }];
        s.WP_EMBED_TYPE = "wp-embed";
      },
      5329: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var _apiVersion$name$titl2 = {
          apiVersion: 2,
          name: "core/embed",
          title: "Embed",
          category: "embed",
          description: "Add a block that displays content pulled from other sites, like Twitter or YouTube.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            type: {
              type: "string"
            },
            providerNameSlug: {
              type: "string"
            },
            allowResponsive: {
              type: "boolean",
              default: !0
            },
            responsive: {
              type: "boolean",
              default: !1
            },
            previewable: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: !0
          },
          editorStyle: "wp-block-embed-editor",
          style: "wp-block-embed"
        },
            k = _apiVersion$name$titl2.attributes;
        var E = [{
          attributes: k,
          save: function save(l) {
            var _ref76;

            var _l$attributes7 = l.attributes,
                s = _l$attributes7.url,
                c = _l$attributes7.caption,
                m = _l$attributes7.type,
                k = _l$attributes7.providerNameSlug;
            if (!s) return null;
            var E = (0, _.default)("wp-block-embed", (_ref76 = {}, _defineProperty(_ref76, "is-type-".concat(m), m), _defineProperty(_ref76, "is-provider-".concat(k), k), _ref76));
            return (0, v.createElement)("figure", {
              className: E
            }, "\n".concat(s, "\n"), !y.RichText.isEmpty(c) && (0, v.createElement)(y.RichText.Content, {
              tagName: "figcaption",
              value: c
            }));
          }
        }];
        s.default = E;
      },
      2255: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4e3),
            y = m(c(6439)),
            k = c(8245),
            E = m(c(1917)),
            w = m(c(5880)),
            C = m(c(8809)),
            S = m(c(2703)),
            P = c(6756),
            T = c(8467),
            B = c(1326),
            z = c(1295),
            L = c(1666);

        var _default = function _default(l) {
          var _l$attributes8 = l.attributes,
              s = _l$attributes8.providerNameSlug,
              c = _l$attributes8.previewable,
              m = _l$attributes8.responsive,
              V = _l$attributes8.url,
              A = l.attributes,
              R = l.isSelected,
              O = l.onReplace,
              D = l.setAttributes,
              F = l.insertBlocksAfter,
              G = l.onFocus,
              q = {
            title: (0, P._x)("Embed", "block title"),
            icon: k.embedContentIcon
          },
              _ref77 = (0, _.getEmbedInfoByProvider)(s) || q,
              W = _ref77.icon,
              U = _ref77.title,
              _ref78 = (0, v.useState)(V),
              _ref79 = _slicedToArray2(_ref78, 2),
              $ = _ref79[0],
              Z = _ref79[1],
              _ref80 = (0, v.useState)(!1),
              _ref81 = _slicedToArray2(_ref80, 2),
              K = _ref81[0],
              Q = _ref81[1],
              _ref82 = (0, T.useDispatch)(z.store),
              Y = _ref82.invalidateResolution,
              _ref83 = (0, T.useSelect)(function (l) {
            var s;

            var _l20 = l(z.store),
                c = _l20.getEmbedPreview,
                m = _l20.isPreviewEmbedFallback,
                v = _l20.isRequestingEmbedPreview,
                _ = _l20.getThemeSupports;

            if (!V) return {
              fetching: !1,
              cannotEmbed: !1
            };
            var y = c(V),
                k = m(V),
                E = !1 === (null == y ? void 0 : y.html) && void 0 === (null == y ? void 0 : y.type),
                w = 404 === (null == y || null === (s = y.data) || void 0 === s ? void 0 : s.status),
                C = !!y && !E && !w;
            return {
              preview: C ? y : void 0,
              fetching: v(V),
              themeSupportsResponsive: _()["responsive-embeds"],
              cannotEmbed: !C || k
            };
          }, [V]),
              X = _ref83.preview,
              J = _ref83.fetching,
              ee = _ref83.themeSupportsResponsive,
              te = _ref83.cannotEmbed,
              getMergedAttributes = function getMergedAttributes() {
            var l = A.allowResponsive,
                s = A.className;
            return _objectSpread(_objectSpread({}, A), (0, _.getAttributesFromPreview)(X, U, s, m, l));
          };

          (0, v.useEffect)(function () {
            if (null == X || !X.html || !te || J) return;
            var l = V.replace(/\/$/, "");
            Z(l), Q(!1), D({
              url: l
            });
          }, [null == X ? void 0 : X.html, V]), (0, v.useEffect)(function () {
            if (X && !K && (D(getMergedAttributes()), O)) {
              var _s4 = (0, _.createUpgradedEmbedBlock)(l, getMergedAttributes());

              _s4 && O(_s4);
            }
          }, [X, K]);
          var re = (0, B.useBlockProps)();
          if (J) return (0, v.createElement)(L.View, re, (0, v.createElement)(E.default, null));
          var ae = (0, P.sprintf)((0, P.__)("%s URL"), U);
          if (!X || te || K) return (0, v.createElement)(L.View, re, (0, v.createElement)(w.default, {
            icon: W,
            label: ae,
            onFocus: G,
            onSubmit: function onSubmit(l) {
              l && l.preventDefault(), Q(!1), D({
                url: $
              });
            },
            value: $,
            cannotEmbed: te,
            onChange: function onChange(l) {
              return Z(l.target.value);
            },
            fallback: function fallback() {
              return (0, _.fallback)($, O);
            },
            tryAgain: function tryAgain() {
              Y("getEmbedPreview", [$]);
            }
          }));

          var _getMergedAttributes = getMergedAttributes(),
              oe = _getMergedAttributes.caption,
              ne = _getMergedAttributes.type,
              le = _getMergedAttributes.allowResponsive,
              ie = _getMergedAttributes.className,
              se = (0, S.default)(ie, l.className);

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.default, {
            showEditButton: X && !te,
            themeSupportsResponsive: ee,
            blockSupportsResponsive: m,
            allowResponsive: le,
            toggleResponsive: function toggleResponsive() {
              var l = A.allowResponsive,
                  s = A.className,
                  c = X.html,
                  v = !l;
              D({
                allowResponsive: v,
                className: (0, _.getClassNames)(c, s, m && v)
              });
            },
            switchBackToURLInput: function switchBackToURLInput() {
              return Q(!0);
            }
          }), (0, v.createElement)(L.View, re, (0, v.createElement)(C.default, {
            preview: X,
            previewable: c,
            className: se,
            url: $,
            type: ne,
            caption: oe,
            onCaptionChange: function onCaptionChange(l) {
              return D({
                caption: l
              });
            },
            isSelected: R,
            icon: W,
            label: ae,
            insertBlocksAfter: F
          })));
        };

        s.default = _default;
      },
      6439: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(1326),
            k = c(5303);

        function getResponsiveHelp(l) {
          return l ? (0, v.__)("This embed will preserve its aspect ratio when the browser is resized.") : (0, v.__)("This embed may not preserve its aspect ratio when the browser is resized.");
        }

        var _default = function _default(l) {
          var s = l.blockSupportsResponsive,
              c = l.showEditButton,
              E = l.themeSupportsResponsive,
              w = l.allowResponsive,
              C = l.toggleResponsive,
              S = l.switchBackToURLInput;
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.BlockControls, null, (0, m.createElement)(_.ToolbarGroup, null, c && (0, m.createElement)(_.ToolbarButton, {
            className: "components-toolbar__control",
            label: (0, v.__)("Edit URL"),
            icon: k.edit,
            onClick: S
          }))), E && s && (0, m.createElement)(y.InspectorControls, null, (0, m.createElement)(_.PanelBody, {
            title: (0, v.__)("Media settings"),
            className: "blocks-responsive"
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Resize for smaller devices"),
            checked: w,
            help: getResponsiveHelp,
            onChange: C
          }))));
        };

        s.default = _default;
      },
      1917: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892);

        var _default = function _default() {
          return (0, m.createElement)("div", {
            className: "wp-block-embed is-loading"
          }, (0, m.createElement)(_.Spinner, null), (0, m.createElement)("p", null, (0, v.__)("Embedding…")));
        };

        s.default = _default;
      },
      5880: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(1326);

        var _default = function _default(l) {
          var s = l.icon,
              c = l.label,
              k = l.value,
              E = l.onSubmit,
              w = l.onChange,
              C = l.cannotEmbed,
              S = l.fallback,
              P = l.tryAgain;
          return (0, m.createElement)(_.Placeholder, {
            icon: (0, m.createElement)(y.BlockIcon, {
              icon: s,
              showColors: !0
            }),
            label: c,
            className: "wp-block-embed",
            instructions: (0, v.__)("Paste a link to the content you want to display on your site.")
          }, (0, m.createElement)("form", {
            onSubmit: E
          }, (0, m.createElement)("input", {
            type: "url",
            value: k || "",
            className: "components-placeholder__input",
            "aria-label": c,
            placeholder: (0, v.__)("Enter URL to embed here…"),
            onChange: w
          }), (0, m.createElement)(_.Button, {
            variant: "primary",
            type: "submit"
          }, (0, v._x)("Embed", "button label"))), (0, m.createElement)("div", {
            className: "components-placeholder__learn-more"
          }, (0, m.createElement)(_.ExternalLink, {
            href: (0, v.__)("https://wordpress.org/support/article/embeds/")
          }, (0, v.__)("Learn more about embeds"))), C && (0, m.createElement)("div", {
            className: "components-placeholder__error"
          }, (0, m.createElement)("div", {
            className: "components-placeholder__instructions"
          }, (0, v.__)("Sorry, this content could not be embedded.")), (0, m.createElement)(_.Button, {
            variant: "secondary",
            onClick: P
          }, (0, v._x)("Try again", "button label")), " ", (0, m.createElement)(_.Button, {
            variant: "secondary",
            onClick: S
          }, (0, v._x)("Convert to link", "button label"))));
        };

        s.default = _default;
      },
      8809: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4e3),
            y = m(c(7882)),
            k = c(6756),
            E = c(4892),
            w = c(1326),
            C = c(6700),
            S = m(c(4602));

        var EmbedPreview = /*#__PURE__*/function (_v$Component) {
          _inherits(EmbedPreview, _v$Component);

          var _super = _createSuper(EmbedPreview);

          function EmbedPreview() {
            var _this;

            _classCallCheck2(this, EmbedPreview);

            _this = _super.apply(this, arguments), _this.hideOverlay = _this.hideOverlay.bind(_assertThisInitialized(_this)), _this.state = {
              interactive: !1
            };
            return _this;
          }

          _createClass2(EmbedPreview, [{
            key: "hideOverlay",
            value: function hideOverlay() {
              this.setState({
                interactive: !0
              });
            }
          }, {
            key: "render",
            value: function render() {
              var _this$props = this.props,
                  l = _this$props.preview,
                  s = _this$props.previewable,
                  c = _this$props.url,
                  m = _this$props.type,
                  P = _this$props.caption,
                  T = _this$props.onCaptionChange,
                  B = _this$props.isSelected,
                  z = _this$props.className,
                  L = _this$props.icon,
                  V = _this$props.label,
                  A = _this$props.insertBlocksAfter,
                  R = l.scripts,
                  O = this.state.interactive,
                  D = "photo" === m ? (0, _.getPhotoHtml)(l) : l.html,
                  F = new URL(c).host.split("."),
                  G = F.splice(F.length - 2, F.length - 1).join("."),
                  q = (0, k.sprintf)((0, k.__)("Embedded content from %s"), G),
                  W = (0, y.default)(m, z, "wp-block-embed__wrapper"),
                  U = "wp-embed" === m ? (0, v.createElement)(S.default, {
                html: D
              }) : (0, v.createElement)("div", {
                className: "wp-block-embed__wrapper"
              }, (0, v.createElement)(E.SandBox, {
                html: D,
                scripts: R,
                title: q,
                type: W,
                onFocus: this.hideOverlay
              }), !O && (0, v.createElement)("div", {
                className: "block-library-embed__interactive-overlay",
                onMouseUp: this.hideOverlay
              }));
              return (0, v.createElement)("figure", {
                className: (0, y.default)(z, "wp-block-embed", {
                  "is-type-video": "video" === m
                })
              }, s ? U : (0, v.createElement)(E.Placeholder, {
                icon: (0, v.createElement)(w.BlockIcon, {
                  icon: L,
                  showColors: !0
                }),
                label: V
              }, (0, v.createElement)("p", {
                className: "components-placeholder__error"
              }, (0, v.createElement)("a", {
                href: c
              }, c)), (0, v.createElement)("p", {
                className: "components-placeholder__error"
              }, (0, k.sprintf)((0, k.__)("Embedded content from %s can't be previewed in the editor."), G))), (!w.RichText.isEmpty(P) || B) && (0, v.createElement)(w.RichText, {
                tagName: "figcaption",
                placeholder: (0, k.__)("Add caption"),
                value: P,
                onChange: T,
                inlineToolbar: !0,
                __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
                  return A((0, C.createBlock)("core/paragraph"));
                }
              }));
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(l, s) {
              return !l.isSelected && s.interactive ? {
                interactive: !1
              } : null;
            }
          }]);

          return EmbedPreview;
        }(v.Component);

        var P = EmbedPreview;
        s.default = P;
      },
      8245: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.embedYouTubeIcon = s.embedWordPressIcon = s.embedWolframIcon = s.embedVimeoIcon = s.embedVideoIcon = s.embedTwitterIcon = s.embedTumblrIcon = s.embedSpotifyIcon = s.embedRedditIcon = s.embedPinterestIcon = s.embedPhotoIcon = s.embedInstagramIcon = s.embedFlickrIcon = s.embedFacebookIcon = s.embedDailymotionIcon = s.embedContentIcon = s.embedAudioIcon = s.embedAnimotoIcon = s.embedAmazonIcon = void 0;
        var m = c(1753),
            v = c(4892);

        var _ = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V9.8l4.7-5.3H19c.3 0 .5.2.5.5v14zm-6-9.5L16 12l-2.5 2.8 1.1 1L18 12l-3.5-3.5-1 1zm-3 0l-1-1L6 12l3.5 3.8 1.1-1L8 12l2.5-2.5z"
        }));

        s.embedContentIcon = _;
        var y = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V9.8l4.7-5.3H19c.3 0 .5.2.5.5v14zM13.2 7.7c-.4.4-.7 1.1-.7 1.9v3.7c-.4-.3-.8-.4-1.3-.4-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2.5 0 1-.2 1.4-.5.9-.6 1.4-1.6 1.4-2.6V9.6c0-.4.1-.6.2-.8.3-.3 1-.3 1.6-.3h.2V7h-.2c-.7 0-1.8 0-2.6.7z"
        }));
        s.embedAudioIcon = y;
        var k = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.2 4.5H19c.3 0 .5.2.5.5v8.4l-3-2.9c-.3-.3-.8-.3-1 0L11.9 14 9 12c-.3-.2-.6-.2-.8 0l-3.6 2.6V9.8l4.6-5.3zm9.8 15H5c-.3 0-.5-.2-.5-.5v-2.4l4.1-3 3 1.9c.3.2.7.2.9-.1L16 12l3.5 3.4V19c0 .3-.2.5-.5.5z"
        }));
        s.embedPhotoIcon = k;
        var E = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V9.8l4.7-5.3H19c.3 0 .5.2.5.5v14zM10 15l5-3-5-3v6z"
        }));
        s.embedVideoIcon = E;
        var w = {
          foreground: "#1da1f2",
          src: (0, m.createElement)(v.SVG, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.G, null, (0, m.createElement)(v.Path, {
            d: "M22.23 5.924c-.736.326-1.527.547-2.357.646.847-.508 1.498-1.312 1.804-2.27-.793.47-1.67.812-2.606.996C18.325 4.498 17.258 4 16.078 4c-2.266 0-4.103 1.837-4.103 4.103 0 .322.036.635.106.935-3.41-.17-6.433-1.804-8.457-4.287-.353.607-.556 1.312-.556 2.064 0 1.424.724 2.68 1.825 3.415-.673-.022-1.305-.207-1.86-.514v.052c0 1.988 1.415 3.647 3.293 4.023-.344.095-.707.145-1.08.145-.265 0-.522-.026-.773-.074.522 1.63 2.038 2.817 3.833 2.85-1.404 1.1-3.174 1.757-5.096 1.757-.332 0-.66-.02-.98-.057 1.816 1.164 3.973 1.843 6.29 1.843 7.547 0 11.675-6.252 11.675-11.675 0-.178-.004-.355-.012-.53.802-.578 1.497-1.3 2.047-2.124z"
          })))
        };
        s.embedTwitterIcon = w;
        var C = {
          foreground: "#ff0000",
          src: (0, m.createElement)(v.SVG, {
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.Path, {
            d: "M21.8 8s-.195-1.377-.795-1.984c-.76-.797-1.613-.8-2.004-.847-2.798-.203-6.996-.203-6.996-.203h-.01s-4.197 0-6.996.202c-.39.046-1.242.05-2.003.846C2.395 6.623 2.2 8 2.2 8S2 9.62 2 11.24v1.517c0 1.618.2 3.237.2 3.237s.195 1.378.795 1.985c.76.797 1.76.77 2.205.855 1.6.153 6.8.2 6.8.2s4.203-.005 7-.208c.392-.047 1.244-.05 2.005-.847.6-.607.795-1.985.795-1.985s.2-1.618.2-3.237v-1.517C22 9.62 21.8 8 21.8 8zM9.935 14.595v-5.62l5.403 2.82-5.403 2.8z"
          }))
        };
        s.embedYouTubeIcon = C;
        var S = {
          foreground: "#3b5998",
          src: (0, m.createElement)(v.SVG, {
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.Path, {
            d: "M20 3H4c-.6 0-1 .4-1 1v16c0 .5.4 1 1 1h8.6v-7h-2.3v-2.7h2.3v-2c0-2.3 1.4-3.6 3.5-3.6 1 0 1.8.1 2.1.1v2.4h-1.4c-1.1 0-1.3.5-1.3 1.3v1.7h2.7l-.4 2.8h-2.3v7H20c.5 0 1-.4 1-1V4c0-.6-.4-1-1-1z"
          }))
        };
        s.embedFacebookIcon = S;
        var P = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.G, null, (0, m.createElement)(v.Path, {
          d: "M12 4.622c2.403 0 2.688.01 3.637.052.877.04 1.354.187 1.67.31.42.163.72.358 1.036.673.315.315.51.615.673 1.035.123.317.27.794.31 1.67.043.95.052 1.235.052 3.638s-.01 2.688-.052 3.637c-.04.877-.187 1.354-.31 1.67-.163.42-.358.72-.673 1.036-.315.315-.615.51-1.035.673-.317.123-.794.27-1.67.31-.95.043-1.234.052-3.638.052s-2.688-.01-3.637-.052c-.877-.04-1.354-.187-1.67-.31-.42-.163-.72-.358-1.036-.673-.315-.315-.51-.615-.673-1.035-.123-.317-.27-.794-.31-1.67-.043-.95-.052-1.235-.052-3.638s.01-2.688.052-3.637c.04-.877.187-1.354.31-1.67.163-.42.358-.72.673-1.036.315-.315.615-.51 1.035-.673.317-.123.794-.27 1.67-.31.95-.043 1.235-.052 3.638-.052M12 3c-2.444 0-2.75.01-3.71.054s-1.613.196-2.185.418c-.592.23-1.094.538-1.594 1.04-.5.5-.807 1-1.037 1.593-.223.572-.375 1.226-.42 2.184C3.01 9.25 3 9.555 3 12s.01 2.75.054 3.71.196 1.613.418 2.186c.23.592.538 1.094 1.038 1.594s1.002.808 1.594 1.038c.572.222 1.227.375 2.185.418.96.044 1.266.054 3.71.054s2.75-.01 3.71-.054 1.613-.196 2.186-.418c.592-.23 1.094-.538 1.594-1.038s.808-1.002 1.038-1.594c.222-.572.375-1.227.418-2.185.044-.96.054-1.266.054-3.71s-.01-2.75-.054-3.71-.196-1.613-.418-2.186c-.23-.592-.538-1.094-1.038-1.594s-1.002-.808-1.594-1.038c-.572-.222-1.227-.375-2.185-.418C14.75 3.01 14.445 3 12 3zm0 4.378c-2.552 0-4.622 2.07-4.622 4.622s2.07 4.622 4.622 4.622 4.622-2.07 4.622-4.622S14.552 7.378 12 7.378zM12 15c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3zm4.804-8.884c-.596 0-1.08.484-1.08 1.08s.484 1.08 1.08 1.08c.596 0 1.08-.484 1.08-1.08s-.483-1.08-1.08-1.08z"
        })));
        s.embedInstagramIcon = P;
        var T = {
          foreground: "#0073AA",
          src: (0, m.createElement)(v.SVG, {
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.G, null, (0, m.createElement)(v.Path, {
            d: "M12.158 12.786l-2.698 7.84c.806.236 1.657.365 2.54.365 1.047 0 2.05-.18 2.986-.51-.024-.037-.046-.078-.065-.123l-2.762-7.57zM3.008 12c0 3.56 2.07 6.634 5.068 8.092L3.788 8.342c-.5 1.117-.78 2.354-.78 3.658zm15.06-.454c0-1.112-.398-1.88-.74-2.48-.456-.74-.883-1.368-.883-2.11 0-.825.627-1.595 1.51-1.595.04 0 .078.006.116.008-1.598-1.464-3.73-2.36-6.07-2.36-3.14 0-5.904 1.613-7.512 4.053.21.008.41.012.58.012.94 0 2.395-.114 2.395-.114.484-.028.54.684.057.74 0 0-.487.058-1.03.086l3.275 9.74 1.968-5.902-1.4-3.838c-.485-.028-.944-.085-.944-.085-.486-.03-.43-.77.056-.742 0 0 1.484.114 2.368.114.94 0 2.397-.114 2.397-.114.486-.028.543.684.058.74 0 0-.488.058-1.03.086l3.25 9.665.897-2.997c.456-1.17.684-2.137.684-2.907zm1.82-3.86c.04.286.06.593.06.924 0 .912-.17 1.938-.683 3.22l-2.746 7.94c2.672-1.558 4.47-4.454 4.47-7.77 0-1.564-.4-3.033-1.1-4.314zM12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"
          })))
        };
        s.embedWordPressIcon = T;
        var B = {
          foreground: "#1db954",
          src: (0, m.createElement)(v.SVG, {
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.Path, {
            d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m4.586 14.424c-.18.295-.563.387-.857.207-2.35-1.434-5.305-1.76-8.786-.963-.335.077-.67-.133-.746-.47-.077-.334.132-.67.47-.745 3.808-.87 7.076-.496 9.712 1.115.293.18.386.563.206.857M17.81 13.7c-.226.367-.706.482-1.072.257-2.687-1.652-6.785-2.13-9.965-1.166-.413.127-.848-.106-.973-.517-.125-.413.108-.848.52-.973 3.632-1.102 8.147-.568 11.234 1.328.366.226.48.707.256 1.072m.105-2.835C14.692 8.95 9.375 8.775 6.297 9.71c-.493.15-1.016-.13-1.166-.624-.148-.495.13-1.017.625-1.167 3.532-1.073 9.404-.866 13.115 1.337.445.264.59.838.327 1.282-.264.443-.838.59-1.282.325"
          }))
        };
        s.embedSpotifyIcon = B;
        var z = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "m6.5 7c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm11 0c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5z"
        }));
        s.embedFlickrIcon = z;
        var L = {
          foreground: "#1ab7ea",
          src: (0, m.createElement)(v.SVG, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.G, null, (0, m.createElement)(v.Path, {
            d: "M22.396 7.164c-.093 2.026-1.507 4.8-4.245 8.32C15.323 19.16 12.93 21 10.97 21c-1.214 0-2.24-1.12-3.08-3.36-.56-2.052-1.118-4.105-1.68-6.158-.622-2.24-1.29-3.36-2.004-3.36-.156 0-.7.328-1.634.98l-.978-1.26c1.027-.903 2.04-1.806 3.037-2.71C6 3.95 7.03 3.328 7.716 3.265c1.62-.156 2.616.95 2.99 3.32.404 2.558.685 4.148.84 4.77.468 2.12.982 3.18 1.543 3.18.435 0 1.09-.687 1.963-2.064.872-1.376 1.34-2.422 1.402-3.142.125-1.187-.343-1.782-1.4-1.782-.5 0-1.013.115-1.542.34 1.023-3.35 2.977-4.976 5.862-4.883 2.14.063 3.148 1.45 3.024 4.16z"
          })))
        };
        s.embedVimeoIcon = L;
        var V = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M22 11.816c0-1.256-1.02-2.277-2.277-2.277-.593 0-1.122.24-1.526.613-1.48-.965-3.455-1.594-5.647-1.69l1.17-3.702 3.18.75c.01 1.027.847 1.86 1.877 1.86 1.035 0 1.877-.84 1.877-1.877 0-1.035-.842-1.877-1.877-1.877-.77 0-1.43.466-1.72 1.13L13.55 3.92c-.204-.047-.4.067-.46.26l-1.35 4.27c-2.317.037-4.412.67-5.97 1.67-.402-.355-.917-.58-1.493-.58C3.02 9.54 2 10.56 2 11.815c0 .814.433 1.523 1.078 1.925-.037.222-.06.445-.06.673 0 3.292 4.01 5.97 8.94 5.97s8.94-2.678 8.94-5.97c0-.214-.02-.424-.052-.632.687-.39 1.154-1.12 1.154-1.964zm-3.224-7.422c.606 0 1.1.493 1.1 1.1s-.493 1.1-1.1 1.1-1.1-.494-1.1-1.1.493-1.1 1.1-1.1zm-16 7.422c0-.827.673-1.5 1.5-1.5.313 0 .598.103.838.27-.85.675-1.477 1.478-1.812 2.36-.32-.274-.525-.676-.525-1.13zm9.183 7.79c-4.502 0-8.165-2.33-8.165-5.193S7.457 9.22 11.96 9.22s8.163 2.33 8.163 5.193-3.663 5.193-8.164 5.193zM20.635 13c-.326-.89-.948-1.7-1.797-2.383.247-.186.55-.3.882-.3.827 0 1.5.672 1.5 1.5 0 .482-.23.91-.586 1.184zm-11.64 1.704c-.76 0-1.397-.616-1.397-1.376 0-.76.636-1.397 1.396-1.397.76 0 1.376.638 1.376 1.398 0 .76-.616 1.376-1.376 1.376zm7.405-1.376c0 .76-.615 1.376-1.375 1.376s-1.4-.616-1.4-1.376c0-.76.64-1.397 1.4-1.397.76 0 1.376.638 1.376 1.398zm-1.17 3.38c.15.152.15.398 0 .55-.675.674-1.728 1.002-3.22 1.002l-.01-.002-.012.002c-1.492 0-2.544-.328-3.218-1.002-.152-.152-.152-.398 0-.55.152-.152.4-.15.55 0 .52.52 1.394.775 2.67.775l.01.002.01-.002c1.276 0 2.15-.253 2.67-.775.15-.152.398-.152.55 0z"
        }));
        s.embedRedditIcon = V;
        var A = {
          foreground: "#35465c",
          src: (0, m.createElement)(v.SVG, {
            viewBox: "0 0 24 24"
          }, (0, m.createElement)(v.Path, {
            d: "M19 3H5a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-5.69 14.66c-2.72 0-3.1-1.9-3.1-3.16v-3.56H8.49V8.99c1.7-.62 2.54-1.99 2.64-2.87 0-.06.06-.41.06-.58h1.9v3.1h2.17v2.3h-2.18v3.1c0 .47.13 1.3 1.2 1.26h1.1v2.36c-1.01.02-2.07 0-2.07 0z"
          }))
        };
        s.embedTumblrIcon = A;
        var R = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M18.42 14.58c-.51-.66-1.05-1.23-1.05-2.5V7.87c0-1.8.15-3.45-1.2-4.68-1.05-1.02-2.79-1.35-4.14-1.35-2.6 0-5.52.96-6.12 4.14-.06.36.18.54.4.57l2.66.3c.24-.03.42-.27.48-.5.24-1.12 1.17-1.63 2.2-1.63.56 0 1.22.21 1.55.7.4.56.33 1.31.33 1.97v.36c-1.59.18-3.66.27-5.16.93a4.63 4.63 0 0 0-2.93 4.44c0 2.82 1.8 4.23 4.1 4.23 1.95 0 3.03-.45 4.53-1.98.51.72.66 1.08 1.59 1.83.18.09.45.09.63-.1v.04l2.1-1.8c.24-.21.2-.48.03-.75zm-5.4-1.2c-.45.75-1.14 1.23-1.92 1.23-1.05 0-1.65-.81-1.65-1.98 0-2.31 2.1-2.73 4.08-2.73v.6c0 1.05.03 1.92-.5 2.88z"
        }), (0, m.createElement)(v.Path, {
          d: "M21.69 19.2a17.62 17.62 0 0 1-21.6-1.57c-.23-.2 0-.5.28-.33a23.88 23.88 0 0 0 20.93 1.3c.45-.19.84.3.39.6z"
        }), (0, m.createElement)(v.Path, {
          d: "M22.8 17.96c-.36-.45-2.22-.2-3.1-.12-.23.03-.3-.18-.05-.36 1.5-1.05 3.96-.75 4.26-.39.3.36-.1 2.82-1.5 4.02-.21.18-.42.1-.3-.15.3-.8 1.02-2.58.69-3z"
        }));
        s.embedAmazonIcon = R;
        var O = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "m.0206909 21 19.8160091-13.07806 3.5831 6.20826z",
          fill: "#4bc7ee"
        }), (0, m.createElement)(v.Path, {
          d: "m23.7254 19.0205-10.1074-17.18468c-.6421-1.114428-1.7087-1.114428-2.3249 0l-11.2931 19.16418h22.5655c1.279 0 1.8019-.8905 1.1599-1.9795z",
          fill: "#d4cdcb"
        }), (0, m.createElement)(v.Path, {
          d: "m.0206909 21 15.2439091-16.38571 4.3029 7.32271z",
          fill: "#c3d82e"
        }), (0, m.createElement)(v.Path, {
          d: "m13.618 1.83582c-.6421-1.114428-1.7087-1.114428-2.3249 0l-11.2931 19.16418 15.2646-16.38573z",
          fill: "#e4ecb0"
        }), (0, m.createElement)(v.Path, {
          d: "m.0206909 21 19.5468091-9.063 1.6621 2.8344z",
          fill: "#209dbd"
        }), (0, m.createElement)(v.Path, {
          d: "m.0206909 21 17.9209091-11.82623 1.6259 2.76323z",
          fill: "#7cb3c9"
        }));
        s.embedAnimotoIcon = O;
        var D = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "m12.1479 18.5957c-2.4949 0-4.28131-1.7558-4.28131-4.0658 0-2.2176 1.78641-4.0965 4.09651-4.0965 2.2793 0 4.0349 1.7864 4.0349 4.1581 0 2.2794-1.7556 4.0042-3.8501 4.0042zm8.3521-18.5957-4.5329 1v7c-1.1088-1.41691-2.8028-1.8787-4.8049-1.8787-2.09443 0-3.97329.76993-5.5133 2.27917-1.72483 1.66323-2.6489 3.78863-2.6489 6.16033 0 2.5873.98562 4.8049 2.89526 6.499 1.44763 1.2936 3.17251 1.9402 5.17454 1.9402 1.9713 0 3.4498-.5236 4.8973-1.9402v1.9402h4.5329c0-7.6359 0-15.3641 0-23z",
          fill: "#333436"
        }));
        s.embedDailymotionIcon = D;
        var F = (0, m.createElement)(v.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          version: "1.1"
        }, (0, m.createElement)(v.Path, {
          d: "M12.289,2C6.617,2,3.606,5.648,3.606,9.622c0,1.846,1.025,4.146,2.666,4.878c0.25,0.111,0.381,0.063,0.439-0.169 c0.044-0.175,0.267-1.029,0.365-1.428c0.032-0.128,0.017-0.237-0.091-0.362C6.445,11.911,6.01,10.75,6.01,9.668 c0-2.777,2.194-5.464,5.933-5.464c3.23,0,5.49,2.108,5.49,5.122c0,3.407-1.794,5.768-4.13,5.768c-1.291,0-2.257-1.021-1.948-2.277 c0.372-1.495,1.089-3.112,1.089-4.191c0-0.967-0.542-1.775-1.663-1.775c-1.319,0-2.379,1.309-2.379,3.059 c0,1.115,0.394,1.869,0.394,1.869s-1.302,5.279-1.54,6.261c-0.405,1.666,0.053,4.368,0.094,4.604 c0.021,0.126,0.167,0.169,0.25,0.063c0.129-0.165,1.699-2.419,2.142-4.051c0.158-0.59,0.817-2.995,0.817-2.995 c0.43,0.784,1.681,1.446,3.013,1.446c3.963,0,6.822-3.494,6.822-7.833C20.394,5.112,16.849,2,12.289,2"
        }));
        s.embedPinterestIcon = F;
        var G = (0, m.createElement)(v.SVG, {
          viewBox: "0 0 44 44"
        }, (0, m.createElement)(v.Path, {
          d: "M32.59521,22.001l4.31885-4.84473-6.34131-1.38379.646-6.459-5.94336,2.61035L22,6.31934l-3.27344,5.60351L12.78418,9.3125l.645,6.458L7.08643,17.15234,11.40479,21.999,7.08594,26.84375l6.34131,1.38379-.64551,6.458,5.94287-2.60938L22,37.68066l3.27344-5.60351,5.94287,2.61035-.64551-6.458,6.34277-1.38183Zm.44385,2.75244L30.772,23.97827l-1.59558-2.07391,1.97888.735Zm-8.82147,6.1579L22.75,33.424V30.88977l1.52228-2.22168ZM18.56226,13.48816,19.819,15.09534l-2.49219-.88642L15.94037,12.337Zm6.87719.00116,2.62043-1.15027-1.38654,1.86981L24.183,15.0946Zm3.59357,2.6029-1.22546,1.7381.07525-2.73486,1.44507-1.94867ZM22,29.33008l-2.16406-3.15686L22,23.23688l2.16406,2.93634Zm-4.25458-9.582-.10528-3.836,3.60986,1.284v3.73242Zm5.00458-2.552,3.60986-1.284-.10528,3.836L22.75,20.92853Zm-7.78174-1.10559-.29352-2.94263,1.44245,1.94739.07519,2.73321Zm2.30982,5.08319,3.50817,1.18164-2.16247,2.9342-3.678-1.08447Zm2.4486,7.49285L21.25,30.88977v2.53485L19.78052,30.91Zm3.48707-6.31121,3.50817-1.18164,2.33228,3.03137-3.678,1.08447Zm10.87219-4.28113-2.714,3.04529L28.16418,19.928l1.92176-2.72565ZM24.06036,12.81769l-2.06012,2.6322-2.059-2.63318L22,9.292ZM9.91455,18.07227l4.00079-.87195,1.921,2.72735-3.20794,1.19019Zm2.93024,4.565,1.9801-.73462L13.228,23.97827l-2.26838.77429Zm-1.55591,3.58819L13.701,25.4021l2.64935.78058-2.14447.67853Zm3.64868,1.977L18.19,27.17334l.08313,3.46332L14.52979,32.2793Zm10.7876,2.43549.08447-3.464,3.25165,1.03052.407,4.07684Zm4.06824-3.77478-2.14545-.68,2.65063-.781,2.41266.825Z"
        }));
        s.embedWolframIcon = G;
      },
      5834: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(2255)),
            _ = m(c(9824)),
            y = m(c(8142)),
            k = m(c(1907)),
            E = m(c(5329)),
            w = c(8245);

        var C = {
          apiVersion: 2,
          name: "core/embed",
          title: "Embed",
          category: "embed",
          description: "Add a block that displays content pulled from other sites, like Twitter or YouTube.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            type: {
              type: "string"
            },
            providerNameSlug: {
              type: "string"
            },
            allowResponsive: {
              type: "boolean",
              default: !0
            },
            responsive: {
              type: "boolean",
              default: !1
            },
            previewable: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: !0
          },
          editorStyle: "wp-block-embed-editor",
          style: "wp-block-embed"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: w.embedContentIcon,
          edit: v.default,
          save: _.default,
          transforms: y.default,
          variations: k.default,
          deprecated: E.default
        };
        s.settings = P;
      },
      9824: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _ref84;

          var s = l.attributes;
          var c = s.url,
              m = s.caption,
              k = s.type,
              E = s.providerNameSlug;
          if (!c) return null;
          var w = (0, _.default)("wp-block-embed", (_ref84 = {}, _defineProperty(_ref84, "is-type-".concat(k), k), _defineProperty(_ref84, "is-provider-".concat(E), E), _defineProperty(_ref84, "wp-block-embed-".concat(E), E), _ref84));
          return (0, v.createElement)("figure", y.useBlockProps.save({
            className: w
          }), (0, v.createElement)("div", {
            className: "wp-block-embed__wrapper"
          }, "\n".concat(c, "\n")), !y.RichText.isEmpty(m) && (0, v.createElement)(y.RichText.Content, {
            tagName: "figcaption",
            value: m
          }));
        };

        var v = c(1753),
            _ = m(c(7882)),
            y = c(1326);
      },
      8142: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var _apiVersion$name$titl3 = {
          apiVersion: 2,
          name: "core/embed",
          title: "Embed",
          category: "embed",
          description: "Add a block that displays content pulled from other sites, like Twitter or YouTube.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            type: {
              type: "string"
            },
            providerNameSlug: {
              type: "string"
            },
            allowResponsive: {
              type: "boolean",
              default: !0
            },
            responsive: {
              type: "boolean",
              default: !1
            },
            previewable: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: !0
          },
          editorStyle: "wp-block-embed-editor",
          style: "wp-block-embed"
        },
            v = _apiVersion$name$titl3.name;
        var _ = {
          from: [{
            type: "raw",
            isMatch: function isMatch(l) {
              var s, c;
              return "P" === l.nodeName && /^\s*(https?:\/\/\S+)\s*$/i.test(l.textContent) && 1 === (null === (s = l.textContent) || void 0 === s || null === (c = s.match(/https/gi)) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform(l) {
              return (0, m.createBlock)(v, {
                url: l.textContent.trim()
              });
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            isMatch: function isMatch(l) {
              var s = l.url;
              return !!s;
            },
            transform: function transform(l) {
              var s = l.url,
                  c = l.caption,
                  v = "<a href=\"".concat(s, "\">").concat(s, "</a>");
              return null != c && c.trim() && (v += "<br />".concat(c)), (0, m.createBlock)("core/paragraph", {
                content: v
              });
            }
          }]
        };
        s.default = _;
      },
      4e3: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.createUpgradedEmbedBlock = void 0, s.fallback = function fallback(l, s) {
          var c = (0, v.createElement)("a", {
            href: l
          }, l);
          s((0, w.createBlock)("core/paragraph", {
            content: (0, v.renderToString)(c)
          }));
        }, s.getAttributesFromPreview = s.findMoreSuitableBlock = void 0, s.getClassNames = getClassNames, s.removeAspectRatioClasses = s.matchesPatterns = s.isFromWordPress = s.getPhotoHtml = s.getEmbedInfoByProvider = void 0;

        var v = c(1753),
            _ = c(3611),
            y = c(4793),
            k = m(c(7882)),
            E = m(c(1593)),
            w = c(6700);

        var _apiVersion$name$titl4 = {
          apiVersion: 2,
          name: "core/embed",
          title: "Embed",
          category: "embed",
          description: "Add a block that displays content pulled from other sites, like Twitter or YouTube.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            type: {
              type: "string"
            },
            providerNameSlug: {
              type: "string"
            },
            allowResponsive: {
              type: "boolean",
              default: !0
            },
            responsive: {
              type: "boolean",
              default: !1
            },
            previewable: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: !0
          },
          editorStyle: "wp-block-embed-editor",
          style: "wp-block-embed"
        },
            C = _apiVersion$name$titl4.name;

        s.getEmbedInfoByProvider = function (l) {
          var s;
          return null === (s = (0, w.getBlockVariations)(C)) || void 0 === s ? void 0 : s.find(function (s) {
            var c = s.name;
            return c === l;
          });
        };

        var matchesPatterns = function matchesPatterns(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return s.some(function (s) {
            return l.match(s);
          });
        };

        s.matchesPatterns = matchesPatterns;

        var findMoreSuitableBlock = function findMoreSuitableBlock(l) {
          var s;
          return null === (s = (0, w.getBlockVariations)(C)) || void 0 === s ? void 0 : s.find(function (s) {
            var c = s.patterns;
            return matchesPatterns(l, c);
          });
        };

        s.findMoreSuitableBlock = findMoreSuitableBlock;

        var isFromWordPress = function isFromWordPress(l) {
          return l && l.includes('class="wp-embedded-content"');
        };

        s.isFromWordPress = isFromWordPress;

        s.getPhotoHtml = function (l) {
          var s = l.thumbnail_url || l.url,
              c = (0, v.createElement)("p", null, (0, v.createElement)("img", {
            src: s,
            alt: l.title,
            width: "100%"
          }));
          return (0, v.renderToString)(c);
        };

        s.createUpgradedEmbedBlock = function (l) {
          var s;
          var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

          var m = l.preview,
              _l$attributes9 = l.attributes,
              v = _l$attributes9 === void 0 ? {} : _l$attributes9,
              y = v.url,
              k = v.providerNameSlug,
              E = v.type,
              S = _objectWithoutProperties(v, _excluded4);

          if (!y || !(0, w.getBlockType)(C)) return;
          var P = findMoreSuitableBlock(y),
              T = "wordpress" === k || E === _.WP_EMBED_TYPE,
              B = !T && P && (P.attributes.providerNameSlug !== k || !k);
          if (B) return (0, w.createBlock)(C, _objectSpread(_objectSpread({
            url: y
          }, S), P.attributes));
          var z = null === (s = (0, w.getBlockVariations)(C)) || void 0 === s ? void 0 : s.find(function (l) {
            var s = l.name;
            return "wordpress" === s;
          });
          return z && m && isFromWordPress(m.html) && !T ? (0, w.createBlock)(C, _objectSpread(_objectSpread({
            url: y
          }, z.attributes), c)) : void 0;
        };

        var removeAspectRatioClasses = function removeAspectRatioClasses(l) {
          if (!l) return l;

          var s = _.ASPECT_RATIOS.reduce(function (l, s) {
            var c = s.className;
            return l[c] = !1, l;
          }, {
            "wp-has-aspect-ratio": !1
          });

          return (0, k.default)(l, s);
        };

        function getClassNames(l, s) {
          var c = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          if (!c) return removeAspectRatioClasses(s);
          var m = document.implementation.createHTMLDocument("");
          m.body.innerHTML = l;
          var v = m.body.querySelector("iframe");

          if (v && v.height && v.width) {
            var _l21 = (v.width / v.height).toFixed(2);

            for (var _c = 0; _c < _.ASPECT_RATIOS.length; _c++) {
              var _m = _.ASPECT_RATIOS[_c];

              if (_l21 >= _m.ratio) {
                return _l21 - _m.ratio > .1 ? removeAspectRatioClasses(s) : (0, k.default)(removeAspectRatioClasses(s), _m.className, "wp-has-aspect-ratio");
              }
            }
          }

          return s;
        }

        s.removeAspectRatioClasses = removeAspectRatioClasses;
        var S = (0, E.default)(function (l, s, c, m) {
          var v = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
          if (!l) return {};
          var k = {};
          var _l$type = l.type,
              E = _l$type === void 0 ? "rich" : _l$type;
          var w = l.html,
              C = l.provider_name,
              S = (0, y.kebabCase)((C || s).toLowerCase());
          return isFromWordPress(w) && (E = _.WP_EMBED_TYPE), (w || "photo" === E) && (k.type = E, k.providerNameSlug = S), k.className = getClassNames(w, c, m && v), k;
        });
        s.getAttributesFromPreview = S;
      },
      1907: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756),
            v = c(8245);
        var _ = [{
          name: "twitter",
          title: "Twitter",
          icon: v.embedTwitterIcon,
          keywords: ["tweet", (0, m.__)("social")],
          description: (0, m.__)("Embed a tweet."),
          patterns: [/^https?:\/\/(www\.)?twitter\.com\/.+/i],
          attributes: {
            providerNameSlug: "twitter",
            responsive: !0
          }
        }, {
          name: "youtube",
          title: "YouTube",
          icon: v.embedYouTubeIcon,
          keywords: [(0, m.__)("music"), (0, m.__)("video")],
          description: (0, m.__)("Embed a YouTube video."),
          patterns: [/^https?:\/\/((m|www)\.)?youtube\.com\/.+/i, /^https?:\/\/youtu\.be\/.+/i],
          attributes: {
            providerNameSlug: "youtube",
            responsive: !0
          }
        }, {
          name: "facebook",
          title: "Facebook",
          icon: v.embedFacebookIcon,
          keywords: [(0, m.__)("social")],
          description: (0, m.__)("Embed a Facebook post."),
          scope: ["block"],
          patterns: [],
          attributes: {
            providerNameSlug: "facebook",
            previewable: !1,
            responsive: !0
          }
        }, {
          name: "instagram",
          title: "Instagram",
          icon: v.embedInstagramIcon,
          keywords: [(0, m.__)("image"), (0, m.__)("social")],
          description: (0, m.__)("Embed an Instagram post."),
          scope: ["block"],
          patterns: [],
          attributes: {
            providerNameSlug: "instagram",
            responsive: !0
          }
        }, {
          name: "wordpress",
          title: "WordPress",
          icon: v.embedWordPressIcon,
          keywords: [(0, m.__)("post"), (0, m.__)("blog")],
          description: (0, m.__)("Embed a WordPress post."),
          attributes: {
            providerNameSlug: "wordpress"
          }
        }, {
          name: "soundcloud",
          title: "SoundCloud",
          icon: v.embedAudioIcon,
          keywords: [(0, m.__)("music"), (0, m.__)("audio")],
          description: (0, m.__)("Embed SoundCloud content."),
          patterns: [/^https?:\/\/(www\.)?soundcloud\.com\/.+/i],
          attributes: {
            providerNameSlug: "soundcloud",
            responsive: !0
          }
        }, {
          name: "spotify",
          title: "Spotify",
          icon: v.embedSpotifyIcon,
          keywords: [(0, m.__)("music"), (0, m.__)("audio")],
          description: (0, m.__)("Embed Spotify content."),
          patterns: [/^https?:\/\/(open|play)\.spotify\.com\/.+/i],
          attributes: {
            providerNameSlug: "spotify",
            responsive: !0
          }
        }, {
          name: "flickr",
          title: "Flickr",
          icon: v.embedFlickrIcon,
          keywords: [(0, m.__)("image")],
          description: (0, m.__)("Embed Flickr content."),
          patterns: [/^https?:\/\/(www\.)?flickr\.com\/.+/i, /^https?:\/\/flic\.kr\/.+/i],
          attributes: {
            providerNameSlug: "flickr",
            responsive: !0
          }
        }, {
          name: "vimeo",
          title: "Vimeo",
          icon: v.embedVimeoIcon,
          keywords: [(0, m.__)("video")],
          description: (0, m.__)("Embed a Vimeo video."),
          patterns: [/^https?:\/\/(www\.)?vimeo\.com\/.+/i],
          attributes: {
            providerNameSlug: "vimeo",
            responsive: !0
          }
        }, {
          name: "animoto",
          title: "Animoto",
          icon: v.embedAnimotoIcon,
          description: (0, m.__)("Embed an Animoto video."),
          patterns: [/^https?:\/\/(www\.)?(animoto|video214)\.com\/.+/i],
          attributes: {
            providerNameSlug: "animoto",
            responsive: !0
          }
        }, {
          name: "cloudup",
          title: "Cloudup",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Cloudup content."),
          patterns: [/^https?:\/\/cloudup\.com\/.+/i],
          attributes: {
            providerNameSlug: "cloudup",
            responsive: !0
          }
        }, {
          name: "collegehumor",
          title: "CollegeHumor",
          icon: v.embedVideoIcon,
          description: (0, m.__)("Embed CollegeHumor content."),
          scope: ["block"],
          patterns: [],
          attributes: {
            providerNameSlug: "collegehumor",
            responsive: !0
          }
        }, {
          name: "crowdsignal",
          title: "Crowdsignal",
          icon: v.embedContentIcon,
          keywords: ["polldaddy", (0, m.__)("survey")],
          description: (0, m.__)("Embed Crowdsignal (formerly Polldaddy) content."),
          patterns: [/^https?:\/\/((.+\.)?polldaddy\.com|poll\.fm|.+\.survey\.fm)\/.+/i],
          attributes: {
            providerNameSlug: "crowdsignal",
            responsive: !0
          }
        }, {
          name: "dailymotion",
          title: "Dailymotion",
          icon: v.embedDailymotionIcon,
          keywords: [(0, m.__)("video")],
          description: (0, m.__)("Embed a Dailymotion video."),
          patterns: [/^https?:\/\/(www\.)?dailymotion\.com\/.+/i],
          attributes: {
            providerNameSlug: "dailymotion",
            responsive: !0
          }
        }, {
          name: "imgur",
          title: "Imgur",
          icon: v.embedPhotoIcon,
          description: (0, m.__)("Embed Imgur content."),
          patterns: [/^https?:\/\/(.+\.)?imgur\.com\/.+/i],
          attributes: {
            providerNameSlug: "imgur",
            responsive: !0
          }
        }, {
          name: "issuu",
          title: "Issuu",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Issuu content."),
          patterns: [/^https?:\/\/(www\.)?issuu\.com\/.+/i],
          attributes: {
            providerNameSlug: "issuu",
            responsive: !0
          }
        }, {
          name: "kickstarter",
          title: "Kickstarter",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Kickstarter content."),
          patterns: [/^https?:\/\/(www\.)?kickstarter\.com\/.+/i, /^https?:\/\/kck\.st\/.+/i],
          attributes: {
            providerNameSlug: "kickstarter",
            responsive: !0
          }
        }, {
          name: "mixcloud",
          title: "Mixcloud",
          icon: v.embedAudioIcon,
          keywords: [(0, m.__)("music"), (0, m.__)("audio")],
          description: (0, m.__)("Embed Mixcloud content."),
          patterns: [/^https?:\/\/(www\.)?mixcloud\.com\/.+/i],
          attributes: {
            providerNameSlug: "mixcloud",
            responsive: !0
          }
        }, {
          name: "reddit",
          title: "Reddit",
          icon: v.embedRedditIcon,
          description: (0, m.__)("Embed a Reddit thread."),
          patterns: [/^https?:\/\/(www\.)?reddit\.com\/.+/i],
          attributes: {
            providerNameSlug: "reddit",
            responsive: !0
          }
        }, {
          name: "reverbnation",
          title: "ReverbNation",
          icon: v.embedAudioIcon,
          description: (0, m.__)("Embed ReverbNation content."),
          patterns: [/^https?:\/\/(www\.)?reverbnation\.com\/.+/i],
          attributes: {
            providerNameSlug: "reverbnation",
            responsive: !0
          }
        }, {
          name: "screencast",
          title: "Screencast",
          icon: v.embedVideoIcon,
          description: (0, m.__)("Embed Screencast content."),
          patterns: [/^https?:\/\/(www\.)?screencast\.com\/.+/i],
          attributes: {
            providerNameSlug: "screencast",
            responsive: !0
          }
        }, {
          name: "scribd",
          title: "Scribd",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Scribd content."),
          patterns: [/^https?:\/\/(www\.)?scribd\.com\/.+/i],
          attributes: {
            providerNameSlug: "scribd",
            responsive: !0
          }
        }, {
          name: "slideshare",
          title: "Slideshare",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Slideshare content."),
          patterns: [/^https?:\/\/(.+?\.)?slideshare\.net\/.+/i],
          attributes: {
            providerNameSlug: "slideshare",
            responsive: !0
          }
        }, {
          name: "smugmug",
          title: "SmugMug",
          icon: v.embedPhotoIcon,
          description: (0, m.__)("Embed SmugMug content."),
          patterns: [/^https?:\/\/(.+\.)?smugmug\.com\/.*/i],
          attributes: {
            providerNameSlug: "smugmug",
            previewable: !1,
            responsive: !0
          }
        }, {
          name: "speaker-deck",
          title: "Speaker Deck",
          icon: v.embedContentIcon,
          description: (0, m.__)("Embed Speaker Deck content."),
          patterns: [/^https?:\/\/(www\.)?speakerdeck\.com\/.+/i],
          attributes: {
            providerNameSlug: "speaker-deck",
            responsive: !0
          }
        }, {
          name: "tiktok",
          title: "TikTok",
          icon: v.embedVideoIcon,
          keywords: [(0, m.__)("video")],
          description: (0, m.__)("Embed a TikTok video."),
          patterns: [/^https?:\/\/(www\.)?tiktok\.com\/.+/i],
          attributes: {
            providerNameSlug: "tiktok",
            responsive: !0
          }
        }, {
          name: "ted",
          title: "TED",
          icon: v.embedVideoIcon,
          description: (0, m.__)("Embed a TED video."),
          patterns: [/^https?:\/\/(www\.|embed\.)?ted\.com\/.+/i],
          attributes: {
            providerNameSlug: "ted",
            responsive: !0
          }
        }, {
          name: "tumblr",
          title: "Tumblr",
          icon: v.embedTumblrIcon,
          keywords: [(0, m.__)("social")],
          description: (0, m.__)("Embed a Tumblr post."),
          patterns: [/^https?:\/\/(www\.)?tumblr\.com\/.+/i],
          attributes: {
            providerNameSlug: "tumblr",
            responsive: !0
          }
        }, {
          name: "videopress",
          title: "VideoPress",
          icon: v.embedVideoIcon,
          keywords: [(0, m.__)("video")],
          description: (0, m.__)("Embed a VideoPress video."),
          patterns: [/^https?:\/\/videopress\.com\/.+/i],
          attributes: {
            providerNameSlug: "videopress",
            responsive: !0
          }
        }, {
          name: "wordpress-tv",
          title: "WordPress.tv",
          icon: v.embedVideoIcon,
          description: (0, m.__)("Embed a WordPress.tv video."),
          patterns: [/^https?:\/\/wordpress\.tv\/.+/i],
          attributes: {
            providerNameSlug: "wordpress-tv",
            responsive: !0
          }
        }, {
          name: "amazon-kindle",
          title: "Amazon Kindle",
          icon: v.embedAmazonIcon,
          keywords: [(0, m.__)("ebook")],
          description: (0, m.__)("Embed Amazon Kindle content."),
          patterns: [/^https?:\/\/([a-z0-9-]+\.)?(amazon|amzn)(\.[a-z]{2,4})+\/.+/i, /^https?:\/\/(www\.)?(a\.co|z\.cn)\/.+/i],
          attributes: {
            providerNameSlug: "amazon-kindle"
          }
        }, {
          name: "pinterest",
          title: "Pinterest",
          icon: v.embedPinterestIcon,
          keywords: [(0, m.__)("social"), (0, m.__)("bookmark")],
          description: (0, m.__)("Embed Pinterest pins, boards, and profiles."),
          patterns: [/^https?:\/\/([a-z]{2}|www)\.pinterest\.com(\.(au|mx))?\/.*/i],
          attributes: {
            providerNameSlug: "pinterest"
          }
        }, {
          name: "wolfram-cloud",
          title: "Wolfram Cloud",
          icon: v.embedWolframIcon,
          description: (0, m.__)("Embed Wolfram Cloud notebook content."),
          patterns: [/^https?:\/\/(www\.)?wolframcloud\.com\/obj\/.+/i],
          attributes: {
            providerNameSlug: "wolfram-cloud",
            responsive: !0
          }
        }];

        _.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            return l.providerNameSlug === s.providerNameSlug;
          });
        });

        var y = _;
        s.default = y;
      },
      4602: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function WpEmbedPreview(l) {
          var s = l.html;
          var c = (0, v.useRef)(),
              m = (0, v.useMemo)(function () {
            var l = new window.DOMParser().parseFromString(s, "text/html").querySelector("iframe"),
                c = {};
            return l ? (Array.from(l.attributes).forEach(function (l) {
              var s = l.name,
                  m = l.value;
              "style" !== s && (c[k[s] || s] = m);
            }), c) : c;
          }, [s]);
          return (0, v.useEffect)(function () {
            var l = c.current.ownerDocument,
                s = l.defaultView;

            function resizeWPembeds(l) {
              var _l$data = l.data;
              _l$data = _l$data === void 0 ? {} : _l$data;
              var s = _l$data.secret,
                  v = _l$data.message,
                  _ = _l$data.value;
              "height" === v && s === m["data-secret"] && (c.current.height = _);
            }

            return s.addEventListener("message", resizeWPembeds), function () {
              s.removeEventListener("message", resizeWPembeds);
            };
          }, []), (0, v.createElement)("div", {
            className: "wp-block-embed__wrapper"
          }, (0, v.createElement)("iframe", (0, _.default)({
            ref: (0, y.useMergeRefs)([c, (0, y.useFocusableIframe)()]),
            title: m.title
          }, m)));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(3200);

        var k = {
          class: "className",
          frameborder: "frameBorder",
          marginheight: "marginHeight",
          marginwidth: "marginWidth"
        };
      },
      9529: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(1326),
            _ = c(6756);

        var y = [{
          attributes: {
            id: {
              type: "number"
            },
            href: {
              type: "string"
            },
            fileName: {
              type: "string",
              source: "html",
              selector: "a:not([download])"
            },
            textLinkHref: {
              type: "string",
              source: "attribute",
              selector: "a:not([download])",
              attribute: "href"
            },
            textLinkTarget: {
              type: "string",
              source: "attribute",
              selector: "a:not([download])",
              attribute: "target"
            },
            showDownloadButton: {
              type: "boolean",
              default: !0
            },
            downloadButtonText: {
              type: "string",
              source: "html",
              selector: "a[download]"
            },
            displayPreview: {
              type: "boolean"
            },
            previewHeight: {
              type: "number",
              default: 600
            }
          },
          supports: {
            anchor: !0,
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.href,
                y = s.fileName,
                k = s.textLinkHref,
                E = s.textLinkTarget,
                w = s.showDownloadButton,
                C = s.downloadButtonText,
                S = s.displayPreview,
                P = s.previewHeight,
                T = v.RichText.isEmpty(y) ? (0, _.__)("PDF embed") : (0, _.sprintf)((0, _.__)("Embed of %s."), y);
            return c && (0, m.createElement)("div", v.useBlockProps.save(), S && (0, m.createElement)(m.Fragment, null, (0, m.createElement)("object", {
              className: "wp-block-file__embed",
              data: c,
              type: "application/pdf",
              style: {
                width: "100%",
                height: "".concat(P, "px")
              },
              "aria-label": T
            })), !v.RichText.isEmpty(y) && (0, m.createElement)("a", {
              href: k,
              target: E,
              rel: E ? "noreferrer noopener" : void 0
            }, (0, m.createElement)(v.RichText.Content, {
              value: y
            })), w && (0, m.createElement)("a", {
              href: c,
              className: "wp-block-file__button",
              download: !0
            }, (0, m.createElement)(v.RichText.Content, {
              value: C
            })));
          }
        }];
        s.default = y;
      },
      7876: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.MIN_PREVIEW_HEIGHT = s.MAX_PREVIEW_HEIGHT = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(9388),
            k = c(4892),
            E = c(8467),
            w = c(1326),
            C = c(3200),
            S = c(6756),
            P = c(5303),
            T = c(1295),
            B = c(8448),
            z = m(c(2405)),
            L = c(7964);

        s.MIN_PREVIEW_HEIGHT = 200;

        function ClipboardToolbarButton(l) {
          var s = l.text,
              c = l.disabled;

          var _ref85 = (0, E.useDispatch)(B.store),
              m = _ref85.createNotice,
              _ = (0, C.useCopyToClipboard)(s, function () {
            m("info", (0, S.__)("Copied URL to clipboard."), {
              isDismissible: !0,
              type: "snackbar"
            });
          });

          return (0, v.createElement)(k.ToolbarButton, {
            className: "components-clipboard-toolbar-button",
            ref: _,
            disabled: c
          }, (0, S.__)("Copy URL"));
        }

        s.MAX_PREVIEW_HEIGHT = 2e3;
        var V = (0, k.withNotices)(function FileEdit(l) {
          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              C = l.noticeUI,
              B = l.noticeOperations,
              V = l.clientId;

          var A = s.id,
              R = s.fileName,
              O = s.href,
              D = s.textLinkHref,
              F = s.textLinkTarget,
              G = s.showDownloadButton,
              q = s.downloadButtonText,
              W = s.displayPreview,
              U = s.previewHeight,
              _ref86 = (0, v.useState)(!1),
              _ref87 = _slicedToArray2(_ref86, 2),
              $ = _ref87[0],
              Z = _ref87[1],
              _ref88 = (0, E.useSelect)(function (l) {
            return {
              media: void 0 === A ? void 0 : l(T.store).getMedia(A),
              mediaUpload: l(w.store).getSettings().mediaUpload
            };
          }, [A]),
              K = _ref88.media,
              Q = _ref88.mediaUpload,
              _ref89 = (0, E.useDispatch)(w.store),
              Y = _ref89.toggleSelection;

          function onSelectFile(l) {
            if (l && l.url) {
              Z(!1);

              var _s5 = l.url.endsWith(".pdf");

              m({
                href: l.url,
                fileName: l.title,
                textLinkHref: l.url,
                id: l.id,
                displayPreview: !!_s5 || void 0,
                previewHeight: _s5 ? 600 : void 0
              });
            }
          }

          function onUploadError(l) {
            Z(!0), B.removeAllNotices(), B.createErrorNotice(l);
          }

          function changeDownloadButtonText(l) {
            m({
              downloadButtonText: l.replace(/<\/?a[^>]*>/g, "")
            });
          }

          (0, v.useEffect)(function () {
            if ((0, y.isBlobURL)(O)) {
              var _l22 = (0, y.getBlobByURL)(O);

              Q({
                filesList: [_l22],
                onFileChange: function onFileChange(l) {
                  var _l23 = _slicedToArray2(l, 1),
                      s = _l23[0];

                  return onSelectFile(s);
                },
                onError: function onError(l) {
                  Z(!0), B.createErrorNotice(l);
                }
              }), (0, y.revokeBlobURL)(O);
            }

            void 0 === q && changeDownloadButtonText((0, S._x)("Download", "button label"));
          }, []), (0, v.useEffect)(function () {
            m({
              fileId: "wp-block-file--media-".concat(V)
            });
          }, [V]);
          var X = K && K.link,
              J = (0, w.useBlockProps)({
            className: (0, _.default)((0, y.isBlobURL)(O) && (0, k.__unstableGetAnimateClassName)({
              type: "loading"
            }), {
              "is-transient": (0, y.isBlobURL)(O)
            })
          }),
              ee = (0, L.browserSupportsPdfs)() && W;
          return !O || $ ? (0, v.createElement)("div", J, (0, v.createElement)(w.MediaPlaceholder, {
            icon: (0, v.createElement)(w.BlockIcon, {
              icon: P.file
            }),
            labels: {
              title: (0, S.__)("File"),
              instructions: (0, S.__)("Upload a file or pick one from your media library.")
            },
            onSelect: onSelectFile,
            notices: C,
            onError: onUploadError,
            accept: "*"
          })) : (0, v.createElement)(v.Fragment, null, (0, v.createElement)(z.default, {
            hrefs: {
              href: O,
              textLinkHref: D,
              attachmentPage: X
            },
            openInNewWindow: !!F,
            showDownloadButton: G,
            changeLinkDestinationOption: function changeLinkDestinationOption(l) {
              m({
                textLinkHref: l
              });
            },
            changeOpenInNewWindow: function changeOpenInNewWindow(l) {
              m({
                textLinkTarget: !!l && "_blank"
              });
            },
            changeShowDownloadButton: function changeShowDownloadButton(l) {
              m({
                showDownloadButton: l
              });
            },
            displayPreview: W,
            changeDisplayPreview: function changeDisplayPreview(l) {
              m({
                displayPreview: l
              });
            },
            previewHeight: U,
            changePreviewHeight: function changePreviewHeight(l) {
              var s = Math.max(parseInt(l, 10), 200);
              m({
                previewHeight: s
              });
            }
          }), (0, v.createElement)(w.BlockControls, {
            group: "other"
          }, (0, v.createElement)(w.MediaReplaceFlow, {
            mediaId: A,
            mediaURL: O,
            accept: "*",
            onSelect: onSelectFile,
            onError: onUploadError
          }), (0, v.createElement)(ClipboardToolbarButton, {
            text: O,
            disabled: (0, y.isBlobURL)(O)
          })), (0, v.createElement)("div", J, ee && (0, v.createElement)(k.ResizableBox, {
            size: {
              height: U
            },
            minHeight: 200,
            maxHeight: 2e3,
            minWidth: "100%",
            grid: [10, 10],
            enable: {
              top: !1,
              right: !1,
              bottom: !0,
              left: !1,
              topRight: !1,
              bottomRight: !1,
              bottomLeft: !1,
              topLeft: !1
            },
            onResizeStart: function onResizeStart() {
              return Y(!1);
            },
            onResizeStop: function handleOnResizeStop(l, s, c, v) {
              Y(!0);

              var _ = parseInt(U + v.height, 10);

              m({
                previewHeight: _
              });
            },
            showHandle: c
          }, (0, v.createElement)("object", {
            className: "wp-block-file__preview",
            data: O,
            type: "application/pdf",
            "aria-label": (0, S.__)("Embed of the selected PDF file.")
          }), !c && (0, v.createElement)("div", {
            className: "wp-block-file__preview-overlay"
          })), (0, v.createElement)("div", {
            className: "wp-block-file__content-wrapper"
          }, (0, v.createElement)(w.RichText, {
            tagName: "a",
            value: R,
            placeholder: (0, S.__)("Write file name…"),
            withoutInteractiveFormatting: !0,
            onChange: function onChange(l) {
              return m({
                fileName: l
              });
            },
            href: D
          }), G && (0, v.createElement)("div", {
            className: "wp-block-file__button-richtext-wrapper"
          }, (0, v.createElement)(w.RichText, {
            tagName: "div",
            "aria-label": (0, S.__)("Download button text"),
            className: "wp-block-file__button",
            value: q,
            withoutInteractiveFormatting: !0,
            placeholder: (0, S.__)("Add text…"),
            onChange: function onChange(l) {
              return changeDownloadButtonText(l);
            }
          })))));
        });
        s.default = V;
      },
      5208: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(9529)),
            k = m(c(7876)),
            E = m(c(9374)),
            w = m(c(9624));

        var C = {
          apiVersion: 2,
          name: "core/file",
          title: "File",
          category: "media",
          description: "Add a link to a downloadable file.",
          keywords: ["document", "pdf", "download"],
          textdomain: "default",
          attributes: {
            id: {
              type: "number"
            },
            href: {
              type: "string"
            },
            fileId: {
              type: "string",
              source: "attribute",
              selector: "a:not([download])",
              attribute: "id"
            },
            fileName: {
              type: "string",
              source: "html",
              selector: "a:not([download])"
            },
            textLinkHref: {
              type: "string",
              source: "attribute",
              selector: "a:not([download])",
              attribute: "href"
            },
            textLinkTarget: {
              type: "string",
              source: "attribute",
              selector: "a:not([download])",
              attribute: "target"
            },
            showDownloadButton: {
              type: "boolean",
              default: !0
            },
            downloadButtonText: {
              type: "string",
              source: "html",
              selector: "a[download]"
            },
            displayPreview: {
              type: "boolean"
            },
            previewHeight: {
              type: "number",
              default: 600
            }
          },
          supports: {
            anchor: !0,
            align: !0
          },
          viewScript: "file:./view.min.js",
          editorStyle: "wp-block-file-editor",
          style: "wp-block-file"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.file,
          example: {
            attributes: {
              href: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Armstrong_Small_Step.ogg",
              fileName: (0, v._x)("Armstrong_Small_Step", "Name of the file")
            }
          },
          transforms: w.default,
          deprecated: y.default,
          edit: k.default,
          save: E.default
        };
        s.settings = P;
      },
      2405: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function FileBlockInspector(l) {
          var s = l.hrefs,
              c = l.openInNewWindow,
              E = l.showDownloadButton,
              w = l.changeLinkDestinationOption,
              C = l.changeOpenInNewWindow,
              S = l.changeShowDownloadButton,
              P = l.displayPreview,
              T = l.changeDisplayPreview,
              B = l.previewHeight,
              z = l.changePreviewHeight;
          var L = s.href,
              V = s.textLinkHref,
              A = s.attachmentPage;
          var R = [{
            value: L,
            label: (0, v.__)("URL")
          }];
          A && (R = [{
            value: L,
            label: (0, v.__)("Media file")
          }, {
            value: A,
            label: (0, v.__)("Attachment page")
          }]);
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.InspectorControls, null, L.endsWith(".pdf") && (0, m.createElement)(_.PanelBody, {
            title: (0, v.__)("PDF settings")
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Show inline embed"),
            help: P ? (0, v.__)("Note: Most phone and tablet browsers won't display embedded PDFs.") : null,
            checked: !!P,
            onChange: T
          }), P && (0, m.createElement)(_.RangeControl, {
            label: (0, v.__)("Height in pixels"),
            min: k.MIN_PREVIEW_HEIGHT,
            max: Math.max(k.MAX_PREVIEW_HEIGHT, B),
            value: B,
            onChange: z
          })), (0, m.createElement)(_.PanelBody, {
            title: (0, v.__)("Text link settings")
          }, (0, m.createElement)(_.SelectControl, {
            label: (0, v.__)("Link to"),
            value: V,
            options: R,
            onChange: w
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Open in new tab"),
            checked: c,
            onChange: C
          })), (0, m.createElement)(_.PanelBody, {
            title: (0, v.__)("Download button settings")
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Show download button"),
            checked: E,
            onChange: S
          }))));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(1326),
            k = c(7876);
      },
      9374: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.href,
              y = s.fileId,
              k = s.fileName,
              E = s.textLinkHref,
              w = s.textLinkTarget,
              C = s.showDownloadButton,
              S = s.downloadButtonText,
              P = s.displayPreview,
              T = s.previewHeight,
              B = v.RichText.isEmpty(k) ? (0, _.__)("PDF embed") : (0, _.sprintf)((0, _.__)("Embed of %s."), k);
          return c && (0, m.createElement)("div", v.useBlockProps.save(), P && (0, m.createElement)(m.Fragment, null, (0, m.createElement)("object", {
            className: "wp-block-file__embed",
            data: c,
            type: "application/pdf",
            style: {
              width: "100%",
              height: "".concat(T, "px")
            },
            "aria-label": B
          })), !v.RichText.isEmpty(k) && (0, m.createElement)("a", {
            id: y,
            href: E,
            target: w,
            rel: w ? "noreferrer noopener" : void 0
          }, (0, m.createElement)(v.RichText.Content, {
            value: k
          })), C && (0, m.createElement)("a", {
            href: c,
            className: "wp-block-file__button",
            download: !0,
            "aria-describedby": y
          }, (0, m.createElement)(v.RichText.Content, {
            value: S
          })));
        };

        var m = c(1753),
            v = c(1326),
            _ = c(6756);
      },
      9624: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(4793),
            v = c(9388),
            _ = c(6700),
            y = c(8467),
            k = c(1295),
            E = c(904);

        var w = {
          from: [{
            type: "files",
            isMatch: function isMatch(l) {
              return l.length > 0;
            },
            priority: 15,
            transform: function transform(l) {
              var s = [];
              return l.forEach(function (l) {
                var c = (0, v.createBlobURL)(l);
                s.push((0, _.createBlock)("core/file", {
                  href: c,
                  fileName: l.name,
                  textLinkHref: c
                }));
              }), s;
            }
          }, {
            type: "block",
            blocks: ["core/audio"],
            transform: function transform(l) {
              return (0, _.createBlock)("core/file", {
                href: l.src,
                fileName: l.caption,
                textLinkHref: l.src,
                id: l.id,
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            transform: function transform(l) {
              return (0, _.createBlock)("core/file", {
                href: l.src,
                fileName: l.caption,
                textLinkHref: l.src,
                id: l.id,
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/image"],
            transform: function transform(l) {
              return (0, _.createBlock)("core/file", {
                href: l.url,
                fileName: l.caption || (0, E.getFilename)(l.url),
                textLinkHref: l.url,
                id: l.id,
                anchor: l.anchor
              });
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/audio"],
            isMatch: function isMatch(l) {
              var s = l.id;
              if (!s) return !1;

              var _ref90 = (0, y.select)(k.store),
                  c = _ref90.getMedia,
                  v = c(s);

              return !!v && (0, m.includes)(v.mime_type, "audio");
            },
            transform: function transform(l) {
              return (0, _.createBlock)("core/audio", {
                src: l.href,
                caption: l.fileName,
                id: l.id,
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            isMatch: function isMatch(l) {
              var s = l.id;
              if (!s) return !1;

              var _ref91 = (0, y.select)(k.store),
                  c = _ref91.getMedia,
                  v = c(s);

              return !!v && (0, m.includes)(v.mime_type, "video");
            },
            transform: function transform(l) {
              return (0, _.createBlock)("core/video", {
                src: l.href,
                caption: l.fileName,
                id: l.id,
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/image"],
            isMatch: function isMatch(l) {
              var s = l.id;
              if (!s) return !1;

              var _ref92 = (0, y.select)(k.store),
                  c = _ref92.getMedia,
                  v = c(s);

              return !!v && (0, m.includes)(v.mime_type, "image");
            },
            transform: function transform(l) {
              return (0, _.createBlock)("core/image", {
                url: l.href,
                caption: l.fileName,
                id: l.id,
                anchor: l.anchor
              });
            }
          }]
        };
        s.default = w;
      },
      7964: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.hidePdfEmbedsOnUnsupportedBrowsers = s.browserSupportsPdfs = void 0;

        var browserSupportsPdfs = function browserSupportsPdfs() {
          return !(window.navigator.userAgent.indexOf("Mobi") > -1) && !(window.navigator.userAgent.indexOf("Android") > -1) && !(window.navigator.userAgent.indexOf("Macintosh") > -1 && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2) && !((window.ActiveXObject || "ActiveXObject" in window) && !createActiveXObject("AcroPDF.PDF") && !createActiveXObject("PDF.PdfCtrl"));
        };

        s.browserSupportsPdfs = browserSupportsPdfs;

        var createActiveXObject = function createActiveXObject(l) {
          var s;

          try {
            s = new window.ActiveXObject(l);
          } catch (l) {
            s = void 0;
          }

          return s;
        };

        s.hidePdfEmbedsOnUnsupportedBrowsers = function () {
          if (!browserSupportsPdfs()) {
            var _l24 = document.getElementsByClassName("wp-block-file__embed");

            Array.from(_l24).forEach(function (l) {
              l.style.display = "none";
            });
          }
        };
      },
      910: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(8467),
            k = c(6700),
            E = c(1326);

        var _default = function _default(l) {
          var s = l.clientId;

          var _ref93 = (0, y.useDispatch)(E.store),
              c = _ref93.replaceBlocks,
              w = (0, y.useSelect)(function (l) {
            return l(E.store).getBlock(s);
          }, [s]);

          return (0, m.createElement)(_.ToolbarButton, {
            onClick: function onClick() {
              return c(w.clientId, (0, k.rawHandler)({
                HTML: (0, k.serialize)(w)
              }));
            }
          }, (0, v.__)("Convert to blocks"));
        };

        s.default = _default;
      },
      5933: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ClassicEdit(l) {
          var s = l.clientId,
              c = l.attributes.content,
              m = l.setAttributes,
              T = l.onReplace;

          var _ref94 = (0, k.useSelect)(y.store),
              B = _ref94.getMultiSelectedBlockClientIds,
              z = (0, v.useRef)(!1);

          return (0, v.useEffect)(function () {
            if (!z.current) return;
            var l = window.tinymce.get("editor-".concat(s));
            (null == l ? void 0 : l.getContent()) !== c && l.setContent(c || "");
          }, [c]), (0, v.useEffect)(function () {
            var _window$wpEditorL10n$ = window.wpEditorL10n.tinymce,
                l = _window$wpEditorL10n$.baseURL,
                v = _window$wpEditorL10n$.suffix;

            function onSetup(l) {
              var s;
              c && l.on("loadContent", function () {
                return l.setContent(c);
              }), l.on("blur", function () {
                var c;
                s = l.selection.getBookmark(2, !0);
                var v = document.querySelector(".interface-interface-skeleton__content"),
                    _ = v.scrollTop;
                return null !== (c = B()) && void 0 !== c && c.length || m({
                  content: l.getContent()
                }), l.once("focus", function () {
                  s && (l.selection.moveToBookmark(s), v.scrollTop !== _ && (v.scrollTop = _));
                }), !1;
              }), l.on("mousedown touchstart", function () {
                s = null;
              });
              var v = (0, _.debounce)(function () {
                var s = l.getContent();
                s !== l._lastChange && (l._lastChange = s, m({
                  content: s
                }));
              }, 250);
              l.on("Paste Change input Undo Redo", v), l.on("remove", v.cancel), l.on("keydown", function (s) {
                C.isKeyboardEvent.primary(s, "z") && s.stopPropagation(), s.keyCode !== C.BACKSPACE && s.keyCode !== C.DELETE || !function isTmceEmpty(l) {
                  var s = l.getBody();
                  if (s.childNodes.length > 1) return !1;
                  if (0 === s.childNodes.length) return !0;
                  if (s.childNodes[0].childNodes.length > 1) return !1;
                  return /^\n?$/.test(s.innerText || s.textContent);
                }(l) || (T([]), s.preventDefault(), s.stopImmediatePropagation());
                var c = s.altKey;
                c && s.keyCode === C.F10 && s.stopPropagation();
              }), l.on("init", function () {
                var s = l.getBody();
                s.ownerDocument.activeElement === s && (s.blur(), l.focus());
              });
            }

            function initialize() {
              var l = window.wpEditorL10n.tinymce.settings;
              P.oldEditor.initialize("editor-".concat(s), {
                tinymce: _objectSpread(_objectSpread({}, l), {}, {
                  inline: !0,
                  content_css: !1,
                  fixed_toolbar_container: "#toolbar-".concat(s),
                  setup: onSetup
                })
              });
            }

            function onReadyStateChange() {
              "complete" === document.readyState && initialize();
            }

            return z.current = !0, window.tinymce.EditorManager.overrideDefaults({
              base_url: l,
              suffix: v
            }), "complete" === document.readyState ? initialize() : document.addEventListener("readystatechange", onReadyStateChange), function () {
              document.removeEventListener("readystatechange", onReadyStateChange), P.oldEditor.remove("editor-".concat(s));
            };
          }, []), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, null, (0, v.createElement)(E.ToolbarGroup, null, (0, v.createElement)(S.default, {
            clientId: s
          }))), (0, v.createElement)("div", (0, y.useBlockProps)(), (0, v.createElement)("div", {
            key: "toolbar",
            id: "toolbar-".concat(s),
            className: "block-library-classic__toolbar",
            onClick: function focus() {
              var l = window.tinymce.get("editor-".concat(s));
              l && l.focus();
            },
            "data-placeholder": (0, w.__)("Classic"),
            onKeyDown: function onToolbarKeyDown(l) {
              l.stopPropagation(), l.nativeEvent.stopImmediatePropagation();
            }
          }), (0, v.createElement)("div", {
            key: "editor",
            id: "editor-".concat(s),
            className: "wp-block-freeform block-library-rich-text__tinymce"
          })));
        };

        var v = c(1753),
            _ = c(4793),
            y = c(1326),
            k = c(8467),
            E = c(4892),
            w = c(6756),
            C = c(9880),
            S = m(c(910));

        var _window = window,
            P = _window.wp;
      },
      5725: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(5933)),
            y = m(c(5634));

        var k = {
          apiVersion: 2,
          name: "core/freeform",
          title: "Classic",
          category: "text",
          description: "Use the classic WordPress editor.",
          textdomain: "default",
          attributes: {
            content: {
              type: "string",
              source: "html"
            }
          },
          supports: {
            className: !1,
            customClassName: !1,
            reusable: !1
          },
          editorStyle: "wp-block-freeform-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.classic,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      5634: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.content;
          return (0, m.createElement)(m.RawHTML, null, c);
        };
        var m = c(1753);
      },
      6785: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LINK_DESTINATION_NONE = s.LINK_DESTINATION_MEDIA = s.LINK_DESTINATION_ATTACHMENT = void 0;
        s.LINK_DESTINATION_NONE = "none";
        s.LINK_DESTINATION_MEDIA = "media";
        s.LINK_DESTINATION_ATTACHMENT = "attachment";
      },
      127: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.defaultColumnsNumberV1 = defaultColumnsNumberV1, s.getHrefAndDestination = getHrefAndDestination, s.getImageBlock = getImageBlock;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(6700),
            w = c(6785),
            C = c(651);

        var S = "file",
            P = "post";

        function defaultColumnsNumberV1(l) {
          var s;
          return Math.min(3, null == l || null === (s = l.images) || void 0 === s ? void 0 : s.length);
        }

        function getHrefAndDestination(l, s) {
          switch (s) {
            case S:
              return {
                href: (null == l ? void 0 : l.source_url) || (null == l ? void 0 : l.url),
                linkDestination: w.LINK_DESTINATION_MEDIA
              };

            case P:
              return {
                href: null == l ? void 0 : l.link,
                linkDestination: w.LINK_DESTINATION_ATTACHMENT
              };

            case w.LINK_DESTINATION_MEDIA:
              return {
                href: (null == l ? void 0 : l.source_url) || (null == l ? void 0 : l.url),
                linkDestination: w.LINK_DESTINATION_MEDIA
              };

            case w.LINK_DESTINATION_ATTACHMENT:
              return {
                href: null == l ? void 0 : l.link,
                linkDestination: w.LINK_DESTINATION_ATTACHMENT
              };

            case w.LINK_DESTINATION_NONE:
              return {
                href: void 0,
                linkDestination: w.LINK_DESTINATION_NONE
              };
          }

          return {};
        }

        function runV2Migration(l) {
          var s = l.linkTo ? l.linkTo : "none";
          "post" === s ? s = "attachment" : "file" === s && (s = "media");
          var c = l.images.map(function (c) {
            return getImageBlock(c, l.sizeSlug, s);
          });
          return [_objectSpread(_objectSpread({}, (0, y.omit)(l, ["images", "ids"])), {}, {
            linkTo: s,
            allowResize: !1
          }), c];
        }

        function getImageBlock(l, s, c) {
          return (0, E.createBlock)("core/image", _objectSpread(_objectSpread({}, l.id && {
            id: parseInt(l.id)
          }), {}, {
            url: l.url,
            alt: l.alt,
            caption: l.caption,
            sizeSlug: s
          }, getHrefAndDestination(l, c)));
        }

        var T = [{
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: ".blocks-gallery-item",
              query: {
                url: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                fullUrl: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-full-url"
                },
                link: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                alt: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                caption: {
                  type: "string",
                  source: "html",
                  selector: ".blocks-gallery-item__caption"
                }
              }
            },
            ids: {
              type: "array",
              items: {
                type: "number"
              },
              default: []
            },
            columns: {
              type: "number",
              minimum: 1,
              maximum: 8
            },
            caption: {
              type: "string",
              source: "html",
              selector: ".blocks-gallery-caption"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string"
            },
            sizeSlug: {
              type: "string",
              default: "large"
            }
          },
          supports: {
            anchor: !0,
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns = s.columns,
                m = _s$columns === void 0 ? defaultColumnsNumberV1(s) : _s$columns,
                _ = s.imageCrop,
                y = s.caption,
                E = s.linkTo,
                w = "columns-".concat(m, " ").concat(_ ? "is-cropped" : "");
            return (0, v.createElement)("figure", k.useBlockProps.save({
              className: w
            }), (0, v.createElement)("ul", {
              className: "blocks-gallery-grid"
            }, c.map(function (l) {
              var s;

              switch (E) {
                case S:
                  s = l.fullUrl || l.url;
                  break;

                case P:
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id,
                "data-full-url": l.fullUrl,
                "data-link": l.link,
                className: l.id ? "wp-image-".concat(l.id) : null
              });
              return (0, v.createElement)("li", {
                key: l.id || l.url,
                className: "blocks-gallery-item"
              }, (0, v.createElement)("figure", null, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c, !k.RichText.isEmpty(l.caption) && (0, v.createElement)(k.RichText.Content, {
                tagName: "figcaption",
                className: "blocks-gallery-item__caption",
                value: l.caption
              })));
            })), !k.RichText.isEmpty(y) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              className: "blocks-gallery-caption",
              value: y
            }));
          },
          migrate: function migrate(l) {
            return (0, C.isGalleryV2Enabled)() ? runV2Migration(l) : l;
          }
        }, {
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: ".blocks-gallery-item",
              query: {
                url: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                fullUrl: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-full-url"
                },
                link: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                alt: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                caption: {
                  type: "string",
                  source: "html",
                  selector: ".blocks-gallery-item__caption"
                }
              }
            },
            ids: {
              type: "array",
              items: {
                type: "number"
              },
              default: []
            },
            columns: {
              type: "number",
              minimum: 1,
              maximum: 8
            },
            caption: {
              type: "string",
              source: "html",
              selector: ".blocks-gallery-caption"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string",
              default: "none"
            },
            sizeSlug: {
              type: "string",
              default: "large"
            }
          },
          supports: {
            align: !0
          },
          isEligible: function isEligible(l) {
            var s = l.linkTo;
            return !s || "attachment" === s || "media" === s;
          },
          migrate: function migrate(l) {
            if ((0, C.isGalleryV2Enabled)()) return runV2Migration(l);
            var s = l.linkTo;
            return l.linkTo ? "attachment" === l.linkTo ? s = "post" : "media" === l.linkTo && (s = "file") : s = "none", _objectSpread(_objectSpread({}, l), {}, {
              linkTo: s
            });
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns2 = s.columns,
                m = _s$columns2 === void 0 ? defaultColumnsNumberV1(s) : _s$columns2,
                _ = s.imageCrop,
                y = s.caption,
                E = s.linkTo;
            return (0, v.createElement)("figure", {
              className: "columns-".concat(m, " ").concat(_ ? "is-cropped" : "")
            }, (0, v.createElement)("ul", {
              className: "blocks-gallery-grid"
            }, c.map(function (l) {
              var s;

              switch (E) {
                case "media":
                  s = l.fullUrl || l.url;
                  break;

                case "attachment":
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id,
                "data-full-url": l.fullUrl,
                "data-link": l.link,
                className: l.id ? "wp-image-".concat(l.id) : null
              });
              return (0, v.createElement)("li", {
                key: l.id || l.url,
                className: "blocks-gallery-item"
              }, (0, v.createElement)("figure", null, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c, !k.RichText.isEmpty(l.caption) && (0, v.createElement)(k.RichText.Content, {
                tagName: "figcaption",
                className: "blocks-gallery-item__caption",
                value: l.caption
              })));
            })), !k.RichText.isEmpty(y) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              className: "blocks-gallery-caption",
              value: y
            }));
          }
        }, {
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: ".blocks-gallery-item",
              query: {
                url: {
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                fullUrl: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-full-url"
                },
                link: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                alt: {
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                caption: {
                  type: "string",
                  source: "html",
                  selector: ".blocks-gallery-item__caption"
                }
              }
            },
            ids: {
              type: "array",
              default: []
            },
            columns: {
              type: "number"
            },
            caption: {
              type: "string",
              source: "html",
              selector: ".blocks-gallery-caption"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string",
              default: "none"
            }
          },
          supports: {
            align: !0
          },
          isEligible: function isEligible(l) {
            var s = l.ids;
            return s && s.some(function (l) {
              return "string" == typeof l;
            });
          },
          migrate: function migrate(l) {
            return (0, C.isGalleryV2Enabled)() ? runV2Migration(l) : _objectSpread(_objectSpread({}, l), {}, {
              ids: (0, y.map)(l.ids, function (l) {
                var s = parseInt(l, 10);
                return Number.isInteger(s) ? s : null;
              })
            });
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns3 = s.columns,
                m = _s$columns3 === void 0 ? defaultColumnsNumberV1(s) : _s$columns3,
                _ = s.imageCrop,
                y = s.caption,
                E = s.linkTo;
            return (0, v.createElement)("figure", {
              className: "columns-".concat(m, " ").concat(_ ? "is-cropped" : "")
            }, (0, v.createElement)("ul", {
              className: "blocks-gallery-grid"
            }, c.map(function (l) {
              var s;

              switch (E) {
                case "media":
                  s = l.fullUrl || l.url;
                  break;

                case "attachment":
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id,
                "data-full-url": l.fullUrl,
                "data-link": l.link,
                className: l.id ? "wp-image-".concat(l.id) : null
              });
              return (0, v.createElement)("li", {
                key: l.id || l.url,
                className: "blocks-gallery-item"
              }, (0, v.createElement)("figure", null, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c, !k.RichText.isEmpty(l.caption) && (0, v.createElement)(k.RichText.Content, {
                tagName: "figcaption",
                className: "blocks-gallery-item__caption",
                value: l.caption
              })));
            })), !k.RichText.isEmpty(y) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              className: "blocks-gallery-caption",
              value: y
            }));
          }
        }, {
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: "ul.wp-block-gallery .blocks-gallery-item",
              query: {
                url: {
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                fullUrl: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-full-url"
                },
                alt: {
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                link: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                caption: {
                  type: "array",
                  source: "children",
                  selector: "figcaption"
                }
              }
            },
            ids: {
              type: "array",
              default: []
            },
            columns: {
              type: "number"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string",
              default: "none"
            }
          },
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns4 = s.columns,
                m = _s$columns4 === void 0 ? defaultColumnsNumberV1(s) : _s$columns4,
                _ = s.imageCrop,
                y = s.linkTo;
            return (0, v.createElement)("ul", {
              className: "columns-".concat(m, " ").concat(_ ? "is-cropped" : "")
            }, c.map(function (l) {
              var s;

              switch (y) {
                case "media":
                  s = l.fullUrl || l.url;
                  break;

                case "attachment":
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id,
                "data-full-url": l.fullUrl,
                "data-link": l.link,
                className: l.id ? "wp-image-".concat(l.id) : null
              });
              return (0, v.createElement)("li", {
                key: l.id || l.url,
                className: "blocks-gallery-item"
              }, (0, v.createElement)("figure", null, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c, l.caption && l.caption.length > 0 && (0, v.createElement)(k.RichText.Content, {
                tagName: "figcaption",
                value: l.caption
              })));
            }));
          },
          migrate: function migrate(l) {
            return (0, C.isGalleryV2Enabled)() ? runV2Migration(l) : l;
          }
        }, {
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: "ul.wp-block-gallery .blocks-gallery-item",
              query: {
                url: {
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                alt: {
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                link: {
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                caption: {
                  type: "array",
                  source: "children",
                  selector: "figcaption"
                }
              }
            },
            columns: {
              type: "number"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string",
              default: "none"
            }
          },
          isEligible: function isEligible(l) {
            var s = l.images,
                c = l.ids;
            return s && s.length > 0 && (!c && s || c && s && c.length !== s.length || (0, y.some)(s, function (l, s) {
              return !l && null !== c[s] || parseInt(l, 10) !== c[s];
            }));
          },
          migrate: function migrate(l) {
            return (0, C.isGalleryV2Enabled)() ? runV2Migration(l) : _objectSpread(_objectSpread({}, l), {}, {
              ids: (0, y.map)(l.images, function (l) {
                var s = l.id;
                return s ? parseInt(s, 10) : null;
              })
            });
          },
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns5 = s.columns,
                m = _s$columns5 === void 0 ? defaultColumnsNumberV1(s) : _s$columns5,
                _ = s.imageCrop,
                y = s.linkTo;
            return (0, v.createElement)("ul", {
              className: "columns-".concat(m, " ").concat(_ ? "is-cropped" : "")
            }, c.map(function (l) {
              var s;

              switch (y) {
                case "media":
                  s = l.url;
                  break;

                case "attachment":
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id,
                "data-link": l.link,
                className: l.id ? "wp-image-".concat(l.id) : null
              });
              return (0, v.createElement)("li", {
                key: l.id || l.url,
                className: "blocks-gallery-item"
              }, (0, v.createElement)("figure", null, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c, l.caption && l.caption.length > 0 && (0, v.createElement)(k.RichText.Content, {
                tagName: "figcaption",
                value: l.caption
              })));
            }));
          }
        }, {
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: "div.wp-block-gallery figure.blocks-gallery-image img",
              query: {
                url: {
                  source: "attribute",
                  attribute: "src"
                },
                alt: {
                  source: "attribute",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  source: "attribute",
                  attribute: "data-id"
                }
              }
            },
            columns: {
              type: "number"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            linkTo: {
              type: "string",
              default: "none"
            },
            align: {
              type: "string",
              default: "none"
            }
          },
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.images,
                _s$columns6 = s.columns,
                m = _s$columns6 === void 0 ? defaultColumnsNumberV1(s) : _s$columns6,
                y = s.align,
                k = s.imageCrop,
                E = s.linkTo,
                w = (0, _.default)("columns-".concat(m), {
              alignnone: "none" === y,
              "is-cropped": k
            });
            return (0, v.createElement)("div", {
              className: w
            }, c.map(function (l) {
              var s;

              switch (E) {
                case "media":
                  s = l.url;
                  break;

                case "attachment":
                  s = l.link;
              }

              var c = (0, v.createElement)("img", {
                src: l.url,
                alt: l.alt,
                "data-id": l.id
              });
              return (0, v.createElement)("figure", {
                key: l.id || l.url,
                className: "blocks-gallery-image"
              }, s ? (0, v.createElement)("a", {
                href: s
              }, c) : c);
            }));
          },
          migrate: function migrate(l) {
            return (0, C.isGalleryV2Enabled)() ? runV2Migration(l) : l;
          }
        }];
        s.default = T;
      },
      6496: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(3200),
            y = c(4892),
            k = m(c(6364)),
            E = m(c(4005)),
            w = c(651);

        var C = (0, _.compose)([y.withNotices])(function GalleryEditWrapper(l) {
          return (0, w.isGalleryV2Enabled)() ? (0, v.createElement)(k.default, l) : (0, v.createElement)(E.default, l);
        });
        s.default = C;
      },
      6364: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(4793),
            E = c(3200),
            w = c(4892),
            C = c(1326),
            S = c(6756),
            P = c(8467),
            T = c(1627),
            B = c(1666),
            z = c(6700),
            L = c(9388),
            V = c(8448),
            A = c(5291),
            R = c(651),
            O = c(4874),
            D = c(1305),
            F = m(c(2406)),
            G = c(6785),
            q = m(c(1258)),
            W = m(c(389)),
            U = m(c(2592)),
            $ = m(c(2901));

        var Z = [{
          value: G.LINK_DESTINATION_ATTACHMENT,
          label: (0, S.__)("Attachment Page")
        }, {
          value: G.LINK_DESTINATION_MEDIA,
          label: (0, S.__)("Media File")
        }, {
          value: G.LINK_DESTINATION_NONE,
          label: (0, S._x)("None", "Media item link option")
        }],
            K = ["image"],
            Q = v.Platform.isNative ? (0, S.__)("ADD MEDIA") : (0, S.__)("Drag images, upload new ones or select files from your library."),
            Y = v.Platform.isNative ? {
          type: "stepper"
        } : {};
        var X = (0, E.compose)([w.withNotices, (0, T.withViewportMatch)({
          isNarrow: "< small"
        })])(function GalleryEdit(l) {
          var s = l.setAttributes,
              c = l.attributes,
              m = l.className,
              E = l.clientId,
              T = l.noticeOperations,
              X = l.isSelected,
              J = l.noticeUI,
              ee = l.insertBlocksAfter,
              te = c.columns,
              re = c.imageCrop,
              ae = c.linkTarget,
              oe = c.linkTo,
              ne = c.shortCodeTransforms,
              le = c.sizeSlug,
              _ref95 = (0, P.useDispatch)(C.store),
              ie = _ref95.__unstableMarkNextChangeAsNotPersistent,
              se = _ref95.replaceInnerBlocks,
              ce = _ref95.updateBlockAttributes,
              _ref96 = (0, P.useDispatch)(V.store),
              ue = _ref96.createSuccessNotice,
              _ref97 = (0, P.useSelect)(function (l) {
            var s;

            var c = l(C.store).getSettings().__experimentalPreferredStyleVariations;

            return {
              getBlock: l(C.store).getBlock,
              getSettings: l(C.store).getSettings,
              preferredStyle: null == c || null === (s = c.value) || void 0 === s ? void 0 : s["core/image"]
            };
          }, []),
              de = _ref97.getBlock,
              me = _ref97.getSettings,
              pe = _ref97.preferredStyle,
              ge = (0, P.useSelect)(function (l) {
            var s;
            return null === (s = l(C.store).getBlock(E)) || void 0 === s ? void 0 : s.innerBlocks;
          }, [E]),
              ve = (0, v.useMemo)(function () {
            return null == ge ? void 0 : ge.map(function (l) {
              return {
                clientId: l.clientId,
                id: l.attributes.id,
                url: l.attributes.url,
                attributes: l.attributes,
                fromSavedContent: Boolean(l.originalContent)
              };
            });
          }, [ge]),
              he = (0, $.default)(ge),
              be = (0, U.default)(ve, he);

          (0, v.useEffect)(function () {
            null == be || be.forEach(function (l) {
              ce(l.clientId, _objectSpread(_objectSpread({}, buildImageAttributes(l.attributes)), {}, {
                id: l.id,
                align: void 0
              }));
            });
          }, [be]);

          var _e = (0, W.default)(ne);

          (0, v.useEffect)(function () {
            ne && _e && (updateImages(_e), s({
              shortCodeTransforms: void 0
            }));
          }, [ne, _e]);
          var fe = (0, q.default)(he, X, me);

          function buildImageAttributes(l) {
            var s = l.id ? (0, k.find)(he, {
              id: l.id
            }) : null;
            var m;
            return m = l.className && "" !== l.className ? l.className : pe ? "is-style-".concat(pe) : void 0, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, R.pickRelevantMediaFiles)(l, le)), (0, O.getHrefAndDestination)(s, oe)), (0, D.getUpdatedLinkTargetSettings)(ae, c)), {}, {
              className: m,
              sizeSlug: le
            });
          }

          function isValidFileType(l) {
            var s;
            return K.some(function (s) {
              var c;
              return 0 === (null === (c = l.type) || void 0 === c ? void 0 : c.indexOf(s));
            }) || 0 === (null === (s = l.url) || void 0 === s ? void 0 : s.indexOf("blob:"));
          }

          function updateImages(l) {
            var s = "[object FileList]" === Object.prototype.toString.call(l),
                c = s ? Array.from(l).map(function (l) {
              return l.url ? l : (0, R.pickRelevantMediaFiles)({
                url: (0, L.createBlobURL)(l)
              });
            }) : l;
            c.every(isValidFileType) || (T.removeAllNotices(), T.createErrorNotice((0, S.__)("If uploading to a gallery all files need to be image formats"), {
              id: "gallery-upload-invalid-file"
            }));

            var m = c.filter(function (l) {
              return l.url || isValidFileType(l);
            }).map(function (l) {
              return l.url ? l : (0, R.pickRelevantMediaFiles)({
                url: (0, L.createBlobURL)(l)
              });
            }),
                v = m.reduce(function (l, s, c) {
              return l[s.id] = c, l;
            }, {}),
                _ = s ? ge : ge.filter(function (l) {
              return m.find(function (s) {
                return s.id === l.attributes.id;
              });
            }),
                y = m.filter(function (l) {
              return !_.find(function (s) {
                return l.id === s.attributes.id;
              });
            }).map(function (l) {
              return (0, z.createBlock)("core/image", {
                id: l.id,
                url: l.url,
                caption: l.caption,
                alt: l.alt
              });
            });

            se(E, (0, k.concat)(_, y).sort(function (l, s) {
              return v[l.attributes.id] - v[s.attributes.id];
            }));
          }

          (0, v.useEffect)(function () {
            var l, c, m, v, _, y;

            oe || (ie(), s({
              linkTo: (null === (l = window) || void 0 === l || null === (c = l.wp) || void 0 === c || null === (m = c.media) || void 0 === m || null === (v = m.view) || void 0 === v || null === (_ = v.settings) || void 0 === _ || null === (y = _.defaultProps) || void 0 === y ? void 0 : y.link) || G.LINK_DESTINATION_NONE
            }));
          }, [oe]);
          var ye = !!ve.length,
              ke = ye && ve.some(function (l) {
            return !!l.id;
          }),
              Ee = ve.some(function (l) {
            var s;
            return !l.id && 0 === (null === (s = l.url) || void 0 === s ? void 0 : s.indexOf("blob:"));
          }),
              we = (0, v.createElement)(C.MediaPlaceholder, {
            addToGallery: ke,
            handleUpload: !1,
            isAppender: ye,
            disableMediaButtons: ye && !X || Ee,
            icon: !ye && A.sharedIcon,
            labels: {
              title: !ye && (0, S.__)("Gallery"),
              instructions: !ye && Q
            },
            onSelect: updateImages,
            accept: "image/*",
            allowedTypes: K,
            multiple: !0,
            value: ke ? ve : {},
            onError: function onUploadError(l) {
              T.removeAllNotices(), T.createErrorNotice(l);
            },
            notices: ye ? void 0 : J
          }),
              Ce = (0, C.useBlockProps)({
            className: (0, y.default)(m, "has-nested-images")
          });
          if (!ye) return (0, v.createElement)(B.View, Ce, we);
          var xe = oe && "none" !== oe;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.InspectorControls, null, (0, v.createElement)(w.PanelBody, {
            title: (0, S.__)("Gallery settings")
          }, ve.length > 1 && (0, v.createElement)(w.RangeControl, (0, _.default)({
            label: (0, S.__)("Columns"),
            value: te || (0, R.defaultColumnsNumber)(ve.length),
            onChange: function setColumnsNumber(l) {
              s({
                columns: l
              });
            },
            min: 1,
            max: Math.min(8, ve.length)
          }, Y, {
            required: !0
          })), (0, v.createElement)(w.ToggleControl, {
            label: (0, S.__)("Crop images"),
            checked: !!re,
            onChange: function toggleImageCrop() {
              s({
                imageCrop: !re
              });
            },
            help: function getImageCropHelp(l) {
              return l ? (0, S.__)("Thumbnails are cropped to align.") : (0, S.__)("Thumbnails are not cropped.");
            }
          }), (0, v.createElement)(w.SelectControl, {
            label: (0, S.__)("Link to"),
            value: oe,
            onChange: function setLinkTo(l) {
              s({
                linkTo: l
              });
              var c = {},
                  m = [];
              de(E).innerBlocks.forEach(function (s) {
                m.push(s.clientId);
                var v = s.attributes.id ? (0, k.find)(he, {
                  id: s.attributes.id
                }) : null;
                c[s.clientId] = (0, O.getHrefAndDestination)(v, l);
              }), ce(m, c, !0);
              var v = [].concat(Z).find(function (s) {
                return s.value === l;
              });
              ue((0, S.sprintf)((0, S.__)("All gallery image links updated to: %s"), v.label), {
                id: "gallery-attributes-linkTo",
                type: "snackbar"
              });
            },
            options: Z,
            hideCancelButton: !0
          }), xe && (0, v.createElement)(w.ToggleControl, {
            label: (0, S.__)("Open in new tab"),
            checked: "_blank" === ae,
            onChange: function toggleOpenInNewTab(l) {
              var c = l ? "_blank" : void 0;
              s({
                linkTarget: c
              });
              var m = {},
                  v = [];
              de(E).innerBlocks.forEach(function (l) {
                v.push(l.clientId), m[l.clientId] = (0, D.getUpdatedLinkTargetSettings)(c, l.attributes);
              }), ce(v, m, !0);

              var _ = l ? (0, S.__)("All gallery images updated to open in new tab") : (0, S.__)("All gallery images updated to not open in new tab");

              ue(_, {
                id: "gallery-attributes-openInNewTab",
                type: "snackbar"
              });
            }
          }), (null == fe ? void 0 : fe.length) > 0 && (0, v.createElement)(w.SelectControl, {
            label: (0, S.__)("Image size"),
            value: le,
            options: fe,
            onChange: function updateImagesSize(l) {
              s({
                sizeSlug: l
              });
              var c = {},
                  m = [];
              de(E).innerBlocks.forEach(function (s) {
                m.push(s.clientId);
                var v = s.attributes.id ? (0, k.find)(he, {
                  id: s.attributes.id
                }) : null;
                c[s.clientId] = (0, D.getImageSizeAttributes)(v, l);
              }), ce(m, c, !0);
              var v = fe.find(function (s) {
                return s.value === l;
              });
              ue((0, S.sprintf)((0, S.__)("All gallery image sizes updated to: %s"), v.label), {
                id: "gallery-attributes-sizeSlug",
                type: "snackbar"
              });
            },
            hideCancelButton: !0
          }), v.Platform.isWeb && !fe && ke && (0, v.createElement)(w.BaseControl, {
            className: "gallery-image-sizes"
          }, (0, v.createElement)(w.BaseControl.VisualLabel, null, (0, S.__)("Image size")), (0, v.createElement)(B.View, {
            className: "gallery-image-sizes__loading"
          }, (0, v.createElement)(w.Spinner, null), (0, S.__)("Loading options…"))))), J, (0, v.createElement)(F.default, (0, _.default)({}, l, {
            images: ve,
            mediaPlaceholder: we,
            blockProps: Ce,
            insertBlocksAfter: ee
          })));
        });
        s.default = X;
      },
      2406: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.Gallery = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(6700),
            S = c(1666);

        var P = ["core/image"],
            Gallery = function Gallery(l) {
          var _ref101;

          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              E = l.mediaPlaceholder,
              T = l.insertBlocksAfter,
              B = l.blockProps,
              z = s.align,
              L = s.columns,
              V = s.caption,
              A = s.imageCrop,
              _ref98 = (0, k.useInnerBlocksProps)(B, {
            allowedBlocks: P,
            orientation: "horizontal",
            renderAppender: !1,
            __experimentalLayout: {
              type: "default",
              alignments: []
            }
          }),
              R = _ref98.children,
              O = _objectWithoutProperties(_ref98, _excluded5),
              _ref99 = (0, v.useState)(!1),
              _ref100 = _slicedToArray2(_ref99, 2),
              D = _ref100[0],
              F = _ref100[1];

          return (0, v.useEffect)(function () {
            c || F(!1);
          }, [c]), (0, v.createElement)("figure", (0, _.default)({}, O, {
            className: (0, y.default)(B.className, "blocks-gallery-grid", (_ref101 = {}, _defineProperty(_ref101, "align".concat(z), z), _defineProperty(_ref101, "columns-".concat(L), void 0 !== L), _defineProperty(_ref101, "columns-default", void 0 === L), _defineProperty(_ref101, "is-cropped", A), _ref101))
          }), R, (0, v.createElement)(S.View, {
            className: "blocks-gallery-media-placeholder-wrapper",
            onClick: function removeCaptionFocus() {
              D && F(!1);
            }
          }, E), (0, v.createElement)(RichTextVisibilityHelper, {
            isHidden: !c && k.RichText.isEmpty(V),
            captionFocused: D,
            onFocusCaption: function onFocusCaption() {
              D || F(!0);
            },
            tagName: "figcaption",
            className: "blocks-gallery-caption",
            "aria-label": (0, w.__)("Gallery caption text"),
            placeholder: (0, w.__)("Write gallery caption…"),
            value: V,
            onChange: function onChange(l) {
              return m({
                caption: l
              });
            },
            inlineToolbar: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return T((0, C.createBlock)("core/paragraph"));
            }
          }));
        };

        function RichTextVisibilityHelper(l) {
          var s = l.isHidden,
              c = l.captionFocused,
              m = l.onFocusCaption,
              y = l.className,
              w = l.value,
              C = l.placeholder,
              S = l.tagName,
              P = l.captionRef,
              T = _objectWithoutProperties(l, _excluded6);

          return s ? (0, v.createElement)(E.VisuallyHidden, (0, _.default)({
            as: k.RichText
          }, T)) : (0, v.createElement)(k.RichText, (0, _.default)({
            ref: P,
            value: w,
            placeholder: C,
            className: y,
            tagName: S,
            isSelected: c,
            onClick: m
          }, T));
        }

        s.Gallery = Gallery;
        var T = Gallery;
        s.default = T;
      },
      4226: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(127)),
            y = m(c(6496)),
            k = m(c(7412)),
            E = m(c(8844));

        var w = {
          apiVersion: 2,
          name: "core/gallery",
          title: "Gallery",
          category: "media",
          description: "Display multiple images in a rich gallery.",
          keywords: ["images", "photos"],
          textdomain: "default",
          attributes: {
            images: {
              type: "array",
              default: [],
              source: "query",
              selector: ".blocks-gallery-item",
              query: {
                url: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "src"
                },
                fullUrl: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-full-url"
                },
                link: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-link"
                },
                alt: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "alt",
                  default: ""
                },
                id: {
                  type: "string",
                  source: "attribute",
                  selector: "img",
                  attribute: "data-id"
                },
                caption: {
                  type: "string",
                  source: "html",
                  selector: ".blocks-gallery-item__caption"
                }
              }
            },
            ids: {
              type: "array",
              items: {
                type: "number"
              },
              default: []
            },
            shortCodeTransforms: {
              type: "array",
              default: [],
              items: {
                type: "object"
              }
            },
            columns: {
              type: "number",
              minimum: 1,
              maximum: 8
            },
            caption: {
              type: "string",
              source: "html",
              selector: ".blocks-gallery-caption"
            },
            imageCrop: {
              type: "boolean",
              default: !0
            },
            fixedHeight: {
              type: "boolean",
              default: !0
            },
            linkTarget: {
              type: "string"
            },
            linkTo: {
              type: "string"
            },
            sizeSlug: {
              type: "string",
              default: "large"
            },
            allowResize: {
              type: "boolean",
              default: !1
            }
          },
          providesContext: {
            allowResize: "allowResize",
            imageCrop: "imageCrop",
            fixedHeight: "fixedHeight"
          },
          supports: {
            anchor: !0,
            align: !0
          },
          editorStyle: "wp-block-gallery-editor",
          style: "wp-block-gallery"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: v.gallery,
          example: {
            attributes: {
              columns: 2
            },
            innerBlocks: [{
              name: "core/image",
              attributes: {
                url: "https://s.w.org/images/core/5.3/Glacial_lakes%2C_Bhutan.jpg"
              }
            }, {
              name: "core/image",
              attributes: {
                url: "https://s.w.org/images/core/5.3/Sediment_off_the_Yucatan_Peninsula.jpg"
              }
            }]
          },
          transforms: E.default,
          edit: y.default,
          save: k.default,
          deprecated: _.default
        };
        s.settings = S;
      },
      7412: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function saveWithInnerBlocks(l) {
          var _ref102;

          var s = l.attributes;
          if (!(0, E.isGalleryV2Enabled)()) return (0, k.default)({
            attributes: s
          });
          var c = s.caption,
              m = s.columns,
              w = s.imageCrop,
              C = (0, _.default)("has-nested-images", (_ref102 = {}, _defineProperty(_ref102, "columns-".concat(m), void 0 !== m), _defineProperty(_ref102, "columns-default", void 0 === m), _defineProperty(_ref102, "is-cropped", w), _ref102)),
              S = y.useBlockProps.save({
            className: C
          }),
              P = y.useInnerBlocksProps.save(S);
          return (0, v.createElement)("figure", P, P.children, !y.RichText.isEmpty(c) && (0, v.createElement)(y.RichText.Content, {
            tagName: "figcaption",
            className: "blocks-gallery-caption",
            value: c
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = m(c(1887)),
            E = c(651);
      },
      5291: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.sharedIcon = void 0;

        var m = c(1753),
            v = c(1326),
            _ = c(5303);

        var y = (0, m.createElement)(v.BlockIcon, {
          icon: _.gallery
        });
        s.sharedIcon = y;
      },
      651: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.defaultColumnsNumber = function defaultColumnsNumber(l) {
          return l ? Math.min(3, l) : 3;
        }, s.isGalleryV2Enabled = function isGalleryV2Enabled() {
          if (!window.wp || "boolean" != typeof window.wp.galleryBlockV2Enabled) throw "window.wp.galleryBlockV2Enabled is not defined";
          return window.wp.galleryBlockV2Enabled;
          return !0;
        }, s.pickRelevantMediaFiles = void 0;
        var m = c(4793);

        s.pickRelevantMediaFiles = function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "large";
          var c = (0, m.pick)(l, ["alt", "id", "link", "caption"]);
          c.url = (0, m.get)(l, ["sizes", s, "url"]) || (0, m.get)(l, ["media_details", "sizes", s, "source_url"]) || l.url;
          var v = (0, m.get)(l, ["sizes", "full", "url"]) || (0, m.get)(l, ["media_details", "sizes", "full", "source_url"]);
          return v && (c.fullUrl = v), c;
        };
      },
      8844: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(4793),
            v = c(6700),
            _ = c(9388),
            y = c(1149),
            k = c(6785),
            E = c(8047),
            w = c(651);

        var parseShortcodeIds = function parseShortcodeIds(l) {
          return l ? l.split(",").map(function (l) {
            return parseInt(l, 10);
          }) : [];
        };

        (0, y.addFilter)("blocks.switchToBlockType.transformedBlock", "core/gallery/update-third-party-transform-to", function updateThirdPartyTransformToGallery(l) {
          var s;

          if ((0, w.isGalleryV2Enabled)() && "core/gallery" === l.name && (null === (s = l.attributes) || void 0 === s ? void 0 : s.images.length) > 0) {
            var _s6 = l.attributes.images.map(function (s) {
              var c = s.url,
                  m = s.id,
                  _ = s.alt;
              return (0, v.createBlock)("core/image", {
                url: c,
                id: m ? parseInt(m, 10) : null,
                alt: _,
                sizeSlug: l.attributes.sizeSlug,
                linkDestination: l.attributes.linkDestination
              });
            });

            delete l.attributes.ids, delete l.attributes.images, l.innerBlocks = _s6;
          }

          return l;
        }), (0, y.addFilter)("blocks.switchToBlockType.transformedBlock", "core/gallery/update-third-party-transform-from", function updateThirdPartyTransformFromGallery(l, s) {
          var c = (Array.isArray(s) ? s : [s]).find(function (s) {
            var c;
            return "core/gallery" === s.name && s.innerBlocks.length > 0 && !(null !== (c = s.attributes.images) && void 0 !== c && c.length) > 0 && !l.name.includes("core/");
          });

          if (c) {
            var _l25 = c.innerBlocks.map(function (l) {
              var _l$attributes10 = l.attributes,
                  s = _l$attributes10.url,
                  c = _l$attributes10.id,
                  m = _l$attributes10.alt;
              return {
                url: s,
                id: c ? parseInt(c, 10) : null,
                alt: m
              };
            }),
                _s7 = _l25.map(function (l) {
              var s = l.id;
              return s;
            });

            c.attributes.images = _l25, c.attributes.ids = _s7;
          }

          return l;
        });
        var C = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/image"],
            transform: function transform(l) {
              var _l$ = l[0],
                  s = _l$.align,
                  c = _l$.sizeSlug;
              s = (0, m.every)(l, ["align", s]) ? s : void 0, c = (0, m.every)(l, ["sizeSlug", c]) ? c : void 0;

              var _ = (0, m.filter)(l, function (l) {
                var s = l.url;
                return s;
              });

              if ((0, w.isGalleryV2Enabled)()) {
                var _l26 = _.map(function (l) {
                  return (0, v.createBlock)("core/image", l);
                });

                return (0, v.createBlock)("core/gallery", {
                  align: s,
                  sizeSlug: c
                }, _l26);
              }

              return (0, v.createBlock)("core/gallery", {
                images: _.map(function (l) {
                  var s = l.id,
                      c = l.url,
                      v = l.alt,
                      _ = l.caption;
                  return {
                    id: (0, m.toString)(s),
                    url: c,
                    alt: v,
                    caption: _
                  };
                }),
                ids: _.map(function (l) {
                  var s = l.id;
                  return parseInt(s, 10);
                }),
                align: s,
                sizeSlug: c
              });
            }
          }, {
            type: "shortcode",
            tag: "gallery",
            attributes: {
              images: {
                type: "array",
                shortcode: function shortcode(l) {
                  var s = l.named.ids;
                  if (!(0, w.isGalleryV2Enabled)()) return parseShortcodeIds(s).map(function (l) {
                    return {
                      id: (0, m.toString)(l)
                    };
                  });
                }
              },
              ids: {
                type: "array",
                shortcode: function shortcode(l) {
                  var s = l.named.ids;
                  if (!(0, w.isGalleryV2Enabled)()) return parseShortcodeIds(s);
                }
              },
              shortCodeTransforms: {
                type: "array",
                shortcode: function shortcode(l) {
                  var s = l.named.ids;
                  if ((0, w.isGalleryV2Enabled)()) return parseShortcodeIds(s).map(function (l) {
                    return {
                      id: parseInt(l)
                    };
                  });
                }
              },
              columns: {
                type: "number",
                shortcode: function shortcode(l) {
                  var _l$named$columns = l.named.columns,
                      s = _l$named$columns === void 0 ? "3" : _l$named$columns;
                  return parseInt(s, 10);
                }
              },
              linkTo: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.link;
                  if (!(0, w.isGalleryV2Enabled)()) switch (s) {
                    case "post":
                    default:
                      return E.LINK_DESTINATION_ATTACHMENT;

                    case "file":
                      return E.LINK_DESTINATION_MEDIA;
                  }

                  switch (s) {
                    case "post":
                      return k.LINK_DESTINATION_ATTACHMENT;

                    case "file":
                      return k.LINK_DESTINATION_MEDIA;

                    default:
                      return k.LINK_DESTINATION_NONE;
                  }
                }
              }
            },
            isMatch: function isMatch(l) {
              var s = l.named;
              return void 0 !== s.ids;
            }
          }, {
            type: "files",
            priority: 1,
            isMatch: function isMatch(l) {
              return 1 !== l.length && (0, m.every)(l, function (l) {
                return 0 === l.type.indexOf("image/");
              });
            },
            transform: function transform(l) {
              if ((0, w.isGalleryV2Enabled)()) {
                var _s8 = l.map(function (l) {
                  return (0, v.createBlock)("core/image", {
                    url: (0, _.createBlobURL)(l)
                  });
                });

                return (0, v.createBlock)("core/gallery", {}, _s8);
              }

              return (0, v.createBlock)("core/gallery", {
                images: l.map(function (l) {
                  return (0, w.pickRelevantMediaFiles)({
                    url: (0, _.createBlobURL)(l)
                  });
                })
              });
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/image"],
            transform: function transform(l, s) {
              var c = l.align,
                  m = l.images,
                  _ = l.ids,
                  y = l.sizeSlug;
              return (0, w.isGalleryV2Enabled)() ? s.length > 0 ? s.map(function (l) {
                var _l$attributes11 = l.attributes,
                    s = _l$attributes11.id,
                    m = _l$attributes11.url,
                    _ = _l$attributes11.alt,
                    y = _l$attributes11.caption,
                    k = _l$attributes11.imageSizeSlug;
                return (0, v.createBlock)("core/image", {
                  id: s,
                  url: m,
                  alt: _,
                  caption: y,
                  sizeSlug: k,
                  align: c
                });
              }) : (0, v.createBlock)("core/image", {
                align: c
              }) : m.length > 0 ? m.map(function (l, s) {
                var m = l.url,
                    k = l.alt,
                    E = l.caption;
                return (0, v.createBlock)("core/image", {
                  id: _[s],
                  url: m,
                  alt: k,
                  caption: E,
                  align: c,
                  sizeSlug: y
                });
              }) : (0, v.createBlock)("core/image", {
                align: c
              });
            }
          }]
        };
        s.default = C;
      },
      2901: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useGetMedia(l) {
          var _ref103 = (0, m.useState)([]),
              _ref104 = _slicedToArray2(_ref103, 2),
              s = _ref104[0],
              c = _ref104[1],
              y = (0, v.useSelect)(function (c) {
            if (null == l || !l.length) return s;
            var m = l.map(function (l) {
              return l.attributes.id;
            }).filter(function (l) {
              return void 0 !== l;
            });
            return 0 === m.length ? s : c(_.store).getMediaItems({
              include: m.join(","),
              per_page: -1
            });
          }, [l]);

          if ((null == y ? void 0 : y.length) !== (null == s ? void 0 : s.length) || null != y && y.some(function (l) {
            return !s.find(function (s) {
              return s.id === l.id;
            });
          })) return c(y), y;
          return s;
        };

        var m = c(1753),
            v = c(8467),
            _ = c(1295);
      },
      2592: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useGetNewImages(l, s) {
          var _ref105 = (0, m.useState)([]),
              _ref106 = _slicedToArray2(_ref105, 2),
              c = _ref106[0],
              v = _ref106[1];

          return (0, m.useMemo)(function () {
            return function getNewImages() {
              var m = !1;

              var _ = c.filter(function (s) {
                return l.find(function (l) {
                  return s.clientId === l.clientId;
                });
              });

              _.length < c.length && (m = !0);
              l.forEach(function (l) {
                l.fromSavedContent && !_.find(function (s) {
                  return s.id === l.id;
                }) && (m = !0, _.push(l));
              });
              var y = l.filter(function (l) {
                return !_.find(function (s) {
                  return l.clientId && s.clientId === l.clientId;
                }) && (null == s ? void 0 : s.find(function (s) {
                  return s.id === l.id;
                })) && !l.fromSavedConent;
              });
              (m || (null == y ? void 0 : y.length) > 0) && v([].concat(_toConsumableArray(_), _toConsumableArray(y)));
              return y.length > 0 ? y : null;
            }();
          }, [l, s]);
        };
        var m = c(1753);
      },
      1258: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useImageSizes(l, s, c) {
          return (0, v.useMemo)(function () {
            return function getImageSizing() {
              if (!l || 0 === l.length) return;

              var _c2 = c(),
                  v = _c2.imageSizes;

              var _ = {};
              s && (_ = l.reduce(function (l, s) {
                if (!s.id) return l;
                var c = v.reduce(function (l, c) {
                  var v = (0, m.get)(s, ["sizes", c.slug, "url"]),
                      _ = (0, m.get)(s, ["media_details", "sizes", c.slug, "source_url"]);

                  return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, c.slug, v || _));
                }, {});
                return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, parseInt(s.id, 10), c));
              }, {}));
              return v.filter(function (l) {
                var s = l.slug;
                return (0, m.some)(_, function (l) {
                  return l[s];
                });
              }).map(function (l) {
                var s = l.name,
                    c = l.slug;
                return {
                  value: c,
                  label: s
                };
              });
            }();
          }, [l, s]);
        };
        var m = c(4793),
            v = c(1753);
      },
      389: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useShortCodeTransform(l) {
          var s = (0, v.useSelect)(function (s) {
            if (!l || 0 === l.length) return;
            var c = s(_.store).getMedia;
            return l.map(function (l) {
              var s = c(l.id);
              if (s) return {
                id: s.id,
                type: "image",
                url: s.source_url,
                mime: s.mime_type,
                alt: s.alt_text,
                link: s.link
              };
            });
          }, [l]);
          if (!s) return;
          if ((0, m.every)(s, function (l) {
            return l && l.url;
          })) return s;
        };

        var m = c(4793),
            v = c(8467),
            _ = c(1295);
      },
      4874: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getHrefAndDestination = function getHrefAndDestination(l, s) {
          switch (s) {
            case m.LINK_DESTINATION_MEDIA:
              return {
                href: (null == l ? void 0 : l.source_url) || (null == l ? void 0 : l.url),
                linkDestination: v.LINK_DESTINATION_MEDIA
              };

            case m.LINK_DESTINATION_ATTACHMENT:
              return {
                href: null == l ? void 0 : l.link,
                linkDestination: v.LINK_DESTINATION_ATTACHMENT
              };

            case m.LINK_DESTINATION_NONE:
              return {
                href: void 0,
                linkDestination: v.LINK_DESTINATION_NONE
              };
          }

          return {};
        };
        var m = c(6785),
            v = c(7814);
      },
      8047: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LINK_DESTINATION_NONE = s.LINK_DESTINATION_MEDIA = s.LINK_DESTINATION_ATTACHMENT = void 0;
        s.LINK_DESTINATION_NONE = "none";
        s.LINK_DESTINATION_MEDIA = "file";
        s.LINK_DESTINATION_ATTACHMENT = "post";
      },
      4005: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = c(4793),
            k = c(3200),
            E = c(4892),
            w = c(1326),
            C = c(6756),
            S = c(9388),
            P = c(8467),
            T = c(1627),
            B = c(1666),
            z = c(1295),
            L = c(5291),
            V = c(7604),
            A = c(127),
            R = m(c(469)),
            O = c(8047);

        var D = [{
          value: O.LINK_DESTINATION_ATTACHMENT,
          label: (0, C.__)("Attachment Page")
        }, {
          value: O.LINK_DESTINATION_MEDIA,
          label: (0, C.__)("Media File")
        }, {
          value: O.LINK_DESTINATION_NONE,
          label: (0, C.__)("None")
        }],
            F = ["image"],
            G = v.Platform.select({
          web: (0, C.__)("Drag images, upload new ones or select files from your library."),
          native: (0, C.__)("ADD MEDIA")
        }),
            q = v.Platform.select({
          web: {},
          native: {
            type: "stepper"
          }
        });
        var W = (0, k.compose)([E.withNotices, (0, T.withViewportMatch)({
          isNarrow: "< small"
        })])(function GalleryEdit(l) {
          var s = l.attributes,
              c = l.clientId,
              m = l.isSelected,
              k = l.noticeUI,
              T = l.noticeOperations,
              W = l.onFocus,
              _s$columns7 = s.columns,
              U = _s$columns7 === void 0 ? (0, A.defaultColumnsNumberV1)(s) : _s$columns7,
              $ = s.imageCrop,
              Z = s.images,
              K = s.linkTo,
              Q = s.sizeSlug,
              _ref107 = (0, v.useState)(),
              _ref108 = _slicedToArray2(_ref107, 2),
              Y = _ref108[0],
              X = _ref108[1],
              _ref109 = (0, v.useState)(),
              _ref110 = _slicedToArray2(_ref109, 2),
              J = _ref110[0],
              ee = _ref110[1],
              _ref111 = (0, P.useDispatch)(w.store),
              te = _ref111.__unstableMarkNextChangeAsNotPersistent,
              _ref112 = (0, P.useSelect)(function (l) {
            var s = l(w.store).getSettings();
            return {
              imageSizes: s.imageSizes,
              mediaUpload: s.mediaUpload,
              getMedia: l(z.store).getMedia,
              wasBlockJustInserted: l(w.store).wasBlockJustInserted(c, "inserter_menu")
            };
          }),
              re = _ref112.imageSizes,
              ae = _ref112.mediaUpload,
              oe = _ref112.getMedia,
              ne = _ref112.wasBlockJustInserted,
              le = (0, v.useMemo)(function () {
            return m ? (0, y.reduce)(s.ids, function (l, s) {
              if (!s) return l;
              var c = oe(s),
                  m = (0, y.reduce)(re, function (l, s) {
                var m = (0, y.get)(c, ["sizes", s.slug, "url"]),
                    v = (0, y.get)(c, ["media_details", "sizes", s.slug, "source_url"]);
                return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.slug, m || v));
              }, {});
              return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, parseInt(s, 10), m));
            }, {}) : {};
          }, [m, s.ids, re]);

          function setAttributes(s) {
            if (s.ids) throw new Error('The "ids" attribute should not be changed directly. It is managed automatically when "images" attribute changes');
            s.images && (s = _objectSpread(_objectSpread({}, s), {}, {
              ids: (0, y.map)(s.images, function (l) {
                var s = l.id;
                return parseInt(s, 10);
              })
            })), l.setAttributes(s);
          }

          function onMove(l, s) {
            var c = _toConsumableArray(Z);

            c.splice(s, 1, Z[l]), c.splice(l, 1, Z[s]), X(s), setAttributes({
              images: c
            });
          }

          function selectCaption(l) {
            var s = (0, y.toString)(l.id),
                c = (0, y.find)(Z, {
              id: s
            }),
                m = c ? c.caption : l.caption;
            if (!J) return m;
            var v = (0, y.find)(J, {
              id: s
            });
            return v && v.caption !== l.caption ? l.caption : m;
          }

          function onSelectImages(l) {
            ee(l.map(function (l) {
              return {
                id: (0, y.toString)(l.id),
                caption: l.caption
              };
            })), setAttributes({
              images: l.map(function (l) {
                return _objectSpread(_objectSpread({}, (0, V.pickRelevantMediaFiles)(l, Q)), {}, {
                  caption: selectCaption(l),
                  id: (0, y.toString)(l.id)
                });
              }),
              columns: s.columns ? Math.min(l.length, s.columns) : s.columns
            });
          }

          (0, v.useEffect)(function () {
            if ("web" === v.Platform.OS && Z && Z.length > 0 && (0, y.every)(Z, function (l) {
              var s = l.url;
              return (0, S.isBlobURL)(s);
            })) {
              var _l27 = (0, y.map)(Z, function (l) {
                var s = l.url;
                return (0, S.getBlobByURL)(s);
              });

              (0, y.forEach)(Z, function (l) {
                var s = l.url;
                return (0, S.revokeBlobURL)(s);
              }), ae({
                filesList: _l27,
                onFileChange: onSelectImages,
                allowedTypes: ["image"]
              });
            }
          }, []), (0, v.useEffect)(function () {
            m || X();
          }, [m]), (0, v.useEffect)(function () {
            var l, s, c, m, v, _;

            K || (te(), setAttributes({
              linkTo: (null === (l = window) || void 0 === l || null === (s = l.wp) || void 0 === s || null === (c = s.media) || void 0 === c || null === (m = c.view) || void 0 === m || null === (v = m.settings) || void 0 === v || null === (_ = v.defaultProps) || void 0 === _ ? void 0 : _.link) || O.LINK_DESTINATION_NONE
            }));
          }, [K]);
          var ie = !!Z.length,
              se = ie && Z.some(function (l) {
            return !!l.id;
          }),
              ce = (0, v.createElement)(w.MediaPlaceholder, {
            addToGallery: se,
            isAppender: ie,
            disableMediaButtons: ie && !m,
            icon: !ie && L.sharedIcon,
            labels: {
              title: !ie && (0, C.__)("Gallery"),
              instructions: !ie && G
            },
            onSelect: onSelectImages,
            accept: "image/*",
            allowedTypes: F,
            multiple: !0,
            value: se ? Z : {},
            onError: function onUploadError(l) {
              T.removeAllNotices(), T.createErrorNotice(l);
            },
            notices: ie ? void 0 : k,
            onFocus: W,
            autoOpenMediaUpload: !ie && m && ne
          }),
              ue = (0, w.useBlockProps)();
          if (!ie) return (0, v.createElement)(B.View, ue, ce);

          var de = function getImagesSizeOptions() {
            return (0, y.map)((0, y.filter)(re, function (l) {
              var s = l.slug;
              return (0, y.some)(le, function (l) {
                return l[s];
              });
            }), function (l) {
              var s = l.name,
                  c = l.slug;
              return {
                value: c,
                label: s
              };
            });
          }(),
              me = ie && !(0, y.isEmpty)(de);

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, C.__)("Gallery settings")
          }, Z.length > 1 && (0, v.createElement)(E.RangeControl, (0, _.default)({
            label: (0, C.__)("Columns"),
            value: U,
            onChange: function setColumnsNumber(l) {
              setAttributes({
                columns: l
              });
            },
            min: 1,
            max: Math.min(8, Z.length)
          }, q, {
            required: !0
          })), (0, v.createElement)(E.ToggleControl, {
            label: (0, C.__)("Crop images"),
            checked: !!$,
            onChange: function toggleImageCrop() {
              setAttributes({
                imageCrop: !$
              });
            },
            help: function getImageCropHelp(l) {
              return l ? (0, C.__)("Thumbnails are cropped to align.") : (0, C.__)("Thumbnails are not cropped.");
            }
          }), (0, v.createElement)(E.SelectControl, {
            label: (0, C.__)("Link to"),
            value: K,
            onChange: function setLinkTo(l) {
              setAttributes({
                linkTo: l
              });
            },
            options: D,
            hideCancelButton: !0
          }), me && (0, v.createElement)(E.SelectControl, {
            label: (0, C.__)("Image size"),
            value: Q,
            options: de,
            onChange: function updateImagesSize(l) {
              setAttributes({
                images: (0, y.map)(Z, function (s) {
                  if (!s.id) return s;
                  var c = (0, y.get)(le, [parseInt(s.id, 10), l]);
                  return _objectSpread(_objectSpread({}, s), c && {
                    url: c
                  });
                }),
                sizeSlug: l
              });
            },
            hideCancelButton: !0
          }))), k, (0, v.createElement)(R.default, (0, _.default)({}, l, {
            selectedImage: Y,
            mediaPlaceholder: ce,
            onMoveBackward: function onMoveBackward(l) {
              return function () {
                0 !== l && onMove(l, l - 1);
              };
            },
            onMoveForward: function onMoveForward(l) {
              return function () {
                l !== Z.length - 1 && onMove(l, l + 1);
              };
            },
            onRemoveImage: function onRemoveImage(l) {
              return function () {
                var c = (0, y.filter)(Z, function (s, c) {
                  return l !== c;
                });
                X(), setAttributes({
                  images: c,
                  columns: s.columns ? Math.min(c.length, s.columns) : s.columns
                });
              };
            },
            onSelectImage: function onSelectImage(l) {
              return function () {
                X(l);
              };
            },
            onDeselectImage: function onDeselectImage() {
              return function () {
                X();
              };
            },
            onSetImageAttributes: function setImageAttributes(l, s) {
              Z[l] && setAttributes({
                images: [].concat(_toConsumableArray(Z.slice(0, l)), [_objectSpread(_objectSpread({}, Z[l]), s)], _toConsumableArray(Z.slice(l + 1)))
              });
            },
            blockProps: ue,
            onFocusGalleryCaption: function onFocusGalleryCaption() {
              X();
            }
          })));
        });
        s.default = W;
      },
      9907: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(4892),
            E = c(6756),
            w = c(9880),
            C = c(8467),
            S = c(1326),
            P = c(9388),
            T = c(3200),
            B = c(5303),
            z = c(1295),
            L = c(7604),
            V = c(8047);

        var GalleryImage = /*#__PURE__*/function (_v$Component2) {
          _inherits(GalleryImage, _v$Component2);

          var _super2 = _createSuper(GalleryImage);

          function GalleryImage() {
            var _this2;

            _classCallCheck2(this, GalleryImage);

            _this2 = _super2.apply(this, arguments), _this2.onSelectImage = _this2.onSelectImage.bind(_assertThisInitialized(_this2)), _this2.onRemoveImage = _this2.onRemoveImage.bind(_assertThisInitialized(_this2)), _this2.bindContainer = _this2.bindContainer.bind(_assertThisInitialized(_this2)), _this2.onEdit = _this2.onEdit.bind(_assertThisInitialized(_this2)), _this2.onSelectImageFromLibrary = _this2.onSelectImageFromLibrary.bind(_assertThisInitialized(_this2)), _this2.onSelectCustomURL = _this2.onSelectCustomURL.bind(_assertThisInitialized(_this2)), _this2.state = {
              isEditing: !1
            };
            return _this2;
          }

          _createClass2(GalleryImage, [{
            key: "bindContainer",
            value: function bindContainer(l) {
              this.container = l;
            }
          }, {
            key: "onSelectImage",
            value: function onSelectImage() {
              this.props.isSelected || this.props.onSelect();
            }
          }, {
            key: "onRemoveImage",
            value: function onRemoveImage(l) {
              this.container === this.container.ownerDocument.activeElement && this.props.isSelected && -1 !== [w.BACKSPACE, w.DELETE].indexOf(l.keyCode) && (l.preventDefault(), this.props.onRemove());
            }
          }, {
            key: "onEdit",
            value: function onEdit() {
              this.setState({
                isEditing: !0
              });
            }
          }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
              var _this$props2 = this.props,
                  l = _this$props2.image,
                  s = _this$props2.url,
                  c = _this$props2.__unstableMarkNextChangeAsNotPersistent;
              l && !s && (c(), this.props.setAttributes({
                url: l.source_url,
                alt: l.alt_text
              }));
            }
          }, {
            key: "deselectOnBlur",
            value: function deselectOnBlur() {
              this.props.onDeselect();
            }
          }, {
            key: "onSelectImageFromLibrary",
            value: function onSelectImageFromLibrary(l) {
              var _this$props3 = this.props,
                  s = _this$props3.setAttributes,
                  c = _this$props3.id,
                  m = _this$props3.url,
                  v = _this$props3.alt,
                  _ = _this$props3.caption,
                  k = _this$props3.sizeSlug;
              if (!l || !l.url) return;
              var E = (0, L.pickRelevantMediaFiles)(l, k);
              (function (l, s) {
                return !l && (0, P.isBlobURL)(s);
              })(c, m) && v && (E = (0, y.omit)(E, ["alt"])), _ && !(0, y.get)(E, ["caption"]) && (E = (0, y.omit)(E, ["caption"])), s(E), this.setState({
                isEditing: !1
              });
            }
          }, {
            key: "onSelectCustomURL",
            value: function onSelectCustomURL(l) {
              var _this$props4 = this.props,
                  s = _this$props4.setAttributes,
                  c = _this$props4.url;
              l !== c && (s({
                url: l,
                id: void 0
              }), this.setState({
                isEditing: !1
              }));
            }
          }, {
            key: "render",
            value: function render() {
              var _this$props5 = this.props,
                  l = _this$props5.url,
                  s = _this$props5.alt,
                  c = _this$props5.id,
                  m = _this$props5.linkTo,
                  y = _this$props5.link,
                  w = _this$props5.isFirstItem,
                  C = _this$props5.isLastItem,
                  T = _this$props5.isSelected,
                  z = _this$props5.caption,
                  L = _this$props5.onRemove,
                  A = _this$props5.onMoveForward,
                  R = _this$props5.onMoveBackward,
                  O = _this$props5.setAttributes,
                  D = _this$props5["aria-label"],
                  F = this.state.isEditing;
              var G;

              switch (m) {
                case V.LINK_DESTINATION_MEDIA:
                  G = l;
                  break;

                case V.LINK_DESTINATION_ATTACHMENT:
                  G = y;
              }

              var q = (0, v.createElement)(v.Fragment, null, (0, v.createElement)("img", {
                src: l,
                alt: s,
                "data-id": c,
                onKeyDown: this.onRemoveImage,
                tabIndex: "0",
                "aria-label": D,
                ref: this.bindContainer
              }), (0, P.isBlobURL)(l) && (0, v.createElement)(k.Spinner, null)),
                  W = (0, _.default)({
                "is-selected": T,
                "is-transient": (0, P.isBlobURL)(l)
              });
              return (0, v.createElement)("figure", {
                className: W,
                onClick: this.onSelectImage,
                onFocus: this.onSelectImage
              }, !F && (G ? (0, v.createElement)("a", {
                href: G
              }, q) : q), F && (0, v.createElement)(S.MediaPlaceholder, {
                labels: {
                  title: (0, E.__)("Edit gallery image")
                },
                icon: B.image,
                onSelect: this.onSelectImageFromLibrary,
                onSelectURL: this.onSelectCustomURL,
                accept: "image/*",
                allowedTypes: ["image"],
                value: {
                  id: c,
                  src: l
                }
              }), (0, v.createElement)(k.ButtonGroup, {
                className: "block-library-gallery-item__inline-menu is-left"
              }, (0, v.createElement)(k.Button, {
                icon: B.chevronLeft,
                onClick: w ? void 0 : R,
                label: (0, E.__)("Move image backward"),
                "aria-disabled": w,
                disabled: !T
              }), (0, v.createElement)(k.Button, {
                icon: B.chevronRight,
                onClick: C ? void 0 : A,
                label: (0, E.__)("Move image forward"),
                "aria-disabled": C,
                disabled: !T
              })), (0, v.createElement)(k.ButtonGroup, {
                className: "block-library-gallery-item__inline-menu is-right"
              }, (0, v.createElement)(k.Button, {
                icon: B.edit,
                onClick: this.onEdit,
                label: (0, E.__)("Replace image"),
                disabled: !T
              }), (0, v.createElement)(k.Button, {
                icon: B.closeSmall,
                onClick: L,
                label: (0, E.__)("Remove image"),
                disabled: !T
              })), !F && (T || z) && (0, v.createElement)(S.RichText, {
                tagName: "figcaption",
                "aria-label": (0, E.__)("Image caption text"),
                placeholder: T ? (0, E.__)("Add caption") : null,
                value: z,
                onChange: function onChange(l) {
                  return O({
                    caption: l
                  });
                },
                inlineToolbar: !0
              }));
            }
          }]);

          return GalleryImage;
        }(v.Component);

        var A = (0, T.compose)([(0, C.withSelect)(function (l, s) {
          var _l28 = l(z.store),
              c = _l28.getMedia,
              m = s.id;

          return {
            image: m ? c(parseInt(m, 10)) : null
          };
        }), (0, C.withDispatch)(function (l) {
          var _l29 = l(S.store),
              s = _l29.__unstableMarkNextChangeAsNotPersistent;

          return {
            __unstableMarkNextChangeAsNotPersistent: s
          };
        })])(GalleryImage);
        s.default = A;
      },
      469: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.Gallery = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(6700),
            S = m(c(9907)),
            P = c(127);

        var Gallery = function Gallery(l) {
          var _ref113;

          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              E = l.selectedImage,
              T = l.mediaPlaceholder,
              B = l.onMoveBackward,
              z = l.onMoveForward,
              L = l.onRemoveImage,
              V = l.onSelectImage,
              A = l.onDeselectImage,
              R = l.onSetImageAttributes,
              O = l.insertBlocksAfter,
              D = l.blockProps,
              F = s.align,
              _s$columns8 = s.columns,
              G = _s$columns8 === void 0 ? (0, P.defaultColumnsNumberV1)(s) : _s$columns8,
              q = s.caption,
              W = s.imageCrop,
              U = s.images;
          return (0, v.createElement)("figure", (0, _.default)({}, D, {
            className: (0, y.default)(D.className, (_ref113 = {}, _defineProperty(_ref113, "align".concat(F), F), _defineProperty(_ref113, "columns-".concat(G), G), _defineProperty(_ref113, "is-cropped", W), _ref113))
          }), (0, v.createElement)("ul", {
            className: "blocks-gallery-grid"
          }, U.map(function (l, m) {
            var _ = (0, w.sprintf)((0, w.__)("image %1$d of %2$d in gallery"), m + 1, U.length);

            return (0, v.createElement)("li", {
              className: "blocks-gallery-item",
              key: l.id ? "".concat(l.id, "-").concat(m) : l.url
            }, (0, v.createElement)(S.default, {
              url: l.url,
              alt: l.alt,
              id: l.id,
              isFirstItem: 0 === m,
              isLastItem: m + 1 === U.length,
              isSelected: c && E === m,
              onMoveBackward: B(m),
              onMoveForward: z(m),
              onRemove: L(m),
              onSelect: V(m),
              onDeselect: A(m),
              setAttributes: function setAttributes(l) {
                return R(m, l);
              },
              caption: l.caption,
              "aria-label": _,
              sizeSlug: s.sizeSlug
            }));
          })), T, (0, v.createElement)(RichTextVisibilityHelper, {
            isHidden: !c && k.RichText.isEmpty(q),
            tagName: "figcaption",
            className: "blocks-gallery-caption",
            "aria-label": (0, w.__)("Gallery caption text"),
            placeholder: (0, w.__)("Write gallery caption…"),
            value: q,
            onChange: function onChange(l) {
              return m({
                caption: l
              });
            },
            inlineToolbar: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return O((0, C.createBlock)("core/paragraph"));
            }
          }));
        };

        function RichTextVisibilityHelper(l) {
          var s = l.isHidden,
              c = _objectWithoutProperties(l, _excluded7);

          return s ? (0, v.createElement)(E.VisuallyHidden, (0, _.default)({
            as: k.RichText
          }, c)) : (0, v.createElement)(k.RichText, c);
        }

        s.Gallery = Gallery;
        var T = Gallery;
        s.default = T;
      },
      1887: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function saveV1(l) {
          var s = l.attributes;
          var c = s.images,
              _s$columns9 = s.columns,
              k = _s$columns9 === void 0 ? (0, _.defaultColumnsNumberV1)(s) : _s$columns9,
              E = s.imageCrop,
              w = s.caption,
              C = s.linkTo,
              S = "columns-".concat(k, " ").concat(E ? "is-cropped" : "");
          return (0, m.createElement)("figure", v.useBlockProps.save({
            className: S
          }), (0, m.createElement)("ul", {
            className: "blocks-gallery-grid"
          }, c.map(function (l) {
            var s;

            switch (C) {
              case y.LINK_DESTINATION_MEDIA:
                s = l.fullUrl || l.url;
                break;

              case y.LINK_DESTINATION_ATTACHMENT:
                s = l.link;
            }

            var c = (0, m.createElement)("img", {
              src: l.url,
              alt: l.alt,
              "data-id": l.id,
              "data-full-url": l.fullUrl,
              "data-link": l.link,
              className: l.id ? "wp-image-".concat(l.id) : null
            });
            return (0, m.createElement)("li", {
              key: l.id || l.url,
              className: "blocks-gallery-item"
            }, (0, m.createElement)("figure", null, s ? (0, m.createElement)("a", {
              href: s
            }, c) : c, !v.RichText.isEmpty(l.caption) && (0, m.createElement)(v.RichText.Content, {
              tagName: "figcaption",
              className: "blocks-gallery-item__caption",
              value: l.caption
            })));
          })), !v.RichText.isEmpty(w) && (0, m.createElement)(v.RichText.Content, {
            tagName: "figcaption",
            className: "blocks-gallery-caption",
            value: w
          }));
        };

        var m = c(1753),
            v = c(1326),
            _ = c(127),
            y = c(8047);
      },
      7604: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.pickRelevantMediaFiles = void 0;
        var m = c(4793);

        s.pickRelevantMediaFiles = function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "large";
          var c = (0, m.pick)(l, ["alt", "id", "link", "caption"]);
          c.url = (0, m.get)(l, ["sizes", s, "url"]) || (0, m.get)(l, ["media_details", "sizes", s, "source_url"]) || l.url;
          var v = (0, m.get)(l, ["sizes", "full", "url"]) || (0, m.get)(l, ["media_details", "sizes", "full", "source_url"]);
          return v && (c.fullUrl = v), c;
        };
      },
      8828: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326);

        var migrateAttributes = function migrateAttributes(l) {
          if (l.tagName || (l = _objectSpread(_objectSpread({}, l), {}, {
            tagName: "div"
          })), !l.customTextColor && !l.customBackgroundColor) return l;
          var s = {
            color: {}
          };
          return l.customTextColor && (s.color.text = l.customTextColor), l.customBackgroundColor && (s.color.background = l.customBackgroundColor), _objectSpread(_objectSpread({}, (0, y.omit)(l, ["customTextColor", "customBackgroundColor"])), {}, {
            style: s
          });
        };

        var E = [{
          attributes: {
            tagName: {
              type: "string",
              default: "div"
            },
            templateLock: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              padding: !0
            },
            __experimentalBorder: {
              radius: !0
            }
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.tagName;
            return (0, v.createElement)(c, k.useBlockProps.save(), (0, v.createElement)("div", {
              className: "wp-block-group__inner-container"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }, {
          attributes: {
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1
          },
          migrate: migrateAttributes,
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                y = s.textColor,
                E = s.customTextColor,
                w = (0, k.getColorClassName)("background-color", c),
                C = (0, k.getColorClassName)("color", y),
                S = (0, _.default)(w, C, {
              "has-text-color": y || E,
              "has-background": c || m
            }),
                P = {
              backgroundColor: w ? void 0 : m,
              color: C ? void 0 : E
            };
            return (0, v.createElement)("div", {
              className: S,
              style: P
            }, (0, v.createElement)("div", {
              className: "wp-block-group__inner-container"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }, {
          attributes: {
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            }
          },
          migrate: migrateAttributes,
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                y = s.textColor,
                E = s.customTextColor,
                w = (0, k.getColorClassName)("background-color", c),
                C = (0, k.getColorClassName)("color", y),
                S = (0, _.default)(w, {
              "has-text-color": y || E,
              "has-background": c || m
            }),
                P = {
              backgroundColor: w ? void 0 : m,
              color: C ? void 0 : E
            };
            return (0, v.createElement)("div", {
              className: S,
              style: P
            }, (0, v.createElement)("div", {
              className: "wp-block-group__inner-container"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }, {
          attributes: {
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1
          },
          migrate: migrateAttributes,
          save: function save(l) {
            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                y = (0, k.getColorClassName)("background-color", c),
                E = (0, _.default)(y, {
              "has-background": c || m
            }),
                w = {
              backgroundColor: y ? void 0 : m
            };
            return (0, v.createElement)("div", {
              className: E,
              style: w
            }, (0, v.createElement)(k.InnerBlocks.Content, null));
          }
        }];
        s.default = E;
      },
      9649: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(1326),
            y = c(4892),
            k = c(6756);

        var E = {
          header: (0, k.__)("The <header> element should represent introductory content, typically a group of introductory or navigational aids."),
          main: (0, k.__)("The <main> element should be used for the primary content of your document only. "),
          section: (0, k.__)("The <section> element should represent a standalone portion of the document that can't be better represented by another element."),
          article: (0, k.__)("The <article> element should represent a self contained, syndicatable portion of the document."),
          aside: (0, k.__)("The <aside> element should represent a portion of a document whose content is only indirectly related to the document's main content."),
          footer: (0, k.__)("The <footer> element should represent a footer for its nearest sectioning element (e.g.: <section>, <article>, <main> etc.).")
        };

        var w = function GroupEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              w = l.clientId;

          var _ref114 = (0, v.useSelect)(function (l) {
            var s;

            var _l30 = l(_.store),
                c = _l30.getBlock,
                m = _l30.getSettings,
                v = c(w);

            return {
              hasInnerBlocks: !(!v || !v.innerBlocks.length),
              themeSupportsLayout: null === (s = m()) || void 0 === s ? void 0 : s.supportsLayout
            };
          }, [w]),
              C = _ref114.hasInnerBlocks,
              S = _ref114.themeSupportsLayout,
              P = (0, _.useSetting)("layout") || {},
              _s$tagName = s.tagName,
              T = _s$tagName === void 0 ? "div" : _s$tagName,
              B = s.templateLock,
              _s$layout = s.layout,
              z = _s$layout === void 0 ? {} : _s$layout,
              L = z && z.inherit ? P : z,
              _L$type = L.type,
              V = _L$type === void 0 ? "default" : _L$type,
              A = S || "default" !== V,
              R = (0, _.useBlockProps)(),
              O = (0, _.useInnerBlocksProps)(A ? R : {
            className: "wp-block-group__inner-container"
          }, {
            templateLock: B,
            renderAppender: C ? void 0 : _.InnerBlocks.ButtonBlockAppender,
            __experimentalLayout: A ? L : void 0
          });

          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, m.createElement)(y.SelectControl, {
            label: (0, k.__)("HTML element"),
            options: [{
              label: (0, k.__)("Default (<div>)"),
              value: "div"
            }, {
              label: "<header>",
              value: "header"
            }, {
              label: "<main>",
              value: "main"
            }, {
              label: "<section>",
              value: "section"
            }, {
              label: "<article>",
              value: "article"
            }, {
              label: "<aside>",
              value: "aside"
            }, {
              label: "<footer>",
              value: "footer"
            }],
            value: T,
            onChange: function onChange(l) {
              return c({
                tagName: l
              });
            },
            help: E[T]
          })), A && (0, m.createElement)(T, O), !A && (0, m.createElement)(T, R, (0, m.createElement)("div", O)));
        };

        s.default = w;
      },
      1693: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(6700),
            y = c(5303),
            k = m(c(8828)),
            E = m(c(9649)),
            w = m(c(7575)),
            C = m(c(3921));

        var S = {
          apiVersion: 2,
          name: "core/group",
          title: "Group",
          category: "design",
          description: "Combine blocks into a group.",
          keywords: ["container", "wrapper", "row", "section"],
          textdomain: "default",
          attributes: {
            tagName: {
              type: "string",
              default: "div"
            },
            templateLock: {
              type: ["string", "boolean"],
              enum: ["all", "insert", !1]
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              padding: !0,
              blockGap: !0,
              __experimentalDefaultControls: {
                padding: !0,
                blockGap: !0
              }
            },
            __experimentalBorder: {
              color: !0,
              radius: !0,
              style: !0,
              width: !0
            },
            __experimentalLayout: !0
          },
          editorStyle: "wp-block-group-editor",
          style: "wp-block-group"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: y.group,
          example: {
            attributes: {
              style: {
                color: {
                  text: "#000000",
                  background: "#ffffff"
                }
              }
            },
            innerBlocks: [{
              name: "core/paragraph",
              attributes: {
                customTextColor: "#cf2e2e",
                fontSize: "large",
                content: (0, v.__)("One.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                customTextColor: "#ff6900",
                fontSize: "large",
                content: (0, v.__)("Two.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                customTextColor: "#fcb900",
                fontSize: "large",
                content: (0, v.__)("Three.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                customTextColor: "#00d084",
                fontSize: "large",
                content: (0, v.__)("Four.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                customTextColor: "#0693e3",
                fontSize: "large",
                content: (0, v.__)("Five.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                customTextColor: "#9b51e0",
                fontSize: "large",
                content: (0, v.__)("Six.")
              }
            }]
          },
          transforms: {
            from: [{
              type: "block",
              isMultiBlock: !0,
              blocks: ["*"],
              __experimentalConvert: function __experimentalConvert(l) {
                if (1 === l.length && "core/group" === l[0].name) return;
                var s = ["wide", "full"],
                    c = l.reduce(function (l, c) {
                  var m = c.attributes.align;
                  return s.indexOf(m) > s.indexOf(l) ? m : l;
                }, void 0),
                    m = l.map(function (l) {
                  return (0, _.createBlock)(l.name, l.attributes, l.innerBlocks);
                });
                return (0, _.createBlock)("core/group", {
                  align: c
                }, m);
              }
            }]
          },
          edit: E.default,
          save: w.default,
          deprecated: k.default,
          variations: C.default
        };
        s.settings = T;
      },
      7575: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes.tagName;
          return (0, m.createElement)(s, v.useInnerBlocksProps.save(v.useBlockProps.save()));
        };
        var m = c(1753),
            v = c(1326);
      },
      3921: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756);
        var v = [{
          name: "group-row",
          title: (0, m.__)("Row"),
          description: (0, m.__)("Blocks shown in a row."),
          attributes: {
            layout: {
              type: "flex",
              allowOrientation: !1
            }
          },
          scope: ["inserter"],
          isActive: function isActive(l) {
            var s;
            return "flex" === (null === (s = l.layout) || void 0 === s ? void 0 : s.type);
          }
        }];
        s.default = v;
      },
      7033: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.setAnchor = s.generateAnchor = void 0;
        var m = c(4793);

        var v = {},
            getSlug = function getSlug(l) {
          return (0, m.trim)((0, m.deburr)(function (l) {
            var s = document.createElement("div");
            return s.innerHTML = l, s.innerText;
          }(l)).replace(/(?:(?![0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])[\s\S])+/g, "-").toLowerCase(), "-");
        };

        s.generateAnchor = function (l, s) {
          var c = getSlug(s);
          if ("" === c) return null;
          delete v[l];
          var m = c,
              _ = 0;

          for (; Object.values(v).includes(m);) {
            _ += 1, m = c + "-" + _;
          }

          return m;
        };

        s.setAnchor = function (l, s) {
          v[l] = s;
        };
      },
      6888: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326);

        var E = {
          className: !1,
          anchor: !0
        },
            w = {
          align: {
            type: "string"
          },
          content: {
            type: "string",
            source: "html",
            selector: "h1,h2,h3,h4,h5,h6",
            default: ""
          },
          level: {
            type: "number",
            default: 2
          },
          placeholder: {
            type: "string"
          }
        },
            migrateCustomColors = function migrateCustomColors(l) {
          if (!l.customTextColor) return l;
          var s = {
            color: {
              text: l.customTextColor
            }
          };
          return _objectSpread(_objectSpread({}, (0, y.omit)(l, ["customTextColor"])), {}, {
            style: s
          });
        },
            C = ["left", "right", "center"],
            migrateTextAlign = function migrateTextAlign(l) {
          var s = l.align,
              c = _objectWithoutProperties(l, _excluded8);

          return C.includes(s) ? _objectSpread(_objectSpread({}, c), {}, {
            textAlign: s
          }) : l;
        };

        var S = [{
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            className: !1,
            color: {
              link: !0
            },
            fontSize: !0,
            lineHeight: !0,
            __experimentalSelector: {
              "core/heading/h1": "h1",
              "core/heading/h2": "h2",
              "core/heading/h3": "h3",
              "core/heading/h4": "h4",
              "core/heading/h5": "h5",
              "core/heading/h6": "h6"
            },
            __unstablePasteTextInline: !0
          },
          attributes: w,
          isEligible: function isEligible(l) {
            var s = l.align;
            return C.includes(s);
          },
          migrate: migrateTextAlign,
          save: function save(l) {
            var s = l.attributes;
            var c = s.align,
                m = s.content,
                y = s.level,
                E = "h" + y,
                w = (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c));
            return (0, v.createElement)(E, k.useBlockProps.save({
              className: w
            }), (0, v.createElement)(k.RichText.Content, {
              value: m
            }));
          }
        }, {
          supports: E,
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customTextColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            }
          }),
          migrate: function migrate(l) {
            return migrateCustomColors(migrateTextAlign(l));
          },
          save: function save(l) {
            var _ref116;

            var s = l.attributes;
            var c = s.align,
                m = s.content,
                y = s.customTextColor,
                E = s.level,
                w = s.textColor,
                C = "h" + E,
                S = (0, k.getColorClassName)("color", w),
                P = (0, _.default)((_ref116 = {}, _defineProperty(_ref116, S, S), _defineProperty(_ref116, "has-text-color", w || y), _defineProperty(_ref116, "has-text-align-".concat(c), c), _ref116));
            return (0, v.createElement)(k.RichText.Content, {
              className: P || void 0,
              tagName: C,
              style: {
                color: S ? void 0 : y
              },
              value: m
            });
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customTextColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            }
          }),
          migrate: function migrate(l) {
            return migrateCustomColors(migrateTextAlign(l));
          },
          save: function save(l) {
            var _ref117;

            var s = l.attributes;
            var c = s.align,
                m = s.content,
                y = s.customTextColor,
                E = s.level,
                w = s.textColor,
                C = "h" + E,
                S = (0, k.getColorClassName)("color", w),
                P = (0, _.default)((_ref117 = {}, _defineProperty(_ref117, S, S), _defineProperty(_ref117, "has-text-align-".concat(c), c), _ref117));
            return (0, v.createElement)(k.RichText.Content, {
              className: P || void 0,
              tagName: C,
              style: {
                color: S ? void 0 : y
              },
              value: m
            });
          },
          supports: E
        }, {
          supports: E,
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customTextColor: {
              type: "string"
            },
            textColor: {
              type: "string"
            }
          }),
          migrate: function migrate(l) {
            return migrateCustomColors(migrateTextAlign(l));
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.align,
                m = s.level,
                y = s.content,
                E = s.textColor,
                w = s.customTextColor,
                C = "h" + m,
                S = (0, k.getColorClassName)("color", E),
                P = (0, _.default)(_defineProperty({}, S, S));
            return (0, v.createElement)(k.RichText.Content, {
              className: P || void 0,
              tagName: C,
              style: {
                textAlign: c,
                color: S ? void 0 : w
              },
              value: y
            });
          }
        }];
        s.default = S;
      },
      2324: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(6756),
            E = c(8467),
            w = c(6700),
            C = c(1326),
            S = m(c(9855)),
            P = c(7033);

        var T = function HeadingEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.mergeBlocks,
              T = l.onReplace,
              B = l.style,
              z = l.clientId;

          var L = s.textAlign,
              V = s.content,
              A = s.level,
              R = s.placeholder,
              O = s.anchor,
              D = "h" + A,
              F = (0, C.useBlockProps)({
            className: (0, y.default)(_defineProperty({}, "has-text-align-".concat(L), L)),
            style: B
          }),
              _ref119 = (0, E.useDispatch)(C.store),
              G = _ref119.__unstableMarkNextChangeAsNotPersistent;

          return (0, v.useEffect)(function () {
            return !O && V && (G(), c({
              anchor: (0, P.generateAnchor)(z, V)
            })), (0, P.setAnchor)(z, O), function () {
              return (0, P.setAnchor)(z, null);
            };
          }, [V, O]), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.BlockControls, {
            group: "block"
          }, (0, v.createElement)(S.default, {
            selectedLevel: A,
            onChange: function onChange(l) {
              return c({
                level: l
              });
            }
          }), (0, v.createElement)(C.AlignmentControl, {
            value: L,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)(C.RichText, (0, _.default)({
            identifier: "content",
            tagName: D,
            value: V,
            onChange: function onChange(l) {
              var s = {
                content: l
              };
              O && l && (0, P.generateAnchor)(z, V) !== O || (s.anchor = (0, P.generateAnchor)(z, l)), c(s);
            },
            onMerge: m,
            onSplit: function onSplit(l, c) {
              var m;
              var v;
              c || l ? m = (0, w.createBlock)("core/heading", _objectSpread(_objectSpread({}, s), {}, {
                content: l
              })) : m = (0, w.createBlock)(null !== (v = (0, w.getDefaultBlockName)()) && void 0 !== v ? v : "core/heading");
              return c && (m.clientId = z), m;
            },
            onReplace: T,
            onRemove: function onRemove() {
              return T([]);
            },
            "aria-label": (0, k.__)("Heading text"),
            placeholder: R || (0, k.__)("Heading"),
            textAlign: L
          }, F)));
        };

        s.default = T;
      },
      9855: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function HeadingLevelDropdown(l) {
          var s = l.selectedLevel,
              c = l.onChange;
          return (0, v.createElement)(_.ToolbarDropdownMenu, {
            popoverProps: w,
            icon: (0, v.createElement)(k.default, {
              level: s
            }),
            label: (0, y.__)("Change heading level"),
            controls: E.map(function (l) {
              {
                var _m2 = l === s;

                return {
                  icon: (0, v.createElement)(k.default, {
                    level: l,
                    isPressed: _m2
                  }),
                  label: (0, y.sprintf)((0, y.__)("Heading %d"), l),
                  isActive: _m2,
                  onClick: function onClick() {
                    c(l);
                  }
                };
              }
            })
          });
        };

        var v = c(1753),
            _ = c(4892),
            y = c(6756),
            k = m(c(1131));

        var E = [1, 2, 3, 4, 5, 6],
            w = {
          className: "block-library-heading-level-dropdown"
        };
      },
      1131: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function HeadingLevelIcon(l) {
          var s = l.level,
              _l$isPressed = l.isPressed,
              c = _l$isPressed === void 0 ? !1 : _l$isPressed;
          var _ = {
            1: "M9 5h2v10H9v-4H5v4H3V5h2v4h4V5zm6.6 0c-.6.9-1.5 1.7-2.6 2v1h2v7h2V5h-1.4z",
            2: "M7 5h2v10H7v-4H3v4H1V5h2v4h4V5zm8 8c.5-.4.6-.6 1.1-1.1.4-.4.8-.8 1.2-1.3.3-.4.6-.8.9-1.3.2-.4.3-.8.3-1.3 0-.4-.1-.9-.3-1.3-.2-.4-.4-.7-.8-1-.3-.3-.7-.5-1.2-.6-.5-.2-1-.2-1.5-.2-.4 0-.7 0-1.1.1-.3.1-.7.2-1 .3-.3.1-.6.3-.9.5-.3.2-.6.4-.8.7l1.2 1.2c.3-.3.6-.5 1-.7.4-.2.7-.3 1.2-.3s.9.1 1.3.4c.3.3.5.7.5 1.1 0 .4-.1.8-.4 1.1-.3.5-.6.9-1 1.2-.4.4-1 .9-1.6 1.4-.6.5-1.4 1.1-2.2 1.6V15h8v-2H15z",
            3: "M12.1 12.2c.4.3.8.5 1.2.7.4.2.9.3 1.4.3.5 0 1-.1 1.4-.3.3-.1.5-.5.5-.8 0-.2 0-.4-.1-.6-.1-.2-.3-.3-.5-.4-.3-.1-.7-.2-1-.3-.5-.1-1-.1-1.5-.1V9.1c.7.1 1.5-.1 2.2-.4.4-.2.6-.5.6-.9 0-.3-.1-.6-.4-.8-.3-.2-.7-.3-1.1-.3-.4 0-.8.1-1.1.3-.4.2-.7.4-1.1.6l-1.2-1.4c.5-.4 1.1-.7 1.6-.9.5-.2 1.2-.3 1.8-.3.5 0 1 .1 1.6.2.4.1.8.3 1.2.5.3.2.6.5.8.8.2.3.3.7.3 1.1 0 .5-.2.9-.5 1.3-.4.4-.9.7-1.5.9v.1c.6.1 1.2.4 1.6.8.4.4.7.9.7 1.5 0 .4-.1.8-.3 1.2-.2.4-.5.7-.9.9-.4.3-.9.4-1.3.5-.5.1-1 .2-1.6.2-.8 0-1.6-.1-2.3-.4-.6-.2-1.1-.6-1.6-1l1.1-1.4zM7 9H3V5H1v10h2v-4h4v4h2V5H7v4z",
            4: "M9 15H7v-4H3v4H1V5h2v4h4V5h2v10zm10-2h-1v2h-2v-2h-5v-2l4-6h3v6h1v2zm-3-2V7l-2.8 4H16z",
            5: "M12.1 12.2c.4.3.7.5 1.1.7.4.2.9.3 1.3.3.5 0 1-.1 1.4-.4.4-.3.6-.7.6-1.1 0-.4-.2-.9-.6-1.1-.4-.3-.9-.4-1.4-.4H14c-.1 0-.3 0-.4.1l-.4.1-.5.2-1-.6.3-5h6.4v1.9h-4.3L14 8.8c.2-.1.5-.1.7-.2.2 0 .5-.1.7-.1.5 0 .9.1 1.4.2.4.1.8.3 1.1.6.3.2.6.6.8.9.2.4.3.9.3 1.4 0 .5-.1 1-.3 1.4-.2.4-.5.8-.9 1.1-.4.3-.8.5-1.3.7-.5.2-1 .3-1.5.3-.8 0-1.6-.1-2.3-.4-.6-.2-1.1-.6-1.6-1-.1-.1 1-1.5 1-1.5zM9 15H7v-4H3v4H1V5h2v4h4V5h2v10z",
            6: "M9 15H7v-4H3v4H1V5h2v4h4V5h2v10zm8.6-7.5c-.2-.2-.5-.4-.8-.5-.6-.2-1.3-.2-1.9 0-.3.1-.6.3-.8.5l-.6.9c-.2.5-.2.9-.2 1.4.4-.3.8-.6 1.2-.8.4-.2.8-.3 1.3-.3.4 0 .8 0 1.2.2.4.1.7.3 1 .6.3.3.5.6.7.9.2.4.3.8.3 1.3s-.1.9-.3 1.4c-.2.4-.5.7-.8 1-.4.3-.8.5-1.2.6-1 .3-2 .3-3 0-.5-.2-1-.5-1.4-.9-.4-.4-.8-.9-1-1.5-.2-.6-.3-1.3-.3-2.1s.1-1.6.4-2.3c.2-.6.6-1.2 1-1.6.4-.4.9-.7 1.4-.9.6-.3 1.1-.4 1.7-.4.7 0 1.4.1 2 .3.5.2 1 .5 1.4.8 0 .1-1.3 1.4-1.3 1.4zm-2.4 5.8c.2 0 .4 0 .6-.1.2 0 .4-.1.5-.2.1-.1.3-.3.4-.5.1-.2.1-.5.1-.7 0-.4-.1-.8-.4-1.1-.3-.2-.7-.3-1.1-.3-.3 0-.7.1-1 .2-.4.2-.7.4-1 .7 0 .3.1.7.3 1 .1.2.3.4.4.6.2.1.3.3.5.3.2.1.5.2.7.1z"
          };
          if (!_.hasOwnProperty(s)) return null;
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            isPressed: c
          }, (0, m.createElement)(v.Path, {
            d: _[s]
          }));
        };
        var m = c(1753),
            v = c(4892);
      },
      6846: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(4793),
            _ = c(5303),
            y = c(6756),
            k = m(c(6888)),
            E = m(c(2324)),
            w = m(c(6717)),
            C = m(c(7611));

        var S = {
          apiVersion: 2,
          name: "core/heading",
          title: "Heading",
          category: "text",
          description: "Introduce new sections and organize content to help visitors (and search engines) understand the structure of your content.",
          keywords: ["title", "subtitle"],
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            content: {
              type: "string",
              source: "html",
              selector: "h1,h2,h3,h4,h5,h6",
              default: "",
              __experimentalRole: "content"
            },
            level: {
              type: "number",
              default: 2
            },
            placeholder: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            className: !1,
            color: {
              link: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0,
                textTransform: !0
              }
            },
            __experimentalSelector: "h1,h2,h3,h4,h5,h6",
            __unstablePasteTextInline: !0,
            __experimentalSlashInserter: !0
          },
          editorStyle: "wp-block-heading-editor",
          style: "wp-block-heading"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: _.heading,
          example: {
            attributes: {
              content: (0, y.__)("Code is Poetry"),
              level: 2
            }
          },
          __experimentalLabel: function __experimentalLabel(l, s) {
            var c = s.context;

            if ("accessibility" === c) {
              var _s9 = l.content,
                  _c3 = l.level;
              return (0, v.isEmpty)(_s9) ? (0, y.sprintf)((0, y.__)("Level %s. Empty."), _c3) : (0, y.sprintf)((0, y.__)("Level %1$s. %2$s"), _c3, _s9);
            }
          },
          transforms: C.default,
          deprecated: k.default,
          merge: function merge(l, s) {
            return {
              content: (l.content || "") + (s.content || "")
            };
          },
          edit: E.default,
          save: w.default
        };
        s.settings = T;
      },
      6717: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.textAlign,
              m = s.content,
              k = s.level,
              E = "h" + k,
              w = (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c));
          return (0, v.createElement)(E, y.useBlockProps.save({
            className: w
          }), (0, v.createElement)(y.RichText.Content, {
            value: m
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      8811: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getLevelFromHeadingNodeName = function getLevelFromHeadingNodeName(l) {
          return Number(l.substr(1));
        };
      },
      7611: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(8811);
        var _apiVersion$name$titl5 = {
          apiVersion: 2,
          name: "core/heading",
          title: "Heading",
          category: "text",
          description: "Introduce new sections and organize content to help visitors (and search engines) understand the structure of your content.",
          keywords: ["title", "subtitle"],
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            content: {
              type: "string",
              source: "html",
              selector: "h1,h2,h3,h4,h5,h6",
              default: "",
              __experimentalRole: "content"
            },
            level: {
              type: "number",
              default: 2
            },
            placeholder: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            className: !1,
            color: {
              link: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0,
                textTransform: !0
              }
            },
            __experimentalSelector: "h1,h2,h3,h4,h5,h6",
            __unstablePasteTextInline: !0,
            __experimentalSlashInserter: !0
          },
          editorStyle: "wp-block-heading-editor",
          style: "wp-block-heading"
        },
            _ = _apiVersion$name$titl5.name;
        var y = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return l.map(function (l) {
                var s = l.content,
                    c = l.anchor;
                return (0, m.createBlock)(_, {
                  content: s,
                  anchor: c
                });
              });
            }
          }, {
            type: "raw",
            selector: "h1,h2,h3,h4,h5,h6",
            schema: function schema(l) {
              var s = l.phrasingContentSchema,
                  c = l.isPaste;
              var m = {
                children: s,
                attributes: c ? [] : ["style", "id"]
              };
              return {
                h1: m,
                h2: m,
                h3: m,
                h4: m,
                h5: m,
                h6: m
              };
            },
            transform: function transform(l) {
              var s = (0, m.getBlockAttributes)(_, l.outerHTML),
                  _ref122 = l.style || {},
                  c = _ref122.textAlign;

              return s.level = (0, v.getLevelFromHeadingNodeName)(l.nodeName), "left" !== c && "center" !== c && "right" !== c || (s.align = c), (0, m.createBlock)(_, s);
            }
          }].concat(_toConsumableArray([1, 2, 3, 4, 5, 6].map(function (l) {
            return {
              type: "prefix",
              prefix: Array(l + 1).join("#"),
              transform: function transform(s) {
                return (0, m.createBlock)(_, {
                  level: l,
                  content: s
                });
              }
            };
          })), _toConsumableArray([1, 2, 3, 4, 5, 6].map(function (l) {
            return {
              type: "enter",
              regExp: new RegExp("^/(h|H)".concat(l, "$")),
              transform: function transform(s) {
                return (0, m.createBlock)(_, {
                  level: l,
                  content: s
                });
              }
            };
          }))),
          to: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return l.map(function (l) {
                var s = l.content,
                    c = l.anchor;
                return (0, m.createBlock)("core/paragraph", {
                  content: s,
                  anchor: c
                });
              });
            }
          }]
        };
        s.default = y;
      },
      9336: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function HomeEdit(l) {
          var _ref124;

          var s, c, m, C;
          var S = l.attributes,
              P = l.setAttributes,
              T = l.context,
              B = l.clientId;

          var _ref123 = (0, E.useSelect)(function (l) {
            var s;

            var _l31 = l(w.store),
                c = _l31.getUnstableBase;

            return {
              homeUrl: null === (s = c()) || void 0 === s ? void 0 : s.home
            };
          }, [B]),
              z = _ref123.homeUrl,
              L = T.textColor,
              V = T.backgroundColor,
              A = T.style,
              R = (0, y.useBlockProps)({
            className: (0, _.default)("wp-block-navigation-item", (_ref124 = {
              "has-text-color": !!L || !(null == A || null === (s = A.color) || void 0 === s || !s.text)
            }, _defineProperty(_ref124, "has-".concat(L, "-color"), !!L), _defineProperty(_ref124, "has-background", !!V || !(null == A || null === (c = A.color) || void 0 === c || !c.background)), _defineProperty(_ref124, "has-".concat(V, "-background-color"), !!V), _ref124)),
            style: {
              color: null == A || null === (m = A.color) || void 0 === m ? void 0 : m.text,
              backgroundColor: null == A || null === (C = A.color) || void 0 === C ? void 0 : C.background
            }
          }),
              O = S.label;

          return (0, v.useEffect)(function () {
            void 0 === O && P({
              label: (0, k.__)("Home")
            });
          }, [B, O]), (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", R, (0, v.createElement)("a", {
            className: "wp-block-home-link__content wp-block-navigation-item__content",
            href: z,
            onClick: preventDefault
          }, (0, v.createElement)(y.RichText, {
            identifier: "label",
            className: "wp-block-home-link__label",
            value: O,
            onChange: function onChange(l) {
              P({
                label: l
              });
            },
            "aria-label": (0, k.__)("Home link text"),
            placeholder: (0, k.__)("Add home link"),
            withoutInteractiveFormatting: !0,
            allowedFormats: ["core/bold", "core/italic", "core/image", "core/strikethrough"]
          }))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(6756),
            E = c(8467),
            w = c(1295);

        var preventDefault = function preventDefault(l) {
          return l.preventDefault();
        };
      },
      7215: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(9336)),
            k = m(c(9796));

        var E = {
          apiVersion: 2,
          name: "core/home-link",
          category: "design",
          parent: ["core/navigation"],
          title: "Home Link",
          description: "Create a link that always points to the homepage of the site. Usually not necessary if there is already a site title link present in the header.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            }
          },
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "fontSize", "customFontSize", "style"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "wp-block-home-link-editor",
          style: "wp-block-home-link"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: _.home,
          edit: y.default,
          save: k.default,
          example: {
            attributes: {
              label: (0, v._x)("Home Link", "block example")
            }
          }
        };
        s.settings = C;
      },
      9796: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      5325: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function HTMLEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              E = l.isSelected;

          var _ref125 = (0, m.useState)(),
              _ref126 = _slicedToArray2(_ref125, 2),
              w = _ref126[0],
              C = _ref126[1],
              S = (0, k.useSelect)(function (l) {
            return ["\n\t\t\thtml,body,:root {\n\t\t\t\tmargin: 0 !important;\n\t\t\t\tpadding: 0 !important;\n\t\t\t\toverflow: visible !important;\n\t\t\t\tmin-height: auto !important;\n\t\t\t}\n\t\t"].concat(_toConsumableArray((0, _.transformStyles)(l(_.store).getSettings().styles)));
          }, []);

          return (0, m.createElement)("div", (0, _.useBlockProps)({
            className: "block-library-html__edit"
          }), (0, m.createElement)(_.BlockControls, null, (0, m.createElement)(y.ToolbarGroup, null, (0, m.createElement)(y.ToolbarButton, {
            className: "components-tab-button",
            isPressed: !w,
            onClick: function switchToHTML() {
              C(!1);
            }
          }, (0, m.createElement)("span", null, "HTML")), (0, m.createElement)(y.ToolbarButton, {
            className: "components-tab-button",
            isPressed: w,
            onClick: function switchToPreview() {
              C(!0);
            }
          }, (0, m.createElement)("span", null, (0, v.__)("Preview"))))), (0, m.createElement)(y.Disabled.Consumer, null, function (l) {
            return w || l ? (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.SandBox, {
              html: s.content,
              styles: S
            }), !E && (0, m.createElement)("div", {
              className: "block-library-html__preview-overlay"
            })) : (0, m.createElement)(_.PlainText, {
              value: s.content,
              onChange: function onChange(l) {
                return c({
                  content: l
                });
              },
              placeholder: (0, v.__)("Write HTML…"),
              "aria-label": (0, v.__)("HTML")
            });
          }));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(1326),
            y = c(4892),
            k = c(8467);
      },
      3534: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(5325)),
            k = m(c(636)),
            E = m(c(6162));

        var w = {
          apiVersion: 2,
          name: "core/html",
          title: "Custom HTML",
          category: "widgets",
          description: "Add custom HTML code and preview it as you edit.",
          keywords: ["embed"],
          textdomain: "default",
          attributes: {
            content: {
              type: "string",
              source: "html"
            }
          },
          supports: {
            customClassName: !1,
            className: !1,
            html: !1
          },
          editorStyle: "wp-block-html-editor"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.html,
          example: {
            attributes: {
              content: "<marquee>" + (0, v.__)("Welcome to the wonderful world of blocks…") + "</marquee>"
            }
          },
          edit: y.default,
          save: k.default,
          transforms: E.default
        };
        s.settings = S;
      },
      636: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          return (0, m.createElement)(m.RawHTML, null, s.content);
        };
        var m = c(1753);
      },
      6162: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            blocks: ["core/code"],
            transform: function transform(l) {
              var s = l.content;
              return (0, m.createBlock)("core/html", {
                content: s
              });
            }
          }]
        };
        s.default = v;
      },
      7814: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.NEW_TAB_REL = s.MIN_SIZE = s.MEDIA_ID_NO_FEATURED_IMAGE_SET = s.LINK_DESTINATION_NONE = s.LINK_DESTINATION_MEDIA = s.LINK_DESTINATION_CUSTOM = s.LINK_DESTINATION_ATTACHMENT = s.ALLOWED_MEDIA_TYPES = void 0;
        s.MIN_SIZE = 20;
        s.LINK_DESTINATION_NONE = "none";
        s.LINK_DESTINATION_MEDIA = "media";
        s.LINK_DESTINATION_ATTACHMENT = "attachment";
        s.LINK_DESTINATION_CUSTOM = "custom";
        s.NEW_TAB_REL = ["noreferrer", "noopener"];
        s.ALLOWED_MEDIA_TYPES = ["image"];
        s.MEDIA_ID_NO_FEATURED_IMAGE_SET = 0;
      },
      9769: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(1326);

        var E = {
          align: {
            type: "string"
          },
          url: {
            type: "string",
            source: "attribute",
            selector: "img",
            attribute: "src"
          },
          alt: {
            type: "string",
            source: "attribute",
            selector: "img",
            attribute: "alt",
            default: ""
          },
          caption: {
            type: "string",
            source: "html",
            selector: "figcaption"
          },
          href: {
            type: "string",
            source: "attribute",
            selector: "figure > a",
            attribute: "href"
          },
          rel: {
            type: "string",
            source: "attribute",
            selector: "figure > a",
            attribute: "rel"
          },
          linkClass: {
            type: "string",
            source: "attribute",
            selector: "figure > a",
            attribute: "class"
          },
          id: {
            type: "number"
          },
          width: {
            type: "number"
          },
          height: {
            type: "number"
          },
          linkDestination: {
            type: "string"
          },
          linkTarget: {
            type: "string",
            source: "attribute",
            selector: "figure > a",
            attribute: "target"
          }
        };
        var w = [{
          attributes: E,
          save: function save(l) {
            var _ref127;

            var s = l.attributes;
            var c = s.url,
                m = s.alt,
                _ = s.caption,
                E = s.align,
                w = s.href,
                C = s.width,
                S = s.height,
                P = s.id,
                T = (0, y.default)((_ref127 = {}, _defineProperty(_ref127, "align".concat(E), E), _defineProperty(_ref127, "is-resized", C || S), _ref127)),
                B = (0, v.createElement)("img", {
              src: c,
              alt: m,
              className: P ? "wp-image-".concat(P) : null,
              width: C,
              height: S
            });
            return (0, v.createElement)("figure", {
              className: T
            }, w ? (0, v.createElement)("a", {
              href: w
            }, B) : B, !k.RichText.isEmpty(_) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              value: _
            }));
          }
        }, {
          attributes: E,
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.alt,
                _ = s.caption,
                y = s.align,
                E = s.href,
                w = s.width,
                C = s.height,
                S = s.id,
                P = (0, v.createElement)("img", {
              src: c,
              alt: m,
              className: S ? "wp-image-".concat(S) : null,
              width: w,
              height: C
            });
            return (0, v.createElement)("figure", {
              className: y ? "align".concat(y) : null
            }, E ? (0, v.createElement)("a", {
              href: E
            }, P) : P, !k.RichText.isEmpty(_) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              value: _
            }));
          }
        }, {
          attributes: E,
          save: function save(l) {
            var s = l.attributes;
            var c = s.url,
                m = s.alt,
                y = s.caption,
                E = s.align,
                w = s.href,
                C = s.width,
                S = s.height,
                P = C || S ? {
              width: C,
              height: S
            } : {},
                T = (0, v.createElement)("img", (0, _.default)({
              src: c,
              alt: m
            }, P));
            var B = {};
            return C ? B = {
              width: C
            } : "left" !== E && "right" !== E || (B = {
              maxWidth: "50%"
            }), (0, v.createElement)("figure", {
              className: E ? "align".concat(E) : null,
              style: B
            }, w ? (0, v.createElement)("a", {
              href: w
            }, T) : T, !k.RichText.isEmpty(y) && (0, v.createElement)(k.RichText.Content, {
              tagName: "figcaption",
              value: y
            }));
          }
        }];
        s.default = w;
      },
      8416: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ImageEdit = ImageEdit, s.pickRelevantMediaFiles = s.isExternalImage = s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(9388),
            E = c(4892),
            w = c(8467),
            C = c(1326),
            S = c(6756),
            P = c(5303),
            T = m(c(3794)),
            B = c(7814);

        var pickRelevantMediaFiles = function pickRelevantMediaFiles(l, s) {
          var c = (0, y.pick)(l, ["alt", "id", "link", "caption"]);
          return c.url = (0, y.get)(l, ["sizes", s, "url"]) || (0, y.get)(l, ["media_details", "sizes", s, "source_url"]) || l.url, c;
        };

        s.pickRelevantMediaFiles = pickRelevantMediaFiles;

        var isExternalImage = function isExternalImage(l, s) {
          return s && !l && !(0, k.isBlobURL)(s);
        };

        function ImageEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.isSelected,
              E = l.className,
              z = l.noticeUI,
              L = l.insertBlocksAfter,
              V = l.noticeOperations,
              A = l.onReplace,
              R = l.context,
              O = l.clientId;

          var _s$url = s.url,
              D = _s$url === void 0 ? "" : _s$url,
              F = s.alt,
              G = s.caption,
              q = s.align,
              W = s.id,
              U = s.width,
              $ = s.height,
              Z = s.sizeSlug,
              _ref128 = (0, v.useState)(),
              _ref129 = _slicedToArray2(_ref128, 2),
              K = _ref129[0],
              Q = _ref129[1],
              Y = (0, v.useRef)();

          (0, v.useEffect)(function () {
            Y.current = F;
          }, [F]);
          var X = (0, v.useRef)();
          (0, v.useEffect)(function () {
            X.current = G;
          }, [G]);

          var J = (0, v.useRef)(),
              _ref130 = (0, w.useSelect)(function (l) {
            var _l32 = l(C.store),
                s = _l32.getSettings;

            return (0, y.pick)(s(), ["imageDefaultSize", "mediaUpload"]);
          }, []),
              ee = _ref130.imageDefaultSize,
              te = _ref130.mediaUpload;

          function onUploadError(l) {
            V.removeAllNotices(), V.createErrorNotice(l);
          }

          function onSelectImage(l) {
            var m, v, _, E, w;

            if (!l || !l.url) return void c({
              url: void 0,
              alt: void 0,
              id: void 0,
              title: void 0,
              caption: void 0
            });
            if ((0, k.isBlobURL)(l.url)) return void Q(l.url);
            Q();
            var C,
                S = pickRelevantMediaFiles(l, ee);
            var P, T;
            X.current && !(0, y.get)(S, ["caption"]) && (S = (0, y.omit)(S, ["caption"])), C = l.id && l.id === W ? {
              url: D
            } : {
              width: void 0,
              height: void 0,
              sizeSlug: (P = l, T = ee, (0, y.has)(P, ["sizes", T, "url"]) || (0, y.has)(P, ["media_details", "sizes", T, "source_url"]) ? ee : "full")
            };
            var z,
                L = s.linkDestination;
            if (!L) switch ((null === (m = wp) || void 0 === m || null === (v = m.media) || void 0 === v || null === (_ = v.view) || void 0 === _ || null === (E = _.settings) || void 0 === E || null === (w = E.defaultProps) || void 0 === w ? void 0 : w.link) || B.LINK_DESTINATION_NONE) {
              case "file":
              case B.LINK_DESTINATION_MEDIA:
                L = B.LINK_DESTINATION_MEDIA;
                break;

              case "post":
              case B.LINK_DESTINATION_ATTACHMENT:
                L = B.LINK_DESTINATION_ATTACHMENT;
                break;

              case B.LINK_DESTINATION_CUSTOM:
                L = B.LINK_DESTINATION_CUSTOM;
                break;

              case B.LINK_DESTINATION_NONE:
                L = B.LINK_DESTINATION_NONE;
            }

            switch (L) {
              case B.LINK_DESTINATION_MEDIA:
                z = l.url;
                break;

              case B.LINK_DESTINATION_ATTACHMENT:
                z = l.link;
            }

            S.href = z, c(_objectSpread(_objectSpread(_objectSpread({}, S), C), {}, {
              linkDestination: L
            }));
          }

          function onSelectURL(l) {
            l !== D && c({
              url: l,
              id: void 0,
              width: void 0,
              height: void 0,
              sizeSlug: ee
            });
          }

          var re = function (l, s) {
            return !l && (0, k.isBlobURL)(s);
          }(W, D);

          (0, v.useEffect)(function () {
            if (!re) return;
            var l = (0, k.getBlobByURL)(D);
            l && te({
              filesList: [l],
              onFileChange: function onFileChange(l) {
                var _l33 = _slicedToArray2(l, 1),
                    s = _l33[0];

                onSelectImage(s);
              },
              allowedTypes: B.ALLOWED_MEDIA_TYPES,
              onError: function onError(l) {
                re = !1, V.createErrorNotice(l), c({
                  src: void 0,
                  id: void 0,
                  url: void 0
                });
              }
            });
          }, []), (0, v.useEffect)(function () {
            re ? Q(D) : (0, k.revokeBlobURL)(K);
          }, [re, D]);
          var ae = isExternalImage(W, D) ? D : void 0,
              oe = !!D && (0, v.createElement)("img", {
            alt: (0, S.__)("Edit image"),
            title: (0, S.__)("Edit image"),
            className: "edit-image-preview",
            src: D
          }),
              ne = (0, _.default)(E, _defineProperty({
            "is-transient": K,
            "is-resized": !!U || !!$
          }, "size-".concat(Z), Z)),
              le = (0, C.useBlockProps)({
            ref: J,
            className: ne
          });
          return (0, v.createElement)("figure", le, (K || D) && (0, v.createElement)(T.default, {
            temporaryURL: K,
            attributes: s,
            setAttributes: c,
            isSelected: m,
            insertBlocksAfter: L,
            onReplace: A,
            onSelectImage: onSelectImage,
            onSelectURL: onSelectURL,
            onUploadError: onUploadError,
            containerRef: J,
            context: R,
            clientId: O
          }), !D && (0, v.createElement)(C.BlockControls, {
            group: "block"
          }, (0, v.createElement)(C.BlockAlignmentControl, {
            value: q,
            onChange: function updateAlignment(l) {
              var s = ["wide", "full"].includes(l) ? {
                width: void 0,
                height: void 0
              } : {};
              c(_objectSpread(_objectSpread({}, s), {}, {
                align: l
              }));
            }
          })), (0, v.createElement)(C.MediaPlaceholder, {
            icon: (0, v.createElement)(C.BlockIcon, {
              icon: P.image
            }),
            onSelect: onSelectImage,
            onSelectURL: onSelectURL,
            notices: z,
            onError: onUploadError,
            accept: "image/*",
            allowedTypes: B.ALLOWED_MEDIA_TYPES,
            value: {
              id: W,
              src: ae
            },
            mediaPreview: oe,
            disableMediaButtons: K || D
          }));
        }

        s.isExternalImage = isExternalImage;
        var z = (0, E.withNotices)(ImageEdit);
        s.default = z;
      },
      3794: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Image(l) {
          var s;
          var c = l.temporaryURL,
              _l$attributes12 = l.attributes,
              _l$attributes12$url = _l$attributes12.url,
              m = _l$attributes12$url === void 0 ? "" : _l$attributes12$url,
              D = _l$attributes12.alt,
              F = _l$attributes12.caption,
              G = _l$attributes12.align,
              q = _l$attributes12.id,
              W = _l$attributes12.href,
              U = _l$attributes12.rel,
              $ = _l$attributes12.linkClass,
              Z = _l$attributes12.linkDestination,
              K = _l$attributes12.title,
              Q = _l$attributes12.width,
              Y = _l$attributes12.height,
              X = _l$attributes12.linkTarget,
              J = _l$attributes12.sizeSlug,
              ee = l.setAttributes,
              te = l.isSelected,
              re = l.insertBlocksAfter,
              ae = l.onReplace,
              oe = l.onSelectImage,
              ne = l.onSelectURL,
              le = l.onUploadError,
              ie = l.containerRef,
              se = l.context,
              ce = l.clientId;

          var ue = (0, v.useRef)(),
              de = (0, v.useRef)(),
              me = (0, E.usePrevious)(m),
              _se$allowResize = se.allowResize,
              pe = _se$allowResize === void 0 ? !0 : _se$allowResize,
              _ref132 = (0, w.useSelect)(C.store),
              ge = _ref132.getBlock,
              _ref133 = (0, w.useSelect)(function (l) {
            var _l34 = l(L.store),
                s = _l34.getMedia,
                _l35 = l(C.store),
                c = _l35.getMultiSelectedBlockClientIds,
                m = _l35.getBlockName,
                v = c();

            return {
              image: q && te ? s(q) : null,
              multiImageSelection: v.length && v.every(function (l) {
                return "core/image" === m(l);
              })
            };
          }, [q, te]),
              ve = _ref133.image,
              he = _ref133.multiImageSelection,
              _ref134 = (0, w.useSelect)(function (l) {
            var _l36 = l(C.store),
                s = _l36.getBlockRootClientId,
                c = _l36.getSettings,
                m = _l36.canInsertBlockType,
                v = s(ce);

            return _objectSpread(_objectSpread({}, (0, _.pick)(c(), ["imageEditing", "imageSizes", "maxWidth", "mediaUpload"])), {}, {
              canInsertCover: m("core/cover", v)
            });
          }, [ce]),
              be = _ref134.canInsertCover,
              _e = _ref134.imageEditing,
              fe = _ref134.imageSizes,
              ye = _ref134.maxWidth,
              ke = _ref134.mediaUpload,
              _ref135 = (0, w.useDispatch)(C.store),
              Ee = _ref135.replaceBlocks,
              we = _ref135.toggleSelection,
              _ref136 = (0, w.useDispatch)(z.store),
              Ce = _ref136.createErrorNotice,
              xe = _ref136.createSuccessNotice,
              Se = (0, E.useViewportMatch)("medium"),
              Pe = (0, _.includes)(["wide", "full"], G),
              _ref137 = (0, v.useState)({}),
              _ref138 = _slicedToArray2(_ref137, 2),
              _ref138$ = _ref138[0],
              Te = _ref138$.loadedNaturalWidth,
              Me = _ref138$.loadedNaturalHeight,
              Be = _ref138[1],
              _ref139 = (0, v.useState)(!1),
              _ref140 = _slicedToArray2(_ref139, 2),
              Ie = _ref140[0],
              Ne = _ref140[1],
              _ref141 = (0, v.useState)(),
              _ref142 = _slicedToArray2(_ref141, 2),
              ze = _ref142[0],
              Le = _ref142[1],
              Ve = (0, A.default)(ie, [G]),
              Ae = pe && !(Pe && Se),
              Re = (0, _.map)((0, _.filter)(fe, function (l) {
            var s = l.slug;
            return (0, _.get)(ve, ["media_details", "sizes", s, "source_url"]);
          }), function (l) {
            var s = l.name,
                c = l.slug;
            return {
              value: c,
              label: s
            };
          });

          (0, v.useEffect)(function () {
            (0, R.isExternalImage)(q, m) && te && !ze && window.fetch(m).then(function (l) {
              return l.blob();
            }).then(function (l) {
              return Le(l);
            }).catch(function () {});
          }, [q, m, te, ze]), (0, v.useEffect)(function () {
            m && !me && te && de.current.focus();
          }, [m, me]);

          var _ref143 = (0, v.useMemo)(function () {
            var l, s;
            return {
              naturalWidth: (null === (l = ue.current) || void 0 === l ? void 0 : l.naturalWidth) || Te || void 0,
              naturalHeight: (null === (s = ue.current) || void 0 === s ? void 0 : s.naturalHeight) || Me || void 0
            };
          }, [Te, Me, null === (s = ue.current) || void 0 === s ? void 0 : s.complete]),
              He = _ref143.naturalWidth,
              Oe = _ref143.naturalHeight;

          (0, v.useEffect)(function () {
            te || Ne(!1);
          }, [te]);
          var De = q && He && Oe && _e,
              Fe = !he && De && !Ie;
          var je = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.BlockControls, {
            group: "block"
          }, (0, v.createElement)(C.BlockAlignmentControl, {
            value: G,
            onChange: function updateAlignment(l) {
              var s = ["wide", "full"].includes(l) ? {
                width: void 0,
                height: void 0
              } : {};
              ee(_objectSpread(_objectSpread({}, s), {}, {
                align: l
              }));
            }
          }), !he && !Ie && (0, v.createElement)(C.__experimentalImageURLInputUI, {
            url: W || "",
            onChangeUrl: function onSetHref(l) {
              ee(l);
            },
            linkDestination: Z,
            mediaUrl: ve && ve.source_url || m,
            mediaLink: ve && ve.link,
            linkTarget: X,
            linkClass: $,
            rel: U
          }), Fe && (0, v.createElement)(k.ToolbarButton, {
            onClick: function onClick() {
              return Ne(!0);
            },
            icon: B.crop,
            label: (0, S.__)("Crop")
          }), ze && (0, v.createElement)(k.ToolbarButton, {
            onClick: function uploadExternal() {
              ke({
                filesList: [ze],
                onFileChange: function onFileChange(l) {
                  var _l37 = _slicedToArray2(l, 1),
                      s = _l37[0];

                  oe(s), (0, y.isBlobURL)(s.url) || (Le(), xe((0, S.__)("Image uploaded."), {
                    type: "snackbar"
                  }));
                },
                allowedTypes: O.ALLOWED_MEDIA_TYPES,
                onError: function onError(l) {
                  Ce(l, {
                    type: "snackbar"
                  });
                }
              });
            },
            icon: B.upload,
            label: (0, S.__)("Upload external image")
          }), !he && be && (0, v.createElement)(k.ToolbarButton, {
            icon: B.overlayText,
            label: (0, S.__)("Add text over image"),
            onClick: function switchToCover() {
              Ee(ce, (0, T.switchToBlockType)(ge(ce), "core/cover"));
            }
          })), !he && !Ie && (0, v.createElement)(C.BlockControls, {
            group: "other"
          }, (0, v.createElement)(C.MediaReplaceFlow, {
            mediaId: q,
            mediaURL: m,
            allowedTypes: O.ALLOWED_MEDIA_TYPES,
            accept: "image/*",
            onSelect: oe,
            onSelectURL: ne,
            onError: le
          })), (0, v.createElement)(C.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, S.__)("Image settings")
          }, !he && (0, v.createElement)(k.TextareaControl, {
            label: (0, S.__)("Alt text (alternative text)"),
            value: D,
            onChange: function updateAlt(l) {
              ee({
                alt: l
              });
            },
            help: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.ExternalLink, {
              href: "https://www.w3.org/WAI/tutorials/images/decision-tree"
            }, (0, S.__)("Describe the purpose of the image")), (0, S.__)("Leave empty if the image is purely decorative."))
          }), (0, v.createElement)(C.__experimentalImageSizeControl, {
            onChangeImage: function updateImage(l) {
              var s = (0, _.get)(ve, ["media_details", "sizes", l, "source_url"]);
              if (!s) return null;
              ee({
                url: s,
                width: void 0,
                height: void 0,
                sizeSlug: l
              });
            },
            onChange: function onChange(l) {
              return ee(l);
            },
            slug: J,
            width: Q,
            height: Y,
            imageSizeOptions: Re,
            isResizable: Ae,
            imageWidth: He,
            imageHeight: Oe
          }))), (0, v.createElement)(C.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, v.createElement)(k.TextControl, {
            label: (0, S.__)("Title attribute"),
            value: K || "",
            onChange: function onSetTitle(l) {
              ee({
                title: l
              });
            },
            help: (0, v.createElement)(v.Fragment, null, (0, S.__)("Describe the role of this image on the page."), (0, v.createElement)(k.ExternalLink, {
              href: "https://www.w3.org/TR/html52/dom.html#the-title-attribute"
            }, (0, S.__)("(Note: many devices and browsers do not display this text.)")))
          }))),
              Ge = (0, P.getFilename)(m);
          var qe;
          qe = D || (Ge ? (0, S.sprintf)((0, S.__)("This image has an empty alt attribute; its file name is %s"), Ge) : (0, S.__)("This image has an empty alt attribute"));
          var We,
              Ue,
              $e = (0, v.createElement)(v.Fragment, null, (0, v.createElement)("img", {
            src: c || m,
            alt: qe,
            onError: function onError() {
              return function onImageError() {
                var l = (0, V.createUpgradedEmbedBlock)({
                  attributes: {
                    url: m
                  }
                });
                void 0 !== l && ae(l);
              }();
            },
            onLoad: function onLoad(l) {
              var s, c;
              Be({
                loadedNaturalWidth: null === (s = l.target) || void 0 === s ? void 0 : s.naturalWidth,
                loadedNaturalHeight: null === (c = l.target) || void 0 === c ? void 0 : c.naturalHeight
              });
            },
            ref: ue
          }), c && (0, v.createElement)(k.Spinner, null));

          if (Ve && He && Oe) {
            var _l38 = He > Ve,
                _s10 = Oe / He;

            We = _l38 ? Ve : He, Ue = _l38 ? Ve * _s10 : Oe;
          }

          if (De && Ie) $e = (0, v.createElement)(C.__experimentalImageEditor, {
            url: m,
            width: Q,
            height: Y,
            clientWidth: Ve,
            naturalHeight: Oe,
            naturalWidth: He
          });else if (Ae && We) {
            var _l39 = Q || We,
                _s11 = Y || Ue,
                _c4 = He / Oe,
                _m3 = He < Oe ? O.MIN_SIZE : O.MIN_SIZE * _c4,
                _2 = Oe < He ? O.MIN_SIZE : O.MIN_SIZE / _c4,
                _y = 2.5 * ye;

            var _E = !1,
                _w = !1;

            "center" === G ? (_E = !0, _w = !0) : (0, S.isRTL)() ? "left" === G ? _E = !0 : _w = !0 : "right" === G ? _w = !0 : _E = !0, $e = (0, v.createElement)(k.ResizableBox, {
              size: {
                width: null != Q ? Q : "auto",
                height: null != Y ? Y : "auto"
              },
              showHandle: te,
              minWidth: _m3,
              maxWidth: _y,
              minHeight: _2,
              maxHeight: _y / _c4,
              lockAspectRatio: !0,
              enable: {
                top: !1,
                right: _E,
                bottom: !0,
                left: _w
              },
              onResizeStart: function onResizeStart() {
                we(!1);
              },
              onResizeStop: function onResizeStop(c, m, v, _) {
                !function onResizeStop() {
                  we(!0);
                }(), ee({
                  width: parseInt(_l39 + _.width, 10),
                  height: parseInt(_s11 + _.height, 10)
                });
              }
            }, $e);
          } else $e = (0, v.createElement)("div", {
            style: {
              width: Q,
              height: Y
            }
          }, $e);
          return (0, v.createElement)(C.__experimentalImageEditingProvider, {
            id: q,
            url: m,
            naturalWidth: He,
            naturalHeight: Oe,
            clientWidth: Ve,
            onSaveImage: function onSaveImage(l) {
              return ee(l);
            },
            isEditing: Ie,
            onFinishEditing: function onFinishEditing() {
              return Ne(!1);
            }
          }, !c && je, $e, (!C.RichText.isEmpty(F) || te) && (0, v.createElement)(C.RichText, {
            ref: de,
            tagName: "figcaption",
            "aria-label": (0, S.__)("Image caption text"),
            placeholder: (0, S.__)("Add caption"),
            value: F,
            onChange: function onChange(l) {
              return ee({
                caption: l
              });
            },
            inlineToolbar: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return re((0, T.createBlock)("core/paragraph"));
            }
          }));
        };

        var v = c(1753),
            _ = c(4793),
            y = c(9388),
            k = c(4892),
            E = c(3200),
            w = c(8467),
            C = c(1326),
            S = c(6756),
            P = c(904),
            T = c(6700),
            B = c(5303),
            z = c(8448),
            L = c(1295),
            V = c(4e3),
            A = m(c(4124)),
            R = c(8416),
            O = c(7814);
      },
      5443: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(9769)),
            k = m(c(8416)),
            E = m(c(2823)),
            w = m(c(2220));

        var C = {
          apiVersion: 2,
          name: "core/image",
          title: "Image",
          category: "media",
          usesContext: ["allowResize", "imageCrop", "fixedHeight"],
          description: "Insert an image to make a visual statement.",
          keywords: ["img", "photo", "picture"],
          textdomain: "default",
          attributes: {
            align: {
              type: "string"
            },
            url: {
              type: "string",
              source: "attribute",
              selector: "img",
              attribute: "src"
            },
            alt: {
              type: "string",
              source: "attribute",
              selector: "img",
              attribute: "alt",
              default: ""
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            title: {
              type: "string",
              source: "attribute",
              selector: "img",
              attribute: "title"
            },
            href: {
              type: "string",
              source: "attribute",
              selector: "figure > a",
              attribute: "href"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "figure > a",
              attribute: "rel"
            },
            linkClass: {
              type: "string",
              source: "attribute",
              selector: "figure > a",
              attribute: "class"
            },
            id: {
              type: "number"
            },
            width: {
              type: "number"
            },
            height: {
              type: "number"
            },
            sizeSlug: {
              type: "string"
            },
            linkDestination: {
              type: "string"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "figure > a",
              attribute: "target"
            }
          },
          supports: {
            anchor: !0,
            color: {
              __experimentalDuotone: "img",
              text: !1,
              background: !1
            },
            __experimentalBorder: {
              radius: !0
            }
          },
          styles: [{
            name: "default",
            label: "Default",
            isDefault: !0
          }, {
            name: "rounded",
            label: "Rounded"
          }],
          editorStyle: "wp-block-image-editor",
          style: "wp-block-image"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.image,
          example: {
            attributes: {
              sizeSlug: "large",
              url: "https://s.w.org/images/core/5.3/MtBlanc1.jpg",
              caption: (0, v.__)("Mont Blanc appears—still, snowy, and serene.")
            }
          },
          __experimentalLabel: function __experimentalLabel(l, s) {
            var c = s.context;

            if ("accessibility" === c) {
              var _s12 = l.caption,
                  _c5 = l.alt,
                  _m4 = l.url;
              return _m4 ? _c5 ? _c5 + (_s12 ? ". " + _s12 : "") : _s12 || "" : (0, v.__)("Empty");
            }
          },
          getEditWrapperProps: function getEditWrapperProps(l) {
            return {
              "data-align": l.align
            };
          },
          transforms: w.default,
          edit: k.default,
          save: E.default,
          deprecated: y.default
        };
        s.settings = P;
      },
      2823: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _ref144;

          var s = l.attributes;
          var c = s.url,
              m = s.alt,
              E = s.caption,
              w = s.align,
              C = s.href,
              S = s.rel,
              P = s.linkClass,
              T = s.width,
              B = s.height,
              z = s.id,
              L = s.linkTarget,
              V = s.sizeSlug,
              A = s.title,
              R = (0, y.isEmpty)(S) ? void 0 : S,
              O = (0, _.default)((_ref144 = {}, _defineProperty(_ref144, "align".concat(w), w), _defineProperty(_ref144, "size-".concat(V), V), _defineProperty(_ref144, "is-resized", T || B), _ref144)),
              D = (0, v.createElement)("img", {
            src: c,
            alt: m,
            className: z ? "wp-image-".concat(z) : null,
            width: T,
            height: B,
            title: A
          }),
              F = (0, v.createElement)(v.Fragment, null, C ? (0, v.createElement)("a", {
            className: P,
            href: C,
            target: L,
            rel: R
          }, D) : D, !k.RichText.isEmpty(E) && (0, v.createElement)(k.RichText.Content, {
            tagName: "figcaption",
            value: E
          }));
          if ("left" === w || "right" === w || "center" === w) return (0, v.createElement)("div", k.useBlockProps.save(), (0, v.createElement)("figure", {
            className: O
          }, F));
          return (0, v.createElement)("figure", k.useBlockProps.save({
            className: O
          }), F);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326);
      },
      2220: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.stripFirstImage = stripFirstImage;

        var m = c(4793),
            v = c(9388),
            _ = c(6700),
            y = c(8467),
            k = c(8448),
            E = c(6756);

        function stripFirstImage(l, s) {
          var c = s.shortcode;

          var _document$implementat = document.implementation.createHTMLDocument(""),
              m = _document$implementat.body;

          m.innerHTML = c.content;
          var v = m.querySelector("img");

          for (; v && v.parentNode && v.parentNode !== m;) {
            v = v.parentNode;
          }

          return v && v.parentNode.removeChild(v), m.innerHTML.trim();
        }

        function getFirstAnchorAttributeFormHTML(l, s) {
          var _document$implementat2 = document.implementation.createHTMLDocument(""),
              c = _document$implementat2.body;

          c.innerHTML = l;
          var m = c.firstElementChild;
          if (m && "A" === m.nodeName) return m.getAttribute(s) || void 0;
        }

        var w = {
          img: {
            attributes: ["src", "alt", "title"],
            classes: ["alignleft", "aligncenter", "alignright", "alignnone", /^wp-image-\d+$/]
          }
        };
        var C = {
          from: [{
            type: "raw",
            isMatch: function isMatch(l) {
              return "FIGURE" === l.nodeName && !!l.querySelector("img");
            },
            schema: function schema(l) {
              var s = l.phrasingContentSchema;
              return {
                figure: {
                  require: ["img"],
                  children: _objectSpread(_objectSpread({}, w), {}, {
                    a: {
                      attributes: ["href", "rel", "target"],
                      children: w
                    },
                    figcaption: {
                      children: s
                    }
                  })
                }
              };
            },
            transform: function transform(l) {
              var s = l.className + " " + l.querySelector("img").className,
                  c = /(?:^|\s)align(left|center|right)(?:$|\s)/.exec(s),
                  m = "" === l.id ? void 0 : l.id,
                  v = c ? c[1] : void 0,
                  y = /(?:^|\s)wp-image-(\d+)(?:$|\s)/.exec(s),
                  k = y ? Number(y[1]) : void 0,
                  E = l.querySelector("a"),
                  w = E && E.href ? "custom" : void 0,
                  C = E && E.href ? E.href : void 0,
                  S = E && E.rel ? E.rel : void 0,
                  P = E && E.className ? E.className : void 0,
                  T = (0, _.getBlockAttributes)("core/image", l.outerHTML, {
                align: v,
                id: k,
                linkDestination: w,
                href: C,
                rel: S,
                linkClass: P,
                anchor: m
              });
              return (0, _.createBlock)("core/image", T);
            }
          }, {
            type: "files",
            isMatch: function isMatch(l) {
              if (l.some(function (l) {
                return 0 === l.type.indexOf("image/");
              }) && l.some(function (l) {
                return 0 !== l.type.indexOf("image/");
              })) {
                var _ref145 = (0, y.dispatch)(k.store),
                    _l40 = _ref145.createErrorNotice;

                _l40((0, E.__)("If uploading to a gallery all files need to be image formats"), {
                  id: "gallery-transform-invalid-file"
                });
              }

              return (0, m.every)(l, function (l) {
                return 0 === l.type.indexOf("image/");
              });
            },
            transform: function transform(l) {
              return l.map(function (l) {
                return (0, _.createBlock)("core/image", {
                  url: (0, v.createBlobURL)(l)
                });
              });
            }
          }, {
            type: "shortcode",
            tag: "caption",
            attributes: {
              url: {
                type: "string",
                source: "attribute",
                attribute: "src",
                selector: "img"
              },
              alt: {
                type: "string",
                source: "attribute",
                attribute: "alt",
                selector: "img"
              },
              caption: {
                shortcode: stripFirstImage
              },
              href: {
                shortcode: function shortcode(l, s) {
                  var c = s.shortcode;
                  return getFirstAnchorAttributeFormHTML(c.content, "href");
                }
              },
              rel: {
                shortcode: function shortcode(l, s) {
                  var c = s.shortcode;
                  return getFirstAnchorAttributeFormHTML(c.content, "rel");
                }
              },
              linkClass: {
                shortcode: function shortcode(l, s) {
                  var c = s.shortcode;
                  return getFirstAnchorAttributeFormHTML(c.content, "class");
                }
              },
              id: {
                type: "number",
                shortcode: function shortcode(l) {
                  var s = l.named.id;
                  if (s) return parseInt(s.replace("attachment_", ""), 10);
                }
              },
              align: {
                type: "string",
                shortcode: function shortcode(l) {
                  var _l$named$align = l.named.align,
                      s = _l$named$align === void 0 ? "alignnone" : _l$named$align;
                  return s.replace("align", "");
                }
              }
            }
          }]
        };
        s.default = C;
      },
      4124: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useClientWidth(l, s) {
          var _ref146 = (0, m.useState)(),
              _ref147 = _slicedToArray2(_ref146, 2),
              c = _ref147[0],
              v = _ref147[1];

          function calculateClientWidth() {
            v(l.current.clientWidth);
          }

          return (0, m.useEffect)(calculateClientWidth, s), (0, m.useEffect)(function () {
            var s = l.current.ownerDocument.defaultView;
            return s.addEventListener("resize", calculateClientWidth), function () {
              s.removeEventListener("resize", calculateClientWidth);
            };
          }, []), c;
        };
        var m = c(1753);
      },
      1305: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getImageSizeAttributes = function getImageSizeAttributes(l, s) {
          var c = (0, m.get)(l, ["media_details", "sizes", s, "source_url"]);
          if (c) return {
            url: c,
            width: void 0,
            height: void 0,
            sizeSlug: s
          };
          return {};
        }, s.getUpdatedLinkTargetSettings = function getUpdatedLinkTargetSettings(l, s) {
          var c = s.rel;
          var m = l ? "_blank" : void 0;
          var v;
          v = m || c ? removeNewTabRel(c) : void 0;
          return {
            linkTarget: m,
            rel: v
          };
        }, s.removeNewTabRel = removeNewTabRel;
        var m = c(4793),
            v = c(7814);

        function removeNewTabRel(l) {
          var s = l;
          return void 0 === l || (0, m.isEmpty)(s) || (0, m.isEmpty)(s) || ((0, m.each)(v.NEW_TAB_REL, function (l) {
            var c = new RegExp("\\b" + l + "\\b", "gi");
            s = s.replace(c, "");
          }), s !== l && (s = s.trim()), (0, m.isEmpty)(s) && (s = void 0)), s;
        }
      },
      8635: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LatestComments(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var m = s.commentsToShow,
              w = s.displayAvatar,
              C = s.displayDate,
              S = s.displayExcerpt;
          return (0, v.createElement)("div", (0, _.useBlockProps)(), (0, v.createElement)(_.InspectorControls, null, (0, v.createElement)(y.PanelBody, {
            title: (0, E.__)("Latest comments settings")
          }, (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display avatar"),
            checked: w,
            onChange: function onChange() {
              return c({
                displayAvatar: !w
              });
            }
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display date"),
            checked: C,
            onChange: function onChange() {
              return c({
                displayDate: !C
              });
            }
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display excerpt"),
            checked: S,
            onChange: function onChange() {
              return c({
                displayExcerpt: !S
              });
            }
          }), (0, v.createElement)(y.RangeControl, {
            label: (0, E.__)("Number of comments"),
            value: m,
            onChange: function onChange(l) {
              return c({
                commentsToShow: l
              });
            },
            min: 1,
            max: 100,
            required: !0
          }))), (0, v.createElement)(y.Disabled, null, (0, v.createElement)(k.default, {
            block: "core/latest-comments",
            attributes: s,
            urlQueryArgs: {
              _locale: "site"
            }
          })));
        };

        var v = c(1753),
            _ = c(1326),
            y = c(4892),
            k = m(c(2643)),
            E = c(6756);
      },
      9800: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8635));

        var y = {
          apiVersion: 2,
          name: "core/latest-comments",
          title: "Latest Comments",
          category: "widgets",
          description: "Display a list of your most recent comments.",
          keywords: ["recent comments"],
          textdomain: "default",
          attributes: {
            commentsToShow: {
              type: "number",
              default: 5,
              minimum: 1,
              maximum: 100
            },
            displayAvatar: {
              type: "boolean",
              default: !0
            },
            displayDate: {
              type: "boolean",
              default: !0
            },
            displayExcerpt: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-latest-comments-editor",
          style: "wp-block-latest-comments"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.comment,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      509: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MIN_EXCERPT_LENGTH = s.MAX_POSTS_COLUMNS = s.MAX_EXCERPT_LENGTH = void 0;
        s.MIN_EXCERPT_LENGTH = 10;
        s.MAX_EXCERPT_LENGTH = 100;
        s.MAX_POSTS_COLUMNS = 6;
      },
      6159: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var _apiVersion$name$titl6 = {
          apiVersion: 2,
          name: "core/latest-posts",
          title: "Latest Posts",
          category: "widgets",
          description: "Display a list of your most recent posts.",
          keywords: ["recent posts"],
          textdomain: "default",
          attributes: {
            categories: {
              type: "array",
              items: {
                type: "object"
              }
            },
            selectedAuthor: {
              type: "number"
            },
            postsToShow: {
              type: "number",
              default: 5
            },
            displayPostContent: {
              type: "boolean",
              default: !1
            },
            displayPostContentRadio: {
              type: "string",
              default: "excerpt"
            },
            excerptLength: {
              type: "number",
              default: 55
            },
            displayAuthor: {
              type: "boolean",
              default: !1
            },
            displayPostDate: {
              type: "boolean",
              default: !1
            },
            postLayout: {
              type: "string",
              default: "list"
            },
            columns: {
              type: "number",
              default: 3
            },
            order: {
              type: "string",
              default: "desc"
            },
            orderBy: {
              type: "string",
              default: "date"
            },
            displayFeaturedImage: {
              type: "boolean",
              default: !1
            },
            featuredImageAlign: {
              type: "string",
              enum: ["left", "center", "right"]
            },
            featuredImageSizeSlug: {
              type: "string",
              default: "thumbnail"
            },
            featuredImageSizeWidth: {
              type: "number",
              default: null
            },
            featuredImageSizeHeight: {
              type: "number",
              default: null
            },
            addLinkToFeaturedImage: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-latest-posts-editor",
          style: "wp-block-latest-posts"
        },
            c = _apiVersion$name$titl6.attributes;
        var m = [{
          attributes: _objectSpread(_objectSpread({}, c), {}, {
            categories: {
              type: "string"
            }
          }),
          supports: {
            align: !0,
            html: !1
          },
          migrate: function migrate(l) {
            return _objectSpread(_objectSpread({}, l), {}, {
              categories: [{
                id: Number(l.categories)
              }]
            });
          },
          isEligible: function isEligible(l) {
            var s = l.categories;
            return s && "string" == typeof s;
          },
          save: function save() {
            return null;
          }
        }];
        s.default = m;
      },
      9178: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LatestPostsEdit(l) {
          var s;
          var c = l.attributes,
              m = l.setAttributes;

          var V = c.postsToShow,
              A = c.order,
              R = c.orderBy,
              O = c.categories,
              D = c.selectedAuthor,
              F = c.displayFeaturedImage,
              G = c.displayPostContentRadio,
              q = c.displayPostContent,
              W = c.displayPostDate,
              U = c.displayAuthor,
              $ = c.postLayout,
              Z = c.columns,
              K = c.excerptLength,
              Q = c.featuredImageAlign,
              Y = c.featuredImageSizeSlug,
              X = c.featuredImageSizeWidth,
              J = c.featuredImageSizeHeight,
              ee = c.addLinkToFeaturedImage,
              _ref148 = (0, S.useSelect)(function (l) {
            var _l41 = l(T.store),
                s = _l41.getEntityRecords,
                c = _l41.getMedia,
                m = _l41.getUsers,
                _l42 = l(C.store),
                v = _l42.getSettings,
                _v = v(),
                y = _v.imageSizes,
                k = _v.imageDimensions,
                E = O && O.length > 0 ? O.map(function (l) {
              return l.id;
            }) : [],
                w = s("postType", "post", (0, _.pickBy)({
              categories: E,
              author: D,
              order: A,
              orderby: R,
              per_page: V
            }, function (l) {
              return !(0, _.isUndefined)(l);
            }));

            return {
              defaultImageWidth: (0, _.get)(k, [Y, "width"], 0),
              defaultImageHeight: (0, _.get)(k, [Y, "height"], 0),
              imageSizeOptions: y.filter(function (l) {
                var s = l.slug;
                return "full" !== s;
              }).map(function (l) {
                var s = l.name,
                    c = l.slug;
                return {
                  value: c,
                  label: s
                };
              }),
              latestPosts: Array.isArray(w) ? w.map(function (l) {
                if (!l.featured_media) return l;
                var s = c(l.featured_media);
                var m = (0, _.get)(s, ["media_details", "sizes", Y, "source_url"], null);
                m || (m = (0, _.get)(s, "source_url", null));
                var v = {
                  url: m,
                  alt: null == s ? void 0 : s.alt_text
                };
                return _objectSpread(_objectSpread({}, l), {}, {
                  featuredImageInfo: v
                });
              }) : w,
              categoriesList: s("taxonomy", "category", z),
              authorList: m(L)
            };
          }, [Y, V, A, R, O, D]),
              te = _ref148.imageSizeOptions,
              re = _ref148.latestPosts,
              ae = _ref148.defaultImageWidth,
              oe = _ref148.defaultImageHeight,
              ne = _ref148.categoriesList,
              le = _ref148.authorList,
              ie = null !== (s = null == ne ? void 0 : ne.reduce(function (l, s) {
            return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.name, s));
          }, {})) && void 0 !== s ? s : {},
              se = !(null == re || !re.length),
              ce = (0, v.createElement)(C.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, E.__)("Post content settings")
          }, (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Post content"),
            checked: q,
            onChange: function onChange(l) {
              return m({
                displayPostContent: l
              });
            }
          }), q && (0, v.createElement)(k.RadioControl, {
            label: (0, E.__)("Show:"),
            selected: G,
            options: [{
              label: (0, E.__)("Excerpt"),
              value: "excerpt"
            }, {
              label: (0, E.__)("Full post"),
              value: "full_post"
            }],
            onChange: function onChange(l) {
              return m({
                displayPostContentRadio: l
              });
            }
          }), q && "excerpt" === G && (0, v.createElement)(k.RangeControl, {
            label: (0, E.__)("Max number of words in excerpt"),
            value: K,
            onChange: function onChange(l) {
              return m({
                excerptLength: l
              });
            },
            min: B.MIN_EXCERPT_LENGTH,
            max: B.MAX_EXCERPT_LENGTH
          })), (0, v.createElement)(k.PanelBody, {
            title: (0, E.__)("Post meta settings")
          }, (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Display author name"),
            checked: U,
            onChange: function onChange(l) {
              return m({
                displayAuthor: l
              });
            }
          }), (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Display post date"),
            checked: W,
            onChange: function onChange(l) {
              return m({
                displayPostDate: l
              });
            }
          })), (0, v.createElement)(k.PanelBody, {
            title: (0, E.__)("Featured image settings")
          }, (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Display featured image"),
            checked: F,
            onChange: function onChange(l) {
              return m({
                displayFeaturedImage: l
              });
            }
          }), F && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.__experimentalImageSizeControl, {
            onChange: function onChange(l) {
              var s = {};
              l.hasOwnProperty("width") && (s.featuredImageSizeWidth = l.width), l.hasOwnProperty("height") && (s.featuredImageSizeHeight = l.height), m(s);
            },
            slug: Y,
            width: X,
            height: J,
            imageWidth: ae,
            imageHeight: oe,
            imageSizeOptions: te,
            onChangeImage: function onChangeImage(l) {
              return m({
                featuredImageSizeSlug: l,
                featuredImageSizeWidth: void 0,
                featuredImageSizeHeight: void 0
              });
            }
          }), (0, v.createElement)(k.BaseControl, {
            className: "block-editor-image-alignment-control__row"
          }, (0, v.createElement)(k.BaseControl.VisualLabel, null, (0, E.__)("Image alignment")), (0, v.createElement)(C.BlockAlignmentToolbar, {
            value: Q,
            onChange: function onChange(l) {
              return m({
                featuredImageAlign: l
              });
            },
            controls: ["left", "center", "right"],
            isCollapsed: !1
          })), (0, v.createElement)(k.ToggleControl, {
            label: (0, E.__)("Add link to featured image"),
            checked: ee,
            onChange: function onChange(l) {
              return m({
                addLinkToFeaturedImage: l
              });
            }
          }))), (0, v.createElement)(k.PanelBody, {
            title: (0, E.__)("Sorting and filtering")
          }, (0, v.createElement)(k.QueryControls, {
            order: A,
            orderBy: R,
            numberOfItems: V,
            onOrderChange: function onOrderChange(l) {
              return m({
                order: l
              });
            },
            onOrderByChange: function onOrderByChange(l) {
              return m({
                orderBy: l
              });
            },
            onNumberOfItemsChange: function onNumberOfItemsChange(l) {
              return m({
                postsToShow: l
              });
            },
            categorySuggestions: ie,
            onCategoryChange: function onCategoryChange(l) {
              if (l.some(function (l) {
                return "string" == typeof l && !ie[l];
              })) return;
              var s = l.map(function (l) {
                return "string" == typeof l ? ie[l] : l;
              });
              if ((0, _.includes)(s, null)) return !1;
              m({
                categories: s
              });
            },
            selectedCategories: O,
            onAuthorChange: function onAuthorChange(l) {
              return m({
                selectedAuthor: "" !== l ? Number(l) : void 0
              });
            },
            authorList: null != le ? le : [],
            selectedAuthorId: D
          }), "grid" === $ && (0, v.createElement)(k.RangeControl, {
            label: (0, E.__)("Columns"),
            value: Z,
            onChange: function onChange(l) {
              return m({
                columns: l
              });
            },
            min: 2,
            max: se ? Math.min(B.MAX_POSTS_COLUMNS, re.length) : B.MAX_POSTS_COLUMNS,
            required: !0
          }))),
              ue = (0, C.useBlockProps)({
            className: (0, y.default)(_defineProperty({
              "wp-block-latest-posts__list": !0,
              "is-grid": "grid" === $,
              "has-dates": W,
              "has-author": U
            }, "columns-".concat(Z), "grid" === $))
          });

          if (!se) return (0, v.createElement)("div", ue, ce, (0, v.createElement)(k.Placeholder, {
            icon: P.pin,
            label: (0, E.__)("Latest Posts")
          }, Array.isArray(re) ? (0, E.__)("No posts found.") : (0, v.createElement)(k.Spinner, null)));
          var de = re.length > V ? re.slice(0, V) : re,
              me = [{
            icon: P.list,
            title: (0, E.__)("List view"),
            onClick: function onClick() {
              return m({
                postLayout: "list"
              });
            },
            isActive: "list" === $
          }, {
            icon: P.grid,
            title: (0, E.__)("Grid view"),
            onClick: function onClick() {
              return m({
                postLayout: "grid"
              });
            },
            isActive: "grid" === $
          }],
              pe = (0, w.__experimentalGetSettings)().formats.date;
          return (0, v.createElement)("div", null, ce, (0, v.createElement)(C.BlockControls, null, (0, v.createElement)(k.ToolbarGroup, {
            controls: me
          })), (0, v.createElement)("ul", ue, de.map(function (l, s) {
            var c = (0, _.invoke)(l, ["title", "rendered", "trim"]);
            var m = l.excerpt.rendered;
            var k = null == le ? void 0 : le.find(function (s) {
              return s.id === l.author;
            }),
                C = document.createElement("div");
            C.innerHTML = m, m = C.textContent || C.innerText || "";
            var _l$featuredImageInfo = l.featuredImageInfo;
            _l$featuredImageInfo = _l$featuredImageInfo === void 0 ? {} : _l$featuredImageInfo;
            var S = _l$featuredImageInfo.url,
                P = _l$featuredImageInfo.alt,
                T = (0, y.default)(_defineProperty({
              "wp-block-latest-posts__featured-image": !0
            }, "align".concat(Q), !!Q)),
                B = F && S,
                z = B && (0, v.createElement)("img", {
              src: S,
              alt: P,
              style: {
                maxWidth: X,
                maxHeight: J
              }
            }),
                L = K < m.trim().split(" ").length && "" === l.excerpt.raw ? (0, v.createElement)(v.Fragment, null, m.trim().split(" ", K).join(" "), (0, E.__)(" … "), (0, v.createElement)("a", {
              href: l.link,
              rel: "noopener noreferrer"
            }, (0, E.__)("Read more"))) : m;
            return (0, v.createElement)("li", {
              key: s
            }, B && (0, v.createElement)("div", {
              className: T
            }, ee ? (0, v.createElement)("a", {
              href: l.link,
              rel: "noreferrer noopener"
            }, z) : z), (0, v.createElement)("a", {
              href: l.link,
              rel: "noreferrer noopener"
            }, c ? (0, v.createElement)(v.RawHTML, null, c) : (0, E.__)("(no title)")), U && k && (0, v.createElement)("div", {
              className: "wp-block-latest-posts__post-author"
            }, (0, E.sprintf)((0, E.__)("by %s"), k.name)), W && l.date_gmt && (0, v.createElement)("time", {
              dateTime: (0, w.format)("c", l.date_gmt),
              className: "wp-block-latest-posts__post-date"
            }, (0, w.dateI18n)(pe, l.date_gmt)), q && "excerpt" === G && (0, v.createElement)("div", {
              className: "wp-block-latest-posts__post-excerpt"
            }, L), q && "full_post" === G && (0, v.createElement)("div", {
              className: "wp-block-latest-posts__post-full-content"
            }, (0, v.createElement)(v.RawHTML, {
              key: "html"
            }, l.content.raw.trim())));
          })));
        };

        var v = c(1753),
            _ = c(4793),
            y = m(c(2703)),
            k = c(4892),
            E = c(6756),
            w = c(7126),
            C = c(1326),
            S = c(8467),
            P = c(5303),
            T = c(1295),
            B = c(509);

        var z = {
          per_page: -1,
          context: "view"
        },
            L = {
          per_page: -1,
          has_published_posts: ["post"],
          context: "view"
        };
      },
      1588: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6159)),
            y = m(c(9178));

        var k = {
          apiVersion: 2,
          name: "core/latest-posts",
          title: "Latest Posts",
          category: "widgets",
          description: "Display a list of your most recent posts.",
          keywords: ["recent posts"],
          textdomain: "default",
          attributes: {
            categories: {
              type: "array",
              items: {
                type: "object"
              }
            },
            selectedAuthor: {
              type: "number"
            },
            postsToShow: {
              type: "number",
              default: 5
            },
            displayPostContent: {
              type: "boolean",
              default: !1
            },
            displayPostContentRadio: {
              type: "string",
              default: "excerpt"
            },
            excerptLength: {
              type: "number",
              default: 55
            },
            displayAuthor: {
              type: "boolean",
              default: !1
            },
            displayPostDate: {
              type: "boolean",
              default: !1
            },
            postLayout: {
              type: "string",
              default: "list"
            },
            columns: {
              type: "number",
              default: 3
            },
            order: {
              type: "string",
              default: "desc"
            },
            orderBy: {
              type: "string",
              default: "date"
            },
            displayFeaturedImage: {
              type: "boolean",
              default: !1
            },
            featuredImageAlign: {
              type: "string",
              enum: ["left", "center", "right"]
            },
            featuredImageSizeSlug: {
              type: "string",
              default: "thumbnail"
            },
            featuredImageSizeWidth: {
              type: "number",
              default: null
            },
            featuredImageSizeHeight: {
              type: "number",
              default: null
            },
            addLinkToFeaturedImage: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-latest-posts-editor",
          style: "wp-block-latest-posts"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.postList,
          example: {},
          edit: y.default,
          deprecated: _.default
        };
        s.settings = w;
      },
      6532: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(1326);

        var y = [{
          attributes: {
            ordered: {
              type: "boolean",
              default: !1,
              __experimentalRole: "content"
            },
            values: {
              type: "string",
              source: "html",
              selector: "ol,ul",
              multiline: "li",
              __unstableMultilineWrapperTags: ["ol", "ul"],
              default: "",
              __experimentalRole: "content"
            },
            type: {
              type: "string"
            },
            start: {
              type: "number"
            },
            reversed: {
              type: "boolean"
            },
            placeholder: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            className: !1,
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0
            },
            color: {
              gradients: !0,
              link: !0
            },
            __unstablePasteTextInline: !0,
            __experimentalSelector: "ol,ul",
            __experimentalSlashInserter: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.ordered,
                m = s.values,
                y = s.type,
                k = s.reversed,
                E = s.start,
                w = c ? "ol" : "ul";
            return (0, v.createElement)(w, _.useBlockProps.save({
              type: y,
              reversed: k,
              start: E
            }), (0, v.createElement)(_.RichText.Content, {
              value: m,
              multiline: "li"
            }));
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = y;
      },
      7848: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ListEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.mergeBlocks,
              B = l.onReplace,
              z = l.style;
          var L = s.ordered,
              V = s.values,
              A = s.type,
              R = s.reversed,
              O = s.start,
              D = s.placeholder,
              F = L ? "ol" : "ul",
              G = (0, E.useBlockProps)({
            style: z
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.RichText, (0, _.default)({
            identifier: "values",
            multiline: "li",
            tagName: F,
            onChange: function onChange(l) {
              return c({
                values: l
              });
            },
            value: V,
            "aria-label": (0, y.__)("List text"),
            placeholder: D || (0, y.__)("List"),
            onMerge: m,
            onSplit: function onSplit(l) {
              return (0, k.createBlock)(P.name, _objectSpread(_objectSpread({}, s), {}, {
                values: l
              }));
            },
            __unstableOnSplitMiddle: function __unstableOnSplitMiddle() {
              return (0, k.createBlock)("core/paragraph");
            },
            onReplace: B,
            onRemove: function onRemove() {
              return B([]);
            },
            start: O,
            reversed: R,
            type: A
          }, G), function (l) {
            var s = l.value,
                m = l.onChange,
                _ = l.onFocus;
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.RichTextShortcut, {
              type: "primary",
              character: "[",
              onUse: function onUse() {
                m((0, C.__unstableOutdentListItems)(s));
              }
            }), (0, v.createElement)(E.RichTextShortcut, {
              type: "primary",
              character: "]",
              onUse: function onUse() {
                m((0, C.__unstableIndentListItems)(s, {
                  type: F
                }));
              }
            }), (0, v.createElement)(E.RichTextShortcut, {
              type: "primary",
              character: "m",
              onUse: function onUse() {
                m((0, C.__unstableIndentListItems)(s, {
                  type: F
                }));
              }
            }), (0, v.createElement)(E.RichTextShortcut, {
              type: "primaryShift",
              character: "m",
              onUse: function onUse() {
                m((0, C.__unstableOutdentListItems)(s));
              }
            }), (0, v.createElement)(E.BlockControls, {
              group: "block"
            }, (0, v.createElement)(w.ToolbarButton, {
              icon: (0, y.isRTL)() ? S.formatListBulletsRTL : S.formatListBullets,
              title: (0, y.__)("Unordered"),
              describedBy: (0, y.__)("Convert to unordered list"),
              isActive: (0, C.__unstableIsActiveListType)(s, "ul", F),
              onClick: function onClick() {
                m((0, C.__unstableChangeListType)(s, {
                  type: "ul"
                })), _(), (0, C.__unstableIsListRootSelected)(s) && c({
                  ordered: !1
                });
              }
            }), (0, v.createElement)(w.ToolbarButton, {
              icon: (0, y.isRTL)() ? S.formatListNumberedRTL : S.formatListNumbered,
              title: (0, y.__)("Ordered"),
              describedBy: (0, y.__)("Convert to ordered list"),
              isActive: (0, C.__unstableIsActiveListType)(s, "ol", F),
              onClick: function onClick() {
                m((0, C.__unstableChangeListType)(s, {
                  type: "ol"
                })), _(), (0, C.__unstableIsListRootSelected)(s) && c({
                  ordered: !0
                });
              }
            }), (0, v.createElement)(w.ToolbarButton, {
              icon: (0, y.isRTL)() ? S.formatOutdentRTL : S.formatOutdent,
              title: (0, y.__)("Outdent"),
              describedBy: (0, y.__)("Outdent list item"),
              shortcut: (0, y._x)("Backspace", "keyboard key"),
              isDisabled: !(0, C.__unstableCanOutdentListItems)(s),
              onClick: function onClick() {
                m((0, C.__unstableOutdentListItems)(s)), _();
              }
            }), (0, v.createElement)(w.ToolbarButton, {
              icon: (0, y.isRTL)() ? S.formatIndentRTL : S.formatIndent,
              title: (0, y.__)("Indent"),
              describedBy: (0, y.__)("Indent list item"),
              shortcut: (0, y._x)("Space", "keyboard key"),
              isDisabled: !(0, C.__unstableCanIndentListItems)(s),
              onClick: function onClick() {
                m((0, C.__unstableIndentListItems)(s, {
                  type: F
                })), _();
              }
            })));
          }), L && (0, v.createElement)(T.default, {
            setAttributes: c,
            ordered: L,
            reversed: R,
            start: O,
            placeholder: D
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(6756),
            k = c(6700),
            E = c(1326),
            w = c(4892),
            C = c(7060),
            S = c(5303),
            P = c(5338),
            T = m(c(2528));
      },
      5338: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6532)),
            y = m(c(7848)),
            k = m(c(2968)),
            E = m(c(9220));

        var w = {
          apiVersion: 2,
          name: "core/list",
          title: "List",
          category: "text",
          description: "Create a bulleted or numbered list.",
          keywords: ["bullet list", "ordered list", "numbered list"],
          textdomain: "default",
          attributes: {
            ordered: {
              type: "boolean",
              default: !1,
              __experimentalRole: "content"
            },
            values: {
              type: "string",
              source: "html",
              selector: "ol,ul",
              multiline: "li",
              __unstableMultilineWrapperTags: ["ol", "ul"],
              default: "",
              __experimentalRole: "content"
            },
            type: {
              type: "string"
            },
            start: {
              type: "number"
            },
            reversed: {
              type: "boolean"
            },
            placeholder: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            className: !1,
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            color: {
              gradients: !0,
              link: !0
            },
            __unstablePasteTextInline: !0,
            __experimentalSelector: "ol,ul",
            __experimentalSlashInserter: !0
          },
          editorStyle: "wp-block-list-editor",
          style: "wp-block-list"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: v.list,
          example: {
            attributes: {
              values: "<li>Alice.</li><li>The White Rabbit.</li><li>The Cheshire Cat.</li><li>The Mad Hatter.</li><li>The Queen of Hearts.</li>"
            }
          },
          transforms: E.default,
          merge: function merge(l, s) {
            var c = s.values;
            return c && "<li></li>" !== c ? _objectSpread(_objectSpread({}, l), {}, {
              values: l.values + c
            }) : l;
          },
          edit: y.default,
          save: k.default,
          deprecated: _.default
        };
        s.settings = S;
      },
      2528: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(1326),
            y = c(4892);

        var _default = function _default(l) {
          var s = l.setAttributes,
              c = l.reversed,
              k = l.start;
          return (0, m.createElement)(_.InspectorControls, null, (0, m.createElement)(y.PanelBody, {
            title: (0, v.__)("Ordered list settings")
          }, (0, m.createElement)(y.TextControl, {
            label: (0, v.__)("Start value"),
            type: "number",
            onChange: function onChange(l) {
              var c = parseInt(l, 10);
              s({
                start: isNaN(c) ? void 0 : c
              });
            },
            value: Number.isInteger(k) ? k.toString(10) : "",
            step: "1"
          }), (0, m.createElement)(y.ToggleControl, {
            label: (0, v.__)("Reverse list numbering"),
            checked: c || !1,
            onChange: function onChange(l) {
              s({
                reversed: l || void 0
              });
            }
          })));
        };

        s.default = _default;
      },
      2968: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.ordered,
              _ = s.values,
              y = s.type,
              k = s.reversed,
              E = s.start,
              w = c ? "ol" : "ul";
          return (0, m.createElement)(w, v.useBlockProps.save({
            type: y,
            reversed: k,
            start: E
          }), (0, m.createElement)(v.RichText.Content, {
            value: _,
            multiline: "li"
          }));
        };
        var m = c(1753),
            v = c(1326);
      },
      9220: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(7060);

        function getListContentSchema(l) {
          var s = l.phrasingContentSchema;

          var c = _objectSpread(_objectSpread({}, s), {}, {
            ul: {},
            ol: {
              attributes: ["type", "start", "reversed"]
            }
          });

          return ["ul", "ol"].forEach(function (l) {
            c[l].children = {
              li: {
                children: c
              }
            };
          }), c;
        }

        var _ = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph", "core/heading"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/list", {
                values: (0, v.toHTMLString)({
                  value: (0, v.join)(l.map(function (s) {
                    var c = s.content;
                    var m = (0, v.create)({
                      html: c
                    });
                    return l.length > 1 ? m : (0, v.replace)(m, /\n/g, v.__UNSTABLE_LINE_SEPARATOR);
                  }), v.__UNSTABLE_LINE_SEPARATOR),
                  multilineTag: "li"
                }),
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/quote", "core/pullquote"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.anchor;
              return (0, m.createBlock)("core/list", {
                values: (0, v.toHTMLString)({
                  value: (0, v.create)({
                    html: s,
                    multilineTag: "p"
                  }),
                  multilineTag: "li"
                }),
                anchor: c
              });
            }
          }, {
            type: "raw",
            selector: "ol,ul",
            schema: function schema(l) {
              return {
                ol: getListContentSchema(l).ol,
                ul: getListContentSchema(l).ul
              };
            },
            transform: function transform(l) {
              var s = {
                ordered: "OL" === l.nodeName,
                anchor: "" === l.id ? void 0 : l.id
              };

              if (s.ordered) {
                var _c6 = l.getAttribute("type");

                _c6 && (s.type = _c6), null !== l.getAttribute("reversed") && (s.reversed = !0);

                var _m5 = parseInt(l.getAttribute("start"), 10);

                isNaN(_m5) || 1 === _m5 && !s.reversed || (s.start = _m5);
              }

              return (0, m.createBlock)("core/list", _objectSpread(_objectSpread({}, (0, m.getBlockAttributes)("core/list", l.outerHTML)), s));
            }
          }].concat(_toConsumableArray(["*", "-"].map(function (l) {
            return {
              type: "prefix",
              prefix: l,
              transform: function transform(l) {
                return (0, m.createBlock)("core/list", {
                  values: "<li>".concat(l, "</li>")
                });
              }
            };
          })), _toConsumableArray(["1.", "1)"].map(function (l) {
            return {
              type: "prefix",
              prefix: l,
              transform: function transform(l) {
                return (0, m.createBlock)("core/list", {
                  ordered: !0,
                  values: "<li>".concat(l, "</li>")
                });
              }
            };
          }))),
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              var s = l.values;
              return (0, v.split)((0, v.create)({
                html: s,
                multilineTag: "li",
                multilineWrapperTags: ["ul", "ol"]
              }), v.__UNSTABLE_LINE_SEPARATOR).map(function (l) {
                return (0, m.createBlock)("core/paragraph", {
                  content: (0, v.toHTMLString)({
                    value: l
                  })
                });
              });
            }
          }, {
            type: "block",
            blocks: ["core/heading"],
            transform: function transform(l) {
              var s = l.values;
              return (0, v.split)((0, v.create)({
                html: s,
                multilineTag: "li",
                multilineWrapperTags: ["ul", "ol"]
              }), v.__UNSTABLE_LINE_SEPARATOR).map(function (l) {
                return (0, m.createBlock)("core/heading", {
                  content: (0, v.toHTMLString)({
                    value: l
                  })
                });
              });
            }
          }, {
            type: "block",
            blocks: ["core/quote"],
            transform: function transform(l) {
              var s = l.values,
                  c = l.anchor;
              return (0, m.createBlock)("core/quote", {
                value: (0, v.toHTMLString)({
                  value: (0, v.create)({
                    html: s,
                    multilineTag: "li",
                    multilineWrapperTags: ["ul", "ol"]
                  }),
                  multilineTag: "p"
                }),
                anchor: c
              });
            }
          }, {
            type: "block",
            blocks: ["core/pullquote"],
            transform: function transform(l) {
              var s = l.values,
                  c = l.anchor;
              return (0, m.createBlock)("core/pullquote", {
                value: (0, v.toHTMLString)({
                  value: (0, v.create)({
                    html: s,
                    multilineTag: "li",
                    multilineWrapperTags: ["ul", "ol"]
                  }),
                  multilineTag: "p"
                }),
                anchor: c
              });
            }
          }]
        };
        s.default = _;
      },
      6716: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LoginOutEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var k = s.displayLoginAsForm,
              E = s.redirectToCurrent;
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.InspectorControls, null, (0, m.createElement)(v.PanelBody, {
            title: (0, _.__)("Login/out settings")
          }, (0, m.createElement)(v.ToggleControl, {
            label: (0, _.__)("Display login as form"),
            checked: k,
            onChange: function onChange() {
              return c({
                displayLoginAsForm: !k
              });
            }
          }), (0, m.createElement)(v.ToggleControl, {
            label: (0, _.__)("Redirect to current URL"),
            checked: E,
            onChange: function onChange() {
              return c({
                redirectToCurrent: !E
              });
            }
          }))), (0, m.createElement)("div", (0, y.useBlockProps)({
            className: "logged-in"
          }), (0, m.createElement)("a", {
            href: "#login-pseudo-link"
          }, (0, _.__)("Log out"))));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            y = c(1326);
      },
      6006: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6716));

        var y = {
          apiVersion: 2,
          name: "core/loginout",
          title: "Login/out",
          category: "theme",
          description: "Show login & logout links.",
          keywords: ["login", "logout", "form"],
          textdomain: "default",
          attributes: {
            displayLoginAsForm: {
              type: "boolean",
              default: !1
            },
            redirectToCurrent: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            className: !0,
            typography: {
              fontSize: !1
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.login,
          edit: _.default
        };
        s.settings = E;
      },
      2965: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DEFAULT_MEDIA_SIZE_SLUG = void 0;
        s.DEFAULT_MEDIA_SIZE_SLUG = "full";
      },
      6542: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(6193);

        var migrateCustomColors = function migrateCustomColors(l) {
          if (!l.customBackgroundColor) return l;
          var s = {
            color: {
              background: l.customBackgroundColor
            }
          };
          return _objectSpread(_objectSpread({}, (0, y.omit)(l, ["customBackgroundColor"])), {}, {
            style: s
          });
        },
            w = {
          align: {
            type: "string",
            default: "wide"
          },
          backgroundColor: {
            type: "string"
          },
          mediaAlt: {
            type: "string",
            source: "attribute",
            selector: "figure img",
            attribute: "alt",
            default: ""
          },
          mediaPosition: {
            type: "string",
            default: "left"
          },
          mediaId: {
            type: "number"
          },
          mediaType: {
            type: "string"
          },
          mediaWidth: {
            type: "number",
            default: 50
          },
          isStackedOnMobile: {
            type: "boolean",
            default: !0
          }
        };

        var C = [{
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customBackgroundColor: {
              type: "string"
            },
            mediaLink: {
              type: "string"
            },
            linkDestination: {
              type: "string"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "target"
            },
            href: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "href"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "rel"
            },
            linkClass: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "class"
            },
            verticalAlignment: {
              type: "string"
            },
            imageFill: {
              type: "boolean"
            },
            focalPoint: {
              type: "object"
            }
          }),
          migrate: migrateCustomColors,
          save: function save(l) {
            var _ref151;

            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                w = s.isStackedOnMobile,
                C = s.mediaAlt,
                S = s.mediaPosition,
                P = s.mediaType,
                T = s.mediaUrl,
                B = s.mediaWidth,
                z = s.mediaId,
                L = s.verticalAlignment,
                V = s.imageFill,
                A = s.focalPoint,
                R = s.linkClass,
                O = s.href,
                D = s.linkTarget,
                F = s.rel,
                G = (0, y.isEmpty)(F) ? void 0 : F;
            var q = (0, v.createElement)("img", {
              src: T,
              alt: C,
              className: z && "image" === P ? "wp-image-".concat(z) : null
            });
            O && (q = (0, v.createElement)("a", {
              className: R,
              href: O,
              target: D,
              rel: G
            }, q));
            var W = {
              image: function image() {
                return q;
              },
              video: function video() {
                return (0, v.createElement)("video", {
                  controls: !0,
                  src: T
                });
              }
            },
                U = (0, k.getColorClassName)("background-color", c),
                $ = (0, _.default)((_ref151 = {
              "has-media-on-the-right": "right" === S,
              "has-background": U || m
            }, _defineProperty(_ref151, U, U), _defineProperty(_ref151, "is-stacked-on-mobile", w), _defineProperty(_ref151, "is-vertically-aligned-".concat(L), L), _defineProperty(_ref151, "is-image-fill", V), _ref151)),
                Z = V ? (0, E.imageFillStyles)(T, A) : {};
            var K;
            50 !== B && (K = "right" === S ? "auto ".concat(B, "%") : "".concat(B, "% auto"));
            var Q = {
              backgroundColor: U ? void 0 : m,
              gridTemplateColumns: K
            };
            return (0, v.createElement)("div", {
              className: $,
              style: Q
            }, (0, v.createElement)("figure", {
              className: "wp-block-media-text__media",
              style: Z
            }, (W[P] || y.noop)()), (0, v.createElement)("div", {
              className: "wp-block-media-text__content"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customBackgroundColor: {
              type: "string"
            },
            mediaUrl: {
              type: "string",
              source: "attribute",
              selector: "figure video,figure img",
              attribute: "src"
            },
            verticalAlignment: {
              type: "string"
            },
            imageFill: {
              type: "boolean"
            },
            focalPoint: {
              type: "object"
            }
          }),
          migrate: migrateCustomColors,
          save: function save(l) {
            var _ref152;

            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                w = s.isStackedOnMobile,
                C = s.mediaAlt,
                S = s.mediaPosition,
                P = s.mediaType,
                T = s.mediaUrl,
                B = s.mediaWidth,
                z = s.mediaId,
                L = s.verticalAlignment,
                V = s.imageFill,
                A = s.focalPoint,
                R = {
              image: function image() {
                return (0, v.createElement)("img", {
                  src: T,
                  alt: C,
                  className: z && "image" === P ? "wp-image-".concat(z) : null
                });
              },
              video: function video() {
                return (0, v.createElement)("video", {
                  controls: !0,
                  src: T
                });
              }
            },
                O = (0, k.getColorClassName)("background-color", c),
                D = (0, _.default)((_ref152 = {
              "has-media-on-the-right": "right" === S
            }, _defineProperty(_ref152, O, O), _defineProperty(_ref152, "is-stacked-on-mobile", w), _defineProperty(_ref152, "is-vertically-aligned-".concat(L), L), _defineProperty(_ref152, "is-image-fill", V), _ref152)),
                F = V ? (0, E.imageFillStyles)(T, A) : {};
            var G;
            50 !== B && (G = "right" === S ? "auto ".concat(B, "%") : "".concat(B, "% auto"));
            var q = {
              backgroundColor: O ? void 0 : m,
              gridTemplateColumns: G
            };
            return (0, v.createElement)("div", {
              className: D,
              style: q
            }, (0, v.createElement)("figure", {
              className: "wp-block-media-text__media",
              style: F
            }, (R[P] || y.noop)()), (0, v.createElement)("div", {
              className: "wp-block-media-text__content"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            customBackgroundColor: {
              type: "string"
            },
            mediaUrl: {
              type: "string",
              source: "attribute",
              selector: "figure video,figure img",
              attribute: "src"
            }
          }),
          save: function save(l) {
            var _ref153;

            var s = l.attributes;
            var c = s.backgroundColor,
                m = s.customBackgroundColor,
                E = s.isStackedOnMobile,
                w = s.mediaAlt,
                C = s.mediaPosition,
                S = s.mediaType,
                P = s.mediaUrl,
                T = s.mediaWidth,
                B = {
              image: function image() {
                return (0, v.createElement)("img", {
                  src: P,
                  alt: w
                });
              },
              video: function video() {
                return (0, v.createElement)("video", {
                  controls: !0,
                  src: P
                });
              }
            },
                z = (0, k.getColorClassName)("background-color", c),
                L = (0, _.default)((_ref153 = {
              "has-media-on-the-right": "right" === C
            }, _defineProperty(_ref153, z, z), _defineProperty(_ref153, "is-stacked-on-mobile", E), _ref153));
            var V;
            50 !== T && (V = "right" === C ? "auto ".concat(T, "%") : "".concat(T, "% auto"));
            var A = {
              backgroundColor: z ? void 0 : m,
              gridTemplateColumns: V
            };
            return (0, v.createElement)("div", {
              className: L,
              style: A
            }, (0, v.createElement)("figure", {
              className: "wp-block-media-text__media"
            }, (B[S] || y.noop)()), (0, v.createElement)("div", {
              className: "wp-block-media-text__content"
            }, (0, v.createElement)(k.InnerBlocks.Content, null)));
          }
        }];
        s.default = C;
      },
      2456: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(6756),
            E = c(8467),
            w = c(1326),
            C = c(4892),
            S = c(5303),
            P = c(1295),
            T = m(c(6193)),
            B = c(2965);

        var z = [["core/paragraph", {
          fontSize: "large",
          placeholder: (0, k._x)("Content…", "content placeholder")
        }]],
            applyWidthConstraints = function applyWidthConstraints(l) {
          return Math.max(15, Math.min(l, 85));
        };

        function getImageSourceUrlBySizeSlug(l, s) {
          var c, m, v;
          return null == l || null === (c = l.media_details) || void 0 === c || null === (m = c.sizes) || void 0 === m || null === (v = m[s]) || void 0 === v ? void 0 : v.source_url;
        }

        var L = function MediaTextEdit(l) {
          var _ref156;

          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes;

          var L = s.focalPoint,
              V = s.href,
              A = s.imageFill,
              R = s.isStackedOnMobile,
              O = s.linkClass,
              D = s.linkDestination,
              F = s.linkTarget,
              G = s.mediaAlt,
              q = s.mediaId,
              W = s.mediaPosition,
              U = s.mediaType,
              $ = s.mediaUrl,
              Z = s.mediaWidth,
              K = s.rel,
              Q = s.verticalAlignment,
              Y = s.mediaSizeSlug || B.DEFAULT_MEDIA_SIZE_SLUG,
              X = (0, E.useSelect)(function (l) {
            return q && c ? l(P.store).getMedia(q) : null;
          }, [c, q]),
              J = (0, v.useRef)(),
              imperativeFocalPointPreview = function imperativeFocalPointPreview(l) {
            var s = J.current.resizable.style,
                c = l.x,
                m = l.y;
            s.backgroundPosition = "".concat(100 * c, "% ").concat(100 * m, "%");
          },
              _ref154 = (0, v.useState)(null),
              _ref155 = _slicedToArray2(_ref154, 2),
              ee = _ref155[0],
              te = _ref155[1],
              re = function attributesFromMedia(l) {
            var _l$attributes13 = l.attributes,
                s = _l$attributes13.linkDestination,
                c = _l$attributes13.href,
                m = l.setAttributes;
            return function (l) {
              var v, _;

              var y, k, E, w, C;
              v = l.media_type ? "image" === l.media_type ? "image" : "video" : l.type, "image" === v && (_ = (null === (y = l.sizes) || void 0 === y || null === (k = y.large) || void 0 === k ? void 0 : k.url) || (null === (E = l.media_details) || void 0 === E || null === (w = E.sizes) || void 0 === w || null === (C = w.large) || void 0 === C ? void 0 : C.source_url));
              var S = c;
              "media" === s && (S = l.url), "attachment" === s && (S = l.link), m({
                mediaAlt: l.alt,
                mediaId: l.id,
                mediaType: v,
                mediaUrl: _ || l.url,
                mediaLink: l.link || void 0,
                href: S,
                focalPoint: void 0
              });
            };
          }({
            attributes: s,
            setAttributes: m
          }),
              commitWidthChange = function commitWidthChange(l) {
            m({
              mediaWidth: applyWidthConstraints(l)
            }), te(applyWidthConstraints(l));
          },
              ae = (0, _.default)((_ref156 = {
            "has-media-on-the-right": "right" === W,
            "is-selected": c,
            "is-stacked-on-mobile": R
          }, _defineProperty(_ref156, "is-vertically-aligned-".concat(Q), Q), _defineProperty(_ref156, "is-image-fill", A), _ref156)),
              oe = "".concat(ee || Z, "%"),
              ne = "right" === W ? "1fr ".concat(oe) : "".concat(oe, " 1fr"),
              le = {
            gridTemplateColumns: ne,
            msGridColumns: ne
          },
              ie = (0, E.useSelect)(function (l) {
            var s = l(w.store).getSettings();
            return null == s ? void 0 : s.imageSizes;
          }, []),
              se = (0, y.map)((0, y.filter)(ie, function (l) {
            var s = l.slug;
            return getImageSourceUrlBySizeSlug(X, s);
          }), function (l) {
            var s = l.name,
                c = l.slug;
            return {
              value: c,
              label: s
            };
          }),
              ce = (0, v.createElement)(C.PanelBody, {
            title: (0, k.__)("Media & Text settings")
          }, (0, v.createElement)(C.ToggleControl, {
            label: (0, k.__)("Stack on mobile"),
            checked: R,
            onChange: function onChange() {
              return m({
                isStackedOnMobile: !R
              });
            }
          }), "image" === U && (0, v.createElement)(C.ToggleControl, {
            label: (0, k.__)("Crop image to fill entire column"),
            checked: A,
            onChange: function onChange() {
              return m({
                imageFill: !A
              });
            }
          }), A && $ && "image" === U && (0, v.createElement)(C.FocalPointPicker, {
            label: (0, k.__)("Focal point picker"),
            url: $,
            value: L,
            onChange: function onChange(l) {
              return m({
                focalPoint: l
              });
            },
            onDragStart: imperativeFocalPointPreview,
            onDrag: imperativeFocalPointPreview
          }), "image" === U && (0, v.createElement)(C.TextareaControl, {
            label: (0, k.__)("Alt text (alternative text)"),
            value: G,
            onChange: function onChange(l) {
              m({
                mediaAlt: l
              });
            },
            help: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.ExternalLink, {
              href: "https://www.w3.org/WAI/tutorials/images/decision-tree"
            }, (0, k.__)("Describe the purpose of the image")), (0, k.__)("Leave empty if the image is purely decorative."))
          }), "image" === U && (0, v.createElement)(w.__experimentalImageSizeControl, {
            onChangeImage: function onChangeImage(l) {
              var s = getImageSourceUrlBySizeSlug(X, l);
              if (!s) return null;
              m({
                mediaUrl: s,
                mediaSizeSlug: l
              });
            },
            slug: Y,
            imageSizeOptions: se,
            isResizable: !1
          }), $ && (0, v.createElement)(C.RangeControl, {
            label: (0, k.__)("Media width"),
            value: ee || Z,
            onChange: commitWidthChange,
            min: 15,
            max: 85
          })),
              ue = (0, w.useBlockProps)({
            className: ae,
            style: le
          }),
              de = (0, w.useInnerBlocksProps)({
            className: "wp-block-media-text__content"
          }, {
            template: z
          });

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.InspectorControls, null, ce), (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, (0, v.createElement)(w.BlockVerticalAlignmentControl, {
            onChange: function onChange(l) {
              m({
                verticalAlignment: l
              });
            },
            value: Q
          }), (0, v.createElement)(C.ToolbarButton, {
            icon: S.pullLeft,
            title: (0, k.__)("Show media on left"),
            isActive: "left" === W,
            onClick: function onClick() {
              return m({
                mediaPosition: "left"
              });
            }
          }), (0, v.createElement)(C.ToolbarButton, {
            icon: S.pullRight,
            title: (0, k.__)("Show media on right"),
            isActive: "right" === W,
            onClick: function onClick() {
              return m({
                mediaPosition: "right"
              });
            }
          }), "image" === U && (0, v.createElement)(w.__experimentalImageURLInputUI, {
            url: V || "",
            onChangeUrl: function onChangeUrl(l) {
              m(l);
            },
            linkDestination: D,
            mediaType: U,
            mediaUrl: X && X.source_url,
            mediaLink: X && X.link,
            linkTarget: F,
            linkClass: O,
            rel: K
          })), (0, v.createElement)("div", ue, (0, v.createElement)(T.default, {
            className: "wp-block-media-text__media",
            onSelectMedia: re,
            onWidthChange: function onWidthChange(l) {
              te(applyWidthConstraints(l));
            },
            commitWidthChange: commitWidthChange,
            ref: J,
            focalPoint: L,
            imageFill: A,
            isSelected: c,
            isStackedOnMobile: R,
            mediaAlt: G,
            mediaId: q,
            mediaPosition: W,
            mediaType: U,
            mediaUrl: $,
            mediaWidth: Z
          }), (0, v.createElement)("div", de)));
        };

        s.default = L;
      },
      1930: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(6542)),
            k = m(c(2456)),
            E = m(c(6720)),
            w = m(c(7219));

        var C = {
          apiVersion: 2,
          name: "core/media-text",
          title: "Media & Text",
          category: "media",
          description: "Set media and words side-by-side for a richer layout.",
          keywords: ["image", "video"],
          textdomain: "default",
          attributes: {
            align: {
              type: "string",
              default: "wide"
            },
            mediaAlt: {
              type: "string",
              source: "attribute",
              selector: "figure img",
              attribute: "alt",
              default: ""
            },
            mediaPosition: {
              type: "string",
              default: "left"
            },
            mediaId: {
              type: "number"
            },
            mediaUrl: {
              type: "string",
              source: "attribute",
              selector: "figure video,figure img",
              attribute: "src"
            },
            mediaLink: {
              type: "string"
            },
            linkDestination: {
              type: "string"
            },
            linkTarget: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "target"
            },
            href: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "href"
            },
            rel: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "rel"
            },
            linkClass: {
              type: "string",
              source: "attribute",
              selector: "figure a",
              attribute: "class"
            },
            mediaType: {
              type: "string"
            },
            mediaWidth: {
              type: "number",
              default: 50
            },
            mediaSizeSlug: {
              type: "string"
            },
            isStackedOnMobile: {
              type: "boolean",
              default: !0
            },
            verticalAlignment: {
              type: "string"
            },
            imageFill: {
              type: "boolean"
            },
            focalPoint: {
              type: "object"
            }
          },
          supports: {
            anchor: !0,
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            }
          },
          editorStyle: "wp-block-media-text-editor",
          style: "wp-block-media-text"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.mediaAndText,
          example: {
            viewportWidth: 601,
            attributes: {
              mediaType: "image",
              mediaUrl: "https://s.w.org/images/core/5.3/Biologia_Centrali-Americana_-_Cantorchilus_semibadius_1902.jpg"
            },
            innerBlocks: [{
              name: "core/paragraph",
              attributes: {
                content: (0, v.__)("The wren<br>Earns his living<br>Noiselessly.")
              }
            }, {
              name: "core/paragraph",
              attributes: {
                content: (0, v.__)("— Kobayashi Issa (一茶)")
              }
            }]
          },
          transforms: w.default,
          edit: k.default,
          save: E.default,
          deprecated: y.default
        };
        s.settings = P;
      },
      4384: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M18 2l2 4h-2l-2-4h-3l2 4h-2l-2-4h-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2zm2 12H10V4.4L11.8 8H20z"
        }), (0, m.createElement)(v.Path, {
          d: "M14 20H4V10h3V8H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2z"
        }), (0, m.createElement)(v.Path, {
          d: "M5 19h8l-1.59-2H9.24l-.84 1.1L7 16.3 5 19z"
        }));

        s.default = _;
      },
      6193: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.imageFillStyles = imageFillStyles;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(4793),
            E = c(4892),
            w = c(1326),
            C = c(6756),
            S = c(3200),
            P = c(8467),
            T = c(9388),
            B = m(c(4384));

        var z = ["image", "video"];

        function imageFillStyles(l, s) {
          return l ? {
            backgroundImage: "url(".concat(l, ")"),
            backgroundPosition: s ? "".concat(100 * s.x, "% ").concat(100 * s.y, "%") : "50% 50%"
          } : {};
        }

        var L = (0, v.forwardRef)(function (l, s) {
          var c = l.isSelected,
              m = l.isStackedOnMobile,
              y = _objectWithoutProperties(l, _excluded9);

          var k = (0, S.useViewportMatch)("small", "<");
          return (0, v.createElement)(E.ResizableBox, (0, _.default)({
            ref: s,
            showHandle: c && (!k || !m)
          }, y));
        });

        function ToolbarEditButton(l) {
          var s = l.mediaId,
              c = l.mediaUrl,
              m = l.onSelectMedia;
          return (0, v.createElement)(w.BlockControls, {
            group: "other"
          }, (0, v.createElement)(w.MediaReplaceFlow, {
            mediaId: s,
            mediaURL: c,
            allowedTypes: z,
            accept: "image/*,video/*",
            onSelect: m
          }));
        }

        function PlaceholderContainer(l) {
          var s = l.className,
              c = l.noticeOperations,
              m = l.noticeUI,
              _ = l.mediaUrl,
              y = l.onSelectMedia;
          return (0, v.createElement)(w.MediaPlaceholder, {
            icon: (0, v.createElement)(w.BlockIcon, {
              icon: B.default
            }),
            labels: {
              title: (0, C.__)("Media area")
            },
            className: s,
            onSelect: y,
            accept: "image/*,video/*",
            allowedTypes: z,
            notices: m,
            onError: function onError(l) {
              c.removeAllNotices(), c.createErrorNotice(l);
            },
            disableMediaButtons: _
          });
        }

        var V = (0, E.withNotices)((0, v.forwardRef)(function MediaContainer(l, s) {
          var c = l.className,
              m = l.commitWidthChange,
              _ = l.focalPoint,
              C = l.imageFill,
              S = l.isSelected,
              B = l.isStackedOnMobile,
              z = l.mediaAlt,
              V = l.mediaId,
              A = l.mediaPosition,
              R = l.mediaType,
              O = l.mediaUrl,
              D = l.mediaWidth,
              F = l.onSelectMedia,
              G = l.onWidthChange,
              q = !V && (0, T.isBlobURL)(O),
              _ref157 = (0, P.useDispatch)(w.store),
              W = _ref157.toggleSelection;

          if (O) {
            var onResizeStart = function onResizeStart() {
              W(!1);
            },
                onResize = function onResize(l, s, c) {
              G(parseInt(c.style.width));
            },
                onResizeStop = function onResizeStop(l, s, c) {
              W(!0), m(parseInt(c.style.width));
            },
                _w2 = {
              right: "left" === A,
              left: "right" === A
            },
                _P = "image" === R && C ? imageFillStyles(O, _) : {},
                _T2 = {
              image: function image() {
                return (0, v.createElement)("img", {
                  src: O,
                  alt: z
                });
              },
              video: function video() {
                return (0, v.createElement)("video", {
                  controls: !0,
                  src: O
                });
              }
            };

            return (0, v.createElement)(L, {
              as: "figure",
              className: (0, y.default)(c, "editor-media-container__resizer", {
                "is-transient": q
              }),
              style: _P,
              size: {
                width: D + "%"
              },
              minWidth: "10%",
              maxWidth: "100%",
              enable: _w2,
              onResizeStart: onResizeStart,
              onResize: onResize,
              onResizeStop: onResizeStop,
              axis: "x",
              isSelected: S,
              isStackedOnMobile: B,
              ref: s
            }, (0, v.createElement)(ToolbarEditButton, {
              onSelectMedia: F,
              mediaUrl: O,
              mediaId: V
            }), (_T2[R] || k.noop)(), q && (0, v.createElement)(E.Spinner, null), (0, v.createElement)(PlaceholderContainer, l));
          }

          return (0, v.createElement)(PlaceholderContainer, l);
        }));
        s.default = V;
      },
      6720: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _ref158, _ref159;

          var s = l.attributes;
          var c = s.isStackedOnMobile,
              m = s.mediaAlt,
              C = s.mediaPosition,
              S = s.mediaType,
              P = s.mediaUrl,
              T = s.mediaWidth,
              B = s.mediaId,
              z = s.verticalAlignment,
              L = s.imageFill,
              V = s.focalPoint,
              A = s.linkClass,
              R = s.href,
              O = s.linkTarget,
              D = s.rel,
              F = s.mediaSizeSlug || w.DEFAULT_MEDIA_SIZE_SLUG,
              G = (0, y.isEmpty)(D) ? void 0 : D,
              q = (0, _.default)((_ref158 = {}, _defineProperty(_ref158, "wp-image-".concat(B), B && "image" === S), _defineProperty(_ref158, "size-".concat(F), B && "image" === S), _ref158));
          var W = (0, v.createElement)("img", {
            src: P,
            alt: m,
            className: q || null
          });
          R && (W = (0, v.createElement)("a", {
            className: A,
            href: R,
            target: O,
            rel: G
          }, W));
          var U = {
            image: function image() {
              return W;
            },
            video: function video() {
              return (0, v.createElement)("video", {
                controls: !0,
                src: P
              });
            }
          },
              $ = (0, _.default)((_ref159 = {
            "has-media-on-the-right": "right" === C,
            "is-stacked-on-mobile": c
          }, _defineProperty(_ref159, "is-vertically-aligned-".concat(z), z), _defineProperty(_ref159, "is-image-fill", L), _ref159)),
              Z = L ? (0, E.imageFillStyles)(P, V) : {};
          var K;
          50 !== T && (K = "right" === C ? "auto ".concat(T, "%") : "".concat(T, "% auto"));
          var Q = {
            gridTemplateColumns: K
          };
          return (0, v.createElement)("div", k.useBlockProps.save({
            className: $,
            style: Q
          }), (0, v.createElement)("figure", {
            className: "wp-block-media-text__media",
            style: Z
          }, (U[S] || y.noop)()), (0, v.createElement)("div", k.useInnerBlocksProps.save({
            className: "wp-block-media-text__content"
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(6193),
            w = c(2965);
      },
      7219: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            blocks: ["core/image"],
            transform: function transform(l) {
              var s = l.alt,
                  c = l.url,
                  v = l.id,
                  _ = l.anchor;
              return (0, m.createBlock)("core/media-text", {
                mediaAlt: s,
                mediaId: v,
                mediaUrl: c,
                mediaType: "image",
                anchor: _
              });
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            transform: function transform(l) {
              var s = l.src,
                  c = l.id,
                  v = l.anchor;
              return (0, m.createBlock)("core/media-text", {
                mediaId: c,
                mediaUrl: s,
                mediaType: "video",
                anchor: v
              });
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/image"],
            isMatch: function isMatch(l) {
              var s = l.mediaType,
                  c = l.mediaUrl;
              return !c || "image" === s;
            },
            transform: function transform(l) {
              var s = l.mediaAlt,
                  c = l.mediaId,
                  v = l.mediaUrl,
                  _ = l.anchor;
              return (0, m.createBlock)("core/image", {
                alt: s,
                id: c,
                url: v,
                anchor: _
              });
            }
          }, {
            type: "block",
            blocks: ["core/video"],
            isMatch: function isMatch(l) {
              var s = l.mediaType,
                  c = l.mediaUrl;
              return !c || "video" === s;
            },
            transform: function transform(l) {
              var s = l.mediaId,
                  c = l.mediaUrl,
                  v = l.anchor;
              return (0, m.createBlock)("core/video", {
                id: s,
                src: c,
                anchor: v
              });
            }
          }]
        };
        s.default = v;
      },
      8234: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(6700),
            k = c(8467),
            E = c(1326),
            w = c(5480);

        var C = (0, k.withDispatch)(function (l, s) {
          var c = s.clientId,
              m = s.attributes;

          var _l43 = l(E.store),
              v = _l43.replaceBlock;

          return {
            convertToHTML: function convertToHTML() {
              v(c, (0, y.createBlock)("core/html", {
                content: m.originalUndelimitedContent
              }));
            }
          };
        })(function MissingBlockWarning(l) {
          var s = l.attributes,
              c = l.convertToHTML;
          var k = s.originalName,
              C = s.originalUndelimitedContent,
              S = !!C,
              P = (0, y.getBlockType)("core/html"),
              T = [];
          var B;
          return S && P ? (B = (0, v.sprintf)((0, v.__)('Your site doesn’t include support for the "%s" block. You can leave this block intact, convert its content to a Custom HTML block, or remove it entirely.'), k), T.push((0, m.createElement)(_.Button, {
            key: "convert",
            onClick: c,
            variant: "primary"
          }, (0, v.__)("Keep as HTML")))) : B = (0, v.sprintf)((0, v.__)('Your site doesn’t include support for the "%s" block. You can leave this block intact or remove it entirely.'), k), (0, m.createElement)("div", (0, E.useBlockProps)({
            className: "has-warning"
          }), (0, m.createElement)(E.Warning, {
            actions: T
          }, B), (0, m.createElement)(m.RawHTML, null, (0, w.safeHTML)(C)));
        });
        s.default = C;
      },
      9084: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6700),
            _ = m(c(8234)),
            y = m(c(5596));

        var k = {
          apiVersion: 2,
          name: "core/missing",
          title: "Unsupported",
          category: "text",
          description: "Your site doesn’t include support for this block.",
          textdomain: "default",
          attributes: {
            originalName: {
              type: "string"
            },
            originalUndelimitedContent: {
              type: "string"
            },
            originalContent: {
              type: "string",
              source: "html"
            }
          },
          supports: {
            className: !1,
            customClassName: !1,
            inserter: !1,
            html: !1,
            reusable: !1
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          name: E,
          __experimentalLabel: function __experimentalLabel(l, s) {
            var c = s.context;

            if ("accessibility" === c) {
              var _s13 = l.originalName,
                  _c7 = _s13 ? (0, v.getBlockType)(_s13) : void 0;

              return _c7 ? _c7.settings.title || _s13 : "";
            }
          },
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      5596: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          return (0, m.createElement)(m.RawHTML, null, s.originalContent);
        };
        var m = c(1753);
      },
      6930: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function MoreEdit(l) {
          var _l$attributes14 = l.attributes,
              s = _l$attributes14.customText,
              c = _l$attributes14.noTeaser,
              C = l.insertBlocksAfter,
              S = l.setAttributes;
          var P = {
            width: "".concat((s || w).length + 1.2, "em")
          };
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(y.InspectorControls, null, (0, m.createElement)(_.PanelBody, null, (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Hide the excerpt on the full content page"),
            checked: !!c,
            onChange: function onChange() {
              return S({
                noTeaser: !c
              });
            },
            help: function help(l) {
              return l ? (0, v.__)("The excerpt is hidden.") : (0, v.__)("The excerpt is visible.");
            }
          }))), (0, m.createElement)("div", (0, y.useBlockProps)(), (0, m.createElement)("div", {
            className: "wp-block-more"
          }, (0, m.createElement)("input", {
            "aria-label": (0, v.__)("Read more link text"),
            type: "text",
            value: s,
            placeholder: w,
            onChange: function onChange(l) {
              S({
                customText: "" !== l.target.value ? l.target.value : void 0
              });
            },
            onKeyDown: function onKeyDown(l) {
              var s = l.keyCode;
              s === k.ENTER && C([(0, E.createBlock)((0, E.getDefaultBlockName)())]);
            },
            style: P
          }))));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(1326),
            k = c(9880),
            E = c(6700);

        var w = (0, v.__)("Read more");
      },
      3683: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6930)),
            y = m(c(7431)),
            k = m(c(5814));

        var E = {
          apiVersion: 2,
          name: "core/more",
          title: "More",
          category: "design",
          description: "Content before this block will be shown in the excerpt on your archives page.",
          keywords: ["read more"],
          textdomain: "default",
          attributes: {
            customText: {
              type: "string"
            },
            noTeaser: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            customClassName: !1,
            className: !1,
            html: !1,
            multiple: !1
          },
          editorStyle: "wp-block-more-editor"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.more,
          example: {},
          __experimentalLabel: function __experimentalLabel(l, s) {
            var c = s.context;
            if ("accessibility" === c) return l.customText;
          },
          transforms: k.default,
          edit: _.default,
          save: y.default
        };
        s.settings = C;
      },
      7431: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _l$attributes15 = l.attributes,
              s = _l$attributes15.customText,
              c = _l$attributes15.noTeaser;

          var _ = s ? "<!--more ".concat(s, "-->") : "\x3c!--more--\x3e",
              y = c ? "\x3c!--noteaser--\x3e" : "";

          return (0, m.createElement)(m.RawHTML, null, (0, v.compact)([_, y]).join("\n"));
        };
        var m = c(1753),
            v = c(4793);
      },
      5814: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "raw",
            schema: {
              "wp-block": {
                attributes: ["data-block"]
              }
            },
            isMatch: function isMatch(l) {
              return l.dataset && "core/more" === l.dataset.block;
            },
            transform: function transform(l) {
              var _l$dataset = l.dataset,
                  s = _l$dataset.customText,
                  c = _l$dataset.noTeaser,
                  v = {};
              return s && (v.customText = s), "" === c && (v.noTeaser = !0), (0, m.createBlock)("core/more", v);
            }
          }]
        };
        s.default = v;
      },
      9709: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            y = m(c(3703)),
            k = c(1295),
            E = c(4892),
            w = c(1326),
            C = c(8467),
            S = m(c(609)),
            P = m(c(5256));

        var T = function NavigationAreaBlock(l) {
          var s = l.attributes,
              c = l.setAttributes;

          var m = s.area,
              _ref160 = (0, C.useSelect)(function (l) {
            var _l44 = l(k.store),
                s = _l44.getEntityRecords,
                c = _l44.hasFinishedResolution;

            return {
              navigationAreas: s("root", "navigationArea"),
              hasResolvedNavigationAreas: c("getEntityRecords", ["root", "navigationArea"])
            };
          }),
              T = _ref160.navigationAreas,
              B = _ref160.hasResolvedNavigationAreas,
              z = null != T && T.length ? T[m] : void 0,
              L = (0, v.useMemo)(function () {
            return null == T ? void 0 : T.map(function (l) {
              var s = l.name,
                  c = l.description;
              return {
                label: c,
                value: s
              };
            });
          }, [T]);

          return (0, y.default)("wp.blockLibrary.NavigationArea", {
            since: "5.9"
          }), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.BlockControls, null, (0, v.createElement)(E.ToolbarGroup, null, (0, v.createElement)(E.ToolbarDropdownMenu, {
            label: (0, _.__)("Select Area"),
            text: (0, _.__)("Select Area"),
            icon: null
          }, function (l) {
            var s = l.onClose;
            return (0, v.createElement)(E.MenuGroup, null, (0, v.createElement)(E.MenuItemsChoice, {
              value: m,
              onSelect: function onSelect(l) {
                c({
                  area: l
                }), s();
              },
              choices: L
            }));
          }))), (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, _.__)("Options")
          }, (0, v.createElement)(E.SelectControl, {
            label: (0, _._x)("Area"),
            value: m,
            onChange: function onChange(l) {
              return c({
                area: l
              });
            },
            options: L
          }))), !B && (0, v.createElement)(P.default, {
            isLoading: !0
          }), B && (0, v.createElement)(S.default, {
            navigationMenuId: z
          }));
        };

        s.default = T;
      },
      1564: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(9709)),
            y = m(c(7613));

        var k = {
          apiVersion: 2,
          name: "core/navigation-area",
          title: "Navigation Area",
          category: "theme",
          description: "Define a navigation area for your theme. The navigation block associated with this area will be automatically displayed.",
          keywords: ["menu", "navigation", "links", "location"],
          textdomain: "default",
          attributes: {
            area: {
              type: "string",
              default: "primary"
            }
          },
          providesContext: {
            navigationArea: "area"
          },
          supports: {
            html: !1,
            inserter: !0
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.symbolFilled,
          example: {
            attributes: {
              area: "primary"
            }
          },
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      609: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationAreaInnerBlocks(l) {
          var s = l.navigationMenuId;
          var c = (0, m.useMemo)(function () {
            return [["core/navigation", {
              navigationMenuId: s
            }]];
          }, [s]),
              y = (0, v.useBlockProps)(),
              k = (0, v.useInnerBlocksProps)(y, {
            orientation: "horizontal",
            renderAppender: !1,
            template: c,
            templateLock: "all",
            allowedBlocks: _
          });
          return (0, m.createElement)("div", k);
        };
        var m = c(1753),
            v = c(1326);
        var _ = ["core/navigation"];
      },
      7613: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      1443: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationLinkEdit(l) {
          var _ref168;

          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              y = l.insertBlocksAfter,
              A = l.mergeBlocks,
              R = l.onReplace,
              O = l.context,
              D = l.clientId;

          var F = s.label,
              G = s.type,
              q = s.opensInNewTab,
              W = s.url,
              U = s.description,
              $ = s.rel,
              Z = s.title,
              K = s.kind,
              Q = {
            url: W,
            opensInNewTab: q,
            title: F && navStripHTML(F)
          },
              _ref161 = (0, E.useDispatch)(L.store),
              Y = _ref161.saveEntityRecord,
              _ref162 = (0, E.useDispatch)(P.store),
              X = _ref162.replaceBlock,
              J = _ref162.__unstableMarkNextChangeAsNotPersistent,
              _ref163 = (0, v.useState)(!1),
              _ref164 = _slicedToArray2(_ref163, 2),
              ee = _ref164[0],
              te = _ref164[1],
              re = (0, v.useRef)(null),
              ae = function (l) {
            var _ref166 = (0, v.useState)(!1),
                _ref167 = _slicedToArray2(_ref166, 2),
                s = _ref167[0],
                c = _ref167[1];

            return (0, v.useEffect)(function () {
              var s = l.current.ownerDocument;

              function handleDragStart(l) {
                handleDragEnter(l);
              }

              function handleDragEnd() {
                c(!1);
              }

              function handleDragEnter(s) {
                l.current.contains(s.target) ? c(!0) : c(!1);
              }

              return s.addEventListener("dragstart", handleDragStart), s.addEventListener("dragend", handleDragEnd), s.addEventListener("dragenter", handleDragEnter), function () {
                s.removeEventListener("dragstart", handleDragStart), s.removeEventListener("dragend", handleDragEnd), s.removeEventListener("dragenter", handleDragEnter);
              };
            }, []), s;
          }(re),
              oe = (0, S.__)("Add link…"),
              ne = (0, v.useRef)(),
              _ref165 = (0, E.useSelect)(function (l) {
            var s;

            var _l45 = l(P.store),
                c = _l45.getBlock,
                m = _l45.getBlocks,
                v = _l45.getBlockName,
                _ = _l45.getBlockRootClientId,
                y = _l45.getClientIdsOfDescendants,
                k = _l45.hasSelectedInnerBlock,
                E = _l45.getSelectedBlockClientId,
                w = _l45.getBlockParentsByBlockName,
                C = _l45.getBlockTransformItems,
                S = E(),
                T = y([D]).length;

            return {
              innerBlocks: m(D),
              isAtMaxNesting: w(D, [V, "core/navigation-submenu"]).length >= 5,
              isTopLevelLink: "core/navigation" === v(_(D)),
              isParentOfSelectedBlock: k(D, !0),
              isImmediateParentOfSelectedBlock: k(D, !1),
              hasDescendants: !!T,
              selectedBlockHasDescendants: !(null === (s = y([S])) || void 0 === s || !s.length),
              userCanCreatePages: l(L.store).canUser("create", "pages"),
              userCanCreatePosts: l(L.store).canUser("create", "posts"),
              thisBlock: c(D),
              blockTransforms: C([c(D)], _(D))
            };
          }, [D]),
              le = _ref165.innerBlocks,
              ie = _ref165.isAtMaxNesting,
              se = _ref165.isTopLevelLink,
              ce = _ref165.isParentOfSelectedBlock,
              ue = _ref165.hasDescendants,
              de = _ref165.userCanCreatePages,
              me = _ref165.userCanCreatePosts,
              pe = _ref165.thisBlock,
              ge = _ref165.blockTransforms;

          function transformToSubmenu() {
            var l = (0, k.createBlock)("core/navigation-submenu", s, le);
            X(D, l);
          }

          (0, v.useEffect)(function () {
            J(), m({
              isTopLevelLink: se
            });
          }, [se]);
          var ve = ["core/site-logo", "core/social-links", "core/search"],
              he = ge.filter(function (l) {
            return ve.includes(l.name);
          });
          (0, v.useEffect)(function () {
            W || te(!0), ue && transformToSubmenu();
          }, []), (0, v.useEffect)(function () {
            c || te(!1);
          }, [c]), (0, v.useEffect)(function () {
            ee && W && ((0, T.isURL)((0, T.prependHTTP)(F)) && /^.+\.[a-z]+/.test(F) ? function selectLabelText() {
              ne.current.focus();
              var l = ne.current.ownerDocument,
                  s = l.defaultView,
                  c = s.getSelection(),
                  m = l.createRange();
              m.selectNodeContents(ne.current), c.removeAllRanges(), c.addRange(m);
            }() : (0, B.placeCaretAtHorizontalEdge)(ne.current, !0));
          }, [W]);
          var be = !1;
          G && "page" !== G ? "post" === G && (be = me) : be = de;

          var _getColors = function getColors(l, s) {
            var c, m;
            var v = l.textColor,
                _ = l.customTextColor,
                y = l.backgroundColor,
                k = l.customBackgroundColor,
                E = l.overlayTextColor,
                w = l.customOverlayTextColor,
                C = l.overlayBackgroundColor,
                S = l.customOverlayBackgroundColor,
                P = l.style,
                T = {};
            s && w ? T.customTextColor = w : s && E ? T.textColor = E : _ ? T.customTextColor = _ : v ? T.textColor = v : null != P && null !== (c = P.color) && void 0 !== c && c.text && (T.customTextColor = P.color.text);
            s && S ? T.customBackgroundColor = S : s && C ? T.backgroundColor = C : k ? T.customBackgroundColor = k : y ? T.backgroundColor = y : null != P && null !== (m = P.color) && void 0 !== m && m.background && (T.customTextColor = P.color.background);
            return T;
          }(O, !se),
              _e = _getColors.textColor,
              fe = _getColors.customTextColor,
              ye = _getColors.backgroundColor,
              ke = _getColors.customBackgroundColor;

          var Ee = (0, P.useBlockProps)({
            ref: re,
            className: (0, _.default)("wp-block-navigation-item", (_ref168 = {
              "is-editing": c || ce,
              "is-dragging-within": ae,
              "has-link": !!W,
              "has-child": ue,
              "has-text-color": !!_e || !!fe
            }, _defineProperty(_ref168, (0, P.getColorClassName)("color", _e), !!_e), _defineProperty(_ref168, "has-background", !!ye || ke), _defineProperty(_ref168, (0, P.getColorClassName)("background-color", ye), !!ye), _ref168)),
            style: {
              color: !_e && fe,
              backgroundColor: !ye && ke
            },
            onKeyDown: function onKeyDown(l) {
              (C.isKeyboardEvent.primary(l, "k") || !W && l.keyCode === C.ENTER) && te(!0);
            }
          });
          W || (Ee.onClick = function () {
            return te(!0);
          });
          var we = (0, _.default)("wp-block-navigation-item__content", {
            "wp-block-navigation-link__placeholder": !W
          });
          var Ce = "";

          switch (G) {
            case "post":
              Ce = (0, S.__)("Select post");
              break;

            case "page":
              Ce = (0, S.__)("Select page");
              break;

            case "category":
              Ce = (0, S.__)("Select category");
              break;

            case "tag":
              Ce = (0, S.__)("Select tag");
              break;

            default:
              Ce = (0, S.__)("Add link");
          }

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(P.BlockControls, null, (0, v.createElement)(w.ToolbarGroup, null, (0, v.createElement)(w.ToolbarButton, {
            name: "link",
            icon: z.link,
            title: (0, S.__)("Link"),
            shortcut: C.displayShortcut.primary("k"),
            onClick: function onClick() {
              return te(!0);
            }
          }), !ie && (0, v.createElement)(w.ToolbarButton, {
            name: "submenu",
            icon: z.addSubmenu,
            title: (0, S.__)("Add submenu"),
            onClick: transformToSubmenu
          }))), (0, v.createElement)(P.InspectorControls, null, (0, v.createElement)(w.PanelBody, {
            title: (0, S.__)("Link settings")
          }, (0, v.createElement)(w.TextareaControl, {
            value: U || "",
            onChange: function onChange(l) {
              m({
                description: l
              });
            },
            label: (0, S.__)("Description"),
            help: (0, S.__)("The description will be displayed in the menu if the current theme supports it.")
          }), (0, v.createElement)(w.TextControl, {
            value: Z || "",
            onChange: function onChange(l) {
              m({
                title: l
              });
            },
            label: (0, S.__)("Link title"),
            autoComplete: "off"
          }), (0, v.createElement)(w.TextControl, {
            value: $ || "",
            onChange: function onChange(l) {
              m({
                rel: l
              });
            },
            label: (0, S.__)("Link rel"),
            autoComplete: "off"
          }))), (0, v.createElement)("div", Ee, (0, v.createElement)("a", {
            className: we
          }, W ? (0, v.createElement)(P.RichText, {
            ref: ne,
            identifier: "label",
            className: "wp-block-navigation-item__label",
            value: F,
            onChange: function onChange(l) {
              return m({
                label: l
              });
            },
            onMerge: A,
            onReplace: R,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return y((0, k.createBlock)("core/navigation-link"));
            },
            "aria-label": (0, S.__)("Navigation link text"),
            placeholder: oe,
            withoutInteractiveFormatting: !0,
            allowedFormats: ["core/bold", "core/italic", "core/image", "core/strikethrough"],
            onClick: function onClick() {
              W || te(!0);
            }
          }) : (0, v.createElement)("div", {
            className: "wp-block-navigation-link__placeholder-text"
          }, (0, v.createElement)(w.Tooltip, {
            position: "top center",
            text: (0, S.__)("This item is missing a link")
          }, (0, v.createElement)("span", null, Ce))), ee && (0, v.createElement)(w.Popover, {
            position: "bottom center",
            onClose: function onClose() {
              return te(!1);
            },
            anchorRef: re.current
          }, (0, v.createElement)(P.__experimentalLinkControl, {
            hasTextControl: !0,
            className: "wp-block-navigation-link__inline-link-input",
            value: Q,
            showInitialSuggestions: !0,
            withCreateSuggestion: be,
            createSuggestion: function () {
              var _handleCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(l) {
                var s, c;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        s = G || "page";
                        _context.next = 3;
                        return Y("postType", s, {
                          title: l,
                          status: "draft"
                        });

                      case 3:
                        c = _context.sent;
                        return _context.abrupt("return", {
                          id: c.id,
                          type: s,
                          title: c.title.rendered,
                          url: c.link,
                          kind: "post-type"
                        });

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function handleCreate(_x) {
                return _handleCreate.apply(this, arguments);
              }

              return handleCreate;
            }(),
            createSuggestionButtonText: function createSuggestionButtonText(l) {
              var s;
              return s = "post" === G ? (0, S.__)("Create draft post: <mark>%s</mark>") : (0, S.__)("Create draft page: <mark>%s</mark>"), (0, v.createInterpolateElement)((0, S.sprintf)(s, l), {
                mark: (0, v.createElement)("mark", null)
              });
            },
            noDirectEntry: !!G,
            noURLSuggestion: !!G,
            suggestionsQuery: getSuggestionsQuery(G, K),
            onChange: function onChange(l) {
              return updateNavigationLinkBlockAttributes(l, m, s);
            },
            onRemove: function removeLink() {
              m({
                url: "",
                label: "",
                id: "",
                kind: "",
                type: ""
              }), te(!1);
            },
            renderControlBottom: W ? null : function () {
              return (0, v.createElement)(LinkControlTransforms, {
                block: pe,
                transforms: he,
                replace: X
              });
            }
          })))));
        }, s.updateNavigationLinkBlockAttributes = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(6700),
            E = c(8467),
            w = c(4892),
            C = c(9880),
            S = c(6756),
            P = c(1326),
            T = c(904),
            B = c(5480),
            z = c(5303),
            L = c(1295);

        var _apiVersion$name$titl7 = {
          apiVersion: 2,
          name: "core/navigation-link",
          title: "Custom Link",
          category: "design",
          parent: ["core/navigation"],
          description: "Add a page, link, or another item to your navigation.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            },
            type: {
              type: "string"
            },
            description: {
              type: "string"
            },
            rel: {
              type: "string"
            },
            id: {
              type: "number"
            },
            opensInNewTab: {
              type: "boolean",
              default: !1
            },
            url: {
              type: "string"
            },
            title: {
              type: "string"
            },
            kind: {
              type: "string"
            },
            isTopLevelLink: {
              type: "boolean"
            }
          },
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "overlayTextColor", "customOverlayTextColor", "overlayBackgroundColor", "customOverlayBackgroundColor", "fontSize", "customFontSize", "showSubmenuIcon", "style"],
          supports: {
            reusable: !1,
            html: !1,
            __experimentalSlashInserter: !0
          },
          editorStyle: "wp-block-navigation-link-editor",
          style: "wp-block-navigation-link"
        },
            V = _apiVersion$name$titl7.name;

        function getSuggestionsQuery(l, s) {
          switch (l) {
            case "post":
            case "page":
              return {
                type: "post",
                subtype: l
              };

            case "category":
              return {
                type: "term",
                subtype: "category"
              };

            case "tag":
              return {
                type: "term",
                subtype: "post_tag"
              };

            case "post_format":
              return {
                type: "post-format"
              };

            default:
              return "taxonomy" === s ? {
                type: "term",
                subtype: l
              } : "post-type" === s ? {
                type: "post",
                subtype: l
              } : {};
          }
        }

        var updateNavigationLinkBlockAttributes = function updateNavigationLinkBlockAttributes() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 ? arguments[1] : void 0,
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          var _c$label = c.label,
              m = _c$label === void 0 ? "" : _c$label,
              _c$kind = c.kind,
              v = _c$kind === void 0 ? "" : _c$kind,
              _c$type = c.type,
              _ = _c$type === void 0 ? "" : _c$type,
              _l$title = l.title,
              k = _l$title === void 0 ? "" : _l$title,
              _l$url2 = l.url,
              E = _l$url2 === void 0 ? "" : _l$url2,
              w = l.opensInNewTab,
              C = l.id,
              _l$kind = l.kind,
              S = _l$kind === void 0 ? v : _l$kind,
              _l$type2 = l.type,
              P = _l$type2 === void 0 ? _ : _l$type2,
              B = k.replace(/http(s?):\/\//gi, ""),
              z = E.replace(/http(s?):\/\//gi, ""),
              L = "" !== k && B !== z && m !== k,
              V = L ? (0, y.escape)(k) : m || (0, y.escape)(z),
              A = "post_tag" === P ? "tag" : P.replace("-", "_"),
              R = ["post", "page", "tag", "category"].indexOf(A) > -1,
              O = !S && !R || "custom" === S,
              D = O ? "custom" : S;

          s(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, E && {
            url: encodeURI((0, T.safeDecodeURI)(E))
          }), V && {
            label: V
          }), void 0 !== w && {
            opensInNewTab: w
          }), C && Number.isInteger(C) && {
            id: C
          }), D && {
            kind: D
          }), A && "URL" !== A && {
            type: A
          }));
        };

        function navStripHTML(l) {
          var s = document.implementation.createHTMLDocument("");
          return s.body.innerHTML = l, s.body.textContent || "";
        }

        function LinkControlTransforms(l) {
          var s = l.block,
              c = l.transforms,
              m = l.replace;
          return (0, v.createElement)("div", {
            className: "link-control-transform"
          }, (0, v.createElement)("h3", {
            className: "link-control-transform__subheading"
          }, (0, S.__)("Transform")), (0, v.createElement)("div", {
            className: "link-control-transform__items"
          }, c.map(function (l, c) {
            return (0, v.createElement)(w.Button, {
              key: "transform-".concat(c),
              onClick: function onClick() {
                return m(s.clientId, (0, k.switchToBlockType)(s, l.name));
              },
              className: "link-control-transform__item"
            }, (0, v.createElement)(P.BlockIcon, {
              icon: l.icon
            }), l.title);
          })));
        }

        s.updateNavigationLinkBlockAttributes = updateNavigationLinkBlockAttributes;
      },
      6554: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756),
            v = c(5303);
        var _ = [{
          name: "link",
          isDefault: !0,
          title: (0, m.__)("Custom Link"),
          description: (0, m.__)("A link to a custom URL."),
          attributes: {}
        }, {
          name: "post",
          icon: v.postTitle,
          title: (0, m.__)("Post Link"),
          description: (0, m.__)("A link to a post."),
          attributes: {
            type: "post",
            kind: "post-type"
          }
        }, {
          name: "page",
          icon: v.page,
          title: (0, m.__)("Page Link"),
          description: (0, m.__)("A link to a page."),
          attributes: {
            type: "page",
            kind: "post-type"
          }
        }, {
          name: "category",
          icon: v.category,
          title: (0, m.__)("Category Link"),
          description: (0, m.__)("A link to a category."),
          attributes: {
            type: "category",
            kind: "taxonomy"
          }
        }, {
          name: "tag",
          icon: v.tag,
          title: (0, m.__)("Tag Link"),
          description: (0, m.__)("A link to a tag."),
          attributes: {
            type: "tag",
            kind: "taxonomy"
          }
        }];

        _.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            return l.type === s.type;
          });
        });

        var y = _;
        s.default = y;
      },
      2022: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.enhanceNavigationLinkVariations = function enhanceNavigationLinkVariations(l, s) {
          if ("core/navigation-link" !== s) return l;
          if (!l.variations) return _objectSpread(_objectSpread({}, l), {}, {
            variations: _.default
          });

          if (l.variations) {
            var isActive = function isActive(l, s) {
              return l.type === s.type;
            },
                _s14 = l.variations.map(function (l) {
              return _objectSpread(_objectSpread(_objectSpread({}, l), !l.icon && {
                icon: getIcon(l.name)
              }), !l.isActive && {
                isActive: isActive
              });
            });

            return _objectSpread(_objectSpread({}, l), {}, {
              variations: _s14
            });
          }

          return l;
        };

        var v = c(5303),
            _ = m(c(6554));

        function getIcon(l) {
          switch (l) {
            case "post":
              return v.postTitle;

            case "page":
              return v.page;

            case "tag":
              return v.tag;

            case "category":
              return v.category;

            default:
              return v.customPostType;
          }
        }
      },
      3033: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ItemSubmenuIcon = void 0;
        var m = c(1753),
            v = c(4892);

        s.ItemSubmenuIcon = function () {
          return (0, m.createElement)(v.SVG, {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none"
          }, (0, m.createElement)(v.Path, {
            d: "M1.50002 4L6.00002 8L10.5 4",
            strokeWidth: "1.5"
          }));
        };
      },
      7739: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(1753),
            _ = c(6756),
            y = c(5303),
            k = c(1326),
            E = c(1149),
            w = m(c(1443)),
            C = m(c(9755)),
            S = c(2022),
            P = m(c(1697));

        var T = {
          apiVersion: 2,
          name: "core/navigation-link",
          title: "Custom Link",
          category: "design",
          parent: ["core/navigation"],
          description: "Add a page, link, or another item to your navigation.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            },
            type: {
              type: "string"
            },
            description: {
              type: "string"
            },
            rel: {
              type: "string"
            },
            id: {
              type: "number"
            },
            opensInNewTab: {
              type: "boolean",
              default: !1
            },
            url: {
              type: "string"
            },
            title: {
              type: "string"
            },
            kind: {
              type: "string"
            },
            isTopLevelLink: {
              type: "boolean"
            }
          },
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "overlayTextColor", "customOverlayTextColor", "overlayBackgroundColor", "customOverlayBackgroundColor", "fontSize", "customFontSize", "showSubmenuIcon", "style"],
          supports: {
            reusable: !1,
            html: !1,
            __experimentalSlashInserter: !0
          },
          editorStyle: "wp-block-navigation-link-editor",
          style: "wp-block-navigation-link"
        };
        s.metadata = T;
        var B = T.name;
        s.name = B;
        var z = {
          icon: y.customLink,
          __experimentalLabel: function __experimentalLabel(l) {
            var s = l.label;
            return s;
          },
          merge: function merge(l, s) {
            var _s$label = s.label,
                c = _s$label === void 0 ? "" : _s$label;
            return _objectSpread(_objectSpread({}, l), {}, {
              label: l.label + c
            });
          },
          edit: w.default,
          save: C.default,
          example: {
            attributes: {
              label: (0, _._x)("Example Link", "navigation link preview example"),
              url: "https://example.com"
            }
          },
          deprecated: [{
            isEligible: function isEligible(l) {
              return l.nofollow;
            },
            attributes: {
              label: {
                type: "string"
              },
              type: {
                type: "string"
              },
              nofollow: {
                type: "boolean"
              },
              description: {
                type: "string"
              },
              id: {
                type: "number"
              },
              opensInNewTab: {
                type: "boolean",
                default: !1
              },
              url: {
                type: "string"
              }
            },
            migrate: function migrate(l) {
              var s = l.nofollow,
                  c = _objectWithoutProperties(l, _excluded10);

              return _objectSpread({
                rel: s ? "nofollow" : ""
              }, c);
            },
            save: function save() {
              return (0, v.createElement)(k.InnerBlocks.Content, null);
            }
          }],
          transforms: P.default
        };
        s.settings = z, (0, E.addFilter)("blocks.registerBlockType", "core/navigation-link", S.enhanceNavigationLinkVariations);
      },
      9755: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      1697: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            blocks: ["core/site-logo"],
            transform: function transform() {
              return (0, m.createBlock)("core/navigation-link");
            }
          }, {
            type: "block",
            blocks: ["core/spacer"],
            transform: function transform() {
              return (0, m.createBlock)("core/navigation-link");
            }
          }, {
            type: "block",
            blocks: ["core/home-link"],
            transform: function transform() {
              return (0, m.createBlock)("core/navigation-link");
            }
          }, {
            type: "block",
            blocks: ["core/social-links"],
            transform: function transform() {
              return (0, m.createBlock)("core/navigation-link");
            }
          }, {
            type: "block",
            blocks: ["core/search"],
            transform: function transform() {
              return (0, m.createBlock)("core/navigation-link");
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/navigation-submenu"],
            transform: function transform(l, s) {
              return (0, m.createBlock)("core/navigation-submenu", l, s);
            }
          }, {
            type: "block",
            blocks: ["core/spacer"],
            transform: function transform() {
              return (0, m.createBlock)("core/spacer");
            }
          }, {
            type: "block",
            blocks: ["core/site-logo"],
            transform: function transform() {
              return (0, m.createBlock)("core/site-logo");
            }
          }, {
            type: "block",
            blocks: ["core/home-link"],
            transform: function transform() {
              return (0, m.createBlock)("core/home-link");
            }
          }, {
            type: "block",
            blocks: ["core/social-links"],
            transform: function transform() {
              return (0, m.createBlock)("core/social-links");
            }
          }, {
            type: "block",
            blocks: ["core/search"],
            transform: function transform() {
              return (0, m.createBlock)("core/search", {
                showLabel: !1,
                buttonUseIcon: !0,
                buttonPosition: "button-inside"
              });
            }
          }]
        };
        s.default = v;
      },
      2113: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationSubmenuEdit(l) {
          var _ref176, _ref177;

          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              D = l.mergeBlocks,
              F = l.onReplace,
              G = l.context,
              q = l.clientId;

          var W = s.label,
              U = s.type,
              $ = s.opensInNewTab,
              Z = s.url,
              K = s.description,
              Q = s.rel,
              Y = s.title,
              X = s.kind,
              J = {
            url: Z,
            opensInNewTab: $
          },
              ee = G.showSubmenuIcon,
              te = G.openSubmenusOnClick,
              _ref169 = (0, k.useDispatch)(z.store),
              re = _ref169.saveEntityRecord,
              _ref170 = (0, k.useDispatch)(S.store),
              ae = _ref170.__unstableMarkNextChangeAsNotPersistent,
              _ref171 = (0, v.useState)(!1),
              _ref172 = _slicedToArray2(_ref171, 2),
              oe = _ref172[0],
              ne = _ref172[1],
              le = (0, v.useRef)(null),
              ie = function (l) {
            var _ref174 = (0, v.useState)(!1),
                _ref175 = _slicedToArray2(_ref174, 2),
                s = _ref175[0],
                c = _ref175[1];

            return (0, v.useEffect)(function () {
              var s = l.current.ownerDocument;

              function handleDragStart(l) {
                handleDragEnter(l);
              }

              function handleDragEnd() {
                c(!1);
              }

              function handleDragEnter(s) {
                l.current.contains(s.target) ? c(!0) : c(!1);
              }

              return s.addEventListener("dragstart", handleDragStart), s.addEventListener("dragend", handleDragEnd), s.addEventListener("dragenter", handleDragEnter), function () {
                s.removeEventListener("dragstart", handleDragStart), s.removeEventListener("dragend", handleDragEnd), s.removeEventListener("dragenter", handleDragEnter);
              };
            }, []), s;
          }(le),
              se = (0, C.__)("Add text…"),
              ce = (0, v.useRef)(),
              _ref173 = (0, k.useSelect)(function (l) {
            var s;

            var _l46 = l(S.store),
                c = _l46.getClientIdsOfDescendants,
                m = _l46.hasSelectedInnerBlock,
                v = _l46.getSelectedBlockClientId,
                _ = _l46.getBlockParentsByBlockName,
                y = v(),
                k = c([q]).length;

            return {
              isAtMaxNesting: _(q, A).length >= 5,
              isTopLevelItem: 0 === _(q, A).length,
              isParentOfSelectedBlock: m(q, !0),
              isImmediateParentOfSelectedBlock: m(q, !1),
              hasDescendants: !!k,
              selectedBlockHasDescendants: !(null === (s = c([y])) || void 0 === s || !s.length),
              userCanCreatePages: l(z.store).canUser("create", "pages"),
              userCanCreatePosts: l(z.store).canUser("create", "posts")
            };
          }, [q]),
              ue = _ref173.isAtMaxNesting,
              de = _ref173.isTopLevelItem,
              me = _ref173.isParentOfSelectedBlock,
              pe = _ref173.isImmediateParentOfSelectedBlock,
              ge = _ref173.hasDescendants,
              ve = _ref173.selectedBlockHasDescendants,
              he = _ref173.userCanCreatePages,
              be = _ref173.userCanCreatePosts;

          (0, v.useEffect)(function () {
            te || Z || ne(!0);
          }, []), (0, v.useEffect)(function () {
            ae(), m({
              isTopLevelItem: de
            });
          }, [de]), (0, v.useEffect)(function () {
            c || ne(!1);
          }, [c]), (0, v.useEffect)(function () {
            oe && Z && ((0, P.isURL)((0, P.prependHTTP)(W)) && /^.+\.[a-z]+/.test(W) ? function selectLabelText() {
              ce.current.focus();
              var l = ce.current.ownerDocument,
                  s = l.defaultView,
                  c = s.getSelection(),
                  m = l.createRange();
              m.selectNodeContents(ce.current), c.removeAllRanges(), c.addRange(m);
            }() : (0, T.placeCaretAtHorizontalEdge)(ce.current, !0));
          }, [Z]);

          var _e = !1;

          U && "page" !== U ? "post" === U && (_e = be) : _e = he;

          var _getColors2 = getColors(G, !de),
              fe = _getColors2.textColor,
              ye = _getColors2.customTextColor,
              ke = _getColors2.backgroundColor,
              Ee = _getColors2.customBackgroundColor;

          var we = (0, S.useBlockProps)({
            ref: le,
            className: (0, _.default)("wp-block-navigation-item", (_ref176 = {
              "is-editing": c || me,
              "is-dragging-within": ie,
              "has-link": !!Z,
              "has-child": ge,
              "has-text-color": !!fe || !!ye
            }, _defineProperty(_ref176, (0, S.getColorClassName)("color", fe), !!fe), _defineProperty(_ref176, "has-background", !!ke || Ee), _defineProperty(_ref176, (0, S.getColorClassName)("background-color", ke), !!ke), _defineProperty(_ref176, "open-on-click", te), _ref176)),
            style: {
              color: !fe && ye,
              backgroundColor: !ke && Ee
            },
            onKeyDown: function onKeyDown(l) {
              w.isKeyboardEvent.primary(l, "k") && ne(!0);
            }
          }),
              Ce = getColors(G, !0);
          ue && (0, y.pull)(R, "core/navigation-submenu");
          var xe = (0, S.useInnerBlocksProps)({
            className: (0, _.default)("wp-block-navigation__submenu-container", (_ref177 = {
              "is-parent-of-selected-block": me,
              "has-text-color": !(!Ce.textColor && !Ce.customTextColor)
            }, _defineProperty(_ref177, "has-".concat(Ce.textColor, "-color"), !!Ce.textColor), _defineProperty(_ref177, "has-background", !(!Ce.backgroundColor && !Ce.customBackgroundColor)), _defineProperty(_ref177, "has-".concat(Ce.backgroundColor, "-background-color"), !!Ce.backgroundColor), _ref177)),
            style: {
              color: Ce.customTextColor,
              backgroundColor: Ce.customBackgroundColor
            }
          }, {
            allowedBlocks: R,
            __experimentalDefaultBlock: O,
            __experimentalDirectInsert: !0,
            __experimentalCaptureToolbars: !0,
            renderAppender: !!(c || pe && !ve || ge) && S.InnerBlocks.ButtonBlockAppender
          }),
              Se = te ? "button" : "a";
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(S.BlockControls, null, (0, v.createElement)(E.ToolbarGroup, null, !te && (0, v.createElement)(E.ToolbarButton, {
            name: "link",
            icon: B.link,
            title: (0, C.__)("Link"),
            shortcut: w.displayShortcut.primary("k"),
            onClick: function onClick() {
              return ne(!0);
            }
          }))), (0, v.createElement)(S.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, C.__)("Link settings")
          }, (0, v.createElement)(E.TextareaControl, {
            value: K || "",
            onChange: function onChange(l) {
              m({
                description: l
              });
            },
            label: (0, C.__)("Description"),
            help: (0, C.__)("The description will be displayed in the menu if the current theme supports it.")
          }), (0, v.createElement)(E.TextControl, {
            value: Y || "",
            onChange: function onChange(l) {
              m({
                title: l
              });
            },
            label: (0, C.__)("Link title"),
            autoComplete: "off"
          }), (0, v.createElement)(E.TextControl, {
            value: Q || "",
            onChange: function onChange(l) {
              m({
                rel: l
              });
            },
            label: (0, C.__)("Link rel"),
            autoComplete: "off"
          }))), (0, v.createElement)("div", we, (0, v.createElement)(Se, {
            className: "wp-block-navigation-item__content"
          }, (0, v.createElement)(S.RichText, {
            ref: ce,
            identifier: "label",
            className: "wp-block-navigation-item__label",
            value: W,
            onChange: function onChange(l) {
              return m({
                label: l
              });
            },
            onMerge: D,
            onReplace: F,
            "aria-label": (0, C.__)("Navigation link text"),
            placeholder: se,
            withoutInteractiveFormatting: !0,
            allowedFormats: ["core/bold", "core/italic", "core/image", "core/strikethrough"],
            onClick: function onClick() {
              te || Z || ne(!0);
            }
          }), !te && oe && (0, v.createElement)(E.Popover, {
            position: "bottom center",
            onClose: function onClose() {
              return ne(!1);
            },
            anchorRef: le.current
          }, (0, v.createElement)(S.__experimentalLinkControl, {
            className: "wp-block-navigation-link__inline-link-input",
            value: J,
            showInitialSuggestions: !0,
            withCreateSuggestion: _e,
            createSuggestion: function () {
              var _handleCreate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(l) {
                var s, c;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        s = U || "page";
                        _context2.next = 3;
                        return re("postType", s, {
                          title: l,
                          status: "draft"
                        });

                      case 3:
                        c = _context2.sent;
                        return _context2.abrupt("return", {
                          id: c.id,
                          type: s,
                          title: c.title.rendered,
                          url: c.link,
                          kind: "post-type"
                        });

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              function handleCreate(_x2) {
                return _handleCreate2.apply(this, arguments);
              }

              return handleCreate;
            }(),
            createSuggestionButtonText: function createSuggestionButtonText(l) {
              var s;
              return s = "post" === U ? (0, C.__)("Create draft post: <mark>%s</mark>") : (0, C.__)("Create draft page: <mark>%s</mark>"), (0, v.createInterpolateElement)((0, C.sprintf)(s, l), {
                mark: (0, v.createElement)("mark", null)
              });
            },
            noDirectEntry: !!U,
            noURLSuggestion: !!U,
            suggestionsQuery: getSuggestionsQuery(U, X),
            onChange: function onChange(l) {
              return updateNavigationLinkBlockAttributes(l, m, s);
            },
            onRemove: function onRemove() {
              m({
                url: ""
              }), (0, L.speak)((0, C.__)("Link removed."), "assertive");
            }
          })), (ee || te) && (0, v.createElement)("span", {
            className: "wp-block-navigation__submenu-icon"
          }, (0, v.createElement)(V.ItemSubmenuIcon, null))), (0, v.createElement)("div", xe)));
        }, s.updateNavigationLinkBlockAttributes = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(8467),
            E = c(4892),
            w = c(9880),
            C = c(6756),
            S = c(1326),
            P = c(904),
            T = c(5480),
            B = c(5303),
            z = c(1295),
            L = c(9773),
            V = c(8111);

        var _apiVersion$name$titl8 = {
          apiVersion: 2,
          name: "core/navigation-submenu",
          title: "Submenu",
          category: "design",
          parent: ["core/navigation"],
          description: "Add a submenu to your navigation.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            },
            type: {
              type: "string"
            },
            description: {
              type: "string"
            },
            rel: {
              type: "string"
            },
            id: {
              type: "number"
            },
            opensInNewTab: {
              type: "boolean",
              default: !1
            },
            url: {
              type: "string"
            },
            title: {
              type: "string"
            },
            kind: {
              type: "string"
            },
            isTopLevelItem: {
              type: "boolean"
            }
          },
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "overlayTextColor", "customOverlayTextColor", "overlayBackgroundColor", "customOverlayBackgroundColor", "fontSize", "customFontSize", "showSubmenuIcon", "openSubmenusOnClick", "style"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "wp-block-navigation-submenu-editor",
          style: "wp-block-navigation-submenu"
        },
            A = _apiVersion$name$titl8.name,
            R = ["core/navigation-link", "core/navigation-submenu"],
            O = ["core/navigation-link"];

        function getSuggestionsQuery(l, s) {
          switch (l) {
            case "post":
            case "page":
              return {
                type: "post",
                subtype: l
              };

            case "category":
              return {
                type: "term",
                subtype: "category"
              };

            case "tag":
              return {
                type: "term",
                subtype: "post_tag"
              };

            case "post_format":
              return {
                type: "post-format"
              };

            default:
              return "taxonomy" === s ? {
                type: "term",
                subtype: l
              } : "post-type" === s ? {
                type: "post",
                subtype: l
              } : {};
          }
        }

        function getColors(l, s) {
          var c, m;
          var v = l.textColor,
              _ = l.customTextColor,
              y = l.backgroundColor,
              k = l.customBackgroundColor,
              E = l.overlayTextColor,
              w = l.customOverlayTextColor,
              C = l.overlayBackgroundColor,
              S = l.customOverlayBackgroundColor,
              P = l.style,
              T = {};
          return s && w ? T.customTextColor = w : s && E ? T.textColor = E : _ ? T.customTextColor = _ : v ? T.textColor = v : null != P && null !== (c = P.color) && void 0 !== c && c.text && (T.customTextColor = P.color.text), s && S ? T.customBackgroundColor = S : s && C ? T.backgroundColor = C : k ? T.customBackgroundColor = k : y ? T.backgroundColor = y : null != P && null !== (m = P.color) && void 0 !== m && m.background && (T.customTextColor = P.color.background), T;
        }

        var updateNavigationLinkBlockAttributes = function updateNavigationLinkBlockAttributes() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 ? arguments[1] : void 0,
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          var _c$label2 = c.label,
              m = _c$label2 === void 0 ? "" : _c$label2,
              _c$kind2 = c.kind,
              v = _c$kind2 === void 0 ? "" : _c$kind2,
              _c$type2 = c.type,
              _ = _c$type2 === void 0 ? "" : _c$type2,
              _l$title2 = l.title,
              k = _l$title2 === void 0 ? "" : _l$title2,
              _l$url3 = l.url,
              E = _l$url3 === void 0 ? "" : _l$url3,
              w = l.opensInNewTab,
              C = l.id,
              _l$kind2 = l.kind,
              S = _l$kind2 === void 0 ? v : _l$kind2,
              _l$type3 = l.type,
              T = _l$type3 === void 0 ? _ : _l$type3,
              B = k.replace(/http(s?):\/\//gi, ""),
              z = E.replace(/http(s?):\/\//gi, ""),
              L = "" !== k && B !== z && m !== k,
              V = L ? (0, y.escape)(k) : m || (0, y.escape)(z),
              A = "post_tag" === T ? "tag" : T.replace("-", "_"),
              R = ["post", "page", "tag", "category"].indexOf(A) > -1,
              O = !S && !R || "custom" === S,
              D = O ? "custom" : S;

          s(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, E && {
            url: encodeURI((0, P.safeDecodeURI)(E))
          }), V && {
            label: V
          }), void 0 !== w && {
            opensInNewTab: w
          }), C && Number.isInteger(C) && {
            id: C
          }), D && {
            kind: D
          }), A && "URL" !== A && {
            type: A
          }));
        };

        s.updateNavigationLinkBlockAttributes = updateNavigationLinkBlockAttributes;
      },
      8111: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ItemSubmenuIcon = void 0;
        var m = c(1753),
            v = c(4892);

        s.ItemSubmenuIcon = function () {
          return (0, m.createElement)(v.SVG, {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none"
          }, (0, m.createElement)(v.Path, {
            d: "M1.50002 4L6.00002 8L10.5 4",
            strokeWidth: "1.5"
          }));
        };
      },
      4357: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(2113)),
            y = m(c(9978)),
            k = m(c(5858));

        var E = {
          apiVersion: 2,
          name: "core/navigation-submenu",
          title: "Submenu",
          category: "design",
          parent: ["core/navigation"],
          description: "Add a submenu to your navigation.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            },
            type: {
              type: "string"
            },
            description: {
              type: "string"
            },
            rel: {
              type: "string"
            },
            id: {
              type: "number"
            },
            opensInNewTab: {
              type: "boolean",
              default: !1
            },
            url: {
              type: "string"
            },
            title: {
              type: "string"
            },
            kind: {
              type: "string"
            },
            isTopLevelItem: {
              type: "boolean"
            }
          },
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "overlayTextColor", "customOverlayTextColor", "overlayBackgroundColor", "customOverlayBackgroundColor", "fontSize", "customFontSize", "showSubmenuIcon", "openSubmenusOnClick", "style"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "wp-block-navigation-submenu-editor",
          style: "wp-block-navigation-submenu"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.addSubmenu,
          __experimentalLabel: function __experimentalLabel(l) {
            var s = l.label;
            return s;
          },
          edit: _.default,
          save: y.default,
          transforms: k.default
        };
        s.settings = C;
      },
      9978: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      5858: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          to: [{
            type: "block",
            blocks: ["core/navigation-link"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform(l) {
              return (0, m.createBlock)("core/navigation-link", l);
            }
          }, {
            type: "block",
            blocks: ["core/spacer"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform() {
              return (0, m.createBlock)("core/spacer");
            }
          }, {
            type: "block",
            blocks: ["core/site-logo"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform() {
              return (0, m.createBlock)("core/site-logo");
            }
          }, {
            type: "block",
            blocks: ["core/home-link"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform() {
              return (0, m.createBlock)("core/home-link");
            }
          }, {
            type: "block",
            blocks: ["core/social-links"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform() {
              return (0, m.createBlock)("core/social-links");
            }
          }, {
            type: "block",
            blocks: ["core/search"],
            isMatch: function isMatch(l, s) {
              var c;
              return 0 === (null == s || null === (c = s.innerBlocks) || void 0 === c ? void 0 : c.length);
            },
            transform: function transform() {
              return (0, m.createBlock)("core/search");
            }
          }]
        };
        s.default = v;
      },
      1617: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = c(1326),
            k = c(3200),
            E = m(c(5935));

        var w = {
          fontStyle: "var:preset|font-style|",
          fontWeight: "var:preset|font-weight|",
          textDecoration: "var:preset|text-decoration|",
          textTransform: "var:preset|text-transform|"
        },
            migrateIdToRef = function migrateIdToRef(l) {
          var s = l.navigationMenuId,
              c = _objectWithoutProperties(l, _excluded11);

          return _objectSpread(_objectSpread({}, c), {}, {
            ref: s
          });
        },
            migrateWithLayout = function migrateWithLayout(l) {
          if (l.layout) return l;

          var s = l.itemsJustification,
              c = l.orientation,
              m = _objectWithoutProperties(l, _excluded12);

          return (s || c) && Object.assign(m, {
            layout: _objectSpread(_objectSpread({
              type: "flex"
            }, s && {
              justifyContent: s
            }), c && {
              orientation: c
            })
          }), m;
        };

        var C = [{
          attributes: {
            navigationMenuId: {
              type: "number"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            },
            openSubmenusOnClick: {
              type: "boolean",
              default: !1
            },
            overlayMenu: {
              type: "string",
              default: "mobile"
            },
            __unstableLocation: {
              type: "string"
            },
            overlayBackgroundColor: {
              type: "string"
            },
            customOverlayBackgroundColor: {
              type: "string"
            },
            overlayTextColor: {
              type: "string"
            },
            customOverlayTextColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalTextTransform: !0,
              __experimentalFontFamily: !0,
              __experimentalTextDecoration: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            spacing: {
              blockGap: !0,
              units: ["px", "em", "rem", "vh", "vw"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            },
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            }
          },
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          },
          isEligible: function isEligible(l) {
            var s = l.navigationMenuId;
            return !!s;
          },
          migrate: migrateIdToRef
        }, {
          attributes: {
            navigationMenuId: {
              type: "number"
            },
            orientation: {
              type: "string",
              default: "horizontal"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            itemsJustification: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            },
            openSubmenusOnClick: {
              type: "boolean",
              default: !1
            },
            overlayMenu: {
              type: "string",
              default: "never"
            },
            __unstableLocation: {
              type: "string"
            },
            overlayBackgroundColor: {
              type: "string"
            },
            customOverlayBackgroundColor: {
              type: "string"
            },
            overlayTextColor: {
              type: "string"
            },
            customOverlayTextColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalTextTransform: !0,
              __experimentalFontFamily: !0,
              __experimentalTextDecoration: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            spacing: {
              blockGap: !0,
              units: ["px", "em", "rem", "vh", "vw"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            }
          },
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          },
          isEligible: function isEligible(l) {
            var s = l.itemsJustification,
                c = l.orientation;
            return !!s || !!c;
          },
          migrate: (0, k.compose)(migrateIdToRef, migrateWithLayout)
        }, {
          attributes: {
            orientation: {
              type: "string",
              default: "horizontal"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            itemsJustification: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            },
            openSubmenusOnClick: {
              type: "boolean",
              default: !1
            },
            overlayMenu: {
              type: "string",
              default: "never"
            },
            __unstableLocation: {
              type: "string"
            },
            overlayBackgroundColor: {
              type: "string"
            },
            customOverlayBackgroundColor: {
              type: "string"
            },
            overlayTextColor: {
              type: "string"
            },
            customOverlayTextColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalTextTransform: !0,
              __experimentalFontFamily: !0,
              __experimentalTextDecoration: !0
            },
            spacing: {
              blockGap: !0,
              units: ["px", "em", "rem", "vh", "vw"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            }
          },
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          },
          migrate: (0, k.compose)(migrateIdToRef, migrateWithLayout, E.default),
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }, {
          attributes: {
            orientation: {
              type: "string",
              default: "horizontal"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            itemsJustification: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            },
            openSubmenusOnClick: {
              type: "boolean",
              default: !1
            },
            isResponsive: {
              type: "boolean",
              default: "false"
            },
            __unstableLocation: {
              type: "string"
            },
            overlayBackgroundColor: {
              type: "string"
            },
            customOverlayBackgroundColor: {
              type: "string"
            },
            overlayTextColor: {
              type: "string"
            },
            customOverlayTextColor: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalTextTransform: !0,
              __experimentalFontFamily: !0,
              __experimentalTextDecoration: !0
            }
          },
          isEligible: function isEligible(l) {
            return l.isResponsive;
          },
          migrate: (0, k.compose)(migrateIdToRef, migrateWithLayout, E.default, function (l) {
            return delete l.isResponsive, _objectSpread(_objectSpread({}, l), {}, {
              overlayMenu: "mobile"
            });
          }),
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          }
        }, {
          attributes: {
            orientation: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            itemsJustification: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            }
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            fontSize: !0,
            __experimentalFontStyle: !0,
            __experimentalFontWeight: !0,
            __experimentalTextTransform: !0,
            color: !0,
            __experimentalFontFamily: !0,
            __experimentalTextDecoration: !0
          },
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          },
          isEligible: function isEligible(l) {
            if (!l.style || !l.style.typography) return !1;

            for (var _s15 in w) {
              var _c8 = l.style.typography[_s15];
              if (_c8 && _c8.startsWith(w[_s15])) return !0;
            }

            return !1;
          },
          migrate: (0, k.compose)(migrateIdToRef, migrateWithLayout, E.default, function (l) {
            return _objectSpread(_objectSpread({}, l), {}, {
              style: _objectSpread(_objectSpread({}, l.style), {}, {
                typography: (0, _.mapValues)(l.style.typography, function (l, s) {
                  var c = w[s];

                  if (c && l.startsWith(c)) {
                    var _m6 = l.slice(c.length);

                    return "textDecoration" === s && "strikethrough" === _m6 ? "line-through" : _m6;
                  }

                  return l;
                })
              })
            });
          })
        }, {
          attributes: {
            className: {
              type: "string"
            },
            textColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            fontSize: {
              type: "string"
            },
            customFontSize: {
              type: "number"
            },
            itemsJustification: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean"
            }
          },
          isEligible: function isEligible(l) {
            return l.rgbTextColor || l.rgbBackgroundColor;
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0
          },
          migrate: (0, k.compose)(migrateIdToRef, function (l) {
            return _objectSpread(_objectSpread({}, (0, _.omit)(l, ["rgbTextColor", "rgbBackgroundColor"])), {}, {
              customTextColor: l.textColor ? void 0 : l.rgbTextColor,
              customBackgroundColor: l.backgroundColor ? void 0 : l.rgbBackgroundColor
            });
          }),
          save: function save() {
            return (0, v.createElement)(y.InnerBlocks.Content, null);
          }
        }];
        s.default = C;
      },
      5636: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(1295),
            w = c(8467),
            C = c(4892),
            S = c(6756),
            P = m(c(4585)),
            T = m(c(430)),
            B = m(c(6491)),
            z = m(c(1974)),
            L = m(c(5256)),
            V = m(c(7721)),
            A = m(c(3225)),
            R = m(c(9120)),
            O = m(c(3480)),
            D = m(c(7844)),
            F = m(c(1213)),
            G = m(c(4739));

        var q = [];

        function getComputedStyle(l) {
          return l.ownerDocument.defaultView.getComputedStyle(l);
        }

        function detectColors(l, s, c) {
          if (!l) return;
          s(getComputedStyle(l).color);
          var m = l,
              v = getComputedStyle(m).backgroundColor;

          for (; "rgba(0, 0, 0, 0)" === v && m.parentNode && m.parentNode.nodeType === m.parentNode.ELEMENT_NODE;) {
            m = m.parentNode, v = getComputedStyle(m).backgroundColor;
          }

          c(v);
        }

        var W = (0, k.withColors)({
          textColor: "color"
        }, {
          backgroundColor: "color"
        }, {
          overlayBackgroundColor: "color"
        }, {
          overlayTextColor: "color"
        })(function Navigation(l) {
          var _ref200, _ref201;

          var s = l.attributes,
              c = l.setAttributes,
              m = l.clientId,
              W = l.isSelected,
              U = l.className,
              $ = l.backgroundColor,
              Z = l.setBackgroundColor,
              K = l.textColor,
              Q = l.setTextColor,
              Y = l.overlayBackgroundColor,
              X = l.setOverlayBackgroundColor,
              J = l.overlayTextColor,
              ee = l.setOverlayTextColor,
              te = l.context.navigationArea,
              _l$hasSubmenuIndicato = l.hasSubmenuIndicatorSetting,
              re = _l$hasSubmenuIndicato === void 0 ? !0 : _l$hasSubmenuIndicato,
              _l$hasColorSettings = l.hasColorSettings,
              ae = _l$hasColorSettings === void 0 ? !0 : _l$hasColorSettings,
              _l$customPlaceholder = l.customPlaceholder,
              oe = _l$customPlaceholder === void 0 ? null : _l$customPlaceholder,
              _l$customAppender = l.customAppender,
              ne = _l$customAppender === void 0 ? null : _l$customAppender;
          var le = s.openSubmenusOnClick,
              ie = s.overlayMenu,
              se = s.showSubmenuIcon,
              _s$layout2 = s.layout;
          _s$layout2 = _s$layout2 === void 0 ? {} : _s$layout2;
          var ce = _s$layout2.justifyContent,
              _s$layout2$orientatio = _s$layout2.orientation,
              ue = _s$layout2$orientatio === void 0 ? "horizontal" : _s$layout2$orientatio,
              _s$layout2$flexWrap = _s$layout2.flexWrap,
              de = _s$layout2$flexWrap === void 0 ? "wrap" : _s$layout2$flexWrap;
          var me,
              pe = y.noop;

          var _ref178 = (0, E.useEntityProp)("root", "navigationArea", "navigation", te);

          var _ref179 = _slicedToArray2(_ref178, 2);

          me = _ref179[0];
          pe = _ref179[1];

          var ge = te ? 0 === me ? void 0 : me : s.ref,
              ve = (0, w.useRegistry)(),
              he = (0, v.useCallback)(function (l) {
            c({
              ref: l
            }), te && pe(l);
          }, [te]),
              _ref180 = (0, k.__experimentalUseNoRecursiveRenders)("navigationMenu/".concat(ge)),
              _ref181 = _slicedToArray2(_ref180, 2),
              be = _ref181[0],
              _e = _ref181[1];

          (0, B.default)();

          var _ref182 = (0, w.useSelect)(function (l) {
            var _l47 = l(k.store),
                s = _l47.getBlock,
                c = _l47.getBlocks,
                v = _l47.hasSelectedInnerBlock,
                _ = s(m).innerBlocks,
                y = null == _ ? void 0 : _.length,
                E = y ? q : c(m);

            return {
              hasSubmenus: !!(y ? _ : E).find(function (l) {
                return "core/navigation-submenu" === l.name;
              }),
              hasUncontrolledInnerBlocks: y,
              uncontrolledInnerBlocks: _,
              isInnerBlockSelected: v(m, !0)
            };
          }, [m]),
              fe = _ref182.hasUncontrolledInnerBlocks,
              ye = _ref182.uncontrolledInnerBlocks,
              ke = _ref182.isInnerBlockSelected,
              _ref183 = (0, w.useDispatch)(k.store),
              Ee = _ref183.replaceInnerBlocks,
              we = _ref183.selectBlock,
              Ce = _ref183.__unstableMarkNextChangeAsNotPersistent,
              _ref184 = (0, v.useState)(!1),
              _ref185 = _slicedToArray2(_ref184, 2),
              xe = _ref185[0],
              Se = _ref185[1],
              Pe = !!te && !ge,
              _ref186 = (0, v.useState)(!fe || Pe),
              _ref187 = _slicedToArray2(_ref186, 2),
              Te = _ref187[0],
              Me = _ref187[1],
              _ref188 = (0, v.useState)(!1),
              _ref189 = _slicedToArray2(_ref188, 2),
              Be = _ref189[0],
              Ie = _ref189[1],
              _ref190 = (0, T.default)(ge),
              Ne = _ref190.isNavigationMenuResolved,
              ze = _ref190.isNavigationMenuMissing,
              Le = _ref190.canSwitchNavigationMenu,
              Ve = _ref190.hasResolvedNavigationMenus,
              Ae = _ref190.navigationMenus,
              Re = _ref190.navigationMenu,
              He = _ref190.canUserUpdateNavigationEntity,
              Oe = _ref190.hasResolvedCanUserUpdateNavigationEntity,
              De = _ref190.canUserDeleteNavigationEntity,
              Fe = _ref190.hasResolvedCanUserDeleteNavigationEntity,
              je = _ref190.canUserCreateNavigation,
              Ge = _ref190.hasResolvedCanUserCreateNavigation,
              qe = (0, v.useRef)(),
              We = "draft" === (null == Re ? void 0 : Re.status),
              _ref191 = (0, P.default)(m),
              Ue = _ref191.listViewToolbarButton,
              $e = _ref191.listViewModal,
              Ze = !ze && Ne,
              Ke = (0, k.useBlockProps)({
            ref: qe,
            className: (0, _.default)(U, (_ref200 = {
              "items-justified-right": "right" === ce,
              "items-justified-space-between": "space-between" === ce,
              "items-justified-left": "left" === ce,
              "items-justified-center": "center" === ce,
              "is-vertical": "vertical" === ue,
              "no-wrap": "nowrap" === de,
              "is-responsive": "never" !== ie,
              "has-text-color": !!K.color || !(null == K || !K.class)
            }, _defineProperty(_ref200, (0, k.getColorClassName)("color", null == K ? void 0 : K.slug), !(null == K || !K.slug)), _defineProperty(_ref200, "has-background", !!$.color || $.class), _defineProperty(_ref200, (0, k.getColorClassName)("background-color", null == $ ? void 0 : $.slug), !(null == $ || !$.slug)), _ref200)),
            style: {
              color: !(null != K && K.slug) && (null == K ? void 0 : K.color),
              backgroundColor: !(null != $ && $.slug) && (null == $ ? void 0 : $.color)
            }
          }),
              Qe = (0, _.default)((_ref201 = {
            "has-text-color": !!J.color || !(null == J || !J.class)
          }, _defineProperty(_ref201, (0, k.getColorClassName)("color", null == J ? void 0 : J.slug), !(null == J || !J.slug)), _defineProperty(_ref201, "has-background", !!Y.color || (null == Y ? void 0 : Y.class)), _defineProperty(_ref201, (0, k.getColorClassName)("background-color", null == Y ? void 0 : Y.slug), !(null == Y || !Y.slug)), _ref201)),
              Ye = {
            color: !(null != J && J.slug) && (null == J ? void 0 : J.color),
            backgroundColor: !(null != Y && Y.slug) && (null == Y ? void 0 : Y.color) && Y.color
          },
              Xe = "web" === v.Platform.OS,
              _ref192 = (0, v.useState)(),
              _ref193 = _slicedToArray2(_ref192, 2),
              Je = _ref193[0],
              et = _ref193[1],
              _ref194 = (0, v.useState)(),
              _ref195 = _slicedToArray2(_ref194, 2),
              tt = _ref195[0],
              rt = _ref195[1],
              _ref196 = (0, v.useState)(),
              _ref197 = _slicedToArray2(_ref196, 2),
              at = _ref197[0],
              ot = _ref197[1],
              _ref198 = (0, v.useState)(),
              _ref199 = _slicedToArray2(_ref198, 2),
              nt = _ref199[0],
              lt = _ref199[1];

          (0, v.useEffect)(function () {
            ue && (Ce(), c({
              orientation: ue
            }));
          }, [ue]), (0, v.useEffect)(function () {
            var l;
            if (!Xe) return;
            detectColors(qe.current, rt, et);
            var s = null === (l = qe.current) || void 0 === l ? void 0 : l.querySelector('[data-type="core/navigation-link"] [data-type="core/navigation-link"]');
            s && detectColors(s, lt, ot);
          }), (0, v.useEffect)(function () {
            Me(!Ze);
          }, [Ze]);

          var _ref202 = (0, G.default)({
            name: "block-library/core/navigation/permissions/update",
            message: (0, S.__)("You do not have permission to edit this Menu. Any changes made will not be saved.")
          }),
              _ref203 = _slicedToArray2(_ref202, 2),
              it = _ref203[0],
              st = _ref203[1],
              _ref204 = (0, G.default)({
            name: "block-library/core/navigation/permissions/create",
            message: (0, S.__)("You do not have permission to create Navigation Menus.")
          }),
              _ref205 = _slicedToArray2(_ref204, 2),
              ct = _ref205[0],
              ut = _ref205[1];

          (0, v.useEffect)(function () {
            W || ke || (st(), ut()), (W || ke) && (Oe && !He && it(), ge || !Ge || je || ct());
          }, [W, ke, He, Oe, je, Ge, ge]);
          var dt = (0, v.useCallback)(function () {
            ve.batch(function () {
              te && pe(0), c({
                ref: void 0
              }), ge || Ee(m, []), Me(!0);
            });
          }, [m, ge]);
          if (fe && !Ze) return (0, v.createElement)("nav", Ke, (0, v.createElement)(V.default, {
            id: m,
            onToggle: Ie,
            isOpen: Be,
            isResponsive: "never" !== ie,
            isHiddenByDefault: "always" === ie,
            classNames: Qe,
            styles: Ye
          }, (0, v.createElement)(D.default, {
            blockProps: Ke,
            blocks: ye,
            clientId: m,
            navigationMenus: Ae,
            hasSelection: W || ke,
            hasSavedUnsavedInnerBlocks: xe,
            onSave: function onSave(l) {
              Se(!0), he(l.id);
            }
          })));
          if (ge && ze) return (0, v.createElement)("div", Ke, (0, v.createElement)(k.Warning, null, (0, S.__)("Navigation menu has been deleted or is unavailable. "), (0, v.createElement)(C.Button, {
            onClick: dt,
            variant: "link"
          }, (0, S.__)("Create a new menu?"))));
          if (Ze && be) return (0, v.createElement)("div", Ke, (0, v.createElement)(k.Warning, null, (0, S.__)("Block cannot be rendered inside itself.")));
          var mt = oe || z.default;
          return (0, v.createElement)(E.EntityProvider, {
            kind: "postType",
            type: "wp_navigation",
            id: ge
          }, (0, v.createElement)(_e, null, (0, v.createElement)(k.BlockControls, null, !We && Ze && (0, v.createElement)(C.ToolbarGroup, null, (0, v.createElement)(C.ToolbarDropdownMenu, {
            label: (0, S.__)("Select Menu"),
            text: (0, S.__)("Select Menu"),
            icon: null
          }, function (l) {
            var s = l.onClose;
            return (0, v.createElement)(R.default, {
              clientId: m,
              onSelect: function onSelect(l) {
                var c = l.id;
                he(c), s();
              },
              onCreateNew: dt,
              canUserCreateNavigation: je
            });
          })), (0, v.createElement)(C.ToolbarGroup, null, Ue)), $e, (0, v.createElement)(k.InspectorControls, null, re && (0, v.createElement)(C.PanelBody, {
            title: (0, S.__)("Display")
          }, (0, v.createElement)("h3", null, (0, S.__)("Overlay Menu")), (0, v.createElement)(C.__experimentalToggleGroupControl, {
            label: (0, S.__)("Configure overlay menu"),
            value: ie,
            help: (0, S.__)("Collapses the navigation options in a menu icon opening an overlay."),
            onChange: function onChange(l) {
              return c({
                overlayMenu: l
              });
            },
            isBlock: !0,
            hideLabelFromVision: !0
          }, (0, v.createElement)(C.__experimentalToggleGroupControlOption, {
            value: "never",
            label: (0, S.__)("Off")
          }), (0, v.createElement)(C.__experimentalToggleGroupControlOption, {
            value: "mobile",
            label: (0, S.__)("Mobile")
          }), (0, v.createElement)(C.__experimentalToggleGroupControlOption, {
            value: "always",
            label: (0, S.__)("Always")
          })), (0, v.createElement)("h3", null, (0, S.__)("Submenus")), (0, v.createElement)(C.ToggleControl, {
            checked: le,
            onChange: function onChange(l) {
              c({
                openSubmenusOnClick: l
              });
            },
            label: (0, S.__)("Open on click")
          }), !s.openSubmenusOnClick && (0, v.createElement)(C.ToggleControl, {
            checked: se,
            onChange: function onChange(l) {
              c({
                showSubmenuIcon: l
              });
            },
            label: (0, S.__)("Show icons")
          })), ae && (0, v.createElement)(k.PanelColorSettings, {
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0,
            title: (0, S.__)("Color"),
            initialOpen: !1,
            colorSettings: [{
              value: K.color,
              onChange: Q,
              label: (0, S.__)("Text")
            }, {
              value: $.color,
              onChange: Z,
              label: (0, S.__)("Background")
            }, {
              value: J.color,
              onChange: ee,
              label: (0, S.__)("Submenu & overlay text")
            }, {
              value: Y.color,
              onChange: X,
              label: (0, S.__)("Submenu & overlay background")
            }]
          }, Xe && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.ContrastChecker, {
            backgroundColor: Je,
            textColor: tt
          }), (0, v.createElement)(k.ContrastChecker, {
            backgroundColor: at,
            textColor: nt
          })))), Ze && (0, v.createElement)(k.InspectorControls, {
            __experimentalGroup: "advanced"
          }, Oe && He && (0, v.createElement)(O.default, null), Fe && De && (0, v.createElement)(F.default, {
            onDelete: dt
          })), (0, v.createElement)("nav", Ke, Te && (0, v.createElement)(mt, {
            onFinish: function onFinish(l) {
              Me(!1), l && he(l.id), we(m);
            },
            canSwitchNavigationMenu: Le,
            hasResolvedNavigationMenus: Ve,
            clientId: m,
            canUserCreateNavigation: je
          }), !Ge || !Ze && !Te && (0, v.createElement)(L.default, {
            isLoading: !0
          }), !Te && (0, v.createElement)(V.default, {
            id: m,
            onToggle: Ie,
            isOpen: Be,
            isResponsive: "never" !== ie,
            isHiddenByDefault: "always" === ie,
            classNames: Qe,
            styles: Ye
          }, Ze && (0, v.createElement)(A.default, {
            isVisible: !Te,
            clientId: m,
            appender: ne,
            hasCustomPlaceholder: !!oe,
            orientation: ue
          })))));
        });
        s.default = W;
      },
      3225: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationInnerBlocks(l) {
          var s = l.isVisible,
              c = l.clientId,
              m = l.appender,
              P = l.hasCustomPlaceholder,
              T = l.orientation;

          var _ref206 = (0, k.useSelect)(function (l) {
            var s;

            var _l48 = l(y.store),
                m = _l48.getClientIdsOfDescendants,
                v = _l48.hasSelectedInnerBlock,
                _ = _l48.getSelectedBlockClientId,
                k = _();

            return {
              isImmediateParentOfSelectedBlock: v(c, !1),
              selectedBlockHasDescendants: !(null === (s = m([k])) || void 0 === s || !s.length),
              isSelected: k === c
            };
          }, [c]),
              B = _ref206.isImmediateParentOfSelectedBlock,
              z = _ref206.selectedBlockHasDescendants,
              L = _ref206.isSelected,
              _ref207 = (0, _.useEntityBlockEditor)("postType", "wp_navigation"),
              _ref208 = _slicedToArray2(_ref207, 3),
              V = _ref208[0],
              A = _ref208[1],
              R = _ref208[2],
              O = (0, v.useMemo)(function () {
            return V.every(function (l) {
              var s = l.name;
              return "core/navigation-link" === s || "core/navigation-submenu" === s || "core/page-list" === s;
            });
          }, [V]),
              D = L || B && !z,
              F = !(!s || !D) && void 0,
              G = (0, v.useMemo)(function () {
            return (0, v.createElement)(E.default, null);
          }, []),
              q = (0, y.useInnerBlocksProps)({
            className: "wp-block-navigation__container"
          }, {
            value: V,
            onInput: A,
            onChange: R,
            allowedBlocks: w,
            __experimentalDefaultBlock: C,
            __experimentalDirectInsert: O,
            orientation: T,
            renderAppender: m || F,
            templateLock: !1,
            __experimentalLayout: S,
            placeholder: !s || P ? void 0 : G
          });

          return (0, v.createElement)(y.__experimentalBlockContentOverlay, {
            clientId: c,
            tagName: "div",
            wrapperProps: q
          });
        };

        var v = c(1753),
            _ = c(1295),
            y = c(1326),
            k = c(8467),
            E = m(c(5256));

        var w = ["core/navigation-link", "core/search", "core/social-links", "core/page-list", "core/spacer", "core/home-link", "core/site-title", "core/site-logo", "core/navigation-submenu"],
            C = ["core/navigation-link"],
            S = {
          type: "default",
          alignments: []
        };
      },
      1213: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationMenuDeleteControl(l) {
          var s = l.onDelete;

          var _ref209 = (0, m.useState)(!1),
              _ref210 = _slicedToArray2(_ref209, 2),
              c = _ref210[0],
              E = _ref210[1],
              w = (0, _.useEntityId)("postType", "wp_navigation"),
              _ref211 = (0, _.useEntityProp)("postType", "wp_navigation", "title"),
              _ref212 = _slicedToArray2(_ref211, 1),
              C = _ref212[0],
              _ref213 = (0, y.useDispatch)(_.store),
              S = _ref213.deleteEntityRecord;

          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(v.Button, {
            className: "wp-block-navigation-delete-menu-button",
            variant: "secondary",
            isDestructive: !0,
            onClick: function onClick() {
              E(!0);
            }
          }, (0, k.__)("Delete menu")), c && (0, m.createElement)(v.Modal, {
            title: (0, k.sprintf)((0, k.__)("Delete %s"), C),
            closeLabel: (0, k.__)("Cancel"),
            onRequestClose: function onRequestClose() {
              return E(!1);
            }
          }, (0, m.createElement)("p", null, (0, k.__)("Are you sure you want to delete this navigation menu?")), (0, m.createElement)(v.Flex, {
            justify: "flex-end"
          }, (0, m.createElement)(v.FlexItem, null, (0, m.createElement)(v.Button, {
            variant: "secondary",
            onClick: function onClick() {
              E(!1);
            }
          }, (0, k.__)("Cancel"))), (0, m.createElement)(v.FlexItem, null, (0, m.createElement)(v.Button, {
            variant: "primary",
            onClick: function onClick() {
              S("postType", "wp_navigation", w, {
                force: !0
              }), s();
            }
          }, (0, k.__)("Confirm"))))));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(1295),
            y = c(8467),
            k = c(6756);
      },
      3480: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationMenuNameControl() {
          var _ref214 = (0, _.useEntityProp)("postType", "wp_navigation", "title"),
              _ref215 = _slicedToArray2(_ref214, 2),
              l = _ref215[0],
              s = _ref215[1];

          return (0, m.createElement)(v.TextControl, {
            label: (0, y.__)("Menu name"),
            value: l,
            onChange: s
          });
        };

        var m = c(1753),
            v = c(4892),
            _ = c(1295),
            y = c(6756);
      },
      9120: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationMenuSelector(l) {
          var s = l.clientId,
              c = l.onSelect,
              m = l.onCreateNew,
              _l$canUserCreateNavig = l.canUserCreateNavigation,
              B = _l$canUserCreateNavig === void 0 ? !1 : _l$canUserCreateNavig;

          var _ref216 = (0, S.default)(),
              z = _ref216.menus,
              L = _ref216.hasMenus,
              _ref217 = (0, C.default)(),
              V = _ref217.navigationMenus,
              A = (0, y.useEntityId)("postType", "wp_navigation"),
              R = (0, T.default)(s),
              O = (0, P.default)( /*#__PURE__*/function () {
            var _ref218 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(l) {
              var s,
                  m,
                  _args3 = arguments;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      s = _args3.length > 1 && void 0 !== _args3[1] ? _args3[1] : null;

                      if (B) {
                        _context3.next = 3;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 3:
                      _context3.next = 5;
                      return R(s, l);

                    case 5:
                      m = _context3.sent;
                      c(m);

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref218.apply(this, arguments);
            };
          }());

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(_.MenuGroup, {
            label: (0, k.__)("Menus")
          }, (0, v.createElement)(_.MenuItemsChoice, {
            value: A,
            onSelect: function onSelect(l) {
              return c(V.find(function (s) {
                return s.id === l;
              }));
            },
            choices: V.map(function (l) {
              var s = l.id,
                  c = l.title;
              var m = (0, E.decodeEntities)(c.rendered);
              return {
                value: s,
                label: m,
                "aria-label": (0, k.sprintf)((0, k.__)("Switch to '%s'"), m)
              };
            })
          })), B && (0, v.createElement)(v.Fragment, null, L && (0, v.createElement)(_.MenuGroup, {
            label: (0, k.__)("Classic Menus")
          }, z.map(function (l) {
            return (0, v.createElement)(_.MenuItem, {
              onClick: function onClick() {
                O(l.id, l.name);
              },
              key: l.id
            }, (0, E.decodeEntities)(l.name));
          })), (0, v.createElement)(_.MenuGroup, {
            label: (0, k.__)("Tools")
          }, (0, v.createElement)(_.MenuItem, {
            onClick: m
          }, (0, k.__)("Create new menu")), (0, v.createElement)(_.MenuItem, {
            href: (0, w.addQueryArgs)("edit.php", {
              post_type: "wp_navigation"
            })
          }, (0, k.__)("Manage menus")))));
        };

        var v = c(1753),
            _ = c(4892),
            y = c(1295),
            k = c(6756),
            E = c(3248),
            w = c(904),
            C = m(c(430)),
            S = m(c(6491)),
            P = m(c(7108)),
            T = m(c(6254));
      },
      1974: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NavigationPlaceholder(l) {
          var s = l.clientId,
              c = l.onFinish,
              m = l.canSwitchNavigationMenu,
              w = l.hasResolvedNavigationMenus,
              _l$canUserCreateNavig2 = l.canUserCreateNavigation,
              z = _l$canUserCreateNavig2 === void 0 ? !1 : _l$canUserCreateNavig2;

          var L = (0, T.default)(s),
              onFinishMenuCreation = /*#__PURE__*/function () {
            var _ref221 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(l) {
              var s,
                  m,
                  _args4 = arguments;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      s = _args4.length > 1 && void 0 !== _args4[1] ? _args4[1] : null;

                      if (z) {
                        _context4.next = 3;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 3:
                      _context4.next = 5;
                      return L(s, l);

                    case 5:
                      m = _context4.sent;
                      c(m, l);

                    case 7:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function onFinishMenuCreation(_x4) {
              return _ref221.apply(this, arguments);
            };
          }(),
              V = (0, B.default)(onFinishMenuCreation),
              _ref219 = (0, C.default)(),
              A = _ref219.isResolvingPages,
              R = _ref219.menus,
              O = _ref219.isResolvingMenus,
              D = _ref219.hasPages,
              F = _ref219.hasMenus,
              G = A || O,
              _ref220 = (0, P.default)(),
              q = _ref220.navigationMenus;

          return (0, v.createElement)(v.Fragment, null, (!w || G) && (0, v.createElement)(S.default, {
            isLoading: !0
          }), w && !G && (0, v.createElement)(y.Placeholder, {
            className: "wp-block-navigation-placeholder"
          }, (0, v.createElement)(S.default, null), (0, v.createElement)("div", {
            className: "wp-block-navigation-placeholder__controls"
          }, (0, v.createElement)("div", {
            className: "wp-block-navigation-placeholder__actions"
          }, (0, v.createElement)("div", {
            className: "wp-block-navigation-placeholder__actions__indicator"
          }, (0, v.createElement)(E.Icon, {
            icon: E.navigation
          }), " ", (0, k.__)("Navigation")), (0, v.createElement)("hr", null), F || null != q && q.length ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)(ExistingMenusDropdown, {
            canSwitchNavigationMenu: m,
            navigationMenus: q,
            onFinish: c,
            menus: R,
            onCreateFromMenu: V,
            showClassicMenus: z
          }), (0, v.createElement)("hr", null)) : void 0, z && D ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.Button, {
            variant: "tertiary",
            onClick: function onClick() {
              var l = [(0, _.createBlock)("core/page-list")];
              onFinishMenuCreation(l);
            }
          }, (0, k.__)("Add all pages")), (0, v.createElement)("hr", null)) : void 0, z && (0, v.createElement)(y.Button, {
            variant: "tertiary",
            onClick: function onClick() {
              onFinishMenuCreation([]);
            }
          }, (0, k.__)("Start empty"))))));
        };

        var v = c(1753),
            _ = c(6700),
            y = c(4892),
            k = c(6756),
            E = c(5303),
            w = c(3248),
            C = m(c(6491)),
            S = m(c(5256)),
            P = m(c(430)),
            T = m(c(6254)),
            B = m(c(7108));

        var ExistingMenusDropdown = function ExistingMenusDropdown(l) {
          var s = l.canSwitchNavigationMenu,
              c = l.navigationMenus,
              m = l.onFinish,
              _ = l.menus,
              E = l.onCreateFromMenu,
              _l$showClassicMenus = l.showClassicMenus,
              C = _l$showClassicMenus === void 0 ? !1 : _l$showClassicMenus;
          return (0, v.createElement)(y.DropdownMenu, {
            text: (0, k.__)("Select menu"),
            icon: null,
            toggleProps: {
              variant: "tertiary",
              iconPosition: "right",
              className: "wp-block-navigation-placeholder__actions__dropdown"
            },
            popoverProps: {
              isAlternate: !0
            }
          }, function (l) {
            var S = l.onClose;
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.MenuGroup, {
              label: (0, k.__)("Menus")
            }, s && (null == c ? void 0 : c.map(function (l) {
              return (0, v.createElement)(y.MenuItem, {
                onClick: function onClick() {
                  m(l);
                },
                onClose: S,
                key: l.id
              }, (0, w.decodeEntities)(l.title.rendered));
            }))), C && (0, v.createElement)(y.MenuGroup, {
              label: (0, k.__)("Classic Menus")
            }, null == _ ? void 0 : _.map(function (l) {
              return (0, v.createElement)(y.MenuItem, {
                onClick: function onClick() {
                  E(l.id, l.name);
                },
                onClose: S,
                key: l.id
              }, (0, w.decodeEntities)(l.name));
            })));
          });
        };
      },
      5256: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(5303);

        var _default = function _default(l) {
          var s = l.isLoading;
          return (0, v.createElement)("ul", {
            className: (0, _.default)("wp-block-navigation-placeholder__preview", "wp-block-navigation__container", {
              "is-loading": s
            })
          }, (0, v.createElement)("li", {
            className: "wp-block-navigation-item"
          }, "​"), (0, v.createElement)("li", {
            className: "wp-block-navigation-item"
          }, "​"), (0, v.createElement)("li", {
            className: "wp-block-navigation-item"
          }, "​"), (0, v.createElement)("li", {
            className: "wp-block-navigation-placeholder__preview-search-icon"
          }, (0, v.createElement)(y.Icon, {
            icon: y.search
          })));
        };

        s.default = _default;
      },
      7721: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ResponsiveWrapper(l) {
          var s = l.children,
              c = l.id,
              m = l.isOpen,
              C = l.isResponsive,
              S = l.onToggle,
              P = l.isHiddenByDefault,
              T = l.classNames,
              B = l.styles;
          if (!C) return s;

          var z = (0, _.default)("wp-block-navigation__responsive-container", T, {
            "is-menu-open": m,
            "hidden-by-default": P
          }),
              L = (0, _.default)("wp-block-navigation__responsive-container-open", {
            "always-shown": P
          }),
              V = "".concat(c, "-modal"),
              A = _objectSpread({
            className: "wp-block-navigation__responsive-dialog"
          }, m && {
            role: "dialog",
            "aria-modal": !0,
            "aria-label": (0, w.__)("Menu")
          });

          return (0, v.createElement)(v.Fragment, null, !m && (0, v.createElement)(k.Button, {
            "aria-haspopup": "true",
            "aria-label": (0, w.__)("Open menu"),
            className: L,
            onClick: function onClick() {
              return S(!0);
            }
          }, (0, v.createElement)(E.SVG, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            role: "img",
            "aria-hidden": "true",
            focusable: "false"
          }, (0, v.createElement)(E.Rect, {
            x: "4",
            y: "7.5",
            width: "16",
            height: "1.5"
          }), (0, v.createElement)(E.Rect, {
            x: "4",
            y: "15",
            width: "16",
            height: "1.5"
          }))), (0, v.createElement)("div", {
            className: z,
            style: B,
            id: V
          }, (0, v.createElement)("div", {
            className: "wp-block-navigation__responsive-close",
            tabIndex: "-1"
          }, (0, v.createElement)("div", A, (0, v.createElement)(k.Button, {
            className: "wp-block-navigation__responsive-container-close",
            "aria-label": (0, w.__)("Close menu"),
            onClick: function onClick() {
              return S(!1);
            }
          }, (0, v.createElement)(y.Icon, {
            icon: y.close
          })), (0, v.createElement)("div", {
            className: "wp-block-navigation__responsive-container-content",
            id: "".concat(V, "-content")
          }, s)))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(5303),
            k = c(4892),
            E = c(1666),
            w = c(6756);
      },
      7844: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function UnsavedInnerBlocks(l) {
          var s = l.blockProps,
              c = l.blocks,
              m = l.clientId,
              B = l.hasSavedUnsavedInnerBlocks,
              z = l.onSave,
              L = l.hasSelection;

          var V = (0, v.useContext)(k.Disabled.Context),
              A = (0, v.useRef)(!1),
              R = (0, y.useInnerBlocksProps)(s, {
            renderAppender: !!L && void 0
          }),
              _ref222 = (0, w.useSelect)(function (l) {
            if (V) return P;

            var _l49 = l(E.store),
                s = _l49.getEntityRecords,
                c = _l49.hasFinishedResolution,
                m = _l49.isSavingEntityRecord;

            return {
              isSaving: m("postType", "wp_navigation"),
              draftNavigationMenus: s.apply(void 0, T),
              hasResolvedDraftNavigationMenus: c("getEntityRecords", T)
            };
          }, [V]),
              O = _ref222.isSaving,
              D = _ref222.draftNavigationMenus,
              F = _ref222.hasResolvedDraftNavigationMenus,
              _ref223 = (0, C.default)(),
              G = _ref223.hasResolvedNavigationMenus,
              q = _ref223.navigationMenus,
              W = (0, S.default)(m);

          return (0, v.useEffect)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            var l;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!(V || B || O || A.current || !F || !G || !L)) {
                      _context5.next = 2;
                      break;
                    }

                    return _context5.abrupt("return");

                  case 2:
                    A.current = !0;
                    _context5.next = 5;
                    return W(null, c);

                  case 5:
                    l = _context5.sent;
                    z(l), A.current = !1;

                  case 7:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })), [V, O, F, G, D, q, L, W, c]), (0, v.createElement)("div", {
            className: "wp-block-navigation__unsaved-changes"
          }, (0, v.createElement)(k.Disabled, {
            className: (0, _.default)("wp-block-navigation__unsaved-changes-overlay", {
              "is-saving": L
            })
          }, (0, v.createElement)("div", R)), L && (0, v.createElement)(k.Spinner, null));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(4892),
            E = c(1295),
            w = c(8467),
            C = m(c(430)),
            S = m(c(6254));

        var P = {},
            T = ["postType", "wp_navigation", {
          status: "draft",
          per_page: -1
        }];
      },
      6254: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useCreateNavigationMenu(l) {
          var _ref225 = (0, y.useDispatch)(_.store),
              s = _ref225.saveEntityRecord,
              c = (0, E.default)(l);

          return (0, k.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var l,
                m,
                _,
                _args6 = arguments;

            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    l = _args6.length > 0 && void 0 !== _args6[0] ? _args6[0] : null, m = _args6.length > 1 && void 0 !== _args6[1] ? _args6[1] : [];
                    _context6.t0 = l;

                    if (_context6.t0) {
                      _context6.next = 6;
                      break;
                    }

                    _context6.next = 5;
                    return c();

                  case 5:
                    l = _context6.sent;

                  case 6:
                    _ = {
                      title: l,
                      content: (0, v.serialize)(m),
                      status: "publish"
                    };
                    _context6.next = 9;
                    return s("postType", "wp_navigation", _);

                  case 9:
                    return _context6.abrupt("return", _context6.sent);

                  case 10:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })), [v.serialize, s]);
        };

        var v = c(6700),
            _ = c(1295),
            y = c(8467),
            k = c(1753),
            E = m(c(3053));
      },
      3053: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useGenerateDefaultNavigationTitle(l) {
          var s = (0, k.useContext)(v.Disabled.Context),
              c = (0, w.default)(s ? void 0 : l),
              m = (0, y.useRegistry)();
          return (0, k.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
            var _m$resolveSelect, l, _yield$Promise$all, _yield$Promise$all2, v, y, k, w;

            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!s) {
                      _context7.next = 2;
                      break;
                    }

                    return _context7.abrupt("return", "");

                  case 2:
                    _m$resolveSelect = m.resolveSelect(_.store);
                    l = _m$resolveSelect.getEntityRecords;
                    _context7.next = 6;
                    return Promise.all([l.apply(void 0, C), l.apply(void 0, S)]);

                  case 6:
                    _yield$Promise$all = _context7.sent;
                    _yield$Promise$all2 = _slicedToArray2(_yield$Promise$all, 2);
                    v = _yield$Promise$all2[0];
                    y = _yield$Promise$all2[1];
                    k = c ? (0, E.sprintf)((0, E.__)("%s navigation"), c) : (0, E.__)("Navigation");
                    w = [].concat(_toConsumableArray(v), _toConsumableArray(y)).reduce(function (l, s) {
                      var c, m;
                      return null != s && null !== (c = s.title) && void 0 !== c && null !== (m = c.raw) && void 0 !== m && m.startsWith(k) ? l + 1 : l;
                    }, 0);
                    return _context7.abrupt("return", (w > 0 ? "".concat(k, " ").concat(w + 1) : k) || "");

                  case 13:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          })), [s, c]);
        };

        var v = c(4892),
            _ = c(1295),
            y = c(8467),
            k = c(1753),
            E = c(6756),
            w = m(c(4639));

        var C = ["postType", "wp_navigation", {
          status: "draft",
          per_page: -1
        }],
            S = ["postType", "wp_navigation", {
          per_page: -1,
          status: "publish"
        }];
      },
      4585: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useListViewModal(l, s) {
          var _ref228 = (0, m.useState)(!1),
              _ref229 = _slicedToArray2(_ref228, 2),
              c = _ref229[0],
              v = _ref229[1],
              y = (0, m.createElement)(_.ToolbarButton, {
            className: "components-toolbar__control",
            label: (0, k.__)("Open list view"),
            onClick: function onClick() {
              return v(!0);
            },
            icon: E.listView
          }),
              w = c && (0, m.createElement)(_.Modal, {
            title: (0, k.__)("List View"),
            closeLabel: (0, k.__)("Close"),
            onRequestClose: function onRequestClose() {
              v(!1);
            },
            shouldCloseOnClickOutside: !1
          }, (0, m.createElement)(NavigationBlockListView, {
            clientId: l,
            __experimentalFeatures: s
          }));

          return {
            listViewToolbarButton: y,
            listViewModal: w
          };
        };

        var m = c(1753),
            v = c(1326),
            _ = c(4892),
            y = c(8467),
            k = c(6756),
            E = c(5303);

        function NavigationBlockListView(l) {
          var s = l.clientId,
              c = l.__experimentalFeatures;

          var _ = (0, y.useSelect)(function (l) {
            return l(v.store).__unstableGetClientIdsTree(s);
          }, [s]),
              k = (0, m.useRef)(),
              _ref230 = (0, m.useState)(300),
              _ref231 = _slicedToArray2(_ref230, 2),
              E = _ref231[0],
              w = _ref231[1];

          return (0, m.useEffect)(function () {
            var l, s;
            w(null !== (l = null == k || null === (s = k.current) || void 0 === s ? void 0 : s.clientHeight) && void 0 !== l ? l : 300);
          }, []), (0, m.createElement)("div", {
            style: {
              minHeight: E
            }
          }, (0, m.createElement)(v.__experimentalListView, {
            ref: k,
            blocks: _,
            showBlockMovers: !0,
            showNestedBlocks: !0,
            __experimentalFeatures: c
          }));
        }
      },
      4739: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(8448);

        var y = function useNavigationNotice() {
          var _ref232 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref232.name,
              s = _ref232.message;

          var c = (0, m.useRef)(),
              _ref233 = (0, v.useDispatch)(_.store),
              y = _ref233.createWarningNotice,
              k = _ref233.removeNotice,
              showNotice = function showNotice() {
            c.current || (c.current = l, y(s, {
              id: c.current,
              type: "snackbar"
            }));
          },
              hideNotice = function hideNotice() {
            c.current && (k(c.current), c.current = null);
          };

          return [showNotice, hideNotice];
        };

        s.default = y;
      },
      6298: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(5636)),
            k = m(c(9037)),
            E = m(c(1617));

        var w = {
          apiVersion: 2,
          name: "core/navigation",
          title: "Navigation",
          category: "theme",
          description: "A collection of blocks that allow visitors to get around your site.",
          keywords: ["menu", "navigation", "links"],
          textdomain: "default",
          attributes: {
            ref: {
              type: "number"
            },
            textColor: {
              type: "string"
            },
            customTextColor: {
              type: "string"
            },
            rgbTextColor: {
              type: "string"
            },
            backgroundColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            rgbBackgroundColor: {
              type: "string"
            },
            showSubmenuIcon: {
              type: "boolean",
              default: !0
            },
            openSubmenusOnClick: {
              type: "boolean",
              default: !1
            },
            overlayMenu: {
              type: "string",
              default: "mobile"
            },
            __unstableLocation: {
              type: "string"
            },
            overlayBackgroundColor: {
              type: "string"
            },
            customOverlayBackgroundColor: {
              type: "string"
            },
            overlayTextColor: {
              type: "string"
            },
            customOverlayTextColor: {
              type: "string"
            }
          },
          usesContext: ["navigationArea"],
          providesContext: {
            textColor: "textColor",
            customTextColor: "customTextColor",
            backgroundColor: "backgroundColor",
            customBackgroundColor: "customBackgroundColor",
            overlayTextColor: "overlayTextColor",
            customOverlayTextColor: "customOverlayTextColor",
            overlayBackgroundColor: "overlayBackgroundColor",
            customOverlayBackgroundColor: "customOverlayBackgroundColor",
            fontSize: "fontSize",
            customFontSize: "customFontSize",
            showSubmenuIcon: "showSubmenuIcon",
            openSubmenusOnClick: "openSubmenusOnClick",
            style: "style",
            orientation: "orientation"
          },
          supports: {
            align: ["wide", "full"],
            anchor: !0,
            html: !1,
            inserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalTextTransform: !0,
              __experimentalFontFamily: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            spacing: {
              units: ["px", "em", "rem", "vh", "vw"]
            },
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            }
          },
          viewScript: "file:./view.min.js",
          editorStyle: "wp-block-navigation-editor",
          style: "wp-block-navigation"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.navigation,
          example: {
            innerBlocks: [{
              name: "core/navigation-link",
              attributes: {
                label: (0, v.__)("Home"),
                url: "https://make.wordpress.org/"
              }
            }, {
              name: "core/navigation-link",
              attributes: {
                label: (0, v.__)("About"),
                url: "https://make.wordpress.org/"
              }
            }, {
              name: "core/navigation-link",
              attributes: {
                label: (0, v.__)("Contact"),
                url: "https://make.wordpress.org/"
              }
            }]
          },
          edit: y.default,
          save: k.default,
          deprecated: E.default
        };
        s.settings = S;
      },
      467: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function menuItemsToBlocks(l) {
          if (!l) return null;
          var s = mapMenuItemsToBlocks(function createDataTree(l) {
            var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "id",
                c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "parent";
            var m = Object.create(null),
                v = [];

            var _iterator2 = _createForOfIteratorHelper(l),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _3 = _step2.value;
                m[_3[s]] = _objectSpread(_objectSpread({}, _3), {}, {
                  children: []
                }), _3[c] ? (m[_3[c]] = m[_3[c]] || {}, m[_3[c]].children = m[_3[c]].children || [], m[_3[c]].children.push(m[_3[s]])) : v.push(m[_3[s]]);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return v;
          }(l));
          return (0, _.applyFilters)("blocks.navigation.__unstableMenuItemsToBlocks", s, l);
        };

        var m = c(4793),
            v = c(6700),
            _ = c(1149);

        function mapMenuItemsToBlocks(l) {
          var s = {};
          return {
            innerBlocks: (0, m.sortBy)(l, "menu_order").map(function (l) {
              var c, m;

              if ("block" === l.type) {
                var _ref234 = (0, v.parse)(l.content.raw),
                    _ref235 = _slicedToArray2(_ref234, 1),
                    _s16 = _ref235[0];

                return _s16 || (0, v.createBlock)("core/freeform", {
                  content: l.content
                });
              }

              var _ = function menuItemToBlockAttributes(l) {
                var s;
                var c = l.title,
                    m = l.xfn,
                    v = l.classes,
                    _ = l.attr_title,
                    y = l.object,
                    k = l.object_id,
                    E = l.description,
                    w = l.url,
                    C = l.type,
                    S = l.target;
                y && "post_tag" === y && (y = "tag");
                return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                  label: (null == c ? void 0 : c.rendered) || ""
                }, (null === (s = y) || void 0 === s ? void 0 : s.length) && {
                  type: y
                }), {}, {
                  kind: (null == C ? void 0 : C.replace("_", "-")) || "custom",
                  url: w || ""
                }, (null == m ? void 0 : m.length) && m.join(" ").trim() && {
                  rel: m.join(" ").trim()
                }), (null == v ? void 0 : v.length) && v.join(" ").trim() && {
                  className: v.join(" ").trim()
                }), (null == _ ? void 0 : _.length) && {
                  title: _
                }), k && "custom" !== y && {
                  id: k
                }), (null == E ? void 0 : E.length) && {
                  description: E
                }), "_blank" === S && {
                  opensInNewTab: !0
                });
              }(l),
                  _ref236 = null !== (c = l.children) && void 0 !== c && c.length ? mapMenuItemsToBlocks(l.children) : {},
                  _ref236$innerBlocks = _ref236.innerBlocks,
                  y = _ref236$innerBlocks === void 0 ? [] : _ref236$innerBlocks,
                  _ref236$mapping = _ref236.mapping,
                  k = _ref236$mapping === void 0 ? {} : _ref236$mapping;

              s = _objectSpread(_objectSpread({}, s), k);
              var E = null !== (m = l.children) && void 0 !== m && m.length ? "core/navigation-submenu" : "core/navigation-link",
                  w = (0, v.createBlock)(E, _, y);
              return s[l.id] = w.clientId, w;
            }),
            mapping: s
          };
        }
      },
      9037: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          if (s.ref) return;
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      7108: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useConvertClassicMenu(l) {
          var _ref237 = (0, v.useState)(),
              _ref238 = _slicedToArray2(_ref237, 2),
              s = _ref238[0],
              c = _ref238[1],
              _ref239 = (0, v.useState)(!1),
              _ref240 = _slicedToArray2(_ref239, 2),
              m = _ref240[0],
              k = _ref240[1],
              _ref241 = (0, v.useState)(""),
              _ref242 = _slicedToArray2(_ref241, 2),
              E = _ref242[0],
              w = _ref242[1],
              _ref243 = (0, _.default)(s),
              C = _ref243.menuItems,
              S = _ref243.hasResolvedMenuItems,
              P = (0, v.useCallback)(function (s) {
            var _ref244 = (0, y.default)(C),
                c = _ref244.innerBlocks;

            l(c, s);
          }, [C, y.default, l]);

          return (0, v.useEffect)(function () {
            m && S && (P(E), k(!1));
          }, [m, S, E]), (0, v.useCallback)(function (l, s) {
            c(l), S ? P(s) : (k(!0), w(s));
          }, [S, P]);
        };

        var v = c(1753),
            _ = m(c(6491)),
            y = m(c(467));
      },
      6491: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useNavigationEntities(l) {
          return _objectSpread(_objectSpread(_objectSpread({}, usePageEntities()), useMenuEntities()), useMenuItemEntities(l));
        };
        var m = c(8467),
            v = c(1295);

        function useMenuEntities() {
          var _ref245 = (0, m.useSelect)(function (l) {
            var _l50 = l(v.store),
                s = _l50.getMenus,
                c = _l50.isResolving,
                m = _l50.hasFinishedResolution,
                _ = [{
              per_page: -1
            }];

            return {
              menus: s.apply(void 0, _),
              isResolvingMenus: c("getMenus", _),
              hasResolvedMenus: m("getMenus", _)
            };
          }, []),
              l = _ref245.menus,
              s = _ref245.isResolvingMenus,
              c = _ref245.hasResolvedMenus;

          return {
            menus: l,
            isResolvingMenus: s,
            hasResolvedMenus: c,
            hasMenus: !(!c || null == l || !l.length)
          };
        }

        function useMenuItemEntities(l) {
          var _ref246 = (0, m.useSelect)(function (s) {
            var _s17 = s(v.store),
                c = _s17.getMenuItems,
                m = _s17.hasFinishedResolution,
                _ = void 0 !== l,
                y = _ ? [{
              menus: l,
              per_page: -1
            }] : void 0;

            return {
              menuItems: _ ? c.apply(void 0, _toConsumableArray(y)) : void 0,
              hasResolvedMenuItems: !!_ && m("getMenuItems", y)
            };
          }, [l]),
              s = _ref246.menuItems,
              c = _ref246.hasResolvedMenuItems;

          return {
            menuItems: s,
            hasResolvedMenuItems: c
          };
        }

        function usePageEntities() {
          var _ref247 = (0, m.useSelect)(function (l) {
            var _l51 = l(v.store),
                s = _l51.getEntityRecords,
                c = _l51.isResolving,
                m = _l51.hasFinishedResolution,
                _ = ["postType", "page", {
              parent: 0,
              order: "asc",
              orderby: "id",
              per_page: -1
            }];

            return {
              pages: s.apply(void 0, _) || null,
              isResolvingPages: c("getEntityRecords", _),
              hasResolvedPages: m("getEntityRecords", _)
            };
          }, []),
              l = _ref247.pages,
              s = _ref247.isResolvingPages,
              c = _ref247.hasResolvedPages;

          return {
            pages: l,
            isResolvingPages: s,
            hasResolvedPages: c,
            hasPages: !(!c || null == l || !l.length)
          };
        }
      },
      430: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useNavigationMenu(l) {
          return (0, v.useSelect)(function (s) {
            var c;

            var _s18 = s(m.store),
                v = _s18.getEntityRecord,
                _ = _s18.getEditedEntityRecord,
                y = _s18.getEntityRecords,
                k = _s18.hasFinishedResolution,
                E = _s18.canUser,
                w = ["postType", "wp_navigation", l],
                C = l ? v.apply(void 0, w) : null;

            var S = l ? _.apply(void 0, w) : null;
            "publish" !== (null === (c = S) || void 0 === c ? void 0 : c.status) && (S = null);
            var P = !!l && k("getEditedEntityRecord", w),
                T = ["postType", "wp_navigation", {
              per_page: -1,
              status: "publish"
            }],
                B = y.apply(void 0, T),
                z = l ? (null == B ? void 0 : B.length) > 1 : (null == B ? void 0 : B.length) > 0;
            return {
              isNavigationMenuResolved: P,
              isNavigationMenuMissing: !l || P && !C,
              canSwitchNavigationMenu: z,
              hasResolvedNavigationMenus: k("getEntityRecords", T),
              navigationMenu: S,
              navigationMenus: B,
              canUserUpdateNavigationEntity: l ? E("update", "navigation", l) : void 0,
              hasResolvedCanUserUpdateNavigationEntity: k("canUser", ["update", "navigation", l]),
              canUserDeleteNavigationEntity: l ? E("delete", "navigation", l) : void 0,
              hasResolvedCanUserDeleteNavigationEntity: k("canUser", ["delete", "navigation", l]),
              canUserCreateNavigation: E("create", "navigation"),
              hasResolvedCanUserCreateNavigation: k("canUser", ["create", "navigation"])
            };
          }, [l]);
        };
        var m = c(1295),
            v = c(8467);
      },
      4639: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useTemplatePartAreaLabel(l) {
          return (0, _.useSelect)(function (s) {
            if (!l) return;

            var _s19 = s(m.store),
                c = _s19.getBlock,
                _ = _s19.getBlockParentsByBlockName,
                k = _(l, "core/template-part", !0);

            if (null == k || !k.length) return;

            var E = s("core/editor").__experimentalGetDefaultTemplatePartAreas(),
                _s20 = s(v.store),
                w = _s20.getEditedEntityRecord;

            var _iterator3 = _createForOfIteratorHelper(k),
                _step3;

            try {
              var _loop = function _loop() {
                var l = _step3.value;

                var s = c(l),
                    _s$attributes = s.attributes,
                    m = _s$attributes.theme,
                    v = _s$attributes.slug,
                    _ = w("postType", "wp_template_part", (0, y.createTemplatePartId)(m, v));

                if (null != _ && _.area) return {
                  v: null === (C = E.find(function (l) {
                    return "uncategorized" !== l.area && l.area === _.area;
                  })) || void 0 === C ? void 0 : C.label
                };
              };

              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var C;

                var _ret = _loop();

                if (typeof _ret === "object") return _ret.v;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }, [l]);
        };

        var m = c(1326),
            v = c(1295),
            _ = c(8467),
            y = c(6760);
      },
      4202: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function NextPageEdit() {
          return (0, m.createElement)("div", (0, _.useBlockProps)(), (0, m.createElement)("div", {
            className: "wp-block-nextpage"
          }, (0, m.createElement)("span", null, (0, v.__)("Page break"))));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(1326);
      },
      7188: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(4202)),
            y = m(c(2972)),
            k = m(c(5042));

        var E = {
          apiVersion: 2,
          name: "core/nextpage",
          title: "Page Break",
          category: "design",
          description: "Separate your content into a multi-page experience.",
          keywords: ["next page", "pagination"],
          parent: ["core/post-content"],
          textdomain: "default",
          supports: {
            customClassName: !1,
            className: !1,
            html: !1
          },
          editorStyle: "wp-block-nextpage-editor"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.pageBreak,
          example: {},
          transforms: k.default,
          edit: _.default,
          save: y.default
        };
        s.settings = C;
      },
      2972: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(m.RawHTML, null, "\x3c!--nextpage--\x3e");
        };
        var m = c(1753);
      },
      5042: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "raw",
            schema: {
              "wp-block": {
                attributes: ["data-block"]
              }
            },
            isMatch: function isMatch(l) {
              return l.dataset && "core/nextpage" === l.dataset.block;
            },
            transform: function transform() {
              return (0, m.createBlock)("core/nextpage", {});
            }
          }]
        };
        s.default = v;
      },
      4176: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.convertSelectedBlockToNavigationLinks = void 0, s.default = function ConvertToLinksModal(l) {
          var s = l.onClose,
              c = l.clientId;

          var _ref248 = (0, y.useSelect)(function (l) {
            var _l52 = l(k.store),
                s = _l52.getEntityRecords,
                c = _l52.hasFinishedResolution,
                m = ["postType", "page", {
              per_page: 100,
              _fields: C,
              orderby: "menu_order",
              order: "asc"
            }];

            return {
              pages: s.apply(void 0, m),
              pagesFinished: c("getEntityRecords", m)
            };
          }, [c]),
              S = _ref248.pages,
              P = _ref248.pagesFinished,
              _ref249 = (0, y.useDispatch)(w.store),
              T = _ref249.replaceBlock;

          return (0, m.createElement)(v.Modal, {
            closeLabel: (0, _.__)("Close"),
            onRequestClose: s,
            title: (0, _.__)("Convert to links"),
            className: "wp-block-page-list-modal",
            aria: {
              describedby: "wp-block-page-list-modal__description"
            }
          }, (0, m.createElement)("p", {
            id: "wp-block-page-list-modal__description"
          }, (0, _.__)("To edit this navigation menu, convert it to single page links. This allows you to add, re-order, remove items, or edit their labels.")), (0, m.createElement)("p", null, (0, _.__)("Note: if you add new pages to your site, you'll need to add them to your navigation menu.")), (0, m.createElement)("div", {
            className: "wp-block-page-list-modal-buttons"
          }, (0, m.createElement)(v.Button, {
            variant: "tertiary",
            onClick: s
          }, (0, _.__)("Cancel")), (0, m.createElement)(v.Button, {
            variant: "primary",
            disabled: !P,
            onClick: convertSelectedBlockToNavigationLinks({
              pages: S,
              replaceBlock: T,
              clientId: c,
              createBlock: E.createBlock
            })
          }, (0, _.__)("Convert"))));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            y = c(8467),
            k = c(1295),
            E = c(6700),
            w = c(1326);

        var C = ["id", "title", "link", "type", "parent"],
            convertSelectedBlockToNavigationLinks = function convertSelectedBlockToNavigationLinks(l) {
          var s = l.pages,
              c = l.clientId,
              m = l.replaceBlock,
              v = l.createBlock;
          return function () {
            if (!s) return;
            var l = {},
                _ = [];
            s.forEach(function (s) {
              var c, m;
              var y = s.id,
                  k = s.title,
                  E = s.link,
                  w = s.type,
                  C = s.parent;
              var S = null !== (c = null === (m = l[y]) || void 0 === m ? void 0 : m.innerBlocks) && void 0 !== c ? c : [];

              if (l[y] = v("core/navigation-link", {
                id: y,
                label: k.rendered,
                url: E,
                type: w,
                kind: "post-type"
              }, S), C) {
                l[C] || (l[C] = {
                  innerBlocks: []
                });
                l[C].innerBlocks.push(l[y]);
              } else _.push(l[y]);
            });

            var transformSubmenus = function transformSubmenus(l) {
              l.forEach(function (l, s, c) {
                var m = l.attributes,
                    _ = l.innerBlocks;

                if (0 !== _.length) {
                  transformSubmenus(_);

                  var _l53 = v("core/navigation-submenu", m, _);

                  c[s] = _l53;
                }
              });
            };

            transformSubmenus(_), m(c, _);
          };
        };

        s.convertSelectedBlockToNavigationLinks = convertSelectedBlockToNavigationLinks;
      },
      4603: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PageListEdit(l) {
          var _ref253;

          var s;
          var c = l.context,
              m = l.clientId;

          var _usePagesByParentId = function usePagesByParentId() {
            var _ref252 = (0, C.useSelect)(function (l) {
              var _l54 = l(S.store),
                  s = _l54.getEntityRecords;

              return {
                pages: s("postType", "page", {
                  orderby: "menu_order",
                  order: "asc",
                  _fields: ["id", "link", "parent", "title", "menu_order"],
                  per_page: -1
                })
              };
            }, []),
                l = _ref252.pages;

            return (0, v.useMemo)(function () {
              return {
                pagesByParentId: (0, y.sortBy)(l, ["menu_order", "title.rendered"]).reduce(function (l, s) {
                  var c = s.parent;
                  return l.has(c) ? l.get(c).push(s) : l.set(c, [s]), l;
                }, new Map()),
                totalPages: null == l ? void 0 : l.length
              };
            }, [l]);
          }(),
              T = _usePagesByParentId.pagesByParentId,
              z = _usePagesByParentId.totalPages,
              L = "showSubmenuIcon" in c && z <= 100,
              _ref250 = (0, v.useState)(!1),
              _ref251 = _slicedToArray2(_ref250, 2),
              V = _ref251[0],
              A = _ref251[1],
              R = (0, k.useBlockProps)({
            className: (0, _.default)("wp-block-page-list", (_ref253 = {
              "has-text-color": !!c.textColor
            }, _defineProperty(_ref253, (0, k.getColorClassName)("color", c.textColor), !!c.textColor), _defineProperty(_ref253, "has-background", !!c.backgroundColor), _defineProperty(_ref253, (0, k.getColorClassName)("background-color", c.backgroundColor), !!c.backgroundColor), _ref253)),
            style: _objectSpread({}, null === (s = c.style) || void 0 === s ? void 0 : s.color)
          });

          return (0, v.createElement)(v.Fragment, null, L && (0, v.createElement)(k.BlockControls, {
            group: "other"
          }, (0, v.createElement)(E.ToolbarButton, {
            title: (0, w.__)("Edit"),
            onClick: function onClick() {
              return A(!0);
            }
          }, (0, w.__)("Edit"))), L && V && (0, v.createElement)(P.default, {
            onClose: function onClose() {
              return A(!1);
            },
            clientId: m
          }), void 0 === z && (0, v.createElement)("div", R, (0, v.createElement)(E.Placeholder, null, (0, v.createElement)(E.Spinner, null))), 0 === z && (0, v.createElement)("div", R, (0, v.createElement)("span", null, (0, w.__)("Page List: No pages to show."))), z > 0 && (0, v.createElement)("ul", R, (0, v.createElement)(B, {
            context: c,
            pagesByParentId: T
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(8467),
            S = c(1295),
            P = m(c(4176)),
            T = c(3033);

        var B = (0, v.memo)(function PageItems(l) {
          var s = l.context,
              c = l.pagesByParentId,
              _l$parentId = l.parentId,
              m = _l$parentId === void 0 ? 0 : _l$parentId,
              _l$depth = l.depth,
              y = _l$depth === void 0 ? 0 : _l$depth;
          var k = c.get(m);
          return null != k && k.length ? k.map(function (l) {
            var m, k;
            var E = c.has(l.id),
                w = ("showSubmenuIcon" in s);
            return (0, v.createElement)("li", {
              key: l.id,
              className: (0, _.default)("wp-block-pages-list__item", {
                "has-child": E,
                "wp-block-navigation-item": w,
                "open-on-click": s.openSubmenusOnClick,
                "open-on-hover-click": !s.openSubmenusOnClick && s.showSubmenuIcon
              })
            }, E && s.openSubmenusOnClick ? (0, v.createElement)(ItemSubmenuToggle, {
              title: null === (m = l.title) || void 0 === m ? void 0 : m.rendered
            }) : (0, v.createElement)("a", {
              className: (0, _.default)("wp-block-pages-list__item__link", {
                "wp-block-navigation-item__content": w
              }),
              href: l.link
            }, null === (k = l.title) || void 0 === k ? void 0 : k.rendered), E && (0, v.createElement)(v.Fragment, null, !s.openSubmenusOnClick && s.showSubmenuIcon && (0, v.createElement)(ItemSubmenuToggle, null), (0, v.createElement)("ul", {
              className: (0, _.default)("submenu-container", {
                "wp-block-navigation__submenu-container": w
              })
            }, (0, v.createElement)(PageItems, {
              context: s,
              pagesByParentId: c,
              parentId: l.id,
              depth: y + 1
            }))));
          }) : [];
        });

        function ItemSubmenuToggle(l) {
          var s = l.title;
          return (0, v.createElement)("button", {
            className: "wp-block-navigation-item__content wp-block-navigation-submenu__toggle",
            "aria-expanded": "false"
          }, s, (0, v.createElement)("span", {
            className: "wp-block-page-list__submenu-icon wp-block-navigation__submenu-icon"
          }, (0, v.createElement)(T.ItemSubmenuIcon, null)));
        }
      },
      7002: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(4603));

        var y = {
          apiVersion: 2,
          name: "core/page-list",
          title: "Page List",
          category: "widgets",
          description: "Display a list of all pages.",
          keywords: ["menu", "navigation"],
          textdomain: "default",
          attributes: {},
          usesContext: ["textColor", "customTextColor", "backgroundColor", "customBackgroundColor", "overlayTextColor", "customOverlayTextColor", "overlayBackgroundColor", "customOverlayBackgroundColor", "fontSize", "customFontSize", "showSubmenuIcon", "style", "openSubmenusOnClick"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "wp-block-page-list-editor",
          style: "wp-block-page-list"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.pages,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      3854: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326);

        var E = {
          className: !1
        },
            w = {
          align: {
            type: "string"
          },
          content: {
            type: "string",
            source: "html",
            selector: "p",
            default: ""
          },
          dropCap: {
            type: "boolean",
            default: !1
          },
          placeholder: {
            type: "string"
          },
          textColor: {
            type: "string"
          },
          backgroundColor: {
            type: "string"
          },
          fontSize: {
            type: "string"
          },
          direction: {
            type: "string",
            enum: ["ltr", "rtl"]
          },
          style: {
            type: "object"
          }
        },
            migrateCustomColorsAndFontSizes = function migrateCustomColorsAndFontSizes(l) {
          if (!l.customTextColor && !l.customBackgroundColor && !l.customFontSize) return l;
          var s = {};
          return (l.customTextColor || l.customBackgroundColor) && (s.color = {}), l.customTextColor && (s.color.text = l.customTextColor), l.customBackgroundColor && (s.color.background = l.customBackgroundColor), l.customFontSize && (s.typography = {
            fontSize: l.customFontSize
          }), _objectSpread(_objectSpread({}, (0, y.omit)(l, ["customTextColor", "customBackgroundColor", "customFontSize"])), {}, {
            style: s
          });
        };

        var C = [{
          supports: E,
          attributes: _objectSpread(_objectSpread({}, (0, y.omit)(w, ["style"])), {}, {
            customTextColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customFontSize: {
              type: "number"
            }
          }),
          migrate: migrateCustomColorsAndFontSizes,
          save: function save(l) {
            var _ref254;

            var s = l.attributes;
            var c = s.align,
                m = s.content,
                y = s.dropCap,
                E = s.backgroundColor,
                w = s.textColor,
                C = s.customBackgroundColor,
                S = s.customTextColor,
                P = s.fontSize,
                T = s.customFontSize,
                B = s.direction,
                z = (0, k.getColorClassName)("color", w),
                L = (0, k.getColorClassName)("background-color", E),
                V = (0, k.getFontSizeClass)(P),
                A = (0, _.default)((_ref254 = {
              "has-text-color": w || S,
              "has-background": E || C,
              "has-drop-cap": y
            }, _defineProperty(_ref254, "has-text-align-".concat(c), c), _defineProperty(_ref254, V, V), _defineProperty(_ref254, z, z), _defineProperty(_ref254, L, L), _ref254)),
                R = {
              backgroundColor: L ? void 0 : C,
              color: z ? void 0 : S,
              fontSize: V ? void 0 : T
            };
            return (0, v.createElement)(k.RichText.Content, {
              tagName: "p",
              style: R,
              className: A || void 0,
              value: m,
              dir: B
            });
          }
        }, {
          supports: E,
          attributes: _objectSpread(_objectSpread({}, (0, y.omit)(w, ["style"])), {}, {
            customTextColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customFontSize: {
              type: "number"
            }
          }),
          migrate: migrateCustomColorsAndFontSizes,
          save: function save(l) {
            var _ref255;

            var s = l.attributes;
            var c = s.align,
                m = s.content,
                y = s.dropCap,
                E = s.backgroundColor,
                w = s.textColor,
                C = s.customBackgroundColor,
                S = s.customTextColor,
                P = s.fontSize,
                T = s.customFontSize,
                B = s.direction,
                z = (0, k.getColorClassName)("color", w),
                L = (0, k.getColorClassName)("background-color", E),
                V = (0, k.getFontSizeClass)(P),
                A = (0, _.default)((_ref255 = {
              "has-text-color": w || S,
              "has-background": E || C,
              "has-drop-cap": y
            }, _defineProperty(_ref255, V, V), _defineProperty(_ref255, z, z), _defineProperty(_ref255, L, L), _ref255)),
                R = {
              backgroundColor: L ? void 0 : C,
              color: z ? void 0 : S,
              fontSize: V ? void 0 : T,
              textAlign: c
            };
            return (0, v.createElement)(k.RichText.Content, {
              tagName: "p",
              style: R,
              className: A || void 0,
              value: m,
              dir: B
            });
          }
        }, {
          supports: E,
          attributes: _objectSpread(_objectSpread({}, (0, y.omit)(w, ["style"])), {}, {
            customTextColor: {
              type: "string"
            },
            customBackgroundColor: {
              type: "string"
            },
            customFontSize: {
              type: "number"
            },
            width: {
              type: "string"
            }
          }),
          migrate: migrateCustomColorsAndFontSizes,
          save: function save(l) {
            var _ref256;

            var s = l.attributes;
            var c = s.width,
                m = s.align,
                y = s.content,
                E = s.dropCap,
                w = s.backgroundColor,
                C = s.textColor,
                S = s.customBackgroundColor,
                P = s.customTextColor,
                T = s.fontSize,
                B = s.customFontSize,
                z = (0, k.getColorClassName)("color", C),
                L = (0, k.getColorClassName)("background-color", w),
                V = T && "is-".concat(T, "-text"),
                A = (0, _.default)((_ref256 = {}, _defineProperty(_ref256, "align".concat(c), c), _defineProperty(_ref256, "has-background", w || S), _defineProperty(_ref256, "has-drop-cap", E), _defineProperty(_ref256, V, V), _defineProperty(_ref256, z, z), _defineProperty(_ref256, L, L), _ref256)),
                R = {
              backgroundColor: L ? void 0 : S,
              color: z ? void 0 : P,
              fontSize: V ? void 0 : B,
              textAlign: m
            };
            return (0, v.createElement)(k.RichText.Content, {
              tagName: "p",
              style: R,
              className: A || void 0,
              value: y
            });
          }
        }, {
          supports: E,
          attributes: (0, y.omit)(_objectSpread(_objectSpread({}, w), {}, {
            fontSize: {
              type: "number"
            }
          }), ["style"]),
          save: function save(l) {
            var _ref257;

            var s = l.attributes;
            var c = s.width,
                m = s.align,
                y = s.content,
                k = s.dropCap,
                E = s.backgroundColor,
                w = s.textColor,
                C = s.fontSize,
                S = (0, _.default)((_ref257 = {}, _defineProperty(_ref257, "align".concat(c), c), _defineProperty(_ref257, "has-background", E), _defineProperty(_ref257, "has-drop-cap", k), _ref257)),
                P = {
              backgroundColor: E,
              color: w,
              fontSize: C,
              textAlign: m
            };
            return (0, v.createElement)("p", {
              style: P,
              className: S || void 0
            }, y);
          },
          migrate: function migrate(l) {
            return migrateCustomColorsAndFontSizes((0, y.omit)(_objectSpread(_objectSpread({}, l), {}, {
              customFontSize: (0, y.isFinite)(l.fontSize) ? l.fontSize : void 0,
              customTextColor: l.textColor && "#" === l.textColor[0] ? l.textColor : void 0,
              customBackgroundColor: l.backgroundColor && "#" === l.backgroundColor[0] ? l.backgroundColor : void 0
            })));
          }
        }, {
          supports: E,
          attributes: _objectSpread(_objectSpread({}, w), {}, {
            content: {
              type: "string",
              source: "html",
              default: ""
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            return (0, v.createElement)(v.RawHTML, null, s.content);
          },
          migrate: function migrate(l) {
            return l;
          }
        }];
        s.default = C;
      },
      4312: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(6756),
            E = c(4892),
            w = c(1326),
            C = c(6700),
            S = c(5303);

        function ParagraphRTLControl(l) {
          var s = l.direction,
              c = l.setDirection;
          return (0, k.isRTL)() && (0, v.createElement)(E.ToolbarDropdownMenu, {
            controls: [{
              icon: S.formatLtr,
              title: (0, k._x)("Left to right", "editor button"),
              isActive: "ltr" === s,
              onClick: function onClick() {
                c("ltr" === s ? void 0 : "ltr");
              }
            }]
          });
        }

        var P = function ParagraphBlock(l) {
          var s = l.attributes,
              c = l.mergeBlocks,
              m = l.onReplace,
              S = l.onRemove,
              P = l.setAttributes,
              T = l.clientId;
          var B = s.align,
              z = s.content,
              L = s.direction,
              V = s.dropCap,
              A = s.placeholder,
              R = (0, w.useSetting)("typography.dropCap"),
              O = (0, w.useBlockProps)({
            className: (0, y.default)(_defineProperty({
              "has-drop-cap": V
            }, "has-text-align-".concat(B), B)),
            style: {
              direction: L
            }
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, (0, v.createElement)(w.AlignmentControl, {
            value: B,
            onChange: function onChange(l) {
              return P({
                align: l
              });
            }
          }), (0, v.createElement)(ParagraphRTLControl, {
            direction: L,
            setDirection: function setDirection(l) {
              return P({
                direction: l
              });
            }
          })), R && (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, k.__)("Text settings")
          }, (0, v.createElement)(E.ToggleControl, {
            label: (0, k.__)("Drop cap"),
            checked: !!V,
            onChange: function onChange() {
              return P({
                dropCap: !V
              });
            },
            help: V ? (0, k.__)("Showing large initial letter.") : (0, k.__)("Toggle to show a large initial letter.")
          }))), (0, v.createElement)(w.RichText, (0, _.default)({
            identifier: "content",
            tagName: "p"
          }, O, {
            value: z,
            onChange: function onChange(l) {
              return P({
                content: l
              });
            },
            onSplit: function onSplit(l, c) {
              var m;
              (c || l) && (m = _objectSpread(_objectSpread({}, s), {}, {
                content: l
              }));
              var v = (0, C.createBlock)("core/paragraph", m);
              return c && (v.clientId = T), v;
            },
            onMerge: c,
            onReplace: m,
            onRemove: S,
            "aria-label": z ? (0, k.__)("Paragraph block") : (0, k.__)("Empty block; start writing or type forward slash to choose a block"),
            "data-empty": !z,
            placeholder: A || (0, k.__)("Type / to choose a block"),
            __unstableEmbedURLOnPaste: !0,
            __unstableAllowPrefixTransformations: !0
          })));
        };

        s.default = P;
      },
      9401: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(4793),
            _ = c(6756),
            y = c(5303),
            k = m(c(3854)),
            E = m(c(4312)),
            w = m(c(8593)),
            C = m(c(7309));

        var S = {
          apiVersion: 2,
          name: "core/paragraph",
          title: "Paragraph",
          category: "text",
          description: "Start with the building block of all narrative.",
          keywords: ["text"],
          textdomain: "default",
          attributes: {
            align: {
              type: "string"
            },
            content: {
              type: "string",
              source: "html",
              selector: "p",
              default: "",
              __experimentalRole: "content"
            },
            dropCap: {
              type: "boolean",
              default: !1
            },
            placeholder: {
              type: "string"
            },
            direction: {
              type: "string",
              enum: ["ltr", "rtl"]
            }
          },
          supports: {
            anchor: !0,
            className: !1,
            color: {
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            __experimentalSelector: "p",
            __unstablePasteTextInline: !0
          },
          editorStyle: "wp-block-paragraph-editor",
          style: "wp-block-paragraph"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: y.paragraph,
          example: {
            attributes: {
              content: (0, _.__)("In a village of La Mancha, the name of which I have no desire to call to mind, there lived not long since one of those gentlemen that keep a lance in the lance-rack, an old buckler, a lean hack, and a greyhound for coursing."),
              style: {
                typography: {
                  fontSize: 28
                }
              },
              dropCap: !0
            }
          },
          __experimentalLabel: function __experimentalLabel(l, s) {
            var c = s.context;

            if ("accessibility" === c) {
              var _s21 = l.content;
              return (0, v.isEmpty)(_s21) ? (0, _.__)("Empty") : _s21;
            }
          },
          transforms: C.default,
          deprecated: k.default,
          merge: function merge(l, s) {
            return {
              content: (l.content || "") + (s.content || "")
            };
          },
          edit: E.default,
          save: w.default
        };
        s.settings = T;
      },
      8593: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.align,
              m = s.content,
              k = s.dropCap,
              E = s.direction,
              w = (0, _.default)(_defineProperty({
            "has-drop-cap": k
          }, "has-text-align-".concat(c), c));
          return (0, v.createElement)("p", y.useBlockProps.save({
            className: w,
            dir: E
          }), (0, v.createElement)(y.RichText.Content, {
            value: m
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      7309: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var _apiVersion$name$titl9 = {
          apiVersion: 2,
          name: "core/paragraph",
          title: "Paragraph",
          category: "text",
          description: "Start with the building block of all narrative.",
          keywords: ["text"],
          textdomain: "default",
          attributes: {
            align: {
              type: "string"
            },
            content: {
              type: "string",
              source: "html",
              selector: "p",
              default: "",
              __experimentalRole: "content"
            },
            dropCap: {
              type: "boolean",
              default: !1
            },
            placeholder: {
              type: "string"
            },
            direction: {
              type: "string",
              enum: ["ltr", "rtl"]
            }
          },
          supports: {
            anchor: !0,
            className: !1,
            color: {
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            __experimentalSelector: "p",
            __unstablePasteTextInline: !0
          },
          editorStyle: "wp-block-paragraph-editor",
          style: "wp-block-paragraph"
        },
            v = _apiVersion$name$titl9.name;
        var _ = {
          from: [{
            type: "raw",
            priority: 20,
            selector: "p",
            schema: function schema(l) {
              var s = l.phrasingContentSchema,
                  c = l.isPaste;
              return {
                p: {
                  children: s,
                  attributes: c ? [] : ["style", "id"]
                }
              };
            },
            transform: function transform(l) {
              var s = (0, m.getBlockAttributes)(v, l.outerHTML),
                  _ref260 = l.style || {},
                  c = _ref260.textAlign;

              return "left" !== c && "center" !== c && "right" !== c || (s.align = c), (0, m.createBlock)(v, s);
            }
          }]
        };
        s.default = _;
      },
      9185: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(1326);

        var _default = function _default(l) {
          var s = l.attributes,
              c = l.clientId;

          var y = (0, v.useSelect)(function (l) {
            return l(_.store).__experimentalGetParsedPattern(s.slug);
          }, [s.slug]),
              _ref261 = (0, v.useDispatch)(_.store),
              k = _ref261.replaceBlocks,
              E = _ref261.__unstableMarkNextChangeAsNotPersistent;

          (0, m.useEffect)(function () {
            null != y && y.blocks && (E(), k(c, y.blocks));
          }, [null == y ? void 0 : y.blocks]);
          var w = (0, _.useBlockProps)();
          return (0, m.createElement)("div", w);
        };

        s.default = _default;
      },
      9202: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;
        var v = m(c(9185));
        var _ = {
          apiVersion: 2,
          name: "core/pattern",
          title: "Pattern",
          category: "theme",
          description: "Show a block pattern.",
          supports: {
            html: !1,
            inserter: !1
          },
          textdomain: "default",
          attributes: {
            slug: {
              type: "string"
            }
          }
        };
        s.metadata = _;
        var y = _.name;
        s.name = y;
        var k = {
          edit: v.default
        };
        s.settings = k;
      },
      526: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = m(c(2703)),
            k = c(1326),
            E = c(4892),
            w = c(8467),
            C = c(6756),
            S = c(1295);

        var P = function PostAuthorEdit(l) {
          var s = l.isSelected,
              _l$context2 = l.context,
              c = _l$context2.postType,
              m = _l$context2.postId,
              P = _l$context2.queryId,
              T = l.attributes,
              B = l.setAttributes;

          var z = Number.isFinite(P),
              _ref262 = (0, w.useSelect)(function (l) {
            var s;

            var _l55 = l(S.store),
                v = _l55.getEditedEntityRecord,
                _ = _l55.getUser,
                y = _l55.getUsers,
                k = null === (s = v("postType", c, m)) || void 0 === s ? void 0 : s.author;

            return {
              authorId: k,
              authorDetails: k ? _(k) : null,
              authors: y({
                who: "authors"
              })
            };
          }, [c, m]),
              L = _ref262.authorId,
              V = _ref262.authorDetails,
              A = _ref262.authors,
              _ref263 = (0, w.useDispatch)(S.store),
              R = _ref263.editEntityRecord,
              O = T.textAlign,
              D = T.showAvatar,
              F = T.showBio,
              G = T.byline,
              q = [];

          V && (0, _.forEach)(V.avatar_urls, function (l, s) {
            q.push({
              value: s,
              label: "".concat(s, " x ").concat(s)
            });
          });
          var W = (0, k.useBlockProps)({
            className: (0, y.default)(_defineProperty({}, "has-text-align-".concat(O), O))
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, C.__)("Author Settings")
          }, !z && !(null == A || !A.length) && (0, v.createElement)(E.SelectControl, {
            label: (0, C.__)("Author"),
            value: L,
            options: A.map(function (l) {
              var s = l.id,
                  c = l.name;
              return {
                value: s,
                label: c
              };
            }),
            onChange: function onChange(l) {
              R("postType", c, m, {
                author: l
              });
            }
          }), (0, v.createElement)(E.ToggleControl, {
            label: (0, C.__)("Show avatar"),
            checked: D,
            onChange: function onChange() {
              return B({
                showAvatar: !D
              });
            }
          }), D && (0, v.createElement)(E.SelectControl, {
            label: (0, C.__)("Avatar size"),
            value: T.avatarSize,
            options: q,
            onChange: function onChange(l) {
              B({
                avatarSize: Number(l)
              });
            }
          }), (0, v.createElement)(E.ToggleControl, {
            label: (0, C.__)("Show bio"),
            checked: F,
            onChange: function onChange() {
              return B({
                showBio: !F
              });
            }
          }))), (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: O,
            onChange: function onChange(l) {
              B({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", W, D && V && (0, v.createElement)("div", {
            className: "wp-block-post-author__avatar"
          }, (0, v.createElement)("img", {
            width: T.avatarSize,
            src: V.avatar_urls[T.avatarSize],
            alt: V.name
          })), (0, v.createElement)("div", {
            className: "wp-block-post-author__content"
          }, (!k.RichText.isEmpty(G) || s) && (0, v.createElement)(k.RichText, {
            className: "wp-block-post-author__byline",
            multiline: !1,
            "aria-label": (0, C.__)("Post author byline text"),
            placeholder: (0, C.__)("Write byline…"),
            value: G,
            onChange: function onChange(l) {
              return B({
                byline: l
              });
            }
          }), (0, v.createElement)("p", {
            className: "wp-block-post-author__name"
          }, (null == V ? void 0 : V.name) || (0, C.__)("Post Author")), F && (0, v.createElement)("p", {
            className: "wp-block-post-author__bio"
          }, null == V ? void 0 : V.description))));
        };

        s.default = P;
      },
      5089: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(526)),
            _ = c(5303);

        var y = {
          apiVersion: 2,
          name: "core/post-author",
          title: "Post Author",
          category: "theme",
          description: "Add the author of this post.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            avatarSize: {
              type: "number",
              default: 48
            },
            showAvatar: {
              type: "boolean",
              default: !0
            },
            showBio: {
              type: "boolean"
            },
            byline: {
              type: "string"
            }
          },
          usesContext: ["postType", "postId", "queryId"],
          supports: {
            html: !1,
            spacing: {
              margin: !0,
              padding: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            color: {
              gradients: !0,
              link: !0,
              __experimentalDuotone: ".wp-block-post-author__avatar img"
            }
          },
          editorStyle: "wp-block-post-author-editor",
          style: "wp-block-post-author"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: _.postAuthor,
          edit: v.default
        };
        s.settings = E;
      },
      3784: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Edit(l) {
          var s = l.attributes.commentId,
              c = l.setAttributes;

          var _ref265 = (0, m.useState)(s),
              _ref266 = _slicedToArray2(_ref265, 2),
              C = _ref266[0],
              S = _ref266[1],
              P = (0, k.useBlockProps)(),
              T = (0, k.useInnerBlocksProps)(P, {
            template: w,
            allowedBlocks: E
          });

          if (!s) return (0, m.createElement)("div", P, (0, m.createElement)(_.Placeholder, {
            icon: y.blockDefault,
            label: (0, v._x)("Post Comment", "block title"),
            instructions: (0, v.__)("To show a comment, input the comment ID.")
          }, (0, m.createElement)(_.TextControl, {
            value: s,
            onChange: function onChange(l) {
              return S(parseInt(l));
            }
          }), (0, m.createElement)(_.Button, {
            variant: "primary",
            onClick: function onClick() {
              c({
                commentId: C
              });
            }
          }, (0, v.__)("Save"))));
          return (0, m.createElement)("div", T);
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(5303),
            k = c(1326);

        var E = ["core/comment-author-avatar", "core/comment-author-name", "core/comment-content", "core/comment-date", "core/comment-edit-link", "core/comment-reply-link"],
            w = [["core/comment-author-avatar"], ["core/comment-author-name"], ["core/comment-date"], ["core/comment-content"], ["core/comment-reply-link"], ["core/comment-edit-link"]];
      },
      5076: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(3784)),
            y = m(c(1779));

        var k = {
          apiVersion: 2,
          name: "core/post-comment",
          title: "Post Comment (deprecated)",
          category: "theme",
          description: "This block is deprecated. Please use the Comments Query Loop block instead.",
          textdomain: "default",
          attributes: {
            commentId: {
              type: "number"
            }
          },
          providesContext: {
            commentId: "commentId"
          },
          supports: {
            html: !1,
            inserter: !1
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.comment,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      1779: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          var l = v.useBlockProps.save(),
              s = v.useInnerBlocksProps.save(l);
          return (0, m.createElement)("div", s);
        };
        var m = c(1753),
            v = c(1326);
      },
      1649: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostCommentsCountEdit(l) {
          var s = l.attributes,
              c = l.context,
              m = l.setAttributes;

          var C = s.textAlign,
              S = c.postId,
              _ref267 = (0, v.useState)(),
              _ref268 = _slicedToArray2(_ref267, 2),
              P = _ref268[0],
              T = _ref268[1],
              B = (0, y.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(C), C))
          });

          return (0, v.useEffect)(function () {
            if (!S) return;
            var l = S;
            (0, k.default)({
              path: (0, E.addQueryArgs)("/wp/v2/comments", {
                post: S
              }),
              parse: !1
            }).then(function (s) {
              l === S && T(s.headers.get("X-WP-Total"));
            });
          }, [S]), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(y.AlignmentControl, {
            value: C,
            onChange: function onChange(l) {
              m({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", B, S && void 0 !== P ? P : (0, v.createElement)(y.Warning, null, (0, w.__)("Post Comments Count block: post not found."))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = m(c(507)),
            E = c(904),
            w = c(6756);
      },
      2549: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(1649));

        var y = {
          apiVersion: 2,
          name: "core/post-comments-count",
          title: "Post Comments Count",
          category: "theme",
          description: "Display a post's comments count.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          usesContext: ["postId"],
          supports: {
            html: !1,
            color: {
              gradients: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postCommentsCount,
          edit: _.default
        };
        s.settings = E;
      },
      8066: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostCommentsFormEdit(l) {
          var s = l.attributes,
              c = l.context,
              m = l.setAttributes;

          var w = s.textAlign,
              C = c.postId,
              S = c.postType,
              _ref270 = (0, k.useEntityProp)("postType", S, "comment_status", C),
              _ref271 = _slicedToArray2(_ref270, 1),
              P = _ref271[0],
              T = (0, y.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(w), w))
          });

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(y.AlignmentControl, {
            value: w,
            onChange: function onChange(l) {
              m({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", T, !P && (0, v.createElement)(y.Warning, null, (0, E.__)("Post Comments Form block: comments are not enabled for this post type.")), "open" !== P && (0, v.createElement)(y.Warning, null, (0, E.__)("Post Comments Form block: comments to this post are not allowed.")), "open" === P && (0, E.__)("Post Comments Form")));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(1295),
            E = c(6756);
      },
      3451: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8066));

        var y = {
          apiVersion: 2,
          name: "core/post-comments-form",
          title: "Post Comments Form",
          category: "theme",
          description: "Display a post's comments form.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          usesContext: ["postId", "postType"],
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          style: ["wp-block-post-comments-form", "wp-block-buttons", "wp-block-button"]
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postCommentsForm,
          edit: _.default
        };
        s.settings = E;
      },
      685: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(8467),
            E = m(c(507)),
            w = c(904),
            C = c(6756),
            S = c(1295);

        var P = function PostCommentsLinkEdit(l) {
          var s = l.context,
              c = l.attributes,
              m = l.setAttributes;

          var P = c.textAlign,
              T = s.postType,
              B = s.postId,
              _ref273 = (0, v.useState)(),
              _ref274 = _slicedToArray2(_ref273, 2),
              z = _ref274[0],
              L = _ref274[1],
              V = (0, y.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(P), P))
          });

          (0, v.useEffect)(function () {
            if (!B) return;
            var l = B;
            (0, E.default)({
              path: (0, w.addQueryArgs)("/wp/v2/comments", {
                post: B
              }),
              parse: !1
            }).then(function (s) {
              l === B && L(s.headers.get("X-WP-Total"));
            });
          }, [B]);
          var A = (0, k.useSelect)(function (l) {
            return l(S.store).getEditedEntityRecord("postType", T, B);
          }, [T, B]);
          if (!A) return null;
          var R = A.link;
          var O;

          if (void 0 !== z) {
            var _l56 = parseInt(z);

            O = 0 === _l56 ? (0, C.__)("No comments") : (0, C.sprintf)((0, C._n)("%s comment", "%s comments", _l56), _l56.toLocaleString());
          }

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(y.AlignmentControl, {
            value: P,
            onChange: function onChange(l) {
              m({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", V, R && void 0 !== O ? (0, v.createElement)("a", {
            href: R + "#comments",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, O) : (0, v.createElement)(y.Warning, null, (0, C.__)("Post Comments Link block: post not found."))));
        };

        s.default = P;
      },
      3272: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(685));

        var y = {
          apiVersion: 2,
          name: "core/post-comments-link",
          title: "Post Comments Link",
          category: "theme",
          description: "Displays the link to the current post comments.",
          textdomain: "default",
          usesContext: ["postType", "postId"],
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            html: !1,
            color: {
              link: !0,
              text: !1
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          edit: _.default,
          icon: v.postCommentsCount
        };
        s.settings = E;
      },
      6633: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostCommentsEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.context;
          var y = m.postType,
              w = m.postId,
              C = s.textAlign,
              S = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(C), C))
          });
          if (!y || !w) return (0, v.createElement)("div", S, (0, v.createElement)(k.Warning, null, (0, E.__)("Post comments block: no post found.")));
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: C,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", S, (0, v.createElement)(PostCommentsDisplay, {
            postId: w
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(8467),
            k = c(1326),
            E = c(6756),
            w = c(1295);

        function PostCommentsDisplay(l) {
          var s = l.postId;
          return (0, y.useSelect)(function (l) {
            var c = l(w.store).getEntityRecords("root", "comment", {
              post: s
            });
            return c && c.length ? c.map(function (l) {
              return (0, v.createElement)(v.RawHTML, {
                className: "wp-block-post-comments__comment",
                key: l.id
              }, l.content.rendered);
            }) : (0, E.__)("No comments.");
          }, [s]);
        }
      },
      2623: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6633));

        var y = {
          apiVersion: 2,
          name: "core/post-comments",
          title: "Post Comments",
          category: "theme",
          description: "Display a post's comments.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          usesContext: ["postId", "postType"],
          supports: {
            html: !1,
            align: ["wide", "full"],
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            color: {
              gradients: !0,
              link: !0
            }
          },
          style: ["wp-block-post-comments", "wp-block-buttons", "wp-block-button"]
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postComments,
          edit: _.default
        };
        s.settings = E;
      },
      8016: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostContentEdit(l) {
          var s = l.context,
              c = l.attributes;

          var v = s.postId,
              _ = s.postType,
              _c$layout = c.layout,
              k = _c$layout === void 0 ? {} : _c$layout,
              _ref277 = (0, y.__experimentalUseNoRecursiveRenders)(v),
              _ref278 = _slicedToArray2(_ref277, 2),
              E = _ref278[0],
              w = _ref278[1];

          if (v && _ && E) return (0, m.createElement)(RecursionError, null);
          return (0, m.createElement)(w, null, v && _ ? (0, m.createElement)(Content, {
            context: s,
            layout: k
          }) : (0, m.createElement)(Placeholder, null));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(8467),
            y = c(1326),
            k = c(1295),
            E = c(2803);

        function ReadOnlyContent(l) {
          var s = l.userCanEdit,
              c = l.postType,
              _ = l.postId;

          var _ref279 = (0, k.useEntityProp)("postType", c, "content", _),
              _ref280 = _slicedToArray2(_ref279, 3),
              E = _ref280[2],
              w = (0, y.useBlockProps)();

          return null != E && E.protected && !s ? (0, m.createElement)("div", w, (0, m.createElement)(y.Warning, null, (0, v.__)("This content is password protected."))) : (0, m.createElement)("div", w, (0, m.createElement)(m.RawHTML, {
            key: "html"
          }, null == E ? void 0 : E.rendered));
        }

        function EditableContent(l) {
          var s = l.layout,
              _l$context3 = l.context,
              c = _l$context3 === void 0 ? {} : _l$context3;

          var v = c.postType,
              E = c.postId,
              w = (0, _.useSelect)(function (l) {
            var s;

            var _l57 = l(y.store),
                c = _l57.getSettings;

            return null === (s = c()) || void 0 === s ? void 0 : s.supportsLayout;
          }, []),
              C = (0, y.useSetting)("layout") || {},
              S = s && s.inherit ? C : s,
              _ref281 = (0, k.useEntityBlockEditor)("postType", v, {
            id: E
          }),
              _ref282 = _slicedToArray2(_ref281, 3),
              P = _ref282[0],
              T = _ref282[1],
              B = _ref282[2],
              z = (0, y.useInnerBlocksProps)((0, y.useBlockProps)({
            className: "entry-content"
          }), {
            value: P,
            onInput: T,
            onChange: B,
            __experimentalLayout: w ? S : void 0
          });

          return (0, m.createElement)("div", z);
        }

        function Content(l) {
          var _l$context4 = l.context;
          _l$context4 = _l$context4 === void 0 ? {} : _l$context4;

          var s = _l$context4.queryId,
              c = _l$context4.postType,
              v = _l$context4.postId,
              _ = Number.isFinite(s),
              y = (0, E.useCanEditEntity)("postType", c, v);

          return y && !_ ? (0, m.createElement)(EditableContent, l) : (0, m.createElement)(ReadOnlyContent, {
            userCanEdit: y,
            postType: c,
            postId: v
          });
        }

        function Placeholder() {
          var l = (0, y.useBlockProps)();
          return (0, m.createElement)("div", l, (0, m.createElement)("p", null, (0, v.__)("Post Content")));
        }

        function RecursionError() {
          var l = (0, y.useBlockProps)();
          return (0, m.createElement)("div", l, (0, m.createElement)(y.Warning, null, (0, v.__)("Block cannot be rendered inside itself.")));
        }
      },
      8558: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8016));

        var y = {
          apiVersion: 2,
          name: "core/post-content",
          title: "Post Content",
          category: "theme",
          description: "Displays the contents of a post or page.",
          textdomain: "default",
          usesContext: ["postId", "postType", "queryId"],
          supports: {
            align: ["wide", "full"],
            html: !1,
            __experimentalLayout: !0
          },
          editorStyle: "wp-block-post-content-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postContent,
          edit: _.default
        };
        s.settings = E;
      },
      4201: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            textAlign: {
              type: "string"
            },
            format: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      8260: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostDateEdit(l) {
          var _l$attributes16 = l.attributes,
              s = _l$attributes16.textAlign,
              c = _l$attributes16.format,
              m = _l$attributes16.isLink,
              _l$context5 = l.context,
              T = _l$context5.postId,
              B = _l$context5.postType,
              z = _l$context5.queryId,
              L = l.setAttributes;

          var V = Number.isFinite(z),
              _ref283 = (0, y.useEntityProp)("root", "site", "date_format"),
              _ref284 = _slicedToArray2(_ref283, 1),
              A = _ref284[0],
              _ref285 = (0, y.useEntityProp)("postType", B, "date", T),
              _ref286 = _slicedToArray2(_ref285, 2),
              R = _ref286[0],
              O = _ref286[1],
              D = (0, k.__experimentalGetSettings)(),
              F = /a(?!\\)/i.test(D.formats.time.toLowerCase().replace(/\\\\/g, "").split("").reverse().join("")),
              G = Object.values(D.formats).map(function (l) {
            return {
              key: l,
              name: (0, k.dateI18n)(l, R)
            };
          }),
              q = c || A || D.formats.date,
              W = (0, E.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(s), s))
          }),
              U = (0, v.useRef)();

          var $ = R ? (0, v.createElement)("time", {
            dateTime: (0, k.dateI18n)("c", R),
            ref: U
          }, (0, k.dateI18n)(q, R)) : (0, C.__)("Post Date");
          m && R && ($ = (0, v.createElement)("a", {
            href: "#post-date-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, $));
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.BlockControls, {
            group: "block"
          }, (0, v.createElement)(E.AlignmentControl, {
            value: s,
            onChange: function onChange(l) {
              L({
                textAlign: l
              });
            }
          }), R && !V && (0, v.createElement)(w.ToolbarGroup, null, (0, v.createElement)(w.Dropdown, {
            popoverProps: {
              anchorRef: U.current
            },
            renderContent: function renderContent() {
              return (0, v.createElement)(w.DateTimePicker, {
                currentDate: R,
                onChange: O,
                is12Hour: F
              });
            },
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, v.createElement)(w.ToolbarButton, {
                "aria-expanded": s,
                icon: S.edit,
                title: (0, C.__)("Change Date"),
                onClick: c,
                onKeyDown: function onKeyDown(l) {
                  s || l.keyCode !== P.DOWN || (l.preventDefault(), c());
                }
              });
            }
          }))), (0, v.createElement)(E.InspectorControls, null, (0, v.createElement)(w.PanelBody, {
            title: (0, C.__)("Format settings")
          }, (0, v.createElement)(w.CustomSelectControl, {
            hideLabelFromVision: !0,
            label: (0, C.__)("Date Format"),
            options: G,
            onChange: function onChange(l) {
              var s = l.selectedItem;
              return L({
                format: s.key
              });
            },
            value: G.find(function (l) {
              return l.key === q;
            })
          })), (0, v.createElement)(w.PanelBody, {
            title: (0, C.__)("Link settings")
          }, (0, v.createElement)(w.ToggleControl, {
            label: (0, C.sprintf)((0, C.__)("Link to %s"), B),
            onChange: function onChange() {
              return L({
                isLink: !m
              });
            },
            checked: m
          }))), (0, v.createElement)("div", W, $));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1295),
            k = c(7126),
            E = c(1326),
            w = c(4892),
            C = c(6756),
            S = c(5303),
            P = c(9880);
      },
      4479: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8260)),
            y = m(c(4201));

        var k = {
          apiVersion: 2,
          name: "core/post-date",
          title: "Post Date",
          category: "theme",
          description: "Add the date of this post.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            format: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !1
            }
          },
          usesContext: ["postId", "postType", "queryId"],
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.postDate,
          edit: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      3947: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostExcerptEditor(l) {
          var _l$attributes17 = l.attributes,
              s = _l$attributes17.textAlign,
              c = _l$attributes17.moreText,
              m = _l$attributes17.showMoreOnNewLine,
              S = l.setAttributes,
              P = l.isSelected,
              _l$context6 = l.context,
              T = _l$context6.postId,
              B = _l$context6.postType,
              z = _l$context6.queryId;

          var L = Number.isFinite(z),
              V = (0, C.useCanEditEntity)("postType", B, T),
              A = V && !L,
              _ref288 = (0, y.useEntityProp)("postType", B, "excerpt", T),
              _ref289 = _slicedToArray2(_ref288, 3),
              R = _ref289[0],
              O = _ref289[1],
              _ref289$ = _ref289[2];

          _ref289$ = _ref289$ === void 0 ? {} : _ref289$;
          var D = _ref289$.rendered,
              F = _ref289$.protected,
              G = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(s), s))
          }),
              q = (0, v.useMemo)(function () {
            if (!D) return "";
            var l = new window.DOMParser().parseFromString(D, "text/html");
            return l.body.textContent || l.body.innerText || "";
          }, [D]);
          if (!B || !T) return (0, v.createElement)("div", G, (0, w.__)("Post Excerpt"));
          if (F && !V) return (0, v.createElement)("div", G, (0, v.createElement)(k.Warning, null, (0, w.__)("There is no excerpt because this is a protected post.")));
          var W = (0, v.createElement)(k.RichText, {
            className: "wp-block-post-excerpt__more-link",
            tagName: "a",
            "aria-label": (0, w.__)('"Read more" link text'),
            placeholder: (0, w.__)('Add "read more" link text'),
            value: c,
            onChange: function onChange(l) {
              return S({
                moreText: l
              });
            },
            withoutInteractiveFormatting: !0
          }),
              U = A ? (0, v.createElement)(k.RichText, {
            className: !m && "wp-block-post-excerpt__excerpt is-inline",
            "aria-label": (0, w.__)("Post excerpt text"),
            value: R || q || (P ? "" : (0, w.__)("No post excerpt found")),
            onChange: O
          }) : D && (0, v.createElement)(E.Disabled, null, (0, v.createElement)(v.RawHTML, {
            key: "html"
          }, D)) || (0, w.__)("No post excerpt found");
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, null, (0, v.createElement)(k.AlignmentToolbar, {
            value: s,
            onChange: function onChange(l) {
              return S({
                textAlign: l
              });
            }
          })), (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, w.__)("Post Excerpt Settings")
          }, (0, v.createElement)(E.ToggleControl, {
            label: (0, w.__)("Show link on new line"),
            checked: m,
            onChange: function onChange(l) {
              return S({
                showMoreOnNewLine: l
              });
            }
          }))), (0, v.createElement)("div", G, U, !m && " ", m ? (0, v.createElement)("p", {
            className: "wp-block-post-excerpt__more-text"
          }, W) : W));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1295),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(2803);
      },
      4512: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(3947));

        var y = {
          apiVersion: 2,
          name: "core/post-excerpt",
          title: "Post Excerpt",
          category: "theme",
          description: "Display a post's excerpt.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            moreText: {
              type: "string"
            },
            showMoreOnNewLine: {
              type: "boolean",
              default: !0
            }
          },
          usesContext: ["postId", "postType", "queryId"],
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              margin: !0,
              padding: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          editorStyle: "wp-block-post-excerpt-editor",
          style: "wp-block-post-excerpt"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postExcerpt,
          edit: _.default
        };
        s.settings = E;
      },
      5506: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(4892),
            E = c(1326);

        var w = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.__experimentalToggleGroupControlOption, {
          value: "cover",
          label: (0, y._x)("Cover", "Scale option for Image dimension control")
        }), (0, v.createElement)(k.__experimentalToggleGroupControlOption, {
          value: "contain",
          label: (0, y._x)("Contain", "Scale option for Image dimension control")
        }), (0, v.createElement)(k.__experimentalToggleGroupControlOption, {
          value: "fill",
          label: (0, y._x)("Fill", "Scale option for Image dimension control")
        })),
            C = {
          cover: (0, y.__)("Image is scaled and cropped to fill the entire space without being distorted."),
          contain: (0, y.__)("Image is scaled to fill the space without clipping nor distorting."),
          fill: (0, y.__)("Image will be stretched and distorted to completely fill the space.")
        };

        var _default = function _default(l) {
          var _l$attributes18 = l.attributes,
              s = _l$attributes18.width,
              c = _l$attributes18.height,
              m = _l$attributes18.scale,
              S = l.setAttributes;

          var P = (0, k.__experimentalUseCustomUnits)({
            availableUnits: (0, E.useSetting)("spacing.units") || ["px", "%", "vw", "em", "rem"]
          }),
              onDimensionChange = function onDimensionChange(l, s) {
            var c = parseFloat(s);
            isNaN(c) && s || S(_defineProperty({}, l, c < 0 ? "0" : s));
          },
              T = (0, y._x)("Scale", "Image scaling options");

          return (0, v.createElement)(k.PanelBody, {
            title: (0, y.__)("Dimensions")
          }, (0, v.createElement)(k.Flex, {
            justify: "space-between",
            className: (0, _.default)("block-library-post-featured-image-dimension-controls", {
              "scale-control-is-visible": !!c
            })
          }, (0, v.createElement)(k.FlexItem, null, (0, v.createElement)(k.__experimentalUnitControl, {
            label: (0, y.__)("Height"),
            labelPosition: "top",
            value: c || "",
            onChange: function onChange(l) {
              onDimensionChange("height", l);
            },
            units: P
          })), (0, v.createElement)(k.FlexItem, null, (0, v.createElement)(k.__experimentalUnitControl, {
            label: (0, y.__)("Width"),
            labelPosition: "top",
            value: s || "",
            onChange: function onChange(l) {
              onDimensionChange("width", l);
            },
            units: P
          }))), !!c && (0, v.createElement)(k.__experimentalToggleGroupControl, {
            label: T,
            value: m,
            help: C[m],
            onChange: function onChange(l) {
              S({
                scale: l
              });
            },
            isBlock: !0
          }, w));
        };

        s.default = _default;
      },
      8422: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostFeaturedImageEdit(l) {
          var s;
          var c = (0, E.useBlockProps)();
          if (null === (s = l.context) || void 0 === s || !s.postId) return (0, v.createElement)("div", c, L);
          return (0, v.createElement)(PostFeaturedImageDisplay, l);
        };

        var v = c(1753),
            _ = c(1295),
            y = c(8467),
            k = c(4892),
            E = c(1326),
            w = c(6756),
            C = c(5303),
            S = c(1666),
            P = c(8448),
            T = m(c(5506));

        var B = (0, v.createElement)(S.SVG, {
          className: "components-placeholder__illustration",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 60 60",
          preserveAspectRatio: "none"
        }, (0, v.createElement)(S.Path, {
          vectorEffect: "non-scaling-stroke",
          d: "M60 60 0 0"
        })),
            z = ["image"],
            L = (0, v.createElement)("div", {
          className: "wp-block-post-featured-image__placeholder"
        }, B);

        function PostFeaturedImageDisplay(l) {
          var s = l.attributes,
              c = l.setAttributes,
              _l$context7 = l.context,
              m = _l$context7.postId,
              S = _l$context7.postType,
              V = _l$context7.queryId;

          var A = Number.isFinite(V),
              R = s.isLink,
              O = s.height,
              D = s.width,
              F = s.scale,
              _ref291 = (0, _.useEntityProp)("postType", S, "featured_media", m),
              _ref292 = _slicedToArray2(_ref291, 2),
              G = _ref292[0],
              q = _ref292[1],
              W = (0, y.useSelect)(function (l) {
            return G && l(_.store).getMedia(G, {
              context: "view"
            });
          }, [G]),
              U = (0, E.useBlockProps)({
            style: {
              width: D,
              height: O
            }
          }),
              placeholder = function placeholder(l) {
            return (0, v.createElement)(k.Placeholder, {
              className: "block-editor-media-placeholder"
            }, B, l);
          },
              onSelectImage = function onSelectImage(l) {
            null != l && l.id && q(l.id);
          },
              _ref293 = (0, y.useDispatch)(P.store),
              $ = _ref293.createErrorNotice,
              onUploadError = function onUploadError(l) {
            $(l[2], {
              type: "snackbar"
            });
          };

          var Z;
          if (!G && A) return (0, v.createElement)("div", U, L);
          var K = (0, w.__)("Add a featured image");
          return Z = G ? W ? (0, v.createElement)("img", {
            src: W.source_url,
            alt: W.alt_text || (0, w.__)("Featured image"),
            style: {
              height: O,
              objectFit: O && F
            }
          }) : L : (0, v.createElement)(E.MediaPlaceholder, {
            onSelect: onSelectImage,
            accept: "image/*",
            allowedTypes: z,
            onError: onUploadError,
            placeholder: placeholder,
            mediaLibraryButton: function mediaLibraryButton(l) {
              var s = l.open;
              return (0, v.createElement)(k.Button, {
                icon: C.upload,
                variant: "primary",
                label: K,
                showTooltip: !0,
                tooltipPosition: "top center",
                onClick: function onClick() {
                  s();
                }
              });
            }
          }), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.InspectorControls, null, (0, v.createElement)(T.default, {
            attributes: s,
            setAttributes: c
          }), (0, v.createElement)(k.PanelBody, {
            title: (0, w.__)("Link settings")
          }, (0, v.createElement)(k.ToggleControl, {
            label: (0, w.sprintf)((0, w.__)("Link to %s"), S),
            onChange: function onChange() {
              return c({
                isLink: !R
              });
            },
            checked: R
          }))), !!W && !A && (0, v.createElement)(E.BlockControls, {
            group: "other"
          }, (0, v.createElement)(E.MediaReplaceFlow, {
            mediaId: G,
            mediaURL: W.source_url,
            allowedTypes: z,
            accept: "image/*",
            onSelect: onSelectImage,
            onError: onUploadError
          })), (0, v.createElement)("figure", U, Z));
        }
      },
      6850: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8422));

        var y = {
          apiVersion: 2,
          name: "core/post-featured-image",
          title: "Post Featured Image",
          category: "theme",
          description: "Display a post's featured image.",
          textdomain: "default",
          attributes: {
            isLink: {
              type: "boolean",
              default: !1
            },
            width: {
              type: "string"
            },
            height: {
              type: "string"
            },
            scale: {
              type: "string",
              default: "cover"
            }
          },
          usesContext: ["postId", "postType", "queryId"],
          supports: {
            align: ["left", "right", "center", "wide", "full"],
            color: {
              __experimentalDuotone: "img",
              text: !1,
              background: !1
            },
            html: !1,
            spacing: {
              margin: !0,
              padding: !0
            }
          },
          editorStyle: "wp-block-post-featured-image-editor",
          style: "wp-block-post-featured-image"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.postFeaturedImage,
          edit: _.default
        };
        s.settings = E;
      },
      5087: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostNavigationLinkEdit(l) {
          var _l$attributes19 = l.attributes,
              s = _l$attributes19.type,
              c = _l$attributes19.label,
              m = _l$attributes19.showTitle,
              w = _l$attributes19.textAlign,
              C = _l$attributes19.linkLabel,
              S = l.setAttributes;
          var P = "next" === s;
          var T = P ? (0, E.__)("Next") : (0, E.__)("Previous");
          m && (T = P ? (0, E.__)("Next: ") : (0, E.__)("Previous: "));
          var B = P ? (0, E.__)("Next post") : (0, E.__)("Previous post"),
              z = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(w), w))
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(y.PanelBody, null, (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display the title as a link"),
            help: (0, E.__)("If you have entered a custom label, it will be prepended before the title."),
            checked: !!m,
            onChange: function onChange() {
              return S({
                showTitle: !m
              });
            }
          }), m && (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Include the label as part of the link"),
            checked: !!C,
            onChange: function onChange() {
              return S({
                linkLabel: !C
              });
            }
          }))), (0, v.createElement)(k.BlockControls, null, (0, v.createElement)(k.AlignmentToolbar, {
            value: w,
            onChange: function onChange(l) {
              S({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", z, (0, v.createElement)(k.RichText, {
            tagName: "a",
            "aria-label": B,
            placeholder: T,
            value: c,
            allowedFormats: ["core/bold", "core/italic"],
            onChange: function onChange(l) {
              return S({
                label: l
              });
            }
          }), m && (0, v.createElement)("a", {
            href: "#post-navigation-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, E.__)("An example title"))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4892),
            k = c(1326),
            E = c(6756);
      },
      8619: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(5087)),
            _ = m(c(8866));

        var y = {
          apiVersion: 2,
          name: "core/post-navigation-link",
          title: "Post Navigation Link",
          category: "theme",
          description: "Displays the next or previous post link that is adjacent to the current post.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            },
            type: {
              type: "string",
              default: "next"
            },
            label: {
              type: "string"
            },
            showTitle: {
              type: "boolean",
              default: !1
            },
            linkLabel: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            reusable: !1,
            html: !1,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          edit: v.default,
          variations: _.default
        };
        s.settings = E;
      },
      8866: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756),
            v = c(5303);
        var _ = [{
          isDefault: !0,
          name: "post-next",
          title: (0, m.__)("Next post"),
          description: (0, m.__)("Displays the post link that follows the current post."),
          icon: v.next,
          attributes: {
            type: "next"
          },
          scope: ["inserter", "transform"]
        }, {
          name: "post-previous",
          title: (0, m.__)("Previous post"),
          description: (0, m.__)("Displays the post link that precedes the current post."),
          icon: v.previous,
          attributes: {
            type: "previous"
          },
          scope: ["inserter", "transform"]
        }];

        _.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            return l.type === s.type;
          });
        });

        var y = _;
        s.default = y;
      },
      9897: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostTemplateEdit(l) {
          var s = l.clientId,
              _l$context8 = l.context,
              _l$context8$query = _l$context8.query;
          _l$context8$query = _l$context8$query === void 0 ? {} : _l$context8$query;

          var c = _l$context8$query.perPage,
              m = _l$context8$query.offset,
              _l$context8$query$cat = _l$context8$query.categoryIds,
              _ = _l$context8$query$cat === void 0 ? [] : _l$context8$query$cat,
              P = _l$context8$query.postType,
              _l$context8$query$tag = _l$context8$query.tagIds,
              B = _l$context8$query$tag === void 0 ? [] : _l$context8$query$tag,
              z = _l$context8$query.order,
              L = _l$context8$query.orderBy,
              V = _l$context8$query.author,
              A = _l$context8$query.search,
              R = _l$context8$query.exclude,
              O = _l$context8$query.sticky,
              D = _l$context8$query.inherit,
              _l$context8$queryCont = _l$context8.queryContext,
              F = _l$context8$queryCont === void 0 ? [{
            page: 1
          }] : _l$context8$queryCont,
              G = _l$context8.templateSlug,
              _l$context8$displayLa = _l$context8.displayLayout;

          _l$context8$displayLa = _l$context8$displayLa === void 0 ? {} : _l$context8$displayLa;
          var _l$context8$displayLa2 = _l$context8$displayLa.type,
              q = _l$context8$displayLa2 === void 0 ? "flex" : _l$context8$displayLa2,
              _l$context8$displayLa3 = _l$context8$displayLa.columns,
              W = _l$context8$displayLa3 === void 0 ? 1 : _l$context8$displayLa3;

          var _F = _slicedToArray2(F, 1),
              U = _F[0].page,
              _ref295 = (0, v.useState)(),
              _ref296 = _slicedToArray2(_ref295, 2),
              $ = _ref296[0],
              Z = _ref296[1],
              _ref297 = (0, k.useSelect)(function (l) {
            var _l58 = l(S.store),
                v = _l58.getEntityRecords,
                _l59 = l(w.store),
                y = _l59.getBlocks,
                k = {
              offset: c ? c * (U - 1) + m : 0,
              categories: _,
              tags: B,
              order: z,
              orderby: L
            };

            return c && (k.per_page = c), V && (k.author = V), A && (k.search = A), null != R && R.length && (k.exclude = R), O && (k.sticky = "only" === O), D && null != G && G.startsWith("archive-") && (k.postType = G.replace("archive-", ""), P = k.postType), {
              posts: v("postType", P, k),
              blocks: y(s)
            };
          }, [c, U, m, _, B, z, L, s, V, A, P, R, O, D, G]),
              K = _ref297.posts,
              Q = _ref297.blocks,
              Y = (0, v.useMemo)(function () {
            return null == K ? void 0 : K.map(function (l) {
              return {
                postType: l.type,
                postId: l.id
              };
            });
          }, [K]),
              X = "flex" === q && W > 1,
              J = (0, w.useBlockProps)({
            className: (0, y.default)(_defineProperty({
              "is-flex-container": X
            }, "columns-".concat(W), X))
          });

          if (!K) return (0, v.createElement)("p", J, (0, v.createElement)(C.Spinner, null));
          if (!K.length) return (0, v.createElement)("p", J, " ", (0, E.__)("No results found."));
          return (0, v.createElement)("ul", J, Y && Y.map(function (l) {
            var s, c;
            return (0, v.createElement)(w.BlockContextProvider, {
              key: l.postId,
              value: l
            }, l.postId === ($ || (null === (s = Y[0]) || void 0 === s ? void 0 : s.postId)) ? (0, v.createElement)(PostTemplateInnerBlocks, null) : null, (0, v.createElement)(T, {
              blocks: Q,
              blockContextId: l.postId,
              setActiveBlockContextId: Z,
              isHidden: l.postId === ($ || (null === (c = Y[0]) || void 0 === c ? void 0 : c.postId))
            }));
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(8467),
            E = c(6756),
            w = c(1326),
            C = c(4892),
            S = c(1295);

        var P = [["core/post-title"], ["core/post-date"], ["core/post-excerpt"]];

        function PostTemplateInnerBlocks() {
          var l = (0, w.useInnerBlocksProps)({}, {
            template: P
          });
          return (0, v.createElement)("li", l);
        }

        var T = (0, v.memo)(function PostTemplateBlockPreview(l) {
          var s = l.blocks,
              c = l.blockContextId,
              m = l.isHidden,
              y = l.setActiveBlockContextId;

          var k = (0, w.__experimentalUseBlockPreview)({
            blocks: s
          }),
              handleOnClick = function handleOnClick() {
            y(c);
          },
              E = {
            display: m ? "none" : void 0
          };

          return (0, v.createElement)("li", (0, _.default)({}, k, {
            tabIndex: 0,
            role: "button",
            onClick: handleOnClick,
            onKeyPress: handleOnClick,
            style: E
          }));
        });
      },
      2533: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(9897)),
            y = m(c(3776));

        var k = {
          apiVersion: 2,
          name: "core/post-template",
          title: "Post Template",
          category: "design",
          parent: ["core/query"],
          description: "Contains the block elements used to render a post, like the title, date, featured image, content or excerpt, and more.",
          textdomain: "default",
          usesContext: ["queryId", "query", "queryContext", "displayLayout", "templateSlug"],
          supports: {
            reusable: !1,
            html: !1,
            align: !0,
            __experimentalLayout: {
              allowEditing: !1
            }
          },
          style: "wp-block-post-template",
          editorStyle: "wp-block-post-template-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.layout,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      3776: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostTemplateSave() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      4861: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostTermsEdit(l) {
          var _ref300;

          var s;
          var c = l.attributes,
              m = l.context,
              P = l.setAttributes;

          var T = c.term,
              B = c.textAlign,
              z = c.separator,
              L = m.postId,
              V = m.postType,
              A = (0, E.useSelect)(function (l) {
            var s;
            if (!T) return {};

            var _l60 = l(C.store),
                c = _l60.getTaxonomy,
                m = c(T);

            return null != m && null !== (s = m.visibility) && void 0 !== s && s.publicly_queryable ? m : {};
          }, [T]),
              _ref299 = (0, S.default)({
            postId: L,
            postType: V,
            term: A
          }),
              R = _ref299.postTerms,
              O = _ref299.hasPostTerms,
              D = _ref299.isLoading,
              F = L && V,
              G = (0, y.useBlockProps)({
            className: (0, _.default)((_ref300 = {}, _defineProperty(_ref300, "has-text-align-".concat(B), B), _defineProperty(_ref300, "taxonomy-".concat(T), T), _ref300))
          });

          if (!F || !T) return (0, v.createElement)("div", G, (0, w.__)("Post Terms"));
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, null, (0, v.createElement)(y.AlignmentToolbar, {
            value: B,
            onChange: function onChange(l) {
              P({
                textAlign: l
              });
            }
          })), (0, v.createElement)(y.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, v.createElement)(k.TextControl, {
            autoComplete: "off",
            label: (0, w.__)("Separator"),
            value: z || "",
            onChange: function onChange(l) {
              P({
                separator: l
              });
            },
            help: (0, w.__)("Enter character(s) used to separate terms.")
          })), (0, v.createElement)("div", G, D && (0, v.createElement)(k.Spinner, null), !D && O && R.map(function (l) {
            return (0, v.createElement)("a", {
              key: l.id,
              href: l.link,
              onClick: function onClick(l) {
                return l.preventDefault();
              }
            }, l.name);
          }).reduce(function (l, s) {
            return (0, v.createElement)(v.Fragment, null, l, (0, v.createElement)("span", {
              className: "wp-block-post-terms__separator"
            }, z || " "), s);
          }), !D && !O && ((null == A || null === (s = A.labels) || void 0 === s ? void 0 : s.no_terms) || (0, w.__)("Term items not found."))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(4892),
            E = c(8467),
            w = c(6756),
            C = c(1295),
            S = m(c(2725));
      },
      815: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(4861)),
            _ = m(c(2919));

        var y = {
          apiVersion: 2,
          name: "core/post-terms",
          title: "Post Terms",
          category: "theme",
          description: "Post terms.",
          textdomain: "default",
          attributes: {
            term: {
              type: "string"
            },
            textAlign: {
              type: "string"
            },
            separator: {
              type: "string",
              default: ", "
            }
          },
          usesContext: ["postId", "postType"],
          supports: {
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              lineHeight: !0,
              fontSize: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          style: "wp-block-post-terms"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          variations: _.default,
          edit: v.default
        };
        s.settings = E;
      },
      2725: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function usePostTerms(l) {
          var s;
          var c = l.postId,
              _ = l.postType,
              y = l.term;

          var k = y.rest_base,
              E = y.slug,
              _ref301 = (0, m.useEntityProp)("postType", _, k, c),
              _ref302 = _slicedToArray2(_ref301, 1),
              w = _ref302[0];

          return (0, v.useSelect)(function (l) {
            var s;
            if (!(null == y || null === (s = y.visibility) || void 0 === s ? void 0 : s.publicly_queryable)) return {
              postTerms: [],
              _isLoading: !1,
              hasPostTerms: !1
            };
            var c;
            if (!w) return {
              isLoading: null == y || null === (c = y.postTerms) || void 0 === c ? void 0 : c.includes(_)
            };
            if (!w.length) return {
              isLoading: !1
            };

            var _l61 = l(m.store),
                v = _l61.getEntityRecords,
                k = _l61.isResolving,
                C = ["taxonomy", E, {
              include: w,
              context: "view"
            }],
                S = v.apply(void 0, C);

            return {
              postTerms: S,
              isLoading: k("getEntityRecords", C),
              hasPostTerms: !(null == S || !S.length)
            };
          }, [w, null == y || null === (s = y.visibility) || void 0 === s ? void 0 : s.publicly_queryable]);
        };
        var m = c(1295),
            v = c(8467);
      },
      2919: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756),
            v = c(5303);
        var _ = [{
          name: "category",
          title: (0, m.__)("Post Categories"),
          description: (0, m.__)("Display a post's categories."),
          icon: v.postCategories,
          isDefault: !0,
          attributes: {
            term: "category"
          },
          isActive: function isActive(l) {
            return "category" === l.term;
          }
        }, {
          name: "post_tag",
          title: (0, m.__)("Post Tags"),
          description: (0, m.__)("Display a post's tags."),
          icon: v.postCategories,
          attributes: {
            term: "post_tag"
          },
          isActive: function isActive(l) {
            return "post_tag" === l.term;
          }
        }];
        s.default = _;
      },
      4438: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            textAlign: {
              type: "string"
            },
            level: {
              type: "number",
              default: 2
            },
            isLink: {
              type: "boolean",
              default: !1
            },
            rel: {
              type: "string",
              attribute: "rel",
              default: ""
            },
            linkTarget: {
              type: "string",
              default: "_self"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      1058: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PostTitleEdit(l) {
          var _l$attributes20 = l.attributes,
              s = _l$attributes20.level,
              c = _l$attributes20.textAlign,
              m = _l$attributes20.isLink,
              T = _l$attributes20.rel,
              B = _l$attributes20.linkTarget,
              z = l.setAttributes,
              _l$context9 = l.context,
              L = _l$context9.postType,
              V = _l$context9.postId,
              A = _l$context9.queryId;

          var R = 0 === s ? "p" : "h" + s,
              O = Number.isFinite(A),
              D = (0, P.useCanEditEntity)("postType", L, V),
              _ref303 = (0, C.useEntityProp)("postType", L, "title", V),
              _ref304 = _slicedToArray2(_ref303, 3),
              _ref304$ = _ref304[0],
              F = _ref304$ === void 0 ? "" : _ref304$,
              G = _ref304[1],
              q = _ref304[2],
              _ref305 = (0, C.useEntityProp)("postType", L, "link", V),
              _ref306 = _slicedToArray2(_ref305, 1),
              W = _ref306[0],
              U = (0, k.useBlockProps)({
            className: (0, y.default)(_defineProperty({}, "has-text-align-".concat(c), c))
          });

          var $ = (0, v.createElement)(R, U, (0, w.__)("Post Title"));
          L && V && ($ = D && !O ? (0, v.createElement)(k.PlainText, (0, _.default)({
            tagName: R,
            placeholder: (0, w.__)("No Title"),
            value: F,
            onChange: G,
            __experimentalVersion: 2
          }, U)) : (0, v.createElement)(R, U, (0, v.createElement)(v.RawHTML, {
            key: "html"
          }, null == q ? void 0 : q.rendered)));
          m && L && V && ($ = D && !O ? (0, v.createElement)(R, U, (0, v.createElement)(k.PlainText, {
            tagName: "a",
            href: W,
            target: B,
            rel: T,
            placeholder: F.length ? null : (0, w.__)("No Title"),
            value: F,
            onChange: G,
            __experimentalVersion: 2
          })) : (0, v.createElement)(R, U, (0, v.createElement)("a", {
            href: W,
            target: B,
            rel: T,
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, v.createElement)(v.RawHTML, {
            key: "html"
          }, null == q ? void 0 : q.rendered))));
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(S.default, {
            selectedLevel: s,
            onChange: function onChange(l) {
              return z({
                level: l
              });
            }
          }), (0, v.createElement)(k.AlignmentControl, {
            value: c,
            onChange: function onChange(l) {
              z({
                textAlign: l
              });
            }
          })), (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, w.__)("Link settings")
          }, (0, v.createElement)(E.ToggleControl, {
            label: (0, w.__)("Make title a link"),
            onChange: function onChange() {
              return z({
                isLink: !m
              });
            },
            checked: m
          }), m && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.ToggleControl, {
            label: (0, w.__)("Open in new tab"),
            onChange: function onChange(l) {
              return z({
                linkTarget: l ? "_blank" : "_self"
              });
            },
            checked: "_blank" === B
          }), (0, v.createElement)(E.TextControl, {
            label: (0, w.__)("Link rel"),
            value: T,
            onChange: function onChange(l) {
              return z({
                rel: l
              });
            }
          })))), $);
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(1295),
            S = m(c(9855)),
            P = c(2803);
      },
      4873: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(1058)),
            y = m(c(4438));

        var k = {
          apiVersion: 2,
          name: "core/post-title",
          title: "Post Title",
          category: "theme",
          description: "Displays the title of a post, page, or any other content-type.",
          textdomain: "default",
          usesContext: ["postId", "postType", "queryId"],
          attributes: {
            textAlign: {
              type: "string"
            },
            level: {
              type: "number",
              default: 2
            },
            isLink: {
              type: "boolean",
              default: !1
            },
            rel: {
              type: "string",
              attribute: "rel",
              default: ""
            },
            linkTarget: {
              type: "string",
              default: "_self"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontWeight: !0,
              __experimentalFontStyle: !0,
              __experimentalTextTransform: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0,
                textTransform: !0
              }
            }
          },
          style: "wp-block-post-title"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.postTitle,
          edit: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      9842: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PreformattedEdit(l) {
          var s = l.attributes,
              c = l.mergeBlocks,
              m = l.setAttributes,
              E = l.onRemove,
              w = l.style;
          var C = s.content,
              S = (0, k.useBlockProps)({
            style: w
          });
          return (0, v.createElement)(k.RichText, (0, _.default)({
            tagName: "pre",
            identifier: "content",
            preserveWhiteSpace: !0,
            value: C,
            onChange: function onChange(l) {
              m({
                content: l
              });
            },
            onRemove: E,
            "aria-label": (0, y.__)("Preformatted text"),
            placeholder: (0, y.__)("Write preformatted text…"),
            onMerge: c
          }, S, {
            __unstablePastePlainText: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(6756),
            k = c(1326);
      },
      7268: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(9842)),
            k = m(c(9268)),
            E = m(c(9982));

        var w = {
          apiVersion: 2,
          name: "core/preformatted",
          title: "Preformatted",
          category: "text",
          description: "Add text that respects your spacing and tabs, and also allows styling.",
          textdomain: "default",
          attributes: {
            content: {
              type: "string",
              source: "html",
              selector: "pre",
              default: "",
              __unstablePreserveWhiteSpace: !0,
              __experimentalRole: "content"
            }
          },
          supports: {
            anchor: !0,
            color: {
              gradients: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          style: "wp-block-preformatted"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.preformatted,
          example: {
            attributes: {
              content: (0, v.__)("EXT. XANADU - FAINT DAWN - 1940 (MINIATURE)\nWindow, very small in the distance, illuminated.\nAll around this is an almost totally black screen. Now, as the camera moves slowly towards the window which is almost a postage stamp in the frame, other forms appear;")
            }
          },
          transforms: E.default,
          edit: y.default,
          save: k.default,
          merge: function merge(l, s) {
            return {
              content: l.content + s.content
            };
          }
        };
        s.settings = S;
      },
      9268: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.content;
          return (0, m.createElement)("pre", v.useBlockProps.save(), (0, m.createElement)(v.RichText.Content, {
            value: c
          }));
        };
        var m = c(1753),
            v = c(1326);
      },
      9982: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            blocks: ["core/code", "core/paragraph"],
            transform: function transform(l) {
              var s = l.content,
                  c = l.anchor;
              return (0, m.createBlock)("core/preformatted", {
                content: s,
                anchor: c
              });
            }
          }, {
            type: "raw",
            isMatch: function isMatch(l) {
              return "PRE" === l.nodeName && !(1 === l.children.length && "CODE" === l.firstChild.nodeName);
            },
            schema: function schema(l) {
              var s = l.phrasingContentSchema;
              return {
                pre: {
                  children: s
                }
              };
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/paragraph", l);
            }
          }, {
            type: "block",
            blocks: ["core/code"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/code", l);
            }
          }]
        };
        s.default = v;
      },
      9879: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockQuote = void 0;
        s.BlockQuote = "blockquote";
      },
      8364: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(1326),
            E = c(8467),
            w = c(1402);

        var C = {
          value: {
            type: "string",
            source: "html",
            selector: "blockquote",
            multiline: "p"
          },
          citation: {
            type: "string",
            source: "html",
            selector: "cite",
            default: ""
          },
          mainColor: {
            type: "string"
          },
          customMainColor: {
            type: "string"
          },
          textColor: {
            type: "string"
          },
          customTextColor: {
            type: "string"
          }
        };

        function parseBorderColor(l) {
          if (!l) return;
          var s = l.match(/border-color:([^;]+)[;]?/);
          return s && s[1] ? s[1] : void 0;
        }

        var S = [{
          attributes: _objectSpread({}, C),
          save: function save(l) {
            var s = l.attributes;
            var c = s.mainColor,
                m = s.customMainColor,
                E = s.customTextColor,
                C = s.textColor,
                S = s.value,
                P = s.citation,
                T = s.className;
            var B, z;

            if ((0, y.includes)(T, w.SOLID_COLOR_CLASS)) {
              var _l62 = (0, k.getColorClassName)("background-color", c);

              B = (0, _.default)(_defineProperty({
                "has-background": _l62 || m
              }, _l62, _l62)), z = {
                backgroundColor: _l62 ? void 0 : m
              };
            } else m && (z = {
              borderColor: m
            });

            var L = (0, k.getColorClassName)("color", C),
                V = (0, _.default)(_defineProperty({
              "has-text-color": C || E
            }, L, L)),
                A = L ? void 0 : {
              color: E
            };
            return (0, v.createElement)("figure", k.useBlockProps.save({
              className: B,
              style: z
            }), (0, v.createElement)("blockquote", {
              className: V,
              style: A
            }, (0, v.createElement)(k.RichText.Content, {
              value: S,
              multiline: !0
            }), !k.RichText.isEmpty(P) && (0, v.createElement)(k.RichText.Content, {
              tagName: "cite",
              value: P
            })));
          },
          migrate: function migrate(l) {
            var s = l.className,
                c = l.mainColor,
                m = l.customMainColor,
                v = l.customTextColor,
                _ = _objectWithoutProperties(l, _excluded13);

            var k = (0, y.includes)(s, w.SOLID_COLOR_CLASS);
            var E;
            return m && (E = k ? {
              color: {
                background: m
              }
            } : {
              border: {
                color: m
              }
            }), v && E && (E.color = _objectSpread(_objectSpread({}, E.color), {}, {
              text: v
            })), _objectSpread({
              className: s,
              backgroundColor: k ? c : void 0,
              borderColor: k ? void 0 : c,
              textAlign: k ? "left" : void 0,
              style: E
            }, _);
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            figureStyle: {
              source: "attribute",
              selector: "figure",
              attribute: "style"
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            var c = s.mainColor,
                m = s.customMainColor,
                E = s.textColor,
                C = s.customTextColor,
                S = s.value,
                P = s.citation,
                T = s.className,
                B = s.figureStyle;
            var z, L;

            if ((0, y.includes)(T, w.SOLID_COLOR_CLASS)) {
              var _l63 = (0, k.getColorClassName)("background-color", c);

              z = (0, _.default)(_defineProperty({
                "has-background": _l63 || m
              }, _l63, _l63)), L = {
                backgroundColor: _l63 ? void 0 : m
              };
            } else if (m) L = {
              borderColor: m
            };else if (c) {
              L = {
                borderColor: parseBorderColor(B)
              };
            }

            var V = (0, k.getColorClassName)("color", E),
                A = (E || C) && (0, _.default)("has-text-color", _defineProperty({}, V, V)),
                R = V ? void 0 : {
              color: C
            };
            return (0, v.createElement)("figure", {
              className: z,
              style: L
            }, (0, v.createElement)("blockquote", {
              className: A,
              style: R
            }, (0, v.createElement)(k.RichText.Content, {
              value: S,
              multiline: !0
            }), !k.RichText.isEmpty(P) && (0, v.createElement)(k.RichText.Content, {
              tagName: "cite",
              value: P
            })));
          },
          migrate: function migrate(l) {
            var s = l.className,
                c = l.figureStyle,
                m = l.mainColor,
                v = l.customMainColor,
                _ = l.customTextColor,
                k = _objectWithoutProperties(l, _excluded14);

            var E = (0, y.includes)(s, w.SOLID_COLOR_CLASS);
            var C;

            if (v && (C = E ? {
              color: {
                background: v
              }
            } : {
              border: {
                color: v
              }
            }), _ && C && (C.color = _objectSpread(_objectSpread({}, C.color), {}, {
              text: _
            })), !E && m && c) {
              var _l64 = parseBorderColor(c);

              if (_l64) return _objectSpread(_objectSpread({}, k), {}, {
                className: s,
                style: {
                  border: {
                    color: _l64
                  }
                }
              });
            }

            return _objectSpread({
              className: s,
              backgroundColor: E ? m : void 0,
              borderColor: E ? void 0 : m,
              textAlign: E ? "left" : void 0,
              style: C
            }, k);
          }
        }, {
          attributes: C,
          save: function save(l) {
            var s = l.attributes;
            var c = s.mainColor,
                m = s.customMainColor,
                C = s.textColor,
                S = s.customTextColor,
                P = s.value,
                T = s.citation,
                B = s.className;
            var z, L;
            if ((0, y.includes)(B, w.SOLID_COLOR_CLASS)) z = (0, k.getColorClassName)("background-color", c), z || (L = {
              backgroundColor: m
            });else if (m) L = {
              borderColor: m
            };else if (c) {
              var _l65 = (0, y.get)((0, E.select)(k.store).getSettings(), ["colors"], []);

              L = {
                borderColor: (0, k.getColorObjectByAttributeValues)(_l65, c).color
              };
            }
            var V = (0, k.getColorClassName)("color", C),
                A = C || S ? (0, _.default)("has-text-color", _defineProperty({}, V, V)) : void 0,
                R = V ? void 0 : {
              color: S
            };
            return (0, v.createElement)("figure", {
              className: z,
              style: L
            }, (0, v.createElement)("blockquote", {
              className: A,
              style: R
            }, (0, v.createElement)(k.RichText.Content, {
              value: P,
              multiline: !0
            }), !k.RichText.isEmpty(T) && (0, v.createElement)(k.RichText.Content, {
              tagName: "cite",
              value: T
            })));
          },
          migrate: function migrate(l) {
            var s = l.className,
                c = l.mainColor,
                m = l.customMainColor,
                v = l.customTextColor,
                _ = _objectWithoutProperties(l, _excluded15);

            var k = (0, y.includes)(s, w.SOLID_COLOR_CLASS);
            var E = {};
            return m && (E = k ? {
              color: {
                background: m
              }
            } : {
              border: {
                color: m
              }
            }), v && E && (E.color = _objectSpread(_objectSpread({}, E.color), {}, {
              text: v
            })), _objectSpread({
              className: s,
              backgroundColor: k ? c : void 0,
              borderColor: k ? void 0 : c,
              textAlign: k ? "left" : void 0,
              style: E
            }, _);
          }
        }, {
          attributes: _objectSpread({}, C),
          save: function save(l) {
            var s = l.attributes;
            var c = s.value,
                m = s.citation;
            return (0, v.createElement)("blockquote", null, (0, v.createElement)(k.RichText.Content, {
              value: c,
              multiline: !0
            }), !k.RichText.isEmpty(m) && (0, v.createElement)(k.RichText.Content, {
              tagName: "cite",
              value: m
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, C), {}, {
            citation: {
              type: "string",
              source: "html",
              selector: "footer"
            },
            align: {
              type: "string",
              default: "none"
            }
          }),
          save: function save(l) {
            var s = l.attributes;
            var c = s.value,
                m = s.citation,
                _ = s.align;
            return (0, v.createElement)("blockquote", {
              className: "align".concat(_)
            }, (0, v.createElement)(k.RichText.Content, {
              value: c,
              multiline: !0
            }), !k.RichText.isEmpty(m) && (0, v.createElement)(k.RichText.Content, {
              tagName: "footer",
              value: m
            }));
          }
        }];
        s.default = S;
      },
      9884: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(1326),
            E = c(6700),
            w = c(4812),
            C = c(9879);

        var S = function PullQuoteEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.isSelected,
              S = l.insertBlocksAfter;
          var P = s.textAlign,
              T = s.citation,
              B = s.value,
              z = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(P), P))
          }),
              L = !k.RichText.isEmpty(T) || m;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: P,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)(w.Figure, z, (0, v.createElement)(C.BlockQuote, null, (0, v.createElement)(k.RichText, {
            identifier: "value",
            multiline: !0,
            value: B,
            onChange: function onChange(l) {
              return c({
                value: l
              });
            },
            "aria-label": (0, y.__)("Pullquote text"),
            placeholder: (0, y.__)("Add quote"),
            textAlign: "center"
          }), L && (0, v.createElement)(k.RichText, {
            identifier: "citation",
            value: T,
            "aria-label": (0, y.__)("Pullquote citation text"),
            placeholder: (0, y.__)("Add citation"),
            onChange: function onChange(l) {
              return c({
                citation: l
              });
            },
            className: "wp-block-pullquote__citation",
            __unstableMobileNoFocusOnMount: !0,
            textAlign: "center",
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return S((0, E.createBlock)("core/paragraph"));
            }
          }))));
        };

        s.default = S;
      },
      4812: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.Figure = void 0;
        s.Figure = "figure";
      },
      1850: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(8364)),
            k = m(c(9884)),
            E = m(c(6715)),
            w = m(c(7748));

        var C = {
          apiVersion: 2,
          name: "core/pullquote",
          title: "Pullquote",
          category: "text",
          description: "Give special visual emphasis to a quote from your text.",
          textdomain: "default",
          attributes: {
            value: {
              type: "string",
              source: "html",
              selector: "blockquote",
              multiline: "p",
              __experimentalRole: "content"
            },
            citation: {
              type: "string",
              source: "html",
              selector: "cite",
              default: "",
              __experimentalRole: "content"
            },
            textAlign: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            align: ["left", "right", "wide", "full"],
            color: {
              gradients: !0,
              background: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0
              }
            },
            __experimentalBorder: {
              color: !0,
              radius: !0,
              style: !0,
              width: !0
            }
          },
          editorStyle: "wp-block-pullquote-editor",
          style: "wp-block-pullquote"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.pullquote,
          example: {
            attributes: {
              value: "<p>" + (0, v.__)("One of the hardest things to do in technology is disrupt yourself.") + "</p>",
              citation: (0, v.__)("Matt Mullenweg")
            }
          },
          transforms: w.default,
          edit: k.default,
          save: E.default,
          deprecated: y.default
        };
        s.settings = P;
      },
      6715: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.textAlign,
              m = s.citation,
              k = s.value,
              E = !y.RichText.isEmpty(m);
          return (0, v.createElement)("figure", y.useBlockProps.save({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c))
          }), (0, v.createElement)("blockquote", null, (0, v.createElement)(y.RichText.Content, {
            value: k,
            multiline: !0
          }), E && (0, v.createElement)(y.RichText.Content, {
            tagName: "cite",
            value: m
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      1402: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SOLID_COLOR_CLASS = void 0;
        s.SOLID_COLOR_CLASS = "is-style-solid-color";
      },
      7748: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(7060);
        var _ = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/pullquote", {
                value: (0, v.toHTMLString)({
                  value: (0, v.join)(l.map(function (l) {
                    var s = l.content;
                    return (0, v.create)({
                      html: s
                    });
                  }), "\u2028"),
                  multilineTag: "p"
                }),
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/heading"],
            transform: function transform(l) {
              var s = l.content,
                  c = l.anchor;
              return (0, m.createBlock)("core/pullquote", {
                value: "<p>".concat(s, "</p>"),
                anchor: c
              });
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation;
              var _ = [];
              return s && "<p></p>" !== s && _.push.apply(_, _toConsumableArray((0, v.split)((0, v.create)({
                html: s,
                multilineTag: "p"
              }), "\u2028").map(function (l) {
                return (0, m.createBlock)("core/paragraph", {
                  content: (0, v.toHTMLString)({
                    value: l
                  })
                });
              }))), c && "<p></p>" !== c && _.push((0, m.createBlock)("core/paragraph", {
                content: c
              })), 0 === _.length ? (0, m.createBlock)("core/paragraph", {
                content: ""
              }) : _;
            }
          }, {
            type: "block",
            blocks: ["core/heading"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation,
                  _ = _objectWithoutProperties(l, _excluded16);

              if ("<p></p>" === s) return (0, m.createBlock)("core/heading", {
                content: c
              });
              var y = (0, v.split)((0, v.create)({
                html: s,
                multilineTag: "p"
              }), "\u2028"),
                  k = (0, m.createBlock)("core/heading", {
                content: (0, v.toHTMLString)({
                  value: y[0]
                })
              });
              if (!c && 1 === y.length) return k;
              var E = y.slice(1);
              return [k, (0, m.createBlock)("core/pullquote", _objectSpread(_objectSpread({}, _), {}, {
                citation: c,
                value: (0, v.toHTMLString)({
                  value: E.length ? (0, v.join)(y.slice(1), "\u2028") : (0, v.create)(),
                  multilineTag: "p"
                })
              }))];
            }
          }]
        };
        s.default = _;
      },
      6836: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryPaginationNextEdit(l) {
          var s = l.attributes.label,
              c = l.setAttributes,
              m = l.context.paginationArrow;
          var w = E[m];
          return (0, v.createElement)("a", (0, _.default)({
            href: "#pagination-next-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, k.useBlockProps)()), (0, v.createElement)(k.PlainText, {
            __experimentalVersion: 2,
            tagName: "span",
            "aria-label": (0, y.__)("Next page link"),
            placeholder: (0, y.__)("Next Page"),
            value: s,
            onChange: function onChange(l) {
              return c({
                label: l
              });
            }
          }), w && (0, v.createElement)("span", {
            className: "wp-block-query-pagination-next-arrow is-arrow-".concat(m)
          }, w));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(6756),
            k = c(1326);

        var E = {
          none: "",
          arrow: "→",
          chevron: "»"
        };
      },
      3335: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6836));

        var y = {
          apiVersion: 2,
          name: "core/query-pagination-next",
          title: "Next Page",
          category: "design",
          parent: ["core/query-pagination"],
          description: "Displays the next posts page link.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            }
          },
          usesContext: ["queryId", "query", "paginationArrow"],
          supports: {
            reusable: !1,
            html: !1,
            color: {
              gradients: !0,
              text: !1
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.queryPaginationNext,
          edit: _.default
        };
        s.settings = E;
      },
      3351: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryPaginationNumbersEdit() {
          var l = (0, m.createElement)(m.Fragment, null, createPaginationItem(1), createPaginationItem(2), createPaginationItem(3, "span", "current"), createPaginationItem(4), createPaginationItem(5), createPaginationItem("...", "span", "dots"), createPaginationItem(8));
          return (0, m.createElement)("div", (0, v.useBlockProps)(), l);
        };
        var m = c(1753),
            v = c(1326);

        var createPaginationItem = function createPaginationItem(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "a",
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
          return (0, m.createElement)(s, {
            className: "page-numbers ".concat(c)
          }, l);
        };
      },
      749: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(3351));

        var y = {
          apiVersion: 2,
          name: "core/query-pagination-numbers",
          title: "Page Numbers",
          category: "design",
          parent: ["core/query-pagination"],
          description: "Displays a list of page numbers for pagination",
          textdomain: "default",
          usesContext: ["queryId", "query"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "query-pagination-numbers-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.queryPaginationNumbers,
          edit: _.default
        };
        s.settings = E;
      },
      8722: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryPaginationPreviousEdit(l) {
          var s = l.attributes.label,
              c = l.setAttributes,
              m = l.context.paginationArrow;
          var w = E[m];
          return (0, v.createElement)("a", (0, _.default)({
            href: "#pagination-previous-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, (0, k.useBlockProps)()), w && (0, v.createElement)("span", {
            className: "wp-block-query-pagination-previous-arrow is-arrow-".concat(m)
          }, w), (0, v.createElement)(k.PlainText, {
            __experimentalVersion: 2,
            tagName: "span",
            "aria-label": (0, y.__)("Previous page link"),
            placeholder: (0, y.__)("Previous Page"),
            value: s,
            onChange: function onChange(l) {
              return c({
                label: l
              });
            }
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(6756),
            k = c(1326);

        var E = {
          none: "",
          arrow: "←",
          chevron: "«"
        };
      },
      2176: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8722));

        var y = {
          apiVersion: 2,
          name: "core/query-pagination-previous",
          title: "Previous Page",
          category: "design",
          parent: ["core/query-pagination"],
          description: "Displays the previous posts page link.",
          textdomain: "default",
          attributes: {
            label: {
              type: "string"
            }
          },
          usesContext: ["queryId", "query", "paginationArrow"],
          supports: {
            reusable: !1,
            html: !1,
            color: {
              gradients: !0,
              text: !1
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          }
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.queryPaginationPrevious,
          edit: _.default
        };
        s.settings = E;
      },
      6824: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(1753),
            v = c(1326);
        var _ = [{
          save: function save() {
            return (0, m.createElement)("div", v.useBlockProps.save(), (0, m.createElement)(v.InnerBlocks.Content, null));
          }
        }];
        s.default = _;
      },
      938: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryPaginationEdit(l) {
          var _l$attributes21 = l.attributes,
              s = _l$attributes21.paginationArrow,
              c = _l$attributes21.layout,
              S = l.setAttributes,
              P = l.clientId,
              T = l.name;

          var B = c || function (l) {
            var s = (0, k.getBlockSupport)(l, "__experimentalLayout");
            return null == s ? void 0 : s.default;
          }(T),
              z = (0, y.useSelect)(function (l) {
            var _l66 = l(_.store),
                s = _l66.getBlocks,
                c = s(P);

            return null == c ? void 0 : c.find(function (l) {
              return ["core/query-pagination-next", "core/query-pagination-previous"].includes(l.name);
            });
          }, []),
              L = (0, _.useBlockProps)(),
              V = (0, _.useInnerBlocksProps)(L, {
            template: C,
            allowedBlocks: ["core/query-pagination-previous", "core/query-pagination-numbers", "core/query-pagination-next"],
            __experimentalLayout: B
          });

          return (0, m.createElement)(m.Fragment, null, z && (0, m.createElement)(_.InspectorControls, null, (0, m.createElement)(E.PanelBody, {
            title: (0, v.__)("Settings")
          }, (0, m.createElement)(w.QueryPaginationArrowControls, {
            value: s,
            onChange: function onChange(l) {
              S({
                paginationArrow: l
              });
            }
          }))), (0, m.createElement)("div", V));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(1326),
            y = c(8467),
            k = c(6700),
            E = c(4892),
            w = c(8798);

        var C = [["core/query-pagination-previous"], ["core/query-pagination-numbers"], ["core/query-pagination-next"]];
      },
      104: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(938)),
            y = m(c(5102)),
            k = m(c(6824));

        var E = {
          apiVersion: 2,
          name: "core/query-pagination",
          title: "Pagination",
          category: "design",
          parent: ["core/query"],
          description: "Displays a paginated navigation to next/previous set of posts, when applicable.",
          textdomain: "default",
          attributes: {
            paginationArrow: {
              type: "string",
              default: "none"
            }
          },
          usesContext: ["queryId", "query"],
          providesContext: {
            paginationArrow: "paginationArrow"
          },
          supports: {
            align: !0,
            reusable: !1,
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            }
          },
          editorStyle: "wp-block-query-pagination-editor",
          style: "wp-block-query-pagination"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.queryPagination,
          edit: _.default,
          save: y.default,
          deprecated: k.default
        };
        s.settings = C;
      },
      8798: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.QueryPaginationArrowControls = function QueryPaginationArrowControls(l) {
          var s = l.value,
              c = l.onChange;
          return (0, m.createElement)(_.__experimentalToggleGroupControl, {
            label: (0, v.__)("Arrow"),
            value: s,
            onChange: c,
            help: (0, v.__)("A decorative arrow appended to the next and previous page link."),
            isBlock: !0
          }, (0, m.createElement)(_.__experimentalToggleGroupControlOption, {
            value: "none",
            label: (0, v._x)("None", "Arrow option for Query Pagination Next/Previous blocks")
          }), (0, m.createElement)(_.__experimentalToggleGroupControlOption, {
            value: "arrow",
            label: (0, v._x)("Arrow", "Arrow option for Query Pagination Next/Previous blocks")
          }), (0, m.createElement)(_.__experimentalToggleGroupControlOption, {
            value: "chevron",
            label: (0, v._x)("Chevron", "Arrow option for Query Pagination Next/Previous blocks")
          }));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892);
      },
      5102: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save() {
          return (0, m.createElement)(v.InnerBlocks.Content, null);
        };
        var m = c(1753),
            v = c(1326);
      },
      4147: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            type: {
              type: "string"
            },
            textAlign: {
              type: "string"
            },
            level: {
              type: "number",
              default: 1
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      1906: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryTitleEdit(l) {
          var _ref315;

          var _l$attributes22 = l.attributes,
              s = _l$attributes22.type,
              c = _l$attributes22.level,
              m = _l$attributes22.textAlign,
              C = l.setAttributes;
          var S = "h".concat(c),
              P = (0, y.useBlockProps)({
            className: (0, _.default)((_ref315 = {}, _defineProperty(_ref315, "has-text-align-".concat(m), m), _defineProperty(_ref315, "wp-block-query-title__placeholder", "archive" === s), _ref315))
          });
          if (!w.includes(s)) return (0, v.createElement)("div", P, (0, v.createElement)(y.Warning, null, (0, k.__)("Provided type is not supported.")));
          var T;
          "archive" === s && (T = (0, v.createElement)(S, P, (0, k.__)("Archive title")));
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(E.default, {
            selectedLevel: c,
            onChange: function onChange(l) {
              return C({
                level: l
              });
            }
          }), (0, v.createElement)(y.AlignmentControl, {
            value: m,
            onChange: function onChange(l) {
              C({
                textAlign: l
              });
            }
          })), T);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(6756),
            E = m(c(9855));

        var w = ["archive"];
      },
      3462: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(1906)),
            _ = m(c(6792)),
            y = m(c(4147));

        var k = {
          apiVersion: 2,
          name: "core/query-title",
          title: "Query Title",
          category: "theme",
          description: "Display the query title.",
          textdomain: "default",
          attributes: {
            type: {
              type: "string"
            },
            textAlign: {
              type: "string"
            },
            level: {
              type: "number",
              default: 1
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0
            },
            spacing: {
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0,
                textTransform: !0
              }
            }
          },
          editorStyle: "wp-block-query-title-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          edit: v.default,
          variations: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      6792: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756),
            v = c(5303);
        var _ = [{
          isDefault: !0,
          name: "archive-title",
          title: (0, m.__)("Archive Title"),
          description: (0, m.__)("Display the archive title based on the queried object."),
          icon: v.archiveTitle,
          attributes: {
            type: "archive"
          },
          scope: ["inserter"]
        }];

        _.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            return l.type === s.type;
          });
        });

        var y = _;
        s.default = y;
      },
      8193: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.MAX_FETCHED_TERMS = s.DEFAULTS_POSTS_PER_PAGE = void 0;
        s.MAX_FETCHED_TERMS = 100;
        s.DEFAULTS_POSTS_PER_PAGE = 3;
        var c = {
          MAX_FETCHED_TERMS: 100,
          DEFAULTS_POSTS_PER_PAGE: 3
        };
        s.default = c;
      },
      8740: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(1326);

        var y = [{
          attributes: {
            queryId: {
              type: "number"
            },
            query: {
              type: "object",
              default: {
                perPage: null,
                pages: 0,
                offset: 0,
                postType: "post",
                categoryIds: [],
                tagIds: [],
                order: "desc",
                orderBy: "date",
                author: "",
                search: "",
                exclude: [],
                sticky: "",
                inherit: !0
              }
            },
            layout: {
              type: "object",
              default: {
                type: "list"
              }
            }
          },
          supports: {
            html: !1
          },
          migrate: function migrate(l) {
            return _objectSpread(_objectSpread({}, (0, v.omit)(l, ["layout"])), {}, {
              displayLayout: l.layout
            });
          },
          save: function save() {
            return (0, m.createElement)(_.InnerBlocks.Content, null);
          }
        }];
        s.default = y;
      },
      8991: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.QueryContent = QueryContent, s.default = void 0;

        var v = c(1753),
            _ = c(8467),
            y = c(6700),
            k = c(3200),
            E = c(1326),
            w = c(4892),
            C = c(6756),
            S = m(c(7826)),
            P = m(c(2468)),
            T = m(c(422)),
            B = c(8193),
            z = c(9328);

        var L = [["core/post-template"]];

        function QueryContent(l) {
          var s = l.attributes,
              c = l.setAttributes;

          var m = s.queryId,
              y = s.query,
              T = s.displayLayout,
              _s$tagName2 = s.tagName,
              z = _s$tagName2 === void 0 ? "div" : _s$tagName2,
              _s$layout3 = s.layout,
              V = _s$layout3 === void 0 ? {} : _s$layout3,
              _ref316 = (0, _.useDispatch)(E.store),
              A = _ref316.__unstableMarkNextChangeAsNotPersistent,
              R = (0, k.useInstanceId)(QueryContent),
              _ref317 = (0, _.useSelect)(function (l) {
            var s;

            var _l67 = l(E.store),
                c = _l67.getSettings;

            return {
              themeSupportsLayout: null === (s = c()) || void 0 === s ? void 0 : s.supportsLayout
            };
          }, []),
              O = _ref317.themeSupportsLayout,
              D = (0, E.useSetting)("layout") || {},
              F = V && V.inherit ? D : V,
              G = (0, E.useBlockProps)(),
              q = (0, E.useInnerBlocksProps)(G, {
            template: L,
            __experimentalLayout: O ? F : void 0
          }),
              _ref318 = (0, _.useSelect)(function (l) {
            var _l68 = l(E.store),
                s = _l68.getSettings;

            return {
              postsPerPage: +s().postsPerPage || B.DEFAULTS_POSTS_PER_PAGE
            };
          }, []),
              W = _ref318.postsPerPage;

          (0, v.useEffect)(function () {
            var l = {};
            !y.perPage && W && (l.perPage = W), Object.keys(l).length && (A(), updateQuery(l));
          }, [y.perPage]), (0, v.useEffect)(function () {
            m || (A(), c({
              queryId: R
            }));
          }, [m, R]);

          var updateQuery = function updateQuery(l) {
            return c({
              query: _objectSpread(_objectSpread({}, y), l)
            });
          },
              updateDisplayLayout = function updateDisplayLayout(l) {
            return c({
              displayLayout: _objectSpread(_objectSpread({}, T), l)
            });
          };

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(P.default, {
            attributes: s,
            setQuery: updateQuery,
            setDisplayLayout: updateDisplayLayout
          }), (0, v.createElement)(E.BlockControls, null, (0, v.createElement)(S.default, {
            attributes: s,
            setQuery: updateQuery,
            setDisplayLayout: updateDisplayLayout
          })), (0, v.createElement)(E.InspectorControls, {
            __experimentalGroup: "advanced"
          }, (0, v.createElement)(w.SelectControl, {
            label: (0, C.__)("HTML element"),
            options: [{
              label: (0, C.__)("Default (<div>)"),
              value: "div"
            }, {
              label: "<main>",
              value: "main"
            }, {
              label: "<section>",
              value: "section"
            }, {
              label: "<aside>",
              value: "aside"
            }],
            value: z,
            onChange: function onChange(l) {
              return c({
                tagName: l
              });
            }
          })), (0, v.createElement)(z, q));
        }

        function QueryPatternSetup(l) {
          var s = l.clientId,
              c = l.name,
              m = (0, E.useBlockProps)(),
              _ref319 = (0, _.useDispatch)(E.store),
              k = _ref319.replaceBlock,
              w = _ref319.selectBlock;

          return (0, v.createElement)("div", m, (0, v.createElement)(E.__experimentalBlockPatternSetup, {
            blockName: c,
            clientId: s,
            startBlankComponent: (0, v.createElement)(T.default, l),
            onBlockPatternSelect: function onBlockPatternSelect(l) {
              var c = l.map(function (l) {
                return (0, y.cloneBlock)(l);
              }),
                  m = (0, z.getFirstQueryClientIdFromBlocks)(c);
              k(s, c), m && w(m);
            }
          }));
        }

        var _default = function _default(l) {
          var s = l.clientId,
              c = (0, _.useSelect)(function (l) {
            return !!l(E.store).getBlocks(s).length;
          }, [s]) ? QueryContent : QueryPatternSetup;
          return (0, v.createElement)(c, l);
        };

        s.default = _default;
      },
      2468: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryInspectorControls(l) {
          var s, c;
          var _l$attributes23 = l.attributes,
              T = _l$attributes23.query,
              B = _l$attributes23.displayLayout,
              z = l.setQuery,
              L = l.setDisplayLayout;

          var V = T.order,
              A = T.orderBy,
              R = T.author,
              O = T.postType,
              D = T.sticky,
              F = T.inherit,
              _ref320 = (0, m.useState)(!0),
              _ref321 = _slicedToArray2(_ref320, 2),
              G = _ref321[0],
              q = _ref321[1],
              _ref322 = (0, m.useState)(!0),
              _ref323 = _slicedToArray2(_ref322, 2),
              W = _ref323[0],
              U = _ref323[1],
              _ref324 = (0, m.useState)("post" === O),
              _ref325 = _slicedToArray2(_ref324, 2),
              $ = _ref325[0],
              Z = _ref325[1],
              _ref326 = (0, C.usePostTypes)(),
              K = _ref326.postTypesTaxonomiesMap,
              Q = _ref326.postTypesSelectOptions,
              _ref327 = (0, E.useSelect)(function (l) {
            var _l69 = l(w.store),
                s = _l69.getEntityRecords,
                c = {
              per_page: S.MAX_FETCHED_TERMS
            },
                m = s("taxonomy", "category", c),
                v = s("taxonomy", "post_tag", c);

            return {
              categories: (0, C.getTermsInfo)(m),
              tags: (0, C.getTermsInfo)(v),
              authorList: s("root", "user", {
                per_page: -1
              })
            };
          }, []),
              Y = _ref327.authorList,
              X = _ref327.categories,
              J = _ref327.tags;

          (0, m.useEffect)(function () {
            if (!K) return;
            var l = K[O];
            q(l.includes("category")), U(l.includes("post_tag"));
          }, [O, K]), (0, m.useEffect)(function () {
            Z("post" === O);
          }, [O]);

          var onTermsChange = function onTermsChange(l, s) {
            return function (c) {
              var m = Array.from(c.reduce(function (s, c) {
                var m = function (l, s) {
                  var c;
                  var m = (null == s ? void 0 : s.id) || (null === (c = l[s]) || void 0 === c ? void 0 : c.id);
                  if (m) return m;
                  var v = s.toLocaleLowerCase();

                  for (var _s22 in l) {
                    if (_s22.toLocaleLowerCase() === v) return l[_s22].id;
                  }
                }(l.mapByName, c);

                return m && s.add(m), s;
              }, new Set()));
              z(_defineProperty({}, s, m));
            };
          },
              ee = onTermsChange(X, "categoryIds"),
              te = onTermsChange(J, "tagIds"),
              _ref328 = (0, m.useState)(T.search),
              _ref329 = _slicedToArray2(_ref328, 2),
              re = _ref329[0],
              ae = _ref329[1],
              oe = (0, m.useCallback)((0, v.debounce)(function () {
            T.search !== re && z({
              search: re
            });
          }, 250), [re, T.search]);

          (0, m.useEffect)(function () {
            return oe(), oe.cancel;
          }, [re, oe]);

          var getExistingTermsFormTokenValue = function getExistingTermsFormTokenValue(l) {
            var s = {
              category: {
                queryProp: "categoryIds",
                terms: X
              },
              post_tag: {
                queryProp: "tagIds",
                terms: J
              }
            }[l];
            return (T[s.queryProp] || []).reduce(function (l, c) {
              var m = s.terms.mapById[c];
              return m && l.push({
                id: c,
                value: m.name
              }), l;
            }, []);
          };

          return (0, m.createElement)(k.InspectorControls, null, (0, m.createElement)(_.PanelBody, {
            title: (0, y.__)("Settings")
          }, (0, m.createElement)(_.ToggleControl, {
            label: (0, y.__)("Inherit query from template"),
            help: (0, y.__)("Toggle to use the global query context that is set with the current template, such as an archive or search. Disable to customize the settings independently."),
            checked: !!F,
            onChange: function onChange(l) {
              return z({
                inherit: !!l
              });
            }
          }), !F && (0, m.createElement)(_.SelectControl, {
            options: Q,
            value: O,
            label: (0, y.__)("Post Type"),
            onChange: function onChange(l) {
              var s = {
                postType: l
              };
              K[l].includes("category") || (s.categoryIds = []), K[l].includes("post_tag") || (s.tagIds = []), "post" !== l && (s.sticky = ""), z(s);
            },
            help: (0, y.__)('WordPress contains different types of content and they are divided into collections called "Post Types". By default there are a few different ones such as blog posts and pages, but plugins could add more.')
          }), "flex" === (null == B ? void 0 : B.type) && (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.RangeControl, {
            label: (0, y.__)("Columns"),
            value: B.columns,
            onChange: function onChange(l) {
              return L({
                columns: l
              });
            },
            min: 2,
            max: Math.max(6, B.columns)
          }), B.columns > 6 && (0, m.createElement)(_.Notice, {
            status: "warning",
            isDismissible: !1
          }, (0, y.__)("This column count exceeds the recommended amount and may cause visual breakage."))), !F && (0, m.createElement)(_.QueryControls, {
            order: V,
            orderBy: A,
            onOrderChange: function onOrderChange(l) {
              return z({
                order: l
              });
            },
            onOrderByChange: function onOrderByChange(l) {
              return z({
                orderBy: l
              });
            }
          }), $ && (0, m.createElement)(_.SelectControl, {
            label: (0, y.__)("Sticky posts"),
            options: P,
            value: D,
            onChange: function onChange(l) {
              return z({
                sticky: l
              });
            },
            help: (0, y.__)('Blog posts can be "stickied", a feature that places them at the top of the front page of posts, keeping it there until new sticky posts are published.')
          })), !F && (0, m.createElement)(_.PanelBody, {
            title: (0, y.__)("Filters")
          }, G && (null == X || null === (s = X.terms) || void 0 === s ? void 0 : s.length) > 0 && (0, m.createElement)(_.FormTokenField, {
            label: (0, y.__)("Categories"),
            value: getExistingTermsFormTokenValue("category"),
            suggestions: X.names,
            onChange: ee
          }), W && (null == J || null === (c = J.terms) || void 0 === c ? void 0 : c.length) > 0 && (0, m.createElement)(_.FormTokenField, {
            label: (0, y.__)("Tags"),
            value: getExistingTermsFormTokenValue("post_tag"),
            suggestions: J.names,
            onChange: te
          }), (0, m.createElement)(_.QueryControls, {
            selectedAuthorId: R,
            authorList: Y,
            onAuthorChange: function onAuthorChange(l) {
              return z({
                author: "" !== l ? +l : void 0
              });
            }
          }), (0, m.createElement)(_.TextControl, {
            label: (0, y.__)("Keyword"),
            value: re,
            onChange: ae
          })));
        };

        var m = c(1753),
            v = c(4793),
            _ = c(4892),
            y = c(6756),
            k = c(1326),
            E = c(8467),
            w = c(1295),
            C = c(9328),
            S = c(8193);

        var P = [{
          label: (0, y.__)("Include"),
          value: ""
        }, {
          label: (0, y.__)("Exclude"),
          value: "exclude"
        }, {
          label: (0, y.__)("Only"),
          value: "only"
        }];
      },
      422: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(1326),
            y = c(6700);

        var _default = function _default(l) {
          var s;
          var c = l.clientId,
              k = l.name,
              E = l.attributes,
              w = l.setAttributes;

          var _ref330 = (0, v.useSelect)(function (l) {
            var _l70 = l(y.store),
                s = _l70.getBlockVariations,
                c = _l70.getBlockType,
                m = _l70.getDefaultBlockVariation;

            return {
              blockType: c(k),
              defaultVariation: m(k, "block"),
              scopeVariations: s(k, "block"),
              allVariations: s(k)
            };
          }, [k]),
              C = _ref330.blockType,
              S = _ref330.defaultVariation,
              P = _ref330.scopeVariations,
              T = _ref330.allVariations,
              _ref331 = (0, v.useDispatch)(_.store),
              B = _ref331.replaceInnerBlocks,
              z = (0, _.useBlockProps)(),
              L = (0, _.__experimentalGetMatchingVariation)(E, T),
              V = (null == L ? void 0 : L.icon) || (null == C || null === (s = C.icon) || void 0 === s ? void 0 : s.src),
              A = (null == L ? void 0 : L.title) || (null == C ? void 0 : C.title);

          return (0, m.createElement)("div", z, (0, m.createElement)(_.__experimentalBlockVariationPicker, {
            icon: V,
            label: A,
            variations: P,
            onSelect: function onSelect() {
              var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : S;
              l.attributes && w(l.attributes), l.innerBlocks && B(c, (0, y.createBlocksFromInnerBlocksTemplate)(l.innerBlocks), !1);
            }
          }));
        };

        s.default = _default;
      },
      7826: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QueryToolbar(l) {
          var _l$attributes24 = l.attributes,
              s = _l$attributes24.query,
              c = _l$attributes24.displayLayout,
              E = l.setQuery,
              w = l.setDisplayLayout;
          var C = (0, _.useInstanceId)(QueryToolbar, "blocks-query-pagination-max-page-input"),
              S = [{
            icon: k.list,
            title: (0, y.__)("List view"),
            onClick: function onClick() {
              return w({
                type: "list"
              });
            },
            isActive: "list" === (null == c ? void 0 : c.type)
          }, {
            icon: k.grid,
            title: (0, y.__)("Grid view"),
            onClick: function onClick() {
              return w({
                type: "flex",
                columns: (null == c ? void 0 : c.columns) || 3
              });
            },
            isActive: "flex" === (null == c ? void 0 : c.type)
          }];
          return (0, m.createElement)(m.Fragment, null, !s.inherit && (0, m.createElement)(v.ToolbarGroup, null, (0, m.createElement)(v.Dropdown, {
            contentClassName: "block-library-query-toolbar__popover",
            renderToggle: function renderToggle(l) {
              var s = l.onToggle;
              return (0, m.createElement)(v.ToolbarButton, {
                icon: k.settings,
                label: (0, y.__)("Display settings"),
                onClick: s
              });
            },
            renderContent: function renderContent() {
              return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(v.BaseControl, null, (0, m.createElement)(v.__experimentalNumberControl, {
                __unstableInputWidth: "60px",
                label: (0, y.__)("Items per Page"),
                labelPosition: "edge",
                min: 1,
                max: 100,
                onChange: function onChange(l) {
                  isNaN(l) || l < 1 || l > 100 || E({
                    perPage: l
                  });
                },
                step: "1",
                value: s.perPage,
                isDragEnabled: !1
              })), (0, m.createElement)(v.BaseControl, null, (0, m.createElement)(v.__experimentalNumberControl, {
                __unstableInputWidth: "60px",
                label: (0, y.__)("Offset"),
                labelPosition: "edge",
                min: 0,
                max: 100,
                onChange: function onChange(l) {
                  isNaN(l) || l < 0 || l > 100 || E({
                    offset: l
                  });
                },
                step: "1",
                value: s.offset,
                isDragEnabled: !1
              })), (0, m.createElement)(v.BaseControl, {
                id: C,
                help: (0, y.__)("Limit the pages you want to show, even if the query has more results. To show all pages use 0 (zero).")
              }, (0, m.createElement)(v.__experimentalNumberControl, {
                id: C,
                __unstableInputWidth: "60px",
                label: (0, y.__)("Max page to show"),
                labelPosition: "edge",
                min: 0,
                onChange: function onChange(l) {
                  isNaN(l) || l < 0 || E({
                    pages: l
                  });
                },
                step: "1",
                value: s.pages,
                isDragEnabled: !1
              })));
            }
          })), (0, m.createElement)(v.ToolbarGroup, {
            controls: S
          }));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(3200),
            y = c(6756),
            k = c(5303);
      },
      8450: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            y = c(6756),
            k = c(904),
            E = c(3200),
            w = c(1326);

        var CreateNewPostLink = function CreateNewPostLink(l) {
          var _l$attributes25 = l.attributes;
          _l$attributes25 = _l$attributes25 === void 0 ? {} : _l$attributes25;
          var _l$attributes25$query = _l$attributes25.query;
          _l$attributes25$query = _l$attributes25$query === void 0 ? {} : _l$attributes25$query;
          var s = _l$attributes25$query.postType;
          if (!s) return null;
          var c = (0, k.addQueryArgs)("post-new.php", {
            post_type: s
          });
          return (0, v.createElement)("div", {
            className: "wp-block-query__create-new-link"
          }, (0, v.createInterpolateElement)((0, y.__)("<a>Create a new post</a> for this feed."), {
            a: (0, v.createElement)("a", {
              href: c
            })
          }));
        };

        var C = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = s.name,
                m = s.isSelected;
            return "core/query" === c && m ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(CreateNewPostLink, s)), (0, v.createElement)(l, (0, _.default)({
              key: "edit"
            }, s))) : (0, v.createElement)(l, (0, _.default)({
              key: "edit"
            }, s));
          };
        }, "withInspectorControls");
        s.default = C;
      },
      4890: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.titleExcerpt = s.titleDateExcerpt = s.titleDate = s.imageDateTitle = void 0;
        var m = c(1753),
            v = c(4892);

        var _ = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48"
        }, (0, m.createElement)(v.Path, {
          d: "M41 9H7v3h34V9zm-22 5H7v1h12v-1zM7 26h12v1H7v-1zm34-5H7v3h34v-3zM7 38h12v1H7v-1zm34-5H7v3h34v-3z"
        }));

        s.titleDate = _;
        var y = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48"
        }, (0, m.createElement)(v.Path, {
          d: "M41 9H7v3h34V9zm-4 5H7v1h30v-1zm4 3H7v1h34v-1zM7 20h30v1H7v-1zm0 12h30v1H7v-1zm34 3H7v1h34v-1zM7 38h30v1H7v-1zm34-11H7v3h34v-3z"
        }));
        s.titleExcerpt = y;
        var k = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48"
        }, (0, m.createElement)(v.Path, {
          d: "M41 9H7v3h34V9zm-22 5H7v1h12v-1zm22 3H7v1h34v-1zM7 20h34v1H7v-1zm0 12h12v1H7v-1zm34 3H7v1h34v-1zM7 38h34v1H7v-1zm34-11H7v3h34v-3z"
        }));
        s.titleDateExcerpt = k;
        var E = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48"
        }, (0, m.createElement)(v.Path, {
          d: "M7 9h34v6H7V9zm12 8H7v1h12v-1zm18 3H7v1h30v-1zm0 18H7v1h30v-1zM7 35h12v1H7v-1zm34-8H7v6h34v-6z"
        }));
        s.imageDateTitle = E;
      },
      6237: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = c(1149),
            y = m(c(8991)),
            k = m(c(2191)),
            E = m(c(3255)),
            w = m(c(8740)),
            C = m(c(8450));

        var S = {
          apiVersion: 2,
          name: "core/query",
          title: "Query Loop",
          category: "theme",
          description: "An advanced block that allows displaying post types based on different query parameters and visual configurations.",
          textdomain: "default",
          attributes: {
            queryId: {
              type: "number"
            },
            query: {
              type: "object",
              default: {
                perPage: null,
                pages: 0,
                offset: 0,
                postType: "post",
                categoryIds: [],
                tagIds: [],
                order: "desc",
                orderBy: "date",
                author: "",
                search: "",
                exclude: [],
                sticky: "",
                inherit: !0
              }
            },
            tagName: {
              type: "string",
              default: "div"
            },
            displayLayout: {
              type: "object",
              default: {
                type: "list"
              }
            }
          },
          providesContext: {
            queryId: "queryId",
            query: "query",
            displayLayout: "displayLayout"
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            __experimentalLayout: !0
          },
          editorStyle: "wp-block-query-editor"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: v.loop,
          edit: y.default,
          save: k.default,
          variations: E.default,
          deprecated: w.default
        };
        s.settings = T, (0, _.addFilter)("editor.BlockEdit", "core/query", C.default);
      },
      2191: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QuerySave(l) {
          var _l$attributes$tagName = l.attributes.tagName,
              s = _l$attributes$tagName === void 0 ? "div" : _l$attributes$tagName;

          var c = v.useBlockProps.save(),
              _ = v.useInnerBlocksProps.save(c);

          return (0, m.createElement)(s, _);
        };
        var m = c(1753),
            v = c(1326);
      },
      9328: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.usePostTypes = s.getTermsInfo = s.getFirstQueryClientIdFromBlocks = void 0;

        var m = c(8467),
            v = c(1753),
            _ = c(1295);

        s.getTermsInfo = function (l) {
          var s = null == l ? void 0 : l.reduce(function (l, s) {
            var c = l.mapById,
                m = l.mapByName,
                v = l.names;
            return c[s.id] = s, m[s.name] = s, v.push(s.name), l;
          }, {
            mapById: {},
            mapByName: {},
            names: []
          });
          return _objectSpread({
            terms: l
          }, s);
        };

        s.usePostTypes = function () {
          var _ref332 = (0, m.useSelect)(function (l) {
            var s;

            var _l71 = l(_.store),
                c = _l71.getPostTypes,
                m = ["attachment"];

            return {
              postTypes: null === (s = c({
                per_page: -1
              })) || void 0 === s ? void 0 : s.filter(function (l) {
                var s = l.viewable,
                    c = l.slug;
                return s && !m.includes(c);
              })
            };
          }, []),
              l = _ref332.postTypes;

          return {
            postTypesTaxonomiesMap: (0, v.useMemo)(function () {
              if (null != l && l.length) return l.reduce(function (l, s) {
                return l[s.slug] = s.taxonomies, l;
              }, {});
            }, [l]),
            postTypesSelectOptions: (0, v.useMemo)(function () {
              return (l || []).map(function (l) {
                var s = l.labels,
                    c = l.slug;
                return {
                  label: s.singular_name,
                  value: c
                };
              });
            }, [l])
          };
        };

        s.getFirstQueryClientIdFromBlocks = function (l) {
          var s = _toConsumableArray(l);

          for (; s.length > 0;) {
            var c;

            var _l72 = s.shift();

            if ("core/query" === _l72.name) return _l72.clientId;
            null === (c = _l72.innerBlocks) || void 0 === c || c.forEach(function (l) {
              s.push(l);
            });
          }
        };
      },
      3255: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(6756),
            v = c(5303),
            _ = c(4890);

        var y = {
          query: {
            perPage: 3,
            pages: 0,
            offset: 0,
            postType: "post",
            categoryIds: [],
            tagIds: [],
            order: "desc",
            orderBy: "date",
            author: "",
            search: "",
            exclude: [],
            sticky: "",
            inherit: !1
          }
        };
        var k = [{
          name: "posts-list",
          title: (0, m.__)("Posts List"),
          description: (0, m.__)("Display a list of your most recent posts, excluding sticky posts."),
          icon: v.postList,
          attributes: {
            query: {
              perPage: 4,
              pages: 1,
              offset: 0,
              postType: "post",
              categoryIds: [],
              tagIds: [],
              order: "desc",
              orderBy: "date",
              author: "",
              search: "",
              sticky: "exclude",
              inherit: !1
            }
          },
          scope: ["inserter"]
        }, {
          name: "title-date",
          title: (0, m.__)("Title & Date"),
          icon: _.titleDate,
          attributes: _objectSpread({}, y),
          innerBlocks: [["core/post-template", {}, [["core/post-title"], ["core/post-date"]]], ["core/query-pagination"]],
          scope: ["block"]
        }, {
          name: "title-excerpt",
          title: (0, m.__)("Title & Excerpt"),
          icon: _.titleExcerpt,
          attributes: _objectSpread({}, y),
          innerBlocks: [["core/post-template", {}, [["core/post-title"], ["core/post-excerpt"]]], ["core/query-pagination"]],
          scope: ["block"]
        }, {
          name: "title-date-excerpt",
          title: (0, m.__)("Title, Date, & Excerpt"),
          icon: _.titleDateExcerpt,
          attributes: _objectSpread({}, y),
          innerBlocks: [["core/post-template", {}, [["core/post-title"], ["core/post-date"], ["core/post-excerpt"]]], ["core/query-pagination"]],
          scope: ["block"]
        }, {
          name: "image-date-title",
          title: (0, m.__)("Image, Date, & Title"),
          icon: _.imageDateTitle,
          attributes: _objectSpread({}, y),
          innerBlocks: [["core/post-template", {}, [["core/post-featured-image"], ["core/post-date"], ["core/post-title"]]], ["core/query-pagination"]],
          scope: ["block"]
        }];
        s.default = k;
      },
      6069: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(1326);

        var y = {
          value: {
            type: "string",
            source: "html",
            selector: "blockquote",
            multiline: "p",
            default: ""
          },
          citation: {
            type: "string",
            source: "html",
            selector: "cite",
            default: ""
          },
          align: {
            type: "string"
          }
        };
        var k = [{
          attributes: y,
          save: function save(l) {
            var s = l.attributes;
            var c = s.align,
                v = s.value,
                y = s.citation;
            return (0, m.createElement)("blockquote", {
              style: {
                textAlign: c || null
              }
            }, (0, m.createElement)(_.RichText.Content, {
              multiline: !0,
              value: v
            }), !_.RichText.isEmpty(y) && (0, m.createElement)(_.RichText.Content, {
              tagName: "cite",
              value: y
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, y), {}, {
            style: {
              type: "number",
              default: 1
            }
          }),
          migrate: function migrate(l) {
            return 2 === l.style ? _objectSpread(_objectSpread({}, (0, v.omit)(l, ["style"])), {}, {
              className: l.className ? l.className + " is-style-large" : "is-style-large"
            }) : l;
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.align,
                v = s.value,
                y = s.citation,
                k = s.style;
            return (0, m.createElement)("blockquote", {
              className: 2 === k ? "is-large" : "",
              style: {
                textAlign: c || null
              }
            }, (0, m.createElement)(_.RichText.Content, {
              multiline: !0,
              value: v
            }), !_.RichText.isEmpty(y) && (0, m.createElement)(_.RichText.Content, {
              tagName: "cite",
              value: y
            }));
          }
        }, {
          attributes: _objectSpread(_objectSpread({}, y), {}, {
            citation: {
              type: "string",
              source: "html",
              selector: "footer",
              default: ""
            },
            style: {
              type: "number",
              default: 1
            }
          }),
          migrate: function migrate(l) {
            return isNaN(parseInt(l.style)) ? l : _objectSpread({}, (0, v.omit)(l, ["style"]));
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.align,
                v = s.value,
                y = s.citation,
                k = s.style;
            return (0, m.createElement)("blockquote", {
              className: "blocks-quote-style-".concat(k),
              style: {
                textAlign: c || null
              }
            }, (0, m.createElement)(_.RichText.Content, {
              multiline: !0,
              value: v
            }), !_.RichText.isEmpty(y) && (0, m.createElement)(_.RichText.Content, {
              tagName: "footer",
              value: y
            }));
          }
        }];
        s.default = k;
      },
      1795: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QuoteEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.isSelected,
              S = l.mergeBlocks,
              P = l.onReplace,
              T = l.className,
              B = l.insertBlocksAfter,
              z = l.style;
          var L = s.align,
              V = s.value,
              A = s.citation,
              R = (0, k.useBlockProps)({
            className: (0, _.default)(T, _defineProperty({}, "has-text-align-".concat(L), L)),
            style: z
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: L,
            onChange: function onChange(l) {
              c({
                align: l
              });
            }
          })), (0, v.createElement)(E.BlockQuotation, R, (0, v.createElement)(k.RichText, {
            identifier: "value",
            multiline: !0,
            value: V,
            onChange: function onChange(l) {
              return c({
                value: l
              });
            },
            onMerge: S,
            onRemove: function onRemove(l) {
              var s = !A || 0 === A.length;
              !l && s && P([]);
            },
            "aria-label": (0, y.__)("Quote text"),
            placeholder: (0, y.__)("Add quote"),
            onReplace: P,
            onSplit: function onSplit(l) {
              return (0, w.createBlock)("core/quote", _objectSpread(_objectSpread({}, s), {}, {
                value: l
              }));
            },
            __unstableOnSplitMiddle: function __unstableOnSplitMiddle() {
              return (0, w.createBlock)("core/paragraph");
            },
            textAlign: L
          }), (!k.RichText.isEmpty(A) || m) && (0, v.createElement)(k.RichText, {
            identifier: "citation",
            tagName: C ? "cite" : void 0,
            style: {
              display: "block"
            },
            value: A,
            onChange: function onChange(l) {
              return c({
                citation: l
              });
            },
            __unstableMobileNoFocusOnMount: !0,
            "aria-label": (0, y.__)("Quote citation text"),
            placeholder: (0, y.__)("Add citation"),
            className: "wp-block-quote__citation",
            textAlign: L,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return B((0, w.createBlock)("core/paragraph"));
            }
          })));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(1326),
            E = c(4892),
            w = c(6700);

        var C = "web" === v.Platform.OS;
      },
      3376: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(6069)),
            k = m(c(1795)),
            E = m(c(7258)),
            w = m(c(4114));

        var C = {
          apiVersion: 2,
          name: "core/quote",
          title: "Quote",
          category: "text",
          description: 'Give quoted text visual emphasis. "In quoting others, we cite ourselves." — Julio Cortázar',
          keywords: ["blockquote", "cite"],
          textdomain: "default",
          attributes: {
            value: {
              type: "string",
              source: "html",
              selector: "blockquote",
              multiline: "p",
              default: "",
              __experimentalRole: "content"
            },
            citation: {
              type: "string",
              source: "html",
              selector: "cite",
              default: "",
              __experimentalRole: "content"
            },
            align: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            __experimentalSlashInserter: !0,
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0
              }
            }
          },
          styles: [{
            name: "default",
            label: "Default",
            isDefault: !0
          }, {
            name: "plain",
            label: "Plain"
          }, {
            name: "large",
            label: "Large"
          }],
          editorStyle: "wp-block-quote-editor",
          style: "wp-block-quote"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.quote,
          example: {
            attributes: {
              value: "<p>" + (0, v.__)("In quoting others, we cite ourselves.") + "</p>",
              citation: "Julio Cortázar",
              className: "is-style-large"
            }
          },
          transforms: w.default,
          edit: k.default,
          save: E.default,
          merge: function merge(l, s) {
            var c = s.value,
                m = s.citation;
            return m || (m = l.citation), c && "<p></p>" !== c ? _objectSpread(_objectSpread({}, l), {}, {
              value: l.value + c,
              citation: m
            }) : _objectSpread(_objectSpread({}, l), {}, {
              citation: m
            });
          },
          deprecated: y.default
        };
        s.settings = P;
      },
      7258: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.align,
              m = s.value,
              k = s.citation,
              E = (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c));
          return (0, v.createElement)("blockquote", y.useBlockProps.save({
            className: E
          }), (0, v.createElement)(y.RichText.Content, {
            multiline: !0,
            value: m
          }), !y.RichText.isEmpty(k) && (0, v.createElement)(y.RichText.Content, {
            tagName: "cite",
            value: k
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      4114: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700),
            v = c(7060);
        var _ = {
          from: [{
            type: "block",
            isMultiBlock: !0,
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/quote", {
                value: (0, v.toHTMLString)({
                  value: (0, v.join)(l.map(function (l) {
                    var s = l.content;
                    return (0, v.create)({
                      html: s
                    });
                  }), "\u2028"),
                  multilineTag: "p"
                }),
                anchor: l.anchor
              });
            }
          }, {
            type: "block",
            blocks: ["core/heading"],
            transform: function transform(l) {
              var s = l.content,
                  c = l.anchor;
              return (0, m.createBlock)("core/quote", {
                value: "<p>".concat(s, "</p>"),
                anchor: c
              });
            }
          }, {
            type: "block",
            blocks: ["core/pullquote"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation,
                  v = l.anchor;
              return (0, m.createBlock)("core/quote", {
                value: s,
                citation: c,
                anchor: v
              });
            }
          }, {
            type: "prefix",
            prefix: ">",
            transform: function transform(l) {
              return (0, m.createBlock)("core/quote", {
                value: "<p>".concat(l, "</p>")
              });
            }
          }, {
            type: "raw",
            isMatch: function isMatch(l) {
              var s = function () {
                var l = !1;
                return function (s) {
                  return "P" === s.nodeName || (l || "CITE" !== s.nodeName ? void 0 : (l = !0, !0));
                };
              }();

              return "BLOCKQUOTE" === l.nodeName && Array.from(l.childNodes).every(s);
            },
            schema: function schema(l) {
              var s = l.phrasingContentSchema;
              return {
                blockquote: {
                  children: {
                    p: {
                      children: s
                    },
                    cite: {
                      children: s
                    }
                  }
                }
              };
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation;
              var _ = [];
              return s && "<p></p>" !== s && _.push.apply(_, _toConsumableArray((0, v.split)((0, v.create)({
                html: s,
                multilineTag: "p"
              }), "\u2028").map(function (l) {
                return (0, m.createBlock)("core/paragraph", {
                  content: (0, v.toHTMLString)({
                    value: l
                  })
                });
              }))), c && "<p></p>" !== c && _.push((0, m.createBlock)("core/paragraph", {
                content: c
              })), 0 === _.length ? (0, m.createBlock)("core/paragraph", {
                content: ""
              }) : _;
            }
          }, {
            type: "block",
            blocks: ["core/heading"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation,
                  _ = _objectWithoutProperties(l, _excluded17);

              if ("<p></p>" === s) return (0, m.createBlock)("core/heading", {
                content: c
              });
              var y = (0, v.split)((0, v.create)({
                html: s,
                multilineTag: "p"
              }), "\u2028"),
                  k = (0, m.createBlock)("core/heading", {
                content: (0, v.toHTMLString)({
                  value: y[0]
                })
              });
              if (!c && 1 === y.length) return k;
              var E = y.slice(1);
              return [k, (0, m.createBlock)("core/quote", _objectSpread(_objectSpread({}, _), {}, {
                citation: c,
                value: (0, v.toHTMLString)({
                  value: E.length ? (0, v.join)(y.slice(1), "\u2028") : (0, v.create)(),
                  multilineTag: "p"
                })
              }))];
            }
          }, {
            type: "block",
            blocks: ["core/pullquote"],
            transform: function transform(l) {
              var s = l.value,
                  c = l.citation,
                  v = l.anchor;
              return (0, m.createBlock)("core/pullquote", {
                value: s,
                citation: c,
                anchor: v
              });
            }
          }]
        };
        s.default = _;
      },
      9197: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function RSSEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;

          var _ref335 = (0, v.useState)(!s.feedURL),
              _ref336 = _slicedToArray2(_ref335, 2),
              m = _ref336[0],
              C = _ref336[1],
              S = s.blockLayout,
              P = s.columns,
              T = s.displayAuthor,
              B = s.displayDate,
              z = s.displayExcerpt,
              L = s.excerptLength,
              V = s.feedURL,
              A = s.itemsToShow;

          function toggleAttribute(l) {
            return function () {
              var m = s[l];
              c(_defineProperty({}, l, !m));
            };
          }

          var R = (0, _.useBlockProps)();
          if (m) return (0, v.createElement)("div", R, (0, v.createElement)(y.Placeholder, {
            icon: k.rss,
            label: "RSS"
          }, (0, v.createElement)("form", {
            onSubmit: function onSubmitURL(l) {
              l.preventDefault(), V && C(!1);
            },
            className: "wp-block-rss__placeholder-form"
          }, (0, v.createElement)(y.TextControl, {
            placeholder: (0, E.__)("Enter URL here…"),
            value: V,
            onChange: function onChange(l) {
              return c({
                feedURL: l
              });
            },
            className: "wp-block-rss__placeholder-input"
          }), (0, v.createElement)(y.Button, {
            variant: "primary",
            type: "submit"
          }, (0, E.__)("Use URL")))));
          var O = [{
            icon: k.edit,
            title: (0, E.__)("Edit RSS URL"),
            onClick: function onClick() {
              return C(!0);
            }
          }, {
            icon: k.list,
            title: (0, E.__)("List view"),
            onClick: function onClick() {
              return c({
                blockLayout: "list"
              });
            },
            isActive: "list" === S
          }, {
            icon: k.grid,
            title: (0, E.__)("Grid view"),
            onClick: function onClick() {
              return c({
                blockLayout: "grid"
              });
            },
            isActive: "grid" === S
          }];
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(_.BlockControls, null, (0, v.createElement)(y.ToolbarGroup, {
            controls: O
          })), (0, v.createElement)(_.InspectorControls, null, (0, v.createElement)(y.PanelBody, {
            title: (0, E.__)("RSS settings")
          }, (0, v.createElement)(y.RangeControl, {
            label: (0, E.__)("Number of items"),
            value: A,
            onChange: function onChange(l) {
              return c({
                itemsToShow: l
              });
            },
            min: 1,
            max: 10,
            required: !0
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display author"),
            checked: T,
            onChange: toggleAttribute("displayAuthor")
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display date"),
            checked: B,
            onChange: toggleAttribute("displayDate")
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Display excerpt"),
            checked: z,
            onChange: toggleAttribute("displayExcerpt")
          }), z && (0, v.createElement)(y.RangeControl, {
            label: (0, E.__)("Max number of words in excerpt"),
            value: L,
            onChange: function onChange(l) {
              return c({
                excerptLength: l
              });
            },
            min: 10,
            max: 100,
            required: !0
          }), "grid" === S && (0, v.createElement)(y.RangeControl, {
            label: (0, E.__)("Columns"),
            value: P,
            onChange: function onChange(l) {
              return c({
                columns: l
              });
            },
            min: 2,
            max: 6,
            required: !0
          }))), (0, v.createElement)("div", R, (0, v.createElement)(y.Disabled, null, (0, v.createElement)(w.default, {
            block: "core/rss",
            attributes: s
          }))));
        };

        var v = c(1753),
            _ = c(1326),
            y = c(4892),
            k = c(5303),
            E = c(6756),
            w = m(c(2643));
      },
      1898: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(9197));

        var y = {
          apiVersion: 2,
          name: "core/rss",
          title: "RSS",
          category: "widgets",
          description: "Display entries from any RSS or Atom feed.",
          keywords: ["atom", "feed"],
          textdomain: "default",
          attributes: {
            columns: {
              type: "number",
              default: 2
            },
            blockLayout: {
              type: "string",
              default: "list"
            },
            feedURL: {
              type: "string",
              default: ""
            },
            itemsToShow: {
              type: "number",
              default: 5
            },
            displayExcerpt: {
              type: "boolean",
              default: !1
            },
            displayAuthor: {
              type: "boolean",
              default: !1
            },
            displayDate: {
              type: "boolean",
              default: !1
            },
            excerptLength: {
              type: "number",
              default: 55
            }
          },
          supports: {
            align: !0,
            html: !1
          },
          editorStyle: "wp-block-rss-editor",
          style: "wp-block-rss"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.rss,
          example: {
            attributes: {
              feedURL: "https://wordpress.org"
            }
          },
          edit: _.default
        };
        s.settings = E;
      },
      7772: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function SearchEdit(l) {
          var s, c;
          var m = l.className,
              B = l.attributes,
              z = l.setAttributes,
              L = l.toggleSelection,
              V = l.isSelected,
              A = l.clientId;

          var R = B.label,
              O = B.showLabel,
              D = B.placeholder,
              F = B.width,
              G = B.widthUnit,
              q = B.align,
              W = B.buttonText,
              U = B.buttonPosition,
              $ = B.buttonUseIcon,
              Z = B.style,
              K = (0, k.useSelect)(function (l) {
            var s;

            var _l73 = l(y.store),
                c = _l73.getBlockParentsByBlockName,
                m = _l73.wasBlockJustInserted;

            return !(null === (s = c(A, "core/navigation")) || void 0 === s || !s.length) && m(A);
          }, [A]),
              _ref337 = (0, k.useDispatch)(y.store),
              Q = _ref337.__unstableMarkNextChangeAsNotPersistent;

          (0, v.useEffect)(function () {
            K && (Q(), z({
              showLabel: !1,
              buttonUseIcon: !0,
              buttonPosition: "button-inside"
            }));
          }, [K]);
          var Y = null == Z || null === (s = Z.border) || void 0 === s ? void 0 : s.radius,
              X = null == Z || null === (c = Z.border) || void 0 === c ? void 0 : c.color,
              J = (0, y.__experimentalUseBorderProps)(B);
          "number" == typeof Y && (J.style.borderRadius = "".concat(Y, "px"));

          var ee = (0, y.__experimentalUseColorProps)(B),
              te = "wp-block-search__width-".concat((0, w.useInstanceId)(y.__experimentalUnitControl)),
              re = "button-inside" === U,
              ae = "button-outside" === U,
              oe = "no-button" === U,
              ne = "button-only" === U,
              le = (0, E.__experimentalUseCustomUnits)({
            availableUnits: ["%", "px"],
            defaultValues: {
              "%": T.PC_WIDTH_DEFAULT,
              px: T.PX_WIDTH_DEFAULT
            }
          }),
              ie = [{
            role: "menuitemradio",
            title: (0, S.__)("Button outside"),
            isActive: "button-outside" === U,
            icon: P.buttonOutside,
            onClick: function onClick() {
              z({
                buttonPosition: "button-outside"
              });
            }
          }, {
            role: "menuitemradio",
            title: (0, S.__)("Button inside"),
            isActive: "button-inside" === U,
            icon: P.buttonInside,
            onClick: function onClick() {
              z({
                buttonPosition: "button-inside"
              });
            }
          }, {
            role: "menuitemradio",
            title: (0, S.__)("No button"),
            isActive: "no-button" === U,
            icon: P.noButton,
            onClick: function onClick() {
              z({
                buttonPosition: "no-button"
              });
            }
          }],
              renderTextField = function renderTextField() {
            var l = (0, _.default)("wp-block-search__input", re ? void 0 : J.className),
                s = re ? {
              borderRadius: Y
            } : J.style;
            return (0, v.createElement)("input", {
              className: l,
              style: s,
              "aria-label": (0, S.__)("Optional placeholder text"),
              placeholder: D ? void 0 : (0, S.__)("Optional placeholder…"),
              value: D,
              onChange: function onChange(l) {
                return z({
                  placeholder: l.target.value
                });
              }
            });
          },
              renderButton = function renderButton() {
            var l = (0, _.default)("wp-block-search__button", ee.className, re ? void 0 : J.className, $ ? "has-icon" : void 0),
                s = _objectSpread(_objectSpread({}, ee.style), re ? {
              borderRadius: Y
            } : J.style);

            return (0, v.createElement)(v.Fragment, null, $ && (0, v.createElement)("button", {
              type: "button",
              className: l,
              style: s
            }, (0, v.createElement)(C.Icon, {
              icon: C.search
            })), !$ && (0, v.createElement)(y.RichText, {
              className: l,
              style: s,
              "aria-label": (0, S.__)("Button text"),
              placeholder: (0, S.__)("Add button text…"),
              withoutInteractiveFormatting: !0,
              value: W,
              onChange: function onChange(l) {
                return z({
                  buttonText: l
                });
              }
            }));
          },
              se = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, null, (0, v.createElement)(E.ToolbarGroup, null, (0, v.createElement)(E.ToolbarButton, {
            title: (0, S.__)("Toggle search label"),
            icon: P.toggleLabel,
            onClick: function onClick() {
              z({
                showLabel: !O
              });
            },
            className: O ? "is-pressed" : void 0
          }), (0, v.createElement)(E.ToolbarDropdownMenu, {
            icon: function () {
              switch (U) {
                case "button-inside":
                  return P.buttonInside;

                case "button-outside":
                  return P.buttonOutside;

                case "no-button":
                  return P.noButton;

                case "button-only":
                  return P.buttonOnly;
              }
            }(),
            label: (0, S.__)("Change button position"),
            controls: ie
          }), !oe && (0, v.createElement)(E.ToolbarButton, {
            title: (0, S.__)("Use button with icon"),
            icon: P.buttonWithIcon,
            onClick: function onClick() {
              z({
                buttonUseIcon: !$
              });
            },
            className: $ ? "is-pressed" : void 0
          }))), (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, S.__)("Display Settings")
          }, (0, v.createElement)(E.BaseControl, {
            label: (0, S.__)("Width"),
            id: te
          }, (0, v.createElement)(y.__experimentalUnitControl, {
            id: te,
            min: "".concat(T.MIN_WIDTH).concat(T.MIN_WIDTH_UNIT),
            onChange: function onChange(l) {
              var s = "%" === G && parseInt(l, 10) > 100 ? 100 : l;
              z({
                width: parseInt(s, 10)
              });
            },
            onUnitChange: function onUnitChange(l) {
              z({
                width: "%" === l ? T.PC_WIDTH_DEFAULT : T.PX_WIDTH_DEFAULT,
                widthUnit: l
              });
            },
            style: {
              maxWidth: 80
            },
            value: "".concat(F).concat(G),
            unit: G,
            units: le
          }), (0, v.createElement)(E.ButtonGroup, {
            className: "wp-block-search__components-button-group",
            "aria-label": (0, S.__)("Percentage Width")
          }, [25, 50, 75, 100].map(function (l) {
            return (0, v.createElement)(E.Button, {
              key: l,
              isSmall: !0,
              variant: "".concat(l, "%") == "".concat(F).concat(G) ? 0 : void 0,
              onClick: function onClick() {
                return z({
                  width: l,
                  widthUnit: "%"
                });
              }
            }, l, "%");
          })))))),
              padBorderRadius = function padBorderRadius(l) {
            return l ? "calc(".concat(l, " + 4px)") : void 0;
          },
              ce = (0, y.useBlockProps)({
            className: (0, _.default)(m, re ? void 0 : J.className, re ? "wp-block-search__button-inside" : void 0, ae ? "wp-block-search__button-outside" : void 0, oe ? "wp-block-search__no-button" : void 0, ne ? "wp-block-search__button-only" : void 0, $ || oe ? void 0 : "wp-block-search__text-button", $ && !oe ? "wp-block-search__icon-button" : void 0)
          });

          return (0, v.createElement)("div", ce, se, O && (0, v.createElement)(y.RichText, {
            className: "wp-block-search__label",
            "aria-label": (0, S.__)("Label text"),
            placeholder: (0, S.__)("Add label…"),
            withoutInteractiveFormatting: !0,
            value: R,
            onChange: function onChange(l) {
              return z({
                label: l
              });
            }
          }), (0, v.createElement)(E.ResizableBox, {
            size: {
              width: "".concat(F).concat(G)
            },
            className: (0, _.default)("wp-block-search__inside-wrapper", re ? J.className : void 0),
            style: function () {
              var l = {
                borderColor: X
              },
                  s = 0 !== parseInt(Y, 10);

              if (re && s) {
                if ("object" == typeof Y) {
                  var _s24 = Y.topLeft,
                      _c10 = Y.topRight,
                      _m7 = Y.bottomLeft,
                      _v2 = Y.bottomRight;
                  return _objectSpread({
                    borderTopLeftRadius: padBorderRadius(_s24),
                    borderTopRightRadius: padBorderRadius(_c10),
                    borderBottomLeftRadius: padBorderRadius(_m7),
                    borderBottomRightRadius: padBorderRadius(_v2)
                  }, l);
                }

                var _s23 = Number.isInteger(Y) ? "".concat(Y, "px") : Y;

                l.borderRadius = "calc(".concat(_s23, " + 4px)");
              }

              return l;
            }(),
            minWidth: T.MIN_WIDTH,
            enable: ne ? {} : {
              right: "right" !== q,
              left: "right" === q
            },
            onResizeStart: function onResizeStart(l, s, c) {
              z({
                width: parseInt(c.offsetWidth, 10),
                widthUnit: "px"
              }), L(!1);
            },
            onResizeStop: function onResizeStop(l, s, c, m) {
              z({
                width: parseInt(F + m.width, 10)
              }), L(!0);
            },
            showHandle: V
          }, (re || ae) && (0, v.createElement)(v.Fragment, null, renderTextField(), renderButton()), ne && renderButton(), oe && renderTextField()));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(8467),
            E = c(4892),
            w = c(3200),
            C = c(5303),
            S = c(6756),
            P = c(895),
            T = c(8255);
      },
      895: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.toggleLabel = s.noButton = s.buttonWithIcon = s.buttonOutside = s.buttonOnly = s.buttonInside = void 0;
        var m = c(1753),
            v = c(4892);

        var _ = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "7",
          y: "10",
          width: "10",
          height: "4",
          rx: "1",
          fill: "currentColor"
        }));

        s.buttonOnly = _;
        var y = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "4.75",
          y: "15.25",
          width: "6.5",
          height: "9.5",
          transform: "rotate(-90 4.75 15.25)",
          stroke: "currentColor",
          strokeWidth: "1.5",
          fill: "none"
        }), (0, m.createElement)(v.Rect, {
          x: "16",
          y: "10",
          width: "4",
          height: "4",
          rx: "1",
          fill: "currentColor"
        }));
        s.buttonOutside = y;
        var k = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "4.75",
          y: "15.25",
          width: "6.5",
          height: "14.5",
          transform: "rotate(-90 4.75 15.25)",
          stroke: "currentColor",
          strokeWidth: "1.5",
          fill: "none"
        }), (0, m.createElement)(v.Rect, {
          x: "14",
          y: "10",
          width: "4",
          height: "4",
          rx: "1",
          fill: "currentColor"
        }));
        s.buttonInside = k;
        var E = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "4.75",
          y: "15.25",
          width: "6.5",
          height: "14.5",
          transform: "rotate(-90 4.75 15.25)",
          stroke: "currentColor",
          fill: "none",
          strokeWidth: "1.5"
        }));
        s.noButton = E;
        var w = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "4.75",
          y: "7.75",
          width: "14.5",
          height: "8.5",
          rx: "1.25",
          stroke: "currentColor",
          fill: "none",
          strokeWidth: "1.5"
        }), (0, m.createElement)(v.Rect, {
          x: "8",
          y: "11",
          width: "8",
          height: "2",
          fill: "currentColor"
        }));
        s.buttonWithIcon = w;
        var C = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Rect, {
          x: "4.75",
          y: "17.25",
          width: "5.5",
          height: "14.5",
          transform: "rotate(-90 4.75 17.25)",
          stroke: "currentColor",
          fill: "none",
          strokeWidth: "1.5"
        }), (0, m.createElement)(v.Rect, {
          x: "4",
          y: "7",
          width: "10",
          height: "2",
          fill: "currentColor"
        }));
        s.toggleLabel = C;
      },
      5093: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(7772)),
            y = m(c(3720));

        var k = {
          apiVersion: 2,
          name: "core/search",
          title: "Search",
          category: "widgets",
          description: "Help visitors find your content.",
          keywords: ["find"],
          textdomain: "default",
          attributes: {
            label: {
              type: "string",
              __experimentalRole: "content"
            },
            showLabel: {
              type: "boolean",
              default: !0
            },
            placeholder: {
              type: "string",
              default: "",
              __experimentalRole: "content"
            },
            width: {
              type: "number"
            },
            widthUnit: {
              type: "string"
            },
            buttonText: {
              type: "string",
              __experimentalRole: "content"
            },
            buttonPosition: {
              type: "string",
              default: "button-outside"
            },
            buttonUseIcon: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            align: ["left", "center", "right"],
            color: {
              gradients: !0,
              __experimentalSkipSerialization: !0
            },
            __experimentalBorder: {
              color: !0,
              radius: !0,
              __experimentalSkipSerialization: !0
            },
            html: !1
          },
          editorStyle: "wp-block-search-editor",
          style: "wp-block-search"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.search,
          example: {},
          variations: y.default,
          edit: _.default
        };
        s.settings = w;
      },
      8255: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.PX_WIDTH_DEFAULT = s.PC_WIDTH_DEFAULT = s.MIN_WIDTH_UNIT = s.MIN_WIDTH = void 0, s.isPercentageUnit = function isPercentageUnit(l) {
          return "%" === l;
        };
        s.PC_WIDTH_DEFAULT = 50;
        s.PX_WIDTH_DEFAULT = 350;
        s.MIN_WIDTH = 220;
        s.MIN_WIDTH_UNIT = "px";
      },
      3720: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6756);
        var v = [{
          name: "default",
          isDefault: !0,
          attributes: {
            buttonText: (0, m.__)("Search"),
            label: (0, m.__)("Search")
          }
        }];
        s.default = v;
      },
      1702: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4892),
            k = c(1326),
            E = m(c(4669));

        var w = (0, k.withColors)("color", {
          textColor: "color"
        })(function SeparatorEdit(l) {
          var s = l.color,
              c = l.setColor,
              m = l.className;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.HorizontalRule, (0, k.useBlockProps)({
            className: (0, _.default)(m, _defineProperty({
              "has-background": s.color
            }, s.class, s.class)),
            style: {
              backgroundColor: s.color,
              color: s.color
            }
          })), (0, v.createElement)(E.default, {
            color: s,
            setColor: c
          }));
        });
        s.default = w;
      },
      5411: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(1702)),
            y = m(c(881)),
            k = m(c(3342));

        var E = {
          apiVersion: 2,
          name: "core/separator",
          title: "Separator",
          category: "design",
          description: "Create a break between ideas or sections with a horizontal separator.",
          keywords: ["horizontal-line", "hr", "divider"],
          textdomain: "default",
          attributes: {
            color: {
              type: "string"
            },
            customColor: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            align: ["center", "wide", "full"]
          },
          styles: [{
            name: "default",
            label: "Default",
            isDefault: !0
          }, {
            name: "wide",
            label: "Wide Line"
          }, {
            name: "dots",
            label: "Dots"
          }],
          editorStyle: "wp-block-separator-editor",
          style: "wp-block-separator"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.separator,
          example: {
            attributes: {
              customColor: "#065174",
              className: "is-style-wide"
            }
          },
          transforms: k.default,
          edit: _.default,
          save: y.default
        };
        s.settings = C;
      },
      881: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function separatorSave(l) {
          var _ref339;

          var s = l.attributes;
          var c = s.color,
              m = s.customColor,
              k = (0, y.getColorClassName)("background-color", c),
              E = (0, y.getColorClassName)("color", c),
              w = (0, _.default)((_ref339 = {
            "has-text-color has-background": c || m
          }, _defineProperty(_ref339, k, k), _defineProperty(_ref339, E, E), _ref339)),
              C = {
            backgroundColor: k ? void 0 : m,
            color: E ? void 0 : m
          };
          return (0, v.createElement)("hr", y.useBlockProps.save({
            className: w,
            style: C
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      4669: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(1326);

        var _default = function _default(l) {
          var s = l.color,
              c = l.setColor;
          return (0, m.createElement)(_.InspectorControls, null, (0, m.createElement)(_.PanelColorSettings, {
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0,
            title: (0, v.__)("Color"),
            colorSettings: [{
              value: s.color,
              onChange: c,
              label: (0, v.__)("Color")
            }]
          }));
        };

        s.default = _default;
      },
      3342: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "enter",
            regExp: /^-{3,}$/,
            transform: function transform() {
              return (0, m.createBlock)("core/separator");
            }
          }, {
            type: "raw",
            selector: "hr",
            schema: {
              hr: {}
            }
          }]
        };
        s.default = v;
      },
      4296: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ShortcodeEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var E = (0, y.useInstanceId)(ShortcodeEdit),
              w = "blocks-shortcode-input-".concat(E);
          return (0, m.createElement)("div", (0, _.useBlockProps)({
            className: "components-placeholder"
          }), (0, m.createElement)("label", {
            htmlFor: w,
            className: "components-placeholder__label"
          }, (0, m.createElement)(k.Icon, {
            icon: k.shortcode
          }), (0, v.__)("Shortcode")), (0, m.createElement)(_.PlainText, {
            className: "blocks-shortcode__textarea",
            id: w,
            value: s.text,
            "aria-label": (0, v.__)("Shortcode text"),
            placeholder: (0, v.__)("Write shortcode here…"),
            onChange: function onChange(l) {
              return c({
                text: l
              });
            }
          }));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(1326),
            y = c(3200),
            k = c(5303);
      },
      678: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(4296)),
            y = m(c(8887)),
            k = m(c(7193));

        var E = {
          apiVersion: 2,
          name: "core/shortcode",
          title: "Shortcode",
          category: "widgets",
          description: "Insert additional custom elements with a WordPress shortcode.",
          textdomain: "default",
          attributes: {
            text: {
              type: "string",
              source: "html"
            }
          },
          supports: {
            className: !1,
            customClassName: !1,
            html: !1
          },
          editorStyle: "wp-block-shortcode-editor"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          icon: v.shortcode,
          transforms: k.default,
          edit: _.default,
          save: y.default
        };
        s.settings = C;
      },
      8887: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          return (0, m.createElement)(m.RawHTML, null, s.text);
        };
        var m = c(1753);
      },
      7193: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(9568);
        var v = {
          from: [{
            type: "shortcode",
            tag: "[a-z][a-z0-9_-]*",
            attributes: {
              text: {
                type: "string",
                shortcode: function shortcode(l, s) {
                  var c = s.content;
                  return (0, m.removep)((0, m.autop)(c));
                }
              }
            },
            priority: 20
          }]
        };
        s.default = v;
      },
      835: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LogoEdit(l) {
          var s = l.attributes,
              c = l.className,
              m = l.setAttributes,
              y = l.isSelected;

          var k = s.className,
              C = s.width,
              V = s.shouldSyncIcon,
              _ref340 = (0, v.useState)(),
              _ref341 = _slicedToArray2(_ref340, 2),
              A = _ref341[0],
              D = _ref341[1],
              F = (0, v.useRef)(),
              _ref342 = (0, P.useSelect)(function (l) {
            var _l74 = l(T.store),
                s = _l74.canUser,
                c = _l74.getEntityRecord,
                m = _l74.getEditedEntityRecord,
                v = m("root", "site"),
                _ = c("root", "__unstableBase"),
                y = null == v ? void 0 : v.site_logo,
                k = null == _ ? void 0 : _.site_logo,
                E = s("update", "settings"),
                w = E ? y : k,
                C = null == v ? void 0 : v.site_icon,
                S = w && l(T.store).getMedia(w, {
              context: "view"
            }),
                P = w && !l(T.store).hasFinishedResolution("getMedia", [w, {
              context: "view"
            }]);

            return {
              siteLogoId: w,
              canUserEdit: E,
              url: null == _ ? void 0 : _.url,
              mediaItemData: S && {
                id: S.id,
                url: S.source_url,
                alt: S.alt_text
              },
              isRequestingMediaItem: P,
              siteIconId: C
            };
          }, []),
              G = _ref342.siteLogoId,
              q = _ref342.canUserEdit,
              W = _ref342.url,
              U = _ref342.siteIconId,
              $ = _ref342.mediaItemData,
              Z = _ref342.isRequestingMediaItem,
              _ref343 = (0, P.useSelect)(S.store),
              K = _ref343.getGlobalBlockCount,
              _ref344 = (0, P.useDispatch)(T.store),
              Q = _ref344.editEntityRecord;

          (0, v.useEffect)(function () {
            return function () {
              if (null != k && k.includes("block-editor-block-types-list__site-logo-example") || null != k && k.includes("block-editor-block-styles__block-preview-container")) return;
              0 === K("core/site-logo") && Q("root", "site", void 0, {
                site_logo: void 0,
                site_icon: void 0
              });
            };
          }, []);

          var setLogo = function setLogo(l) {
            var s = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            (V || s) && setIcon(l), Q("root", "site", void 0, {
              site_logo: l
            });
          },
              setIcon = function setIcon(l) {
            return Q("root", "site", void 0, {
              site_icon: l
            });
          };

          var Y = null;
          $ && (Y = $.alt, A !== $.url && D($.url));

          var onSelectLogo = function onSelectLogo(l) {
            var s = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (l) return !l.id && l.url ? (setLogo(void 0), void D(l.url)) : void setLogo(l.id, s);
          },
              _ref345 = (0, P.useDispatch)(L.store),
              X = _ref345.createErrorNotice,
              onUploadError = function onUploadError(l) {
            X(l[2], {
              type: "snackbar"
            });
          },
              J = q && A && (0, v.createElement)(S.BlockControls, {
            group: "other"
          }, (0, v.createElement)(S.MediaReplaceFlow, {
            mediaURL: A,
            allowedTypes: R,
            accept: O,
            onSelect: onSelectLogo,
            onError: onUploadError
          }, (0, v.createElement)(w.MenuItem, {
            onClick: function onClick() {
              setLogo(null), D(void 0), m({
                width: void 0
              });
            }
          }, (0, E.__)("Reset"))));

          var ee;
          var te = void 0 === G || Z;
          te && (ee = (0, v.createElement)(w.Spinner, null));
          A && (ee = (0, v.createElement)(SiteLogo, {
            alt: Y,
            attributes: s,
            className: c,
            containerRef: F,
            isSelected: y,
            setAttributes: m,
            logoUrl: A,
            setLogo: setLogo,
            logoId: (null == $ ? void 0 : $.id) || G,
            siteUrl: W,
            setIcon: setIcon,
            iconId: U,
            canUserEdit: q
          }));
          var re = (0, _.default)(c, {
            "is-default-size": !C
          }),
              ae = (0, S.useBlockProps)({
            ref: F,
            className: re
          }),
              oe = (0, E.__)("Add a site logo");
          return (0, v.createElement)("div", ae, J, !!A && ee, !A && !q && (0, v.createElement)(w.Placeholder, {
            className: "site-logo_placeholder"
          }, te && (0, v.createElement)("span", {
            className: "components-placeholder__preview"
          }, (0, v.createElement)(w.Spinner, null))), !A && q && (0, v.createElement)(S.MediaPlaceholder, {
            onSelect: function onSelect(l) {
              if (void 0 === V) {
                var _s25 = !U;

                return m({
                  shouldSyncIcon: _s25
                }), void onSelectLogo(l, _s25);
              }

              onSelectLogo(l);
            },
            accept: O,
            allowedTypes: R,
            onError: onUploadError,
            placeholder: function placeholder(l) {
              var s = (0, _.default)("block-editor-media-placeholder", c);
              return (0, v.createElement)(w.Placeholder, {
                className: s,
                preview: ee
              }, (0, v.createElement)(z.SVG, {
                className: "components-placeholder__illustration",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 60 60"
              }, (0, v.createElement)(z.Path, {
                vectorEffect: "non-scaling-stroke",
                d: "m61 32.622-13.555-9.137-15.888 9.859a5 5 0 0 1-5.386-.073l-9.095-5.989L1 37.5"
              })), l);
            },
            mediaLibraryButton: function mediaLibraryButton(l) {
              var s = l.open;
              return (0, v.createElement)(w.Button, {
                icon: B.upload,
                variant: "primary",
                label: oe,
                showTooltip: !0,
                tooltipPosition: "top center",
                onClick: function onClick() {
                  s();
                }
              });
            }
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(4793),
            k = c(9388),
            E = c(6756),
            w = c(4892),
            C = c(3200),
            S = c(1326),
            P = c(8467),
            T = c(1295),
            B = c(5303),
            z = c(1666),
            L = c(8448),
            V = m(c(4124)),
            A = c(7814);

        var R = ["image"],
            O = "image/*",
            SiteLogo = function SiteLogo(l) {
          var s = l.alt,
              _l$attributes26 = l.attributes,
              c = _l$attributes26.align,
              m = _l$attributes26.width,
              z = _l$attributes26.height,
              L = _l$attributes26.isLink,
              R = _l$attributes26.linkTarget,
              O = _l$attributes26.shouldSyncIcon,
              D = l.containerRef,
              F = l.isSelected,
              G = l.setAttributes,
              q = l.setLogo,
              W = l.logoUrl,
              U = l.siteUrl,
              $ = l.logoId,
              Z = l.iconId,
              K = l.setIcon,
              Q = l.canUserEdit;

          var Y = (0, V.default)(D, [c]),
              X = (0, C.useViewportMatch)("medium"),
              J = !(0, y.includes)(["wide", "full"], c) && X,
              _ref346 = (0, v.useState)({}),
              _ref347 = _slicedToArray2(_ref346, 2),
              _ref347$ = _ref347[0],
              ee = _ref347$.naturalWidth,
              te = _ref347$.naturalHeight,
              re = _ref347[1],
              _ref348 = (0, v.useState)(!1),
              _ref349 = _slicedToArray2(_ref348, 2),
              ae = _ref349[0],
              oe = _ref349[1],
              _ref350 = (0, P.useDispatch)(S.store),
              ne = _ref350.toggleSelection,
              le = (0, _.default)("custom-logo-link", {
            "is-transient": (0, k.isBlobURL)(W)
          }),
              _ref351 = (0, P.useSelect)(function (l) {
            var _l75 = l(S.store),
                s = _l75.getSettings;

            return _objectSpread({
              title: l(T.store).getEditedEntityRecord("root", "site").title
            }, (0, y.pick)(s(), ["imageEditing", "maxWidth"]));
          }, []),
              ie = _ref351.imageEditing,
              se = _ref351.maxWidth,
              ce = _ref351.title;

          (0, v.useEffect)(function () {
            O && $ !== Z && G({
              shouldSyncIcon: !1
            });
          }, []), (0, v.useEffect)(function () {
            F || oe(!1);
          }, [F]);
          var ue = (0, v.createElement)("img", {
            className: "custom-logo",
            src: W,
            alt: s,
            onLoad: function onLoad(l) {
              re((0, y.pick)(l.target, ["naturalWidth", "naturalHeight"]));
            }
          });
          var de,
              me = ue;

          if (L && (me = (0, v.createElement)("a", {
            href: U,
            className: le,
            rel: "home",
            title: ce,
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, ue)), Y && ee && te) {
            de = ee > Y ? Y : ee;
          }

          if (!J || !de) return (0, v.createElement)("div", {
            style: {
              width: m,
              height: z
            }
          }, me);

          var pe = m || 120,
              ge = ee / te,
              ve = pe / ge,
              he = ee < te ? A.MIN_SIZE : Math.ceil(A.MIN_SIZE * ge),
              be = te < ee ? A.MIN_SIZE : Math.ceil(A.MIN_SIZE / ge),
              _e = 2.5 * se;

          var fe = !1,
              ye = !1;
          "center" === c ? (fe = !0, ye = !0) : (0, E.isRTL)() ? "left" === c ? fe = !0 : ye = !0 : "right" === c ? ye = !0 : fe = !0;
          var ke = $ && ee && te && ie,
              Ee = ke && ae ? (0, v.createElement)(S.__experimentalImageEditingProvider, {
            id: $,
            url: W,
            naturalWidth: ee,
            naturalHeight: te,
            clientWidth: Y,
            onSaveImage: function onSaveImage(l) {
              q(l.id);
            },
            isEditing: ae,
            onFinishEditing: function onFinishEditing() {
              return oe(!1);
            }
          }, (0, v.createElement)(S.__experimentalImageEditor, {
            url: W,
            width: pe,
            height: ve,
            clientWidth: Y,
            naturalHeight: te,
            naturalWidth: ee
          })) : (0, v.createElement)(w.ResizableBox, {
            size: {
              width: pe,
              height: ve
            },
            showHandle: F,
            minWidth: he,
            maxWidth: _e,
            minHeight: be,
            maxHeight: _e / ge,
            lockAspectRatio: !0,
            enable: {
              top: !1,
              right: fe,
              bottom: !0,
              left: ye
            },
            onResizeStart: function onResizeStart() {
              ne(!1);
            },
            onResizeStop: function onResizeStop(l, s, c, m) {
              !function onResizeStop() {
                ne(!0);
              }(), G({
                width: parseInt(pe + m.width, 10),
                height: parseInt(ve + m.height, 10)
              });
            }
          }, me),
              we = (0, v.createInterpolateElement)((0, E.__)("Site Icons are what you see in browser tabs, bookmark bars, and within the WordPress mobile apps. To use a custom icon that is different from your site logo, use the <a>Site Icon settings</a>."), {
            a: (0, v.createElement)("a", {
              href: U + "/wp-admin/customize.php?autofocus[section]=title_tagline",
              target: "_blank",
              rel: "noopener noreferrer"
            })
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(S.InspectorControls, null, (0, v.createElement)(w.PanelBody, {
            title: (0, E.__)("Settings")
          }, (0, v.createElement)(w.RangeControl, {
            label: (0, E.__)("Image width"),
            onChange: function onChange(l) {
              return G({
                width: l
              });
            },
            min: he,
            max: _e,
            initialPosition: Math.min(120, _e),
            value: m || "",
            disabled: !J
          }), (0, v.createElement)(w.ToggleControl, {
            label: (0, E.__)("Link image to home"),
            onChange: function onChange() {
              return G({
                isLink: !L
              });
            },
            checked: L
          }), L && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.ToggleControl, {
            label: (0, E.__)("Open in new tab"),
            onChange: function onChange(l) {
              return G({
                linkTarget: l ? "_blank" : "_self"
              });
            },
            checked: "_blank" === R
          })), Q && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.ToggleControl, {
            label: (0, E.__)("Use as site icon"),
            onChange: function onChange(l) {
              G({
                shouldSyncIcon: l
              }), K(l ? $ : void 0);
            },
            checked: !!O,
            help: we
          })))), (0, v.createElement)(S.BlockControls, {
            group: "block"
          }, ke && !ae && (0, v.createElement)(w.ToolbarButton, {
            onClick: function onClick() {
              return oe(!0);
            },
            icon: B.crop,
            label: (0, E.__)("Crop")
          })), Ee);
        };
      },
      4210: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(835));

        var y = {
          apiVersion: 2,
          name: "core/site-logo",
          title: "Site Logo",
          category: "theme",
          description: "Display a graphic to represent this site. Update the block, and the changes apply everywhere it’s used. This is different than the site icon, which is the smaller image visible in your dashboard, browser tabs, etc used to help others recognize this site.",
          textdomain: "default",
          attributes: {
            width: {
              type: "number"
            },
            isLink: {
              type: "boolean",
              default: !0
            },
            linkTarget: {
              type: "string",
              default: "_self"
            },
            shouldSyncIcon: {
              type: "boolean"
            }
          },
          example: {
            viewportWidth: 500,
            attributes: {
              width: 350,
              className: "block-editor-block-types-list__site-logo-example"
            }
          },
          supports: {
            html: !1,
            align: !0,
            alignWide: !1,
            color: {
              __experimentalDuotone: "img",
              text: !1,
              background: !1
            }
          },
          styles: [{
            name: "default",
            label: "Default",
            isDefault: !0
          }, {
            name: "rounded",
            label: "Rounded"
          }],
          editorStyle: "wp-block-site-logo-editor",
          style: "wp-block-site-logo"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.siteLogo,
          edit: _.default
        };
        s.settings = E;
      },
      4928: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0
            },
            spacing: {
              margin: !0,
              padding: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalTextTransform: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      4347: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function SiteTaglineEdit(l) {
          var _ref355;

          var s = l.attributes,
              c = l.setAttributes;

          var m = s.textAlign,
              _ref352 = (0, E.useEntityProp)("root", "site", "description"),
              _ref353 = _slicedToArray2(_ref352, 2),
              S = _ref353[0],
              P = _ref353[1],
              _ref354 = (0, k.useSelect)(function (l) {
            var _l76 = l(E.store),
                s = _l76.canUser,
                c = _l76.getEntityRecord,
                m = c("root", "__unstableBase");

            return {
              canUserEdit: s("update", "settings"),
              readOnlySiteTagLine: null == m ? void 0 : m.description
            };
          }, []),
              T = _ref354.canUserEdit,
              B = _ref354.readOnlySiteTagLine,
              z = (0, w.useBlockProps)({
            className: (0, y.default)((_ref355 = {}, _defineProperty(_ref355, "has-text-align-".concat(m), m), _defineProperty(_ref355, "wp-block-site-tagline__placeholder", !T && !B), _ref355))
          }),
              L = T ? (0, v.createElement)(w.RichText, (0, _.default)({
            allowedFormats: [],
            onChange: P,
            "aria-label": (0, C.__)("Site tagline text"),
            placeholder: (0, C.__)("Write site tagline…"),
            tagName: "p",
            value: S
          }, z)) : (0, v.createElement)("p", z, B || (0, C.__)("Site Tagline placeholder"));

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, (0, v.createElement)(w.AlignmentControl, {
            onChange: function onChange(l) {
              return c({
                textAlign: l
              });
            },
            value: m
          })), L);
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(8467),
            E = c(1295),
            w = c(1326),
            C = c(6756);
      },
      7478: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24"
        }, (0, m.createElement)(v.Path, {
          fill: "none",
          d: "M0 0h24v24H0z"
        }), (0, m.createElement)(v.Path, {
          d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
        }));

        s.default = _;
      },
      5976: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(4347)),
            _ = m(c(7478)),
            y = m(c(4928));

        var k = {
          apiVersion: 2,
          name: "core/site-tagline",
          title: "Site Tagline",
          category: "theme",
          description: "Describe in a few words what the website is about. The tagline can be used in search results or when sharing on social networks even if it's not displayed in the theme design.",
          keywords: ["description"],
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0
            },
            spacing: {
              margin: !0,
              padding: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalTextTransform: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          editorStyle: "wp-block-site-tagline-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: _.default,
          edit: v.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      3823: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var v = [{
          attributes: {
            level: {
              type: "number",
              default: 1
            },
            textAlign: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !0
            },
            linkTarget: {
              type: "string",
              default: "_self"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              padding: !0,
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalTextTransform: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0
            }
          },
          save: function save() {
            return null;
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }];
        s.default = v;
      },
      6907: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function SiteTitleEdit(l) {
          var _ref359;

          var s = l.attributes,
              c = l.setAttributes,
              m = l.insertBlocksAfter;

          var B = s.level,
              z = s.textAlign,
              L = s.isLink,
              V = s.linkTarget,
              _ref356 = (0, k.useEntityProp)("root", "site", "title"),
              _ref357 = _slicedToArray2(_ref356, 2),
              A = _ref357[0],
              R = _ref357[1],
              _ref358 = (0, y.useSelect)(function (l) {
            var _l77 = l(k.store),
                s = _l77.canUser,
                c = _l77.getEntityRecord,
                m = c("root", "__unstableBase");

            return {
              canUserEdit: s("update", "settings"),
              readOnlyTitle: (0, P.decodeEntities)(null == m ? void 0 : m.name)
            };
          }, []),
              O = _ref358.canUserEdit,
              D = _ref358.readOnlyTitle,
              F = 0 === B ? "p" : "h".concat(B),
              G = (0, w.useBlockProps)({
            className: (0, _.default)((_ref359 = {}, _defineProperty(_ref359, "has-text-align-".concat(z), z), _defineProperty(_ref359, "wp-block-site-title__placeholder", !O && !D), _ref359))
          }),
              q = O ? (0, v.createElement)(F, G, (0, v.createElement)(w.RichText, {
            tagName: L ? "a" : "span",
            href: L ? "#site-title-pseudo-link" : void 0,
            "aria-label": (0, E.__)("Site title text"),
            placeholder: (0, E.__)("Write site title…"),
            value: A,
            onChange: R,
            allowedFormats: [],
            disableLineBreaks: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return m((0, S.createBlock)((0, S.getDefaultBlockName)()));
            }
          })) : (0, v.createElement)(F, G, L ? (0, v.createElement)("a", {
            href: "#site-title-pseudo-link",
            onClick: function onClick(l) {
              return l.preventDefault();
            }
          }, D || (0, E.__)("Site Title placeholder")) : (0, v.createElement)("span", null, A || D));

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.BlockControls, {
            group: "block"
          }, (0, v.createElement)(T.default, {
            level: B,
            onChange: function onChange(l) {
              return c({
                level: l
              });
            }
          }), (0, v.createElement)(w.AlignmentControl, {
            value: z,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(C.PanelBody, {
            title: (0, E.__)("Link settings")
          }, (0, v.createElement)(C.ToggleControl, {
            label: (0, E.__)("Make title link to home"),
            onChange: function onChange() {
              return c({
                isLink: !L
              });
            },
            checked: L
          }), L && (0, v.createElement)(C.ToggleControl, {
            label: (0, E.__)("Open in new tab"),
            onChange: function onChange(l) {
              return c({
                linkTarget: l ? "_blank" : "_self"
              });
            },
            checked: "_blank" === V
          }))), q);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(8467),
            k = c(1295),
            E = c(6756),
            w = c(1326),
            C = c(4892),
            S = c(6700),
            P = c(3248),
            T = m(c(6400));
      },
      4983: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LevelIcon(l) {
          var s = l.level,
              _l$isPressed2 = l.isPressed,
              c = _l$isPressed2 === void 0 ? !1 : _l$isPressed2;
          if (0 === s) return _.paragraph;
          return (0, m.createElement)(v.SVG, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            isPressed: c
          }, (0, m.createElement)(v.Path, {
            d: {
              1: "M9 5h2v10H9v-4H5v4H3V5h2v4h4V5zm6.6 0c-.6.9-1.5 1.7-2.6 2v1h2v7h2V5h-1.4z",
              2: "M7 5h2v10H7v-4H3v4H1V5h2v4h4V5zm8 8c.5-.4.6-.6 1.1-1.1.4-.4.8-.8 1.2-1.3.3-.4.6-.8.9-1.3.2-.4.3-.8.3-1.3 0-.4-.1-.9-.3-1.3-.2-.4-.4-.7-.8-1-.3-.3-.7-.5-1.2-.6-.5-.2-1-.2-1.5-.2-.4 0-.7 0-1.1.1-.3.1-.7.2-1 .3-.3.1-.6.3-.9.5-.3.2-.6.4-.8.7l1.2 1.2c.3-.3.6-.5 1-.7.4-.2.7-.3 1.2-.3s.9.1 1.3.4c.3.3.5.7.5 1.1 0 .4-.1.8-.4 1.1-.3.5-.6.9-1 1.2-.4.4-1 .9-1.6 1.4-.6.5-1.4 1.1-2.2 1.6V15h8v-2H15z",
              3: "M12.1 12.2c.4.3.8.5 1.2.7.4.2.9.3 1.4.3.5 0 1-.1 1.4-.3.3-.1.5-.5.5-.8 0-.2 0-.4-.1-.6-.1-.2-.3-.3-.5-.4-.3-.1-.7-.2-1-.3-.5-.1-1-.1-1.5-.1V9.1c.7.1 1.5-.1 2.2-.4.4-.2.6-.5.6-.9 0-.3-.1-.6-.4-.8-.3-.2-.7-.3-1.1-.3-.4 0-.8.1-1.1.3-.4.2-.7.4-1.1.6l-1.2-1.4c.5-.4 1.1-.7 1.6-.9.5-.2 1.2-.3 1.8-.3.5 0 1 .1 1.6.2.4.1.8.3 1.2.5.3.2.6.5.8.8.2.3.3.7.3 1.1 0 .5-.2.9-.5 1.3-.4.4-.9.7-1.5.9v.1c.6.1 1.2.4 1.6.8.4.4.7.9.7 1.5 0 .4-.1.8-.3 1.2-.2.4-.5.7-.9.9-.4.3-.9.4-1.3.5-.5.1-1 .2-1.6.2-.8 0-1.6-.1-2.3-.4-.6-.2-1.1-.6-1.6-1l1.1-1.4zM7 9H3V5H1v10h2v-4h4v4h2V5H7v4z",
              4: "M9 15H7v-4H3v4H1V5h2v4h4V5h2v10zm10-2h-1v2h-2v-2h-5v-2l4-6h3v6h1v2zm-3-2V7l-2.8 4H16z",
              5: "M12.1 12.2c.4.3.7.5 1.1.7.4.2.9.3 1.3.3.5 0 1-.1 1.4-.4.4-.3.6-.7.6-1.1 0-.4-.2-.9-.6-1.1-.4-.3-.9-.4-1.4-.4H14c-.1 0-.3 0-.4.1l-.4.1-.5.2-1-.6.3-5h6.4v1.9h-4.3L14 8.8c.2-.1.5-.1.7-.2.2 0 .5-.1.7-.1.5 0 .9.1 1.4.2.4.1.8.3 1.1.6.3.2.6.6.8.9.2.4.3.9.3 1.4 0 .5-.1 1-.3 1.4-.2.4-.5.8-.9 1.1-.4.3-.8.5-1.3.7-.5.2-1 .3-1.5.3-.8 0-1.6-.1-2.3-.4-.6-.2-1.1-.6-1.6-1-.1-.1 1-1.5 1-1.5zM9 15H7v-4H3v4H1V5h2v4h4V5h2v10z",
              6: "M9 15H7v-4H3v4H1V5h2v4h4V5h2v10zm8.6-7.5c-.2-.2-.5-.4-.8-.5-.6-.2-1.3-.2-1.9 0-.3.1-.6.3-.8.5l-.6.9c-.2.5-.2.9-.2 1.4.4-.3.8-.6 1.2-.8.4-.2.8-.3 1.3-.3.4 0 .8 0 1.2.2.4.1.7.3 1 .6.3.3.5.6.7.9.2.4.3.8.3 1.3s-.1.9-.3 1.4c-.2.4-.5.7-.8 1-.4.3-.8.5-1.2.6-1 .3-2 .3-3 0-.5-.2-1-.5-1.4-.9-.4-.4-.8-.9-1-1.5-.2-.6-.3-1.3-.3-2.1s.1-1.6.4-2.3c.2-.6.6-1.2 1-1.6.4-.4.9-.7 1.4-.9.6-.3 1.1-.4 1.7-.4.7 0 1.4.1 2 .3.5.2 1 .5 1.4.8 0 .1-1.3 1.4-1.3 1.4zm-2.4 5.8c.2 0 .4 0 .6-.1.2 0 .4-.1.5-.2.1-.1.3-.3.4-.5.1-.2.1-.5.1-.7 0-.4-.1-.8-.4-1.1-.3-.2-.7-.3-1.1-.3-.3 0-.7.1-1 .2-.4.2-.7.4-1 .7 0 .3.1.7.3 1 .1.2.3.4.4.6.2.1.3.3.5.3.2.1.5.2.7.1z"
            }[s]
          }));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(5303);
      },
      6400: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LevelControl(l) {
          var s = l.level,
              c = l.onChange;
          var m = [1, 2, 3, 4, 5, 6, 0].map(function (l) {
            var m = l === s;
            return {
              icon: (0, v.createElement)(k.default, {
                level: l,
                isPressed: m
              }),
              title: 0 === l ? (0, y.__)("Paragraph") : (0, y.sprintf)((0, y.__)("Heading %d"), l),
              isActive: m,
              onClick: function onClick() {
                return c(l);
              }
            };
          });
          return (0, v.createElement)(_.ToolbarDropdownMenu, {
            label: (0, y.__)("Change heading level"),
            icon: (0, v.createElement)(k.default, {
              level: s
            }),
            controls: m
          });
        };

        var v = c(1753),
            _ = c(4892),
            y = c(6756),
            k = m(c(4983));
      },
      2931: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(6907)),
            y = m(c(3823));

        var k = {
          apiVersion: 2,
          name: "core/site-title",
          title: "Site Title",
          category: "theme",
          description: "Displays the name of this site. Update the block, and the changes apply everywhere it’s used. This will also appear in the browser title bar and in search results.",
          textdomain: "default",
          attributes: {
            level: {
              type: "number",
              default: 1
            },
            textAlign: {
              type: "string"
            },
            isLink: {
              type: "boolean",
              default: !0
            },
            linkTarget: {
              type: "string",
              default: "_self"
            }
          },
          example: {
            viewportWidth: 500
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              gradients: !0,
              link: !0
            },
            spacing: {
              padding: !0,
              margin: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontFamily: !0,
              __experimentalTextTransform: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                lineHeight: !0,
                fontAppearance: !0,
                letterSpacing: !0,
                textTransform: !0
              }
            }
          },
          editorStyle: "wp-block-site-title-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.mapMarker,
          edit: _.default,
          deprecated: y.default
        };
        s.settings = w;
      },
      4868: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(4892),
            E = c(6756),
            w = c(5303),
            C = c(1893);

        var SocialLinkURLPopover = function SocialLinkURLPopover(l) {
          var s = l.url,
              c = l.setAttributes,
              m = l.setPopover,
              _ = l.anchorRef;
          return (0, v.createElement)(y.URLPopover, {
            anchorRef: null == _ ? void 0 : _.current,
            onClose: function onClose() {
              return m(!1);
            }
          }, (0, v.createElement)("form", {
            className: "block-editor-url-popover__link-editor",
            onSubmit: function onSubmit(l) {
              l.preventDefault(), m(!1);
            }
          }, (0, v.createElement)("div", {
            className: "block-editor-url-input"
          }, (0, v.createElement)(y.URLInput, {
            value: s,
            onChange: function onChange(l) {
              return c({
                url: l
              });
            },
            placeholder: (0, E.__)("Enter address"),
            disableSuggestions: !0
          })), (0, v.createElement)(k.Button, {
            icon: w.keyboardReturn,
            label: (0, E.__)("Apply"),
            type: "submit"
          })));
        };

        var _default = function _default(l) {
          var s = l.attributes,
              c = l.context,
              m = l.isSelected,
              w = l.setAttributes;

          var S = s.url,
              P = s.service,
              T = s.label,
              B = c.iconColorValue,
              z = c.iconBackgroundColorValue,
              _ref360 = (0, v.useState)(!1),
              _ref361 = _slicedToArray2(_ref360, 2),
              L = _ref361[0],
              V = _ref361[1],
              A = (0, _.default)("wp-social-link", "wp-social-link-" + P, {
            "wp-social-link__is-incomplete": !S
          }),
              R = (0, v.useRef)(),
              O = (0, C.getIconBySite)(P),
              D = (0, C.getNameBySite)(P),
              F = (0, y.useBlockProps)({
            className: A,
            style: {
              color: B,
              backgroundColor: z
            }
          });

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, E.sprintf)((0, E.__)("%s label"), D),
            initialOpen: !1
          }, (0, v.createElement)(k.PanelRow, null, (0, v.createElement)(k.TextControl, {
            label: (0, E.__)("Link label"),
            help: (0, E.__)("Briefly describe the link to help screen reader users."),
            value: T,
            onChange: function onChange(l) {
              return w({
                label: l
              });
            }
          })))), (0, v.createElement)("li", F, (0, v.createElement)(k.Button, {
            ref: R,
            onClick: function onClick() {
              return V(!0);
            }
          }, (0, v.createElement)(O, null), m && L && (0, v.createElement)(SocialLinkURLPopover, {
            url: S,
            setAttributes: w,
            setPopover: V,
            anchorRef: R
          }))));
        };

        s.default = _default;
      },
      473: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.AmazonIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.AmazonIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M13.582,8.182C11.934,8.367,9.78,8.49,8.238,9.166c-1.781,0.769-3.03,2.337-3.03,4.644 c0,2.953,1.86,4.429,4.253,4.429c2.02,0,3.125-0.477,4.685-2.065c0.516,0.747,0.685,1.109,1.629,1.894 c0.212,0.114,0.483,0.103,0.672-0.066l0.006,0.006c0.567-0.505,1.599-1.401,2.18-1.888c0.231-0.188,0.19-0.496,0.009-0.754 c-0.52-0.718-1.072-1.303-1.072-2.634V8.305c0-1.876,0.133-3.599-1.249-4.891C15.23,2.369,13.422,2,12.04,2 C9.336,2,6.318,3.01,5.686,6.351C5.618,6.706,5.877,6.893,6.109,6.945l2.754,0.298C9.121,7.23,9.308,6.977,9.357,6.72 c0.236-1.151,1.2-1.706,2.284-1.706c0.584,0,1.249,0.215,1.595,0.738c0.398,0.584,0.346,1.384,0.346,2.061V8.182z M13.049,14.088 c-0.451,0.8-1.169,1.291-1.967,1.291c-1.09,0-1.728-0.83-1.728-2.061c0-2.42,2.171-2.86,4.227-2.86v0.615 C13.582,12.181,13.608,13.104,13.049,14.088z M20.683,19.339C18.329,21.076,14.917,22,11.979,22c-4.118,0-7.826-1.522-10.632-4.057 c-0.22-0.199-0.024-0.471,0.241-0.317c3.027,1.762,6.771,2.823,10.639,2.823c2.608,0,5.476-0.541,8.115-1.66 C20.739,18.62,21.072,19.051,20.683,19.339z M21.336,21.043c-0.194,0.163-0.379,0.076-0.293-0.139 c0.284-0.71,0.92-2.298,0.619-2.684c-0.301-0.386-1.99-0.183-2.749-0.092c-0.23,0.027-0.266-0.173-0.059-0.319 c1.348-0.946,3.555-0.673,3.811-0.356C22.925,17.773,22.599,19.986,21.336,21.043z"
          }));
        };
      },
      6475: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BandcampIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.BandcampIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M15.27 17.289 3 17.289 8.73 6.711 21 6.711 15.27 17.289"
          }));
        };
      },
      6034: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BehanceIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.BehanceIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M7.799,5.698c0.589,0,1.12,0.051,1.606,0.156c0.482,0.102,0.894,0.273,1.241,0.507c0.344,0.235,0.612,0.546,0.804,0.938 c0.188,0.387,0.281,0.871,0.281,1.443c0,0.619-0.141,1.137-0.421,1.551c-0.284,0.413-0.7,0.751-1.255,1.014 c0.756,0.218,1.317,0.601,1.689,1.146c0.374,0.549,0.557,1.205,0.557,1.975c0,0.623-0.12,1.161-0.359,1.612 c-0.241,0.457-0.569,0.828-0.973,1.114c-0.408,0.288-0.876,0.5-1.399,0.637C9.052,17.931,8.514,18,7.963,18H2V5.698H7.799 M7.449,10.668c0.481,0,0.878-0.114,1.192-0.345c0.311-0.228,0.463-0.603,0.463-1.119c0-0.286-0.051-0.523-0.152-0.707 C8.848,8.315,8.711,8.171,8.536,8.07C8.362,7.966,8.166,7.894,7.94,7.854c-0.224-0.044-0.457-0.06-0.697-0.06H4.709v2.874H7.449z M7.6,15.905c0.267,0,0.521-0.024,0.759-0.077c0.243-0.053,0.457-0.137,0.637-0.261c0.182-0.12,0.332-0.283,0.441-0.491 C9.547,14.87,9.6,14.602,9.6,14.278c0-0.633-0.18-1.084-0.533-1.357c-0.356-0.27-0.83-0.404-1.413-0.404H4.709v3.388L7.6,15.905z M16.162,15.864c0.367,0.358,0.897,0.538,1.583,0.538c0.493,0,0.92-0.125,1.277-0.374c0.354-0.248,0.571-0.514,0.654-0.79h2.155 c-0.347,1.072-0.872,1.838-1.589,2.299C19.534,18,18.67,18.23,17.662,18.23c-0.701,0-1.332-0.113-1.899-0.337 c-0.567-0.227-1.041-0.544-1.439-0.958c-0.389-0.415-0.689-0.907-0.904-1.484c-0.213-0.574-0.32-1.21-0.32-1.899 c0-0.666,0.11-1.288,0.329-1.863c0.222-0.577,0.529-1.075,0.933-1.492c0.406-0.42,0.885-0.751,1.444-0.994 c0.558-0.241,1.175-0.363,1.857-0.363c0.754,0,1.414,0.145,1.98,0.44c0.563,0.291,1.026,0.686,1.389,1.181 c0.363,0.493,0.622,1.057,0.783,1.69c0.16,0.632,0.217,1.292,0.171,1.983h-6.428C15.557,14.84,15.795,15.506,16.162,15.864 M18.973,11.184c-0.291-0.321-0.783-0.496-1.384-0.496c-0.39,0-0.714,0.066-0.973,0.2c-0.254,0.132-0.461,0.297-0.621,0.491 c-0.157,0.197-0.265,0.405-0.328,0.628c-0.063,0.217-0.101,0.413-0.111,0.587h3.98C19.478,11.969,19.265,11.509,18.973,11.184z M15.057,7.738h4.985V6.524h-4.985L15.057,7.738z"
          }));
        };
      },
      2291: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ChainIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.ChainIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M19.647,16.706a1.134,1.134,0,0,0-.343-.833l-2.549-2.549a1.134,1.134,0,0,0-.833-.343,1.168,1.168,0,0,0-.883.392l.233.226q.2.189.264.264a2.922,2.922,0,0,1,.184.233.986.986,0,0,1,.159.312,1.242,1.242,0,0,1,.043.337,1.172,1.172,0,0,1-1.176,1.176,1.237,1.237,0,0,1-.337-.043,1,1,0,0,1-.312-.159,2.76,2.76,0,0,1-.233-.184q-.073-.068-.264-.264l-.226-.233a1.19,1.19,0,0,0-.4.895,1.134,1.134,0,0,0,.343.833L15.837,19.3a1.13,1.13,0,0,0,.833.331,1.18,1.18,0,0,0,.833-.318l1.8-1.789a1.12,1.12,0,0,0,.343-.821Zm-8.615-8.64a1.134,1.134,0,0,0-.343-.833L8.163,4.7a1.134,1.134,0,0,0-.833-.343,1.184,1.184,0,0,0-.833.331L4.7,6.473a1.12,1.12,0,0,0-.343.821,1.134,1.134,0,0,0,.343.833l2.549,2.549a1.13,1.13,0,0,0,.833.331,1.184,1.184,0,0,0,.883-.38L8.728,10.4q-.2-.189-.264-.264A2.922,2.922,0,0,1,8.28,9.9a.986.986,0,0,1-.159-.312,1.242,1.242,0,0,1-.043-.337A1.172,1.172,0,0,1,9.254,8.079a1.237,1.237,0,0,1,.337.043,1,1,0,0,1,.312.159,2.761,2.761,0,0,1,.233.184q.073.068.264.264l.226.233a1.19,1.19,0,0,0,.4-.895ZM22,16.706a3.343,3.343,0,0,1-1.042,2.488l-1.8,1.789a3.536,3.536,0,0,1-4.988-.025l-2.525-2.537a3.384,3.384,0,0,1-1.017-2.488,3.448,3.448,0,0,1,1.078-2.561l-1.078-1.078a3.434,3.434,0,0,1-2.549,1.078,3.4,3.4,0,0,1-2.5-1.029L3.029,9.794A3.4,3.4,0,0,1,2,7.294,3.343,3.343,0,0,1,3.042,4.806l1.8-1.789A3.384,3.384,0,0,1,7.331,2a3.357,3.357,0,0,1,2.5,1.042l2.525,2.537a3.384,3.384,0,0,1,1.017,2.488,3.448,3.448,0,0,1-1.078,2.561l1.078,1.078a3.551,3.551,0,0,1,5.049-.049l2.549,2.549A3.4,3.4,0,0,1,22,16.706Z"
          }));
        };
      },
      2089: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.CodepenIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.CodepenIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M22.016,8.84c-0.002-0.013-0.005-0.025-0.007-0.037c-0.005-0.025-0.008-0.048-0.015-0.072 c-0.003-0.015-0.01-0.028-0.013-0.042c-0.008-0.02-0.015-0.04-0.023-0.062c-0.007-0.015-0.013-0.028-0.02-0.042 c-0.008-0.02-0.018-0.037-0.03-0.057c-0.007-0.013-0.017-0.027-0.025-0.038c-0.012-0.018-0.023-0.035-0.035-0.052 c-0.01-0.013-0.02-0.025-0.03-0.037c-0.015-0.017-0.028-0.032-0.043-0.045c-0.01-0.012-0.022-0.023-0.035-0.035 c-0.015-0.015-0.032-0.028-0.048-0.04c-0.012-0.01-0.025-0.02-0.037-0.03c-0.005-0.003-0.01-0.008-0.015-0.012l-9.161-6.096 c-0.289-0.192-0.666-0.192-0.955,0L2.359,8.237C2.354,8.24,2.349,8.245,2.344,8.249L2.306,8.277 c-0.017,0.013-0.033,0.027-0.048,0.04C2.246,8.331,2.234,8.342,2.222,8.352c-0.015,0.015-0.028,0.03-0.042,0.047 c-0.012,0.013-0.022,0.023-0.03,0.037C2.139,8.453,2.125,8.471,2.115,8.488C2.107,8.501,2.099,8.514,2.09,8.526 C2.079,8.548,2.069,8.565,2.06,8.585C2.054,8.6,2.047,8.613,2.04,8.626C2.032,8.648,2.025,8.67,2.019,8.69 c-0.005,0.013-0.01,0.027-0.013,0.042C1.999,8.755,1.995,8.778,1.99,8.803C1.989,8.817,1.985,8.828,1.984,8.84 C1.978,8.879,1.975,8.915,1.975,8.954v6.093c0,0.037,0.003,0.075,0.008,0.112c0.002,0.012,0.005,0.025,0.007,0.038 c0.005,0.023,0.008,0.047,0.015,0.072c0.003,0.015,0.008,0.028,0.013,0.04c0.007,0.022,0.013,0.042,0.022,0.063 c0.007,0.015,0.013,0.028,0.02,0.04c0.008,0.02,0.018,0.038,0.03,0.058c0.007,0.013,0.015,0.027,0.025,0.038 c0.012,0.018,0.023,0.035,0.035,0.052c0.01,0.013,0.02,0.025,0.03,0.037c0.013,0.015,0.028,0.032,0.042,0.045 c0.012,0.012,0.023,0.023,0.035,0.035c0.015,0.013,0.032,0.028,0.048,0.04l0.038,0.03c0.005,0.003,0.01,0.007,0.013,0.01 l9.163,6.095C11.668,21.953,11.833,22,12,22c0.167,0,0.332-0.047,0.478-0.144l9.163-6.095l0.015-0.01 c0.013-0.01,0.027-0.02,0.037-0.03c0.018-0.013,0.035-0.028,0.048-0.04c0.013-0.012,0.025-0.023,0.035-0.035 c0.017-0.015,0.03-0.032,0.043-0.045c0.01-0.013,0.02-0.025,0.03-0.037c0.013-0.018,0.025-0.035,0.035-0.052 c0.008-0.013,0.018-0.027,0.025-0.038c0.012-0.02,0.022-0.038,0.03-0.058c0.007-0.013,0.013-0.027,0.02-0.04 c0.008-0.022,0.015-0.042,0.023-0.063c0.003-0.013,0.01-0.027,0.013-0.04c0.007-0.025,0.01-0.048,0.015-0.072 c0.002-0.013,0.005-0.027,0.007-0.037c0.003-0.042,0.007-0.079,0.007-0.117V8.954C22.025,8.915,22.022,8.879,22.016,8.84z M12.862,4.464l6.751,4.49l-3.016,2.013l-3.735-2.492V4.464z M11.138,4.464v4.009l-3.735,2.494L4.389,8.954L11.138,4.464z M3.699,10.562L5.853,12l-2.155,1.438V10.562z M11.138,19.536l-6.749-4.491l3.015-2.011l3.735,2.492V19.536z M12,14.035L8.953,12 L12,9.966L15.047,12L12,14.035z M12.862,19.536v-4.009l3.735-2.492l3.016,2.011L12.862,19.536z M20.303,13.438L18.147,12 l2.156-1.438L20.303,13.438z"
          }));
        };
      },
      4758: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DeviantArtIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.DeviantArtIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M 18.19 5.636 18.19 2 18.188 2 14.553 2 14.19 2.366 12.474 5.636 11.935 6 5.81 6 5.81 10.994 9.177 10.994 9.477 11.357 5.81 18.363 5.81 22 5.811 22 9.447 22 9.81 21.634 11.526 18.364 12.065 18 18.19 18 18.19 13.006 14.823 13.006 14.523 12.641 18.19 5.636z"
          }));
        };
      },
      6543: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DribbbleIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.DribbbleIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12,22C6.486,22,2,17.514,2,12S6.486,2,12,2c5.514,0,10,4.486,10,10S17.514,22,12,22z M20.434,13.369 c-0.292-0.092-2.644-0.794-5.32-0.365c1.117,3.07,1.572,5.57,1.659,6.09C18.689,17.798,20.053,15.745,20.434,13.369z M15.336,19.876c-0.127-0.749-0.623-3.361-1.822-6.477c-0.019,0.006-0.038,0.013-0.056,0.019c-4.818,1.679-6.547,5.02-6.701,5.334 c1.448,1.129,3.268,1.803,5.243,1.803C13.183,20.555,14.311,20.313,15.336,19.876z M5.654,17.724 c0.193-0.331,2.538-4.213,6.943-5.637c0.111-0.036,0.224-0.07,0.337-0.102c-0.214-0.485-0.448-0.971-0.692-1.45 c-4.266,1.277-8.405,1.223-8.778,1.216c-0.003,0.087-0.004,0.174-0.004,0.261C3.458,14.207,4.29,16.21,5.654,17.724z M3.639,10.264 c0.382,0.005,3.901,0.02,7.897-1.041c-1.415-2.516-2.942-4.631-3.167-4.94C5.979,5.41,4.193,7.613,3.639,10.264z M9.998,3.709 c0.236,0.316,1.787,2.429,3.187,5c3.037-1.138,4.323-2.867,4.477-3.085C16.154,4.286,14.17,3.471,12,3.471 C11.311,3.471,10.641,3.554,9.998,3.709z M18.612,6.612C18.432,6.855,17,8.69,13.842,9.979c0.199,0.407,0.389,0.821,0.567,1.237 c0.063,0.148,0.124,0.295,0.184,0.441c2.842-0.357,5.666,0.215,5.948,0.275C20.522,9.916,19.801,8.065,18.612,6.612z"
          }));
        };
      },
      9393: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DropboxIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.DropboxIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12,6.134L6.069,9.797L2,6.54l5.883-3.843L12,6.134z M2,13.054l5.883,3.843L12,13.459L6.069,9.797L2,13.054z M12,13.459 l4.116,3.439L22,13.054l-4.069-3.257L12,13.459z M22,6.54l-5.884-3.843L12,6.134l5.931,3.663L22,6.54z M12.011,14.2l-4.129,3.426 l-1.767-1.153v1.291l5.896,3.539l5.897-3.539v-1.291l-1.769,1.153L12.011,14.2z"
          }));
        };
      },
      3130: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.EtsyIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.EtsyIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M9.16033,4.038c0-.27174.02717-.43478.48913-.43478h6.22283c1.087,0,1.68478.92391,2.11957,2.663l.35326,1.38587h1.05978C19.59511,3.712,19.75815,2,19.75815,2s-2.663.29891-4.23913.29891h-7.962L3.29076,2.163v1.1413L4.731,3.57609c1.00543.19022,1.25.40761,1.33152,1.33152,0,0,.08152,2.71739.08152,7.20109s-.08152,7.17391-.08152,7.17391c0,.81522-.32609,1.11413-1.33152,1.30435l-1.44022.27174V22l4.2663-.13587h7.11957c1.60326,0,5.32609.13587,5.32609.13587.08152-.97826.625-5.40761.70652-5.89674H19.7038L18.644,18.52174c-.84239,1.90217-2.06522,2.038-3.42391,2.038H11.1712c-1.3587,0-2.01087-.54348-2.01087-1.712V12.65217s3.0163,0,3.99457.08152c.76087.05435,1.22283.27174,1.46739,1.33152l.32609,1.413h1.16848l-.08152-3.55978.163-3.587H15.02989l-.38043,1.57609c-.24457,1.03261-.40761,1.22283-1.46739,1.33152-1.38587.13587-4.02174.1087-4.02174.1087Z"
          }));
        };
      },
      90: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FacebookIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.FacebookIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"
          }));
        };
      },
      1120: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FeedIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.FeedIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M2,8.667V12c5.515,0,10,4.485,10,10h3.333C15.333,14.637,9.363,8.667,2,8.667z M2,2v3.333 c9.19,0,16.667,7.477,16.667,16.667H22C22,10.955,13.045,2,2,2z M4.5,17C3.118,17,2,18.12,2,19.5S3.118,22,4.5,22S7,20.88,7,19.5 S5.882,17,4.5,17z"
          }));
        };
      },
      5213: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FivehundredpxIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.FivehundredpxIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M6.94026,15.1412c.00437.01213.108.29862.168.44064a6.55008,6.55008,0,1,0,6.03191-9.09557,6.68654,6.68654,0,0,0-2.58357.51467A8.53914,8.53914,0,0,0,8.21268,8.61344L8.209,8.61725V3.22948l9.0504-.00008c.32934-.0036.32934-.46353.32934-.61466s0-.61091-.33035-.61467L7.47248,2a.43.43,0,0,0-.43131.42692v7.58355c0,.24466.30476.42131.58793.4819.553.11812.68074-.05864.81617-.2457l.018-.02481A10.52673,10.52673,0,0,1,9.32258,9.258a5.35268,5.35268,0,1,1,7.58985,7.54976,5.417,5.417,0,0,1-3.80867,1.56365,5.17483,5.17483,0,0,1-2.69822-.74478l.00342-4.61111a2.79372,2.79372,0,0,1,.71372-1.78792,2.61611,2.61611,0,0,1,1.98282-.89477,2.75683,2.75683,0,0,1,1.95525.79477,2.66867,2.66867,0,0,1,.79656,1.909,2.724,2.724,0,0,1-2.75849,2.748,4.94651,4.94651,0,0,1-.86254-.13719c-.31234-.093-.44519.34058-.48892.48349-.16811.54966.08453.65862.13687.67489a3.75751,3.75751,0,0,0,1.25234.18375,3.94634,3.94634,0,1,0-2.82444-6.742,3.67478,3.67478,0,0,0-1.13028,2.584l-.00041.02323c-.0035.11667-.00579,2.881-.00644,3.78811l-.00407-.00451a6.18521,6.18521,0,0,1-1.0851-1.86092c-.10544-.27856-.34358-.22925-.66857-.12917-.14192.04372-.57386.17677-.47833.489Zm4.65165-1.08338a.51346.51346,0,0,0,.19513.31818l.02276.022a.52945.52945,0,0,0,.3517.18416.24242.24242,0,0,0,.16577-.0611c.05473-.05082.67382-.67812.73287-.738l.69041.68819a.28978.28978,0,0,0,.21437.11032.53239.53239,0,0,0,.35708-.19486c.29792-.30419.14885-.46821.07676-.54751l-.69954-.69975.72952-.73469c.16-.17311.01874-.35708-.12218-.498-.20461-.20461-.402-.25742-.52855-.14083l-.7254.72665-.73354-.73375a.20128.20128,0,0,0-.14179-.05695.54135.54135,0,0,0-.34379.19648c-.22561.22555-.274.38149-.15656.5059l.73374.7315-.72942.73072A.26589.26589,0,0,0,11.59191,14.05782Zm1.59866-9.915A8.86081,8.86081,0,0,0,9.854,4.776a.26169.26169,0,0,0-.16938.22759.92978.92978,0,0,0,.08619.42094c.05682.14524.20779.531.50006.41955a8.40969,8.40969,0,0,1,2.91968-.55484,7.87875,7.87875,0,0,1,3.086.62286,8.61817,8.61817,0,0,1,2.30562,1.49315.2781.2781,0,0,0,.18318.07586c.15529,0,.30425-.15253.43167-.29551.21268-.23861.35873-.4369.1492-.63538a8.50425,8.50425,0,0,0-2.62312-1.694A9.0177,9.0177,0,0,0,13.19058,4.14283ZM19.50945,18.6236h0a.93171.93171,0,0,0-.36642-.25406.26589.26589,0,0,0-.27613.06613l-.06943.06929A7.90606,7.90606,0,0,1,7.60639,18.505a7.57284,7.57284,0,0,1-1.696-2.51537,8.58715,8.58715,0,0,1-.5147-1.77754l-.00871-.04864c-.04939-.25873-.28755-.27684-.62981-.22448-.14234.02178-.5755.088-.53426.39969l.001.00712a9.08807,9.08807,0,0,0,15.406,4.99094c.00193-.00192.04753-.04718.0725-.07436C19.79425,19.16234,19.87422,18.98728,19.50945,18.6236Z"
          }));
        };
      },
      9919: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FlickrIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.FlickrIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M6.5,7c-2.75,0-5,2.25-5,5s2.25,5,5,5s5-2.25,5-5S9.25,7,6.5,7z M17.5,7c-2.75,0-5,2.25-5,5s2.25,5,5,5s5-2.25,5-5 S20.25,7,17.5,7z"
          }));
        };
      },
      796: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FoursquareIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.FoursquareIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M17.573,2c0,0-9.197,0-10.668,0S5,3.107,5,3.805s0,16.948,0,16.948c0,0.785,0.422,1.077,0.66,1.172 c0.238,0.097,0.892,0.177,1.285-0.275c0,0,5.035-5.843,5.122-5.93c0.132-0.132,0.132-0.132,0.262-0.132h3.26 c1.368,0,1.588-0.977,1.732-1.552c0.078-0.318,0.692-3.428,1.225-6.122l0.675-3.368C19.56,2.893,19.14,2,17.573,2z M16.495,7.22 c-0.053,0.252-0.372,0.518-0.665,0.518c-0.293,0-4.157,0-4.157,0c-0.467,0-0.802,0.318-0.802,0.787v0.508 c0,0.467,0.337,0.798,0.805,0.798c0,0,3.197,0,3.528,0s0.655,0.362,0.583,0.715c-0.072,0.353-0.407,2.102-0.448,2.295 c-0.04,0.193-0.262,0.523-0.655,0.523c-0.33,0-2.88,0-2.88,0c-0.523,0-0.683,0.068-1.033,0.503 c-0.35,0.437-3.505,4.223-3.505,4.223c-0.032,0.035-0.063,0.027-0.063-0.015V4.852c0-0.298,0.26-0.648,0.648-0.648 c0,0,8.228,0,8.562,0c0.315,0,0.61,0.297,0.528,0.683L16.495,7.22z"
          }));
        };
      },
      448: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.GitHubIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.GitHubIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12,2C6.477,2,2,6.477,2,12c0,4.419,2.865,8.166,6.839,9.489c0.5,0.09,0.682-0.218,0.682-0.484 c0-0.236-0.009-0.866-0.014-1.699c-2.782,0.602-3.369-1.34-3.369-1.34c-0.455-1.157-1.11-1.465-1.11-1.465 c-0.909-0.62,0.069-0.608,0.069-0.608c1.004,0.071,1.532,1.03,1.532,1.03c0.891,1.529,2.341,1.089,2.91,0.833 c0.091-0.647,0.349-1.086,0.635-1.337c-2.22-0.251-4.555-1.111-4.555-4.943c0-1.091,0.39-1.984,1.03-2.682 C6.546,8.54,6.202,7.524,6.746,6.148c0,0,0.84-0.269,2.75,1.025C10.295,6.95,11.15,6.84,12,6.836 c0.85,0.004,1.705,0.114,2.504,0.336c1.909-1.294,2.748-1.025,2.748-1.025c0.546,1.376,0.202,2.394,0.1,2.646 c0.64,0.699,1.026,1.591,1.026,2.682c0,3.841-2.337,4.687-4.565,4.935c0.359,0.307,0.679,0.917,0.679,1.852 c0,1.335-0.012,2.415-0.012,2.741c0,0.269,0.18,0.579,0.688,0.481C19.138,20.161,22,16.416,22,12C22,6.477,17.523,2,12,2z"
          }));
        };
      },
      7137: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.GoodreadsIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.GoodreadsIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M17.3,17.5c-0.2,0.8-0.5,1.4-1,1.9c-0.4,0.5-1,0.9-1.7,1.2C13.9,20.9,13.1,21,12,21c-0.6,0-1.3-0.1-1.9-0.2 c-0.6-0.1-1.1-0.4-1.6-0.7c-0.5-0.3-0.9-0.7-1.2-1.2c-0.3-0.5-0.5-1.1-0.5-1.7h1.5c0.1,0.5,0.2,0.9,0.5,1.2 c0.2,0.3,0.5,0.6,0.9,0.8c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.1,1.2,0.1c1.4,0,2.5-0.4,3.1-1.2c0.6-0.8,1-2,1-3.5v-1.7h0 c-0.4,0.8-0.9,1.4-1.6,1.9c-0.7,0.5-1.5,0.7-2.4,0.7c-1,0-1.9-0.2-2.6-0.5C8.7,15,8.1,14.5,7.7,14c-0.5-0.6-0.8-1.3-1-2.1 c-0.2-0.8-0.3-1.6-0.3-2.5c0-0.9,0.1-1.7,0.4-2.5c0.3-0.8,0.6-1.5,1.1-2c0.5-0.6,1.1-1,1.8-1.4C10.3,3.2,11.1,3,12,3 c0.5,0,0.9,0.1,1.3,0.2c0.4,0.1,0.8,0.3,1.1,0.5c0.3,0.2,0.6,0.5,0.9,0.8c0.3,0.3,0.5,0.6,0.6,1h0V3.4h1.5V15 C17.6,15.9,17.5,16.7,17.3,17.5z M13.8,14.1c0.5-0.3,0.9-0.7,1.3-1.1c0.3-0.5,0.6-1,0.8-1.6c0.2-0.6,0.3-1.2,0.3-1.9 c0-0.6-0.1-1.2-0.2-1.9c-0.1-0.6-0.4-1.2-0.7-1.7c-0.3-0.5-0.7-0.9-1.3-1.2c-0.5-0.3-1.1-0.5-1.9-0.5s-1.4,0.2-1.9,0.5 c-0.5,0.3-1,0.7-1.3,1.2C8.5,6.4,8.3,7,8.1,7.6C8,8.2,7.9,8.9,7.9,9.5c0,0.6,0.1,1.3,0.2,1.9C8.3,12,8.6,12.5,8.9,13 c0.3,0.5,0.8,0.8,1.3,1.1c0.5,0.3,1.1,0.4,1.9,0.4C12.7,14.5,13.3,14.4,13.8,14.1z"
          }));
        };
      },
      1146: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.GoogleIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.GoogleIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12.02,10.18v3.72v0.01h5.51c-0.26,1.57-1.67,4.22-5.5,4.22c-3.31,0-6.01-2.75-6.01-6.12s2.7-6.12,6.01-6.12 c1.87,0,3.13,0.8,3.85,1.48l2.84-2.76C16.99,2.99,14.73,2,12.03,2c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.77,0,9.6-4.06,9.6-9.77 c0-0.83-0.11-1.42-0.25-2.05H12.02z"
          }));
        };
      },
      4253: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        });
        var m = c(473);
        Object.keys(m).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === m[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return m[l];
            }
          }));
        });
        var v = c(6475);
        Object.keys(v).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === v[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return v[l];
            }
          }));
        });

        var _ = c(6034);

        Object.keys(_).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === _[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return _[l];
            }
          }));
        });
        var y = c(2291);
        Object.keys(y).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === y[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return y[l];
            }
          }));
        });
        var k = c(2089);
        Object.keys(k).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === k[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return k[l];
            }
          }));
        });
        var E = c(4758);
        Object.keys(E).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === E[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return E[l];
            }
          }));
        });
        var w = c(6543);
        Object.keys(w).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === w[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return w[l];
            }
          }));
        });
        var C = c(9393);
        Object.keys(C).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === C[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return C[l];
            }
          }));
        });
        var S = c(3130);
        Object.keys(S).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === S[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return S[l];
            }
          }));
        });
        var P = c(90);
        Object.keys(P).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === P[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return P[l];
            }
          }));
        });
        var T = c(1120);
        Object.keys(T).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === T[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return T[l];
            }
          }));
        });
        var B = c(5213);
        Object.keys(B).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === B[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return B[l];
            }
          }));
        });
        var z = c(9919);
        Object.keys(z).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === z[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return z[l];
            }
          }));
        });
        var L = c(796);
        Object.keys(L).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === L[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return L[l];
            }
          }));
        });
        var V = c(7137);
        Object.keys(V).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === V[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return V[l];
            }
          }));
        });
        var A = c(1146);
        Object.keys(A).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === A[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return A[l];
            }
          }));
        });
        var R = c(448);
        Object.keys(R).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === R[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return R[l];
            }
          }));
        });
        var O = c(3291);
        Object.keys(O).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === O[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return O[l];
            }
          }));
        });
        var D = c(2559);
        Object.keys(D).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === D[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return D[l];
            }
          }));
        });
        var F = c(6927);
        Object.keys(F).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === F[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return F[l];
            }
          }));
        });
        var G = c(5319);
        Object.keys(G).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === G[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return G[l];
            }
          }));
        });
        var q = c(3439);
        Object.keys(q).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === q[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return q[l];
            }
          }));
        });
        var W = c(6992);
        Object.keys(W).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === W[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return W[l];
            }
          }));
        });
        var U = c(6345);
        Object.keys(U).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === U[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return U[l];
            }
          }));
        });
        var $ = c(6911);
        Object.keys($).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === $[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return $[l];
            }
          }));
        });
        var Z = c(1438);
        Object.keys(Z).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === Z[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return Z[l];
            }
          }));
        });
        var K = c(2990);
        Object.keys(K).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === K[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return K[l];
            }
          }));
        });
        var Q = c(156);
        Object.keys(Q).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === Q[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return Q[l];
            }
          }));
        });
        var Y = c(322);
        Object.keys(Y).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === Y[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return Y[l];
            }
          }));
        });
        var X = c(54);
        Object.keys(X).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === X[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return X[l];
            }
          }));
        });
        var J = c(9417);
        Object.keys(J).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === J[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return J[l];
            }
          }));
        });
        var ee = c(7712);
        Object.keys(ee).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ee[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ee[l];
            }
          }));
        });
        var te = c(8104);
        Object.keys(te).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === te[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return te[l];
            }
          }));
        });
        var re = c(5551);
        Object.keys(re).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === re[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return re[l];
            }
          }));
        });
        var ae = c(8046);
        Object.keys(ae).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ae[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ae[l];
            }
          }));
        });
        var oe = c(5822);
        Object.keys(oe).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === oe[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return oe[l];
            }
          }));
        });
        var ne = c(4720);
        Object.keys(ne).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ne[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ne[l];
            }
          }));
        });
        var le = c(9100);
        Object.keys(le).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === le[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return le[l];
            }
          }));
        });
        var ie = c(4157);
        Object.keys(ie).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ie[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ie[l];
            }
          }));
        });
        var se = c(3874);
        Object.keys(se).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === se[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return se[l];
            }
          }));
        });
        var ce = c(183);
        Object.keys(ce).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ce[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ce[l];
            }
          }));
        });
        var ue = c(1912);
        Object.keys(ue).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === ue[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return ue[l];
            }
          }));
        });
      },
      3291: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.InstagramIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.InstagramIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12,4.622c2.403,0,2.688,0.009,3.637,0.052c0.877,0.04,1.354,0.187,1.671,0.31c0.42,0.163,0.72,0.358,1.035,0.673 c0.315,0.315,0.51,0.615,0.673,1.035c0.123,0.317,0.27,0.794,0.31,1.671c0.043,0.949,0.052,1.234,0.052,3.637 s-0.009,2.688-0.052,3.637c-0.04,0.877-0.187,1.354-0.31,1.671c-0.163,0.42-0.358,0.72-0.673,1.035 c-0.315,0.315-0.615,0.51-1.035,0.673c-0.317,0.123-0.794,0.27-1.671,0.31c-0.949,0.043-1.233,0.052-3.637,0.052 s-2.688-0.009-3.637-0.052c-0.877-0.04-1.354-0.187-1.671-0.31c-0.42-0.163-0.72-0.358-1.035-0.673 c-0.315-0.315-0.51-0.615-0.673-1.035c-0.123-0.317-0.27-0.794-0.31-1.671C4.631,14.688,4.622,14.403,4.622,12 s0.009-2.688,0.052-3.637c0.04-0.877,0.187-1.354,0.31-1.671c0.163-0.42,0.358-0.72,0.673-1.035 c0.315-0.315,0.615-0.51,1.035-0.673c0.317-0.123,0.794-0.27,1.671-0.31C9.312,4.631,9.597,4.622,12,4.622 M12,3 C9.556,3,9.249,3.01,8.289,3.054C7.331,3.098,6.677,3.25,6.105,3.472C5.513,3.702,5.011,4.01,4.511,4.511 c-0.5,0.5-0.808,1.002-1.038,1.594C3.25,6.677,3.098,7.331,3.054,8.289C3.01,9.249,3,9.556,3,12c0,2.444,0.01,2.751,0.054,3.711 c0.044,0.958,0.196,1.612,0.418,2.185c0.23,0.592,0.538,1.094,1.038,1.594c0.5,0.5,1.002,0.808,1.594,1.038 c0.572,0.222,1.227,0.375,2.185,0.418C9.249,20.99,9.556,21,12,21s2.751-0.01,3.711-0.054c0.958-0.044,1.612-0.196,2.185-0.418 c0.592-0.23,1.094-0.538,1.594-1.038c0.5-0.5,0.808-1.002,1.038-1.594c0.222-0.572,0.375-1.227,0.418-2.185 C20.99,14.751,21,14.444,21,12s-0.01-2.751-0.054-3.711c-0.044-0.958-0.196-1.612-0.418-2.185c-0.23-0.592-0.538-1.094-1.038-1.594 c-0.5-0.5-1.002-0.808-1.594-1.038c-0.572-0.222-1.227-0.375-2.185-0.418C14.751,3.01,14.444,3,12,3L12,3z M12,7.378 c-2.552,0-4.622,2.069-4.622,4.622S9.448,16.622,12,16.622s4.622-2.069,4.622-4.622S14.552,7.378,12,7.378z M12,15 c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S13.657,15,12,15z M16.804,6.116c-0.596,0-1.08,0.484-1.08,1.08 s0.484,1.08,1.08,1.08c0.596,0,1.08-0.484,1.08-1.08S17.401,6.116,16.804,6.116z"
          }));
        };
      },
      2559: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LastfmIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.LastfmIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M 12.0002 1.5 C 6.2006 1.5 1.5 6.2011 1.5 11.9998 C 1.5 17.799 6.2006 22.5 12.0002 22.5 C 17.799 22.5 22.5 17.799 22.5 11.9998 C 22.5 6.2011 17.799 1.5 12.0002 1.5 Z M 16.1974 16.2204 C 14.8164 16.2152 13.9346 15.587 13.3345 14.1859 L 13.1816 13.8451 L 11.8541 10.8101 C 11.4271 9.7688 10.3526 9.0712 9.1801 9.0712 C 7.5695 9.0712 6.2593 10.3851 6.2593 12.001 C 6.2593 13.6165 7.5695 14.9303 9.1801 14.9303 C 10.272 14.9303 11.2651 14.3275 11.772 13.3567 C 11.7893 13.3235 11.8239 13.302 11.863 13.3038 C 11.9007 13.3054 11.9353 13.3288 11.9504 13.3632 L 12.4865 14.6046 C 12.5016 14.639 12.4956 14.6778 12.4723 14.7069 C 11.6605 15.6995 10.4602 16.2683 9.1801 16.2683 C 6.8331 16.2683 4.9234 14.3536 4.9234 12.001 C 4.9234 9.6468 6.833 7.732 9.1801 7.732 C 10.9572 7.732 12.3909 8.6907 13.1138 10.3636 C 13.1206 10.3802 13.8412 12.0708 14.4744 13.5191 C 14.8486 14.374 15.1462 14.896 16.1288 14.9292 C 17.0663 14.9613 17.7538 14.4122 17.7538 13.6485 C 17.7538 12.9691 17.3321 12.8004 16.3803 12.4822 C 14.7365 11.9398 13.845 11.3861 13.845 10.0182 C 13.845 8.6809 14.7667 7.8162 16.192 7.8162 C 17.1288 7.8162 17.8155 8.2287 18.2921 9.0768 C 18.305 9.1006 18.3079 9.1281 18.3004 9.1542 C 18.2929 9.1803 18.2748 9.2021 18.2507 9.2138 L 17.3614 9.669 C 17.3178 9.692 17.2643 9.6781 17.2356 9.6385 C 16.9329 9.2135 16.5956 9.0251 16.1423 9.0251 C 15.5512 9.0251 15.122 9.429 15.122 9.9865 C 15.122 10.6738 15.6529 10.8414 16.5339 11.1192 C 16.6491 11.1558 16.7696 11.194 16.8939 11.2343 C 18.2763 11.6865 19.0768 12.2311 19.0768 13.6836 C 19.0769 15.1297 17.8389 16.2204 16.1974 16.2204 Z"
          }));
        };
      },
      6927: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LinkedInIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.LinkedInIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M19.7,3H4.3C3.582,3,3,3.582,3,4.3v15.4C3,20.418,3.582,21,4.3,21h15.4c0.718,0,1.3-0.582,1.3-1.3V4.3 C21,3.582,20.418,3,19.7,3z M8.339,18.338H5.667v-8.59h2.672V18.338z M7.004,8.574c-0.857,0-1.549-0.694-1.549-1.548 c0-0.855,0.691-1.548,1.549-1.548c0.854,0,1.547,0.694,1.547,1.548C8.551,7.881,7.858,8.574,7.004,8.574z M18.339,18.338h-2.669 v-4.177c0-0.996-0.017-2.278-1.387-2.278c-1.389,0-1.601,1.086-1.601,2.206v4.249h-2.667v-8.59h2.559v1.174h0.037 c0.356-0.675,1.227-1.387,2.526-1.387c2.703,0,3.203,1.779,3.203,4.092V18.338z"
          }));
        };
      },
      5319: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MailIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.MailIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M20,4H4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2V6C22,4.895,21.105,4,20,4z M20,8.236l-8,4.882 L4,8.236V6h16V8.236z"
          }));
        };
      },
      3439: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MastodonIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.MastodonIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M23.193 7.879c0-5.206-3.411-6.732-3.411-6.732C18.062.357 15.108.025 12.041 0h-.076c-3.068.025-6.02.357-7.74 1.147 0 0-3.411 1.526-3.411 6.732 0 1.192-.023 2.618.015 4.129.124 5.092.934 10.109 5.641 11.355 2.17.574 4.034.695 5.535.612 2.722-.15 4.25-.972 4.25-.972l-.09-1.975s-1.945.613-4.129.539c-2.165-.074-4.449-.233-4.799-2.891a5.499 5.499 0 0 1-.048-.745s2.125.52 4.817.643c1.646.075 3.19-.097 4.758-.283 3.007-.359 5.625-2.212 5.954-3.905.517-2.665.475-6.507.475-6.507zm-4.024 6.709h-2.497V8.469c0-1.29-.543-1.944-1.628-1.944-1.2 0-1.802.776-1.802 2.312v3.349h-2.483v-3.35c0-1.536-.602-2.312-1.802-2.312-1.085 0-1.628.655-1.628 1.944v6.119H4.832V8.284c0-1.289.328-2.313.987-3.07.68-.758 1.569-1.146 2.674-1.146 1.278 0 2.246.491 2.886 1.474L12 6.585l.622-1.043c.64-.983 1.608-1.474 2.886-1.474 1.104 0 1.994.388 2.674 1.146.658.757.986 1.781.986 3.07v6.304z"
          }));
        };
      },
      6345: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MediumIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.MediumIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M20.962,7.257l-5.457,8.867l-3.923-6.375l3.126-5.08c0.112-0.182,0.319-0.286,0.527-0.286c0.05,0,0.1,0.008,0.149,0.02 c0.039,0.01,0.078,0.023,0.114,0.041l5.43,2.715l0.006,0.003c0.004,0.002,0.007,0.006,0.011,0.008 C20.971,7.191,20.98,7.227,20.962,7.257z M9.86,8.592v5.783l5.14,2.57L9.86,8.592z M15.772,17.331l4.231,2.115 C20.554,19.721,21,19.529,21,19.016V8.835L15.772,17.331z M8.968,7.178L3.665,4.527C3.569,4.479,3.478,4.456,3.395,4.456 C3.163,4.456,3,4.636,3,4.938v11.45c0,0.306,0.224,0.669,0.498,0.806l4.671,2.335c0.12,0.06,0.234,0.088,0.337,0.088 c0.29,0,0.494-0.225,0.494-0.602V7.231C9,7.208,8.988,7.188,8.968,7.178z"
          }));
        };
      },
      6992: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MeetupIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.MeetupIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M19.24775,14.722a3.57032,3.57032,0,0,1-2.94457,3.52073,3.61886,3.61886,0,0,1-.64652.05634c-.07314-.0008-.10187.02846-.12507.09547A2.38881,2.38881,0,0,1,13.49453,20.094a2.33092,2.33092,0,0,1-1.827-.50716.13635.13635,0,0,0-.19878-.00408,3.191,3.191,0,0,1-2.104.60248,3.26309,3.26309,0,0,1-3.00324-2.71993,2.19076,2.19076,0,0,1-.03512-.30865c-.00156-.08579-.03413-.1189-.11608-.13493a2.86421,2.86421,0,0,1-1.23189-.56111,2.945,2.945,0,0,1-1.166-2.05749,2.97484,2.97484,0,0,1,.87524-2.50774.112.112,0,0,0,.02091-.16107,2.7213,2.7213,0,0,1-.36648-1.48A2.81256,2.81256,0,0,1,6.57673,7.58838a.35764.35764,0,0,0,.28869-.22819,4.2208,4.2208,0,0,1,6.02892-1.90111.25161.25161,0,0,0,.22023.0243,3.65608,3.65608,0,0,1,3.76031.90678A3.57244,3.57244,0,0,1,17.95918,8.626a2.97339,2.97339,0,0,1,.01829.57356.10637.10637,0,0,0,.0853.12792,1.97669,1.97669,0,0,1,1.27939,1.33733,2.00266,2.00266,0,0,1-.57112,2.12652c-.05284.05166-.04168.08328-.01173.13489A3.51189,3.51189,0,0,1,19.24775,14.722Zm-6.35959-.27836a1.6984,1.6984,0,0,0,1.14556,1.61113,3.82039,3.82039,0,0,0,1.036.17935,1.46888,1.46888,0,0,0,.73509-.12255.44082.44082,0,0,0,.26057-.44274.45312.45312,0,0,0-.29211-.43375.97191.97191,0,0,0-.20678-.063c-.21326-.03806-.42754-.0701-.63973-.11215a.54787.54787,0,0,1-.50172-.60926,2.75864,2.75864,0,0,1,.1773-.901c.1763-.535.414-1.045.64183-1.55913A12.686,12.686,0,0,0,15.85,10.47863a1.58461,1.58461,0,0,0,.04861-.87208,1.04531,1.04531,0,0,0-.85432-.83981,1.60658,1.60658,0,0,0-1.23654.16594.27593.27593,0,0,1-.36286-.03413c-.085-.0747-.16594-.15379-.24918-.23055a.98682.98682,0,0,0-1.33577-.04933,6.1468,6.1468,0,0,1-.4989.41615.47762.47762,0,0,1-.51535.03566c-.17448-.09307-.35512-.175-.53531-.25665a1.74949,1.74949,0,0,0-.56476-.2016,1.69943,1.69943,0,0,0-1.61654.91787,8.05815,8.05815,0,0,0-.32952.80126c-.45471,1.2557-.82507,2.53825-1.20838,3.81639a1.24151,1.24151,0,0,0,.51532,1.44389,1.42659,1.42659,0,0,0,1.22008.17166,1.09728,1.09728,0,0,0,.66994-.69764c.44145-1.04111.839-2.09989,1.25981-3.14926.11581-.28876.22792-.57874.35078-.86438a.44548.44548,0,0,1,.69189-.19539.50521.50521,0,0,1,.15044.43836,1.75625,1.75625,0,0,1-.14731.50453c-.27379.69219-.55265,1.38236-.82766,2.074a2.0836,2.0836,0,0,0-.14038.42876.50719.50719,0,0,0,.27082.57722.87236.87236,0,0,0,.66145.02739.99137.99137,0,0,0,.53406-.532q.61571-1.20914,1.228-2.42031.28423-.55863.57585-1.1133a.87189.87189,0,0,1,.29055-.35253.34987.34987,0,0,1,.37634-.01265.30291.30291,0,0,1,.12434.31459.56716.56716,0,0,1-.04655.1915c-.05318.12739-.10286.25669-.16183.38156-.34118.71775-.68754,1.43273-1.02568,2.152A2.00213,2.00213,0,0,0,12.88816,14.44366Zm4.78568,5.28972a.88573.88573,0,0,0-1.77139.00465.8857.8857,0,0,0,1.77139-.00465Zm-14.83838-7.296a.84329.84329,0,1,0,.00827-1.68655.8433.8433,0,0,0-.00827,1.68655Zm10.366-9.43673a.83506.83506,0,1,0-.0091,1.67.83505.83505,0,0,0,.0091-1.67Zm6.85014,5.22a.71651.71651,0,0,0-1.433.0093.71656.71656,0,0,0,1.433-.0093ZM5.37528,6.17908A.63823.63823,0,1,0,6.015,5.54483.62292.62292,0,0,0,5.37528,6.17908Zm6.68214,14.80843a.54949.54949,0,1,0-.55052.541A.54556.54556,0,0,0,12.05742,20.98752Zm8.53235-8.49689a.54777.54777,0,0,0-.54027.54023.53327.53327,0,0,0,.532.52293.51548.51548,0,0,0,.53272-.5237A.53187.53187,0,0,0,20.58977,12.49063ZM7.82846,2.4715a.44927.44927,0,1,0,.44484.44766A.43821.43821,0,0,0,7.82846,2.4715Zm13.775,7.60492a.41186.41186,0,0,0-.40065.39623.40178.40178,0,0,0,.40168.40168A.38994.38994,0,0,0,22,10.48172.39946.39946,0,0,0,21.60349,10.07642ZM5.79193,17.96207a.40469.40469,0,0,0-.397-.39646.399.399,0,0,0-.396.405.39234.39234,0,0,0,.39939.389A.39857.39857,0,0,0,5.79193,17.96207Z"
          }));
        };
      },
      6911: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.PatreonIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.PatreonIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 569 546",
            version: "1.1"
          }, (0, m.createElement)(v.Circle, {
            cx: "363",
            cy: "205",
            r: "205"
          }), (0, m.createElement)(v.Rect, {
            width: "100",
            height: "546",
            x: "0",
            y: "0"
          }));
        };
      },
      1438: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.PinterestIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.PinterestIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12.289,2C6.617,2,3.606,5.648,3.606,9.622c0,1.846,1.025,4.146,2.666,4.878c0.25,0.111,0.381,0.063,0.439-0.169 c0.044-0.175,0.267-1.029,0.365-1.428c0.032-0.128,0.017-0.237-0.091-0.362C6.445,11.911,6.01,10.75,6.01,9.668 c0-2.777,2.194-5.464,5.933-5.464c3.23,0,5.49,2.108,5.49,5.122c0,3.407-1.794,5.768-4.13,5.768c-1.291,0-2.257-1.021-1.948-2.277 c0.372-1.495,1.089-3.112,1.089-4.191c0-0.967-0.542-1.775-1.663-1.775c-1.319,0-2.379,1.309-2.379,3.059 c0,1.115,0.394,1.869,0.394,1.869s-1.302,5.279-1.54,6.261c-0.405,1.666,0.053,4.368,0.094,4.604 c0.021,0.126,0.167,0.169,0.25,0.063c0.129-0.165,1.699-2.419,2.142-4.051c0.158-0.59,0.817-2.995,0.817-2.995 c0.43,0.784,1.681,1.446,3.013,1.446c3.963,0,6.822-3.494,6.822-7.833C20.394,5.112,16.849,2,12.289,2"
          }));
        };
      },
      2990: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.PocketIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.PocketIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M21.927,4.194C21.667,3.48,20.982,3,20.222,3h-0.01h-1.721H3.839C3.092,3,2.411,3.47,2.145,4.17 C2.066,4.378,2.026,4.594,2.026,4.814v6.035l0.069,1.2c0.29,2.73,1.707,5.115,3.899,6.778c0.039,0.03,0.079,0.059,0.119,0.089 l0.025,0.018c1.175,0.859,2.491,1.441,3.91,1.727c0.655,0.132,1.325,0.2,1.991,0.2c0.615,0,1.232-0.057,1.839-0.17 c0.073-0.014,0.145-0.028,0.219-0.044c0.02-0.004,0.042-0.012,0.064-0.023c1.359-0.297,2.621-0.864,3.753-1.691l0.025-0.018 c0.04-0.029,0.08-0.058,0.119-0.089c2.192-1.664,3.609-4.049,3.898-6.778l0.069-1.2V4.814C22.026,4.605,22,4.398,21.927,4.194z M17.692,10.481l-4.704,4.512c-0.266,0.254-0.608,0.382-0.949,0.382c-0.342,0-0.684-0.128-0.949-0.382l-4.705-4.512 C5.838,9.957,5.82,9.089,6.344,8.542c0.524-0.547,1.392-0.565,1.939-0.04l3.756,3.601l3.755-3.601 c0.547-0.524,1.415-0.506,1.939,0.04C18.256,9.089,18.238,9.956,17.692,10.481z"
          }));
        };
      },
      156: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.RedditIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.RedditIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M22,11.816c0-1.256-1.021-2.277-2.277-2.277c-0.593,0-1.122,0.24-1.526,0.614c-1.481-0.965-3.455-1.594-5.647-1.69 l1.171-3.702l3.18,0.748c0.008,1.028,0.846,1.862,1.876,1.862c1.035,0,1.877-0.842,1.877-1.878c0-1.035-0.842-1.877-1.877-1.877 c-0.769,0-1.431,0.466-1.72,1.13l-3.508-0.826c-0.203-0.047-0.399,0.067-0.46,0.261l-1.35,4.268 c-2.316,0.038-4.411,0.67-5.97,1.671C5.368,9.765,4.853,9.539,4.277,9.539C3.021,9.539,2,10.56,2,11.816 c0,0.814,0.433,1.523,1.078,1.925c-0.037,0.221-0.061,0.444-0.061,0.672c0,3.292,4.011,5.97,8.941,5.97s8.941-2.678,8.941-5.97 c0-0.214-0.02-0.424-0.053-0.632C21.533,13.39,22,12.661,22,11.816z M18.776,4.394c0.606,0,1.1,0.493,1.1,1.1s-0.493,1.1-1.1,1.1 s-1.1-0.494-1.1-1.1S18.169,4.394,18.776,4.394z M2.777,11.816c0-0.827,0.672-1.5,1.499-1.5c0.313,0,0.598,0.103,0.838,0.269 c-0.851,0.676-1.477,1.479-1.812,2.36C2.983,12.672,2.777,12.27,2.777,11.816z M11.959,19.606c-4.501,0-8.164-2.329-8.164-5.193 S7.457,9.22,11.959,9.22s8.164,2.329,8.164,5.193S16.46,19.606,11.959,19.606z M20.636,13.001c-0.326-0.89-0.948-1.701-1.797-2.384 c0.248-0.186,0.55-0.301,0.883-0.301c0.827,0,1.5,0.673,1.5,1.5C21.223,12.299,20.992,12.727,20.636,13.001z M8.996,14.704 c-0.76,0-1.397-0.616-1.397-1.376c0-0.76,0.637-1.397,1.397-1.397c0.76,0,1.376,0.637,1.376,1.397 C10.372,14.088,9.756,14.704,8.996,14.704z M16.401,13.328c0,0.76-0.616,1.376-1.376,1.376c-0.76,0-1.399-0.616-1.399-1.376 c0-0.76,0.639-1.397,1.399-1.397C15.785,11.931,16.401,12.568,16.401,13.328z M15.229,16.708c0.152,0.152,0.152,0.398,0,0.55 c-0.674,0.674-1.727,1.002-3.219,1.002c-0.004,0-0.007-0.002-0.011-0.002c-0.004,0-0.007,0.002-0.011,0.002 c-1.492,0-2.544-0.328-3.218-1.002c-0.152-0.152-0.152-0.398,0-0.55c0.152-0.152,0.399-0.151,0.55,0 c0.521,0.521,1.394,0.775,2.669,0.775c0.004,0,0.007,0.002,0.011,0.002c0.004,0,0.007-0.002,0.011-0.002 c1.275,0,2.148-0.253,2.669-0.775C14.831,16.556,15.078,16.556,15.229,16.708z"
          }));
        };
      },
      322: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SkypeIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.SkypeIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M10.113,2.699c0.033-0.006,0.067-0.013,0.1-0.02c0.033,0.017,0.066,0.033,0.098,0.051L10.113,2.699z M2.72,10.223 c-0.006,0.034-0.011,0.069-0.017,0.103c0.018,0.032,0.033,0.064,0.051,0.095L2.72,10.223z M21.275,13.771 c0.007-0.035,0.011-0.071,0.018-0.106c-0.018-0.031-0.033-0.064-0.052-0.095L21.275,13.771z M13.563,21.199 c0.032,0.019,0.065,0.035,0.096,0.053c0.036-0.006,0.071-0.011,0.105-0.017L13.563,21.199z M22,16.386 c0,1.494-0.581,2.898-1.637,3.953c-1.056,1.057-2.459,1.637-3.953,1.637c-0.967,0-1.914-0.251-2.75-0.725 c0.036-0.006,0.071-0.011,0.105-0.017l-0.202-0.035c0.032,0.019,0.065,0.035,0.096,0.053c-0.543,0.096-1.099,0.147-1.654,0.147 c-1.275,0-2.512-0.25-3.676-0.743c-1.125-0.474-2.135-1.156-3.002-2.023c-0.867-0.867-1.548-1.877-2.023-3.002 c-0.493-1.164-0.743-2.401-0.743-3.676c0-0.546,0.049-1.093,0.142-1.628c0.018,0.032,0.033,0.064,0.051,0.095L2.72,10.223 c-0.006,0.034-0.011,0.069-0.017,0.103C2.244,9.5,2,8.566,2,7.615c0-1.493,0.582-2.898,1.637-3.953 c1.056-1.056,2.46-1.638,3.953-1.638c0.915,0,1.818,0.228,2.622,0.655c-0.033,0.007-0.067,0.013-0.1,0.02l0.199,0.031 c-0.032-0.018-0.066-0.034-0.098-0.051c0.002,0,0.003-0.001,0.004-0.001c0.586-0.112,1.187-0.169,1.788-0.169 c1.275,0,2.512,0.249,3.676,0.742c1.124,0.476,2.135,1.156,3.002,2.024c0.868,0.867,1.548,1.877,2.024,3.002 c0.493,1.164,0.743,2.401,0.743,3.676c0,0.575-0.054,1.15-0.157,1.712c-0.018-0.031-0.033-0.064-0.052-0.095l0.034,0.201 c0.007-0.035,0.011-0.071,0.018-0.106C21.754,14.494,22,15.432,22,16.386z M16.817,14.138c0-1.331-0.613-2.743-3.033-3.282 l-2.209-0.49c-0.84-0.192-1.807-0.444-1.807-1.237c0-0.794,0.679-1.348,1.903-1.348c2.468,0,2.243,1.696,3.468,1.696 c0.645,0,1.209-0.379,1.209-1.031c0-1.521-2.435-2.663-4.5-2.663c-2.242,0-4.63,0.952-4.63,3.488c0,1.221,0.436,2.521,2.839,3.123 l2.984,0.745c0.903,0.223,1.129,0.731,1.129,1.189c0,0.762-0.758,1.507-2.129,1.507c-2.679,0-2.307-2.062-3.743-2.062 c-0.645,0-1.113,0.444-1.113,1.078c0,1.236,1.501,2.886,4.856,2.886C15.236,17.737,16.817,16.199,16.817,14.138z"
          }));
        };
      },
      54: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SnapchatIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.SnapchatIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12.065,2a5.526,5.526,0,0,1,3.132.892A5.854,5.854,0,0,1,17.326,5.4a5.821,5.821,0,0,1,.351,2.33q0,.612-.117,2.487a.809.809,0,0,0,.365.091,1.93,1.93,0,0,0,.664-.176,1.93,1.93,0,0,1,.664-.176,1.3,1.3,0,0,1,.729.234.7.7,0,0,1,.351.6.839.839,0,0,1-.41.7,2.732,2.732,0,0,1-.9.41,3.192,3.192,0,0,0-.9.378.728.728,0,0,0-.41.618,1.575,1.575,0,0,0,.156.56,6.9,6.9,0,0,0,1.334,1.953,5.6,5.6,0,0,0,1.881,1.315,5.875,5.875,0,0,0,1.042.3.42.42,0,0,1,.365.456q0,.911-2.852,1.341a1.379,1.379,0,0,0-.143.507,1.8,1.8,0,0,1-.182.605.451.451,0,0,1-.429.241,5.878,5.878,0,0,1-.807-.085,5.917,5.917,0,0,0-.833-.085,4.217,4.217,0,0,0-.807.065,2.42,2.42,0,0,0-.82.293,6.682,6.682,0,0,0-.755.5q-.351.267-.755.527a3.886,3.886,0,0,1-.989.436A4.471,4.471,0,0,1,11.831,22a4.307,4.307,0,0,1-1.256-.176,3.784,3.784,0,0,1-.976-.436q-.4-.26-.749-.527a6.682,6.682,0,0,0-.755-.5,2.422,2.422,0,0,0-.807-.293,4.432,4.432,0,0,0-.82-.065,5.089,5.089,0,0,0-.853.1,5,5,0,0,1-.762.1.474.474,0,0,1-.456-.241,1.819,1.819,0,0,1-.182-.618,1.411,1.411,0,0,0-.143-.521q-2.852-.429-2.852-1.341a.42.42,0,0,1,.365-.456,5.793,5.793,0,0,0,1.042-.3,5.524,5.524,0,0,0,1.881-1.315,6.789,6.789,0,0,0,1.334-1.953A1.575,1.575,0,0,0,6,12.9a.728.728,0,0,0-.41-.618,3.323,3.323,0,0,0-.9-.384,2.912,2.912,0,0,1-.9-.41.814.814,0,0,1-.41-.684.71.71,0,0,1,.338-.593,1.208,1.208,0,0,1,.716-.241,1.976,1.976,0,0,1,.625.169,2.008,2.008,0,0,0,.69.169.919.919,0,0,0,.416-.091q-.117-1.849-.117-2.474A5.861,5.861,0,0,1,6.385,5.4,5.516,5.516,0,0,1,8.625,2.819,7.075,7.075,0,0,1,12.062,2Z"
          }));
        };
      },
      9417: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SoundCloudIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.SoundCloudIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M8.9,16.1L9,14L8.9,9.5c0-0.1,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1L8.3,14l0.1,2.1 c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1C8.8,16.3,8.9,16.3,8.9,16.1z M11.4,15.9l0.1-1.8L11.4,9c0-0.1,0-0.2-0.1-0.2 c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2l0,0.1l-0.1,5c0,0,0,0.7,0.1,2v0c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2L11.4,15.9z M2.4,12.9L2.5,14l-0.2,1.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1L2.1,14 l0.1-1.1C2.2,12.9,2.3,12.9,2.4,12.9C2.3,12.9,2.4,12.9,2.4,12.9z M3.1,12.2L3.3,14l-0.2,1.8c0,0.1,0,0.1-0.1,0.1 c-0.1,0-0.1,0-0.1-0.1L2.8,14L3,12.2C3,12.2,3,12.2,3.1,12.2C3.1,12.2,3.1,12.2,3.1,12.2z M3.9,11.9L4.1,14l-0.2,2.1 c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1L3.5,14l0.2-2.1c0-0.1,0-0.1,0.1-0.1C3.9,11.8,3.9,11.8,3.9,11.9z M4.7,11.9L4.9,14 l-0.2,2.1c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1L4.3,14l0.2-2.2c0-0.1,0-0.1,0.1-0.1C4.7,11.7,4.7,11.8,4.7,11.9z M5.6,12 l0.2,2l-0.2,2.1c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1L5.1,14l0.2-2c0,0,0-0.1,0-0.1s0.1,0,0.1,0 C5.5,11.9,5.5,11.9,5.6,12L5.6,12z M6.4,10.7L6.6,14l-0.2,2.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.2-0.2L5.9,14 l0.2-3.3c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0C6.4,10.7,6.4,10.7,6.4,10.7z M7.2,10l0.2,4.1l-0.2,2.1c0,0,0,0.1,0,0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.2l-0.1-2.1L6.8,10c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0S7.2,9.9,7.2,10z M8,9.6L8.2,14 L8,16.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2L7.5,14l0.1-4.4c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1 C8,9.6,8,9.6,8,9.6z M11.4,16.1L11.4,16.1L11.4,16.1z M9.7,9.6L9.8,14l-0.1,2.1c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1 c-0.1,0-0.1,0-0.1-0.1s-0.1-0.1-0.1-0.2L9.2,14l0.1-4.4c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1S9.7,9.5,9.7,9.6 L9.7,9.6z M10.6,9.8l0.1,4.3l-0.1,2c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2L10,14 l0.1-4.3c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1S10.6,9.7,10.6,9.8z M12.4,14l-0.1,2c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1-1l-0.1-1l0.1-5.5v0c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.2L12.4,14z M22.1,13.9c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.5-1.1,0.7-1.7,0.7 h-6.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2V8.2c0-0.1,0.1-0.2,0.2-0.3c0.5-0.2,1-0.3,1.6-0.3c1.1,0,2.1,0.4,2.9,1.1 c0.8,0.8,1.3,1.7,1.4,2.8c0.3-0.1,0.6-0.2,1-0.2c0.7,0,1.3,0.2,1.7,0.7C21.8,12.6,22.1,13.2,22.1,13.9L22.1,13.9z"
          }));
        };
      },
      7712: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SpotifyIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.SpotifyIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12,2C6.477,2,2,6.477,2,12c0,5.523,4.477,10,10,10c5.523,0,10-4.477,10-10C22,6.477,17.523,2,12,2 M16.586,16.424 c-0.18,0.295-0.563,0.387-0.857,0.207c-2.348-1.435-5.304-1.76-8.785-0.964c-0.335,0.077-0.67-0.133-0.746-0.469 c-0.077-0.335,0.132-0.67,0.469-0.746c3.809-0.871,7.077-0.496,9.713,1.115C16.673,15.746,16.766,16.13,16.586,16.424 M17.81,13.7 c-0.226,0.367-0.706,0.482-1.072,0.257c-2.687-1.652-6.785-2.131-9.965-1.166C6.36,12.917,5.925,12.684,5.8,12.273 C5.675,11.86,5.908,11.425,6.32,11.3c3.632-1.102,8.147-0.568,11.234,1.328C17.92,12.854,18.035,13.335,17.81,13.7 M17.915,10.865 c-3.223-1.914-8.54-2.09-11.618-1.156C5.804,9.859,5.281,9.58,5.131,9.086C4.982,8.591,5.26,8.069,5.755,7.919 c3.532-1.072,9.404-0.865,13.115,1.338c0.445,0.264,0.59,0.838,0.327,1.282C18.933,10.983,18.359,11.129,17.915,10.865"
          }));
        };
      },
      8104: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TelegramIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.TelegramIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 128 128",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M28.9700376,63.3244248 C47.6273373,55.1957357 60.0684594,49.8368063 66.2934036,47.2476366 C84.0668845,39.855031 87.7600616,38.5708563 90.1672227,38.528 C90.6966555,38.5191258 91.8804274,38.6503351 92.6472251,39.2725385 C93.294694,39.7979149 93.4728387,40.5076237 93.5580865,41.0057381 C93.6433345,41.5038525 93.7494885,42.63857 93.6651041,43.5252052 C92.7019529,53.6451182 88.5344133,78.2034783 86.4142057,89.5379542 C85.5170662,94.3339958 83.750571,95.9420841 82.0403991,96.0994568 C78.3237996,96.4414641 75.5015827,93.6432685 71.9018743,91.2836143 C66.2690414,87.5912212 63.0868492,85.2926952 57.6192095,81.6896017 C51.3004058,77.5256038 55.3966232,75.2369981 58.9976911,71.4967761 C59.9401076,70.5179421 76.3155302,55.6232293 76.6324771,54.2720454 C76.6721165,54.1030573 76.7089039,53.4731496 76.3346867,53.1405352 C75.9604695,52.8079208 75.4081573,52.921662 75.0095933,53.0121213 C74.444641,53.1403447 65.4461175,59.0880351 48.0140228,70.8551922 C45.4598218,72.6091037 43.1463059,73.4636682 41.0734751,73.4188859 C38.7883453,73.3695169 34.3926725,72.1268388 31.1249416,71.0646282 C27.1169366,69.7617838 23.931454,69.0729605 24.208838,66.8603276 C24.3533167,65.7078514 25.9403832,64.5292172 28.9700376,63.3244248 Z"
          }));
        };
      },
      5551: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TiktokIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.TiktokIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 32 32",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z"
          }));
        };
      },
      8046: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TumblrIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.TumblrIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M17.04 21.28h-3.28c-2.84 0-4.94-1.37-4.94-5.02v-5.67H6.08V7.5c2.93-.73 4.11-3.3 4.3-5.48h3.01v4.93h3.47v3.65H13.4v4.93c0 1.47.73 2.01 1.92 2.01h1.73v3.75z"
          }));
        };
      },
      5822: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TwitchIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.TwitchIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M16.499,8.089h-1.636v4.91h1.636V8.089z M12,8.089h-1.637v4.91H12V8.089z M4.228,3.178L3,6.451v13.092h4.499V22h2.456 l2.454-2.456h3.681L21,14.636V3.178H4.228z M19.364,13.816l-2.864,2.865H12l-2.453,2.453V16.68H5.863V4.814h13.501V13.816z"
          }));
        };
      },
      4720: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TwitterIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.TwitterIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M22.23,5.924c-0.736,0.326-1.527,0.547-2.357,0.646c0.847-0.508,1.498-1.312,1.804-2.27 c-0.793,0.47-1.671,0.812-2.606,0.996C18.324,4.498,17.257,4,16.077,4c-2.266,0-4.103,1.837-4.103,4.103 c0,0.322,0.036,0.635,0.106,0.935C8.67,8.867,5.647,7.234,3.623,4.751C3.27,5.357,3.067,6.062,3.067,6.814 c0,1.424,0.724,2.679,1.825,3.415c-0.673-0.021-1.305-0.206-1.859-0.513c0,0.017,0,0.034,0,0.052c0,1.988,1.414,3.647,3.292,4.023 c-0.344,0.094-0.707,0.144-1.081,0.144c-0.264,0-0.521-0.026-0.772-0.074c0.522,1.63,2.038,2.816,3.833,2.85 c-1.404,1.1-3.174,1.756-5.096,1.756c-0.331,0-0.658-0.019-0.979-0.057c1.816,1.164,3.973,1.843,6.29,1.843 c7.547,0,11.675-6.252,11.675-11.675c0-0.178-0.004-0.355-0.012-0.531C20.985,7.47,21.68,6.747,22.23,5.924z"
          }));
        };
      },
      9100: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.VimeoIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.VimeoIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M22.396,7.164c-0.093,2.026-1.507,4.799-4.245,8.32C15.322,19.161,12.928,21,10.97,21c-1.214,0-2.24-1.119-3.079-3.359 c-0.56-2.053-1.119-4.106-1.68-6.159C5.588,9.243,4.921,8.122,4.206,8.122c-0.156,0-0.701,0.328-1.634,0.98L1.594,7.841 c1.027-0.902,2.04-1.805,3.037-2.708C6.001,3.95,7.03,3.327,7.715,3.264c1.619-0.156,2.616,0.951,2.99,3.321 c0.404,2.557,0.685,4.147,0.841,4.769c0.467,2.121,0.981,3.181,1.542,3.181c0.435,0,1.09-0.688,1.963-2.065 c0.871-1.376,1.338-2.422,1.401-3.142c0.125-1.187-0.343-1.782-1.401-1.782c-0.498,0-1.012,0.115-1.541,0.341 c1.023-3.35,2.977-4.977,5.862-4.884C21.511,3.066,22.52,4.453,22.396,7.164z"
          }));
        };
      },
      4157: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.VkIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.VkIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M22,7.1c0.2,0.4-0.4,1.5-1.6,3.1c-0.2,0.2-0.4,0.5-0.7,0.9c-0.5,0.7-0.9,1.1-0.9,1.4c-0.1,0.3-0.1,0.6,0.1,0.8 c0.1,0.1,0.4,0.4,0.8,0.9h0l0,0c1,0.9,1.6,1.7,2,2.3c0,0,0,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.3c0,0.1,0,0.2,0,0.4 c0,0.1-0.1,0.2-0.3,0.3c-0.1,0.1-0.4,0.1-0.6,0.1l-2.7,0c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.4-0.1-0.5-0.2l-0.2-0.1 c-0.2-0.1-0.5-0.4-0.7-0.7s-0.5-0.6-0.7-0.8c-0.2-0.2-0.4-0.4-0.6-0.6C14.8,15,14.6,15,14.4,15c0,0,0,0-0.1,0c0,0-0.1,0.1-0.2,0.2 c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.5-0.1,0.8c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2l0,0.1 c-0.1,0.1-0.3,0.2-0.6,0.2h-1.2c-0.5,0-1,0-1.5-0.2c-0.5-0.1-1-0.3-1.4-0.6s-0.7-0.5-1.1-0.7s-0.6-0.4-0.7-0.6l-0.3-0.3 c-0.1-0.1-0.2-0.2-0.3-0.3s-0.4-0.5-0.7-0.9s-0.7-1-1.1-1.6c-0.4-0.6-0.8-1.3-1.3-2.2C2.9,9.4,2.5,8.5,2.1,7.5C2,7.4,2,7.3,2,7.2 c0-0.1,0-0.1,0-0.2l0-0.1c0.1-0.1,0.3-0.2,0.6-0.2l2.9,0c0.1,0,0.2,0,0.2,0.1S5.9,6.9,5.9,7L6,7c0.1,0.1,0.2,0.2,0.3,0.3 C6.4,7.7,6.5,8,6.7,8.4C6.9,8.8,7,9,7.1,9.2l0.2,0.3c0.2,0.4,0.4,0.8,0.6,1.1c0.2,0.3,0.4,0.5,0.5,0.7s0.3,0.3,0.4,0.4 c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0.1-0.5,0.1-0.8 c0-0.4,0-0.8,0-1.3c0-0.3,0-0.5-0.1-0.8c0-0.2-0.1-0.4-0.1-0.5L9.6,7.6C9.4,7.3,9.1,7.2,8.7,7.1C8.6,7.1,8.6,7,8.7,6.9 C8.9,6.7,9,6.6,9.1,6.5c0.4-0.2,1.2-0.3,2.5-0.3c0.6,0,1,0.1,1.4,0.1c0.1,0,0.3,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.3s0,0.3,0,0.5c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.7c0,0.3,0,0.6,0,0.9c0,0.1,0,0.2,0,0.4c0,0.2,0,0.4,0,0.5 c0,0.1,0,0.3,0,0.4s0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.4-0.4 s0.3-0.4,0.5-0.7c0.2-0.3,0.5-0.7,0.7-1.1c0.4-0.7,0.8-1.5,1.1-2.3c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1l0,0l0.1,0 c0,0,0,0,0.1,0s0.2,0,0.2,0l3,0c0.3,0,0.5,0,0.7,0S21.9,7,21.9,7L22,7.1z"
          }));
        };
      },
      3874: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.WordPressIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.WordPressIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, m.createElement)(v.Path, {
            d: "M12.158,12.786L9.46,20.625c0.806,0.237,1.657,0.366,2.54,0.366c1.047,0,2.051-0.181,2.986-0.51 c-0.024-0.038-0.046-0.079-0.065-0.124L12.158,12.786z M3.009,12c0,3.559,2.068,6.634,5.067,8.092L3.788,8.341 C3.289,9.459,3.009,10.696,3.009,12z M18.069,11.546c0-1.112-0.399-1.881-0.741-2.48c-0.456-0.741-0.883-1.368-0.883-2.109 c0-0.826,0.627-1.596,1.51-1.596c0.04,0,0.078,0.005,0.116,0.007C16.472,3.904,14.34,3.009,12,3.009 c-3.141,0-5.904,1.612-7.512,4.052c0.211,0.007,0.41,0.011,0.579,0.011c0.94,0,2.396-0.114,2.396-0.114 C7.947,6.93,8.004,7.642,7.52,7.699c0,0-0.487,0.057-1.029,0.085l3.274,9.739l1.968-5.901l-1.401-3.838 C9.848,7.756,9.389,7.699,9.389,7.699C8.904,7.67,8.961,6.93,9.446,6.958c0,0,1.484,0.114,2.368,0.114 c0.94,0,2.397-0.114,2.397-0.114c0.485-0.028,0.542,0.684,0.057,0.741c0,0-0.488,0.057-1.029,0.085l3.249,9.665l0.897-2.996 C17.841,13.284,18.069,12.316,18.069,11.546z M19.889,7.686c0.039,0.286,0.06,0.593,0.06,0.924c0,0.912-0.171,1.938-0.684,3.22 l-2.746,7.94c2.673-1.558,4.47-4.454,4.47-7.771C20.991,10.436,20.591,8.967,19.889,7.686z M12,22C6.486,22,2,17.514,2,12 C2,6.486,6.486,2,12,2c5.514,0,10,4.486,10,10C22,17.514,17.514,22,12,22z"
          }));
        };
      },
      183: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.YelpIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.YelpIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M12.271,16.718v1.417q-.011,3.257-.067,3.4a.707.707,0,0,1-.569.446,4.637,4.637,0,0,1-2.024-.424A4.609,4.609,0,0,1,7.8,20.565a.844.844,0,0,1-.19-.4.692.692,0,0,1,.044-.29,3.181,3.181,0,0,1,.379-.524q.335-.412,2.019-2.409.011,0,.669-.781a.757.757,0,0,1,.44-.274.965.965,0,0,1,.552.039.945.945,0,0,1,.418.324.732.732,0,0,1,.139.468Zm-1.662-2.8a.783.783,0,0,1-.58.781l-1.339.435q-3.067.981-3.257.981a.711.711,0,0,1-.6-.4,2.636,2.636,0,0,1-.19-.836,9.134,9.134,0,0,1,.011-1.857,3.559,3.559,0,0,1,.335-1.389.659.659,0,0,1,.625-.357,22.629,22.629,0,0,1,2.253.859q.781.324,1.283.524l.937.379a.771.771,0,0,1,.4.34A.982.982,0,0,1,10.609,13.917Zm9.213,3.313a4.467,4.467,0,0,1-1.021,1.8,4.559,4.559,0,0,1-1.512,1.417.671.671,0,0,1-.7-.078q-.156-.112-2.052-3.2l-.524-.859a.761.761,0,0,1-.128-.513.957.957,0,0,1,.217-.513.774.774,0,0,1,.926-.29q.011.011,1.327.446,2.264.736,2.7.887a2.082,2.082,0,0,1,.524.229.673.673,0,0,1,.245.68Zm-7.5-7.049q.056,1.137-.6,1.361-.647.19-1.272-.792L6.237,4.08a.7.7,0,0,1,.212-.691,5.788,5.788,0,0,1,2.314-1,5.928,5.928,0,0,1,2.5-.352.681.681,0,0,1,.547.5q.034.2.245,3.407T12.327,10.181Zm7.384,1.2a.679.679,0,0,1-.29.658q-.167.112-3.67.959-.747.167-1.015.257l.011-.022a.769.769,0,0,1-.513-.044.914.914,0,0,1-.413-.357.786.786,0,0,1,0-.971q.011-.011.836-1.137,1.394-1.908,1.673-2.275a2.423,2.423,0,0,1,.379-.435A.7.7,0,0,1,17.435,8a4.482,4.482,0,0,1,1.372,1.489,4.81,4.81,0,0,1,.9,1.868v.034Z"
          }));
        };
      },
      1912: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.YouTubeIcon = void 0;
        var m = c(1753),
            v = c(1666);

        s.YouTubeIcon = function () {
          return (0, m.createElement)(v.SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1"
          }, (0, m.createElement)(v.Path, {
            d: "M21.8,8.001c0,0-0.195-1.378-0.795-1.985c-0.76-0.797-1.613-0.801-2.004-0.847c-2.799-0.202-6.997-0.202-6.997-0.202 h-0.009c0,0-4.198,0-6.997,0.202C4.608,5.216,3.756,5.22,2.995,6.016C2.395,6.623,2.2,8.001,2.2,8.001S2,9.62,2,11.238v1.517 c0,1.618,0.2,3.237,0.2,3.237s0.195,1.378,0.795,1.985c0.761,0.797,1.76,0.771,2.205,0.855c1.6,0.153,6.8,0.201,6.8,0.201 s4.203-0.006,7.001-0.209c0.391-0.047,1.243-0.051,2.004-0.847c0.6-0.607,0.795-1.985,0.795-1.985s0.2-1.618,0.2-3.237v-1.517 C22,9.62,21.8,8.001,21.8,8.001z M9.935,14.594l-0.001-5.62l5.404,2.82L9.935,14.594z"
          }));
        };
      },
      787: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(4868)),
            y = m(c(8633));

        var k = {
          apiVersion: 2,
          name: "core/social-link",
          title: "Social Icon",
          category: "widgets",
          parent: ["core/social-links"],
          description: "Display an icon linking to a social media profile or website.",
          textdomain: "default",
          attributes: {
            url: {
              type: "string"
            },
            service: {
              type: "string"
            },
            label: {
              type: "string"
            }
          },
          usesContext: ["openInNewTab", "iconColorValue", "iconBackgroundColorValue"],
          supports: {
            reusable: !1,
            html: !1
          },
          editorStyle: "wp-block-social-link-editor"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.share,
          edit: _.default,
          variations: y.default
        };
        s.settings = w;
      },
      1893: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getNameBySite = s.getIconBySite = void 0;

        var v = c(4793),
            _ = c(6756),
            y = m(c(8633)),
            k = c(4253);

        s.getIconBySite = function (l) {
          var s = (0, v.find)(y.default, {
            name: l
          });
          return s ? s.icon : k.ChainIcon;
        };

        s.getNameBySite = function (l) {
          var s = (0, v.find)(y.default, {
            name: l
          });
          return s ? s.title : (0, _.__)("Social Icon");
        };
      },
      8633: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4253);
        var v = [{
          isDefault: !0,
          name: "wordpress",
          attributes: {
            service: "wordpress"
          },
          title: "WordPress",
          icon: m.WordPressIcon
        }, {
          name: "fivehundredpx",
          attributes: {
            service: "fivehundredpx"
          },
          title: "500px",
          icon: m.FivehundredpxIcon
        }, {
          name: "amazon",
          attributes: {
            service: "amazon"
          },
          title: "Amazon",
          icon: m.AmazonIcon
        }, {
          name: "bandcamp",
          attributes: {
            service: "bandcamp"
          },
          title: "Bandcamp",
          icon: m.BandcampIcon
        }, {
          name: "behance",
          attributes: {
            service: "behance"
          },
          title: "Behance",
          icon: m.BehanceIcon
        }, {
          name: "chain",
          attributes: {
            service: "chain"
          },
          title: "Link",
          icon: m.ChainIcon
        }, {
          name: "codepen",
          attributes: {
            service: "codepen"
          },
          title: "CodePen",
          icon: m.CodepenIcon
        }, {
          name: "deviantart",
          attributes: {
            service: "deviantart"
          },
          title: "DeviantArt",
          icon: m.DeviantArtIcon
        }, {
          name: "dribbble",
          attributes: {
            service: "dribbble"
          },
          title: "Dribbble",
          icon: m.DribbbleIcon
        }, {
          name: "dropbox",
          attributes: {
            service: "dropbox"
          },
          title: "Dropbox",
          icon: m.DropboxIcon
        }, {
          name: "etsy",
          attributes: {
            service: "etsy"
          },
          title: "Etsy",
          icon: m.EtsyIcon
        }, {
          name: "facebook",
          attributes: {
            service: "facebook"
          },
          title: "Facebook",
          icon: m.FacebookIcon
        }, {
          name: "feed",
          attributes: {
            service: "feed"
          },
          title: "RSS Feed",
          icon: m.FeedIcon
        }, {
          name: "flickr",
          attributes: {
            service: "flickr"
          },
          title: "Flickr",
          icon: m.FlickrIcon
        }, {
          name: "foursquare",
          attributes: {
            service: "foursquare"
          },
          title: "Foursquare",
          icon: m.FoursquareIcon
        }, {
          name: "goodreads",
          attributes: {
            service: "goodreads"
          },
          title: "Goodreads",
          icon: m.GoodreadsIcon
        }, {
          name: "google",
          attributes: {
            service: "google"
          },
          title: "Google",
          icon: m.GoogleIcon
        }, {
          name: "github",
          attributes: {
            service: "github"
          },
          title: "GitHub",
          icon: m.GitHubIcon
        }, {
          name: "instagram",
          attributes: {
            service: "instagram"
          },
          title: "Instagram",
          icon: m.InstagramIcon
        }, {
          name: "lastfm",
          attributes: {
            service: "lastfm"
          },
          title: "Last.fm",
          icon: m.LastfmIcon
        }, {
          name: "linkedin",
          attributes: {
            service: "linkedin"
          },
          title: "LinkedIn",
          icon: m.LinkedInIcon
        }, {
          name: "mail",
          attributes: {
            service: "mail"
          },
          title: "Mail",
          keywords: ["email", "e-mail"],
          icon: m.MailIcon
        }, {
          name: "mastodon",
          attributes: {
            service: "mastodon"
          },
          title: "Mastodon",
          icon: m.MastodonIcon
        }, {
          name: "meetup",
          attributes: {
            service: "meetup"
          },
          title: "Meetup",
          icon: m.MeetupIcon
        }, {
          name: "medium",
          attributes: {
            service: "medium"
          },
          title: "Medium",
          icon: m.MediumIcon
        }, {
          name: "patreon",
          attributes: {
            service: "patreon"
          },
          title: "Patreon",
          icon: m.PatreonIcon
        }, {
          name: "pinterest",
          attributes: {
            service: "pinterest"
          },
          title: "Pinterest",
          icon: m.PinterestIcon
        }, {
          name: "pocket",
          attributes: {
            service: "pocket"
          },
          title: "Pocket",
          icon: m.PocketIcon
        }, {
          name: "reddit",
          attributes: {
            service: "reddit"
          },
          title: "Reddit",
          icon: m.RedditIcon
        }, {
          name: "skype",
          attributes: {
            service: "skype"
          },
          title: "Skype",
          icon: m.SkypeIcon
        }, {
          name: "snapchat",
          attributes: {
            service: "snapchat"
          },
          title: "Snapchat",
          icon: m.SnapchatIcon
        }, {
          name: "soundcloud",
          attributes: {
            service: "soundcloud"
          },
          title: "SoundCloud",
          icon: m.SoundCloudIcon
        }, {
          name: "spotify",
          attributes: {
            service: "spotify"
          },
          title: "Spotify",
          icon: m.SpotifyIcon
        }, {
          name: "telegram",
          attributes: {
            service: "telegram"
          },
          title: "Telegram",
          icon: m.TelegramIcon
        }, {
          name: "tiktok",
          attributes: {
            service: "tiktok"
          },
          title: "TikTok",
          icon: m.TiktokIcon
        }, {
          name: "tumblr",
          attributes: {
            service: "tumblr"
          },
          title: "Tumblr",
          icon: m.TumblrIcon
        }, {
          name: "twitch",
          attributes: {
            service: "twitch"
          },
          title: "Twitch",
          icon: m.TwitchIcon
        }, {
          name: "twitter",
          attributes: {
            service: "twitter"
          },
          title: "Twitter",
          icon: m.TwitterIcon
        }, {
          name: "vimeo",
          attributes: {
            service: "vimeo"
          },
          title: "Vimeo",
          icon: m.VimeoIcon
        }, {
          name: "vk",
          attributes: {
            service: "vk"
          },
          title: "VK",
          icon: m.VkIcon
        }, {
          name: "yelp",
          attributes: {
            service: "yelp"
          },
          title: "Yelp",
          icon: m.YelpIcon
        }, {
          name: "youtube",
          attributes: {
            service: "youtube"
          },
          title: "YouTube",
          icon: m.YouTubeIcon
        }];
        v.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            return l.service === s.service;
          });
        });
        var _ = v;
        s.default = _;
      },
      5875: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var migrateWithLayout = function migrateWithLayout(l) {
          var s, c;
          if (l.layout) return l;

          var m = l.className,
              v = "items-justified-",
              _ = new RegExp("\\b".concat(v, "[^ ]*[ ]?\\b"), "g"),
              y = _objectSpread(_objectSpread({}, l), {}, {
            className: null == m ? void 0 : m.replace(_, "").trim()
          }),
              k = null == m || null === (s = m.match(_)) || void 0 === s || null === (c = s[0]) || void 0 === c ? void 0 : c.trim();

          return k && Object.assign(y, {
            layout: {
              type: "flex",
              justifyContent: k.slice(v.length)
            }
          }), y;
        };

        var k = [{
          attributes: {
            iconColor: {
              type: "string"
            },
            customIconColor: {
              type: "string"
            },
            iconColorValue: {
              type: "string"
            },
            iconBackgroundColor: {
              type: "string"
            },
            customIconBackgroundColor: {
              type: "string"
            },
            iconBackgroundColorValue: {
              type: "string"
            },
            openInNewTab: {
              type: "boolean",
              default: !1
            },
            size: {
              type: "string"
            }
          },
          supports: {
            align: ["left", "center", "right"],
            anchor: !0,
            __experimentalExposeControlsToChildren: !0
          },
          isEligible: function isEligible(l) {
            var s = l.layout;
            return !s;
          },
          migrate: migrateWithLayout,
          save: function save(l) {
            var _l$attributes27 = l.attributes,
                s = _l$attributes27.iconBackgroundColorValue,
                c = _l$attributes27.iconColorValue,
                m = _l$attributes27.itemsJustification,
                k = _l$attributes27.size,
                E = (0, _.default)(k, _defineProperty({
              "has-icon-color": c,
              "has-icon-background-color": s
            }, "items-justified-".concat(m), m));
            return (0, v.createElement)("ul", y.useBlockProps.save({
              className: E
            }), (0, v.createElement)(y.InnerBlocks.Content, null));
          }
        }, {
          attributes: {
            iconColor: {
              type: "string"
            },
            customIconColor: {
              type: "string"
            },
            iconColorValue: {
              type: "string"
            },
            iconBackgroundColor: {
              type: "string"
            },
            customIconBackgroundColor: {
              type: "string"
            },
            iconBackgroundColorValue: {
              type: "string"
            },
            openInNewTab: {
              type: "boolean",
              default: !1
            },
            size: {
              type: "string"
            }
          },
          providesContext: {
            openInNewTab: "openInNewTab"
          },
          supports: {
            align: ["left", "center", "right"],
            anchor: !0
          },
          migrate: migrateWithLayout,
          save: function save(l) {
            var _l$attributes28 = l.attributes,
                s = _l$attributes28.iconBackgroundColorValue,
                c = _l$attributes28.iconColorValue,
                m = _l$attributes28.itemsJustification,
                k = _l$attributes28.size,
                E = (0, _.default)(k, _defineProperty({
              "has-icon-color": c,
              "has-icon-background-color": s
            }, "items-justified-".concat(m), m)),
                w = {
              "--wp--social-links--icon-color": c,
              "--wp--social-links--icon-background-color": s
            };
            return (0, v.createElement)("ul", y.useBlockProps.save({
              className: E,
              style: w
            }), (0, v.createElement)(y.InnerBlocks.Content, null));
          }
        }];
        s.default = k;
      },
      3758: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SocialLinksEdit = SocialLinksEdit, s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6700),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(5303);

        var S = ["core/social-link"],
            P = [{
          name: (0, w.__)("Small"),
          value: "has-small-icon-size"
        }, {
          name: (0, w.__)("Normal"),
          value: "has-normal-icon-size"
        }, {
          name: (0, w.__)("Large"),
          value: "has-large-icon-size"
        }, {
          name: (0, w.__)("Huge"),
          value: "has-huge-icon-size"
        }];

        function SocialLinksEdit(l) {
          var s;

          var c = l.name,
              m = l.attributes,
              T = l.iconBackgroundColor,
              B = l.iconColor,
              z = l.isSelected,
              L = l.setAttributes,
              V = l.setIconBackgroundColor,
              A = l.setIconColor,
              R = m.iconBackgroundColorValue,
              O = m.iconColorValue,
              D = m.openInNewTab,
              F = m.size,
              G = m.layout,
              q = G || function (l) {
            var s = (0, y.getBlockSupport)(l, "__experimentalLayout");
            return null == s ? void 0 : s.default;
          }(c),
              W = (null === (s = m.className) || void 0 === s ? void 0 : s.indexOf("is-style-logos-only")) >= 0;

          (0, v.useEffect)(function () {
            W && L({
              iconBackgroundColor: void 0,
              customIconBackgroundColor: void 0,
              iconBackgroundColorValue: void 0
            });
          }, [W, L]);
          var U = (0, v.createElement)("li", {
            className: "wp-block-social-links__social-placeholder"
          }, (0, v.createElement)("div", {
            className: "wp-social-link"
          }), (0, v.createElement)("div", {
            className: "wp-block-social-links__social-placeholder-icons"
          }, (0, v.createElement)("div", {
            className: "wp-social-link wp-social-link-twitter"
          }), (0, v.createElement)("div", {
            className: "wp-social-link wp-social-link-facebook"
          }), (0, v.createElement)("div", {
            className: "wp-social-link wp-social-link-instagram"
          }))),
              $ = (0, v.createElement)("li", {
            className: "wp-block-social-links__social-prompt"
          }, (0, w.__)("Click plus to add")),
              Z = (0, _.default)(F, {
            "has-icon-color": B.color || O,
            "has-icon-background-color": T.color || R
          }),
              K = (0, k.useBlockProps)({
            className: Z
          }),
              Q = (0, k.useInnerBlocksProps)(K, {
            allowedBlocks: S,
            placeholder: z ? $ : U,
            templateLock: !1,
            __experimentalAppenderTagName: "li",
            __experimentalLayout: q
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "other"
          }, (0, v.createElement)(E.ToolbarDropdownMenu, {
            label: (0, w.__)("Size"),
            text: (0, w.__)("Size"),
            icon: null,
            popoverProps: {
              position: "bottom right"
            }
          }, function (l) {
            var s = l.onClose;
            return (0, v.createElement)(E.MenuGroup, null, P.map(function (l) {
              return (0, v.createElement)(E.MenuItem, {
                icon: (F === l.value || !F && "has-normal-icon-size" === l.value) && C.check,
                isSelected: F === l.value,
                key: l.value,
                onClick: function onClick() {
                  L({
                    size: l.value
                  });
                },
                onClose: s,
                role: "menuitemradio"
              }, l.name);
            }));
          })), (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, w.__)("Link settings")
          }, (0, v.createElement)(E.ToggleControl, {
            label: (0, w.__)("Open links in new tab"),
            checked: D,
            onChange: function onChange() {
              return L({
                openInNewTab: !D
              });
            }
          })), (0, v.createElement)(k.PanelColorSettings, {
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0,
            title: (0, w.__)("Color"),
            colorSettings: [{
              value: B.color || O,
              onChange: function onChange(l) {
                A(l), L({
                  iconColorValue: l
                });
              },
              label: (0, w.__)("Icon color")
            }, !W && {
              value: T.color || R,
              onChange: function onChange(l) {
                V(l), L({
                  iconBackgroundColorValue: l
                });
              },
              label: (0, w.__)("Icon background color")
            }]
          }), !W && (0, v.createElement)(k.ContrastChecker, {
            textColor: O,
            backgroundColor: R,
            isLargeText: !1
          })), (0, v.createElement)("ul", Q));
        }

        var T = (0, k.withColors)({
          iconColor: "icon-color",
          iconBackgroundColor: "icon-background-color"
        })(SocialLinksEdit);
        s.default = T;
      },
      4732: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(5875)),
            y = m(c(3758)),
            k = m(c(5505));

        var E = {
          apiVersion: 2,
          name: "core/social-links",
          title: "Social Icons",
          category: "widgets",
          description: "Display icons linking to your social media profiles or websites.",
          keywords: ["links"],
          textdomain: "default",
          attributes: {
            iconColor: {
              type: "string"
            },
            customIconColor: {
              type: "string"
            },
            iconColorValue: {
              type: "string"
            },
            iconBackgroundColor: {
              type: "string"
            },
            customIconBackgroundColor: {
              type: "string"
            },
            iconBackgroundColorValue: {
              type: "string"
            },
            openInNewTab: {
              type: "boolean",
              default: !1
            },
            size: {
              type: "string"
            }
          },
          providesContext: {
            openInNewTab: "openInNewTab",
            iconColorValue: "iconColorValue",
            iconBackgroundColorValue: "iconBackgroundColorValue"
          },
          supports: {
            align: ["left", "center", "right"],
            anchor: !0,
            __experimentalExposeControlsToChildren: !0,
            __experimentalLayout: {
              allowSwitching: !1,
              allowInheriting: !1,
              default: {
                type: "flex"
              }
            },
            spacing: {
              blockGap: !0,
              margin: ["top", "bottom"],
              units: ["px", "em", "rem", "vh", "vw"],
              __experimentalDefaultControls: {
                blockGap: !0
              }
            }
          },
          styles: [{
            name: "default",
            label: "Default",
            isDefault: !0
          }, {
            name: "logos-only",
            label: "Logos Only"
          }, {
            name: "pill-shape",
            label: "Pill Shape"
          }],
          editorStyle: "wp-block-social-links-editor",
          style: "wp-block-social-links"
        };
        s.metadata = E;
        var w = E.name;
        s.name = w;
        var C = {
          example: {
            innerBlocks: [{
              name: "core/social-link",
              attributes: {
                service: "wordpress",
                url: "https://wordpress.org"
              }
            }, {
              name: "core/social-link",
              attributes: {
                service: "facebook",
                url: "https://www.facebook.com/WordPress/"
              }
            }, {
              name: "core/social-link",
              attributes: {
                service: "twitter",
                url: "https://twitter.com/WordPress"
              }
            }]
          },
          icon: v.share,
          edit: y.default,
          save: k.default,
          deprecated: _.default
        };
        s.settings = C;
      },
      5505: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var _l$attributes29 = l.attributes,
              s = _l$attributes29.iconBackgroundColorValue,
              c = _l$attributes29.iconColorValue,
              m = _l$attributes29.size,
              k = (0, _.default)(m, {
            "has-icon-color": c,
            "has-icon-background-color": s
          }),
              E = y.useBlockProps.save({
            className: k
          }),
              w = y.useInnerBlocksProps.save(E);
          return (0, v.createElement)("ul", w);
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      1234: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(1326),
            E = c(4892),
            w = c(3200),
            C = c(8467),
            S = c(1666);

        var P = (0, w.compose)([(0, C.withDispatch)(function (l) {
          var _l78 = l(k.store),
              s = _l78.toggleSelection;

          return {
            onResizeStart: function onResizeStart() {
              return s(!1);
            },
            onResizeStop: function onResizeStop() {
              return s(!0);
            }
          };
        }), w.withInstanceId])(function (l) {
          var s = l.attributes,
              c = l.isSelected,
              m = l.setAttributes,
              w = l.onResizeStart,
              C = l.onResizeStop,
              P = l.context;

          var T = P.orientation,
              _ref364 = (0, v.useState)(!1),
              _ref365 = _slicedToArray2(_ref364, 2),
              B = _ref365[0],
              z = _ref365[1],
              L = s.height,
              V = s.width,
              updateHeight = function updateHeight(l) {
            m({
              height: l
            });
          },
              updateWidth = function updateWidth(l) {
            m({
              width: l
            });
          },
              handleOnResizeStart = function handleOnResizeStart() {
            w.apply(void 0, arguments), z(!0);
          },
              handleOnVerticalResizeStop = function handleOnVerticalResizeStop(l, s, c, m) {
            C();
            var v = Math.min(parseInt(L + m.height, 10), 500);
            updateHeight(v), z(!1);
          },
              handleOnHorizontalResizeStop = function handleOnHorizontalResizeStop(l, s, c, m) {
            C();
            var v = Math.min(parseInt(V + m.width, 10), 500);
            updateWidth(v), z(!1);
          };

          return (0, v.useEffect)(function () {
            "horizontal" !== T || V || (updateWidth(72), updateHeight(0));
          }, []), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(S.View, (0, k.useBlockProps)(), "horizontal" === T ? (0, v.createElement)(E.ResizableBox, {
            className: (0, _.default)("block-library-spacer__resize-container", "resize-horizontal", {
              "is-selected": c
            }),
            size: {
              width: V,
              height: 24
            },
            minWidth: 1,
            enable: {
              top: !1,
              right: !0,
              bottom: !1,
              left: !1,
              topRight: !1,
              bottomRight: !1,
              bottomLeft: !1,
              topLeft: !1
            },
            onResizeStart: handleOnResizeStart,
            onResizeStop: handleOnHorizontalResizeStop,
            showHandle: c,
            __experimentalShowTooltip: !0,
            __experimentalTooltipProps: {
              axis: "x",
              position: "corner",
              isVisible: B
            }
          }) : (0, v.createElement)(E.ResizableBox, {
            className: (0, _.default)("block-library-spacer__resize-container", {
              "is-selected": c
            }),
            size: {
              height: L
            },
            minHeight: 1,
            enable: {
              top: !1,
              right: !1,
              bottom: !0,
              left: !1,
              topRight: !1,
              bottomRight: !1,
              bottomLeft: !1,
              topLeft: !1
            },
            onResizeStart: handleOnResizeStart,
            onResizeStop: handleOnVerticalResizeStop,
            showHandle: c,
            __experimentalShowTooltip: !0,
            __experimentalTooltipProps: {
              axis: "y",
              position: "bottom",
              isVisible: B
            }
          })), (0, v.createElement)(k.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, y.__)("Spacer settings")
          }, "horizontal" === T && (0, v.createElement)(E.RangeControl, {
            label: (0, y.__)("Width in pixels"),
            min: 1,
            max: Math.max(500, V),
            value: V,
            onChange: updateWidth
          }), "horizontal" !== T && (0, v.createElement)(E.RangeControl, {
            label: (0, y.__)("Height in pixels"),
            min: 1,
            max: Math.max(500, L),
            value: L,
            onChange: updateHeight
          }))));
        });
        s.default = P;
      },
      1038: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(1234)),
            y = m(c(4570));

        var k = {
          apiVersion: 2,
          name: "core/spacer",
          title: "Spacer",
          category: "design",
          description: "Add white space between blocks and customize its height.",
          textdomain: "default",
          attributes: {
            height: {
              type: "number",
              default: 100
            },
            width: {
              type: "number"
            }
          },
          usesContext: ["orientation"],
          supports: {
            anchor: !0
          },
          editorStyle: "wp-block-spacer-editor",
          style: "wp-block-spacer"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          icon: v.resizeCornerNE,
          edit: _.default,
          save: y.default
        };
        s.settings = w;
      },
      4570: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          return (0, m.createElement)("div", v.useBlockProps.save({
            style: {
              height: s.height,
              width: s.width
            },
            "aria-hidden": !0
          }));
        };
        var m = c(1753),
            v = c(1326);
      },
      3290: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var k = {
          "subtle-light-gray": "#f3f4f5",
          "subtle-pale-green": "#e9fbe5",
          "subtle-pale-blue": "#e7f5fe",
          "subtle-pale-pink": "#fcf0ef"
        };
        var E = [{
          attributes: {
            hasFixedLayout: {
              type: "boolean",
              default: !1
            },
            backgroundColor: {
              type: "string"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption",
              default: ""
            },
            head: {
              type: "array",
              default: [],
              source: "query",
              selector: "thead tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            },
            body: {
              type: "array",
              default: [],
              source: "query",
              selector: "tbody tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            },
            foot: {
              type: "array",
              default: [],
              source: "query",
              selector: "tfoot tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            }
          },
          supports: {
            anchor: !0,
            align: !0,
            __experimentalSelector: ".wp-block-table > table"
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.hasFixedLayout,
                m = s.head,
                k = s.body,
                E = s.foot,
                w = s.backgroundColor,
                C = s.caption;
            if (!m.length && !k.length && !E.length) return null;

            var S = (0, y.getColorClassName)("background-color", w),
                P = (0, _.default)(S, {
              "has-fixed-layout": c,
              "has-background": !!S
            }),
                T = !y.RichText.isEmpty(C),
                Section = function Section(l) {
              var s = l.type,
                  c = l.rows;
              if (!c.length) return null;
              var m = "t".concat(s);
              return (0, v.createElement)(m, null, c.map(function (l, s) {
                var c = l.cells;
                return (0, v.createElement)("tr", {
                  key: s
                }, c.map(function (l, s) {
                  var c = l.content,
                      m = l.tag,
                      k = l.scope,
                      E = l.align;
                  var w = (0, _.default)(_defineProperty({}, "has-text-align-".concat(E), E));
                  return (0, v.createElement)(y.RichText.Content, {
                    className: w || void 0,
                    "data-align": E,
                    tagName: m,
                    value: c,
                    key: s,
                    scope: "th" === m ? k : void 0
                  });
                }));
              }));
            };

            return (0, v.createElement)("figure", y.useBlockProps.save(), (0, v.createElement)("table", {
              className: "" === P ? void 0 : P
            }, (0, v.createElement)(Section, {
              type: "head",
              rows: m
            }), (0, v.createElement)(Section, {
              type: "body",
              rows: k
            }), (0, v.createElement)(Section, {
              type: "foot",
              rows: E
            })), T && (0, v.createElement)(y.RichText.Content, {
              tagName: "figcaption",
              value: C
            }));
          },
          isEligible: function isEligible(l) {
            return l.backgroundColor && !l.style;
          },
          migrate: function migrate(l) {
            return _objectSpread(_objectSpread({}, l), {}, {
              backgroundColor: void 0,
              style: {
                color: {
                  background: k[l.backgroundColor]
                }
              }
            });
          }
        }, {
          attributes: {
            hasFixedLayout: {
              type: "boolean",
              default: !1
            },
            backgroundColor: {
              type: "string"
            },
            head: {
              type: "array",
              default: [],
              source: "query",
              selector: "thead tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    }
                  }
                }
              }
            },
            body: {
              type: "array",
              default: [],
              source: "query",
              selector: "tbody tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    }
                  }
                }
              }
            },
            foot: {
              type: "array",
              default: [],
              source: "query",
              selector: "tfoot tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    }
                  }
                }
              }
            }
          },
          supports: {
            align: !0
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.hasFixedLayout,
                m = s.head,
                k = s.body,
                E = s.foot,
                w = s.backgroundColor;
            if (!m.length && !k.length && !E.length) return null;

            var C = (0, y.getColorClassName)("background-color", w),
                S = (0, _.default)(C, {
              "has-fixed-layout": c,
              "has-background": !!C
            }),
                Section = function Section(l) {
              var s = l.type,
                  c = l.rows;
              if (!c.length) return null;
              var m = "t".concat(s);
              return (0, v.createElement)(m, null, c.map(function (l, s) {
                var c = l.cells;
                return (0, v.createElement)("tr", {
                  key: s
                }, c.map(function (l, s) {
                  var c = l.content,
                      m = l.tag,
                      _ = l.scope;
                  return (0, v.createElement)(y.RichText.Content, {
                    tagName: m,
                    value: c,
                    key: s,
                    scope: "th" === m ? _ : void 0
                  });
                }));
              }));
            };

            return (0, v.createElement)("table", {
              className: S
            }, (0, v.createElement)(Section, {
              type: "head",
              rows: m
            }), (0, v.createElement)(Section, {
              type: "body",
              rows: k
            }), (0, v.createElement)(Section, {
              type: "foot",
              rows: E
            }));
          }
        }];
        s.default = E;
      },
      7264: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326),
            k = c(6756),
            E = c(4892),
            w = c(5303),
            C = c(6700),
            S = c(6849);

        var P = [{
          icon: w.alignLeft,
          title: (0, k.__)("Align column left"),
          align: "left"
        }, {
          icon: w.alignCenter,
          title: (0, k.__)("Align column center"),
          align: "center"
        }, {
          icon: w.alignRight,
          title: (0, k.__)("Align column right"),
          align: "right"
        }],
            T = {
          head: (0, k.__)("Header cell text"),
          body: (0, k.__)("Body cell text"),
          foot: (0, k.__)("Footer cell text")
        },
            B = {
          head: (0, k.__)("Header label"),
          foot: (0, k.__)("Footer label")
        };

        function TSection(l) {
          var s = l.name,
              c = _objectWithoutProperties(l, _excluded18);

          var m = "t".concat(s);
          return (0, v.createElement)(m, c);
        }

        var z = function TableEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.insertBlocksAfter,
              z = l.isSelected;

          var L = s.hasFixedLayout,
              V = s.caption,
              A = s.head,
              R = s.foot,
              _ref367 = (0, v.useState)(2),
              _ref368 = _slicedToArray2(_ref367, 2),
              O = _ref368[0],
              D = _ref368[1],
              _ref369 = (0, v.useState)(2),
              _ref370 = _slicedToArray2(_ref369, 2),
              F = _ref370[0],
              G = _ref370[1],
              _ref371 = (0, v.useState)(),
              _ref372 = _slicedToArray2(_ref371, 2),
              q = _ref372[0],
              W = _ref372[1],
              U = (0, y.__experimentalUseColorProps)(s),
              $ = (0, y.__experimentalUseBorderProps)(s);

          function onChange(l) {
            q && c((0, S.updateSelectedCell)(s, q, function (s) {
              return _objectSpread(_objectSpread({}, s), {}, {
                content: l
              });
            }));
          }

          function onInsertRow(l) {
            if (!q) return;

            var m = q.sectionName,
                v = q.rowIndex,
                _ = v + l;

            c((0, S.insertRow)(s, {
              sectionName: m,
              rowIndex: _
            })), W({
              sectionName: m,
              rowIndex: _,
              columnIndex: 0,
              type: "cell"
            });
          }

          function onInsertColumn() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
            if (!q) return;
            var m = q.columnIndex,
                v = m + l;
            c((0, S.insertColumn)(s, {
              columnIndex: v
            })), W({
              rowIndex: 0,
              columnIndex: v,
              type: "cell"
            });
          }

          (0, v.useEffect)(function () {
            z || W();
          }, [z]);
          var Z = ["head", "body", "foot"].filter(function (l) {
            return !(0, S.isEmptyTableSection)(s[l]);
          }),
              K = [{
            icon: w.tableRowBefore,
            title: (0, k.__)("Insert row before"),
            isDisabled: !q,
            onClick: function onInsertRowBefore() {
              onInsertRow(0);
            }
          }, {
            icon: w.tableRowAfter,
            title: (0, k.__)("Insert row after"),
            isDisabled: !q,
            onClick: function onInsertRowAfter() {
              onInsertRow(1);
            }
          }, {
            icon: w.tableRowDelete,
            title: (0, k.__)("Delete row"),
            isDisabled: !q,
            onClick: function onDeleteRow() {
              if (!q) return;
              var l = q.sectionName,
                  m = q.rowIndex;
              W(), c((0, S.deleteRow)(s, {
                sectionName: l,
                rowIndex: m
              }));
            }
          }, {
            icon: w.tableColumnBefore,
            title: (0, k.__)("Insert column before"),
            isDisabled: !q,
            onClick: function onInsertColumnBefore() {
              onInsertColumn(0);
            }
          }, {
            icon: w.tableColumnAfter,
            title: (0, k.__)("Insert column after"),
            isDisabled: !q,
            onClick: function onInsertColumnAfter() {
              onInsertColumn(1);
            }
          }, {
            icon: w.tableColumnDelete,
            title: (0, k.__)("Delete column"),
            isDisabled: !q,
            onClick: function onDeleteColumn() {
              if (!q) return;
              var l = q.sectionName,
                  m = q.columnIndex;
              W(), c((0, S.deleteColumn)(s, {
                sectionName: l,
                columnIndex: m
              }));
            }
          }],
              Q = ["head", "body", "foot"].map(function (l) {
            return (0, v.createElement)(TSection, {
              name: l,
              key: l
            }, s[l].map(function (s, c) {
              var m = s.cells;
              return (0, v.createElement)("tr", {
                key: c
              }, m.map(function (s, m) {
                var k = s.content,
                    E = s.tag,
                    w = s.scope,
                    C = s.align;
                return (0, v.createElement)(y.RichText, {
                  tagName: E,
                  key: m,
                  className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(C), C), "wp-block-table__cell-content"),
                  scope: "th" === E ? w : void 0,
                  value: k,
                  onChange: onChange,
                  unstableOnFocus: function unstableOnFocus() {
                    W({
                      sectionName: l,
                      rowIndex: c,
                      columnIndex: m,
                      type: "cell"
                    });
                  },
                  "aria-label": T[l],
                  placeholder: B[l]
                });
              }));
            }));
          }),
              Y = !Z.length;
          return (0, v.createElement)("figure", (0, y.useBlockProps)(), !Y && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.BlockControls, {
            group: "block"
          }, (0, v.createElement)(y.AlignmentControl, {
            label: (0, k.__)("Change column alignment"),
            alignmentControls: P,
            value: function getCellAlignment() {
              if (q) return (0, S.getCellAttribute)(s, q, "align");
            }(),
            onChange: function onChange(l) {
              return function onChangeColumnAlignment(l) {
                if (!q) return;
                var m = {
                  type: "column",
                  columnIndex: q.columnIndex
                },
                    v = (0, S.updateSelectedCell)(s, m, function (s) {
                  return _objectSpread(_objectSpread({}, s), {}, {
                    align: l
                  });
                });
                c(v);
              }(l);
            }
          })), (0, v.createElement)(y.BlockControls, {
            group: "other"
          }, (0, v.createElement)(E.ToolbarDropdownMenu, {
            hasArrowIndicator: !0,
            icon: w.table,
            label: (0, k.__)("Edit table"),
            controls: K
          }))), !Y && (0, v.createElement)(y.InspectorControls, null, (0, v.createElement)(E.PanelBody, {
            title: (0, k.__)("Table settings"),
            className: "blocks-table-settings"
          }, (0, v.createElement)(E.ToggleControl, {
            label: (0, k.__)("Fixed width table cells"),
            checked: !!L,
            onChange: function onChangeFixedLayout() {
              c({
                hasFixedLayout: !L
              });
            }
          }), (0, v.createElement)(E.ToggleControl, {
            label: (0, k.__)("Header section"),
            checked: !(!A || !A.length),
            onChange: function onToggleHeaderSection() {
              c((0, S.toggleSection)(s, "head"));
            }
          }), (0, v.createElement)(E.ToggleControl, {
            label: (0, k.__)("Footer section"),
            checked: !(!R || !R.length),
            onChange: function onToggleFooterSection() {
              c((0, S.toggleSection)(s, "foot"));
            }
          }))), !Y && (0, v.createElement)("table", {
            className: (0, _.default)(U.className, $.className, {
              "has-fixed-layout": L
            }),
            style: _objectSpread(_objectSpread({}, U.style), $.style)
          }, Q), !Y && (0, v.createElement)(y.RichText, {
            tagName: "figcaption",
            "aria-label": (0, k.__)("Table caption text"),
            placeholder: (0, k.__)("Add caption"),
            value: V,
            onChange: function onChange(l) {
              return c({
                caption: l
              });
            },
            unstableOnFocus: function unstableOnFocus() {
              return W();
            },
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return m((0, C.createBlock)("core/paragraph"));
            }
          }), Y && (0, v.createElement)(E.Placeholder, {
            label: (0, k.__)("Table"),
            icon: (0, v.createElement)(y.BlockIcon, {
              icon: w.blockTable,
              showColors: !0
            }),
            instructions: (0, k.__)("Insert a table for sharing data.")
          }, (0, v.createElement)("form", {
            className: "blocks-table__placeholder-form",
            onSubmit: function onCreateTable(l) {
              l.preventDefault(), c((0, S.createTable)({
                rowCount: parseInt(O, 10) || 2,
                columnCount: parseInt(F, 10) || 2
              }));
            }
          }, (0, v.createElement)(E.TextControl, {
            type: "number",
            label: (0, k.__)("Column count"),
            value: F,
            onChange: function onChangeInitialColumnCount(l) {
              G(l);
            },
            min: "1",
            className: "blocks-table__placeholder-input"
          }), (0, v.createElement)(E.TextControl, {
            type: "number",
            label: (0, k.__)("Row count"),
            value: O,
            onChange: function onChangeInitialRowCount(l) {
              D(l);
            },
            min: "1",
            className: "blocks-table__placeholder-input"
          }), (0, v.createElement)(E.Button, {
            className: "blocks-table__placeholder-button",
            variant: "primary",
            type: "submit"
          }, (0, k.__)("Create Table")))));
        };

        s.default = z;
      },
      4150: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(3290)),
            k = m(c(7264)),
            E = m(c(3566)),
            w = m(c(6842));

        var C = {
          apiVersion: 2,
          name: "core/table",
          title: "Table",
          category: "text",
          description: "Create structured content in rows and columns to display information.",
          textdomain: "default",
          attributes: {
            hasFixedLayout: {
              type: "boolean",
              default: !1
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption",
              default: ""
            },
            head: {
              type: "array",
              default: [],
              source: "query",
              selector: "thead tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            },
            body: {
              type: "array",
              default: [],
              source: "query",
              selector: "tbody tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            },
            foot: {
              type: "array",
              default: [],
              source: "query",
              selector: "tfoot tr",
              query: {
                cells: {
                  type: "array",
                  default: [],
                  source: "query",
                  selector: "td,th",
                  query: {
                    content: {
                      type: "string",
                      source: "html"
                    },
                    tag: {
                      type: "string",
                      default: "td",
                      source: "tag"
                    },
                    scope: {
                      type: "string",
                      source: "attribute",
                      attribute: "scope"
                    },
                    align: {
                      type: "string",
                      source: "attribute",
                      attribute: "data-align"
                    }
                  }
                }
              }
            }
          },
          supports: {
            anchor: !0,
            align: !0,
            color: {
              __experimentalSkipSerialization: !0,
              gradients: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            },
            __experimentalBorder: {
              __experimentalSkipSerialization: !0,
              color: !0,
              style: !0,
              width: !0
            },
            __experimentalSelector: ".wp-block-table > table"
          },
          styles: [{
            name: "regular",
            label: "Default",
            isDefault: !0
          }, {
            name: "stripes",
            label: "Stripes"
          }],
          editorStyle: "wp-block-table-editor",
          style: "wp-block-table"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.blockTable,
          example: {
            attributes: {
              head: [{
                cells: [{
                  content: (0, v.__)("Version"),
                  tag: "th"
                }, {
                  content: (0, v.__)("Jazz Musician"),
                  tag: "th"
                }, {
                  content: (0, v.__)("Release Date"),
                  tag: "th"
                }]
              }],
              body: [{
                cells: [{
                  content: "5.2",
                  tag: "td"
                }, {
                  content: "Jaco Pastorius",
                  tag: "td"
                }, {
                  content: (0, v.__)("May 7, 2019"),
                  tag: "td"
                }]
              }, {
                cells: [{
                  content: "5.1",
                  tag: "td"
                }, {
                  content: "Betty Carter",
                  tag: "td"
                }, {
                  content: (0, v.__)("February 21, 2019"),
                  tag: "td"
                }]
              }, {
                cells: [{
                  content: "5.0",
                  tag: "td"
                }, {
                  content: "Bebo Valdés",
                  tag: "td"
                }, {
                  content: (0, v.__)("December 6, 2018"),
                  tag: "td"
                }]
              }]
            }
          },
          transforms: w.default,
          edit: k.default,
          save: E.default,
          deprecated: y.default
        };
        s.settings = P;
      },
      3566: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.hasFixedLayout,
              m = s.head,
              k = s.body,
              E = s.foot,
              w = s.caption;
          if (!m.length && !k.length && !E.length) return null;

          var C = (0, y.__experimentalGetColorClassesAndStyles)(s),
              S = (0, y.__experimentalGetBorderClassesAndStyles)(s),
              P = (0, _.default)(C.className, S.className, {
            "has-fixed-layout": c
          }),
              T = !y.RichText.isEmpty(w),
              Section = function Section(l) {
            var s = l.type,
                c = l.rows;
            if (!c.length) return null;
            var m = "t".concat(s);
            return (0, v.createElement)(m, null, c.map(function (l, s) {
              var c = l.cells;
              return (0, v.createElement)("tr", {
                key: s
              }, c.map(function (l, s) {
                var c = l.content,
                    m = l.tag,
                    k = l.scope,
                    E = l.align;
                var w = (0, _.default)(_defineProperty({}, "has-text-align-".concat(E), E));
                return (0, v.createElement)(y.RichText.Content, {
                  className: w || void 0,
                  "data-align": E,
                  tagName: m,
                  value: c,
                  key: s,
                  scope: "th" === m ? k : void 0
                });
              }));
            }));
          };

          return (0, v.createElement)("figure", y.useBlockProps.save(), (0, v.createElement)("table", {
            className: "" === P ? void 0 : P,
            style: _objectSpread(_objectSpread({}, C.style), S.style)
          }, (0, v.createElement)(Section, {
            type: "head",
            rows: m
          }), (0, v.createElement)(Section, {
            type: "body",
            rows: k
          }), (0, v.createElement)(Section, {
            type: "foot",
            rows: E
          })), T && (0, v.createElement)(y.RichText.Content, {
            tagName: "figcaption",
            value: w
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      6849: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.createTable = function createTable(l) {
          var s = l.rowCount,
              c = l.columnCount;
          return {
            body: (0, m.times)(s, function () {
              return {
                cells: (0, m.times)(c, function () {
                  return {
                    content: "",
                    tag: "td"
                  };
                })
              };
            })
          };
        }, s.deleteColumn = function deleteColumn(l, s) {
          var c = s.columnIndex;
          var v = (0, m.pick)(l, ["head", "body", "foot"]);
          return (0, m.mapValues)(v, function (l) {
            return isEmptyTableSection(l) ? l : l.map(function (l) {
              return {
                cells: l.cells.length >= c ? l.cells.filter(function (l, s) {
                  return s !== c;
                }) : l.cells
              };
            }).filter(function (l) {
              return l.cells.length;
            });
          });
        }, s.deleteRow = function deleteRow(l, s) {
          var c = s.sectionName,
              m = s.rowIndex;
          return _defineProperty({}, c, l[c].filter(function (l, s) {
            return s !== m;
          }));
        }, s.getCellAttribute = function getCellAttribute(l, s, c) {
          var v = s.sectionName,
              _ = s.rowIndex,
              y = s.columnIndex;
          return (0, m.get)(l, [v, _, "cells", y, c]);
        }, s.getFirstRow = getFirstRow, s.insertColumn = function insertColumn(l, s) {
          var c = s.columnIndex;
          var v = (0, m.pick)(l, ["head", "body", "foot"]);
          return (0, m.mapValues)(v, function (l, s) {
            return isEmptyTableSection(l) ? l : l.map(function (l) {
              return isEmptyRow(l) || l.cells.length < c ? l : {
                cells: [].concat(_toConsumableArray(l.cells.slice(0, c)), [{
                  content: "",
                  tag: "head" === s ? "th" : "td"
                }], _toConsumableArray(l.cells.slice(c)))
              };
            });
          });
        }, s.insertRow = insertRow, s.isCellSelected = isCellSelected, s.isEmptyRow = isEmptyRow, s.isEmptyTableSection = isEmptyTableSection, s.toggleSection = function toggleSection(l, s) {
          if (!isEmptyTableSection(l[s])) return _defineProperty({}, s, []);
          var c = (0, m.get)(l, ["body", 0, "cells", "length"], 1);
          return insertRow(l, {
            sectionName: s,
            rowIndex: 0,
            columnCount: c
          });
        }, s.updateSelectedCell = function updateSelectedCell(l, s, c) {
          if (!s) return l;
          var v = (0, m.pick)(l, ["head", "body", "foot"]),
              _ = s.sectionName,
              y = s.rowIndex;
          return (0, m.mapValues)(v, function (l, m) {
            return _ && _ !== m ? l : l.map(function (l, v) {
              return y && y !== v ? l : {
                cells: l.cells.map(function (l, _) {
                  return isCellSelected({
                    sectionName: m,
                    columnIndex: _,
                    rowIndex: v
                  }, s) ? c(l) : l;
                })
              };
            });
          });
        };
        var m = c(4793);
        var v = ["align"];

        function getFirstRow(l) {
          return isEmptyTableSection(l.head) ? isEmptyTableSection(l.body) ? isEmptyTableSection(l.foot) ? void 0 : l.foot[0] : l.body[0] : l.head[0];
        }

        function isCellSelected(l, s) {
          if (!l || !s) return !1;

          switch (s.type) {
            case "column":
              return "column" === s.type && l.columnIndex === s.columnIndex;

            case "cell":
              return "cell" === s.type && l.sectionName === s.sectionName && l.columnIndex === s.columnIndex && l.rowIndex === s.rowIndex;
          }
        }

        function insertRow(l, s) {
          var c = s.sectionName,
              _ = s.rowIndex,
              y = s.columnCount;
          var k = getFirstRow(l),
              E = void 0 === y ? (0, m.get)(k, ["cells", "length"]) : y;
          return E ? _defineProperty({}, c, [].concat(_toConsumableArray(l[c].slice(0, _)), [{
            cells: (0, m.times)(E, function (l) {
              var s = (0, m.get)(k, ["cells", l], {});
              return _objectSpread(_objectSpread({}, (0, m.pick)(s, v)), {}, {
                content: "",
                tag: "head" === c ? "th" : "td"
              });
            })
          }], _toConsumableArray(l[c].slice(_)))) : l;
        }

        function isEmptyTableSection(l) {
          return !l || !l.length || (0, m.every)(l, isEmptyRow);
        }

        function isEmptyRow(l) {
          return !(l.cells && l.cells.length);
        }
      },
      6842: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var tableContentPasteSchema = function tableContentPasteSchema(l) {
          var s = l.phrasingContentSchema;
          return {
            tr: {
              allowEmpty: !0,
              children: {
                th: {
                  allowEmpty: !0,
                  children: s,
                  attributes: ["scope"]
                },
                td: {
                  allowEmpty: !0,
                  children: s
                }
              }
            }
          };
        };

        var c = {
          from: [{
            type: "raw",
            selector: "table",
            schema: function schema(l) {
              return {
                table: {
                  children: {
                    thead: {
                      allowEmpty: !0,
                      children: tableContentPasteSchema(l)
                    },
                    tfoot: {
                      allowEmpty: !0,
                      children: tableContentPasteSchema(l)
                    },
                    tbody: {
                      allowEmpty: !0,
                      children: tableContentPasteSchema(l)
                    }
                  }
                }
              };
            }
          }]
        };
        s.default = c;
      },
      8221: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            y = c(4892),
            k = c(8467),
            E = c(6756),
            w = c(1326),
            C = m(c(2643)),
            S = c(1295);

        var P = (0, k.withSelect)(function (l) {
          return {
            taxonomies: l(S.store).getTaxonomies({
              per_page: -1
            })
          };
        })(function TagCloudEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.taxonomies;
          var k = s.taxonomy,
              S = s.showTagCounts,
              P = s.numberOfTags,
              T = (0, v.createElement)(w.InspectorControls, null, (0, v.createElement)(y.PanelBody, {
            title: (0, E.__)("Tag Cloud settings")
          }, (0, v.createElement)(y.SelectControl, {
            label: (0, E.__)("Taxonomy"),
            options: [{
              label: (0, E.__)("- Select -"),
              value: "",
              disabled: !0
            }].concat(_toConsumableArray((0, _.map)((0, _.filter)(m, "show_cloud"), function (l) {
              return {
                value: l.slug,
                label: l.name
              };
            }))),
            value: k,
            onChange: function onChange(l) {
              return c({
                taxonomy: l
              });
            }
          }), (0, v.createElement)(y.ToggleControl, {
            label: (0, E.__)("Show post counts"),
            checked: S,
            onChange: function onChange() {
              return c({
                showTagCounts: !S
              });
            }
          }), (0, v.createElement)(y.RangeControl, {
            label: (0, E.__)("Number of tags"),
            value: P,
            onChange: function onChange(l) {
              return c({
                numberOfTags: l
              });
            },
            min: 1,
            max: 100,
            required: !0
          })));
          return (0, v.createElement)(v.Fragment, null, T, (0, v.createElement)("div", (0, w.useBlockProps)(), (0, v.createElement)(C.default, {
            key: "tag-cloud",
            block: "core/tag-cloud",
            attributes: s
          })));
        });
        s.default = P;
      },
      7073: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(8221));

        var y = {
          apiVersion: 2,
          name: "core/tag-cloud",
          title: "Tag Cloud",
          category: "widgets",
          description: "A cloud of your most used tags.",
          textdomain: "default",
          attributes: {
            numberOfTags: {
              type: "number",
              default: 45,
              minimum: 1,
              maximum: 100
            },
            taxonomy: {
              type: "string",
              default: "post_tag"
            },
            showTagCounts: {
              type: "boolean",
              default: !1
            }
          },
          supports: {
            html: !1,
            align: !0
          },
          editorStyle: "wp-block-tag-cloud-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.tag,
          example: {},
          edit: _.default
        };
        s.settings = E;
      },
      3048: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TemplatePartAdvancedControls = function TemplatePartAdvancedControls(l) {
          var s = l.tagName,
              c = l.setAttributes,
              w = l.isEntityAvailable,
              C = l.templatePartId,
              S = l.defaultWrapper;

          var _ref378 = (0, v.useEntityProp)("postType", "wp_template_part", "area", C),
              _ref379 = _slicedToArray2(_ref378, 2),
              P = _ref379[0],
              T = _ref379[1],
              _ref380 = (0, v.useEntityProp)("postType", "wp_template_part", "title", C),
              _ref381 = _slicedToArray2(_ref380, 2),
              B = _ref381[0],
              z = _ref381[1],
              _ref382 = (0, E.useSelect)(function (l) {
            return {
              areaOptions: l("core/editor").__experimentalGetDefaultTemplatePartAreas().map(function (l) {
                var s = l.label,
                    c = l.area;
                return {
                  label: s,
                  value: c
                };
              })
            };
          }, []),
              L = _ref382.areaOptions;

          return (0, m.createElement)(k.InspectorControls, {
            __experimentalGroup: "advanced"
          }, w && (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.TextControl, {
            label: (0, y.__)("Title"),
            value: B,
            onChange: function onChange(l) {
              z(l);
            },
            onFocus: function onFocus(l) {
              return l.target.select();
            }
          }), (0, m.createElement)(_.SelectControl, {
            label: (0, y.__)("Area"),
            labelPosition: "top",
            options: L,
            value: P,
            onChange: T
          })), (0, m.createElement)(_.SelectControl, {
            label: (0, y.__)("HTML element"),
            options: [{
              label: (0, y.sprintf)((0, y.__)("Default based on area (%s)"), "<".concat(S, ">")),
              value: ""
            }, {
              label: "<header>",
              value: "header"
            }, {
              label: "<main>",
              value: "main"
            }, {
              label: "<section>",
              value: "section"
            }, {
              label: "<article>",
              value: "article"
            }, {
              label: "<aside>",
              value: "aside"
            }, {
              label: "<footer>",
              value: "footer"
            }, {
              label: "<div>",
              value: "div"
            }],
            value: s || "",
            onChange: function onChange(l) {
              return c({
                tagName: l
              });
            }
          }));
        };

        var m = c(1753),
            v = c(1295),
            _ = c(4892),
            y = c(6756),
            k = c(1326),
            E = c(8467);
      },
      1653: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TemplatePartEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.clientId;

          var L = s.slug,
              V = s.theme,
              A = s.tagName,
              _s$layout4 = s.layout,
              R = _s$layout4 === void 0 ? {} : _s$layout4,
              O = (0, z.createTemplatePartId)(V, L),
              _ref383 = (0, k.__experimentalUseNoRecursiveRenders)(O),
              _ref384 = _slicedToArray2(_ref383, 2),
              D = _ref384[0],
              F = _ref384[1],
              _ref385 = (0, y.useSelect)(function (l) {
            var c;

            var _l79 = l(C.store),
                v = _l79.getEditedEntityRecord,
                y = _l79.getEntityRecords,
                E = _l79.hasFinishedResolution,
                _l80 = l(k.store),
                w = _l80.getBlocks,
                S = ["postType", "wp_template_part", O],
                P = O ? v.apply(void 0, S) : null,
                T = (null == P ? void 0 : P.area) || s.area,
                B = ["postType", "wp_template_part", T && "uncategorized" !== T && {
              area: T
            }],
                z = y.apply(void 0, B),
                L = O ? (null == z ? void 0 : z.length) > 1 : (null == z ? void 0 : z.length) > 0,
                V = !!O && E("getEditedEntityRecord", S),
                A = null === (c = l("core/editor").__experimentalGetDefaultTemplatePartAreas().find(function (l) {
              var s = l.area;
              return s === T;
            })) || void 0 === c ? void 0 : c.area_tag;

            return {
              innerBlocks: w(m),
              isResolved: V,
              isMissing: V && (0, _.isEmpty)(P),
              defaultWrapper: A || "div",
              area: T,
              enableSelection: L,
              hasResolvedReplacements: E("getEntityRecords", B)
            };
          }, [O, m]),
              G = _ref385.isResolved,
              q = _ref385.innerBlocks,
              W = _ref385.isMissing,
              U = _ref385.defaultWrapper,
              $ = _ref385.area,
              Z = _ref385.enableSelection,
              K = _ref385.hasResolvedReplacements,
              Q = (0, k.useBlockProps)(),
              Y = !L,
              X = !Y && !W && G,
              J = A || U;

          if (0 === q.length && (L && !V || L && W)) return (0, v.createElement)(J, Q, (0, v.createElement)(k.Warning, null, (0, w.sprintf)((0, w.__)("Template part has been deleted or is unavailable: %s"), L)));
          if (X && D) return (0, v.createElement)(J, Q, (0, v.createElement)(k.Warning, null, (0, w.__)("Block cannot be rendered inside itself.")));
          return (0, v.createElement)(F, null, (0, v.createElement)(T.TemplatePartAdvancedControls, {
            tagName: A,
            setAttributes: c,
            isEntityAvailable: X,
            templatePartId: O,
            defaultWrapper: U
          }), Y && (0, v.createElement)(J, Q, (0, v.createElement)(S.default, {
            area: s.area,
            clientId: m,
            setAttributes: c,
            enableSelection: Z,
            hasResolvedReplacements: K
          })), X && Z && (0, v.createElement)(k.BlockControls, null, (0, v.createElement)(E.ToolbarGroup, {
            className: "wp-block-template-part__block-control-group"
          }, (0, v.createElement)(E.Dropdown, {
            className: "wp-block-template-part__preview-dropdown-button",
            contentClassName: "wp-block-template-part__preview-dropdown-content",
            position: "bottom right left",
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, v.createElement)(E.ToolbarButton, {
                "aria-expanded": s,
                onClick: c
              }, (0, w.__)("Replace"));
            },
            renderContent: function renderContent(l) {
              var s = l.onClose;
              return (0, v.createElement)(P.default, {
                setAttributes: c,
                onClose: s,
                area: $,
                templatePartId: O
              });
            }
          }))), X && (0, v.createElement)(B.default, {
            clientId: m,
            tagName: J,
            blockProps: Q,
            postId: O,
            hasInnerBlocks: q.length > 0,
            layout: R
          }), !Y && !G && (0, v.createElement)(J, Q, (0, v.createElement)(E.Spinner, null)));
        };

        var v = c(1753),
            _ = c(4793),
            y = c(8467),
            k = c(1326),
            E = c(4892),
            w = c(6756),
            C = c(1295),
            S = m(c(5019)),
            P = m(c(7317)),
            T = c(3048),
            B = m(c(4841)),
            z = c(6760);
      },
      4841: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TemplatePartInnerBlocks(l) {
          var s = l.postId,
              c = l.hasInnerBlocks,
              k = l.layout,
              E = l.tagName,
              w = l.blockProps,
              C = l.clientId;

          var S = (0, y.useSelect)(function (l) {
            var s;

            var _l81 = l(_.store),
                c = _l81.getSettings;

            return null === (s = c()) || void 0 === s ? void 0 : s.supportsLayout;
          }, []),
              P = (0, _.useSetting)("layout") || {},
              T = k && k.inherit ? P : k,
              _ref386 = (0, v.useEntityBlockEditor)("postType", "wp_template_part", {
            id: s
          }),
              _ref387 = _slicedToArray2(_ref386, 3),
              B = _ref387[0],
              z = _ref387[1],
              L = _ref387[2],
              V = (0, _.useInnerBlocksProps)(w, {
            value: B,
            onInput: z,
            onChange: L,
            renderAppender: c ? void 0 : _.InnerBlocks.ButtonBlockAppender,
            __experimentalLayout: S ? T : void 0
          });

          return (0, m.createElement)(_.__experimentalBlockContentOverlay, {
            clientId: C,
            tagName: E,
            wrapperProps: V
          });
        };

        var m = c(1753),
            v = c(1295),
            _ = c(1326),
            y = c(8467);
      },
      5019: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TemplatePartPlaceholder(l) {
          var s = l.area,
              c = l.clientId,
              m = l.setAttributes,
              z = l.enableSelection,
              L = l.hasResolvedReplacements;

          var _ref388 = (0, k.useDispatch)(C.store),
              V = _ref388.saveEntityRecord,
              _ref389 = (0, v.useState)(T),
              _ref390 = _slicedToArray2(_ref389, 2),
              A = _ref390[0],
              R = _ref390[1],
              _ref391 = (0, k.useSelect)(function (l) {
            var c = l("core/editor").__experimentalGetDefaultTemplatePartAreas(),
                m = (0, _.find)(c, {
              area: s
            }),
                v = (0, _.find)(c, {
              area: "uncategorized"
            });

            return {
              areaIcon: (null == m ? void 0 : m.icon) || (null == v ? void 0 : v.icon),
              areaLabel: (null == m ? void 0 : m.label) || (0, y.__)("Template Part")
            };
          }, [s]),
              O = _ref391.areaIcon,
              D = _ref391.areaLabel,
              F = (0, v.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            var l,
                c,
                v,
                k,
                _args8 = arguments;
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    l = _args8.length > 0 && void 0 !== _args8[0] ? _args8[0] : [], c = _args8.length > 1 && void 0 !== _args8[1] ? _args8[1] : (0, y.__)("Untitled Template Part");
                    v = {
                      title: c,
                      slug: (0, _.kebabCase)(c),
                      content: (0, w.serialize)(l),
                      area: s
                    };
                    _context8.next = 4;
                    return V("postType", "wp_template_part", v);

                  case 4:
                    k = _context8.sent;
                    m({
                      slug: k.slug,
                      theme: k.theme,
                      area: void 0
                    });

                  case 6:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          })), [m, s]);

          return (0, v.createElement)(v.Fragment, null, A === T && (0, v.createElement)(E.Placeholder, {
            icon: O,
            label: D,
            instructions: z ? (0, y.sprintf)((0, y.__)("Choose an existing %s or create a new one."), D.toLowerCase()) : (0, y.sprintf)((0, y.__)("Create a new %s."), D.toLowerCase())
          }, L ? (0, v.createElement)(E.Dropdown, {
            contentClassName: "wp-block-template-part__placeholder-preview-dropdown-content",
            position: "bottom right left",
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, v.createElement)(v.Fragment, null, z && (0, v.createElement)(E.Button, {
                variant: "primary",
                onClick: c,
                "aria-expanded": s
              }, (0, y.__)("Choose existing")), (0, v.createElement)(E.Button, {
                variant: z ? "tertiary" : "primary",
                onClick: function onClick() {
                  return R(B);
                }
              }, (0, y.sprintf)((0, y.__)("New %s"), D.toLowerCase())));
            },
            renderContent: function renderContent(l) {
              var c = l.onClose;
              return (0, v.createElement)(S.default, {
                setAttributes: m,
                onClose: c,
                area: s
              });
            }
          }) : (0, v.createElement)(E.Spinner, null)), A === B && (0, v.createElement)(P.default, {
            area: s,
            areaLabel: D,
            areaIcon: O,
            onCreate: F,
            clientId: c,
            resetPlaceholder: function resetPlaceholder() {
              return R(T);
            }
          }));
        };

        var v = c(1753),
            _ = c(4793),
            y = c(6756),
            k = c(8467),
            E = c(4892),
            w = c(6700),
            C = c(1295),
            S = m(c(7317)),
            P = m(c(2899));

        var T = 1,
            B = 2;
      },
      2899: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PatternsSetup(l) {
          var s = l.area,
              c = l.areaLabel,
              k = l.areaIcon,
              E = l.clientId,
              w = l.onCreate,
              C = l.resetPlaceholder;

          var S = s ? "core/template-part/".concat(s) : "core/template-part",
              _ref393 = (0, m.useState)((0, _.__)("Untitled Template Part")),
              _ref394 = _slicedToArray2(_ref393, 2),
              P = _ref394[0],
              T = _ref394[1],
              _ref395 = (0, m.useState)([]),
              _ref396 = _slicedToArray2(_ref395, 2),
              B = _ref396[0],
              z = _ref396[1],
              _ref397 = (0, m.useState)(!1),
              _ref398 = _slicedToArray2(_ref397, 2),
              L = _ref398[0],
              V = _ref398[1];

          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(v.__experimentalBlockPatternSetup, {
            clientId: E,
            startBlankComponent: (0, m.createElement)(StartBlankComponent, {
              setTitleStep: V,
              areaLabel: c,
              areaIcon: k
            }),
            onBlockPatternSelect: function onBlockPatternSelect(l) {
              z(l), V(!0);
            },
            filterPatternsFn: function filterPatternsFn(l) {
              var s, c;
              return null == l || null === (s = l.blockTypes) || void 0 === s || null === (c = s.some) || void 0 === c ? void 0 : c.call(s, function (l) {
                return l === S;
              });
            }
          }), L && (0, m.createElement)(y.Modal, {
            title: (0, _.sprintf)((0, _.__)("Name and create your new %s"), c.toLowerCase()),
            closeLabel: (0, _.__)("Cancel"),
            onRequestClose: C,
            overlayClassName: "wp-block-template-part__placeholder-create-new__title-form"
          }, (0, m.createElement)("form", {
            onSubmit: function onSubmit(l) {
              l.preventDefault(), w(B, P);
            }
          }, (0, m.createElement)(y.TextControl, {
            label: (0, _.__)("Name"),
            value: P,
            onChange: T
          }), (0, m.createElement)(y.Flex, {
            className: "wp-block-template-part__placeholder-create-new__title-form-actions",
            justify: "flex-end"
          }, (0, m.createElement)(y.FlexItem, null, (0, m.createElement)(y.Button, {
            variant: "secondary",
            onClick: C
          }, (0, _.__)("Cancel"))), (0, m.createElement)(y.FlexItem, null, (0, m.createElement)(y.Button, {
            variant: "primary",
            type: "submit",
            disabled: !P.length,
            "aria-disabled": !P.length
          }, (0, _.__)("Create")))))));
        };

        var m = c(1753),
            v = c(1326),
            _ = c(6756),
            y = c(4892);

        function StartBlankComponent(l) {
          var s = l.setTitleStep,
              c = l.areaLabel,
              v = l.areaIcon;
          return (0, m.useEffect)(function () {
            s(!0);
          }, []), (0, m.createElement)(y.Placeholder, {
            label: c,
            icon: v,
            instructions: (0, _.sprintf)((0, _.__)("Creating your new %s…"), c.toLowerCase())
          });
        }
      },
      7317: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TemplatePartSelection(l) {
          var s = l.setAttributes,
              c = l.onClose,
              m = l.area,
              _l$templatePartId = l.templatePartId,
              k = _l$templatePartId === void 0 ? null : _l$templatePartId;

          var _ref399 = (0, v.useState)(""),
              _ref400 = _slicedToArray2(_ref399, 2),
              E = _ref400[0],
              w = _ref400[1];

          return (0, v.createElement)("div", null, (0, v.createElement)(_.SearchControl, {
            value: E,
            onChange: w,
            className: "wp-block-template-part__selection-preview-search-form"
          }), (0, v.createElement)("div", {
            className: "wp-block-template-part__selection-preview-container"
          }, (0, v.createElement)(y.default, {
            setAttributes: s,
            filterValue: E,
            onClose: c,
            area: m,
            templatePartId: k
          })));
        };

        var v = c(1753),
            _ = c(4892),
            y = m(c(3034));
      },
      3034: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TemplatePartPreviews(l) {
          var s = l.setAttributes,
              c = l.filterValue,
              m = l.onClose,
              y = l.area,
              E = l.templatePartId;

          var w = (0, P.__unstableUseCompositeState)(),
              _ref401 = (0, k.useSelect)(function (l) {
            var s = (l(z.store).getEntityRecords("postType", "wp_template_part", {
              per_page: -1
            }) || []).filter(function (l) {
              return (0, L.createTemplatePartId)(l.theme, l.slug) !== E;
            }),
                c = l("core/editor").__experimentalGetDefaultTemplatePartAreas(),
                m = {};

            return c.forEach(function (l) {
              m[l.area] = l.label;
            }), {
              templateParts: s,
              labelsByArea: m
            };
          }, []),
              S = _ref401.templateParts,
              T = _ref401.labelsByArea;

          if (!S || !S.length) return (0, v.createElement)(PanelGroup, null, (0, C.__)("There are no existing template parts to select."));
          if (c) return (0, v.createElement)(P.__unstableComposite, (0, _.default)({}, w, {
            role: "listbox",
            "aria-label": (0, C.__)("List of template parts")
          }), (0, v.createElement)(TemplatePartSearchResults, {
            templateParts: S,
            setAttributes: s,
            filterValue: c,
            onClose: m,
            composite: w,
            labelsByArea: T
          }));
          return (0, v.createElement)(P.__unstableComposite, (0, _.default)({}, w, {
            role: "listbox",
            "aria-label": (0, C.__)("List of template parts")
          }), (0, v.createElement)(TemplatePartsByArea, {
            templateParts: S,
            setAttributes: s,
            onClose: m,
            composite: w,
            area: y,
            labelsByArea: T
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = c(4793),
            k = c(8467),
            E = c(6700),
            w = c(9880),
            C = c(6756),
            S = c(1326),
            P = c(4892),
            T = c(3200),
            B = c(8448),
            z = c(1295),
            L = c(6760);

        function getAreaGroupTitle(l) {
          return (0, C.sprintf)((0, C.__)("Area: %s"), l);
        }

        function PreviewPlaceholder() {
          return (0, v.createElement)("div", {
            className: "wp-block-template-part__selection-preview-item is-placeholder",
            tabIndex: 0
          });
        }

        function TemplatePartItem(l) {
          var s = l.templatePart,
              c = l.setAttributes,
              m = l.onClose,
              y = l.composite;

          var T = s.slug,
              z = s.theme,
              L = s.title.rendered,
              V = s.content.raw || "",
              A = (0, v.useMemo)(function () {
            return (0, E.parse)(V);
          }, [V]),
              _ref402 = (0, k.useDispatch)(B.store),
              R = _ref402.createSuccessNotice,
              O = (0, v.useCallback)(function () {
            c({
              slug: T,
              theme: z,
              area: void 0
            }), R((0, C.sprintf)((0, C.__)('Template Part "%s" inserted.'), L || T), {
              type: "snackbar"
            }), m();
          }, [T, z]);

          return (0, v.createElement)(P.__unstableCompositeItem, (0, _.default)({
            as: "div",
            className: "wp-block-template-part__selection-preview-item",
            role: "option",
            onClick: O,
            onKeyDown: function onKeyDown(l) {
              w.ENTER !== l.keyCode && w.SPACE !== l.keyCode || O();
            },
            tabIndex: 0,
            "aria-label": L || T
          }, y), (0, v.createElement)(S.BlockPreview, {
            blocks: A
          }), (0, v.createElement)("div", {
            className: "wp-block-template-part__selection-preview-item-title"
          }, L || T));
        }

        function PanelGroup(l) {
          var s = l.title,
              c = l.icon,
              m = l.children;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", {
            className: "wp-block-template-part__selection-panel-group-header"
          }, (0, v.createElement)("span", {
            className: "wp-block-template-part__selection-panel-group-title"
          }, s), (0, v.createElement)(P.Icon, {
            icon: c
          })), (0, v.createElement)("div", {
            className: "wp-block-template-part__selection-panel-group-content"
          }, m));
        }

        function TemplatePartsByArea(l) {
          var s = l.templateParts,
              c = l.setAttributes,
              m = l.onClose,
              _ = l.composite,
              _l$area = l.area,
              k = _l$area === void 0 ? "uncategorized" : _l$area,
              E = l.labelsByArea;

          var _ref403 = (0, v.useMemo)(function () {
            var l = s.filter(function (l) {
              return "uncategorized" === k || l.area === k;
            }) || [];
            return {
              templatePartsByArea: Object.values((0, y.groupBy)(l, "area")),
              templatePartsToShow: (0, y.flatten)(l)
            };
          }, [s, k]),
              w = _ref403.templatePartsByArea,
              S = _ref403.templatePartsToShow,
              P = (0, T.useAsyncList)(S);

          return S.length ? w.map(function (l) {
            return (0, v.createElement)(PanelGroup, {
              key: l[0].area,
              title: getAreaGroupTitle(E[l[0].area] || E.uncategorized)
            }, l.map(function (l) {
              return P.includes(l) ? (0, v.createElement)(TemplatePartItem, {
                key: l.id,
                templatePart: l,
                setAttributes: c,
                onClose: m,
                composite: _
              }) : (0, v.createElement)(PreviewPlaceholder, {
                key: l.id
              });
            }));
          }) : (0, v.createElement)(PanelGroup, {
            title: getAreaGroupTitle(E[k] || E.uncategorized)
          }, (0, C.sprintf)((0, C.__)("There is no other %s available. If you are looking for another type of template part, try searching for it using the input above."), k && "uncategorized" !== k ? E[k] || k : (0, C.__)("Template Part")));
        }

        function TemplatePartSearchResults(l) {
          var s = l.templateParts,
              c = l.setAttributes,
              m = l.filterValue,
              _ = l.onClose,
              k = l.composite,
              E = l.labelsByArea;

          var _ref404 = (0, v.useMemo)(function () {
            var l = (0, y.deburr)(m).toLowerCase(),
                c = s.filter(function (s) {
              var c = s.title.rendered,
                  m = s.area;
              return (0, y.deburr)(c).toLowerCase().includes(l) || (0, y.deburr)(E[m]).toLowerCase().includes(l);
            });
            c.sort(function (s, c) {
              var m = (0, y.deburr)(s.title.rendered).toLowerCase().indexOf(l),
                  v = (0, y.deburr)(c.title.rendered).toLowerCase().indexOf(l);
              return -1 !== m && -1 !== v ? m - v : -1 !== m ? -1 : -1 !== v ? 1 : (0, y.deburr)(E[s.area]).toLowerCase().indexOf(l) - (0, y.deburr)(E[c.area]).toLowerCase().indexOf(l);
            });
            var v = [];

            for (var _l82 = 0; _l82 < c.length; _l82++) {
              0 !== _l82 && c[_l82].area === c[_l82 - 1].area ? v[v.length - 1].push(c[_l82]) : v.push([c[_l82]]);
            }

            return {
              filteredTPs: c,
              groupedResults: v
            };
          }, [m, s]),
              w = _ref404.filteredTPs,
              C = _ref404.groupedResults,
              S = (0, T.useAsyncList)(w);

          return C.map(function (l) {
            return (0, v.createElement)(PanelGroup, {
              key: l[0].id,
              title: getAreaGroupTitle(E[l[0].area] || E.uncategorized)
            }, l.map(function (l) {
              return S.includes(l) ? (0, v.createElement)(TemplatePartItem, {
                key: l.id,
                templatePart: l,
                setAttributes: c,
                onClose: _,
                composite: k
              }) : (0, v.createElement)(PreviewPlaceholder, {
                key: l.id
              });
            }));
          });
        }
      },
      6760: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.createTemplatePartId = function createTemplatePartId(l, s) {
          return l && s ? l + "//" + s : null;
        };
      },
      9461: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(6756),
            v = c(5303),
            _ = c(1295),
            y = c(8467);

        var k = [{
          name: "header",
          icon: v.header,
          title: (0, m.__)("Header"),
          description: (0, m.__)("The Header template defines a page area that typically contains a title, logo, and main navigation."),
          attributes: {
            area: "header"
          },
          scope: ["inserter"]
        }, {
          name: "footer",
          icon: v.footer,
          title: (0, m.__)("Footer"),
          description: (0, m.__)("The Footer template defines a page area that typically contains site credits, social links, or any other combination of blocks."),
          attributes: {
            area: "footer"
          },
          scope: ["inserter"]
        }];
        k.forEach(function (l) {
          l.isActive || (l.isActive = function (l, s) {
            var c = l.area,
                m = l.theme,
                v = l.slug;
            if (c) return c === s.area;
            if (!v) return !1;
            var k = (0, y.select)(_.store).getEntityRecord("postType", "wp_template_part", "".concat(m, "//").concat(v));
            return (null == k ? void 0 : k.area) === s.area;
          });
        });
        var E = k;
        s.default = E;
      },
      6142: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(4793),
            _ = c(1295),
            y = c(8467),
            k = c(5303),
            E = c(1149),
            w = m(c(1653)),
            C = c(4187);

        var S = {
          apiVersion: 2,
          name: "core/template-part",
          title: "Template Part",
          category: "theme",
          description: "Edit the different global regions of your site, like the header, footer, sidebar, or create your own.",
          textdomain: "default",
          attributes: {
            slug: {
              type: "string"
            },
            theme: {
              type: "string"
            },
            tagName: {
              type: "string"
            },
            area: {
              type: "string"
            }
          },
          supports: {
            align: !0,
            html: !1,
            reusable: !1
          },
          editorStyle: "wp-block-template-part-editor"
        };
        s.metadata = S;
        var P = S.name;
        s.name = P;
        var T = {
          icon: k.symbolFilled,
          __experimentalLabel: function __experimentalLabel(l) {
            var s;
            var c = l.slug,
                m = l.theme;
            if (!c) return;
            var k = (0, y.select)(_.store).getEntityRecord("postType", "wp_template_part", m + "//" + c);
            return k ? (0, v.startCase)((null === (s = k.title) || void 0 === s ? void 0 : s.rendered) || k.slug) : void 0;
          },
          edit: w.default
        };
        s.settings = T, (0, E.addFilter)("blocks.registerBlockType", "core/template-part", C.enhanceTemplatePartVariations);
        var B = ["core/post-template", "core/post-content"];
        (0, E.addFilter)("blockEditor.__unstableCanInsertBlockType", "removeTemplatePartsFromPostTemplates", function (l, s, c, m) {
          var v = m.getBlock,
              _ = m.getBlockParentsByBlockName;
          if ("core/template-part" !== s.name) return l;

          var _iterator4 = _createForOfIteratorHelper(B),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _l83 = _step4.value;
              var y;
              if ((null === (y = v(c)) || void 0 === y ? void 0 : y.name) === _l83 || _(c, _l83).length) return !1;
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          return !0;
        });
      },
      4187: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.enhanceTemplatePartVariations = function enhanceTemplatePartVariations(l, s) {
          if ("core/template-part" !== s) return l;
          if (!l.variations || !l.variations.length) return _objectSpread(_objectSpread({}, l), {}, {
            variations: k.default
          });

          if (l.variations) {
            var isActive = function isActive(l, s) {
              var c = l.area,
                  m = l.theme,
                  y = l.slug;
              if (c) return c === s.area;
              if (!y) return !1;
              var k = (0, _.select)(v.store).getEntityRecord("postType", "wp_template_part", "".concat(m, "//").concat(y));
              return (null == k ? void 0 : k.area) === s.area;
            },
                _s26 = l.variations.map(function (l) {
              return _objectSpread(_objectSpread(_objectSpread({}, l), !l.isActive && {
                isActive: isActive
              }), "string" == typeof l.icon && {
                icon: getTemplatePartIcon(l.icon)
              });
            });

            return _objectSpread(_objectSpread({}, l), {}, {
              variations: _s26
            });
          }

          return l;
        };

        var v = c(1295),
            _ = c(8467),
            y = c(5303),
            k = m(c(9461));

        function getTemplatePartIcon(l) {
          return "header" === l ? y.header : "footer" === l ? y.footer : "sidebar" === l ? y.sidebar : y.symbolFilled;
        }
      },
      4184: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TermDescriptionEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.mergedStyle;
          var E = s.textAlign,
              w = (0, k.useBlockProps)({
            className: (0, _.default)(_defineProperty({}, "has-text-align-".concat(E), E)),
            style: m
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.BlockControls, {
            group: "block"
          }, (0, v.createElement)(k.AlignmentControl, {
            value: E,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)("div", w, (0, v.createElement)("div", {
            className: "wp-block-term-description__placeholder"
          }, (0, v.createElement)("span", null, (0, y.__)("Term Description")))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(6756),
            k = c(1326);
      },
      725: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(5303),
            _ = m(c(4184));

        var y = {
          apiVersion: 2,
          name: "core/term-description",
          title: "Term Description",
          category: "theme",
          description: "Display the description of categories, tags and custom taxonomies when viewing an archive.",
          textdomain: "default",
          attributes: {
            textAlign: {
              type: "string"
            }
          },
          supports: {
            align: ["wide", "full"],
            html: !1,
            color: {
              link: !0
            },
            typography: {
              fontSize: !0,
              lineHeight: !0,
              __experimentalDefaultControls: {
                fontSize: !0
              }
            }
          },
          editorStyle: "wp-block-term-description-editor"
        };
        s.metadata = y;
        var k = y.name;
        s.name = k;
        var E = {
          icon: v.termDescription,
          edit: _.default
        };
        s.settings = E;
      },
      1796: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TextColumnsEdit(l) {
          var s = l.attributes,
              c = l.setAttributes;
          var m = s.width,
              C = s.content,
              S = s.columns;
          return (0, w.default)("The Text Columns block", {
            since: "5.3",
            alternative: "the Columns block"
          }), (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.BlockControls, null, (0, v.createElement)(E.BlockAlignmentToolbar, {
            value: m,
            onChange: function onChange(l) {
              return c({
                width: l
              });
            },
            controls: ["center", "wide", "full"]
          })), (0, v.createElement)(E.InspectorControls, null, (0, v.createElement)(k.PanelBody, null, (0, v.createElement)(k.RangeControl, {
            label: (0, y.__)("Columns"),
            value: S,
            onChange: function onChange(l) {
              return c({
                columns: l
              });
            },
            min: 2,
            max: 4,
            required: !0
          }))), (0, v.createElement)("div", (0, E.useBlockProps)({
            className: "align".concat(m, " columns-").concat(S)
          }), (0, _.times)(S, function (l) {
            return (0, v.createElement)("div", {
              className: "wp-block-column",
              key: "column-".concat(l)
            }, (0, v.createElement)(E.RichText, {
              tagName: "p",
              value: (0, _.get)(C, [l, "children"]),
              onChange: function onChange(s) {
                c({
                  content: [].concat(_toConsumableArray(C.slice(0, l)), [{
                    children: s
                  }], _toConsumableArray(C.slice(l + 1)))
                });
              },
              "aria-label": (0, y.sprintf)((0, y.__)("Column %d text"), l + 1),
              placeholder: (0, y.__)("New Column")
            }));
          })));
        };

        var v = c(1753),
            _ = c(4793),
            y = c(6756),
            k = c(4892),
            E = c(1326),
            w = m(c(3703));
      },
      1463: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = m(c(1796)),
            _ = m(c(6730)),
            y = m(c(2737));

        var k = {
          apiVersion: 2,
          name: "core/text-columns",
          title: "Text Columns (deprecated)",
          icon: "columns",
          category: "design",
          description: "This block is deprecated. Please use the Columns block instead.",
          textdomain: "default",
          attributes: {
            content: {
              type: "array",
              source: "query",
              selector: "p",
              query: {
                children: {
                  type: "string",
                  source: "html"
                }
              },
              default: [{}, {}]
            },
            columns: {
              type: "number",
              default: 2
            },
            width: {
              type: "string"
            }
          },
          supports: {
            inserter: !1
          },
          editorStyle: "wp-block-text-columns-editor",
          style: "wp-block-text-columns"
        };
        s.metadata = k;
        var E = k.name;
        s.name = E;
        var w = {
          transforms: y.default,
          getEditWrapperProps: function getEditWrapperProps(l) {
            var s = l.width;
            if ("wide" === s || "full" === s) return {
              "data-align": s
            };
          },
          edit: v.default,
          save: _.default
        };
        s.settings = w;
      },
      6730: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.width,
              y = s.content,
              k = s.columns;
          return (0, m.createElement)("div", _.useBlockProps.save({
            className: "align".concat(c, " columns-").concat(k)
          }), (0, v.times)(k, function (l) {
            return (0, m.createElement)("div", {
              className: "wp-block-column",
              key: "column-".concat(l)
            }, (0, m.createElement)(_.RichText.Content, {
              tagName: "p",
              value: (0, v.get)(y, [l, "children"])
            }));
          }));
        };

        var m = c(1753),
            v = c(4793),
            _ = c(1326);
      },
      2737: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          to: [{
            type: "block",
            blocks: ["core/columns"],
            transform: function transform(l) {
              var s = l.className,
                  c = l.columns,
                  v = l.content,
                  _ = l.width;
              return (0, m.createBlock)("core/columns", {
                align: "wide" === _ || "full" === _ ? _ : void 0,
                className: s,
                columns: c
              }, v.map(function (l) {
                var s = l.children;
                return (0, m.createBlock)("core/column", {}, [(0, m.createBlock)("core/paragraph", {
                  content: s
                })]);
              }));
            }
          }]
        };
        s.default = v;
      },
      8573: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4793);

        var cleanEmptyObject = function cleanEmptyObject(l) {
          if (!(0, m.isObject)(l) || Array.isArray(l)) return l;
          var s = (0, m.pickBy)((0, m.mapValues)(l, cleanEmptyObject), m.identity);
          return (0, m.isEmpty)(s) ? void 0 : s;
        };

        var v = cleanEmptyObject;
        s.default = v;
      },
      2803: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useCanEditEntity = useCanEditEntity;
        var m = c(8467),
            v = c(1295);

        function useCanEditEntity(l, s, c) {
          return (0, m.useSelect)(function (m) {
            return m(v.store).canUserEditEntityRecord(l, s, c);
          }, [l, s, c]);
        }

        var _ = {
          useCanEditEntity: useCanEditEntity
        };
        s.default = _;
      },
      5935: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function _default(l) {
          var s, c;
          if (null == l || null === (s = l.style) || void 0 === s || null === (c = s.typography) || void 0 === c || !c.fontFamily) return l;
          var m = (0, v.cloneDeep)(l),
              y = m.style.typography.fontFamily.split("|").pop();
          return delete m.style.typography.fontFamily, m.style = (0, _.default)(m.style), _objectSpread(_objectSpread({}, m), {}, {
            fontFamily: y
          });
        };

        var v = c(4793),
            _ = m(c(8573));
      },
      3234: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);

        var k = {
          attributes: {
            content: {
              type: "string",
              source: "html",
              selector: "pre",
              default: ""
            },
            textAlign: {
              type: "string"
            }
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.textAlign,
                m = s.content;
            return (0, v.createElement)(y.RichText.Content, {
              tagName: "pre",
              style: {
                textAlign: c
              },
              value: m
            });
          }
        };
        var E = [{
          attributes: {
            content: {
              type: "string",
              source: "html",
              selector: "pre",
              default: "",
              __unstablePreserveWhiteSpace: !0,
              __experimentalRole: "content"
            },
            textAlign: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0
            },
            spacing: {
              padding: !0
            }
          },
          save: function save(l) {
            var s = l.attributes;
            var c = s.textAlign,
                m = s.content,
                k = (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c));
            return (0, v.createElement)("pre", y.useBlockProps.save({
              className: k
            }), (0, v.createElement)(y.RichText.Content, {
              value: m
            }));
          },
          migrate: m(c(5935)).default,
          isEligible: function isEligible(l) {
            var s;
            var c = l.style;
            return null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.fontFamily;
          }
        }, k];
        s.default = E;
      },
      6160: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function VerseEdit(l) {
          var s = l.attributes,
              c = l.setAttributes,
              m = l.mergeBlocks,
              w = l.onRemove,
              C = l.style;
          var S = s.textAlign,
              P = s.content,
              T = (0, E.useBlockProps)({
            className: (0, y.default)(_defineProperty({}, "has-text-align-".concat(S), S)),
            style: C
          });
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.BlockControls, null, (0, v.createElement)(E.AlignmentToolbar, {
            value: S,
            onChange: function onChange(l) {
              c({
                textAlign: l
              });
            }
          })), (0, v.createElement)(E.RichText, (0, _.default)({
            tagName: "pre",
            identifier: "content",
            preserveWhiteSpace: !0,
            value: P,
            onChange: function onChange(l) {
              c({
                content: l
              });
            },
            "aria-label": (0, k.__)("Verse text"),
            placeholder: (0, k.__)("Write verse…"),
            onRemove: w,
            onMerge: m,
            textAlign: S
          }, T, {
            __unstablePastePlainText: !0
          })));
        };

        var v = c(1753),
            _ = m(c(5221)),
            y = m(c(2703)),
            k = c(6756),
            E = c(1326);
      },
      6831: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(3234)),
            k = m(c(6160)),
            E = m(c(8059)),
            w = m(c(5718));

        var C = {
          apiVersion: 2,
          name: "core/verse",
          title: "Verse",
          category: "text",
          description: "Insert poetry. Use special spacing formats. Or quote song lyrics.",
          keywords: ["poetry", "poem"],
          textdomain: "default",
          attributes: {
            content: {
              type: "string",
              source: "html",
              selector: "pre",
              default: "",
              __unstablePreserveWhiteSpace: !0,
              __experimentalRole: "content"
            },
            textAlign: {
              type: "string"
            }
          },
          supports: {
            anchor: !0,
            color: {
              gradients: !0,
              link: !0
            },
            typography: {
              fontSize: !0,
              __experimentalFontFamily: !0,
              lineHeight: !0,
              __experimentalFontStyle: !0,
              __experimentalFontWeight: !0,
              __experimentalLetterSpacing: !0,
              __experimentalTextTransform: !0,
              __experimentalDefaultControls: {
                fontSize: !0,
                fontAppearance: !0
              }
            },
            spacing: {
              padding: !0
            }
          },
          style: "wp-block-verse",
          editorStyle: "wp-block-verse-editor"
        };
        s.metadata = C;
        var S = C.name;
        s.name = S;
        var P = {
          icon: _.verse,
          example: {
            attributes: {
              content: (0, v.__)("WHAT was he doing, the great god Pan,\n\tDown in the reeds by the river?\nSpreading ruin and scattering ban,\nSplashing and paddling with hoofs of a goat,\nAnd breaking the golden lilies afloat\n    With the dragon-fly on the river.")
            }
          },
          transforms: w.default,
          deprecated: y.default,
          merge: function merge(l, s) {
            return {
              content: l.content + s.content
            };
          },
          edit: k.default,
          save: E.default
        };
        s.settings = P;
      },
      8059: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.textAlign,
              m = s.content,
              k = (0, _.default)(_defineProperty({}, "has-text-align-".concat(c), c));
          return (0, v.createElement)("pre", y.useBlockProps.save({
            className: k
          }), (0, v.createElement)(y.RichText.Content, {
            value: m
          }));
        };

        var v = c(1753),
            _ = m(c(2703)),
            y = c(1326);
      },
      5718: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(6700);
        var v = {
          from: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/verse", l);
            }
          }],
          to: [{
            type: "block",
            blocks: ["core/paragraph"],
            transform: function transform(l) {
              return (0, m.createBlock)("core/paragraph", l);
            }
          }]
        };
        s.default = v;
      },
      3114: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892);

        var y = [{
          value: "auto",
          label: (0, v.__)("Auto")
        }, {
          value: "metadata",
          label: (0, v.__)("Metadata")
        }, {
          value: "none",
          label: (0, v._x)("None", "Preload value")
        }];

        var _default = function _default(l) {
          var s = l.setAttributes,
              c = l.attributes;
          var k = c.autoplay,
              E = c.controls,
              w = c.loop,
              C = c.muted,
              S = c.playsInline,
              P = c.preload,
              T = (0, v.__)("Autoplay may cause usability issues for some users."),
              B = m.Platform.select({
            web: (0, m.useCallback)(function (l) {
              return l ? T : null;
            }, []),
            native: T
          }),
              z = (0, m.useMemo)(function () {
            var toggleAttribute = function toggleAttribute(l) {
              return function (c) {
                s(_defineProperty({}, l, c));
              };
            };

            return {
              autoplay: toggleAttribute("autoplay"),
              loop: toggleAttribute("loop"),
              muted: toggleAttribute("muted"),
              controls: toggleAttribute("controls"),
              playsInline: toggleAttribute("playsInline")
            };
          }, []),
              L = (0, m.useCallback)(function (l) {
            s({
              preload: l
            });
          }, []);
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Autoplay"),
            onChange: z.autoplay,
            checked: k,
            help: B
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Loop"),
            onChange: z.loop,
            checked: w
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Muted"),
            onChange: z.muted,
            checked: C
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Playback controls"),
            onChange: z.controls,
            checked: E
          }), (0, m.createElement)(_.ToggleControl, {
            label: (0, v.__)("Play inline"),
            onChange: z.playsInline,
            checked: S
          }), (0, m.createElement)(_.SelectControl, {
            label: (0, v.__)("Preload"),
            value: P,
            onChange: L,
            options: y,
            hideCancelButton: !0
          }));
        };

        s.default = _default;
      },
      8841: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            y = c(9388),
            k = c(4892),
            E = c(1326),
            w = c(6756),
            C = c(3200),
            S = c(8467),
            P = c(5303),
            T = c(6700),
            B = c(4e3),
            z = m(c(3114)),
            L = m(c(9207)),
            V = m(c(1270));

        var A = ["video"],
            R = ["image"];
        var O = (0, k.withNotices)(function VideoEdit(l) {
          var s = l.isSelected,
              c = l.noticeUI,
              m = l.attributes,
              O = l.className,
              D = l.setAttributes,
              F = l.insertBlocksAfter,
              G = l.onReplace,
              q = l.noticeOperations;
          var W = (0, C.useInstanceId)(VideoEdit),
              U = (0, v.useRef)(),
              $ = (0, v.useRef)(),
              Z = m.id,
              K = m.caption,
              Q = m.controls,
              Y = m.poster,
              X = m.src,
              J = m.tracks,
              ee = !Z && (0, y.isBlobURL)(X),
              te = (0, S.useSelect)(function (l) {
            return l(E.store).getSettings().mediaUpload;
          });

          function onSelectVideo(l) {
            var s, c;
            l && l.url ? D({
              src: l.url,
              id: l.id,
              poster: (null === (s = l.image) || void 0 === s ? void 0 : s.src) !== l.icon ? null === (c = l.image) || void 0 === c ? void 0 : c.src : void 0
            }) : D({
              src: void 0,
              id: void 0,
              poster: void 0
            });
          }

          function onSelectURL(l) {
            if (l !== X) {
              var _s28 = (0, B.createUpgradedEmbedBlock)({
                attributes: {
                  url: l
                }
              });

              if (void 0 !== _s28) return void G(_s28);
              D({
                src: l,
                id: void 0,
                poster: void 0
              });
            }
          }

          function onUploadError(l) {
            q.removeAllNotices(), q.createErrorNotice(l);
          }

          (0, v.useEffect)(function () {
            if (!Z && (0, y.isBlobURL)(X)) {
              var _l84 = (0, y.getBlobByURL)(X);

              _l84 && te({
                filesList: [_l84],
                onFileChange: function onFileChange(l) {
                  var _l85 = _slicedToArray2(l, 1),
                      s = _l85[0].url;

                  D({
                    src: s
                  });
                },
                onError: function onError(l) {
                  q.createErrorNotice(l);
                },
                allowedTypes: A
              });
            }
          }, []), (0, v.useEffect)(function () {
            U.current && U.current.load();
          }, [Y]);
          var re = (0, _.default)(O, {
            "is-transient": ee
          }),
              ae = (0, E.useBlockProps)({
            className: re
          });
          if (!X) return (0, v.createElement)("div", ae, (0, v.createElement)(E.MediaPlaceholder, {
            icon: (0, v.createElement)(E.BlockIcon, {
              icon: P.video
            }),
            onSelect: onSelectVideo,
            onSelectURL: onSelectURL,
            accept: "video/*",
            allowedTypes: A,
            value: m,
            notices: c,
            onError: onUploadError
          }));
          var oe = "video-block__poster-image-description-".concat(W);
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.BlockControls, {
            group: "block"
          }, (0, v.createElement)(L.default, {
            tracks: J,
            onChange: function onChange(l) {
              D({
                tracks: l
              });
            }
          })), (0, v.createElement)(E.BlockControls, {
            group: "other"
          }, (0, v.createElement)(E.MediaReplaceFlow, {
            mediaId: Z,
            mediaURL: X,
            allowedTypes: A,
            accept: "video/*",
            onSelect: onSelectVideo,
            onSelectURL: onSelectURL,
            onError: onUploadError
          })), (0, v.createElement)(E.InspectorControls, null, (0, v.createElement)(k.PanelBody, {
            title: (0, w.__)("Video settings")
          }, (0, v.createElement)(z.default, {
            setAttributes: D,
            attributes: m
          }), (0, v.createElement)(E.MediaUploadCheck, null, (0, v.createElement)(k.BaseControl, {
            className: "editor-video-poster-control"
          }, (0, v.createElement)(k.BaseControl.VisualLabel, null, (0, w.__)("Poster image")), (0, v.createElement)(E.MediaUpload, {
            title: (0, w.__)("Select poster image"),
            onSelect: function onSelectPoster(l) {
              D({
                poster: l.url
              });
            },
            allowedTypes: R,
            render: function render(l) {
              var s = l.open;
              return (0, v.createElement)(k.Button, {
                variant: "primary",
                onClick: s,
                ref: $,
                "aria-describedby": oe
              }, Y ? (0, w.__)("Replace") : (0, w.__)("Select"));
            }
          }), (0, v.createElement)("p", {
            id: oe,
            hidden: !0
          }, Y ? (0, w.sprintf)((0, w.__)("The current poster image url is %s"), Y) : (0, w.__)("There is no poster image currently selected")), !!Y && (0, v.createElement)(k.Button, {
            onClick: function onRemovePoster() {
              D({
                poster: void 0
              }), $.current.focus();
            },
            variant: "tertiary"
          }, (0, w.__)("Remove")))))), (0, v.createElement)("figure", ae, (0, v.createElement)(k.Disabled, {
            isDisabled: !s
          }, (0, v.createElement)("video", {
            controls: Q,
            poster: Y,
            src: X,
            ref: U
          }, (0, v.createElement)(V.default, {
            tracks: J
          }))), ee && (0, v.createElement)(k.Spinner, null), (!E.RichText.isEmpty(K) || s) && (0, v.createElement)(E.RichText, {
            tagName: "figcaption",
            "aria-label": (0, w.__)("Video caption text"),
            placeholder: (0, w.__)("Add caption"),
            value: K,
            onChange: function onChange(l) {
              return D({
                caption: l
              });
            },
            inlineToolbar: !0,
            __unstableOnSplitAtEnd: function __unstableOnSplitAtEnd() {
              return F((0, T.createBlock)("core/paragraph"));
            }
          })));
        });
        s.default = O;
      },
      117: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.settings = s.name = s.metadata = void 0;

        var v = c(6756),
            _ = c(5303),
            y = m(c(8841)),
            k = m(c(9146)),
            E = m(c(2172));

        var w = {
          apiVersion: 2,
          name: "core/video",
          title: "Video",
          category: "media",
          description: "Embed a video from your media library or upload a new one.",
          keywords: ["movie"],
          textdomain: "default",
          attributes: {
            autoplay: {
              type: "boolean",
              source: "attribute",
              selector: "video",
              attribute: "autoplay"
            },
            caption: {
              type: "string",
              source: "html",
              selector: "figcaption"
            },
            controls: {
              type: "boolean",
              source: "attribute",
              selector: "video",
              attribute: "controls",
              default: !0
            },
            id: {
              type: "number"
            },
            loop: {
              type: "boolean",
              source: "attribute",
              selector: "video",
              attribute: "loop"
            },
            muted: {
              type: "boolean",
              source: "attribute",
              selector: "video",
              attribute: "muted"
            },
            poster: {
              type: "string",
              source: "attribute",
              selector: "video",
              attribute: "poster"
            },
            preload: {
              type: "string",
              source: "attribute",
              selector: "video",
              attribute: "preload",
              default: "metadata"
            },
            src: {
              type: "string",
              source: "attribute",
              selector: "video",
              attribute: "src"
            },
            playsInline: {
              type: "boolean",
              source: "attribute",
              selector: "video",
              attribute: "playsinline"
            },
            tracks: {
              type: "array",
              items: {
                type: "object"
              },
              default: []
            }
          },
          supports: {
            anchor: !0,
            align: !0
          },
          editorStyle: "wp-block-video-editor",
          style: "wp-block-video"
        };
        s.metadata = w;
        var C = w.name;
        s.name = C;
        var S = {
          icon: _.video,
          example: {
            attributes: {
              src: "https://upload.wikimedia.org/wikipedia/commons/c/ca/Wood_thrush_in_Central_Park_switch_sides_%2816510%29.webm",
              caption: (0, v.__)("Wood thrush singing in Central Park, NYC.")
            }
          },
          transforms: E.default,
          edit: y.default,
          save: k.default
        };
        s.settings = S;
      },
      9146: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function save(l) {
          var s = l.attributes;
          var c = s.autoplay,
              m = s.caption,
              k = s.controls,
              E = s.loop,
              w = s.muted,
              C = s.poster,
              S = s.preload,
              P = s.src,
              T = s.playsInline,
              B = s.tracks;
          return (0, v.createElement)("figure", _.useBlockProps.save(), P && (0, v.createElement)("video", {
            autoPlay: c,
            controls: k,
            loop: E,
            muted: w,
            poster: C,
            preload: "metadata" !== S ? S : void 0,
            src: P,
            playsInline: T
          }, (0, v.createElement)(y.default, {
            tracks: B
          })), !_.RichText.isEmpty(m) && (0, v.createElement)(_.RichText.Content, {
            tagName: "figcaption",
            value: m
          }));
        };

        var v = c(1753),
            _ = c(1326),
            y = m(c(1270));
      },
      9207: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TracksEditor(l) {
          var _l$tracks = l.tracks,
              s = _l$tracks === void 0 ? [] : _l$tracks,
              c = l.onChange;

          var w = (0, E.useSelect)(function (l) {
            return l(y.store).getSettings().mediaUpload;
          }, []),
              _ref409 = (0, m.useState)(null),
              _ref410 = _slicedToArray2(_ref409, 2),
              S = _ref410[0],
              P = _ref410[1];

          if (!w) return null;
          return (0, m.createElement)(_.Dropdown, {
            contentClassName: "block-library-video-tracks-editor",
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, m.createElement)(_.ToolbarButton, {
                label: (0, v.__)("Text tracks"),
                showTooltip: !0,
                "aria-expanded": s,
                "aria-haspopup": "true",
                onClick: c,
                icon: T
              });
            },
            renderContent: function renderContent(l) {
              _objectDestructuringEmpty(l);

              return null !== S ? (0, m.createElement)(SingleTrackEditor, {
                track: s[S],
                onChange: function onChange(l) {
                  var m = _toConsumableArray(s);

                  m[S] = l, c(m);
                },
                onClose: function onClose() {
                  return P(null);
                },
                onRemove: function onRemove() {
                  c(s.filter(function (l, s) {
                    return s !== S;
                  })), P(null);
                }
              }) : (0, m.createElement)(m.Fragment, null, (0, m.createElement)(_.NavigableMenu, null, (0, m.createElement)(TrackList, {
                tracks: s,
                onEditPress: P
              }), (0, m.createElement)(_.MenuGroup, {
                className: "block-library-video-tracks-editor__add-tracks-container",
                label: (0, v.__)("Add tracks")
              }, (0, m.createElement)(y.MediaUpload, {
                onSelect: function onSelect(l) {
                  var m = l.url;
                  var v = s.length;
                  c([].concat(_toConsumableArray(s), [{
                    src: m
                  }])), P(v);
                },
                allowedTypes: C,
                render: function render(l) {
                  var s = l.open;
                  return (0, m.createElement)(_.MenuItem, {
                    icon: k.media,
                    onClick: s
                  }, (0, v.__)("Open Media Library"));
                }
              }), (0, m.createElement)(y.MediaUploadCheck, null, (0, m.createElement)(_.FormFileUpload, {
                onChange: function onChange(l) {
                  var m = l.target.files,
                      v = s.length;
                  w({
                    allowedTypes: C,
                    filesList: m,
                    onFileChange: function onFileChange(l) {
                      var _l86 = _slicedToArray2(l, 1),
                          m = _l86[0].url;

                      var _ = _toConsumableArray(s);

                      _[v] || (_[v] = {}), _[v] = _objectSpread(_objectSpread({}, s[v]), {}, {
                        src: m
                      }), c(_), P(v);
                    }
                  });
                },
                accept: ".vtt,text/vtt",
                render: function render(l) {
                  var s = l.openFileDialog;
                  return (0, m.createElement)(_.MenuItem, {
                    icon: k.upload,
                    onClick: function onClick() {
                      s();
                    }
                  }, (0, v.__)("Upload"));
                }
              })))));
            }
          });
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            y = c(1326),
            k = c(5303),
            E = c(8467),
            w = c(904);

        var C = ["text/vtt"],
            S = "subtitles",
            P = [{
          label: (0, v.__)("Subtitles"),
          value: "subtitles"
        }, {
          label: (0, v.__)("Captions"),
          value: "captions"
        }, {
          label: (0, v.__)("Descriptions"),
          value: "descriptions"
        }, {
          label: (0, v.__)("Chapters"),
          value: "chapters"
        }, {
          label: (0, v.__)("Metadata"),
          value: "metadata"
        }],
            T = (0, m.createElement)(_.SVG, {
          width: "18",
          height: "14",
          viewBox: "0 0 18 14",
          role: "img",
          fill: "none"
        }, (0, m.createElement)(_.Rect, {
          x: "0.75",
          y: "0.75",
          width: "16.5",
          height: "12.5",
          rx: "1.25",
          stroke: "black",
          strokeWidth: "1.5",
          fill: "none"
        }), (0, m.createElement)(_.Path, {
          d: "M3 7H15",
          stroke: "black",
          strokeWidth: "1.5"
        }), (0, m.createElement)(_.Path, {
          d: "M3 10L15 10",
          stroke: "black",
          strokeWidth: "1.5"
        }));

        function TrackList(l) {
          var s,
              c = l.tracks,
              y = l.onEditPress;
          return s = 0 === c.length ? (0, m.createElement)("p", {
            className: "block-library-video-tracks-editor__tracks-informative-message"
          }, (0, v.__)("Tracks can be subtitles, captions, chapters, or descriptions. They help make your content more accessible to a wider range of users.")) : c.map(function (l, s) {
            return (0, m.createElement)("div", {
              key: s,
              className: "block-library-video-tracks-editor__track-list-track"
            }, (0, m.createElement)("span", null, l.label, " "), (0, m.createElement)(_.Button, {
              variant: "tertiary",
              onClick: function onClick() {
                return y(s);
              },
              "aria-label": (0, v.sprintf)((0, v.__)("Edit %s"), l.label)
            }, (0, v.__)("Edit")));
          }), (0, m.createElement)(_.MenuGroup, {
            label: (0, v.__)("Text tracks"),
            className: "block-library-video-tracks-editor__track-list"
          }, s);
        }

        function SingleTrackEditor(l) {
          var s = l.track,
              c = l.onChange,
              y = l.onClose,
              k = l.onRemove;
          var _s$src = s.src,
              E = _s$src === void 0 ? "" : _s$src,
              _s$label2 = s.label,
              C = _s$label2 === void 0 ? "" : _s$label2,
              _s$srcLang = s.srcLang,
              T = _s$srcLang === void 0 ? "" : _s$srcLang,
              _s$kind = s.kind,
              B = _s$kind === void 0 ? S : _s$kind,
              z = E.startsWith("blob:") ? "" : (0, w.getFilename)(E) || "";
          return (0, m.createElement)(_.NavigableMenu, null, (0, m.createElement)("div", {
            className: "block-library-video-tracks-editor__single-track-editor"
          }, (0, m.createElement)("span", {
            className: "block-library-video-tracks-editor__single-track-editor-edit-track-label"
          }, (0, v.__)("Edit track")), (0, m.createElement)("span", null, (0, v.__)("File"), ": ", (0, m.createElement)("b", null, z)), (0, m.createElement)("div", {
            className: "block-library-video-tracks-editor__single-track-editor-label-language"
          }, (0, m.createElement)(_.TextControl, {
            autoFocus: !0,
            onChange: function onChange(l) {
              return c(_objectSpread(_objectSpread({}, s), {}, {
                label: l
              }));
            },
            label: (0, v.__)("Label"),
            value: C,
            help: (0, v.__)("Title of track")
          }), (0, m.createElement)(_.TextControl, {
            onChange: function onChange(l) {
              return c(_objectSpread(_objectSpread({}, s), {}, {
                srcLang: l
              }));
            },
            label: (0, v.__)("Source language"),
            value: T,
            help: (0, v.__)("Language tag (en, fr, etc.)")
          })), (0, m.createElement)(_.SelectControl, {
            className: "block-library-video-tracks-editor__single-track-editor-kind-select",
            options: P,
            value: B,
            label: (0, v.__)("Kind"),
            onChange: function onChange(l) {
              c(_objectSpread(_objectSpread({}, s), {}, {
                kind: l
              }));
            }
          }), (0, m.createElement)("div", {
            className: "block-library-video-tracks-editor__single-track-editor-buttons-container"
          }, (0, m.createElement)(_.Button, {
            variant: "secondary",
            onClick: function onClick() {
              var l = {};
              var m = !1;
              "" === C && (l.label = (0, v.__)("English"), m = !0), "" === T && (l.srcLang = "en", m = !0), void 0 === s.kind && (l.kind = S, m = !0), m && c(_objectSpread(_objectSpread({}, s), l)), y();
            }
          }, (0, v.__)("Close")), (0, m.createElement)(_.Button, {
            isDestructive: !0,
            variant: "link",
            onClick: k
          }, (0, v.__)("Remove track")))));
        }
      },
      1270: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function Tracks(l) {
          var _l$tracks2 = l.tracks,
              s = _l$tracks2 === void 0 ? [] : _l$tracks2;
          return s.map(function (l) {
            return (0, v.createElement)("track", (0, _.default)({
              key: l.src
            }, l));
          });
        };

        var v = c(1753),
            _ = m(c(5221));
      },
      2172: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(9388),
            v = c(6700);
        var _ = {
          from: [{
            type: "files",
            isMatch: function isMatch(l) {
              return 1 === l.length && 0 === l[0].type.indexOf("video/");
            },
            transform: function transform(l) {
              var s = l[0];
              return (0, v.createBlock)("core/video", {
                src: (0, m.createBlobURL)(s)
              });
            }
          }, {
            type: "shortcode",
            tag: "video",
            attributes: {
              src: {
                type: "string",
                shortcode: function shortcode(l) {
                  var _l$named2 = l.named,
                      s = _l$named2.src,
                      c = _l$named2.mp4,
                      m = _l$named2.m4v,
                      v = _l$named2.webm,
                      _ = _l$named2.ogv,
                      y = _l$named2.flv;
                  return s || c || m || v || _ || y;
                }
              },
              poster: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.poster;
                  return s;
                }
              },
              loop: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.loop;
                  return s;
                }
              },
              autoplay: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.autoplay;
                  return s;
                }
              },
              preload: {
                type: "string",
                shortcode: function shortcode(l) {
                  var s = l.named.preload;
                  return s;
                }
              }
            }
          }]
        };
        s.default = _;
      },
      5303: function _(l, s, c) {
        "use strict";

        c.r(s), c.d(s, {
          Icon: function Icon() {
            return v;
          },
          addCard: function addCard() {
            return k;
          },
          addSubmenu: function addSubmenu() {
            return w;
          },
          alignCenter: function alignCenter() {
            return S;
          },
          alignJustify: function alignJustify() {
            return T;
          },
          alignJustifyAlt: function alignJustifyAlt() {
            return z;
          },
          alignLeft: function alignLeft() {
            return V;
          },
          alignNone: function alignNone() {
            return R;
          },
          alignRight: function alignRight() {
            return D;
          },
          archive: function archive() {
            return G;
          },
          archiveTitle: function archiveTitle() {
            return W;
          },
          arrowDown: function arrowDown() {
            return $;
          },
          arrowLeft: function arrowLeft() {
            return K;
          },
          arrowRight: function arrowRight() {
            return Y;
          },
          arrowUp: function arrowUp() {
            return J;
          },
          aspectRatio: function aspectRatio() {
            return ae;
          },
          atSymbol: function atSymbol() {
            return te;
          },
          audio: function audio() {
            return ne;
          },
          backup: function backup() {
            return ie;
          },
          blockDefault: function blockDefault() {
            return ce;
          },
          blockTable: function blockTable() {
            return de;
          },
          box: function box() {
            return pe;
          },
          brush: function brush() {
            return ve;
          },
          bug: function bug() {
            return be;
          },
          button: function button() {
            return fe;
          },
          buttons: function buttons() {
            return ke;
          },
          calendar: function calendar() {
            return we;
          },
          cancelCircleFilled: function cancelCircleFilled() {
            return xe;
          },
          capturePhoto: function capturePhoto() {
            return Pe;
          },
          captureVideo: function captureVideo() {
            return Me;
          },
          category: function category() {
            return Ie;
          },
          chartBar: function chartBar() {
            return ze;
          },
          check: function check() {
            return Ve;
          },
          chevronDown: function chevronDown() {
            return Re;
          },
          chevronLeft: function chevronLeft() {
            return Oe;
          },
          chevronRight: function chevronRight() {
            return Fe;
          },
          chevronRightSmall: function chevronRightSmall() {
            return Ge;
          },
          chevronUp: function chevronUp() {
            return We;
          },
          classic: function classic() {
            return $e;
          },
          close: function close() {
            return Ke;
          },
          closeSmall: function closeSmall() {
            return Ye;
          },
          cloud: function cloud() {
            return tt;
          },
          cloudUpload: function cloudUpload() {
            return Je;
          },
          code: function code() {
            return at;
          },
          cog: function cog() {
            return nt;
          },
          cogAlt: function cogAlt() {
            return it;
          },
          color: function color() {
            return ct;
          },
          column: function column() {
            return dt;
          },
          columns: function columns() {
            return pt;
          },
          comment: function comment() {
            return vt;
          },
          commentAuthorAvatar: function commentAuthorAvatar() {
            return bt;
          },
          commentAuthorName: function commentAuthorName() {
            return ft;
          },
          commentContent: function commentContent() {
            return kt;
          },
          commentReplyLink: function commentReplyLink() {
            return wt;
          },
          cover: function cover() {
            return xt;
          },
          create: function create() {
            return Pt;
          },
          crop: function crop() {
            return Mt;
          },
          currencyDollar: function currencyDollar() {
            return It;
          },
          currencyEuro: function currencyEuro() {
            return zt;
          },
          currencyPound: function currencyPound() {
            return Vt;
          },
          customLink: function customLink() {
            return Po;
          },
          customPostType: function customPostType() {
            return Rt;
          },
          desktop: function desktop() {
            return Ot;
          },
          download: function download() {
            return Gt;
          },
          dragHandle: function dragHandle() {
            return Ft;
          },
          edit: function edit() {
            return Ut;
          },
          external: function external() {
            return Zt;
          },
          file: function file() {
            return Qt;
          },
          flipHorizontal: function flipHorizontal() {
            return Xt;
          },
          flipVertical: function flipVertical() {
            return er;
          },
          footer: function footer() {
            return Xn;
          },
          formatBold: function formatBold() {
            return rr;
          },
          formatCapitalize: function formatCapitalize() {
            return or;
          },
          formatIndent: function formatIndent() {
            return lr;
          },
          formatIndentRTL: function formatIndentRTL() {
            return sr;
          },
          formatItalic: function formatItalic() {
            return ur;
          },
          formatListBullets: function formatListBullets() {
            return mr;
          },
          formatListBulletsRTL: function formatListBulletsRTL() {
            return gr;
          },
          formatListNumbered: function formatListNumbered() {
            return hr;
          },
          formatListNumberedRTL: function formatListNumberedRTL() {
            return _r;
          },
          formatLowercase: function formatLowercase() {
            return Er;
          },
          formatLtr: function formatLtr() {
            return yr;
          },
          formatOutdent: function formatOutdent() {
            return Cr;
          },
          formatOutdentRTL: function formatOutdentRTL() {
            return Sr;
          },
          formatRtl: function formatRtl() {
            return Tr;
          },
          formatStrikethrough: function formatStrikethrough() {
            return Br;
          },
          formatUnderline: function formatUnderline() {
            return Nr;
          },
          formatUppercase: function formatUppercase() {
            return Lr;
          },
          fullscreen: function fullscreen() {
            return Ar;
          },
          gallery: function gallery() {
            return Hr;
          },
          globe: function globe() {
            return Dr;
          },
          grid: function grid() {
            return jr;
          },
          group: function group() {
            return qr;
          },
          handle: function handle() {
            return Ur;
          },
          header: function header() {
            return Jn;
          },
          heading: function heading() {
            return Zr;
          },
          help: function help() {
            return Qr;
          },
          helpFilled: function helpFilled() {
            return Xr;
          },
          home: function home() {
            return oa;
          },
          html: function html() {
            return la;
          },
          image: function image() {
            return sa;
          },
          inbox: function inbox() {
            return ea;
          },
          info: function info() {
            return ua;
          },
          insertAfter: function insertAfter() {
            return ma;
          },
          insertBefore: function insertBefore() {
            return ga;
          },
          institution: function institution() {
            return ra;
          },
          justifyCenter: function justifyCenter() {
            return _a;
          },
          justifyLeft: function justifyLeft() {
            return ha;
          },
          justifyRight: function justifyRight() {
            return ya;
          },
          justifySpaceBetween: function justifySpaceBetween() {
            return Ea;
          },
          key: function key() {
            return Ca;
          },
          keyboardClose: function keyboardClose() {
            return Sa;
          },
          keyboardReturn: function keyboardReturn() {
            return Ta;
          },
          layout: function layout() {
            return Ba;
          },
          lifesaver: function lifesaver() {
            return Na;
          },
          lineDashed: function lineDashed() {
            return La;
          },
          lineDotted: function lineDotted() {
            return Aa;
          },
          lineSolid: function lineSolid() {
            return Ha;
          },
          link: function link() {
            return Da;
          },
          linkOff: function linkOff() {
            return ja;
          },
          list: function list() {
            return qa;
          },
          listView: function listView() {
            return Ua;
          },
          lock: function lock() {
            return Za;
          },
          login: function login() {
            return Qa;
          },
          loop: function loop() {
            return Xa;
          },
          mapMarker: function mapMarker() {
            return eo;
          },
          media: function media() {
            return ro;
          },
          mediaAndText: function mediaAndText() {
            return oo;
          },
          megaphone: function megaphone() {
            return lo;
          },
          menu: function menu() {
            return so;
          },
          mobile: function mobile() {
            return uo;
          },
          more: function more() {
            return po;
          },
          moreHorizontal: function moreHorizontal() {
            return vo;
          },
          moreHorizontalMobile: function moreHorizontalMobile() {
            return bo;
          },
          moreVertical: function moreVertical() {
            return fo;
          },
          moveTo: function moveTo() {
            return ko;
          },
          navigation: function navigation() {
            return wo;
          },
          next: function next() {
            return en;
          },
          overlayText: function overlayText() {
            return xo;
          },
          page: function page() {
            return To;
          },
          pageBreak: function pageBreak() {
            return So;
          },
          pages: function pages() {
            return Mo;
          },
          paragraph: function paragraph() {
            return Bo;
          },
          payment: function payment() {
            return Io;
          },
          pencil: function pencil() {
            return Wt;
          },
          people: function people() {
            return Ao;
          },
          percent: function percent() {
            return No;
          },
          pin: function pin() {
            return Ro;
          },
          plugins: function plugins() {
            return Ho;
          },
          plus: function plus() {
            return Fo;
          },
          plusCircle: function plusCircle() {
            return Do;
          },
          plusCircleFilled: function plusCircleFilled() {
            return Oo;
          },
          positionCenter: function positionCenter() {
            return zo;
          },
          positionLeft: function positionLeft() {
            return Lo;
          },
          positionRight: function positionRight() {
            return Vo;
          },
          postAuthor: function postAuthor() {
            return jo;
          },
          postCategories: function postCategories() {
            return Go;
          },
          postComments: function postComments() {
            return Wo;
          },
          postCommentsCount: function postCommentsCount() {
            return Uo;
          },
          postCommentsForm: function postCommentsForm() {
            return $o;
          },
          postContent: function postContent() {
            return qo;
          },
          postDate: function postDate() {
            return Zo;
          },
          postExcerpt: function postExcerpt() {
            return Ko;
          },
          postFeaturedImage: function postFeaturedImage() {
            return Qo;
          },
          postList: function postList() {
            return Yo;
          },
          postTitle: function postTitle() {
            return Xo;
          },
          preformatted: function preformatted() {
            return tn;
          },
          previous: function previous() {
            return Jo;
          },
          pullLeft: function pullLeft() {
            return rn;
          },
          pullRight: function pullRight() {
            return an;
          },
          pullquote: function pullquote() {
            return on;
          },
          queryPagination: function queryPagination() {
            return nn;
          },
          queryPaginationNext: function queryPaginationNext() {
            return ln;
          },
          queryPaginationNumbers: function queryPaginationNumbers() {
            return sn;
          },
          queryPaginationPrevious: function queryPaginationPrevious() {
            return cn;
          },
          quote: function quote() {
            return un;
          },
          receipt: function receipt() {
            return dn;
          },
          redo: function redo() {
            return mn;
          },
          removeBug: function removeBug() {
            return pn;
          },
          replace: function replace() {
            return gn;
          },
          reset: function reset() {
            return vn;
          },
          resizeCornerNE: function resizeCornerNE() {
            return hn;
          },
          reusableBlock: function reusableBlock() {
            return bn;
          },
          rotateLeft: function rotateLeft() {
            return fn;
          },
          rotateRight: function rotateRight() {
            return yn;
          },
          rss: function rss() {
            return kn;
          },
          search: function search() {
            return En;
          },
          separator: function separator() {
            return wn;
          },
          settings: function settings() {
            return Cn;
          },
          share: function share() {
            return xn;
          },
          shield: function shield() {
            return Sn;
          },
          shipping: function shipping() {
            return Rn;
          },
          shortcode: function shortcode() {
            return Pn;
          },
          sidebar: function sidebar() {
            return el;
          },
          siteLogo: function siteLogo() {
            return Tn;
          },
          sparkles: function sparkles() {
            return Mn;
          },
          stack: function stack() {
            return Bn;
          },
          starEmpty: function starEmpty() {
            return In;
          },
          starFilled: function starFilled() {
            return Nn;
          },
          starHalf: function starHalf() {
            return zn;
          },
          store: function store() {
            return Ln;
          },
          stretchFullWidth: function stretchFullWidth() {
            return Vn;
          },
          stretchWide: function stretchWide() {
            return Hn;
          },
          styles: function styles() {
            return An;
          },
          subscript: function subscript() {
            return On;
          },
          superscript: function superscript() {
            return Dn;
          },
          swatch: function swatch() {
            return Fn;
          },
          symbol: function symbol() {
            return _n;
          },
          symbolFilled: function symbolFilled() {
            return Qn;
          },
          table: function table() {
            return Zn;
          },
          tableColumnAfter: function tableColumnAfter() {
            return jn;
          },
          tableColumnBefore: function tableColumnBefore() {
            return Gn;
          },
          tableColumnDelete: function tableColumnDelete() {
            return qn;
          },
          tableRowAfter: function tableRowAfter() {
            return Wn;
          },
          tableRowBefore: function tableRowBefore() {
            return Un;
          },
          tableRowDelete: function tableRowDelete() {
            return $n;
          },
          tablet: function tablet() {
            return rl;
          },
          tag: function tag() {
            return Kn;
          },
          termDescription: function termDescription() {
            return Yn;
          },
          textColor: function textColor() {
            return tl;
          },
          title: function title() {
            return al;
          },
          tool: function tool() {
            return ol;
          },
          trash: function trash() {
            return nl;
          },
          trashFilled: function trashFilled() {
            return ll;
          },
          trendingDown: function trendingDown() {
            return il;
          },
          trendingUp: function trendingUp() {
            return sl;
          },
          typography: function typography() {
            return cl;
          },
          undo: function undo() {
            return ul;
          },
          ungroup: function ungroup() {
            return dl;
          },
          update: function update() {
            return ml;
          },
          upload: function upload() {
            return pl;
          },
          verse: function verse() {
            return gl;
          },
          video: function video() {
            return vl;
          },
          warning: function warning() {
            return hl;
          },
          widget: function widget() {
            return bl;
          },
          wordpress: function wordpress() {
            return _l;
          }
        });
        var m = c(1753);

        var v = function Icon(l) {
          var s = l.icon,
              _l$size = l.size,
              c = _l$size === void 0 ? 24 : _l$size,
              v = _objectWithoutProperties(l, _excluded19);

          return (0, m.cloneElement)(s, _objectSpread({
            width: c,
            height: c
          }, v));
        };

        var _ = c(1666);

        var y = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 5.5V8H20V5.5h2.5V4H20V1.5h-1.5V4H16v1.5h2.5zM12 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-1.5v6a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h6V4z"
        })),
            k = y,
            E = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 12c0 3.6 2.4 5.5 6 5.5h.5V19l3-2.5-3-2.5v2H8c-2.5 0-4.5-1.5-4.5-4s2-4.5 4.5-4.5h3.5V6H8c-3.6 0-6 2.4-6 6zm19.5-1h-8v1.5h8V11zm0 5h-8v1.5h8V16zm0-10h-8v1.5h8V6z"
        })),
            w = E,
            C = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.4 4.2H7.6v1.5h8.9V4.2zM4 11.2v1.5h16v-1.5H4zm3.6 8.6h8.9v-1.5H7.6v1.5z"
        })),
            S = C,
            P = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 12.8h16v-1.5H4v1.5zm0 7h12.4v-1.5H4v1.5zM4 4.3v1.5h16V4.3H4z"
        })),
            T = P,
            B = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M4 5h16v2H4V5zm0 4v2h16V9H4zm0 4h16v2H4v-2zm16 6H4v-2h16v2z"
        })),
            z = B,
            L = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 19.8h8.9v-1.5H4v1.5zm8.9-15.6H4v1.5h8.9V4.2zm-8.9 7v1.5h16v-1.5H4z"
        })),
            V = L,
            A = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 15h14V9H5v6zm0 4.8h14v-1.5H5v1.5zM5 4.2v1.5h14V4.2H5z"
        })),
            R = A,
            O = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 19.8H20v-1.5h-8.9v1.5zm0-15.6v1.5H20V4.2h-8.9zM4 12.8h16v-1.5H4v1.5z"
        })),
            D = O,
            F = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5zM8 12.8h8v-1.5H8v1.5zm0 3h8v-1.5H8v1.5z"
        })),
            G = F,
            q = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M4 19.25h9M4 15.25h16"
        }), (0, m.createElement)(_.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            W = q,
            U = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.2 13.2l-4 4V4h-1.5v13.3l-4.5-4.1-1 1.1 6.2 5.8 5.8-5.8-1-1.1z"
        })),
            $ = U,
            Z = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 10.8H6.7l4.1-4.5-1.1-1.1-5.8 6.3 5.8 5.8 1.1-1.1-4-3.9H20z"
        })),
            K = Z,
            Q = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.3 6.7l-1.1 1.1 4 4H4v1.5h13.3l-4.1 4.4 1.1 1.1 5.8-6.3z"
        })),
            Y = Q,
            X = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 3.9L6.7 9.7l1.1 1.1 4-4V20h1.4V6.7l4.5 4.1 1.1-1.1z"
        })),
            J = X,
            ee = (0, m.createElement)(_.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5939 21C14.1472 21 16.1269 20.5701 17.0711 20.1975L16.6447 18.879C16.0964 19.051 14.3299 19.6242 12.6548 19.6242C7.4467 19.6242 4.67513 16.8726 4.67513 12C4.67513 7.21338 7.50762 4.34713 12.2893 4.34713C17.132 4.34713 19.4162 7.55732 19.4162 10.7675C19.4162 14.035 19.0508 15.4968 17.4975 15.4968C16.5838 15.4968 16.0964 14.7803 16.0964 13.9777V7.5H14.4822V8.30255H14.3909C14.1777 7.67198 12.9898 7.12739 11.467 7.2707C9.18274 7.5 7.4467 9.27707 7.4467 11.8567C7.4467 14.5796 8.81726 16.672 11.467 16.758C13.203 16.8153 14.1168 16.0127 14.4822 15.1815H14.5736C14.7563 16.414 16.401 16.8439 17.467 16.8439C20.6954 16.8439 21 13.5764 21 10.7962C21 6.86943 18.0761 3 12.3807 3C6.50254 3 3 6.3535 3 11.9427C3 17.7325 6.38071 21 12.5939 21ZM11.7107 15.2962C9.73096 15.2962 9.03046 13.6051 9.03046 11.7707C9.03046 10.1083 10.0355 8.67516 11.7716 8.67516C13.599 8.67516 14.5736 9.36306 14.5736 11.7707C14.5736 14.1497 13.7513 15.2962 11.7107 15.2962Z"
        })),
            te = ee,
            re = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 5.5h-13c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v9zM6.5 12H8v-2h2V8.5H6.5V12zm9.5 2h-2v1.5h3.5V12H16v2z"
        })),
            ae = re,
            oe = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.7 4.3c-1.2 0-2.8 0-3.8 1-.6.6-.9 1.5-.9 2.6V14c-.6-.6-1.5-1-2.5-1C8.6 13 7 14.6 7 16.5S8.6 20 10.5 20c1.5 0 2.8-1 3.3-2.3.5-.8.7-1.8.7-2.5V7.9c0-.7.2-1.2.5-1.6.6-.6 1.8-.6 2.8-.6h.3V4.3h-.4z"
        })),
            ne = oe,
            le = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.5 12h1.75l-2.5 3-2.5-3H4a8 8 0 113.134 6.35l.907-1.194A6.5 6.5 0 105.5 12zm9.53 1.97l-2.28-2.28V8.5a.75.75 0 00-1.5 0V12a.747.747 0 00.218.529l1.282-.84-1.28.842 2.5 2.5a.75.75 0 101.06-1.061z"
        })),
            ie = le,
            se = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 8h-1V6h-5v2h-2V6H6v2H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm.5 10c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v8z"
        })),
            ce = se,
            ue = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v3.5h-15V5c0-.3.2-.5.5-.5zm8 5.5h6.5v3.5H13V10zm-1.5 3.5h-7V10h7v3.5zm-7 5.5v-4h7v4.5H5c-.3 0-.5-.2-.5-.5zm14.5.5h-6V15h6.5v4c0 .3-.2.5-.5.5z"
        })),
            de = ue,
            me = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5 5.5h14a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 9.232A2 2 0 013 7.5V6a2 2 0 012-2h14a2 2 0 012 2v1.5a2 2 0 01-1 1.732V18a2 2 0 01-2 2H6a2 2 0 01-2-2V9.232zm1.5.268V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V9.5h-13z",
          clipRule: "evenodd"
        })),
            pe = me,
            ge = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h8v-1.5H4V20zM18.9 3.5c-.6-.6-1.5-.6-2.1 0l-7.2 7.2c-.4-.1-.7 0-1.1.1-.5.2-1.5.7-1.9 2.2-.4 1.7-.8 2.2-1.1 2.7-.1.1-.2.3-.3.4l-.6 1.1H6c2 0 3.4-.4 4.7-1.4.8-.6 1.2-1.4 1.3-2.3 0-.3 0-.5-.1-.7L19 5.7c.5-.6.5-1.6-.1-2.2zM9.7 14.7c-.7.5-1.5.8-2.4 1 .2-.5.5-1.2.8-2.3.2-.6.4-1 .8-1.1.5-.1 1 .1 1.3.3.2.2.3.5.2.8 0 .3-.1.9-.7 1.3z"
        })),
            ve = ge,
            he = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.13 5.5l1.926 1.927A4.975 4.975 0 007.025 10H5v1.5h2V13H5v1.5h2.1a5.002 5.002 0 009.8 0H19V13h-2v-1.5h2V10h-2.025a4.979 4.979 0 00-1.167-2.74l1.76-1.76-1.061-1.06-1.834 1.834A4.977 4.977 0 0012 5.5c-1.062 0-2.046.33-2.855.895L7.19 4.44 6.13 5.5zm2.37 5v3a3.5 3.5 0 107 0v-3a3.5 3.5 0 10-7 0z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            be = he,
            _e = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.5H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v7zM8 12.8h8v-1.5H8v1.5z"
        })),
            fe = _e,
            ye = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17 3H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V5c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5V6.2h-5v1.6zM17 13H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5v-1.5h-5v1.5z"
        })),
            ke = ye,
            Ee = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V7h15v12zM9 10H7v2h2v-2zm0 4H7v2h2v-2zm4-4h-2v2h2v-2zm4 0h-2v2h2v-2zm-4 4h-2v2h2v-2zm4 0h-2v2h2v-2z"
        })),
            we = Ee,
            Ce = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967Z"
        })),
            xe = Ce,
            Se = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 9.2c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4 4-1.8 4-4-1.8-4-4-4zm0 6.5c-1.4 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM20.2 8c-.1 0-.3 0-.5-.1l-2.5-.8c-.4-.1-.8-.4-1.1-.8l-1-1.5c-.4-.5-1-.9-1.7-.9h-2.9c-.6.1-1.2.4-1.6 1l-1 1.5c-.3.3-.6.6-1.1.7l-2.5.8c-.2.1-.4.1-.6.1-1 .2-1.7.9-1.7 1.9v8.3c0 1 .9 1.9 2 1.9h16c1.1 0 2-.8 2-1.9V9.9c0-1-.7-1.7-1.8-1.9zm.3 10.1c0 .2-.2.4-.5.4H4c-.3 0-.5-.2-.5-.4V9.9c0-.1.2-.3.5-.4.2 0 .5-.1.8-.2l2.5-.8c.7-.2 1.4-.6 1.8-1.3l1-1.5c.1-.1.2-.2.4-.2h2.9c.2 0 .3.1.4.2l1 1.5c.4.7 1.1 1.1 1.9 1.4l2.5.8c.3.1.6.1.8.2.3 0 .4.2.4.4v8.1z"
        })),
            Pe = Se,
            Te = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M14 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm.5 12c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10zm2.5-7v4l5 3V7l-5 3zm3.5 4.4l-2-1.2v-2.3l2-1.2v4.7z"
        })),
            Me = Te,
            Be = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6 5.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm11-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM13 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2V6zm5 8.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM15 13a2 2 0 00-2 2v3a2 2 0 002 2h3a2 2 0 002-2v-3a2 2 0 00-2-2h-3zm-9 1.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zM4 15a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Ie = Be,
            Ne = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M11.25 5h1.5v15h-1.5V5zM6 10h1.5v10H6V10zm12 4h-1.5v6H18v-6z",
          clipRule: "evenodd"
        })),
            ze = Ne,
            Le = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.7 7.1l-6.3 8.5-3.3-2.5-.9 1.2 4.5 3.4L17.9 8z"
        })),
            Ve = Le,
            Ae = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.5 11.6L12 16l-5.5-4.4.9-1.2L12 14l4.5-3.6 1 1.2z"
        })),
            Re = Ae,
            He = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z"
        })),
            Oe = He,
            De = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z"
        })),
            Fe = De,
            je = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.8622 8.04053L14.2805 12.0286L10.8622 16.0167L9.72327 15.0405L12.3049 12.0286L9.72327 9.01672L10.8622 8.04053Z"
        })),
            Ge = je,
            qe = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6.5 12.4L12 8l5.5 4.4-.9 1.2L12 10l-4.5 3.6-1-1.2z"
        })),
            We = qe,
            Ue = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20 6H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h16c.3 0 .5.2.5.5v9zM10 10H8v2h2v-2zm-5 2h2v-2H5v2zm8-2h-2v2h2v-2zm-5 6h8v-2H8v2zm6-4h2v-2h-2v2zm3 0h2v-2h-2v2zm0 4h2v-2h-2v2zM5 16h2v-2H5v2z"
        })),
            $e = Ue,
            Ze = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 11.8l6.1-6.3-1-1-6.1 6.2-6.1-6.2-1 1 6.1 6.3-6.5 6.7 1 1 6.5-6.6 6.5 6.6 1-1z"
        })),
            Ke = Ze,
            Qe = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 13.06l3.712 3.713 1.061-1.06L13.061 12l3.712-3.712-1.06-1.06L12 10.938 8.288 7.227l-1.061 1.06L10.939 12l-3.712 3.712 1.06 1.061L12 13.061z"
        })),
            Ye = Qe,
            Xe = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-4v-2.4L14 14l1-1-3-3-3 3 1 1 1.2-1.2v2.4H7.7c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4H9l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8 0 1-.8 1.8-1.7 1.8z"
        })),
            Je = Xe,
            et = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-9c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4h1.3l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8-.1 1-.9 1.8-1.8 1.8z"
        })),
            tt = et,
            rt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.8 10.7l-4.3-4.3-1.1 1.1 4.3 4.3c.1.1.1.3 0 .4l-4.3 4.3 1.1 1.1 4.3-4.3c.7-.8.7-1.9 0-2.6zM4.2 11.8l4.3-4.3-1-1-4.3 4.3c-.7.7-.7 1.8 0 2.5l4.3 4.3 1.1-1.1-4.3-4.3c-.2-.1-.2-.3-.1-.4z"
        })),
            at = rt,
            ot = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M10.289 4.836A1 1 0 0111.275 4h1.306a1 1 0 01.987.836l.244 1.466c.787.26 1.503.679 2.108 1.218l1.393-.522a1 1 0 011.216.437l.653 1.13a1 1 0 01-.23 1.273l-1.148.944a6.025 6.025 0 010 2.435l1.149.946a1 1 0 01.23 1.272l-.653 1.13a1 1 0 01-1.216.437l-1.394-.522c-.605.54-1.32.958-2.108 1.218l-.244 1.466a1 1 0 01-.987.836h-1.306a1 1 0 01-.986-.836l-.244-1.466a5.995 5.995 0 01-2.108-1.218l-1.394.522a1 1 0 01-1.217-.436l-.653-1.131a1 1 0 01.23-1.272l1.149-.946a6.026 6.026 0 010-2.435l-1.148-.944a1 1 0 01-.23-1.272l.653-1.131a1 1 0 011.217-.437l1.393.522a5.994 5.994 0 012.108-1.218l.244-1.466zM14.929 12a3 3 0 11-6 0 3 3 0 016 0z",
          clipRule: "evenodd"
        })),
            nt = ot,
            lt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M19.867 12c0-.568-.059-1.122-.17-1.656L21.5 8.732l-1.967-3.464-2.283.786a7.813 7.813 0 00-2.813-1.657L13.967 2h-3.934l-.472 2.396a7.813 7.813 0 00-2.81 1.657l-2.284-.785L2.5 8.732l1.804 1.612a8.054 8.054 0 000 3.312L2.5 15.268l1.967 3.464 2.283-.786a7.813 7.813 0 002.813 1.657l.47 2.397h3.934l.472-2.396a7.83 7.83 0 002.81-1.657l2.284.786 1.967-3.464-1.804-1.613c.111-.535.171-1.09.171-1.657V12zM12 16c-2.173 0-3.934-1.79-3.934-4S9.826 8 12 8c2.173 0 3.934 1.79 3.934 4s-1.76 4-3.934 4z"
        })),
            it = lt,
            st = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.2 10.9c-.5-1-1.2-2.1-2.1-3.2-.6-.9-1.3-1.7-2.1-2.6L12 4l-1 1.1c-.6.9-1.3 1.7-2 2.6-.8 1.2-1.5 2.3-2 3.2-.6 1.2-1 2.2-1 3 0 3.4 2.7 6.1 6.1 6.1s6.1-2.7 6.1-6.1c0-.8-.3-1.8-1-3zm-5.1 7.6c-2.5 0-4.6-2.1-4.6-4.6 0-.3.1-1 .8-2.3.5-.9 1.1-1.9 2-3.1.7-.9 1.3-1.7 1.8-2.3.7.8 1.3 1.6 1.8 2.3.8 1.1 1.5 2.2 2 3.1.7 1.3.8 2 .8 2.3 0 2.5-2.1 4.6-4.6 4.6z"
        })),
            ct = st,
            ut = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM6 17.5c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h3v10H6zm13.5-.5c0 .3-.2.5-.5.5h-3v-10h3c.3 0 .5.2.5.5v9z"
        })),
            dt = ut,
            mt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4.1 1.5v10H10v-10h4.9zM5.5 17V8c0-.3.2-.5.5-.5h2.5v10H6c-.3 0-.5-.2-.5-.5zm14 0c0 .3-.2.5-.5.5h-2.6v-10H19c.3 0 .5.2.5.5v9z"
        })),
            pt = mt,
            gt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z"
        })),
            vt = gt,
            ht = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.25 16.4371C6.16445 15.2755 5.5 13.7153 5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 13.7153 17.8356 15.2755 16.75 16.4371V16C16.75 14.4812 15.5188 13.25 14 13.25L10 13.25C8.48122 13.25 7.25 14.4812 7.25 16V16.4371ZM8.75 17.6304C9.70606 18.1835 10.8161 18.5 12 18.5C13.1839 18.5 14.2939 18.1835 15.25 17.6304V16C15.25 15.3096 14.6904 14.75 14 14.75L10 14.75C9.30964 14.75 8.75 15.3096 8.75 16V17.6304ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "black"
        })),
            bt = ht,
            _t = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "#FFFFFF"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, m.createElement)(_.Path, {
          d: "M15 15V15C15 13.8954 14.1046 13 13 13L11 13C9.89543 13 9 13.8954 9 15V15",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, m.createElement)(_.Circle, {
          cx: "12",
          cy: "9",
          r: "2",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            ft = _t,
            yt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.68822 16.625L5.5 17.8145L5.5 5.5L18.5 5.5L18.5 16.625L6.68822 16.625ZM7.31 18.125L19 18.125C19.5523 18.125 20 17.6773 20 17.125L20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19.5247C4 19.8173 4.16123 20.086 4.41935 20.2237C4.72711 20.3878 5.10601 20.3313 5.35252 20.0845L7.31 18.125ZM16 9.99997H8V8.49997H16V9.99997ZM8 14H13V12.5H8V14Z"
        })),
            kt = yt,
            Et = (0, m.createElement)(_.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6.68822 10.625L6.24878 11.0649L5.5 11.8145L5.5 5.5L12.5 5.5V8L14 6.5V5C14 4.44772 13.5523 4 13 4H5C4.44772 4 4 4.44771 4 5V13.5247C4 13.8173 4.16123 14.086 4.41935 14.2237C4.72711 14.3878 5.10601 14.3313 5.35252 14.0845L7.31 12.125H8.375L9.875 10.625H7.31H6.68822ZM14.5605 10.4983L11.6701 13.75H16.9975C17.9963 13.75 18.7796 14.1104 19.3553 14.7048C19.9095 15.2771 20.2299 16.0224 20.4224 16.7443C20.7645 18.0276 20.7543 19.4618 20.7487 20.2544C20.7481 20.345 20.7475 20.4272 20.7475 20.4999L19.2475 20.5001C19.2475 20.4191 19.248 20.3319 19.2484 20.2394V20.2394C19.2526 19.4274 19.259 18.2035 18.973 17.1307C18.8156 16.5401 18.586 16.0666 18.2778 15.7483C17.9909 15.4521 17.5991 15.25 16.9975 15.25H11.8106L14.5303 17.9697L13.4696 19.0303L8.96956 14.5303L13.4394 9.50171L14.5605 10.4983Z"
        })),
            wt = Et,
            Ct = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h6.2v8.9l2.5-3.1 2.5 3.1V4.5h2.2c.4 0 .8.4.8.8v13.4z"
        })),
            xt = Ct,
            St = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16 11.2h-3.2V8h-1.6v3.2H8v1.6h3.2V16h1.6v-3.2H16z"
        })),
            Pt = St,
            Tt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.5 7.8v7H18v-7c0-1-.8-1.8-1.8-1.8h-7v1.5h7c.2 0 .3.1.3.3zm-8.7 8.7c-.1 0-.2-.1-.2-.2V2H6v4H2v1.5h4v8.8c0 1 .8 1.8 1.8 1.8h8.8v4H18v-4h4v-1.5H7.8z"
        })),
            Mt = Tt,
            Bt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm-1.338 4.877c-.314.22-.412.452-.412.623 0 .171.098.403.412.623.312.218.783.377 1.338.377.825 0 1.605.233 2.198.648.59.414 1.052 1.057 1.052 1.852 0 .795-.461 1.438-1.052 1.852-.41.286-.907.486-1.448.582v.316a.75.75 0 01-1.5 0v-.316a3.64 3.64 0 01-1.448-.582c-.59-.414-1.052-1.057-1.052-1.852a.75.75 0 011.5 0c0 .171.098.403.412.623.312.218.783.377 1.338.377s1.026-.159 1.338-.377c.314-.22.412-.452.412-.623 0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377-.825 0-1.605-.233-2.198-.648-.59-.414-1.052-1.057-1.052-1.852 0-.795.461-1.438 1.052-1.852a3.64 3.64 0 011.448-.582V7.5a.75.75 0 011.5 0v.316c.54.096 1.039.296 1.448.582.59.414 1.052 1.057 1.052 1.852a.75.75 0 01-1.5 0c0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377s-1.026.159-1.338.377z"
        })),
            It = Bt,
            Nt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM4.75 12a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0zm9.195 1.944a2.75 2.75 0 01-4.066-.194h.621a.75.75 0 000-1.5H9.262a2.767 2.767 0 010-.5H11.5a.75.75 0 000-1.5H9.88a2.75 2.75 0 014.066-.194.75.75 0 001.06-1.061 4.25 4.25 0 00-6.88 1.255H7.5a.75.75 0 000 1.5h.258c-.01.166-.01.334 0 .5H7.5a.75.75 0 000 1.5h.626a4.25 4.25 0 006.88 1.255.75.75 0 00-1.06-1.06z"
        })),
            zt = Nt,
            Lt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm.25 4c-.787 0-1.425.638-1.425 1.425 0 .058.014.147.069.3.04.113.088.223.147.36a26.094 26.094 0 01.173.415H12.5a.75.75 0 010 1.5h-.953c.002.047.003.095.003.144 0 .617-.236 1.168-.511 1.606h3.386a.75.75 0 010 1.5H9.35a.75.75 0 01-.452-1.349l.007-.005a4.417 4.417 0 00.596-.581c.328-.39.549-.806.549-1.171 0-.05-.002-.097-.004-.144H9.5a.75.75 0 010-1.5h.088a5.875 5.875 0 01-.106-.27 2.382 2.382 0 01-.157-.805 2.925 2.925 0 015.637-1.097.75.75 0 01-1.39.563 1.426 1.426 0 00-1.322-.891zm-3.35 5.9l.45.6-.45-.6z"
        })),
            Vt = Lt,
            At = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h9v-1.5H4V20zm0-5.5V16h16v-1.5H4zm.8-4l.7.7 2-2V12h1V9.2l2 2 .7-.7-2-2H12v-1H9.2l2-2-.7-.7-2 2V4h-1v2.8l-2-2-.7.7 2 2H4v1h2.8l-2 2z"
        })),
            Rt = At,
            Ht = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.5 16h-.7V8c0-1.1-.9-2-2-2H6.2c-1.1 0-2 .9-2 2v8h-.7c-.8 0-1.5.7-1.5 1.5h20c0-.8-.7-1.5-1.5-1.5zM5.7 8c0-.3.2-.5.5-.5h11.6c.3 0 .5.2.5.5v7.6H5.7V8z"
        })),
            Ot = Ht,
            Dt = (0, m.createElement)(_.SVG, {
          width: "18",
          height: "18",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 18 18"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4h2V2H5v2zm6-2v2h2V2h-2zm-6 8h2V8H5v2zm6 0h2V8h-2v2zm-6 6h2v-2H5v2zm6 0h2v-2h-2v2z"
        })),
            Ft = Dt,
            jt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 11.3l-1-1.1-4 4V3h-1.5v11.3L7 10.2l-1 1.1 6.2 5.8 5.8-5.8zm.5 3.7v3.5h-13V15H4v5h16v-5h-1.5z"
        })),
            Gt = jt,
            qt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.1 5.1L16.9 2 6.2 12.7l-1.3 4.4 4.5-1.3L20.1 5.1zM4 20.8h8v-1.5H4v1.5z"
        })),
            Wt = qt,
            Ut = Wt,
            $t = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.2 17c0 .7-.6 1.2-1.2 1.2H7c-.7 0-1.2-.6-1.2-1.2V7c0-.7.6-1.2 1.2-1.2h3.2V4.2H7C5.5 4.2 4.2 5.5 4.2 7v10c0 1.5 1.2 2.8 2.8 2.8h10c1.5 0 2.8-1.2 2.8-2.8v-3.6h-1.5V17zM14.9 3v1.5h3.7l-6.4 6.4 1.1 1.1 6.4-6.4v3.7h1.5V3h-6.3z"
        })),
            Zt = $t,
            Kt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5z"
        })),
            Qt = Kt,
            Yt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 6v12c0 1.1.9 2 2 2h3v-1.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h3V4H6c-1.1 0-2 .9-2 2zm7.2 16h1.5V2h-1.5v20zM15 5.5h1.5V4H15v1.5zm3.5.5H20c0-1.1-.9-2-2-2v1.5c.3 0 .5.2.5.5zm0 10.5H20v-2h-1.5v2zm0-3.5H20v-2h-1.5v2zm-.5 5.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zM15 20h1.5v-1.5H15V20zm3.5-10.5H20v-2h-1.5v2z"
        })),
            Xt = Yt,
            Jt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 11.2v1.5h20v-1.5H2zM5.5 6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v3H20V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3h1.5V6zm2 14h2v-1.5h-2V20zm3.5 0h2v-1.5h-2V20zm7-1.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zm.5-2H20V15h-1.5v1.5zM5.5 18H4c0 1.1.9 2 2 2v-1.5c-.3 0-.5-.2-.5-.5zm0-3H4v1.5h1.5V15zm9 5h2v-1.5h-2V20z"
        })),
            er = Jt,
            tr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.7 11.3c1-.6 1.5-1.6 1.5-3 0-2.3-1.3-3.4-4-3.4H7v14h5.8c1.4 0 2.5-.3 3.3-1 .8-.7 1.2-1.7 1.2-2.9.1-1.9-.8-3.1-2.6-3.7zm-5.1-4h2.3c.6 0 1.1.1 1.4.4.3.3.5.7.5 1.2s-.2 1-.5 1.2c-.3.3-.8.4-1.4.4H9.6V7.3zm4.6 9c-.4.3-1 .4-1.7.4H9.6v-3.9h2.9c.7 0 1.3.2 1.7.5.4.3.6.8.6 1.5s-.2 1.2-.6 1.5z"
        })),
            rr = tr,
            ar = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.1 6.8L3.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H7.1zm-.8 6.8L8 8.9l1.7 4.7H6.3zm14.5-1.5c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2 .1.8-.2 1.4-.6 2z"
        })),
            or = ar,
            nr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-8-3.5l3 3-3 3 1 1 4-4-4-4-1 1z"
        })),
            lr = nr,
            ir = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM20.0303 9.03033L17.0607 12L20.0303 14.9697L18.9697 16.0303L15.4697 12.5303L14.9393 12L15.4697 11.4697L18.9697 7.96967L20.0303 9.03033Z"
        })),
            sr = ir,
            cr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 5L10 19h1.9l2.5-14z"
        })),
            ur = cr,
            dr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM6 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        })),
            mr = dr,
            pr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 8.8h8.9V7.2H4v1.6zm0 7h8.9v-1.5H4v1.5zM18 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
        })),
            gr = pr,
            vr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM5 6.7V10h1V5.3L3.8 6l.4 1 .8-.3zm-.4 5.7c-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5h2.7v-1h-1c.3-.6.8-1.4.9-2.1.1-.3 0-.8-.2-1.1-.5-.6-1.3-.5-1.7-.4z"
        })),
            hr = vr,
            br = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.8 15.8h8.9v-1.5H3.8v1.5zm0-7h8.9V7.2H3.8v1.6zm14.7-2.1V10h1V5.3l-2.2.7.3 1 .9-.3zm1.2 6.1c-.5-.6-1.2-.5-1.7-.4-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5H20v-1h-.9c.3-.6.8-1.4.9-2.1 0-.3 0-.8-.3-1.1z"
        })),
            _r = br,
            fr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM14 14l5-4-5-4v8z"
        })),
            yr = fr,
            kr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 16.8c-.1-.1-.2-.3-.3-.5v-2.6c0-.9-.1-1.7-.3-2.2-.2-.5-.5-.9-.9-1.2-.4-.2-.9-.3-1.6-.3-.5 0-1 .1-1.5.2s-.9.3-1.2.6l.2 1.2c.4-.3.7-.4 1.1-.5.3-.1.7-.2 1-.2.6 0 1 .1 1.3.4.3.2.4.7.4 1.4-1.2 0-2.3.2-3.3.7s-1.4 1.1-1.4 2.1c0 .7.2 1.2.7 1.6.4.4 1 .6 1.8.6.9 0 1.7-.4 2.4-1.2.1.3.2.5.4.7.1.2.3.3.6.4.3.1.6.1 1.1.1h.1l.2-1.2h-.1c-.4.1-.6 0-.7-.1zM9.2 16c-.2.3-.5.6-.9.8-.3.1-.7.2-1.1.2-.4 0-.7-.1-.9-.3-.2-.2-.3-.5-.3-.9 0-.6.2-1 .7-1.3.5-.3 1.3-.4 2.5-.5v2zm10.6-3.9c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2s-.2 1.4-.6 2z"
        })),
            Er = kr,
            wr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-4-4.6l-4 4 4 4 1-1-3-3 3-3-1-1z"
        })),
            Cr = wr,
            xr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM15.4697 14.9697L18.4393 12L15.4697 9.03033L16.5303 7.96967L20.0303 11.4697L20.5607 12L20.0303 12.5303L16.5303 16.0303L15.4697 14.9697Z"
        })),
            Sr = xr,
            Pr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6zM5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6z"
        })),
            Tr = Pr,
            Mr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9.1 9v-.5c0-.6.2-1.1.7-1.4.5-.3 1.2-.5 2-.5.7 0 1.4.1 2.1.3.7.2 1.4.5 2.1.9l.2-1.9c-.6-.3-1.2-.5-1.9-.7-.8-.1-1.6-.2-2.4-.2-1.5 0-2.7.3-3.6 1-.8.7-1.2 1.5-1.2 2.6V9h2zM20 12H4v1h8.3c.3.1.6.2.8.3.5.2.9.5 1.1.8.3.3.4.7.4 1.2 0 .7-.2 1.1-.8 1.5-.5.3-1.2.5-2.1.5-.8 0-1.6-.1-2.4-.3-.8-.2-1.5-.5-2.2-.8L7 18.1c.5.2 1.2.4 2 .6.8.2 1.6.3 2.4.3 1.7 0 3-.3 3.9-1 .9-.7 1.3-1.6 1.3-2.8 0-.9-.2-1.7-.7-2.2H20v-1z"
        })),
            Br = Mr,
            Ir = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 18v1h10v-1H7zm5-2c1.5 0 2.6-.4 3.4-1.2.8-.8 1.1-2 1.1-3.5V5H15v5.8c0 1.2-.2 2.1-.6 2.8-.4.7-1.2 1-2.4 1s-2-.3-2.4-1c-.4-.7-.6-1.6-.6-2.8V5H7.5v6.2c0 1.5.4 2.7 1.1 3.5.8.9 1.9 1.3 3.4 1.3z"
        })),
            Nr = Ir,
            zr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.1 6.8L2.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H6.1zm-.8 6.8L7 8.9l1.7 4.7H5.3zm15.1-.7c-.4-.5-.9-.8-1.6-1 .4-.2.7-.5.8-.9.2-.4.3-.9.3-1.4 0-.9-.3-1.6-.8-2-.6-.5-1.3-.7-2.4-.7h-3.5V18h4.2c1.1 0 2-.3 2.6-.8.6-.6 1-1.4 1-2.4-.1-.8-.3-1.4-.6-1.9zm-5.7-4.7h1.8c.6 0 1.1.1 1.4.4.3.2.5.7.5 1.3 0 .6-.2 1.1-.5 1.3-.3.2-.8.4-1.4.4h-1.8V8.2zm4 8c-.4.3-.9.5-1.5.5h-2.6v-3.8h2.6c1.4 0 2 .6 2 1.9.1.6-.1 1-.5 1.4z"
        })),
            Lr = zr,
            Vr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4.2 9h1.5V5.8H9V4.2H4.2V9zm14 9.2H15v1.5h4.8V15h-1.5v3.2zM15 4.2v1.5h3.2V9h1.5V4.2H15zM5.8 15H4.2v4.8H9v-1.5H5.8V15z"
        })),
            Ar = Vr,
            Rr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8h-1.5zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zM4.5 4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1V12l-2.3-1.7c-.3-.2-.6-.2-.9 0l-2.9 2.1L8 11.3c-.2-.1-.5-.1-.7 0l-2.9 1.5V4.6zm0 11.8v-1.8l3.2-1.7 2.4 1.2c.2.1.5.1.8-.1l2.8-2 2.8 2v2.5c0 .1-.1.1-.1.1H4.6c0-.1-.1-.2-.1-.2z"
        })),
            Hr = Rr,
            Or = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.3c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8s-4-8.8-8.8-8.8zm6.5 5.5h-2.6C15.4 7.3 14.8 6 14 5c2 .6 3.6 2 4.5 3.8zm.7 3.2c0 .6-.1 1.2-.2 1.8h-2.9c.1-.6.1-1.2.1-1.8s-.1-1.2-.1-1.8H19c.2.6.2 1.2.2 1.8zM12 18.7c-1-.7-1.8-1.9-2.3-3.5h4.6c-.5 1.6-1.3 2.9-2.3 3.5zm-2.6-4.9c-.1-.6-.1-1.1-.1-1.8 0-.6.1-1.2.1-1.8h5.2c.1.6.1 1.1.1 1.8s-.1 1.2-.1 1.8H9.4zM4.8 12c0-.6.1-1.2.2-1.8h2.9c-.1.6-.1 1.2-.1 1.8 0 .6.1 1.2.1 1.8H5c-.2-.6-.2-1.2-.2-1.8zM12 5.3c1 .7 1.8 1.9 2.3 3.5H9.7c.5-1.6 1.3-2.9 2.3-3.5zM10 5c-.8 1-1.4 2.3-1.8 3.8H5.5C6.4 7 8 5.6 10 5zM5.5 15.3h2.6c.4 1.5 1 2.8 1.8 3.7-1.8-.6-3.5-2-4.4-3.7zM14 19c.8-1 1.4-2.2 1.8-3.7h2.6C17.6 17 16 18.4 14 19z"
        })),
            Dr = Or,
            Fr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7.8 16.5H5c-.3 0-.5-.2-.5-.5v-6.2h6.8v6.7zm0-8.3H4.5V5c0-.3.2-.5.5-.5h6.2v6.7zm8.3 7.8c0 .3-.2.5-.5.5h-6.2v-6.8h6.8V19zm0-7.8h-6.8V4.5H19c.3 0 .5.2.5.5v6.2z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            jr = Fr,
            Gr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v3H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-3h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-4.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h3V13c0 1.1.9 2 2 2h2.5v3zm0-4.5H11c-.3 0-.5-.2-.5-.5v-2.5H13c.3 0 .5.2.5.5v2.5zm5-.5c0 .3-.2.5-.5.5h-3V11c0-1.1-.9-2-2-2h-2.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7z"
        })),
            qr = Gr,
            Wr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M7 16.5h10V15H7v1.5zm0-9V9h10V7.5H7z"
        })),
            Ur = Wr,
            $r = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.2 5.2v13.4l5.8-4.8 5.8 4.8V5.2z"
        })),
            Zr = $r,
            Kr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zM3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 8.75a1.5 1.5 0 01.167 2.99c-.465.052-.917.44-.917 1.01V14h1.5v-.845A3 3 0 109 10.25h1.5a1.5 1.5 0 011.5-1.5zM11.25 15v1.5h1.5V15h-1.5z"
        })),
            Qr = Kr,
            Yr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 16v-2h2v2h-2zm2-3v-1.141A3.991 3.991 0 0016 10a4 4 0 00-8 0h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 00-1 1v2h2z"
        })),
            Xr = Yr,
            Jr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6 5.5h12a.5.5 0 01.5.5v7H14a2 2 0 11-4 0H5.5V6a.5.5 0 01.5-.5zm-.5 9V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-3.5h-3.337a3.5 3.5 0 01-6.326 0H5.5zM4 13V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-5z",
          clipRule: "evenodd"
        })),
            ea = Jr,
            ta = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M18.646 9H20V8l-1-.5L12 4 5 7.5 4 8v1h14.646zm-3-1.5L12 5.677 8.354 7.5h7.292zm-7.897 9.44v-6.5h-1.5v6.5h1.5zm5-6.5v6.5h-1.5v-6.5h1.5zm5 0v6.5h-1.5v-6.5h1.5zm2.252 8.81c0 .414-.334.75-.748.75H4.752a.75.75 0 010-1.5h14.5a.75.75 0 01.749.75z",
          clipRule: "evenodd"
        })),
            ra = ta,
            aa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4L4 7.9V20h16V7.9L12 4zm6.5 14.5H14V13h-4v5.5H5.5V8.8L12 5.7l6.5 3.1v9.7z"
        })),
            oa = aa,
            na = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4.8 11.4H2.1V9H1v6h1.1v-2.6h2.7V15h1.1V9H4.8v2.4zm1.9-1.3h1.7V15h1.1v-4.9h1.7V9H6.7v1.1zM16.2 9l-1.5 2.7L13.3 9h-.9l-.8 6h1.1l.5-4 1.5 2.8 1.5-2.8.5 4h1.1L17 9h-.8zm3.8 5V9h-1.1v6h3.6v-1H20z"
        })),
            la = na,
            ia = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v8.4l-3-2.9c-.3-.3-.8-.3-1 0L11.9 14 9 12c-.3-.2-.6-.2-.8 0l-3.6 2.6V5c-.1-.3.1-.5.4-.5zm14 15H5c-.3 0-.5-.2-.5-.5v-2.4l4.1-3 3 1.9c.3.2.7.2.9-.1L16 12l3.5 3.4V19c0 .3-.2.5-.5.5z"
        })),
            sa = ia,
            ca = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.2c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8 0-4.8-4-8.8-8.8-8.8zm0 16c-4 0-7.2-3.3-7.2-7.2C4.8 8 8 4.8 12 4.8s7.2 3.3 7.2 7.2c0 4-3.2 7.2-7.2 7.2zM11 17h2v-6h-2v6zm0-8h2V7h-2v2z"
        })),
            ua = ca,
            da = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 12h2v-2h2V8h-2V6H9v2H7v2h2v2zm1 4c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7zm0-12c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zM3 19h14v-2H3v2z"
        })),
            ma = da,
            pa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 8H9v2H7v2h2v2h2v-2h2v-2h-2V8zm-1-4c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zM3 1v2h14V1H3z"
        })),
            ga = pa,
            va = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 9v6h11V9H9zM4 20h1.5V4H4v16z"
        })),
            ha = va,
            ba = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 9h-7.2V4h-1.6v5H4v6h7.2v5h1.6v-5H20z"
        })),
            _a = ba,
            fa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z"
        })),
            ya = fa,
            ka = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 15h6V9H9v6zm-5 5h1.5V4H4v16zM18.5 4v16H20V4h-1.5z"
        })),
            Ea = ka,
            wa = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M9 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 16a4.002 4.002 0 003.8-2.75H15V16h2.5v-2.75H19v-2.5h-6.2A4.002 4.002 0 005 12a4 4 0 004 4z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Ca = wa,
            xa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18,0 L2,0 C0.9,0 0.01,0.9 0.01,2 L0,12 C0,13.1 0.9,14 2,14 L18,14 C19.1,14 20,13.1 20,12 L20,2 C20,0.9 19.1,0 18,0 Z M18,12 L2,12 L2,2 L18,2 L18,12 Z M9,3 L11,3 L11,5 L9,5 L9,3 Z M9,6 L11,6 L11,8 L9,8 L9,6 Z M6,3 L8,3 L8,5 L6,5 L6,3 Z M6,6 L8,6 L8,8 L6,8 L6,6 Z M3,6 L5,6 L5,8 L3,8 L3,6 Z M3,3 L5,3 L5,5 L3,5 L3,3 Z M6,9 L14,9 L14,11 L6,11 L6,9 Z M12,6 L14,6 L14,8 L12,8 L12,6 Z M12,3 L14,3 L14,5 L12,5 L12,3 Z M15,6 L17,6 L17,8 L15,8 L15,6 Z M15,3 L17,3 L17,5 L15,5 L15,3 Z M10,20 L14,16 L6,16 L10,20 Z"
        })),
            Sa = xa,
            Pa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.734 16.106l2.176-2.38-1.093-1.028-3.846 4.158 3.846 4.157 1.093-1.027-2.176-2.38h2.811c1.125 0 2.25.03 3.374 0 1.428-.001 3.362-.25 4.963-1.277 1.66-1.065 2.868-2.906 2.868-5.859 0-2.479-1.327-4.896-3.65-5.93-1.82-.813-3.044-.8-4.806-.788l-.567.002v1.5c.184 0 .368 0 .553-.002 1.82-.007 2.704-.014 4.21.657 1.854.827 2.76 2.657 2.76 4.561 0 2.472-.973 3.824-2.178 4.596-1.258.807-2.864 1.04-4.163 1.04h-.02c-1.115.03-2.229 0-3.344 0H6.734z"
        })),
            Ta = Pa,
            Ma = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            Ba = Ma,
            Ia = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M17.375 15.656A6.47 6.47 0 0018.5 12a6.47 6.47 0 00-.943-3.374l-1.262.813c.448.749.705 1.625.705 2.561a4.977 4.977 0 01-.887 2.844l1.262.813zm-1.951 1.87l-.813-1.261A4.976 4.976 0 0112 17c-.958 0-1.852-.27-2.613-.736l-.812 1.261A6.47 6.47 0 0012 18.5a6.47 6.47 0 003.424-.974zm-8.8-1.87A6.47 6.47 0 015.5 12c0-1.235.344-2.39.943-3.373l1.261.812A4.977 4.977 0 007 12c0 1.056.328 2.036.887 2.843l-1.262.813zm2.581-7.803A4.977 4.977 0 0112 7c1.035 0 1.996.314 2.794.853l.812-1.262A6.47 6.47 0 0012 5.5a6.47 6.47 0 00-3.607 1.092l.812 1.261zM12 20a8 8 0 100-16 8 8 0 000 16zm0-4.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
          clipRule: "evenodd"
        })),
            Na = Ia,
            za = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5 11.25h3v1.5H5v-1.5zm5.5 0h3v1.5h-3v-1.5zm8.5 0h-3v1.5h3v-1.5z",
          clipRule: "evenodd"
        })),
            La = za,
            Va = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5.25 11.25h1.5v1.5h-1.5v-1.5zm3 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5zm1.5 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5z",
          clipRule: "evenodd"
        })),
            Aa = Va,
            Ra = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          d: "M5 11.25h14v1.5H5z"
        })),
            Ha = Ra,
            Oa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 7.2H14v1.5h1.6c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.8 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2zM4.7 12.4c0-2 1.7-3.7 3.7-3.7H10V7.2H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H10v-1.5H8.4c-2 0-3.7-1.7-3.7-3.7zm4.6.9h5.3v-1.5H9.3v1.5z"
        })),
            Da = Oa,
            Fa = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 7.3h-.7l1.6-3.5-.9-.4-3.9 8.5H9v1.5h2l-1.3 2.8H8.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7H10V7.3H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H9l-1.4 3.2.9.4 5.7-12.5h1.4c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.4-5.2-5.2-5.2z"
        })),
            ja = Fa,
            Ga = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 4v1.5h16V4H4zm8 8.5h8V11h-8v1.5zM4 20h16v-1.5H4V20zm4-8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
        })),
            qa = Ga,
            Wa = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M13.8 5.2H3v1.5h10.8V5.2zm-3.6 12v1.5H21v-1.5H10.2zm7.2-6H6.6v1.5h10.8v-1.5z"
        })),
            Ua = Wa,
            $a = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M8 5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V9H18C19.2624 9 20 9.9804 20 11V19C20 20.0196 19.2624 21 18 21H6C4.73763 21 4 20.0196 4 19V11C4 9.9804 4.73763 9 6 9H8V5ZM9.5 9H14.5V5C14.5 4.17157 13.8284 3.5 13 3.5H11C10.1716 3.5 9.5 4.17157 9.5 5V9Z"
        })),
            Za = $a,
            Ka = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 14.5l1.1 1.1 3-3 .5-.5-.6-.6-3-3-1 1 1.7 1.7H5v1.5h7.7L11 14.5zM16.8 5h-7c-1.1 0-2 .9-2 2v1.5h1.5V7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1.5H7.8V17c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
        })),
            Qa = Ka,
            Ya = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18.1823 11.6392C18.1823 13.0804 17.0139 14.2487 15.5727 14.2487C14.3579 14.2487 13.335 13.4179 13.0453 12.2922L13.0377 12.2625L13.0278 12.2335L12.3985 10.377L12.3942 10.3785C11.8571 8.64997 10.246 7.39405 8.33961 7.39405C5.99509 7.39405 4.09448 9.29465 4.09448 11.6392C4.09448 13.9837 5.99509 15.8843 8.33961 15.8843C8.88499 15.8843 9.40822 15.781 9.88943 15.5923L9.29212 14.0697C8.99812 14.185 8.67729 14.2487 8.33961 14.2487C6.89838 14.2487 5.73003 13.0804 5.73003 11.6392C5.73003 10.1979 6.89838 9.02959 8.33961 9.02959C9.55444 9.02959 10.5773 9.86046 10.867 10.9862L10.8772 10.9836L11.4695 12.7311C11.9515 14.546 13.6048 15.8843 15.5727 15.8843C17.9172 15.8843 19.8178 13.9837 19.8178 11.6392C19.8178 9.29465 17.9172 7.39404 15.5727 7.39404C15.0287 7.39404 14.5066 7.4968 14.0264 7.6847L14.6223 9.20781C14.9158 9.093 15.2358 9.02959 15.5727 9.02959C17.0139 9.02959 18.1823 10.1979 18.1823 11.6392Z"
        })),
            Xa = Ya,
            Ja = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 9c-.8 0-1.5.7-1.5 1.5S11.2 12 12 12s1.5-.7 1.5-1.5S12.8 9 12 9zm0-5c-3.6 0-6.5 2.8-6.5 6.2 0 .8.3 1.8.9 3.1.5 1.1 1.2 2.3 2 3.6.7 1 3 3.8 3.2 3.9l.4.5.4-.5c.2-.2 2.6-2.9 3.2-3.9.8-1.2 1.5-2.5 2-3.6.6-1.3.9-2.3.9-3.1C18.5 6.8 15.6 4 12 4zm4.3 8.7c-.5 1-1.1 2.2-1.9 3.4-.5.7-1.7 2.2-2.4 3-.7-.8-1.9-2.3-2.4-3-.8-1.2-1.4-2.3-1.9-3.3-.6-1.4-.7-2.2-.7-2.5 0-2.6 2.2-4.7 5-4.7s5 2.1 5 4.7c0 .2-.1 1-.7 2.4z"
        })),
            eo = Ja,
            to = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            ro = to,
            ao = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3 18h8V6H3v12zM14 7.5V9h7V7.5h-7zm0 5.3h7v-1.5h-7v1.5zm0 3.7h7V15h-7v1.5z"
        })),
            oo = ao,
            no = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6.863 13.644L5 13.25h-.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5H5L18 6.5h2V16h-2l-3.854-.815.026.008a3.75 3.75 0 01-7.31-1.549zm1.477.313a2.251 2.251 0 004.356.921l-4.356-.921zm-2.84-3.28L18.157 8h.343v6.5h-.343L5.5 11.823v-1.146z",
          clipRule: "evenodd"
        })),
            lo = no,
            io = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 5v1.5h14V5H5zm0 7.8h14v-1.5H5v1.5zM5 19h14v-1.5H5V19z"
        })),
            so = io,
            co = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15 4H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v12zm-4.5-.5h2V16h-2v1.5z"
        })),
            uo = co,
            mo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 9v1.5h16V9H4zm12 5.5h4V13h-4v1.5zm-6 0h4V13h-4v1.5zm-6 0h4V13H4v1.5z"
        })),
            po = mo,
            go = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 13h2v-2h-2v2zm-6 0h2v-2H5v2zm12-2v2h2v-2h-2z"
        })),
            vo = go,
            ho = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M7.5 12C7.5 11.1716 6.82843 10.5 6 10.5C5.17157 10.5 4.5 11.1716 4.5 12C4.5 12.8284 5.17157 13.5 6 13.5C6.82843 13.5 7.5 12.8284 7.5 12Z"
        }), (0, m.createElement)(_.Path, {
          d: "M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z"
        }), (0, m.createElement)(_.Path, {
          d: "M19.5 12C19.5 11.1716 18.8284 10.5 18 10.5C17.1716 10.5 16.5 11.1716 16.5 12C16.5 12.8284 17.1716 13.5 18 13.5C18.8284 13.5 19.5 12.8284 19.5 12Z"
        })),
            bo = ho,
            _o = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 19h-2v-2h2v2zm0-6h-2v-2h2v2zm0-6h-2V5h2v2z"
        })),
            fo = _o,
            yo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19.75 9c0-1.257-.565-2.197-1.39-2.858-.797-.64-1.827-1.017-2.815-1.247-1.802-.42-3.703-.403-4.383-.396L11 4.5V6l.177-.001c.696-.006 2.416-.02 4.028.356.887.207 1.67.518 2.216.957.52.416.829.945.829 1.688 0 .592-.167.966-.407 1.23-.255.281-.656.508-1.236.674-1.19.34-2.82.346-4.607.346h-.077c-1.692 0-3.527 0-4.942.404-.732.209-1.424.545-1.935 1.108-.526.579-.796 1.33-.796 2.238 0 1.257.565 2.197 1.39 2.858.797.64 1.827 1.017 2.815 1.247 1.802.42 3.703.403 4.383.396L13 19.5h.714V22L18 18.5 13.714 15v3H13l-.177.001c-.696.006-2.416.02-4.028-.356-.887-.207-1.67-.518-2.216-.957-.52-.416-.829-.945-.829-1.688 0-.592.167-.966.407-1.23.255-.281.656-.508 1.237-.674 1.189-.34 2.819-.346 4.606-.346h.077c1.692 0 3.527 0 4.941-.404.732-.209 1.425-.545 1.936-1.108.526-.579.796-1.33.796-2.238z"
        })),
            ko = yo,
            Eo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.5c-3.6 0-6.5-2.9-6.5-6.5S8.4 5.5 12 5.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zM9 16l4.5-3L15 8.4l-4.5 3L9 16z"
        })),
            wo = Eo,
            Co = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12-9.8c.4 0 .8-.3.9-.7l1.1-3h3.6l.5 1.7h1.9L13 9h-2.2l-3.4 9.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12H20V6c0-1.1-.9-2-2-2zm-6 7l1.4 3.9h-2.7L12 11z"
        })),
            xo = Co,
            So = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.8 6c0-.7.6-1.2 1.2-1.2h6c.7 0 1.2.6 1.2 1.2v3h1.5V6c0-1.5-1.2-2.8-2.8-2.8H9C7.5 3.2 6.2 4.5 6.2 6v3h1.5V6zm8.4 11c0 .7-.6 1.2-1.2 1.2H9c-.7 0-1.2-.6-1.2-1.2v-3H6.2v3c0 1.5 1.2 2.8 2.8 2.8h6c1.5 0 2.8-1.2 2.8-2.8v-3h-1.5v3zM4 11v1h16v-1H4z"
        })),
            Po = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 14.5h-1V16h1c2.2 0 4-1.8 4-4s-1.8-4-4-4h-1v1.5h1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm-4 1.5v-1.5h-1C6.1 14.5 5 13.4 5 12s1.1-2.5 2.5-2.5h1V8h-1c-2.2 0-4 1.8-4 4s1.8 4 4 4h1zm-1-3.2h5v-1.5h-5v1.5zM18 4H9c-1.1 0-2 .9-2 2v.5h1.5V6c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5v-.5H7v.5c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
        })),
            To = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 5.5h10a.5.5 0 01.5.5v12a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM17 4H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2zm-1 3.75H8v1.5h8v-1.5zM8 11h8v1.5H8V11zm6 3.25H8v1.5h6v-1.5z"
        })),
            Mo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 13.8h6v-1.5H7v1.5zM18 16V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2zM5.5 16V4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5zM7 10.5h8V9H7v1.5zm0-3.3h8V5.8H7v1.4zM20.2 6v13c0 .7-.6 1.2-1.2 1.2H8v1.5h11c1.5 0 2.7-1.2 2.7-2.8V6h-1.5z"
        })),
            Bo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.3 4H9.9v-.1l-.9.2c-2.3.4-4 2.4-4 4.8s1.7 4.4 4 4.8l.7.1V20h1.5V5.5h2.9V20h1.5V5.5h2.7V4z"
        })),
            Io = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5.5 9.5v-2h13v2h-13zm0 3v4h13v-4h-13zM4 7a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7z",
          clipRule: "evenodd"
        })),
            No = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM8 5a3 3 0 100 6 3 3 0 000-6zm6.5 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1.5-3a3 3 0 100 6 3 3 0 000-6zM5.47 17.41a.75.75 0 001.06 1.06L18.47 6.53a.75.75 0 10-1.06-1.06L5.47 17.41z",
          clipRule: "evenodd"
        })),
            zo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 9v6h10V9H7zM5 19.8h14v-1.5H5v1.5zM5 4.3v1.5h14V4.3H5z"
        })),
            Lo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 9v6h14V9H4zm8-4.8H4v1.5h8V4.2zM4 19.8h8v-1.5H4v1.5z"
        })),
            Vo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6 15h14V9H6v6zm6-10.8v1.5h8V4.2h-8zm0 15.6h8v-1.5h-8v1.5z"
        })),
            Ao = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.5 9.5a1 1 0 100-2 1 1 0 000 2zm0 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-2.25 6v-2a2.75 2.75 0 00-2.75-2.75h-4A2.75 2.75 0 003.75 15v2h1.5v-2c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2h1.5zm7-2v2h-1.5v-2c0-.69-.56-1.25-1.25-1.25H15v-1.5h2.5A2.75 2.75 0 0120.25 15zM9.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
          fillRule: "evenodd"
        })),
            Ro = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.44 3.02l1.82-1.82 6.36 6.35-1.83 1.82c-1.05-.68-2.48-.57-3.41.36l-.75.75c-.92.93-1.04 2.35-.35 3.41l-1.83 1.82-2.41-2.41-2.8 2.79c-.42.42-3.38 2.71-3.8 2.29s1.86-3.39 2.28-3.81l2.79-2.79L4.1 9.36l1.83-1.82c1.05.69 2.48.57 3.4-.36l.75-.75c.93-.92 1.05-2.35.36-3.41z"
        })),
            Ho = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.5 4v4h3V4H15v4h1.5a1 1 0 011 1v4l-3 4v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2l-3-4V9a1 1 0 011-1H9V4h1.5zm.5 12.5v2h2v-2l3-4v-3H8v3l3 4z"
        })),
            Oo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 12C2 6.44444 6.44444 2 12 2C17.5556 2 22 6.44444 22 12C22 17.5556 17.5556 22 12 22C6.44444 22 2 17.5556 2 12ZM13 11V7H11V11H7V13H11V17H13V13H17V11H13Z"
        })),
            Do = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6zM10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"
        })),
            Fo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"
        })),
            jo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M10 4.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2.25 7.5v-1A2.75 2.75 0 0011 8.25H7A2.75 2.75 0 004.25 11v1h1.5v-1c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1h1.5zM4 20h9v-1.5H4V20zm16-4H4v-1.5h16V16z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Go = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20 4H4v1.5h16V4zm-2 9h-3c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3zM4 9.5h9V8H4v1.5zM9 13H6c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            qo = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h16v-1.5H4V20zm0-4.8h16v-1.5H4v1.5zm0-6.4v1.5h16V8.8H4zM16 4H4v1.5h12V4z"
        })),
            Wo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14 10.1V4c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1zm-1.5-.5H6.7l-1.2 1.2V4.5h7v5.1zM19 12h-8c-.6 0-1 .4-1 1v6.1c0 .6.4 1 1 1h5.7l1.8 1.8c.1.2.4.3.6.3.1 0 .2 0 .3-.1.4-.1.6-.5.6-.8V13c0-.6-.4-1-1-1zm-.5 7.8l-1.2-1.2h-5.8v-5.1h7v6.3z"
        })),
            Uo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-2.2 6.6H7l1.6-2.2c.3-.4.5-.7.6-.9.1-.2.2-.4.2-.5 0-.2-.1-.3-.1-.4-.1-.1-.2-.1-.4-.1s-.4 0-.6.1c-.3.1-.5.3-.7.4l-.2.2-.2-1.2.1-.1c.3-.2.5-.3.8-.4.3-.1.6-.1.9-.1.3 0 .6.1.9.2.2.1.4.3.6.5.1.2.2.5.2.7 0 .3-.1.6-.2.9-.1.3-.4.7-.7 1.1l-.5.6h1.6v1.2z"
        })),
            $o = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-.5 6.6H6.7l-1.2 1.2v-6.3h7v5.1z"
        })),
            Zo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.696 13.972c.356-.546.599-.958.728-1.235a1.79 1.79 0 00.203-.783c0-.264-.077-.47-.23-.618-.148-.153-.354-.23-.618-.23-.295 0-.569.07-.82.212a3.413 3.413 0 00-.738.571l-.147-1.188c.289-.234.59-.41.903-.526.313-.117.66-.175 1.041-.175.375 0 .695.08.959.24.264.153.46.362.59.626.135.265.203.556.203.876 0 .362-.08.734-.24 1.115-.154.381-.427.87-.82 1.466l-.756 1.152H14v1.106h-4l1.696-2.609z"
        }), (0, m.createElement)(_.Path, {
          d: "M19.5 7h-15v12a.5.5 0 00.5.5h14a.5.5 0 00.5-.5V7zM3 7V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
        })),
            Ko = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.75 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.395.395 0 00.199-.166c.05-.083.114-.253.114-.584V7.2H8.8V4h3.95v5.333zM7.95 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.394.394 0 00.198-.166c.05-.083.115-.253.115-.584V7.2H4V4h3.95v5.333zM13 20H4v-1.5h9V20zM20 16H4v-1.5h16V16z"
        })),
            Qo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-.6 0-1 .4-1 1v7c0 .5.4 1 1 1h14c.5 0 1-.4 1-1V4c0-.6-.4-1-1-1zM5.5 10.5v-.4l1.8-1.3 1.3.8c.3.2.7.2.9-.1L11 8.1l2.4 2.4H5.5zm13 0h-2.9l-4-4c-.3-.3-.8-.3-1.1 0L8.9 8l-1.2-.8c-.3-.2-.6-.2-.9 0l-1.3 1V4.5h13v6zM4 20h9v-1.5H4V20zm0-4h16v-1.5H4V16z"
        })),
            Yo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 11h2V9H7v2zm0 4h2v-2H7v2zm3-4h7V9h-7v2zm0 4h7v-2h-7v2z"
        })),
            Xo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 14.5h16V16H4zM4 18.5h9V20H4zM4 4h3c2 0 3 .86 3 2.583 0 .891-.253 1.554-.76 1.988-.505.435-1.24.652-2.204.652H5.542V12H4V4zm2.855 4c.53 0 .924-.114 1.18-.343.266-.228.398-.579.398-1.051 0-.473-.132-.82-.397-1.04-.265-.229-.67-.343-1.217-.343H5.542V8h1.313z"
        })),
            Jo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.6 7l-1.1-1L5 12l5.5 6 1.1-1L7 12l4.6-5zm6 0l-1.1-1-5.5 6 5.5 6 1.1-1-4.6-5 4.6-5z"
        })),
            en = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.6 6L5.4 7l4.5 5-4.5 5 1.1 1 5.5-6-5.4-6zm6 0l-1.1 1 4.5 5-4.5 5 1.1 1 5.5-6-5.5-6z"
        })),
            tn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 16.5h6V15H7v1.5zm4-4h6V11h-6v1.5zM9 11H7v1.5h2V11zm6 5.5h2V15h-2v1.5z"
        })),
            rn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 18h6V6H4v12zm9-9.5V10h7V8.5h-7zm0 7h7V14h-7v1.5z"
        })),
            an = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14 6v12h6V6h-6zM4 10h7V8.5H4V10zm0 5.5h7V14H4v1.5z"
        })),
            on = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 8H6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v4zM4 4v1.5h16V4H4zm0 16h16v-1.5H4V20z"
        })),
            nn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "12",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "17",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        })),
            ln = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "6",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "11",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M16.5 9.5L19 12l-2.5 2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            sn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M13.5 14v-4l-1.5.5",
          stroke: "#1E1E1E"
        }), (0, m.createElement)(_.Path, {
          d: "M19.266 9.805c-.473-.611-1.22-.51-1.702-.367a3.854 3.854 0 00-.718.307l.13 1.082c.192-.17.47-.422.782-.515.34-.1.578.025.668.141.21.27-.034.835-.16 1.055-.49.85-.93 1.594-1.45 2.492H19.5v-1h-.914c.277-.574.814-1.443.914-2.106.052-.343.02-.762-.234-1.09z",
          fill: "#1E1E1E"
        })),
            cn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "18",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 18 13.5)",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "13",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 13 13.5)",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M7.5 14.5L5 12l2.5-2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            un = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M13 6v6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H13zm-9 6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H4v6z"
        })),
            dn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M16.83 6.342l.602.3.625-.25.443-.176v12.569l-.443-.178-.625-.25-.603.301-1.444.723-2.41-.804-.475-.158-.474.158-2.41.803-1.445-.722-.603-.3-.625.25-.443.177V6.215l.443.178.625.25.603-.301 1.444-.722 2.41.803.475.158.474-.158 2.41-.803 1.445.722zM20 4l-1.5.6-1 .4-2-1-3 1-3-1-2 1-1-.4L5 4v17l1.5-.6 1-.4 2 1 3-1 3 1 2-1 1 .4 1.5.6V4zm-3.5 6.25v-1.5h-8v1.5h8zm0 3v-1.5h-8v1.5h8zm-8 3v-1.5h8v1.5h-8z",
          clipRule: "evenodd"
        })),
            mn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 6.5l-1.1 1 2.9 3.3H8c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.3-.5h9.2L14.5 15l1.1 1.1 4.6-4.6-4.6-5z"
        })),
            pn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M8.45474 21.2069L16.4547 3.7069L15.5453 3.29114L14.2837 6.05081C13.5991 5.69873 12.8228 5.49999 12 5.49999C10.9385 5.49999 9.95431 5.83076 9.1448 6.39485L7.18994 4.44L6.12928 5.50066L8.05556 7.42694C7.49044 8.15127 7.12047 9.0353 7.02469 9.99999H5V11.5H7V13H5V14.5H7.10002C7.35089 15.7359 8.0576 16.8062 9.03703 17.5279L7.54526 20.7911L8.45474 21.2069ZM9.68024 16.1209C8.95633 15.4796 8.5 14.5431 8.5 13.5V10.5C8.5 8.567 10.067 6.99999 12 6.99999C12.6003 6.99999 13.1653 7.15111 13.659 7.41738L9.68024 16.1209ZM15.3555 9.50155L16.1645 7.73191C16.6053 8.39383 16.8926 9.16683 16.9753 9.99999H19V11.5H17V13H19V14.5H16.9C16.4367 16.7822 14.419 18.5 12 18.5C11.7508 18.5 11.5058 18.4818 11.2664 18.4466L11.928 16.9993C11.9519 16.9998 11.9759 17 12 17C13.933 17 15.5 15.433 15.5 13.5V10.5C15.5 10.1531 15.4495 9.81794 15.3555 9.50155Z"
        })),
            gn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16 10h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm-8 4H4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm10-2.6L14.5 15l1.1 1.1 1.7-1.7c-.1 1.1-.3 2.3-.9 2.9-.3.3-.7.5-1.3.5h-4.5v1.5H15c.9 0 1.7-.3 2.3-.9 1-1 1.3-2.7 1.4-4l1.8 1.8 1.1-1.1-3.6-3.7zM6.8 9.7c.1-1.1.3-2.3.9-2.9.4-.4.8-.6 1.3-.6h4.5V4.8H9c-.9 0-1.7.3-2.3.9-1 1-1.3 2.7-1.4 4L3.5 8l-1 1L6 12.6 9.5 9l-1-1-1.7 1.7z"
        })),
            vn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 11.5h10V13H7z"
        })),
            hn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 4.2v1.6h4.7L5.8 17.2V12H4.2v7.8H12v-1.6H6.8L18.2 6.8v4.7h1.6V4.2z"
        })),
            bn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 7.2h8.2L13.5 9l1.1 1.1 3.6-3.6-3.5-4-1.1 1 1.9 2.3H7c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.2-.5zm13.8 4V11h-1.5v.3c0 1.1 0 3.5-1 4.5-.3.3-.7.5-1.3.5H8.8l1.7-1.7-1.1-1.1L5.9 17l3.5 4 1.1-1-1.9-2.3H17c.9 0 1.7-.3 2.3-.9 1.5-1.4 1.5-4.2 1.5-5.6z"
        })),
            _n = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-1 1.4l-5.6 5.6c-.1.1-.3.1-.4 0l-5.6-5.6c-.1-.1-.1-.3 0-.4l5.6-5.6s.1-.1.2-.1.1 0 .2.1l5.6 5.6c.1.1.1.3 0 .4zm-16.6-.4L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            fn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4V2.2L9 4.8l3 2.5V5.5c3.6 0 6.5 2.9 6.5 6.5 0 2.9-1.9 5.3-4.5 6.2v.2l-.1-.2c-.4.1-.7.2-1.1.2l.2 1.5c.3 0 .6-.1 1-.2 3.5-.9 6-4 6-7.7 0-4.4-3.6-8-8-8zm-7.9 7l1.5.2c.1-1.2.5-2.3 1.2-3.2l-1.1-.9C4.8 8.2 4.3 9.6 4.1 11zm1.5 1.8l-1.5.2c.1.7.3 1.4.5 2 .3.7.6 1.3 1 1.8l1.2-.8c-.3-.5-.6-1-.8-1.5s-.4-1.1-.4-1.7zm1.5 5.5c1.1.9 2.4 1.4 3.8 1.6l.2-1.5c-1.1-.1-2.2-.5-3.1-1.2l-.9 1.1z"
        })),
            yn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.1 4.8l-3-2.5V4c-4.4 0-8 3.6-8 8 0 3.7 2.5 6.9 6 7.7.3.1.6.1 1 .2l.2-1.5c-.4 0-.7-.1-1.1-.2l-.1.2v-.2c-2.6-.8-4.5-3.3-4.5-6.2 0-3.6 2.9-6.5 6.5-6.5v1.8l3-2.5zM20 11c-.2-1.4-.7-2.7-1.6-3.8l-1.2.8c.7.9 1.1 2 1.3 3.1L20 11zm-1.5 1.8c-.1.5-.2 1.1-.4 1.6s-.5 1-.8 1.5l1.2.9c.4-.5.8-1.1 1-1.8s.5-1.3.5-2l-1.5-.2zm-5.6 5.6l.2 1.5c1.4-.2 2.7-.7 3.8-1.6l-.9-1.1c-.9.7-2 1.1-3.1 1.2z"
        })),
            kn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 10.2h-.8v1.5H5c1.9 0 3.8.8 5.1 2.1 1.4 1.4 2.1 3.2 2.1 5.1v.8h1.5V19c0-2.3-.9-4.5-2.6-6.2-1.6-1.6-3.8-2.6-6.1-2.6zm10.4-1.6C12.6 5.8 8.9 4.2 5 4.2h-.8v1.5H5c3.5 0 6.9 1.4 9.4 3.9s3.9 5.8 3.9 9.4v.8h1.5V19c0-3.9-1.6-7.6-4.4-10.4zM4 20h3v-3H4v3z"
        })),
            En = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13.5 6C10.5 6 8 8.5 8 11.5c0 1.1.3 2.1.9 3l-3.4 3 1 1.1 3.4-2.9c1 .9 2.2 1.4 3.6 1.4 3 0 5.5-2.5 5.5-5.5C19 8.5 16.5 6 13.5 6zm0 9.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
        })),
            wn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 7v4H3.8V7H2.2v9h1.6v-3.5h16.4V16h1.6V7z"
        })),
            Cn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.5 13.8c-1.1 0-2.1.7-2.4 1.8H4V17h8.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20v-1.5h-3.1c-.3-1-1.3-1.7-2.4-1.7zM11.9 7c-.3-1-1.3-1.8-2.4-1.8S7.4 6 7.1 7H4v1.5h3.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20V7h-8.1z"
        })),
            xn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M9 11.8l6.1-4.5c.1.4.4.7.9.7h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v.4l-6.4 4.8c-.2-.1-.4-.2-.6-.2H6c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.2 0 .4-.1.6-.2l6.4 4.8v.4c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-2c-.5 0-.8.3-.9.7L9 12.2v-.4z"
        })),
            Sn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.176l6.75 3.068v4.574c0 3.9-2.504 7.59-6.035 8.755a2.283 2.283 0 01-1.43 0c-3.53-1.164-6.035-4.856-6.035-8.755V6.244L12 3.176zM6.75 7.21v3.608c0 3.313 2.145 6.388 5.005 7.33.159.053.331.053.49 0 2.86-.942 5.005-4.017 5.005-7.33V7.21L12 4.824 6.75 7.21z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Pn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M16 4.2v1.5h2.5v12.5H16v1.5h4V4.2h-4zM4.2 19.8h4v-1.5H5.8V5.8h2.5V4.2h-4l-.1 15.6zm5.1-3.1l1.4.6 4-10-1.4-.6-4 10z"
        })),
            Tn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 1.5c4.1 0 7.5 3.4 7.5 7.5v.1c-1.4-.8-3.3-1.7-3.4-1.8-.2-.1-.5-.1-.8.1l-2.9 2.1L9 11.3c-.2-.1-.4 0-.6.1l-3.7 2.2c-.1-.5-.2-1-.2-1.5 0-4.2 3.4-7.6 7.5-7.6zm0 15c-3.1 0-5.7-1.9-6.9-4.5l3.7-2.2 3.5 1.2c.2.1.5 0 .7-.1l2.9-2.1c.8.4 2.5 1.2 3.5 1.9-.9 3.3-3.9 5.8-7.4 5.8z"
        })),
            Mn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M10 11c-1.588-.479-4-.91-4-.91s2-.241 4-.454c1.8-.191 3.365-.502 4-3.181C14.635 3.775 15 1 15 1s.365 2.775 1 5.455c.635 2.679 2 2.969 4 3.181 2 .213 4 .455 4 .455s-2.412.43-4 .909c-1.588.479-3 1-4 4.546-.746 2.643-.893 4.948-1 5.454-.107-.506-.167-2.5-1-5.454C13 12 11.588 11.479 10 11zM7.333 3.5C6.803 3.333 6 3.182 6 3.182s.667-.085 1.333-.16c.6-.066 1.122-.175 1.334-1.113C8.878.971 9 0 9 0s.122.971.333 1.91c.212.937.667 1.038 1.334 1.113.666.074 1.333.159 1.333.159s-.804.15-1.333.318c-.53.167-1 .35-1.334 1.59C9.085 6.017 9.036 6.824 9 7c-.036-.177-.056-.875-.333-1.91-.334-1.24-.804-1.423-1.334-1.59zM2.444 18C1.474 17.713 0 17.454 0 17.454s1.222-.145 2.444-.272c1.1-.115 2.057-.302 2.445-1.91C5.277 13.666 5.5 12 5.5 12s.223 1.665.611 3.273c.388 1.607 1.222 1.781 2.445 1.909 1.222.127 2.444.273 2.444.273s-1.474.258-2.444.545c-.971.287-1.834.6-2.445 2.727-.456 1.586-.546 2.97-.611 3.273-.065-.304-.102-1.5-.611-3.273C4.278 18.6 3.415 18.287 2.444 18z",
          fill: "#F0C930"
        })),
            Bn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zm-13.5 0V4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1v11.8c0 .1-.1.1-.1.1H4.6l-.1-.1z"
        })),
            In = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M9.706 8.646a.25.25 0 01-.188.137l-4.626.672a.25.25 0 00-.139.427l3.348 3.262a.25.25 0 01.072.222l-.79 4.607a.25.25 0 00.362.264l4.138-2.176a.25.25 0 01.233 0l4.137 2.175a.25.25 0 00.363-.263l-.79-4.607a.25.25 0 01.072-.222l3.347-3.262a.25.25 0 00-.139-.427l-4.626-.672a.25.25 0 01-.188-.137l-2.069-4.192a.25.25 0 00-.448 0L9.706 8.646zM12 7.39l-.948 1.921a1.75 1.75 0 01-1.317.957l-2.12.308 1.534 1.495c.412.402.6.982.503 1.55l-.362 2.11 1.896-.997a1.75 1.75 0 011.629 0l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39z",
          clipRule: "evenodd"
        })),
            Nn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.776 4.454a.25.25 0 01.448 0l2.069 4.192a.25.25 0 00.188.137l4.626.672a.25.25 0 01.139.426l-3.348 3.263a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.362.263l-4.138-2.175a.25.25 0 00-.232 0l-4.138 2.175a.25.25 0 01-.363-.263l.79-4.607a.25.25 0 00-.071-.222L4.754 9.881a.25.25 0 01.139-.426l4.626-.672a.25.25 0 00.188-.137l2.069-4.192z"
        })),
            zn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9.518 8.783a.25.25 0 00.188-.137l2.069-4.192a.25.25 0 01.448 0l2.07 4.192a.25.25 0 00.187.137l4.626.672a.25.25 0 01.139.427l-3.347 3.262a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.363.264l-4.137-2.176a.25.25 0 00-.233 0l-4.138 2.175a.25.25 0 01-.362-.263l.79-4.607a.25.25 0 00-.072-.222L4.753 9.882a.25.25 0 01.14-.427l4.625-.672zM12 14.533c.28 0 .559.067.814.2l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39v7.143z"
        })),
            Ln = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M19.75 11H21V8.667L19.875 4H4.125L3 8.667V11h1.25v8.75h15.5V11zm-1.5 0H5.75v7.25H10V13h4v5.25h4.25V11zm-5.5-5.5h2.067l.486 3.24.028.76H12.75v-4zm-3.567 0h2.067v4H8.669l.028-.76.486-3.24zm7.615 3.1l-.464-3.1h2.36l.806 3.345V9.5h-2.668l-.034-.9zM7.666 5.5h-2.36L4.5 8.845V9.5h2.668l.034-.9.464-3.1z",
          clipRule: "evenodd"
        })),
            Vn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4v11h14V4H5zm3 15.8h8v-1.5H8v1.5z"
        })),
            An = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8v.1c0 4.1 3.2 7.5 7.2 7.9h.8c4.4 0 8-3.6 8-8s-3.6-8-8-8zm0 15V5c3.9 0 7 3.1 7 7s-3.1 7-7 7z"
        })),
            Rn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3 6.75C3 5.784 3.784 5 4.75 5H15V7.313l.05.027 5.056 2.73.394.212v3.468a1.75 1.75 0 01-1.75 1.75h-.012a2.5 2.5 0 11-4.975 0H9.737a2.5 2.5 0 11-4.975 0H3V6.75zM13.5 14V6.5H4.75a.25.25 0 00-.25.25V14h.965a2.493 2.493 0 011.785-.75c.7 0 1.332.287 1.785.75H13.5zm4.535 0h.715a.25.25 0 00.25-.25v-2.573l-4-2.16v4.568a2.487 2.487 0 011.25-.335c.7 0 1.332.287 1.785.75zM6.282 15.5a1.002 1.002 0 00.968 1.25 1 1 0 10-.968-1.25zm9 0a1 1 0 101.937.498 1 1 0 00-1.938-.498z"
        })),
            Hn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 9v6h14V9H5zm11-4.8H8v1.5h8V4.2zM8 19.8h8v-1.5H8v1.5z"
        })),
            On = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.9 18.3l.8-1.2c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.1-.3-.4-.5-.6-.7-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.2 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3L15 19.4h4.3v-1.2h-2.4zM14.1 7.2h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Dn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.9 10.3l.8-1.3c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.2-.2-.4-.4-.7-.6-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.1 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3l-1.8 2.8h4.3v-1.2h-2.2zm-2.8-3.1h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Fn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 17.7c.4.5.8.9 1.2 1.2l1.1-1.4c-.4-.3-.7-.6-1-1L5 17.7zM5 6.3l1.4 1.1c.3-.4.6-.7 1-1L6.3 5c-.5.4-.9.8-1.3 1.3zm.1 7.8l-1.7.5c.2.6.4 1.1.7 1.6l1.5-.8c-.2-.4-.4-.8-.5-1.3zM4.8 12v-.7L3 11.1v1.8l1.7-.2c.1-.2.1-.5.1-.7zm3 7.9c.5.3 1.1.5 1.6.7l.5-1.7c-.5-.1-.9-.3-1.3-.5l-.8 1.5zM19 6.3c-.4-.5-.8-.9-1.2-1.2l-1.1 1.4c.4.3.7.6 1 1L19 6.3zm-.1 3.6l1.7-.5c-.2-.6-.4-1.1-.7-1.6l-1.5.8c.2.4.4.8.5 1.3zM5.6 8.6l-1.5-.8c-.3.5-.5 1-.7 1.6l1.7.5c.1-.5.3-.9.5-1.3zm2.2-4.5l.8 1.5c.4-.2.8-.4 1.3-.5l-.5-1.7c-.6.2-1.1.4-1.6.7zm8.8 13.5l1.1 1.4c.5-.4.9-.8 1.2-1.2l-1.4-1.1c-.2.3-.5.6-.9.9zm1.8-2.2l1.5.8c.3-.5.5-1.1.7-1.6l-1.7-.5c-.1.5-.3.9-.5 1.3zm2.6-4.3l-1.7.2v1.4l1.7.2V12v-.9zM11.1 3l.2 1.7h1.4l.2-1.7h-1.8zm3 2.1c.5.1.9.3 1.3.5l.8-1.5c-.5-.3-1.1-.5-1.6-.7l-.5 1.7zM12 19.2h-.7l-.2 1.8h1.8l-.2-1.7c-.2-.1-.5-.1-.7-.1zm2.1-.3l.5 1.7c.6-.2 1.1-.4 1.6-.7l-.8-1.5c-.4.2-.8.4-1.3.5z"
        })),
            jn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.08 12.864V9.216h3.648V7.424H14.08V3.776h-1.728v3.648H8.64v1.792h3.712v3.648zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm0 5.12H1.28v3.84H6.4V6.4zm0 5.12H1.28v3.84H6.4v-3.84zM19.2 1.28H7.68v14.08H19.2V1.28z"
        })),
            Gn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.4 3.776v3.648H2.752v1.792H6.4v3.648h1.728V9.216h3.712V7.424H8.128V3.776zM0 17.92V0h20.48v17.92H0zM12.8 1.28H1.28v14.08H12.8V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.12h-5.12v3.84h5.12V6.4zm0 5.12h-5.12v3.84h5.12v-3.84z"
        })),
            qn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.4 9.98L7.68 8.7v-.256L6.4 7.164V9.98zm6.4-1.532l1.28-1.28V9.92L12.8 8.64v-.192zm7.68 9.472V0H0v17.92h20.48zm-1.28-2.56h-5.12v-1.024l-.256.256-1.024-1.024v1.792H7.68v-1.792l-1.024 1.024-.256-.256v1.024H1.28V1.28H6.4v2.368l.704-.704.576.576V1.216h5.12V3.52l.96-.96.32.32V1.216h5.12V15.36zm-5.76-2.112l-3.136-3.136-3.264 3.264-1.536-1.536 3.264-3.264L5.632 5.44l1.536-1.536 3.136 3.136 3.2-3.2 1.536 1.536-3.2 3.2 3.136 3.136-1.536 1.536z"
        })),
            Wn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13.824 10.176h-2.88v-2.88H9.536v2.88h-2.88v1.344h2.88v2.88h1.408v-2.88h2.88zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm6.4 0H7.68v3.84h5.12V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.056H1.28v9.024H19.2V6.336z"
        })),
            Un = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84zM6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84z"
        })),
            $n = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.728 11.456L14.592 8.32l3.2-3.2-1.536-1.536-3.2 3.2L9.92 3.648 8.384 5.12l3.2 3.2-3.264 3.264 1.536 1.536 3.264-3.264 3.136 3.136 1.472-1.536zM0 17.92V0h20.48v17.92H0zm19.2-6.4h-.448l-1.28-1.28H19.2V6.4h-1.792l1.28-1.28h.512V1.28H1.28v3.84h6.208l1.28 1.28H1.28v3.84h7.424l-1.28 1.28H1.28v3.84H19.2v-3.84z"
        })),
            Zn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 6v11.5h16V6H4zm1.5 1.5h6V11h-6V7.5zm0 8.5v-3.5h6V16h-6zm13 0H13v-3.5h5.5V16zM13 11V7.5h5.5V11H13z"
        })),
            Kn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.1 11.2l-6.7-6.7c-.1-.1-.3-.2-.5-.2H5c-.4-.1-.8.3-.8.7v7.8c0 .2.1.4.2.5l6.7 6.7c.2.2.5.4.7.5s.6.2.9.2c.3 0 .6-.1.9-.2.3-.1.5-.3.8-.5l5.6-5.6c.4-.4.7-1 .7-1.6.1-.6-.2-1.2-.6-1.6zM19 13.4L13.4 19c-.1.1-.2.1-.3.2-.2.1-.4.1-.6 0-.1 0-.2-.1-.3-.2l-6.5-6.5V5.8h6.8l6.5 6.5c.2.2.2.4.2.6 0 .1 0 .3-.2.5zM9 8c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
        })),
            Qn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-17.6 1L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            Yn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M9 19.25h6M4 19.25h4M12 15.25h8M4 15.25h7"
        }), (0, m.createElement)(_.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            Xn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M18 5.5h-8v8h8.5V6a.5.5 0 00-.5-.5zm-9.5 8h-3V6a.5.5 0 01.5-.5h2.5v8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            Jn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 10.5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            el = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            tl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.9 6h-2l-4 11h1.9l1.1-3h4.2l1.1 3h1.9L12.9 6zm-2.5 6.5l1.5-4.9 1.7 4.9h-3.2z"
        })),
            rl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17 4H7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12zm-7.5-.5h4V16h-4v1.5z"
        })),
            al = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4v3h5.5v12h3V7H19V4H5z"
        })),
            ol = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.103 7.128l2.26-2.26a4 4 0 00-5.207 4.804L5.828 15a2 2 0 102.828 2.828l5.329-5.328a4 4 0 004.804-5.208l-2.261 2.26-1.912-.512-.513-1.912zm-7.214 9.64a.5.5 0 11.707-.707.5.5 0 01-.707.707z"
        })),
            nl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5h-5.7c0-1.3-1-2.3-2.3-2.3S9.7 3.7 9.7 5H4v2h1.5v.3l1.7 11.1c.1 1 1 1.7 2 1.7h5.7c1 0 1.8-.7 2-1.7l1.7-11.1V7H20V5zm-3.2 2l-1.7 11.1c0 .1-.1.2-.3.2H9.1c-.1 0-.3-.1-.3-.2L7.2 7h9.6z"
        })),
            ll = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 5v2H5V5h3V4a2 2 0 012-2h4a2 2 0 012 2v1h3zM6.187 8h11.625l-.695 11.125A2 2 0 0115.121 21H8.879a2 2 0 01-1.996-1.875L6.187 8zM14 5h-4V4h4v1z"
        })),
            il = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4.195 8.245a.75.75 0 011.06-.05l5.004 4.55 4.025-3.521L19 13.939V10.75h1.5v5.75h-5.75V15h3.19l-3.724-3.723-3.975 3.478-5.995-5.45a.75.75 0 01-.051-1.06z"
        })),
            sl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.445 16.505a.75.75 0 001.06.05l5.005-4.55 4.024 3.521 4.716-4.715V14h1.5V8.25H14v1.5h3.19l-3.724 3.723L9.49 9.995l-5.995 5.45a.75.75 0 00-.05 1.06z"
        })),
            cl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.9 7L3 17.8h1.7l1-2.8h4.1l1 2.8h1.7L8.6 7H6.9zm-.7 6.6l1.5-4.3 1.5 4.3h-3zM21.6 17c-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1s-.3-.1-.4-.2c-.1-.1-.1-.3-.1-.6V12c0-.5 0-1-.1-1.4-.1-.4-.3-.7-.5-1-.2-.2-.5-.4-.9-.5-.4 0-.8-.1-1.3-.1s-1 .1-1.4.2c-.4.1-.7.3-1 .4-.2.2-.4.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.5.2.8.2.2.4.3.8.3.3 0 .6-.1.8-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.2-.7-.2-.2-.4-.3-.6-.4.2-.2.4-.3.7-.4.3-.1.6-.1.8-.1.3 0 .6 0 .8.1.2.1.4.3.5.5.1.2.2.5.2.9v1.1c0 .3-.1.5-.3.6-.2.2-.5.3-.9.4-.3.1-.7.3-1.1.4-.4.1-.8.3-1.1.5-.3.2-.6.4-.8.7-.2.3-.3.7-.3 1.2 0 .6.2 1.1.5 1.4.3.4.9.5 1.6.5.5 0 1-.1 1.4-.3.4-.2.8-.6 1.1-1.1 0 .4.1.7.3 1 .2.3.6.4 1.2.4.4 0 .7-.1.9-.2.2-.1.5-.3.7-.4h-.3zm-3-.9c-.2.4-.5.7-.8.8-.3.2-.6.2-.8.2-.4 0-.6-.1-.9-.3-.2-.2-.3-.6-.3-1.1 0-.5.1-.9.3-1.2s.5-.5.8-.7c.3-.2.7-.3 1-.5.3-.1.6-.3.7-.6v3.4z"
        })),
            ul = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.3 11.7c-.6-.6-1.4-.9-2.3-.9H6.7l2.9-3.3-1.1-1-4.5 5L8.5 16l1-1-2.7-2.7H16c.5 0 .9.2 1.3.5 1 1 1 3.4 1 4.5v.3h1.5v-.2c0-1.5 0-4.3-1.5-5.7z"
        })),
            dl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7zm-5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h1V9H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-1h-1.5v1z"
        })),
            ml = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.2 3.28c3.53 0 6.43 2.61 6.92 6h2.08l-3.5 4-3.5-4h2.32c-.45-1.97-2.21-3.45-4.32-3.45-1.45 0-2.73.71-3.54 1.78L4.95 5.66C6.23 4.2 8.11 3.28 10.2 3.28zm-.4 13.44c-3.52 0-6.43-2.61-6.92-6H.8l3.5-4c1.17 1.33 2.33 2.67 3.5 4H5.48c.45 1.97 2.21 3.45 4.32 3.45 1.45 0 2.73-.71 3.54-1.78l1.71 1.95c-1.28 1.46-3.15 2.38-5.25 2.38z"
        })),
            pl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 15v3.5H13V6.7l4.5 4.1 1-1.1-6.2-5.8-5.8 5.8 1 1.1 4-4v11.7h-6V15H4v5h16v-5z"
        })),
            gl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.8 2l-.9.3c-.1 0-3.6 1-5.2 2.1C10 5.5 9.3 6.5 8.9 7.1c-.6.9-1.7 4.7-1.7 6.3l-.9 2.3c-.2.4 0 .8.4 1 .1 0 .2.1.3.1.3 0 .6-.2.7-.5l.6-1.5c.3 0 .7-.1 1.2-.2.7-.1 1.4-.3 2.2-.5.8-.2 1.6-.5 2.4-.8.7-.3 1.4-.7 1.9-1.2s.8-1.2 1-1.9c.2-.7.3-1.6.4-2.4.1-.8.1-1.7.2-2.5 0-.8.1-1.5.2-2.1V2zm-1.9 5.6c-.1.8-.2 1.5-.3 2.1-.2.6-.4 1-.6 1.3-.3.3-.8.6-1.4.9-.7.3-1.4.5-2.2.8-.6.2-1.3.3-1.8.4L15 7.5c.3-.3.6-.7 1-1.1 0 .4 0 .8-.1 1.2zM6 20h8v-1.5H6V20z"
        })),
            vl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            hl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"
        })),
            bl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6 3H8V5H16V3H18V5C19.1046 5 20 5.89543 20 7V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5V3ZM18 6.5H6C5.72386 6.5 5.5 6.72386 5.5 7V8H18.5V7C18.5 6.72386 18.2761 6.5 18 6.5ZM18.5 9.5H5.5V19C5.5 19.2761 5.72386 19.5 6 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V9.5ZM11 11H13V13H11V11ZM7 11V13H9V11H7ZM15 13V11H17V13H15Z"
        })),
            _l = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 10c0-5.51-4.49-10-10-10C4.48 0 0 4.49 0 10c0 5.52 4.48 10 10 10 5.51 0 10-4.48 10-10zM7.78 15.37L4.37 6.22c.55-.02 1.17-.08 1.17-.08.5-.06.44-1.13-.06-1.11 0 0-1.45.11-2.37.11-.18 0-.37 0-.58-.01C4.12 2.69 6.87 1.11 10 1.11c2.33 0 4.45.87 6.05 2.34-.68-.11-1.65.39-1.65 1.58 0 .74.45 1.36.9 2.1.35.61.55 1.36.55 2.46 0 1.49-1.4 5-1.4 5l-3.03-8.37c.54-.02.82-.17.82-.17.5-.05.44-1.25-.06-1.22 0 0-1.44.12-2.38.12-.87 0-2.33-.12-2.33-.12-.5-.03-.56 1.2-.06 1.22l.92.08 1.26 3.41zM17.41 10c.24-.64.74-1.87.43-4.25.7 1.29 1.05 2.71 1.05 4.25 0 3.29-1.73 6.24-4.4 7.78.97-2.59 1.94-5.2 2.92-7.78zM6.1 18.09C3.12 16.65 1.11 13.53 1.11 10c0-1.3.23-2.48.72-3.59C3.25 10.3 4.67 14.2 6.1 18.09zm4.03-6.63l2.58 6.98c-.86.29-1.76.45-2.71.45-.79 0-1.57-.11-2.29-.33.81-2.38 1.62-4.74 2.42-7.1z"
        }));
      },
      7882: function _(l, s) {
        var c;
        !function () {
          "use strict";

          var m = function () {
            function StorageObject() {}

            function _parseArray(l, s) {
              for (var c = s.length, m = 0; m < c; ++m) {
                _parse(l, s[m]);
              }
            }

            StorageObject.prototype = Object.create(null);
            var l = {}.hasOwnProperty;
            var s = /\s+/;

            function _parse(c, m) {
              if (m) {
                var v = typeof m;
                "string" === v ? function _parseString(l, c) {
                  for (var m = c.split(s), v = m.length, _ = 0; _ < v; ++_) {
                    l[m[_]] = !0;
                  }
                }(c, m) : Array.isArray(m) ? _parseArray(c, m) : "object" === v ? function _parseObject(s, c) {
                  if (c.toString === Object.prototype.toString) for (var m in c) {
                    l.call(c, m) && (s[m] = !!c[m]);
                  } else s[c.toString()] = !0;
                }(c, m) : "number" === v && function _parseNumber(l, s) {
                  l[s] = !0;
                }(c, m);
              }
            }

            return function _classNames() {
              for (var l = arguments.length, s = Array(l), c = 0; c < l; c++) {
                s[c] = arguments[c];
              }

              var m = new StorageObject();

              _parseArray(m, s);

              var v = [];

              for (var _ in m) {
                m[_] && v.push(_);
              }

              return v.join(" ");
            };
          }();

          l.exports ? (m.default = m, l.exports = m) : void 0 === (c = function () {
            return m;
          }.apply(s, [])) || (l.exports = c);
        }();
      },
      2703: function _(l, s) {
        var c;
        !function () {
          "use strict";

          var m = {}.hasOwnProperty;

          function classNames() {
            for (var l = [], s = 0; s < arguments.length; s++) {
              var c = arguments[s];

              if (c) {
                var v = typeof c;
                if ("string" === v || "number" === v) l.push(c);else if (Array.isArray(c)) {
                  if (c.length) {
                    var _ = classNames.apply(null, c);

                    _ && l.push(_);
                  }
                } else if ("object" === v) if (c.toString === Object.prototype.toString) for (var y in c) {
                  m.call(c, y) && c[y] && l.push(y);
                } else l.push(c.toString());
              }
            }

            return l.join(" ");
          }

          l.exports ? (classNames.default = classNames, l.exports = classNames) : void 0 === (c = function () {
            return classNames;
          }.apply(s, [])) || (l.exports = c);
        }();
      },
      7270: function _(l, s) {
        Object.defineProperty(s, "__esModule", {
          value: !0
        });

        var c = {
          grad: .9,
          turn: 360,
          rad: 360 / (2 * Math.PI)
        },
            t = function t(l) {
          return "string" == typeof l ? l.length > 0 : "number" == typeof l;
        },
            n = function n(l, s, c) {
          return void 0 === s && (s = 0), void 0 === c && (c = Math.pow(10, s)), Math.round(c * l) / c + 0;
        },
            e = function e(l, s, c) {
          return void 0 === s && (s = 0), void 0 === c && (c = 1), l > c ? c : l > s ? l : s;
        },
            u = function u(l) {
          return (l = isFinite(l) ? l % 360 : 0) > 0 ? l : l + 360;
        },
            o = function o(l) {
          return {
            r: e(l.r, 0, 255),
            g: e(l.g, 0, 255),
            b: e(l.b, 0, 255),
            a: e(l.a)
          };
        },
            a = function a(l) {
          return {
            r: n(l.r),
            g: n(l.g),
            b: n(l.b),
            a: n(l.a, 3)
          };
        },
            m = /^#([0-9a-f]{3,8})$/i,
            i = function i(l) {
          var s = l.toString(16);
          return s.length < 2 ? "0" + s : s;
        },
            h = function h(l) {
          var s = l.r,
              c = l.g,
              m = l.b,
              v = l.a,
              _ = Math.max(s, c, m),
              y = _ - Math.min(s, c, m),
              k = y ? _ === s ? (c - m) / y : _ === c ? 2 + (m - s) / y : 4 + (s - c) / y : 0;

          return {
            h: 60 * (k < 0 ? k + 6 : k),
            s: _ ? y / _ * 100 : 0,
            v: _ / 255 * 100,
            a: v
          };
        },
            b = function b(l) {
          var s = l.h,
              c = l.s,
              m = l.v,
              v = l.a;
          s = s / 360 * 6, c /= 100, m /= 100;

          var _ = Math.floor(s),
              y = m * (1 - c),
              k = m * (1 - (s - _) * c),
              E = m * (1 - (1 - s + _) * c),
              w = _ % 6;

          return {
            r: 255 * [m, k, y, y, E, m][w],
            g: 255 * [E, m, m, k, y, y][w],
            b: 255 * [y, y, E, m, m, k][w],
            a: v
          };
        },
            d = function d(l) {
          return {
            h: u(l.h),
            s: e(l.s, 0, 100),
            l: e(l.l, 0, 100),
            a: e(l.a)
          };
        },
            g = function g(l) {
          return {
            h: n(l.h),
            s: n(l.s),
            l: n(l.l),
            a: n(l.a, 3)
          };
        },
            f = function f(l) {
          return b((c = (s = l).s, {
            h: s.h,
            s: (c *= ((m = s.l) < 50 ? m : 100 - m) / 100) > 0 ? 2 * c / (m + c) * 100 : 0,
            v: m + c,
            a: s.a
          }));
          var s, c, m;
        },
            p = function p(l) {
          return {
            h: (s = h(l)).h,
            s: (v = (200 - (c = s.s)) * (m = s.v) / 100) > 0 && v < 200 ? c * m / 100 / (v <= 100 ? v : 200 - v) * 100 : 0,
            l: v / 2,
            a: s.a
          };
          var s, c, m, v;
        },
            v = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            _ = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            y = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            k = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            E = {
          string: [[function (l) {
            var s = m.exec(l);
            return s ? (l = s[1]).length <= 4 ? {
              r: parseInt(l[0] + l[0], 16),
              g: parseInt(l[1] + l[1], 16),
              b: parseInt(l[2] + l[2], 16),
              a: 4 === l.length ? n(parseInt(l[3] + l[3], 16) / 255, 2) : 1
            } : 6 === l.length || 8 === l.length ? {
              r: parseInt(l.substr(0, 2), 16),
              g: parseInt(l.substr(2, 2), 16),
              b: parseInt(l.substr(4, 2), 16),
              a: 8 === l.length ? n(parseInt(l.substr(6, 2), 16) / 255, 2) : 1
            } : null : null;
          }, "hex"], [function (l) {
            var s = y.exec(l) || k.exec(l);
            return s ? s[2] !== s[4] || s[4] !== s[6] ? null : o({
              r: Number(s[1]) / (s[2] ? 100 / 255 : 1),
              g: Number(s[3]) / (s[4] ? 100 / 255 : 1),
              b: Number(s[5]) / (s[6] ? 100 / 255 : 1),
              a: void 0 === s[7] ? 1 : Number(s[7]) / (s[8] ? 100 : 1)
            }) : null;
          }, "rgb"], [function (l) {
            var s = v.exec(l) || _.exec(l);

            if (!s) return null;
            var m,
                y,
                k = d({
              h: (m = s[1], y = s[2], void 0 === y && (y = "deg"), Number(m) * (c[y] || 1)),
              s: Number(s[3]),
              l: Number(s[4]),
              a: void 0 === s[5] ? 1 : Number(s[5]) / (s[6] ? 100 : 1)
            });
            return f(k);
          }, "hsl"]],
          object: [[function (l) {
            var s = l.r,
                c = l.g,
                m = l.b,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            return t(s) && t(c) && t(m) ? o({
              r: Number(s),
              g: Number(c),
              b: Number(m),
              a: Number(_)
            }) : null;
          }, "rgb"], [function (l) {
            var s = l.h,
                c = l.s,
                m = l.l,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            if (!t(s) || !t(c) || !t(m)) return null;
            var y = d({
              h: Number(s),
              s: Number(c),
              l: Number(m),
              a: Number(_)
            });
            return f(y);
          }, "hsl"], [function (l) {
            var s = l.h,
                c = l.s,
                m = l.v,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            if (!t(s) || !t(c) || !t(m)) return null;

            var y = function (l) {
              return {
                h: u(l.h),
                s: e(l.s, 0, 100),
                v: e(l.v, 0, 100),
                a: e(l.a)
              };
            }({
              h: Number(s),
              s: Number(c),
              v: Number(m),
              a: Number(_)
            });

            return b(y);
          }, "hsv"]]
        },
            N = function N(l, s) {
          for (var c = 0; c < s.length; c++) {
            var m = s[c][0](l);
            if (m) return [m, s[c][1]];
          }

          return [null, void 0];
        },
            x = function x(l) {
          return "string" == typeof l ? N(l.trim(), E.string) : "object" == typeof l && null !== l ? N(l, E.object) : [null, void 0];
        },
            M = function M(l, s) {
          var c = p(l);
          return {
            h: c.h,
            s: e(c.s + 100 * s, 0, 100),
            l: c.l,
            a: c.a
          };
        },
            I = function I(l) {
          return (299 * l.r + 587 * l.g + 114 * l.b) / 1e3 / 255;
        },
            H = function H(l, s) {
          var c = p(l);
          return {
            h: c.h,
            s: c.s,
            l: e(c.l + 100 * s, 0, 100),
            a: c.a
          };
        },
            w = function () {
          function r(l) {
            this.parsed = x(l)[0], this.rgba = this.parsed || {
              r: 0,
              g: 0,
              b: 0,
              a: 1
            };
          }

          return r.prototype.isValid = function () {
            return null !== this.parsed;
          }, r.prototype.brightness = function () {
            return n(I(this.rgba), 2);
          }, r.prototype.isDark = function () {
            return I(this.rgba) < .5;
          }, r.prototype.isLight = function () {
            return I(this.rgba) >= .5;
          }, r.prototype.toHex = function () {
            return s = (l = a(this.rgba)).r, c = l.g, m = l.b, _ = (v = l.a) < 1 ? i(n(255 * v)) : "", "#" + i(s) + i(c) + i(m) + _;

            var l, s, c, m, v, _;
          }, r.prototype.toRgb = function () {
            return a(this.rgba);
          }, r.prototype.toRgbString = function () {
            return s = (l = a(this.rgba)).r, c = l.g, m = l.b, (v = l.a) < 1 ? "rgba(" + s + ", " + c + ", " + m + ", " + v + ")" : "rgb(" + s + ", " + c + ", " + m + ")";
            var l, s, c, m, v;
          }, r.prototype.toHsl = function () {
            return g(p(this.rgba));
          }, r.prototype.toHslString = function () {
            return s = (l = g(p(this.rgba))).h, c = l.s, m = l.l, (v = l.a) < 1 ? "hsla(" + s + ", " + c + "%, " + m + "%, " + v + ")" : "hsl(" + s + ", " + c + "%, " + m + "%)";
            var l, s, c, m, v;
          }, r.prototype.toHsv = function () {
            return l = h(this.rgba), {
              h: n(l.h),
              s: n(l.s),
              v: n(l.v),
              a: n(l.a, 3)
            };
            var l;
          }, r.prototype.invert = function () {
            return j({
              r: 255 - (l = this.rgba).r,
              g: 255 - l.g,
              b: 255 - l.b,
              a: l.a
            });
            var l;
          }, r.prototype.saturate = function (l) {
            return void 0 === l && (l = .1), j(M(this.rgba, l));
          }, r.prototype.desaturate = function (l) {
            return void 0 === l && (l = .1), j(M(this.rgba, -l));
          }, r.prototype.grayscale = function () {
            return j(M(this.rgba, -1));
          }, r.prototype.lighten = function (l) {
            return void 0 === l && (l = .1), j(H(this.rgba, l));
          }, r.prototype.darken = function (l) {
            return void 0 === l && (l = .1), j(H(this.rgba, -l));
          }, r.prototype.rotate = function (l) {
            return void 0 === l && (l = 15), this.hue(this.hue() + l);
          }, r.prototype.alpha = function (l) {
            return "number" == typeof l ? j({
              r: (s = this.rgba).r,
              g: s.g,
              b: s.b,
              a: l
            }) : n(this.rgba.a, 3);
            var s;
          }, r.prototype.hue = function (l) {
            var s = p(this.rgba);
            return "number" == typeof l ? j({
              h: l,
              s: s.s,
              l: s.l,
              a: s.a
            }) : n(s.h);
          }, r.prototype.isEqual = function (l) {
            return this.toHex() === j(l).toHex();
          }, r;
        }(),
            j = function j(l) {
          return l instanceof w ? l : new w(l);
        },
            C = [];

        s.Colord = w, s.colord = j, s.extend = function (l) {
          l.forEach(function (l) {
            C.indexOf(l) < 0 && (l(w, E), C.push(l));
          });
        }, s.getFormat = function (l) {
          return x(l)[1];
        }, s.random = function () {
          return new w({
            r: 255 * Math.random(),
            g: 255 * Math.random(),
            b: 255 * Math.random()
          });
        };
      },
      9785: function _(l) {
        l.exports = function (l, s) {
          var c = {
            white: "#ffffff",
            bisque: "#ffe4c4",
            blue: "#0000ff",
            cadetblue: "#5f9ea0",
            chartreuse: "#7fff00",
            chocolate: "#d2691e",
            coral: "#ff7f50",
            antiquewhite: "#faebd7",
            aqua: "#00ffff",
            azure: "#f0ffff",
            whitesmoke: "#f5f5f5",
            papayawhip: "#ffefd5",
            plum: "#dda0dd",
            blanchedalmond: "#ffebcd",
            black: "#000000",
            gold: "#ffd700",
            goldenrod: "#daa520",
            gainsboro: "#dcdcdc",
            cornsilk: "#fff8dc",
            cornflowerblue: "#6495ed",
            burlywood: "#deb887",
            aquamarine: "#7fffd4",
            beige: "#f5f5dc",
            crimson: "#dc143c",
            cyan: "#00ffff",
            darkblue: "#00008b",
            darkcyan: "#008b8b",
            darkgoldenrod: "#b8860b",
            darkkhaki: "#bdb76b",
            darkgray: "#a9a9a9",
            darkgreen: "#006400",
            darkgrey: "#a9a9a9",
            peachpuff: "#ffdab9",
            darkmagenta: "#8b008b",
            darkred: "#8b0000",
            darkorchid: "#9932cc",
            darkorange: "#ff8c00",
            darkslateblue: "#483d8b",
            gray: "#808080",
            darkslategray: "#2f4f4f",
            darkslategrey: "#2f4f4f",
            deeppink: "#ff1493",
            deepskyblue: "#00bfff",
            wheat: "#f5deb3",
            firebrick: "#b22222",
            floralwhite: "#fffaf0",
            ghostwhite: "#f8f8ff",
            darkviolet: "#9400d3",
            magenta: "#ff00ff",
            green: "#008000",
            dodgerblue: "#1e90ff",
            grey: "#808080",
            honeydew: "#f0fff0",
            hotpink: "#ff69b4",
            blueviolet: "#8a2be2",
            forestgreen: "#228b22",
            lawngreen: "#7cfc00",
            indianred: "#cd5c5c",
            indigo: "#4b0082",
            fuchsia: "#ff00ff",
            brown: "#a52a2a",
            maroon: "#800000",
            mediumblue: "#0000cd",
            lightcoral: "#f08080",
            darkturquoise: "#00ced1",
            lightcyan: "#e0ffff",
            ivory: "#fffff0",
            lightyellow: "#ffffe0",
            lightsalmon: "#ffa07a",
            lightseagreen: "#20b2aa",
            linen: "#faf0e6",
            mediumaquamarine: "#66cdaa",
            lemonchiffon: "#fffacd",
            lime: "#00ff00",
            khaki: "#f0e68c",
            mediumseagreen: "#3cb371",
            limegreen: "#32cd32",
            mediumspringgreen: "#00fa9a",
            lightskyblue: "#87cefa",
            lightblue: "#add8e6",
            midnightblue: "#191970",
            lightpink: "#ffb6c1",
            mistyrose: "#ffe4e1",
            moccasin: "#ffe4b5",
            mintcream: "#f5fffa",
            lightslategray: "#778899",
            lightslategrey: "#778899",
            navajowhite: "#ffdead",
            navy: "#000080",
            mediumvioletred: "#c71585",
            powderblue: "#b0e0e6",
            palegoldenrod: "#eee8aa",
            oldlace: "#fdf5e6",
            paleturquoise: "#afeeee",
            mediumturquoise: "#48d1cc",
            mediumorchid: "#ba55d3",
            rebeccapurple: "#663399",
            lightsteelblue: "#b0c4de",
            mediumslateblue: "#7b68ee",
            thistle: "#d8bfd8",
            tan: "#d2b48c",
            orchid: "#da70d6",
            mediumpurple: "#9370db",
            purple: "#800080",
            pink: "#ffc0cb",
            skyblue: "#87ceeb",
            springgreen: "#00ff7f",
            palegreen: "#98fb98",
            red: "#ff0000",
            yellow: "#ffff00",
            slateblue: "#6a5acd",
            lavenderblush: "#fff0f5",
            peru: "#cd853f",
            palevioletred: "#db7093",
            violet: "#ee82ee",
            teal: "#008080",
            slategray: "#708090",
            slategrey: "#708090",
            aliceblue: "#f0f8ff",
            darkseagreen: "#8fbc8f",
            darkolivegreen: "#556b2f",
            greenyellow: "#adff2f",
            seagreen: "#2e8b57",
            seashell: "#fff5ee",
            tomato: "#ff6347",
            silver: "#c0c0c0",
            sienna: "#a0522d",
            lavender: "#e6e6fa",
            lightgreen: "#90ee90",
            orange: "#ffa500",
            orangered: "#ff4500",
            steelblue: "#4682b4",
            royalblue: "#4169e1",
            turquoise: "#40e0d0",
            yellowgreen: "#9acd32",
            salmon: "#fa8072",
            saddlebrown: "#8b4513",
            sandybrown: "#f4a460",
            rosybrown: "#bc8f8f",
            darksalmon: "#e9967a",
            lightgoldenrodyellow: "#fafad2",
            snow: "#fffafa",
            lightgrey: "#d3d3d3",
            lightgray: "#d3d3d3",
            dimgray: "#696969",
            dimgrey: "#696969",
            olivedrab: "#6b8e23",
            olive: "#808000"
          },
              m = {};

          for (var v in c) {
            m[c[v]] = v;
          }

          var _ = {};
          l.prototype.toName = function (s) {
            if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
            var v,
                y,
                k = m[this.toHex()];
            if (k) return k;

            if (null == s ? void 0 : s.closest) {
              var E = this.toRgb(),
                  w = 1 / 0,
                  C = "black";
              if (!_.length) for (var S in c) {
                _[S] = new l(c[S]).toRgb();
              }

              for (var P in c) {
                var T = (v = E, y = _[P], Math.pow(v.r - y.r, 2) + Math.pow(v.g - y.g, 2) + Math.pow(v.b - y.b, 2));
                T < w && (w = T, C = P);
              }

              return C;
            }
          }, s.string.push([function (s) {
            var m = s.toLowerCase(),
                v = "transparent" === m ? "#0000" : c[m];
            return v ? new l(v).toRgb() : null;
          }, "name"]);
        };
      },
      2689: function _(l) {
        l.exports = function () {
          "use strict";

          function _classCallCheck(l, s) {
            if (!(l instanceof s)) throw new TypeError("Cannot call a class as a function");
          }

          function _defineProperties(l, s) {
            for (var c = 0; c < s.length; c++) {
              var m = s[c];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(l, m.key, m);
            }
          }

          function _createClass(l, s, c) {
            return s && _defineProperties(l.prototype, s), c && _defineProperties(l, c), l;
          }

          function _slicedToArray(l, s) {
            return _arrayWithHoles(l) || _iterableToArrayLimit(l, s) || _nonIterableRest();
          }

          function _arrayWithHoles(l) {
            if (Array.isArray(l)) return l;
          }

          function _iterableToArrayLimit(l, s) {
            var c = [],
                m = !0,
                v = !1,
                _ = void 0;

            try {
              for (var y, k = l[Symbol.iterator](); !(m = (y = k.next()).done) && (c.push(y.value), !s || c.length !== s); m = !0) {
                ;
              }
            } catch (l) {
              v = !0, _ = l;
            } finally {
              try {
                m || null == k.return || k.return();
              } finally {
                if (v) throw _;
              }
            }

            return c;
          }

          function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }

          return function () {
            function FastAverageColor() {
              _classCallCheck(this, FastAverageColor);
            }

            return _createClass(FastAverageColor, [{
              key: "getColorAsync",
              value: function getColorAsync(l, s, c) {
                l.complete ? s.call(l, this.getColor(l, c), c && c.data) : this._bindImageEvents(l, s, c);
              }
            }, {
              key: "getColor",
              value: function getColor(l, s) {
                s = s || {};

                var c = this._getDefaultColor(s),
                    m = this._getOriginalSize(l),
                    v = this._prepareSizeAndPosition(m, s),
                    _ = null,
                    y = c;

                if (!(v.srcWidth && v.srcHeight && v.destWidth && v.destHeight)) return this._prepareResult(c, new Error("FastAverageColor: Incorrect sizes."));
                if (!this._ctx && (this._canvas = this._makeCanvas(), this._ctx = this._canvas.getContext && this._canvas.getContext("2d"), !this._ctx)) return this._prepareResult(c, new Error("FastAverageColor: Canvas Context 2D is not supported in this browser."));
                this._canvas.width = v.destWidth, this._canvas.height = v.destHeight;

                try {
                  this._ctx.clearRect(0, 0, v.destWidth, v.destHeight), this._ctx.drawImage(l, v.srcLeft, v.srcTop, v.srcWidth, v.srcHeight, 0, 0, v.destWidth, v.destHeight);

                  var k = this._ctx.getImageData(0, 0, v.destWidth, v.destHeight).data;

                  y = this.getColorFromArray4(k, s);
                } catch (l) {
                  _ = l;
                }

                return this._prepareResult(y, _);
              }
            }, {
              key: "getColorFromArray4",
              value: function getColorFromArray4(l, s) {
                s = s || {};
                var c = 4,
                    m = l.length;
                if (m < c) return this._getDefaultColor(s);

                var v = m - m % c,
                    _ = (s.step || 1) * c,
                    y = "_" + (s.algorithm || "sqrt") + "Algorithm";

                if ("function" != typeof this[y]) throw new Error("FastAverageColor: ".concat(s.algorithm, " is unknown algorithm."));
                return this[y](l, v, _);
              }
            }, {
              key: "destroy",
              value: function destroy() {
                delete this._canvas, delete this._ctx;
              }
            }, {
              key: "_getDefaultColor",
              value: function _getDefaultColor(l) {
                return this._getOption(l, "defaultColor", [255, 255, 255, 255]);
              }
            }, {
              key: "_getOption",
              value: function _getOption(l, s, c) {
                return void 0 === l[s] ? c : l[s];
              }
            }, {
              key: "_prepareSizeAndPosition",
              value: function _prepareSizeAndPosition(l, s) {
                var c = this._getOption(s, "left", 0),
                    m = this._getOption(s, "top", 0),
                    v = this._getOption(s, "width", l.width),
                    _ = this._getOption(s, "height", l.height),
                    y = v,
                    k = _;

                if ("precision" === s.mode) return {
                  srcLeft: c,
                  srcTop: m,
                  srcWidth: v,
                  srcHeight: _,
                  destWidth: y,
                  destHeight: k
                };
                var E,
                    w = 100,
                    C = 10;
                return v > _ ? (E = v / _, y = w, k = Math.round(y / E)) : (E = _ / v, k = w, y = Math.round(k / E)), (y > v || k > _ || y < C || k < C) && (y = v, k = _), {
                  srcLeft: c,
                  srcTop: m,
                  srcWidth: v,
                  srcHeight: _,
                  destWidth: y,
                  destHeight: k
                };
              }
            }, {
              key: "_simpleAlgorithm",
              value: function _simpleAlgorithm(l, s, c) {
                for (var m = 0, v = 0, _ = 0, y = 0, k = 0, E = 0; E < s; E += c) {
                  var w = l[E + 3];
                  m += l[E] * w, v += l[E + 1] * w, _ += l[E + 2] * w, y += w, k++;
                }

                return y ? [Math.round(m / y), Math.round(v / y), Math.round(_ / y), Math.round(y / k)] : [0, 0, 0, 0];
              }
            }, {
              key: "_sqrtAlgorithm",
              value: function _sqrtAlgorithm(l, s, c) {
                for (var m = 0, v = 0, _ = 0, y = 0, k = 0, E = 0; E < s; E += c) {
                  var w = l[E],
                      C = l[E + 1],
                      S = l[E + 2],
                      P = l[E + 3];
                  m += w * w * P, v += C * C * P, _ += S * S * P, y += P, k++;
                }

                return y ? [Math.round(Math.sqrt(m / y)), Math.round(Math.sqrt(v / y)), Math.round(Math.sqrt(_ / y)), Math.round(y / k)] : [0, 0, 0, 0];
              }
            }, {
              key: "_dominantAlgorithm",
              value: function _dominantAlgorithm(l, s, c) {
                for (var m = {}, v = 24, _ = 0; _ < s; _ += c) {
                  var y = l[_],
                      k = l[_ + 1],
                      E = l[_ + 2],
                      w = l[_ + 3],
                      C = Math.round(y / v) + "," + Math.round(k / v) + "," + Math.round(E / v);
                  m[C] ? m[C] = [m[C][0] + y * w, m[C][1] + k * w, m[C][2] + E * w, m[C][3] + w, m[C][4] + 1] : m[C] = [y * w, k * w, E * w, w, 1];
                }

                var S = Object.keys(m).map(function (l) {
                  return m[l];
                }).sort(function (l, s) {
                  var c = l[4],
                      m = s[4];
                  return c > m ? -1 : c === m ? 0 : 1;
                }),
                    P = _slicedToArray(S[0], 5),
                    T = P[0],
                    B = P[1],
                    z = P[2],
                    L = P[3],
                    V = P[4];

                return L ? [Math.round(T / L), Math.round(B / L), Math.round(z / L), Math.round(L / V)] : [0, 0, 0, 0];
              }
            }, {
              key: "_bindImageEvents",
              value: function _bindImageEvents(l, s, c) {
                var m = this,
                    v = (c = c || {}) && c.data,
                    _ = this._getDefaultColor(c),
                    y = function onload() {
                  w(), s.call(l, m.getColor(l, c), v);
                },
                    k = function onerror() {
                  w(), s.call(l, m._prepareResult(_, new Error("Image error")), v);
                },
                    E = function onabort() {
                  w(), s.call(l, m._prepareResult(_, new Error("Image abort")), v);
                },
                    w = function unbindEvents() {
                  l.removeEventListener("load", y), l.removeEventListener("error", k), l.removeEventListener("abort", E);
                };

                l.addEventListener("load", y), l.addEventListener("error", k), l.addEventListener("abort", E);
              }
            }, {
              key: "_prepareResult",
              value: function _prepareResult(l, s) {
                var c = l.slice(0, 3),
                    m = [].concat(c, l[3] / 255),
                    v = this._isDark(l);

                return {
                  error: s,
                  value: l,
                  rgb: "rgb(" + c.join(",") + ")",
                  rgba: "rgba(" + m.join(",") + ")",
                  hex: this._arrayToHex(c),
                  hexa: this._arrayToHex(l),
                  isDark: v,
                  isLight: !v
                };
              }
            }, {
              key: "_getOriginalSize",
              value: function _getOriginalSize(l) {
                return l instanceof HTMLImageElement ? {
                  width: l.naturalWidth,
                  height: l.naturalHeight
                } : l instanceof HTMLVideoElement ? {
                  width: l.videoWidth,
                  height: l.videoHeight
                } : {
                  width: l.width,
                  height: l.height
                };
              }
            }, {
              key: "_toHex",
              value: function _toHex(l) {
                var s = l.toString(16);
                return 1 === s.length ? "0" + s : s;
              }
            }, {
              key: "_arrayToHex",
              value: function _arrayToHex(l) {
                return "#" + l.map(this._toHex).join("");
              }
            }, {
              key: "_isDark",
              value: function _isDark(l) {
                return (299 * l[0] + 587 * l[1] + 114 * l[2]) / 1e3 < 128;
              }
            }, {
              key: "_makeCanvas",
              value: function _makeCanvas() {
                return "undefined" == typeof window ? new OffscreenCanvas(1, 1) : document.createElement("canvas");
              }
            }]), FastAverageColor;
          }();
        }();
      },
      1593: function _(l) {
        l.exports = function memize(l, s) {
          var c,
              m,
              v = 0;

          function memoized() {
            var _,
                y,
                k = c,
                E = arguments.length;

            e: for (; k;) {
              if (k.args.length === arguments.length) {
                for (y = 0; y < E; y++) {
                  if (k.args[y] !== arguments[y]) {
                    k = k.next;
                    continue e;
                  }
                }

                return k !== c && (k === m && (m = k.prev), k.prev.next = k.next, k.next && (k.next.prev = k.prev), k.next = c, k.prev = null, c.prev = k, c = k), k.val;
              }

              k = k.next;
            }

            for (_ = new Array(E), y = 0; y < E; y++) {
              _[y] = arguments[y];
            }

            return k = {
              args: _,
              val: l.apply(null, _)
            }, c ? (c.prev = k, k.next = c) : m = k, v === s.maxSize ? (m = m.prev).next = null : v++, c = k, k.val;
          }

          return s = s || {}, memoized.clear = function () {
            c = null, m = null, v = 0;
          }, memoized;
        };
      },
      9773: function _(l) {
        "use strict";

        l.exports = require("@wordpress/a11y");
      },
      507: function _(l) {
        "use strict";

        l.exports = require("@wordpress/api-fetch");
      },
      9568: function _(l) {
        "use strict";

        l.exports = require("@wordpress/autop");
      },
      9388: function _(l) {
        "use strict";

        l.exports = require("@wordpress/blob");
      },
      1326: function _(l) {
        "use strict";

        l.exports = require("@wordpress/block-editor");
      },
      6700: function _(l) {
        "use strict";

        l.exports = require("@wordpress/blocks");
      },
      4892: function _(l) {
        "use strict";

        l.exports = require("@wordpress/components");
      },
      3200: function _(l) {
        "use strict";

        l.exports = require("@wordpress/compose");
      },
      1295: function _(l) {
        "use strict";

        l.exports = require("@wordpress/core-data");
      },
      8467: function _(l) {
        "use strict";

        l.exports = require("@wordpress/data");
      },
      7126: function _(l) {
        "use strict";

        l.exports = require("@wordpress/date");
      },
      3703: function _(l) {
        "use strict";

        l.exports = require("@wordpress/deprecated");
      },
      5480: function _(l) {
        "use strict";

        l.exports = require("@wordpress/dom");
      },
      1753: function _(l) {
        "use strict";

        l.exports = require("@wordpress/element");
      },
      1149: function _(l) {
        "use strict";

        l.exports = require("@wordpress/hooks");
      },
      3248: function _(l) {
        "use strict";

        l.exports = require("@wordpress/html-entities");
      },
      6756: function _(l) {
        "use strict";

        l.exports = require("@wordpress/i18n");
      },
      9880: function _(l) {
        "use strict";

        l.exports = require("@wordpress/keycodes");
      },
      8448: function _(l) {
        "use strict";

        l.exports = require("@wordpress/notices");
      },
      1666: function _(l) {
        "use strict";

        l.exports = require("@wordpress/primitives");
      },
      1019: function _(l) {
        "use strict";

        l.exports = require("@wordpress/reusable-blocks");
      },
      7060: function _(l) {
        "use strict";

        l.exports = require("@wordpress/rich-text");
      },
      2643: function _(l) {
        "use strict";

        l.exports = require("@wordpress/server-side-render");
      },
      904: function _(l) {
        "use strict";

        l.exports = require("@wordpress/url");
      },
      1627: function _(l) {
        "use strict";

        l.exports = require("@wordpress/viewport");
      },
      4793: function _(l) {
        "use strict";

        l.exports = require("lodash");
      },
      605: function _(l) {
        "use strict";

        l.exports = require("moment");
      }
    },
        s = {};

    function __webpack_require__(c) {
      var m = s[c];
      if (void 0 !== m) return m.exports;
      var v = s[c] = {
        exports: {}
      };
      return l[c].call(v.exports, v, v.exports, __webpack_require__), v.exports;
    }

    __webpack_require__.d = function (l, s) {
      for (var c in s) {
        __webpack_require__.o(s, c) && !__webpack_require__.o(l, c) && Object.defineProperty(l, c, {
          enumerable: !0,
          get: s[c]
        });
      }
    }, __webpack_require__.o = function (l, s) {
      return Object.prototype.hasOwnProperty.call(l, s);
    }, __webpack_require__.r = function (l) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(l, "__esModule", {
        value: !0
      });
    };
    var c = {};
    return function () {
      "use strict";

      var l = c;
      Object.defineProperty(l, "__esModule", {
        value: !0
      }), l.registerCoreBlocks = l.__experimentalRegisterExperimentalCoreBlocks = l.__experimentalGetCoreBlocks = void 0;

      var s = __webpack_require__(6700),
          m = _interopRequireWildcard(__webpack_require__(8230)),
          v = _interopRequireWildcard(__webpack_require__(2939)),
          _ = _interopRequireWildcard(__webpack_require__(9601)),
          y = _interopRequireWildcard(__webpack_require__(990)),
          k = _interopRequireWildcard(__webpack_require__(8468)),
          E = _interopRequireWildcard(__webpack_require__(3977)),
          w = _interopRequireWildcard(__webpack_require__(5725)),
          C = _interopRequireWildcard(__webpack_require__(2733)),
          S = _interopRequireWildcard(__webpack_require__(8705)),
          P = _interopRequireWildcard(__webpack_require__(1567)),
          T = _interopRequireWildcard(__webpack_require__(236)),
          B = _interopRequireWildcard(__webpack_require__(5513)),
          z = _interopRequireWildcard(__webpack_require__(4040)),
          L = _interopRequireWildcard(__webpack_require__(9150)),
          V = _interopRequireWildcard(__webpack_require__(9261)),
          A = _interopRequireWildcard(__webpack_require__(6899)),
          R = _interopRequireWildcard(__webpack_require__(9060)),
          O = _interopRequireWildcard(__webpack_require__(4073)),
          D = _interopRequireWildcard(__webpack_require__(7260)),
          F = _interopRequireWildcard(__webpack_require__(5834)),
          G = _interopRequireWildcard(__webpack_require__(5208)),
          q = _interopRequireWildcard(__webpack_require__(4226)),
          W = _interopRequireWildcard(__webpack_require__(1693)),
          U = _interopRequireWildcard(__webpack_require__(6846)),
          $ = _interopRequireWildcard(__webpack_require__(7215)),
          Z = _interopRequireWildcard(__webpack_require__(3534)),
          K = _interopRequireWildcard(__webpack_require__(5443)),
          Q = _interopRequireWildcard(__webpack_require__(9800)),
          Y = _interopRequireWildcard(__webpack_require__(1588)),
          X = _interopRequireWildcard(__webpack_require__(5338)),
          J = _interopRequireWildcard(__webpack_require__(6006)),
          ee = _interopRequireWildcard(__webpack_require__(1930)),
          te = _interopRequireWildcard(__webpack_require__(9084)),
          re = _interopRequireWildcard(__webpack_require__(3683)),
          ae = _interopRequireWildcard(__webpack_require__(6298)),
          oe = _interopRequireWildcard(__webpack_require__(1564)),
          ne = _interopRequireWildcard(__webpack_require__(7739)),
          le = _interopRequireWildcard(__webpack_require__(4357)),
          ie = _interopRequireWildcard(__webpack_require__(7188)),
          se = _interopRequireWildcard(__webpack_require__(9202)),
          ce = _interopRequireWildcard(__webpack_require__(7002)),
          ue = _interopRequireWildcard(__webpack_require__(9401)),
          de = _interopRequireWildcard(__webpack_require__(5089)),
          me = _interopRequireWildcard(__webpack_require__(5076)),
          pe = _interopRequireWildcard(__webpack_require__(2623)),
          ge = _interopRequireWildcard(__webpack_require__(2549)),
          ve = _interopRequireWildcard(__webpack_require__(3451)),
          he = _interopRequireWildcard(__webpack_require__(3272)),
          be = _interopRequireWildcard(__webpack_require__(8558)),
          _e = _interopRequireWildcard(__webpack_require__(4479)),
          fe = _interopRequireWildcard(__webpack_require__(4512)),
          ye = _interopRequireWildcard(__webpack_require__(6850)),
          ke = _interopRequireWildcard(__webpack_require__(8619)),
          Ee = _interopRequireWildcard(__webpack_require__(2533)),
          we = _interopRequireWildcard(__webpack_require__(815)),
          Ce = _interopRequireWildcard(__webpack_require__(4873)),
          xe = _interopRequireWildcard(__webpack_require__(7268)),
          Se = _interopRequireWildcard(__webpack_require__(1850)),
          Pe = _interopRequireWildcard(__webpack_require__(6237)),
          Te = _interopRequireWildcard(__webpack_require__(104)),
          Me = _interopRequireWildcard(__webpack_require__(3335)),
          Be = _interopRequireWildcard(__webpack_require__(749)),
          Ie = _interopRequireWildcard(__webpack_require__(2176)),
          Ne = _interopRequireWildcard(__webpack_require__(3462)),
          ze = _interopRequireWildcard(__webpack_require__(3376)),
          Le = _interopRequireWildcard(__webpack_require__(600)),
          Ve = _interopRequireWildcard(__webpack_require__(1898)),
          Ae = _interopRequireWildcard(__webpack_require__(5093)),
          Re = _interopRequireWildcard(__webpack_require__(5411)),
          He = _interopRequireWildcard(__webpack_require__(678)),
          Oe = _interopRequireWildcard(__webpack_require__(4210)),
          De = _interopRequireWildcard(__webpack_require__(5976)),
          Fe = _interopRequireWildcard(__webpack_require__(2931)),
          je = _interopRequireWildcard(__webpack_require__(787)),
          Ge = _interopRequireWildcard(__webpack_require__(4732)),
          qe = _interopRequireWildcard(__webpack_require__(1038)),
          We = _interopRequireWildcard(__webpack_require__(4150)),
          Ue = _interopRequireWildcard(__webpack_require__(7073)),
          $e = _interopRequireWildcard(__webpack_require__(6142)),
          Ze = _interopRequireWildcard(__webpack_require__(725)),
          Ke = _interopRequireWildcard(__webpack_require__(1463)),
          Qe = _interopRequireWildcard(__webpack_require__(6831)),
          Ye = _interopRequireWildcard(__webpack_require__(117));

      function _getRequireWildcardCache(l) {
        if ("function" != typeof WeakMap) return null;
        var s = new WeakMap(),
            c = new WeakMap();
        return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
          return l ? c : s;
        })(l);
      }

      function _interopRequireWildcard(l, s) {
        if (!s && l && l.__esModule) return l;
        if (null === l || "object" != typeof l && "function" != typeof l) return {
          default: l
        };

        var c = _getRequireWildcardCache(s);

        if (c && c.has(l)) return c.get(l);
        var m = {},
            v = Object.defineProperty && Object.getOwnPropertyDescriptor;

        for (var _ in l) {
          if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
            var y = v ? Object.getOwnPropertyDescriptor(l, _) : null;
            y && (y.get || y.set) ? Object.defineProperty(m, _, y) : m[_] = l[_];
          }
        }

        return m.default = l, c && c.set(l, m), m;
      }

      var registerBlock = function registerBlock(l) {
        if (!l) return;
        var c = l.metadata,
            m = l.settings,
            v = l.name;
        (0, s.registerBlockType)(_objectSpread({
          name: v
        }, c), m);
      },
          __experimentalGetCoreBlocks = function __experimentalGetCoreBlocks() {
        return [ue, K, U, q, X, ze, m, v, _, y, k, E, window.wp && window.wp.oldEditor ? w : null, C, S, P, D, F, G, W, Z, Q, Y, ee, te, re, ie, ce, se, xe, Se, Le, Ve, Ae, Re, He, je, Ge, qe, We, Ue, Ke, Qe, Ye, ae, ne, le, Oe, Fe, De, Pe, $e, Ce, fe, ye, be, de, _e, we, ke, Ee, Te, Me, Be, Ie, pe, J, Ze, Ne];
      };

      l.__experimentalGetCoreBlocks = __experimentalGetCoreBlocks;

      l.registerCoreBlocks = function () {
        var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __experimentalGetCoreBlocks();
        l.forEach(registerBlock), (0, s.setDefaultBlockName)(ue.name), window.wp && window.wp.oldEditor && (0, s.setFreeformContentHandlerName)(w.name), (0, s.setUnregisteredTypeHandlerName)(te.name), (0, s.setGroupingBlockName)(W.name);
      };

      var __experimentalRegisterExperimentalCoreBlocks = function __experimentalRegisterExperimentalCoreBlocks() {
        var _ref411 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            l = _ref411.enableFSEBlocks;

        [$].concat(_toConsumableArray(l ? [T, B, z, L, V, A, R, O, oe, me, ge, ve, he] : [])).forEach(registerBlock);
      };

      l.__experimentalRegisterExperimentalCoreBlocks = __experimentalRegisterExperimentalCoreBlocks;
    }(), c;
  }();
});